jsonpMobile([1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(580);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(325);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(623), __esModule: true };

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(612);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(611);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(218);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(218);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.allDestinationsDimVal = exports.dayInMilliseconds = exports.BOARD_BASIS_CODE_MAP = undefined;
	
	var _keys = __webpack_require__(216);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _toConsumableArray2 = __webpack_require__(87);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _assign = __webpack_require__(32);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _PAYMENT_PLAN_LABELS;
	
	exports.setCookie = setCookie;
	exports.setSessionCookie = setSessionCookie;
	exports.readCookie = readCookie;
	exports.isDomainIe = isDomainIe;
	exports.isCurrencyEur = isCurrencyEur;
	exports.getBoardBasisDimVal = getBoardBasisDimVal;
	exports.getBoardBasisLabel = getBoardBasisLabel;
	exports.getBoardBasisCode = getBoardBasisCode;
	exports.getFlexDurationNights = getFlexDurationNights;
	exports.getPaymentPlanLabel = getPaymentPlanLabel;
	exports.getBoardBasisLowToHigh = getBoardBasisLowToHigh;
	exports.getSelectedDurationDays = getSelectedDurationDays;
	exports.titleCase = titleCase;
	exports.capitalize = capitalize;
	exports.updatePageTitle = updatePageTitle;
	exports.round = round;
	exports.formatPrice = formatPrice;
	exports.penceToPounds = penceToPounds;
	exports.formatPenceToPounds = formatPenceToPounds;
	exports.percentToNumber = percentToNumber;
	exports.getPreviousSiblings = getPreviousSiblings;
	exports.checkForNestedProperty = checkForNestedProperty;
	exports.guid = guid;
	exports.serialize = serialize;
	exports.isSubPage = isSubPage;
	exports.getSubPageURL = getSubPageURL;
	exports.getSubPageLocation = getSubPageLocation;
	exports.getChildPageURL = getChildPageURL;
	exports.getParentRoute = getParentRoute;
	exports.getParentPathname = getParentPathname;
	exports.getParentRouteURL = getParentRouteURL;
	exports.getParentRouteLocation = getParentRouteLocation;
	exports.getURLForAPI = getURLForAPI;
	exports.getPandaURL = getPandaURL;
	exports.getDetailsURL = getDetailsURL;
	exports.getSelectedDimensionNumberOfNights = getSelectedDimensionNumberOfNights;
	exports.getSelectedNumberOfNights = getSelectedNumberOfNights;
	exports.getCheapestOfferOfDay = getCheapestOfferOfDay;
	exports.getDurationDimId = getDurationDimId;
	exports.getDurationFromDimId = getDurationFromDimId;
	exports.getMinPriceFromAlternatives = getMinPriceFromAlternatives;
	exports.calculateDepartureDate = calculateDepartureDate;
	exports.isCalOrDeptDateExpired = isCalOrDeptDateExpired;
	exports.getMonthToShowForCalendar = getMonthToShowForCalendar;
	exports.debounce = debounce;
	exports.throttle = throttle;
	exports.obj2Str = obj2Str;
	exports.obj2Hash = obj2Hash;
	exports.hash2Obj = hash2Obj;
	exports.isEveryNth = isEveryNth;
	exports.getNumberOfInfants = getNumberOfInfants;
	exports.hasHotelOnlyResultsRequiredParam = hasHotelOnlyResultsRequiredParam;
	exports.range = range;
	exports.buildURL = buildURL;
	exports.updateWindowLocation = updateWindowLocation;
	exports.updateURLWithReplace = updateURLWithReplace;
	exports.updateURLWithPush = updateURLWithPush;
	exports.updateLocationHashWithPush = updateLocationHashWithPush;
	exports.updatePaginationHashWithPush = updatePaginationHashWithPush;
	exports.updateEncodedStateSearchParam = updateEncodedStateSearchParam;
	exports.getWebTrendsEventType = getWebTrendsEventType;
	exports.fireGTMEvent = fireGTMEvent;
	exports.trackPageChange = trackPageChange;
	exports.fireWebtrendsPageView = fireWebtrendsPageView;
	exports.fireWebtrendsBookPageView = fireWebtrendsBookPageView;
	exports.fireWebtrendsEvent = fireWebtrendsEvent;
	exports.addUrlParam = addUrlParam;
	exports.isIpad = isIpad;
	exports.getCoordinatesRelativeToDocument = getCoordinatesRelativeToDocument;
	exports.replaceWithTheClosestDefinedNumber = replaceWithTheClosestDefinedNumber;
	exports.snakeCaseToHyphenCase = snakeCaseToHyphenCase;
	exports.camelCaseToHyphenCase = camelCaseToHyphenCase;
	exports.camelCase = camelCase;
	exports.getDataAttributes = getDataAttributes;
	exports.sessionVariableExists = sessionVariableExists;
	exports.setSessionVariable = setSessionVariable;
	exports.injectScript = injectScript;
	exports.isHotelOnly = isHotelOnly;
	exports.httpOrigin = httpOrigin;
	exports.scrollIfNotVisible = scrollIfNotVisible;
	
	var _reactRouter = __webpack_require__(78);
	
	var _global = __webpack_require__(79);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _localStorage = __webpack_require__(603);
	
	var localStorageUtil = _interopRequireWildcard(_localStorage);
	
	var _LHX = __webpack_require__(67);
	
	var _LHX2 = _interopRequireDefault(_LHX);
	
	var _payment = __webpack_require__(310);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BOARD_BASIS_LABEL_MAP = {
	  AI: 'All Inclusive',
	  BB: 'Bed & Breakfast',
	  FB: 'Full Board',
	  HB: 'Half Board',
	  RO: 'Room Only',
	  SC: 'Self Catering'
	};
	
	var BOARD_BASIS_CODE_MAP = exports.BOARD_BASIS_CODE_MAP = {
	  38: 'AI',
	  39: 'FB',
	  41: 'BB',
	  40: 'HB',
	  42: 'SC',
	  43: 'RO'
	};
	
	var BOARD_BASIS_DIMVAL_MAP = {
	  AI: 38,
	  FB: 39,
	  BB: 41,
	  HB: 40,
	  SC: 42,
	  RO: 43
	};
	
	var FLEXIBLE_DURATION_LABELS = {
	  1205: '3 - 5',
	  1206: '6 - 8',
	  1207: '9 - 11',
	  1209: '13 - 15'
	};
	
	var PAYMENT_PLAN_LABELS = (_PAYMENT_PLAN_LABELS = {}, (0, _defineProperty3.default)(_PAYMENT_PLAN_LABELS, _payment.PAYMENT_PLAN_TYPES.SPREAD_THE_COST, 'Monthly Payments'), (0, _defineProperty3.default)(_PAYMENT_PLAN_LABELS, _payment.PAYMENT_PLAN_TYPES.LOW_DEPOSIT, 'Low Deposit'), (0, _defineProperty3.default)(_PAYMENT_PLAN_LABELS, _payment.PAYMENT_PLAN_TYPES.STANDARD_DEPOSIT, 'Standard Deposit'), (0, _defineProperty3.default)(_PAYMENT_PLAN_LABELS, _payment.PAYMENT_PLAN_TYPES.PAY_IN_FULL, 'Pay Full Amount'), _PAYMENT_PLAN_LABELS);
	
	function setCookie(cookieName, value, expiryDate) {
	  var settings = [cookieName + '=' + value, 'expires=' + (expiryDate ? expiryDate.toUTCString() : ''), 'path=/'];
	  window.document.cookie = settings.join('; ');
	}
	
	function setSessionCookie(cookieName, value) {
	  var settings = [cookieName + '=' + value, 'path=/'];
	  window.document.cookie = settings.join('; ');
	}
	
	function readCookie(key) {
	  var cookieItems = window.document.cookie.split('; ');
	  var value = void 0;
	
	  cookieItems.some(function (item) {
	    var equalsIndex = item.indexOf('=');
	    var cookieKeyValue = item.substring(0, equalsIndex);
	
	    if (cookieKeyValue === key) {
	      value = item.substring(equalsIndex + 1);
	    }
	
	    return !!value;
	  });
	
	  return value;
	}
	
	function isDomainIe() {
	  var domain = '.ie';
	  return window.document.domain.substr(-domain.length) === domain || _LHX2.default.isEnabled('domainIe');
	}
	
	function isCurrencyEur() {
	  return isDomainIe();
	}
	
	function getBoardBasisDimVal(boardBasisCode) {
	  return BOARD_BASIS_DIMVAL_MAP[boardBasisCode];
	}
	
	function getBoardBasisLabel(boardBasisCode) {
	  return BOARD_BASIS_LABEL_MAP[boardBasisCode];
	}
	
	function getBoardBasisCode(boardBasisDimId) {
	  return BOARD_BASIS_CODE_MAP[boardBasisDimId];
	}
	
	function getFlexDurationNights(durationDimId) {
	  return FLEXIBLE_DURATION_LABELS[durationDimId];
	}
	
	function getPaymentPlanLabel(type) {
	  return PAYMENT_PLAN_LABELS[type];
	}
	
	function getBoardBasisLowToHigh() {
	  return ['RO', 'SC', 'BB', 'HB', 'FB', 'AI'];
	}
	
	function getSelectedDurationDays(baseState, dimensionsEntities) {
	  var days = '';
	  var dimId = baseState.getIn(['D_Nights', 0]);
	  if (dimId) {
	    var isFlexDurationSelected = baseState.getIn(['queryState', 'props', 'nightFlex', 'set']);
	    days = isFlexDurationSelected ? getFlexDurationNights(dimId) : dimensionsEntities.getIn(['' + dimId, 'label']);
	  }
	  return days;
	}
	
	var dayInMilliseconds = exports.dayInMilliseconds = 1000 * 60 * 60 * 24;
	
	function titleCase(text) {
	  return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
	}
	
	function capitalize(text) {
	  return text.charAt(0).toUpperCase() + text.substr(1);
	}
	
	/* istanbul ignore next */
	function updatePageTitle(title) {
	  var pageTitleSuffix = isDomainIe() ? '| loveholidays.ie' : '| loveholidays.com';
	
	  window.document.head.querySelector('title').innerText = title + ' ' + pageTitleSuffix;
	}
	
	// make sure we are consistently rounding amounts on the client
	function round(amount) {
	  return Math.ceil(amount);
	}
	
	function formatPrice(amount) {
	  var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var addCurrencySymbol = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  var output = amount;
	
	  if (typeof amount === 'string') {
	    output = parseFloat(amount);
	  }
	
	  if (!decimalPlaces) {
	    output = round(output);
	  } else {
	    output = output.toFixed(decimalPlaces);
	  }
	
	  if (addCurrencySymbol) {
	    output = isCurrencyEur() ? '\u20AC' + output : '\xA3' + output;
	  } else {
	    output = '' + output;
	  }
	
	  return output;
	}
	
	function penceToPounds(pence) {
	  return parseInt(pence, 10) / 100;
	}
	
	function formatPenceToPounds(pence) {
	  var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var addCurrencySymbol = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  return formatPrice(penceToPounds(pence), decimalPlaces, addCurrencySymbol);
	}
	
	function percentToNumber(percent) {
	  return percent * 0.01;
	}
	
	/* istanbul ignore next */
	function getPreviousSiblings(elem) {
	  var siblings = [];
	  while (elem) {
	    elem = elem.previousElementSibling;
	    siblings.push(elem);
	  }
	  return siblings;
	}
	
	// objectPath arg is String 'rootObj.level2.level3.level4.etc.etc'
	function checkForNestedProperty(objectToTest, objectPath) {
	  var pathLevels = objectPath.split('.');
	  var obj = objectToTest;
	
	  for (var i = 0; i < pathLevels.length; i++) {
	    if (!obj || !obj.hasOwnProperty(pathLevels[i])) {
	      return false;
	    }
	    obj = obj[pathLevels[i]];
	  }
	
	  return true;
	}
	
	/* istanbul ignore next */
	function guid() {
	  function s4() {
	    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	  }
	  return '' + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	}
	
	function serialize(obj) {
	  var keyValuePairsArray = [];
	
	  for (var k in obj) {
	    if (obj.hasOwnProperty(k)) {
	      keyValuePairsArray.push(k + '=' + obj[k]);
	    }
	  }
	
	  return keyValuePairsArray.join('&');
	}
	
	function isSubPage(locationObj) {
	  return locationObj.pathname.indexOf('/sub-page') !== -1;
	}
	
	function getSubPageURL(subPath, locationObj) {
	  var newPath = locationObj.pathname.replace(/\.html.*/, '').replace(/\/$/, '').replace(/\/sub-page.*/, '');
	
	  return newPath + '/sub-page/' + subPath + locationObj.search + (locationObj.hash || '');
	}
	
	function getSubPageLocation(subPath, locationObj) {
	  var newPath = locationObj.pathname.replace(/\.html.*/, '').replace(/\/$/, '').replace(/\/sub-page.*/, '');
	
	  return (0, _assign2.default)({}, locationObj, {
	    pathname: newPath + '/sub-page/' + subPath
	  });
	}
	
	function getChildPageURL(childPath, locationObj) {
	  var subPath = void 0;
	  var path = locationObj.pathname;
	  var newPath = locationObj.pathname.replace(/\.html.*/, '').replace(/\/$/, '').replace(/\/sub-page.*/, '');
	
	  if (path.indexOf('sub-page') > -1) {
	    var subParams = locationObj.pathname.match(/sub-page\/(.*)/).pop();
	    subPath = subParams + '/';
	  } else {
	    subPath = '';
	  }
	
	  return newPath + '/sub-page/' + subPath + childPath + locationObj.search + (locationObj.hash || '');
	}
	
	function getParentRoute(locationObj) {
	  var match = locationObj.pathname.match(/\/([^\/]*)\/[^\/]*$/);
	  var parentRoute = match ? match[1] : '';
	  return parentRoute && parentRoute !== 'sub-page' ? parentRoute + '/' : '';
	}
	
	function getParentPathname(locationObj) {
	  var hasDotHTMLSuffix = !locationObj.pathname.match(/^\/holidays\/sub-page/);
	  var newPath = locationObj.pathname.replace(/\.html.*/, '').replace(/\/sub-page.*/, '');
	  var suffix = hasDotHTMLSuffix && newPath ? '.html' : '';
	  var subParams = locationObj.pathname.match(/sub-page\/(.*)/).pop().split('/');
	  subParams.pop();
	  var subPath = subParams.join('/');
	
	  if (newPath) {
	    newPath = '' + newPath + (subParams.length ? '/sub-page/' : suffix) + subPath;
	  } else {
	    newPath = '/';
	  }
	
	  return newPath;
	}
	
	function getParentRouteURL(locationObj) {
	  return '' + getParentPathname(locationObj) + locationObj.search + (locationObj.hash || '');
	}
	
	function getParentRouteLocation(locationObj) {
	  return (0, _assign2.default)({}, locationObj, {
	    pathname: getParentPathname(locationObj)
	  });
	}
	
	function getURLForAPI(locationObj) {
	  var strippedPathname = locationObj.pathname.replace('/availability', '').replace(/\.html.*/, '').replace(/\/sub-page.*/, '');
	
	  return strippedPathname + '.html';
	}
	
	function getPandaURL(detailLink, state) {
	  var link = detailLink ? detailLink.replace(/^\/holidays/, '/holidays/availability') : '';
	  return link + '?alltabs=1' + (state ? '&state=' + state : '');
	}
	
	function getDetailsURL(detailLink, state) {
	  return detailLink + '?alltabs=1' + (state ? '&state=' + state : '');
	}
	
	function getSelectedDimensionNumberOfNights(props) {
	  if (props.baseState.get('D_Nights')) {
	    var selectedNights = props.baseState.get('D_Nights').map(function (dimId) {
	      return Number(props.dimensionsEntities.getIn(['' + dimId, 'label']), 10);
	    });
	
	    return selectedNights.first();
	  }
	}
	
	function getSelectedNumberOfNights(props) {
	  return props.appState && props.appState.get('nonDimensionNumberOfNights') || getSelectedDimensionNumberOfNights(props);
	}
	
	function getCheapestOfferOfDay(props) {
	  var alternatives = props.calendarOffers.get('alternatives');
	  var cheapestOfferOfDay = void 0;
	
	  if (!alternatives || alternatives && !alternatives.size) {
	    alternatives = props.calendarOffers.get('offers');
	  }
	
	  if (alternatives && alternatives.size) {
	    var selectedNights = getSelectedNumberOfNights(props);
	    cheapestOfferOfDay = alternatives.filter(function (altOffer) {
	      return selectedNights === altOffer.get('nights');
	    }).first();
	  }
	
	  return cheapestOfferOfDay;
	}
	
	function getDurationDimId(numberOfNights) {
	  var dimensionMap = {
	    1: 2662,
	    2: 2663,
	    3: 2664,
	    4: 1205,
	    5: 2665,
	    6: 2666,
	    7: 1206,
	    8: 2667,
	    9: 2668,
	    10: 1207,
	    11: 1208,
	    12: 2669,
	    13: 2670,
	    14: 1209,
	    15: 2671
	  };
	  return dimensionMap[numberOfNights];
	}
	
	function getDurationFromDimId(dimId) {
	  var durationMap = {
	    2662: 1,
	    2663: 2,
	    2664: 3,
	    1205: 4,
	    2665: 5,
	    2666: 6,
	    1206: 7,
	    2667: 8,
	    2668: 9,
	    1207: 10,
	    1208: 11,
	    2669: 12,
	    2670: 13,
	    1209: 14,
	    2671: 15
	  };
	  return durationMap[dimId];
	}
	
	function getMinPriceFromAlternatives(alternativeOffers, numberOfNights) {
	  var minPrice = alternativeOffers.size && Math.min.apply(Math, (0, _toConsumableArray3.default)(alternativeOffers.filter(function (alternativeOffer) {
	    return alternativeOffer.get('nights') === numberOfNights;
	  }).map(function (alternativeOffer) {
	    return alternativeOffer.get('discountPrice');
	  }).toArray()));
	
	  return minPrice && minPrice !== Infinity ? minPrice : 'Unavailable';
	}
	
	function calculateDepartureDate(deptDate) {
	  var nowDayStamp = Math.floor(Date.now() / dayInMilliseconds);
	  return deptDate > nowDayStamp ? deptDate : null;
	}
	
	function isCalOrDeptDateExpired(baseState) {
	  return ['calDate', 'deptDate'].some(function (dateKey) {
	    var date = calculateDepartureDate(baseState.getIn(['queryState', 'props', dateKey, 'value']));
	    var selected = baseState.getIn(['queryState', 'props', dateKey, 'selected']);
	
	    return !date && selected;
	  });
	}
	
	function getMonthToShowForCalendar(deptDate) {
	  var today = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
	
	  var date = today;
	  if (date.getDate() > 15) {
	    date.setMonth(date.getMonth() + 1);
	  }
	  return deptDate || Math.floor(date.getTime() / dayInMilliseconds);
	}
	
	/* istanbul ignore next */
	function debounce(func, wait, immediate) {
	  var _this = this,
	      _arguments = arguments;
	
	  var timeout = void 0;
	
	  return function () {
	    var context = _this;
	    var args = _arguments;
	    var later = function later() {
	      timeout = null;
	      if (!immediate) func.apply(context, args);
	    };
	    var callNow = immediate && !timeout;
	    clearTimeout(timeout);
	    timeout = setTimeout(later, wait);
	    if (callNow) func.apply(context, args);
	  };
	}
	
	function throttle(callback, delay) {
	  var _this2 = this,
	      _arguments2 = arguments;
	
	  var sixtyFPS = 1000 / 60;
	  var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function setTimeoutFallback(fn) {
	    window.setTimeout(fn, sixtyFPS);
	  };
	
	  var fn = delay ? window.setTimeout : requestAnimationFrame;
	  var ticker = void 0;
	  return function () {
	    var context = _this2;
	    var args = _arguments2;
	    if (!ticker) {
	      ticker = fn(function () {
	        callback.apply(context, args);
	        ticker = null;
	      }, delay);
	    }
	  };
	}
	
	function obj2Str(obj) {
	  return (0, _keys2.default)(obj).map(function (key) {
	    return key + '=' + obj[key];
	  }).join('&');
	}
	
	function obj2Hash(obj) {
	  var hashString = obj2Str(obj);
	  return '' + (hashString ? '#' : '') + hashString;
	}
	
	function hash2Obj(hash) {
	  return hash && hash.length !== 1 ? _assign2.default.apply(Object, [{}].concat((0, _toConsumableArray3.default)(hash.slice(1).split('&').map(function (prop) {
	    var splitProp = prop.split('=');
	    return (0, _defineProperty3.default)({}, splitProp[0], splitProp[1]);
	  })))) : {};
	}
	
	function isEveryNth(index, elementNumber) {
	  return (index + 1) % elementNumber === 0;
	}
	
	function getNumberOfInfants() {
	  var childrenAgesCollection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var maxInfantAge = 1;
	  var filteredCollection = childrenAgesCollection.filter(function (age) {
	    return age <= maxInfantAge;
	  });
	  return Array.isArray(filteredCollection) ? filteredCollection.length : filteredCollection.size;
	}
	
	function hasHotelOnlyResultsRequiredParam(locationObj) {
	  return locationObj.query.deptDate && locationObj.query.retDate;
	}
	
	function range(start, end) {
	  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	  /* eslint no-param-reassign: 0 */
	
	  if (!end) {
	    end = start;
	    start = 0;
	  }
	
	  return Array.apply(undefined, (0, _toConsumableArray3.default)(Array(end - start))).map(function (value, i) {
	    return i * step + start;
	  });
	}
	
	function buildURL(location, options) {
	  var newLocation = (0, _assign2.default)({}, location, options);
	  var hashObj = hash2Obj(newLocation.hash);
	  var newQuery = newLocation.query;
	
	  if (options.query) {
	    newQuery = (0, _assign2.default)({}, location.query, options.query);
	    (0, _keys2.default)(options.query).forEach(function (key) {
	      if (options.query[key] === undefined) {
	        delete newQuery[key];
	      }
	    });
	  }
	
	  if (options.deleteHashParams) {
	    options.deleteHashParams.map(function (key) {
	      delete hashObj[key];
	    });
	  }
	
	  if (options.hashObj) {
	    hashObj = (0, _assign2.default)({}, hashObj, options.hashObj);
	  }
	
	  return newLocation.pathname + '?' + serialize(newQuery) + obj2Hash(hashObj);
	}
	
	function updateWindowLocation(url) {
	  window.location.href = url;
	}
	
	function updateURLWithReplace(location) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var newURL = buildURL(location, options);
	  _reactRouter.browserHistory.replace(newURL);
	}
	
	function updateURLWithPush(location) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var newURL = buildURL(location, options);
	  _reactRouter.browserHistory.push(newURL);
	}
	
	function updateLocationHashWithPush(location, hashObj) {
	  var replace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var newHashObj = replace ? hashObj : (0, _assign2.default)({}, hash2Obj(location.hash), hashObj);
	  var hash = obj2Hash(newHashObj);
	  _reactRouter.browserHistory.push(location.pathname + '?' + serialize(location.query) + hash);
	}
	
	function updatePaginationHashWithPush(start, location) {
	  var resultsPerPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _global2.default.paginationDefaults.optionsCount;
	
	  var pageNum = start / resultsPerPage + 1;
	  updateLocationHashWithPush(location, {
	    page: pageNum
	  });
	}
	
	function updateEncodedStateSearchParam(previousStateEncoded, currentStateEncoded, location) {
	  if (currentStateEncoded && currentStateEncoded !== previousStateEncoded) {
	    localStorageUtil.setItem(localStorageUtil.KEYS.currentStateEncoded, currentStateEncoded);
	    localStorageUtil.setItem(localStorageUtil.KEYS.currentStateEncodedTimestamp, Date.now());
	
	    updateURLWithReplace(location, {
	      query: { state: currentStateEncoded },
	      hashObj: { state: currentStateEncoded } // this line can go once panda is completely migrated to react
	    });
	  }
	}
	
	var WEB_TRENDS_EVENT_TYPE_MAP = {
	  HO: 'HotelOnly',
	  HL: 'PandA'
	};
	
	function getWebTrendsEventType(hash) {
	  var viewHashAttr = hash2Obj(hash).view;
	  return viewHashAttr ? WEB_TRENDS_EVENT_TYPE_MAP[viewHashAttr] : 'PandA';
	}
	
	/* eslint-disable no-console */
	function fireGTMEvent(pageType, masterId) {
	  if (window.ignoredFirstGTMCall) {
	    window.dataLayer = window.dataLayer || [];
	    window.google_tag_params = { hrental_id: masterId || null, hrental_pagetype: pageType };
	    var eventPayload = {
	      codeBase: 'react',
	      event: 'AllPageview',
	      masterId: masterId
	    };
	    window.dataLayer.push(eventPayload);
	    /* istanbul ignore if */
	    if (false) console.debug('fireGTMEvent', window.google_tag_params, eventPayload);
	  } else {
	    window.ignoredFirstGTMCall = true;
	  }
	}
	
	function trackPageChange(pageType, masterId) {
	  fireGTMEvent(pageType, masterId);
	}
	
	/* istanbul ignore next */
	function fireWebtrendsPageView(pageType) {
	  var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  if (window && window.dcsMultiTrack) {
	    var _window;
	
	    var lvhid = readCookie('lvhid');
	    (_window = window).dcsMultiTrack.apply(_window, ['DCS.dcsuri', window.location.pathname, 'WT.ti', pageType, 'WT.dl', '0', 'WT.lvhid', lvhid].concat((0, _toConsumableArray3.default)(extraParams)));
	  }
	}
	
	function fireWebtrendsBookPageView(pageType) {
	  var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  if (window && window.dcsMultiTrack) {
	    var _window2;
	
	    var lvhid = readCookie('lvhid');
	    (_window2 = window).dcsMultiTrack.apply(_window2, ['DCS.dcsuri', window.location.pathname, 'WT.ti', pageType, 'WT.dl', '0', 'WT.lvhid', lvhid].concat((0, _toConsumableArray3.default)(extraParams)));
	  }
	}
	
	/* istanbul ignore next */
	function fireWebtrendsEvent(pageType) {
	  var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  if (window && window.dcsMultiTrack) {
	    var _window3;
	
	    var lvhid = readCookie('lvhid');
	    (_window3 = window).dcsMultiTrack.apply(_window3, ['DCS.dcsuri', window.location.pathname, 'WT.ti', pageType, 'WT.dl', '99', 'WT.lvhid', lvhid].concat((0, _toConsumableArray3.default)(extraParams)));
	  }
	}
	
	function addUrlParam(url, key, val) {
	  var newParam = key + '=' + val;
	  var params = '?' + newParam;
	
	  params = url.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);
	
	  if (params === url) {
	    params += '' + (url.includes('?') ? '&' : '?') + newParam;
	  }
	
	  return params;
	}
	
	function isIpad() {
	  return window.navigator.userAgent.match(/iPad/i) !== null;
	}
	
	function getCoordinatesRelativeToDocument(boundingClientRect) {
	  var body = window.document.body;
	  var docEl = window.document.documentElement;
	  var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
	  var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
	  var appRoot = document.getElementById('root');
	  var semseoPattern = /search-unit/i;
	
	  var left = Math.round(boundingClientRect.left + scrollLeft);
	  var top = Math.round(boundingClientRect.top + scrollTop);
	
	  /*
	   * Here we assume immediate parent of #root has relative position
	   * Unless a semseo page
	   */
	  if (appRoot && appRoot.parentNode !== body && appRoot.parentNode.className.match(semseoPattern) === null) {
	    var appRootBoundingClientRect = appRoot.getBoundingClientRect();
	
	    left = Math.round(boundingClientRect.left - appRootBoundingClientRect.left);
	    top = Math.round(boundingClientRect.top - appRootBoundingClientRect.top);
	  }
	
	  return { left: left, top: top };
	}
	
	function replaceWithTheClosestDefinedNumber(definedNumbersArray, numberToReplace) {
	  var smallestDelta = Infinity;
	  var roundTo = numberToReplace;
	  definedNumbersArray.forEach(function (number) {
	    var delta = Math.abs(number - numberToReplace);
	    if (delta < smallestDelta) {
	      smallestDelta = delta;
	      roundTo = number;
	    }
	  });
	  return roundTo;
	}
	
	function snakeCaseToHyphenCase(value) {
	  return value.replace('_', '-');
	}
	
	function camelCaseToHyphenCase(value) {
	  return value.replace(/([A-Z])/g, function (g) {
	    return '-' + g[0].toLowerCase();
	  });
	}
	
	function camelCase(value) {
	  return value.toLowerCase().split(' ').map(capitalize).join(' ');
	}
	
	function getDataAttributes(data) {
	  var dataAttributes = {};
	  var dataKeys = (0, _keys2.default)(data);
	  dataKeys.forEach(function (key) {
	    dataAttributes['data-' + camelCaseToHyphenCase(key)] = data[key];
	  });
	  return dataAttributes;
	}
	
	function sessionVariableExists(variable) {
	  return sessionStorage.getItem(variable);
	}
	
	function setSessionVariable(key, value) {
	  sessionStorage.setItem(key, value);
	}
	
	/* istanbul ignore next */
	function injectScript(src, _ref2) {
	  var async = _ref2.async,
	      onLoad = _ref2.onLoad;
	
	  var scriptElement = document.createElement('script');
	  scriptElement.type = 'text/javascript';
	  scriptElement.src = src;
	
	  if (async) {
	    scriptElement.async = true;
	  }
	
	  if (onLoad) {
	    scriptElement.onload = onLoad;
	  }
	
	  var firstScriptElement = document.getElementsByTagName('script')[0];
	  firstScriptElement.parentNode.insertBefore(scriptElement, firstScriptElement);
	}
	
	function isHotelOnly(pathName) {
	  return pathName.indexOf('/hotel-only/') !== -1;
	}
	
	function httpOrigin() {
	  return window.location.origin.replace('https://', 'http://');
	}
	
	function scrollIfNotVisible(el, parentEl) {
	  var _el$getBoundingClient = el.getBoundingClientRect(),
	      elTop = _el$getBoundingClient.top,
	      elBottom = _el$getBoundingClient.bottom;
	
	  var _parentEl$getBounding = parentEl.getBoundingClientRect(),
	      parentElTop = _parentEl$getBounding.top,
	      parentElBottom = _parentEl$getBounding.bottom;
	
	  var isVisibleWithinParent = elTop >= parentElTop && elBottom <= parentElBottom;
	  var isVisibleWithinWindow = elTop >= 0 && elBottom <= window.innerHeight;
	
	  if (!isVisibleWithinParent || !isVisibleWithinWindow) {
	    el.scrollIntoView();
	  }
	}
	
	var allDestinationsDimVal = exports.allDestinationsDimVal = 214;

/***/ },
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * This is a straight rip-off of the React.js ReactPropTypes.js proptype validators,
	 * modified to make it possible to validate Immutable.js data.
	 *     ImmutableTypes.listOf is patterned after React.PropTypes.arrayOf, but for Immutable.List
	 *     ImmutableTypes.shape  is based on React.PropTypes.shape, but for any Immutable.Iterable
	 */
	"use strict";
	
	var Immutable = __webpack_require__(9);
	
	var ANONYMOUS = "<<anonymous>>";
	
	var ImmutablePropTypes = {
	  listOf: createListOfTypeChecker,
	  mapOf: createMapOfTypeChecker,
	  orderedMapOf: createOrderedMapOfTypeChecker,
	  setOf: createSetOfTypeChecker,
	  orderedSetOf: createOrderedSetOfTypeChecker,
	  stackOf: createStackOfTypeChecker,
	  iterableOf: createIterableOfTypeChecker,
	  recordOf: createRecordOfTypeChecker,
	  shape: createShapeChecker,
	  contains: createShapeChecker,
	  mapContains: createMapContainsChecker,
	  // Primitive Types
	  list: createImmutableTypeChecker("List", Immutable.List.isList),
	  map: createImmutableTypeChecker("Map", Immutable.Map.isMap),
	  orderedMap: createImmutableTypeChecker("OrderedMap", Immutable.OrderedMap.isOrderedMap),
	  set: createImmutableTypeChecker("Set", Immutable.Set.isSet),
	  orderedSet: createImmutableTypeChecker("OrderedSet", Immutable.OrderedSet.isOrderedSet),
	  stack: createImmutableTypeChecker("Stack", Immutable.Stack.isStack),
	  seq: createImmutableTypeChecker("Seq", Immutable.Seq.isSeq),
	  record: createImmutableTypeChecker("Record", function (isRecord) {
	    return isRecord instanceof Immutable.Record;
	  }),
	  iterable: createImmutableTypeChecker("Iterable", Immutable.Iterable.isIterable)
	};
	
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return "array";
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return "object";
	  }
	  if (propValue instanceof Immutable.Iterable) {
	    return "Immutable." + propValue.toSource().split(" ")[0];
	  }
	  return propType;
	}
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      rest[_key - 6] = arguments[_key];
	    }
	
	    propFullName = propFullName || propName;
	    componentName = componentName || ANONYMOUS;
	    if (props[propName] == null) {
	      var locationName = location;
	      if (isRequired) {
	        return new Error("Required " + locationName + " `" + propFullName + "` was not specified in " + ("`" + componentName + "`."));
	      }
	    } else {
	      return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createImmutableTypeChecker(immutableClassName, immutableClassTypeValidator) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!immutableClassTypeValidator(propValue)) {
	      var propType = getPropType(propValue);
	      return new Error("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `" + immutableClassName + "`."));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createIterableTypeChecker(typeChecker, immutableClassName, immutableClassTypeValidator) {
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      rest[_key - 5] = arguments[_key];
	    }
	
	    var propValue = props[propName];
	    if (!immutableClassTypeValidator(propValue)) {
	      var locationName = location;
	      var propType = getPropType(propValue);
	      return new Error("Invalid " + locationName + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
	    }
	
	    if (typeof typeChecker !== "function") {
	      return new Error("Invalid typeChecker supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
	    }
	
	    var propValues = propValue.toArray();
	    for (var i = 0, len = propValues.length; i < len; i++) {
	      var error = typeChecker.apply(undefined, [propValues, i, componentName, location, "" + propFullName + "[" + i + "]"].concat(rest));
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createKeysTypeChecker(typeChecker) {
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      rest[_key - 5] = arguments[_key];
	    }
	
	    var propValue = props[propName];
	    if (typeof typeChecker !== "function") {
	      return new Error("Invalid keysTypeChecker (optional second argument) supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
	    }
	
	    var keys = propValue.keySeq().toArray();
	    for (var i = 0, len = keys.length; i < len; i++) {
	      var error = typeChecker.apply(undefined, [keys, i, componentName, location, "" + propFullName + " -> key(" + keys[i] + ")"].concat(rest));
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createListOfTypeChecker(typeChecker) {
	  return createIterableTypeChecker(typeChecker, "List", Immutable.List.isList);
	}
	
	function createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, immutableClassName, immutableClassTypeValidator) {
	  function validate() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return createIterableTypeChecker(valuesTypeChecker, immutableClassName, immutableClassTypeValidator).apply(undefined, args) || keysTypeChecker && createKeysTypeChecker(keysTypeChecker).apply(undefined, args);
	  }
	
	  return createChainableTypeChecker(validate);
	}
	
	function createMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
	  return createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "Map", Immutable.Map.isMap);
	}
	
	function createOrderedMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
	  return createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "OrderedMap", Immutable.OrderedMap.isOrderedMap);
	}
	
	function createSetOfTypeChecker(typeChecker) {
	  return createIterableTypeChecker(typeChecker, "Set", Immutable.Set.isSet);
	}
	
	function createOrderedSetOfTypeChecker(typeChecker) {
	  return createIterableTypeChecker(typeChecker, "OrderedSet", Immutable.OrderedSet.isOrderedSet);
	}
	
	function createStackOfTypeChecker(typeChecker) {
	  return createIterableTypeChecker(typeChecker, "Stack", Immutable.Stack.isStack);
	}
	
	function createIterableOfTypeChecker(typeChecker) {
	  return createIterableTypeChecker(typeChecker, "Iterable", Immutable.Iterable.isIterable);
	}
	
	function createRecordOfTypeChecker(recordKeys) {
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      rest[_key - 5] = arguments[_key];
	    }
	
	    var propValue = props[propName];
	    if (!(propValue instanceof Immutable.Record)) {
	      var propType = getPropType(propValue);
	      var locationName = location;
	      return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js Record."));
	    }
	    for (var key in recordKeys) {
	      var checker = recordKeys[key];
	      if (!checker) {
	        continue;
	      }
	      var mutablePropValue = propValue.toObject();
	      var error = checker.apply(undefined, [mutablePropValue, key, componentName, location, "" + propFullName + "." + key].concat(rest));
	      if (error) {
	        return error;
	      }
	    }
	  }
	  return createChainableTypeChecker(validate);
	}
	
	// there is some irony in the fact that shapeTypes is a standard hash and not an immutable collection
	function createShapeTypeChecker(shapeTypes) {
	  var immutableClassName = arguments[1] === undefined ? "Iterable" : arguments[1];
	  var immutableClassTypeValidator = arguments[2] === undefined ? Immutable.Iterable.isIterable : arguments[2];
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      rest[_key - 5] = arguments[_key];
	    }
	
	    var propValue = props[propName];
	    if (!immutableClassTypeValidator(propValue)) {
	      var propType = getPropType(propValue);
	      var locationName = location;
	      return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
	    }
	    var mutablePropValue = propValue.toObject();
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker.apply(undefined, [mutablePropValue, key, componentName, location, "" + propFullName + "." + key].concat(rest));
	      if (error) {
	        return error;
	      }
	    }
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeChecker(shapeTypes) {
	  return createShapeTypeChecker(shapeTypes);
	}
	
	function createMapContainsChecker(shapeTypes) {
	  return createShapeTypeChecker(shapeTypes, "Map", Immutable.Map.isMap);
	}
	
	module.exports = ImmutablePropTypes;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(325);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ },
/* 22 */,
/* 23 */,
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(131);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	var _immutable = __webpack_require__(9);
	
	var _deepEqual = __webpack_require__(1328);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _keys = __webpack_require__(1329);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _setIn = __webpack_require__(1330);
	
	var _setIn2 = _interopRequireDefault(_setIn);
	
	var _splice = __webpack_require__(1331);
	
	var _splice2 = _interopRequireDefault(_splice);
	
	var _getIn = __webpack_require__(485);
	
	var _getIn2 = _interopRequireDefault(_getIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyList = (0, _immutable.List)();
	
	var structure = {
	  allowsArrayErrors: false,
	  empty: (0, _immutable.Map)(),
	  emptyList: emptyList,
	  getIn: function getIn(state, field) {
	    return _immutable.Iterable.isIterable(state) ? state.getIn((0, _toPath3.default)(field)) : (0, _getIn2.default)(state, field);
	  },
	  setIn: _setIn2.default,
	  deepEqual: _deepEqual2.default,
	  deleteIn: function deleteIn(state, field) {
	    return state.deleteIn((0, _toPath3.default)(field));
	  },
	  forEach: function forEach(items, callback) {
	    items.forEach(callback);
	  },
	  fromJS: function fromJS(jsValue) {
	    return (0, _immutable.fromJS)(jsValue, function (key, value) {
	      return _immutable.Iterable.isIndexed(value) ? value.toList() : value.toMap();
	    });
	  },
	  keys: _keys2.default,
	  size: function size(list) {
	    return list ? list.size : 0;
	  },
	  some: function some(items, callback) {
	    return items.some(callback);
	  },
	  splice: _splice2.default,
	  toJS: function toJS(value) {
	    return _immutable.Iterable.isIterable(value) ? value.toJS() : value;
	  }
	};
	
	exports.default = structure;

/***/ },
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.push = push;
	exports.getDeviceType = getDeviceType;
	exports.fireOptimizelyRevenueEventOnce = fireOptimizelyRevenueEventOnce;
	exports.fireOptimizelyAncillaryEvent = fireOptimizelyAncillaryEvent;
	exports.fireOptimizelyBoardTypeEvent = fireOptimizelyBoardTypeEvent;
	window.optimizely = window.optimizely || [];
	
	/* istanbul ignore next */
	function push(payload) {
	  window.optimizely.push(payload);
	  /* istanbul ignore next */
	  if (false) console.debug('optimizely.push', payload); // eslint-disable-line no-console
	}
	
	var fireEvent = exports.fireEvent = function fireEvent(className, event) {
	  var validEvents = ['selected', 'displayed', 'clicked'];
	  push({
	    type: 'event',
	    eventName: event + ' ' + className
	  });
	  /* istanbul ignore next */
	  if (false) console.error('optimizely.fireEvent: invalid event type ' + event); // eslint-disable-line no-console
	};
	
	var firePageViewEvent = exports.firePageViewEvent = function firePageViewEvent(pageName) {
	  push({
	    type: 'event',
	    eventName: pageName
	  });
	};
	
	var activate = exports.activate = function activate() {
	  push({
	    type: 'activate'
	  });
	  /* istanbul ignore next */
	  if (false) console.debug('optimizely.activate'); // eslint-disable-line no-console
	};
	
	function getDeviceType() {
	  var userAgent = window.navigator.userAgent;
	  var siteType = void 0;
	
	  if (/iPad/.test(userAgent)) {
	    siteType = 'Tablet';
	  } else if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(userAgent)) {
	    siteType = 'Phone';
	  } else {
	    siteType = 'Desktop';
	  }
	
	  return siteType;
	}
	
	function fireOptimizelyRevenueEventOnce(data) {
	  if (data.isEnablePurchaseTracking) {
	    push({
	      type: 'event',
	      eventName: data.bookTypeEventName
	    });
	    if (data.isExpectedRevenueWithinRange) {
	      push({
	        type: 'user',
	        attributes: {
	          product_type: data.bookTypeId
	        }
	      });
	      push({
	        type: 'event',
	        eventName: 'booking_revenue',
	        tags: {
	          revenue: data.expectedRevenueDcstorm
	        }
	      });
	    }
	  }
	}
	
	function fireOptimizelyAncillaryEvent(data) {
	  if (data.hasTransfer) {
	    push({
	      type: 'event',
	      eventName: 'confirmationPage-transfer--selected'
	    });
	  }
	  if (data.hasBaggage && !!data.hasBaggage.size) {
	    push({
	      type: 'event',
	      eventName: 'confirmationPage-holdLuggage--selected'
	    });
	  }
	  if (data.hasInsurance) {
	    push({
	      type: 'event',
	      eventName: 'confirmationPage-insurance--selected'
	    });
	  }
	  if (data.hasFlightMeals) {
	    push({
	      type: 'event',
	      eventName: 'confirmationPage-flightMeals--selected'
	    });
	  }
	  if (data.hasBaggage && data.amountOfBags > 0) {
	    push({
	      type: 'event',
	      eventName: 'confirmationPage-' + data.amountOfBags + '-baggage--selected'
	    });
	  }
	}
	
	function fireOptimizelyBoardTypeEvent(data) {
	  if (data.boardBasis) {
	    push({
	      type: 'event',
	      eventName: 'confirmationPage-' + data.boardBasis + '-BoardBasis--selected'
	    });
	  }
	}

/***/ },
/* 31 */
70,
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(620), __esModule: true };

/***/ },
/* 33 */,
/* 34 */,
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HOTEL_ONLY_INDEX_MAX_SUPPORTED_DAYS = exports.DEFAULT_HOTEL_ONLY_DURATION = exports.MINIMUM_DAYS_FOR_PRICE_MATCH = exports.HOTEL_ONLY_MAXIMUM_DURATION = exports.DEFAULT_CALENDAR_DAYS_FROM_TODAY = undefined;
	
	var _utils = __webpack_require__(8);
	
	var DEFAULT_CALENDAR_DAYS_FROM_TODAY = exports.DEFAULT_CALENDAR_DAYS_FROM_TODAY = 7;
	var HOTEL_ONLY_MAXIMUM_DURATION = exports.HOTEL_ONLY_MAXIMUM_DURATION = 30;
	var MINIMUM_DAYS_FOR_PRICE_MATCH = exports.MINIMUM_DAYS_FOR_PRICE_MATCH = 14;
	var DEFAULT_HOTEL_ONLY_DURATION = exports.DEFAULT_HOTEL_ONLY_DURATION = 7;
	var HOTEL_ONLY_INDEX_MAX_SUPPORTED_DAYS = exports.HOTEL_ONLY_INDEX_MAX_SUPPORTED_DAYS = 15;
	
	var dateWords = {
	  ddd: 'Sun,Mon,Tue,Wed,Thu,Fri,Sat'.split(','),
	  MMMM: 'January,February,March,April,May,June,July,August,September,October,November,December'.split(','),
	  MMM: 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec'.split(',')
	};
	
	var formatTokens = {
	  ddd: function ddd(date) {
	    return dateWords.ddd[date.getDay()];
	  },
	  D: function D(date) {
	    return date.getDate();
	  },
	  DD: function DD(date) {
	    return ('0' + date.getDate()).substr(-2);
	  },
	  M: function M(date) {
	    return '' + (date.getMonth() + 1);
	  },
	  MM: function MM(date) {
	    return ('0' + (date.getMonth() + 1)).substr(-2);
	  },
	  MMM: function MMM(date) {
	    return dateWords.MMM[date.getMonth()];
	  },
	  MMMM: function MMMM(date) {
	    return dateWords.MMMM[date.getMonth()];
	  },
	  YY: function YY(date) {
	    return ('' + date.getFullYear()).substr(-2);
	  },
	  YYYY: function YYYY(date) {
	    return date.getFullYear();
	  },
	  HH: function HH(date) {
	    return ('0' + date.getHours()).substr(-2);
	  },
	  mm: function mm(date) {
	    return ('0' + date.getMinutes()).substr(-2);
	  },
	  ss: function ss(date) {
	    return ('0' + date.getSeconds()).substr(-2);
	  }
	};
	
	var dateFormatRegEx = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	exports.default = {
	  format: function format(dateOrTimestamp, _format) {
	    var date = void 0;
	
	    if (dateOrTimestamp) {
	      date = dateOrTimestamp instanceof Date ? dateOrTimestamp : this.utcDate(dateOrTimestamp);
	    } else {
	      date = this.utcDate();
	    }
	
	    return _format.replace(dateFormatRegEx, function (match) {
	      return formatTokens[match] ? formatTokens[match](date) : match;
	    });
	  },
	
	
	  isToday: function isToday(date) {
	    var today = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
	    return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getYear() === today.getYear();
	  },
	
	  addOrdinal: function addOrdinal(day) {
	    var s = ['th', 'st', 'nd', 'rd'];
	    var v = day % 100;
	    return day + (s[(v - 20) % 10] || s[v] || s[0]);
	  },
	
	  numDaysInMonth: function numDaysInMonth(year, month) {
	    return new Date(year, month + 1, 0).getDate();
	  },
	
	  utcDate: function utcDate() {
	    var dateOrTimestamp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
	
	    var date = dateOrTimestamp instanceof Date ? dateOrTimestamp : new Date(dateOrTimestamp);
	
	    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
	  },
	
	
	  isoStringToDate: function isoStringToDate(isoString) {
	    if (typeof isoString === 'string') {
	      var isoParts = isoString.split('-');
	      return new Date(Number(isoParts[0]), Number(isoParts[1]) - 1, Number(isoParts[2]));
	    }
	  },
	
	  parseDateStampToCalDate: function parseDateStampToCalDate() {
	    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
	
	    return Math.floor(new Date(date).getTime() / _utils.dayInMilliseconds);
	  },
	
	
	  getMonthNameByIndex: function getMonthNameByIndex(monthIndex) {
	    return dateWords.MMM[monthIndex];
	  },
	
	  getMonthFullNameByIndex: function getMonthFullNameByIndex(monthIndex) {
	    return dateWords.MMMM[monthIndex];
	  },
	
	  isDateWithinNextNumberOfDays: function isDateWithinNextNumberOfDays(date, nextNumberOfDays) {
	    var today = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date();
	
	    var testDate = new Date(date);
	    var daysUntilTestDate = (testDate.getTime() - today.getTime()) / _utils.dayInMilliseconds;
	
	    return daysUntilTestDate >= 0 && daysUntilTestDate < nextNumberOfDays;
	  },
	  getDaysUntilDate: function getDaysUntilDate(date) {
	    var today = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
	
	    var testDate = new Date(date);
	    var daysUntilDate = (testDate.getTime() - today.getTime()) / _utils.dayInMilliseconds;
	
	    return daysUntilDate;
	  },
	  addDays: function addDays(numDays) {
	    var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
	
	    date.setDate(date.getDate() + parseInt(numDays, 10));
	    return date;
	  },
	  addMonths: function addMonths(numMonths) {
	    var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
	
	    date.setMonth(date.getMonth() + numMonths);
	    return date;
	  },
	  addYears: function addYears(numYears) {
	    var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
	
	    date.setFullYear(date.getFullYear() + numYears);
	    return date;
	  },
	  time2Num: function time2Num(timeStr) {
	    return Number(timeStr.replace(':', ''));
	  }
	};

/***/ },
/* 36 */,
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchEndpoint = exports.Schemas = exports.CALL_API = undefined;
	
	var _slicedToArray2 = __webpack_require__(327);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(217);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _stringify = __webpack_require__(610);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(32);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _normalizr = __webpack_require__(417);
	
	var _isomorphicFetch = __webpack_require__(395);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _LHX = __webpack_require__(67);
	
	var _LHX2 = _interopRequireDefault(_LHX);
	
	var _utils = __webpack_require__(8);
	
	var _bookJsonUtils = __webpack_require__(589);
	
	var _bookJsonUtils2 = _interopRequireDefault(_bookJsonUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CALL_API = exports.CALL_API = 'CALL_API';
	
	var dimension = new _normalizr.Schema('dimensions', {
	  idAttribute: 'dimValId'
	});
	
	var partyRoom = new _normalizr.Schema('partyRooms');
	var room = new _normalizr.Schema('rooms');
	var roomPricingOption = new _normalizr.Schema('roomPricingOptions');
	var roomRestriction = new _normalizr.Schema('roomRestrictions');
	var transfer = new _normalizr.Schema('transfers');
	var parkings = new _normalizr.Schema('parkings');
	var carHires = new _normalizr.Schema('carHires');
	var insurance = new _normalizr.Schema('insurance', {
	  idAttribute: 'insuranceid'
	});
	var paymentPlan = new _normalizr.Schema('paymentPlans', {
	  idAttribute: 'type'
	});
	
	var passenger = new _normalizr.Schema('passengers');
	var flightMeal = new _normalizr.Schema('flightMeals');
	
	dimension.define({
	  children: (0, _normalizr.arrayOf)(dimension)
	});
	
	var selectedDimension = new _normalizr.Schema('dimensions', {
	  idAttribute: 'id'
	});
	
	var similarHotels = new _normalizr.Schema('similarHotels', {
	  idAttribute: 'masterId'
	});
	
	var dimensionsStructure = {
	  D_Destination: (0, _normalizr.arrayOf)(dimension),
	  D_DepartureAirport: (0, _normalizr.arrayOf)(dimension),
	  D_BoardBasis: (0, _normalizr.arrayOf)(dimension),
	  D_Nights: (0, _normalizr.arrayOf)(dimension),
	  D_RoomConfiguration: (0, _normalizr.arrayOf)(dimension),
	  D_HolidayType: (0, _normalizr.arrayOf)(dimension),
	  D_DayOfMonth: (0, _normalizr.arrayOf)(dimension),
	  D_Operator: (0, _normalizr.arrayOf)(dimension),
	  D_PCM_Kids: (0, _normalizr.arrayOf)(dimension),
	  D_PCM_Pool: (0, _normalizr.arrayOf)(dimension),
	  D_PCM_Hotel_Facilities: (0, _normalizr.arrayOf)(dimension)
	};
	
	var Schemas = exports.Schemas = {
	  HOTEL_DETAILS: {
	    baseState: {
	      dimensions: (0, _normalizr.arrayOf)(selectedDimension)
	    },
	    dimensions: dimensionsStructure,
	    similarHotels: (0, _normalizr.arrayOf)(similarHotels)
	  },
	  BASE_STATE: {
	    baseState: {
	      dimensions: (0, _normalizr.arrayOf)(selectedDimension)
	    }
	  },
	  ANNUAL_AVAILABILITY: {
	    baseState: {
	      dimensions: (0, _normalizr.arrayOf)(selectedDimension)
	    },
	    dimensions: dimensionsStructure
	  },
	  DIMENSIONS: {
	    dimensions: dimensionsStructure
	  },
	  CALENDAR_OFFERS: {
	    json: {
	      baseState: {
	        dimensions: (0, _normalizr.arrayOf)(selectedDimension)
	      }
	    }
	  },
	  SEARCH_RESULTS: {
	    baseState: {
	      dimensions: (0, _normalizr.arrayOf)(selectedDimension)
	    },
	    dimensions: dimensionsStructure
	  },
	  DAY_OF_MONTH: {
	    dimensions: dimensionsStructure
	  },
	  BOOK: {
	    data: {
	      party: (0, _normalizr.arrayOf)(partyRoom),
	      rooms: (0, _normalizr.arrayOf)(room),
	      room_pricing_options: (0, _normalizr.arrayOf)(roomPricingOption),
	      roomRestrictions: (0, _normalizr.arrayOf)(roomRestriction),
	      transfers: (0, _normalizr.arrayOf)(transfer),
	      parkings: (0, _normalizr.arrayOf)(parkings),
	      car_hires: (0, _normalizr.arrayOf)(carHires),
	      insurance: (0, _normalizr.arrayOf)(insurance),
	      payment_plans: (0, _normalizr.arrayOf)(paymentPlan),
	      extras: {
	        flightMeals: {
	          options: (0, _normalizr.arrayOf)(flightMeal)
	        }
	      }
	    },
	    booking_info: {
	      passengers: (0, _normalizr.arrayOf)(passenger),
	      passengersByRoom: {
	        0: {
	          all: (0, _normalizr.arrayOf)(passenger),
	          adults: (0, _normalizr.arrayOf)(passenger),
	          children: (0, _normalizr.arrayOf)(passenger),
	          infants: (0, _normalizr.arrayOf)(passenger)
	        },
	        1: {
	          all: (0, _normalizr.arrayOf)(passenger),
	          adults: (0, _normalizr.arrayOf)(passenger),
	          children: (0, _normalizr.arrayOf)(passenger),
	          infants: (0, _normalizr.arrayOf)(passenger)
	        },
	        2: {
	          all: (0, _normalizr.arrayOf)(passenger),
	          adults: (0, _normalizr.arrayOf)(passenger),
	          children: (0, _normalizr.arrayOf)(passenger),
	          infants: (0, _normalizr.arrayOf)(passenger)
	        }
	      }
	    }
	  }
	};
	
	/*
	 * TODO: Add tests for the following methods
	 *
	 */
	
	/* istanbul ignore next */
	var fetchEndpoint = exports.fetchEndpoint = function fetchEndpoint(endpoint, jsonRootKey, schema, reqOptions) {
	  var requestOptions = (0, _assign2.default)({ credentials: 'same-origin' }, reqOptions);
	
	  if (requestOptions.method === 'POST' || requestOptions.method === 'PUT') {
	    requestOptions.body = (0, _stringify2.default)(requestOptions.formData);
	    requestOptions.headers = {
	      Accept: 'application/json, text/javascript, */*',
	      'Content-Type': 'application/json; charset=utf-8'
	    };
	  }
	
	  return (0, _isomorphicFetch2.default)(endpoint, requestOptions).then(function (response) {
	    return response.json().then(function (json) {
	      return { json: json, response: response };
	    });
	  }).then(function (_ref) {
	    var json = _ref.json,
	        response = _ref.response;
	
	    if (!response.ok) {
	      return _promise2.default.reject(json);
	    }
	    var resultJson = jsonRootKey ? json[jsonRootKey] : json;
	
	    if (endpoint.indexOf('/book/api/') === 0) {
	      _bookJsonUtils2.default.updateBookJson(resultJson);
	    }
	
	    return schema ? (0, _assign2.default)({}, (0, _normalizr.normalize)(resultJson, schema)) : { result: resultJson };
	  });
	};
	
	/* istanbul ignore next */
	function chkForErrors(_ref2) {
	  var endpoint = _ref2.endpoint,
	      types = _ref2.types;
	
	  if (typeof endpoint !== 'string') {
	    throw new Error('Specify a string endpoint URL.');
	  }
	
	  if (!Array.isArray(types) || types.length !== 3) {
	    throw new Error('Expected an array of three action types.');
	  }
	}
	
	/* istanbul ignore next */
	function actionWith(action, data) {
	  if (data.type === 'HANDOFF_SUCCESS') {
	    if (window.location.pathname.includes('book-handoff')) {
	      window.location.replace(data.response.result.forward);
	    } else {
	      window.location.href = data.response.result.forward;
	    }
	  }
	
	  if ((0, _utils.checkForNestedProperty)(data, 'response.result.status')) {
	    var status = data.response.result.status;
	    if (status.error && status.location) {
	      window.location.href = data.response.result.status.location;
	      return {
	        type: 'SERVER_ERROR_REDIRECT'
	      };
	    }
	  }
	
	  var finalAction = (0, _assign2.default)({}, action, data);
	  delete finalAction[CALL_API];
	  return finalAction;
	}
	
	/* istanbul ignore next */
	function processApiCall(_ref3) {
	  var store = _ref3.store,
	      action = _ref3.action,
	      next = _ref3.next,
	      callAPI = _ref3.callAPI;
	  var endpoint = callAPI.endpoint;
	  var schema = callAPI.schema,
	      types = callAPI.types,
	      jsonRootKey = callAPI.jsonRootKey,
	      requestOptions = callAPI.requestOptions,
	      externalCallback = callAPI.externalCallback;
	
	  var _types = (0, _slicedToArray3.default)(types, 3),
	      requestType = _types[0],
	      successType = _types[1],
	      failureType = _types[2];
	
	  var userClass = _LHX2.default.userClass;
	  var channel = (0, _utils.readCookie)('lvh_ch');
	
	  if (typeof endpoint === 'function') {
	    endpoint = endpoint(store.getState());
	  }
	
	  if (userClass) {
	    endpoint = (0, _utils.addUrlParam)(endpoint, 'uc', userClass);
	  }
	
	  if (channel) {
	    endpoint = (0, _utils.addUrlParam)(endpoint, 'ch', channel);
	  }
	
	  chkForErrors({ endpoint: endpoint, types: types });
	  next(actionWith(action, { type: requestType }));
	
	  return fetchEndpoint(endpoint, jsonRootKey, schema, requestOptions).then(function (response) {
	    if (externalCallback) {
	      externalCallback(response);
	    }
	
	    next(actionWith(action, {
	      response: response,
	      type: successType
	    }));
	  }, function (error) {
	    if (externalCallback) {
	      externalCallback(null, error);
	    }
	
	    next(actionWith(action, {
	      type: failureType,
	      error: error.message || 'Something bad happened'
	    }));
	  });
	}
	
	/* istanbul ignore next */
	
	exports.default = function (store) {
	  return function (next) {
	    return function (action) {
	      var callAPI = action[CALL_API];
	
	      return typeof callAPI === 'undefined' ? next(action) : processApiCall({ store: store, action: action, next: next, callAPI: callAPI });
	    };
	  };
	};

/***/ },
/* 38 */
[1420, 227, 171, 41],
/* 39 */,
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.openSubModal = exports.toggleModal = exports.setModalClosing = exports.TYPES = undefined;
	
	var _assign = __webpack_require__(32);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _utils = __webpack_require__(8);
	
	var _popoverActions = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPES = exports.TYPES = {
	  TOGGLE_MODAL: 'TOGGLE_MODAL',
	  TOGGLE_MODAL_SUBPAGE: 'TOGGLE_MODAL_SUBPAGE',
	  SET_MODAL_CLOSING: 'SET_MODAL_CLOSING'
	};
	
	var setModalClosing = exports.setModalClosing = function setModalClosing() {
	  return {
	    type: TYPES.SET_MODAL_CLOSING
	  };
	};
	
	var toggleModal = exports.toggleModal = function toggleModal() {
	  var modalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var modalConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return function (dispatch, getState) {
	    var modal = modalId;
	    var config = modalConfig;
	    var isMobileBreakpoint = getState().appState.get('isMobileBreakpoint', false);
	
	    if (modal === '') {
	      var currentModalState = getState().modal;
	      var currentModalConfig = currentModalState && currentModalState.config ? currentModalState.config : {};
	
	      if (currentModalConfig.parentModal) {
	        modal = currentModalConfig.parentModal.name;
	        config = currentModalConfig.parentModal.config;
	      } else if (currentModalConfig.delayClosing && !currentModalConfig.isClosing && !isMobileBreakpoint) {
	        dispatch(setModalClosing());
	        setTimeout(function () {
	          dispatch(toggleModal(modal, config));
	        }, currentModalConfig.delayClosing);
	        return;
	      }
	    }
	
	    if (config.forceFullHeightIfMobile) {
	      config.forceFullHeight = isMobileBreakpoint;
	    }
	
	    var shouldOpenSubPageModal = config.subPageIfMobile && isMobileBreakpoint;
	
	    if (shouldOpenSubPageModal) {
	      config.isSubPage = true;
	    }
	
	    if (config.slideInFromTheSide) {
	      config = (0, _assign2.default)({ delayClosing: 500 }, config);
	    }
	
	    dispatch((0, _popoverActions.hidePopover)());
	
	    dispatch({
	      type: TYPES.TOGGLE_MODAL,
	      modal: modal,
	      config: config
	    });
	
	    if (shouldOpenSubPageModal) {
	      var location = getState().router.location;
	      (0, _utils.updateURLWithPush)((0, _utils.getSubPageLocation)(config.subPageIfMobile, location));
	    }
	  };
	};
	
	var openSubModal = exports.openSubModal = function openSubModal(modal) {
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return function (dispatch, getState) {
	    var modalState = getState().modal;
	    if (modalState && modalState.name) {
	      config.parentModal = modalState;
	    }
	
	    dispatch(toggleModal(modal, config));
	  };
	};

/***/ },
/* 41 */
13,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(41);
	var core = __webpack_require__(31);
	var ctx = __webpack_require__(121);
	var hide = __webpack_require__(97);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(32);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var DOMParser = typeof window !== 'undefined' && window.DOMParser;
	var process = process || {};
	process.env = process.env || {};
	var parserAvailable = typeof DOMParser !== 'undefined' && DOMParser.prototype != null && DOMParser.prototype.parseFromString != null;
	
	function isParsable(src) {
	    // kinda naive but meh, ain't gonna use full-blown parser for this
	    return parserAvailable && typeof src === 'string' && src.trim().substr(0, 4) === '<svg';
	}
	
	// parse SVG string using `DOMParser`
	function parseFromSVGString(src) {
	    var parser = new DOMParser();
	    return parser.parseFromString(src, "image/svg+xml");
	}
	
	// Transform DOM prop/attr names applicable to `<svg>` element but react-limited
	function switchSVGAttrToReactProp(propName) {
	    switch (propName) {
	        case 'class':
	            return 'className';
	        default:
	            return propName;
	    }
	}
	
	var InlineSVG = (function (_React$Component) {
	    _inherits(InlineSVG, _React$Component);
	
	    _createClass(InlineSVG, null, [{
	        key: 'defaultProps',
	        value: {
	            element: 'i',
	            raw: false,
	            src: ''
	        },
	        enumerable: true
	    }, {
	        key: 'propTypes',
	        value: {
	            src: _react2['default'].PropTypes.string.isRequired,
	            element: _react2['default'].PropTypes.string,
	            raw: _react2['default'].PropTypes.bool
	        },
	        enumerable: true
	    }]);
	
	    function InlineSVG(props) {
	        _classCallCheck(this, InlineSVG);
	
	        _get(Object.getPrototypeOf(InlineSVG.prototype), 'constructor', this).call(this, props);
	        this._extractSVGProps = this._extractSVGProps.bind(this);
	    }
	
	    // Serialize `Attr` objects in `NamedNodeMap`
	
	    _createClass(InlineSVG, [{
	        key: '_serializeAttrs',
	        value: function _serializeAttrs(map) {
	            var ret = {};
	            var prop = undefined;
	            for (var i = 0; i < map.length; i++) {
	                prop = switchSVGAttrToReactProp(map[i].name);
	                ret[prop] = map[i].value;
	            }
	            return ret;
	        }
	
	        // get <svg /> element props
	    }, {
	        key: '_extractSVGProps',
	        value: function _extractSVGProps(src) {
	            var map = parseFromSVGString(src).documentElement.attributes;
	            return map.length > 0 ? this._serializeAttrs(map) : null;
	        }
	
	        // get content inside <svg> element.
	    }, {
	        key: '_stripSVG',
	        value: function _stripSVG(src) {
	            return parseFromSVGString(src).documentElement.innerHTML;
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref) {
	            var children = _ref.children;
	
	            if ("production" !== process.env.NODE_ENV && children != null) {
	                console.info('<InlineSVG />: `children` prop will be ignored.');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var Element = undefined,
	                __html = undefined,
	                svgProps = undefined;
	            var _props = this.props;
	            var element = _props.element;
	            var raw = _props.raw;
	            var src = _props.src;
	
	            var otherProps = _objectWithoutProperties(_props, ['element', 'raw', 'src']);
	
	            if (raw === true && isParsable(src)) {
	                Element = 'svg';
	                svgProps = this._extractSVGProps(src);
	                __html = this._stripSVG(src);
	            }
	            __html = __html || src;
	            Element = Element || element;
	            svgProps = svgProps || {};
	
	            return _react2['default'].createElement(Element, _extends({}, svgProps, otherProps, { src: null, children: null,
	                dangerouslySetInnerHTML: { __html: __html } }));
	        }
	    }]);
	
	    return InlineSVG;
	})(_react2['default'].Component);
	
	exports['default'] = InlineSVG;
	module.exports = exports['default'];

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _reactRouter = __webpack_require__(78);
	
	var _LinkSubPage = __webpack_require__(208);
	
	var _LinkSubPage2 = _interopRequireDefault(_LinkSubPage);
	
	__webpack_require__(920);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinkButton = function (_Component) {
	  (0, _inherits3.default)(LinkButton, _Component);
	
	  function LinkButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, LinkButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LinkButton.__proto__ || (0, _getPrototypeOf2.default)(LinkButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      tapped: ''
	    }, _this.shouldComponentUpdate = _function2.default, _this.touchStart = function () {
	      _this.setState({
	        tapped: 'tapped'
	      });
	    }, _this.touchEnd = function () {
	      _this.setState({
	        tapped: ''
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(LinkButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          to = _props.to,
	          isExternal = _props.isExternal,
	          children = _props.children,
	          color = _props.color,
	          onClick = _props.onClick,
	          type = _props.type,
	          size = _props.size,
	          align = _props.align,
	          isSubPage = _props.isSubPage,
	          location = _props.location;
	
	
	      var className = 'link-button link-button--' + (type || 'default') + '\n      ' + (this.state.tapped ? 'link-button--' + this.state.tapped : '') + '\n      ' + (size ? 'link-button--' + size : '') + '\n      ' + (align ? 'link-button--' + align + '-align' : '') + '\n      ' + (color ? 'link-button--' + color : '');
	
	      var link = void 0;
	
	      if (this.props.isDisabled) {
	        link = _react2.default.createElement(
	          'div',
	          { className: className + ' link-button--is-disabled', 'data-optimizely-id': 'LinkButton' },
	          children
	        );
	      } else if (isExternal) {
	        link = _react2.default.createElement(
	          'a',
	          {
	            href: to,
	            className: className,
	            onTouchStart: this.touchStart,
	            onTouchEnd: this.touchEnd,
	            onClick: onClick,
	            'data-optimizely-id': 'Link'
	          },
	          children
	        );
	      } else if (isSubPage) {
	        link = _react2.default.createElement(
	          _LinkSubPage2.default,
	          {
	            to: to,
	            location: location,
	            className: className,
	            onTouchStart: this.touchStart,
	            onTouchEnd: this.touchEnd,
	            onClick: onClick,
	            'data-optimizely-id': 'Link'
	          },
	          children
	        );
	      } else {
	        link = _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            to: to,
	            className: className,
	            onTouchStart: this.touchStart,
	            onTouchEnd: this.touchEnd,
	            onClick: onClick,
	            'data-optimizely-id': 'Link'
	          },
	          children
	        );
	      }
	
	      return this.props.hasWrapper ? _react2.default.createElement(
	        'div',
	        { className: 'link-button__wrapper' },
	        link
	      ) : link;
	    }
	  }]);
	  return LinkButton;
	}(_react.Component);
	
	LinkButton.defaultProps = {
	  onClick: function onClick() {
	    return true;
	  },
	  to: '#'
	};
	exports.default = LinkButton;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadDayOfMonthData = exports.suggestDestinations = exports.resetChildCountIfNotAllAgesSet = exports.changeChildAge = exports.changeNumberOfChildren = exports.changeNumberOfAdults = exports.validateRoom = exports.updateSearchUnitData = exports.getSearchUnitData = exports.resetSearchForm = exports.removeRoom = exports.addRoom = exports.setDepartureDateAndFlexibility = exports.setDepartureDateFlexibility = exports.setDepartureDate = exports.clearDepartureDateAndFlexibility = exports.clearDepartureDate = exports.removeDepartureAirport = exports.addDepartureAirport = exports.removeDestination = exports.addDestination = exports.setDuration = exports.updateBaseStateAndGetAvailability = exports.getAvailability = exports.getDimensions = exports.suggestHotels = exports.TYPES = undefined;
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(32);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _global = __webpack_require__(79);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _LHX = __webpack_require__(67);
	
	var _LHX2 = _interopRequireDefault(_LHX);
	
	var _utils = __webpack_require__(8);
	
	var _popoverActions = __webpack_require__(144);
	
	var popoverActions = _interopRequireWildcard(_popoverActions);
	
	var _baseStateActions = __webpack_require__(142);
	
	var baseStateActions = _interopRequireWildcard(_baseStateActions);
	
	var _dimensionsAvailabilityActions = __webpack_require__(318);
	
	var dimensionsAvailabilityActions = _interopRequireWildcard(_dimensionsAvailabilityActions);
	
	var _dimensionsActions = __webpack_require__(212);
	
	var dimensionsActions = _interopRequireWildcard(_dimensionsActions);
	
	var _appStateActions = __webpack_require__(94);
	
	var appStateActions = _interopRequireWildcard(_appStateActions);
	
	var _searchActions = __webpack_require__(320);
	
	var searchActions = _interopRequireWildcard(_searchActions);
	
	var _api = __webpack_require__(37);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var partyRef = void 0;
	var childrenAgesRefs = void 0;
	var smBreakpoint = 768;
	var dimensionTypes = 'D_PCM_Hotel_Facilities,D_Destination,D_DepartureAirport,D_BoardBasis,D_Nights';
	
	var TYPES = exports.TYPES = {
	  DAY_OF_MONTH_REQUEST: 'DAY_OF_MONTH_REQUEST',
	  DAY_OF_MONTH_SUCCESS: 'DAY_OF_MONTH_SUCCESS',
	  DAY_OF_MONTH_FAILURE: 'DAY_OF_MONTH_FAILURE'
	};
	
	var suggestHotels = exports.suggestHotels = function suggestHotels(searchConfig) {
	  return function (dispatch, getState) {
	    dispatch(appStateActions.loadingStartDelayedSpinner());
	    return dispatch(searchActions.suggestHotels(searchConfig)).then(function () {
	      var results = getState().search.toArray();
	      dispatch(appStateActions.setHasNoHotelResults(results.length === 0));
	      dispatch(appStateActions.loadingFinish());
	    });
	  };
	};
	
	var getDimensions = exports.getDimensions = function getDimensions(dispatch, getState) {
	  var baseState = getState().baseState;
	  dispatch(dimensionsActions.loadDimensions({
	    dimensions: dimensionTypes,
	    state: baseState.get('currentStateEncoded')
	  }));
	};
	
	var getAvailability = exports.getAvailability = function getAvailability(dispatch, getState) {
	  var baseState = getState().baseState;
	  dispatch(dimensionsAvailabilityActions.loadDimensionsAvailability({
	    dimensions: dimensionTypes,
	    state: baseState.get('currentStateEncoded')
	  }));
	};
	
	var updateBaseStateAndGetAvailability = exports.updateBaseStateAndGetAvailability = function updateBaseStateAndGetAvailability(requestObj, dispatch, getState) {
	  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var baseState = getState().baseState;
	  var state = baseState.get('currentStateEncoded', '');
	
	  var calDate = baseState.getIn(['queryState', 'props', 'calDate', 'value']);
	  var calDateSelected = baseState.getIn(['queryState', 'props', 'calDate', 'selected']);
	
	  if (!opts.forceReset && calDateSelected && !requestObj.deptDate && !requestObj.calDate) {
	    requestObj.deptDate = requestObj.deptDate || calDate;
	    requestObj.calDate = requestObj.calDate || calDate;
	  }
	
	  var hotelOnlyPanda = window.location.href.includes('view=HO');
	  var isMobileBreakpoint = getState().appState.get('isMobileBreakpoint');
	
	  dispatch(appStateActions.loadingStart());
	  dispatch(baseStateActions.setRoomsValidity(true));
	  dispatch(popoverActions.hidePopover());
	  return dispatch(baseStateActions.loadBaseState((0, _assign2.default)({ state: state }, requestObj))).then(function () {
	    if (!hotelOnlyPanda && !isMobileBreakpoint) {
	      dispatch(getAvailability);
	    }
	  }).then(function () {
	    return dispatch(appStateActions.loadingFinish());
	  }).then(function () {
	    if (opts.externalCallback) {
	      opts.externalCallback();
	    }
	  });
	};
	
	var setDuration = exports.setDuration = function setDuration(duration, isFlex) {
	  return function (dispatch, getState) {
	    var baseState = getState().baseState;
	    var currentDuration = baseState.getIn(['D_Nights', 0]);
	    updateBaseStateAndGetAvailability({
	      remove: currentDuration,
	      add: duration,
	      nightFlex: isFlex ? 1 : 'removed'
	    }, dispatch, getState);
	  };
	};
	
	var addDestination = exports.addDestination = function addDestination(dimId) {
	  return function (dispatch, getState) {
	    return updateBaseStateAndGetAvailability({
	      add: dimId
	    }, dispatch, getState);
	  };
	};
	
	var removeDestination = exports.removeDestination = function removeDestination(dimId) {
	  return function (dispatch, getState) {
	    updateBaseStateAndGetAvailability({
	      remove: dimId
	    }, dispatch, getState);
	  };
	};
	
	var addDepartureAirport = exports.addDepartureAirport = function addDepartureAirport(dimId) {
	  return function (dispatch, getState) {
	    var baseState = getState().baseState;
	    var requestObj = {};
	
	    if (baseState.get('D_DepartureAirport', []).includes(dimId)) {
	      requestObj.remove = dimId;
	    } else {
	      requestObj.add = dimId;
	    }
	
	    updateBaseStateAndGetAvailability(requestObj, dispatch, getState);
	  };
	};
	
	var removeDepartureAirport = exports.removeDepartureAirport = function removeDepartureAirport(dimId) {
	  return function (dispatch, getState) {
	    updateBaseStateAndGetAvailability({
	      remove: dimId
	    }, dispatch, getState);
	  };
	};
	
	var clearDepartureDate = exports.clearDepartureDate = function clearDepartureDate() {
	  return function (dispatch, getState) {
	    updateBaseStateAndGetAvailability({
	      deptDate: 'removed',
	      calDate: 'removed'
	    }, dispatch, getState);
	  };
	};
	
	var clearDepartureDateAndFlexibility = exports.clearDepartureDateAndFlexibility = function clearDepartureDateAndFlexibility() {
	  return function (dispatch, getState) {
	    updateBaseStateAndGetAvailability({
	      deptDate: 'removed',
	      calDate: 'removed',
	      deptDateFlexibility: 'removed'
	    }, dispatch, getState);
	  };
	};
	
	var setDepartureDate = exports.setDepartureDate = function setDepartureDate(calDate, externalCallback) {
	  return function (dispatch, getState) {
	    updateBaseStateAndGetAvailability({
	      deptDate: calDate,
	      calDate: calDate
	    }, dispatch, getState, { externalCallback: externalCallback });
	  };
	};
	
	var setDepartureDateFlexibility = exports.setDepartureDateFlexibility = function setDepartureDateFlexibility(flexibility) {
	  return function (dispatch, getState) {
	    updateBaseStateAndGetAvailability({
	      deptDateFlexibility: flexibility
	    }, dispatch, getState);
	  };
	};
	
	var setDepartureDateAndFlexibility = exports.setDepartureDateAndFlexibility = function setDepartureDateAndFlexibility(calDate, flexibility) {
	  return function (dispatch, getState) {
	    updateBaseStateAndGetAvailability({
	      deptDateFlexibility: flexibility,
	      deptDate: calDate,
	      calDate: calDate
	    }, dispatch, getState);
	  };
	};
	
	var addRoom = exports.addRoom = function addRoom() {
	  return function (dispatch, getState) {
	    var baseState = getState().baseState;
	    var rooms = baseState.getIn(['queryState', 'props', 'rooms'], _immutable2.default.List());
	
	    updateBaseStateAndGetAvailability((0, _defineProperty3.default)({}, 'rooms[' + rooms.size + '].nAdt', 2), dispatch, getState);
	  };
	};
	
	var removeRoom = exports.removeRoom = function removeRoom(roomNumber) {
	  return function (dispatch, getState) {
	    updateBaseStateAndGetAvailability((0, _defineProperty3.default)({}, 'rooms[' + roomNumber + ']', 'removed'), dispatch, getState);
	  };
	};
	
	var resetSearchForm = exports.resetSearchForm = function resetSearchForm() {
	  return function (dispatch, getState) {
	    updateBaseStateAndGetAvailability({ state: '' }, dispatch, getState, { forceReset: true });
	  };
	};
	
	var getSearchUnitData = exports.getSearchUnitData = function getSearchUnitData(state) {
	  return function (dispatch) {
	    dispatch(appStateActions.loadingStart());
	    dispatch(baseStateActions.loadBaseState({
	      state: state || _LHX2.default.state
	    })).then(function () {
	      return dispatch(getDimensions);
	    }).then(function () {
	      return dispatch(getAvailability);
	    }).then(function () {
	      return dispatch(appStateActions.loadingFinish());
	    });
	  };
	};
	
	var updateSearchUnitData = exports.updateSearchUnitData = function updateSearchUnitData() {
	  return function (dispatch, getState) {
	    var baseState = getState().baseState;
	
	    var requestObj = {
	      state: baseState.get('currentStateEncoded', '')
	    };
	
	    baseState.getIn(['queryState', 'props', 'rooms'], _immutable2.default.List()).forEach(function (room, roomNum) {
	      requestObj['rooms[' + roomNum + '].nAdt'] = room.getIn(['nAdt', 'value']);
	
	      var childrenAgesString = room.getIn(['cdn', 'arrayValue'], _immutable2.default.List()).toJS().join(',');
	      requestObj['rooms[' + roomNum + '].cdn'] = childrenAgesString;
	    });
	
	    updateBaseStateAndGetAvailability(requestObj, dispatch, getState);
	  };
	};
	
	function numberOfAdultsInRoom(baseState, roomNum) {
	  return baseState.getIn(['queryState', 'props', 'rooms', Number(roomNum), 'nAdt', 'value']);
	}
	
	function getChildAgesInRoom(baseState, roomNum) {
	  return baseState.getIn(['queryState', 'props', 'rooms', Number(roomNum), 'cdn', 'arrayValue'], _immutable2.default.List()).toJS();
	}
	
	function numberOfGuestsInRoom(baseState, roomNum) {
	  var childAges = getChildAgesInRoom(baseState, roomNum);
	  var numberOfAdults = numberOfAdultsInRoom(baseState, roomNum);
	
	  return numberOfAdults + childAges.length;
	}
	
	function numberOfInfantsInRoom(baseState, roomNum) {
	  var childAges = getChildAgesInRoom(baseState, roomNum);
	
	  return childAges.filter(function (childAge) {
	    return childAge < 2 && childAge >= 0;
	  }).length;
	}
	
	function areAllChildAgesSetInRoom(baseState, roomNum) {
	  var childAges = getChildAgesInRoom(baseState, roomNum);
	  var numChildren = childAges.length;
	
	  return (0, _utils.range)(0, numChildren).every(function (index) {
	    return childAges[index] !== '-1' && childAges[index] !== undefined;
	  });
	}
	
	function areAllChildAgesUnsetInRoom(baseState, roomNum) {
	  var childAges = getChildAgesInRoom(baseState, roomNum);
	  var numChildren = childAges.length;
	
	  return (0, _utils.range)(0, numChildren).every(function (index) {
	    return childAges[index] === '-1' || childAges[index] === undefined;
	  });
	}
	
	function showPartySizePopover(appState) {
	  var content = {
	    id: 'partySize',
	    title: 'Party Size',
	    body: _react2.default.createElement(
	      'p',
	      null,
	      'Bookings are limited to ',
	      _global2.default.maxRoomGuests,
	      ' people per room.'
	    )
	  };
	
	  var viewportWidth = appState.getIn(['viewportDimensions', 'width']);
	
	  return popoverActions.showPopover({
	    position: viewportWidth >= smBreakpoint ? 'left' : 'top',
	    relativeRef: partyRef,
	    yOffset: 35
	  }, content);
	}
	
	function showInfantsPopover(appState, baseState, roomNum) {
	  var firstIndexOfInfantField = baseState.getIn(['queryState', 'props', 'rooms', '' + roomNum, 'cdn', 'arrayValue'], _immutable2.default.List()).toJS().findIndex(function (childAge) {
	    return childAge < 2;
	  });
	
	  var content = {
	    id: 'infants',
	    title: 'Infants',
	    body: _react2.default.createElement(
	      'p',
	      null,
	      'The number of infants on a booking must be equal to or less than the number of adults. Infants must be placed on the lap of an adult at all times during a flight.'
	    )
	  };
	
	  var firstInfantField = childrenAgesRefs[firstIndexOfInfantField];
	  var viewportWidth = appState.getIn(['viewportDimensions', 'width']);
	  var popoverConfig = { relativeRef: firstInfantField };
	
	  if (viewportWidth >= smBreakpoint) {
	    popoverConfig.position = 'left';
	    popoverConfig.yOffset = 45;
	  }
	
	  return popoverActions.showPopover(popoverConfig, content);
	}
	
	function showChildAgesPopover(appState) {
	  var content = {
	    id: 'childAges',
	    title: 'Infant and Child Ages',
	    body: _react2.default.createElement(
	      'p',
	      null,
	      'You must enter the age of all infants and children on the date of return to the UK.'
	    )
	  };
	
	  var viewportWidth = appState.getIn(['viewportDimensions', 'width']);
	  var firstChildAge = childrenAgesRefs[0];
	  var popoverConfig = { relativeRef: firstChildAge };
	
	  if (viewportWidth >= smBreakpoint) {
	    popoverConfig.position = 'left';
	    popoverConfig.yOffset = 45;
	  }
	
	  return popoverActions.showPopover(popoverConfig, content);
	}
	
	var validateRoom = exports.validateRoom = function validateRoom(roomNum) {
	  return function (dispatch, getState) {
	    var isValid = false;
	
	    var _getState = getState(),
	        baseState = _getState.baseState,
	        appState = _getState.appState;
	
	    var numberOfAdults = numberOfAdultsInRoom(baseState, roomNum);
	    var numberOfChildren = getChildAgesInRoom(baseState, roomNum).length;
	
	    if (numberOfGuestsInRoom(baseState, roomNum) > _global2.default.maxRoomGuests) {
	      dispatch(showPartySizePopover(appState));
	    } else if (numberOfInfantsInRoom(baseState, roomNum) > numberOfAdults) {
	      dispatch(showInfantsPopover(appState, baseState, roomNum));
	    } else if (numberOfChildren && areAllChildAgesUnsetInRoom(baseState, roomNum)) {
	      dispatch(showChildAgesPopover(appState));
	    } else if (numberOfChildren && !areAllChildAgesUnsetInRoom(baseState, roomNum) && !areAllChildAgesSetInRoom(baseState, roomNum)) {
	      dispatch(popoverActions.hidePopover());
	    } else if (areAllChildAgesSetInRoom(baseState, roomNum)) {
	      dispatch(updateSearchUnitData());
	      dispatch(popoverActions.hidePopover());
	      isValid = true;
	    }
	
	    dispatch(baseStateActions.setRoomsValidity(isValid));
	  };
	};
	
	var changeNumberOfAdults = exports.changeNumberOfAdults = function changeNumberOfAdults(roomNum, numAdults, partyElementRef, childrenAgesElementRefs) {
	  return function (dispatch) {
	    dispatch(baseStateActions.changeNumberOfAdults(roomNum, numAdults));
	
	    partyRef = partyElementRef;
	    childrenAgesRefs = childrenAgesElementRefs;
	    dispatch(validateRoom(roomNum));
	  };
	};
	
	var changeNumberOfChildren = exports.changeNumberOfChildren = function changeNumberOfChildren(roomNum, numChildren, partyElementRef, childrenAgesElementRefs) {
	  return function (dispatch) {
	    dispatch(baseStateActions.changeNumberOfChildren(roomNum, numChildren));
	
	    partyRef = partyElementRef;
	    childrenAgesRefs = childrenAgesElementRefs;
	    dispatch(validateRoom(roomNum));
	  };
	};
	
	var changeChildAge = exports.changeChildAge = function changeChildAge(roomNum, childNumber, childAge, partyElementRef, childrenAgesElementRefs) {
	  return function (dispatch) {
	    dispatch(baseStateActions.changeChildAge(roomNum, childNumber, childAge));
	
	    partyRef = partyElementRef;
	    childrenAgesRefs = childrenAgesElementRefs;
	    dispatch(validateRoom(roomNum));
	  };
	};
	
	var resetChildCountIfNotAllAgesSet = exports.resetChildCountIfNotAllAgesSet = function resetChildCountIfNotAllAgesSet(roomNum) {
	  return function (dispatch, getState) {
	    var baseState = getState().baseState;
	
	    if (!areAllChildAgesSetInRoom(baseState, roomNum)) {
	      dispatch(changeNumberOfChildren(roomNum, 0, partyRef, childrenAgesRefs));
	    }
	  };
	};
	
	var suggestDestinations = exports.suggestDestinations = function suggestDestinations(searchConfig) {
	  return function (dispatch, getState) {
	    dispatch(appStateActions.loadingStartDelayedSpinner());
	
	    return dispatch(searchActions.suggestDestinations(searchConfig)).then(function () {
	      var results = getState().search.toArray();
	      dispatch(appStateActions.setHasNoDestinationResults(results.length === 0));
	      dispatch(appStateActions.loadingFinish());
	    });
	  };
	};
	
	var loadDayOfMonthData = exports.loadDayOfMonthData = function loadDayOfMonthData(deptDate) {
	  return function (dispatch, getState) {
	    var baseState = getState().baseState;
	    var params = {
	      url: '/holidays/',
	      state: baseState.get('currentStateEncoded', ''),
	      deptDate: deptDate,
	      deptDateFlexibility: -2,
	      expose: 'D_DayOfMonth'
	    };
	
	    return dispatch((0, _defineProperty3.default)({}, _api.CALL_API, {
	      types: [TYPES.DAY_OF_MONTH_REQUEST, TYPES.DAY_OF_MONTH_SUCCESS, TYPES.DAY_OF_MONTH_FAILURE],
	      schema: _api.Schemas.DAY_OF_MONTH,
	      endpoint: '/bridge/dayOfMonth.json?' + (0, _utils.serialize)(params)
	    }));
	  };
	};

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(324);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _typeof2 = __webpack_require__(218);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _keys = __webpack_require__(216);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.withFeatureFlags = withFeatureFlags;
	exports.validateHotelQueryProps = validateHotelQueryProps;
	exports.setFeaturesFromCookies = setFeaturesFromCookies;
	exports.setFeaturesFromSearchQuery = setFeaturesFromSearchQuery;
	exports.setUserClassFromSearchQuery = setUserClassFromSearchQuery;
	exports.setFeaturesFromTemporaryFeatures = setFeaturesFromTemporaryFeatures;
	exports.resetLHX = resetLHX;
	
	var _appStateActions = __webpack_require__(94);
	
	var appStateActions = _interopRequireWildcard(_appStateActions);
	
	var _featureFlagActions = __webpack_require__(319);
	
	var featureFlagActions = _interopRequireWildcard(_featureFlagActions);
	
	var _dates = __webpack_require__(35);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _userClassAssignment = __webpack_require__(554);
	
	var _userClassAssignment2 = _interopRequireDefault(_userClassAssignment);
	
	var _temporaryFeatures = __webpack_require__(553);
	
	var _temporaryFeatures2 = _interopRequireDefault(_temporaryFeatures);
	
	var _utils = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(10);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapFeatureFlagsStateToProps = function mapFeatureFlagsStateToProps(state) {
	  return {
	    featureFlags: state.featureFlags
	  };
	};
	
	function withFeatureFlags(component) {
	  return (0, _reactRedux.connect)(mapFeatureFlagsStateToProps)(component);
	}
	
	var defaultProps = {
	  assetRoot: '',
	  version: '',
	  environment: '',
	  theme: 'loveholidays',
	  isHeaderHidden: false,
	  isFooterHidden: false,
	  isPhoneEnabled: false,
	  landlinePhone: '',
	  afterSalesPhone: '',
	  braintreeToken: '',
	  serverLeg: '',
	  backbonePandaChangeTab: function backbonePandaChangeTab() {
	    return {};
	  },
	  reactFetchCalendarOffers: function reactFetchCalendarOffers() {
	    return {};
	  },
	  bannerHome: '',
	  bannerSearchResults: '',
	  bannerHotelDetails: '',
	  bannerHomeUrl: '',
	  state: '',
	  calDate: 0,
	  manageMyBooking: {},
	  manageAddPassengerInfo: {},
	  cms: {},
	  token: '',
	  landlinePhoneMinBasketValueDP: 0,
	  landlinePhoneMinBasketValueHO: 0,
	  landlinePhoneOnBook: true,
	  landlinePhoneOnPanda: true,
	  landlinePhoneOnFAQ: true,
	  landlinePhoneOnMobile: true,
	  footerDestinationLinks: [],
	  footerAirportLinks: [],
	  footerHotelLinks: [],
	  footerHolidayLinks: [],
	  loggedInSupplier: [],
	  footerTerms: {},
	  changePasswordLink: ''
	};
	
	function initialState() {
	  return {
	    store: null,
	    user: {},
	    userClass: [],
	    featureEntities: {},
	    featureQueriedItems: {},
	    featureCookieItems: {
	      BookDisplayPerNightPricing: 'lvh_per_night_pricing'
	    }
	  };
	}
	
	var state = initialState();
	
	function setUserClass(featureUserClass) {
	  if (featureUserClass && state.userClass.indexOf(featureUserClass.toUpperCase()) === -1) {
	    state.userClass.push(featureUserClass.toUpperCase());
	  }
	}
	
	function deleteUserClass(featureUserClass) {
	  var index = state.userClass.indexOf(featureUserClass.toUpperCase());
	
	  state.userClass.splice(index, 1);
	}
	
	function setFeatureFlag(featureKey) {
	  setUserClass(_userClassAssignment2.default[featureKey]);
	  state.featureEntities[featureKey] = true;
	
	  if (state.store) {
	    state.store.dispatch(featureFlagActions.setFeatureFlag(featureKey));
	  }
	}
	
	function updateUser(userData) {
	  var keys = (0, _keys2.default)(userData);
	
	  keys.map(function (key) {
	    state.user[key] = userData[key];
	  });
	}
	
	/* eslint-disable no-console */
	function validateHotelQueryProps(query) {
	  var requiredNumberParams = ['masterId', 'duration', 'adults'];
	  var optionalNumberParams = ['deptDate'];
	  var optionalArrayParams = ['childAges', 'loggedInSupplier'];
	  var isValid = true;
	
	  requiredNumberParams.forEach(function (key) {
	    if (!query[key]) {
	      console.error('LHX hotelOnlyQuery missing required property: ' + key);
	      isValid = false;
	    } else if (typeof query[key] !== 'number') {
	      console.error('LHX hotelOnlyQuery property must be number: ' + key);
	      isValid = false;
	    }
	  });
	
	  optionalNumberParams.forEach(function (key) {
	    if (query[key] && typeof query[key] !== 'number') {
	      console.error('LHX hotelOnlyQuery property must be number: ' + key);
	      isValid = false;
	    }
	  });
	
	  optionalArrayParams.forEach(function (key) {
	    if (query[key] && !Array.isArray(query[key])) {
	      console.error('LHX hotelOnlyQuery property must be Array: ' + key);
	      isValid = false;
	    }
	  });
	
	  return isValid;
	}
	/* eslint-enable no-console */
	
	function setFeaturesFromCookies() {
	  var cookies = state.featureCookieItems;
	  (0, _keys2.default)(cookies).filter(function (flag) {
	    return (0, _utils.readCookie)(cookies[flag]);
	  }).forEach(setFeatureFlag);
	}
	
	function setFeaturesFromSearchQuery(search) {
	  var searchObj = (0, _utils.hash2Obj)(search);
	  var featureKeyItems = searchObj.lhx && searchObj.lhx.split(',');
	
	  if (featureKeyItems) {
	    featureKeyItems.map(setFeatureFlag);
	  }
	}
	
	function setUserClassFromSearchQuery(search) {
	  var searchObj = (0, _utils.hash2Obj)(search);
	  var userClassKeyItems = searchObj.uc && searchObj.uc.split('');
	
	  if (userClassKeyItems) {
	    userClassKeyItems.map(setUserClass);
	  }
	}
	
	/* eslint-disable no-console */
	function setFeaturesFromTemporaryFeatures(featuresObj) {
	  var featureKeys = (0, _keys2.default)(featuresObj);
	
	  featureKeys.map(function (key) {
	    setFeatureFlag(key);
	
	    /* istanbul ignore if */
	    if (false) {
	      var maxDays = 90;
	      var tempFeatureDate = _dates2.default.isoStringToDate(featuresObj[key]);
	      var tempFeatureExpireDate = tempFeatureDate.setDate(tempFeatureDate.getDate() + maxDays);
	
	      if (tempFeatureExpireDate > Date.now()) {
	        console.warn('LHX temporary feature set for over ' + maxDays + ' days: \'' + key + '\' set on ' + _dates2.default.format(tempFeatureDate, 'DD MMM YYYY'));
	      }
	    }
	  });
	}
	/* eslint-enable no-console */
	
	var LoveholidaysExternalApi = function () {
	  function LoveholidaysExternalApi() {
	    (0, _classCallCheck3.default)(this, LoveholidaysExternalApi);
	
	    /* istanbul ignore next */
	    var initialConfig = window.LHX || [];
	
	    this.setDefaultProps();
	    initialConfig.forEach(this.push, this);
	    setFeaturesFromCookies();
	
	    if (window && window.location && window.location.search) {
	      setFeaturesFromSearchQuery(window.location.search);
	      setUserClassFromSearchQuery(window.location.search);
	    }
	    setFeaturesFromTemporaryFeatures(_temporaryFeatures2.default);
	  }
	
	  (0, _createClass3.default)(LoveholidaysExternalApi, [{
	    key: 'connectToStore',
	    value: function connectToStore(newStore) {
	      var _this = this;
	
	      state.store = newStore;
	
	      this.enabledFeatures.forEach(function (featureFlag) {
	        state.store.dispatch(featureFlagActions.setFeatureFlag(featureFlag));
	      });
	
	      (0, _keys2.default)(defaultProps).forEach(function (key) {
	        state.store.dispatch(appStateActions.setLHXProperty(key, _this[key]));
	      });
	    }
	  }, {
	    key: 'setDefaultProps',
	    value: function setDefaultProps() {
	      var _this2 = this;
	
	      (0, _keys2.default)(defaultProps).forEach(function (key) {
	        _this2.setProperty(key, defaultProps[key]);
	      });
	    }
	  }, {
	    key: 'setProperty',
	    value: function setProperty(key, value) {
	      this[key] = value;
	      if (state.store) {
	        state.store.dispatch(appStateActions.setLHXProperty(key, value));
	      }
	    }
	  }, {
	    key: 'isEnabled',
	    value: function isEnabled(featureKey) {
	      state.featureQueriedItems[featureKey] = true;
	
	      return !!state.featureEntities[featureKey];
	    }
	  }, {
	    key: 'handleConfigObj',
	    value: function handleConfigObj(configObj) {
	      var _this3 = this;
	
	      var isMatched = false;
	      var allowedMethods = {
	        user: updateUser,
	        dangerouslySetUserClass: setUserClass,
	        dangerouslyDeleteUserClass: deleteUserClass
	      };
	      var configObjKeys = (0, _keys2.default)(configObj) || [];
	
	      configObjKeys.forEach(function (key) {
	        if (typeof defaultProps[key] !== 'undefined' && (0, _typeof3.default)(defaultProps[key]) === (0, _typeof3.default)(configObj[key])) {
	          _this3.setProperty(key, configObj[key]);
	          isMatched = true;
	        } else if (allowedMethods[key]) {
	          allowedMethods[key](configObj[key]);
	          isMatched = true;
	        }
	      });
	
	      return isMatched;
	    }
	  }, {
	    key: 'push',
	    value: function push() {
	      var isMatched = false;
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(arguments), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var featureFlagOrConfigObj = _step.value;
	
	          if (typeof featureFlagOrConfigObj === 'string') {
	            setFeatureFlag(featureFlagOrConfigObj);
	            isMatched = true;
	          } else {
	            isMatched = this.handleConfigObj(featureFlagOrConfigObj);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return isMatched;
	    }
	  }, {
	    key: 'user',
	    get: function get() {
	      return state.user;
	    }
	  }, {
	    key: 'userClass',
	    get: function get() {
	      return state.userClass.sort().join('');
	    }
	  }, {
	    key: 'enabledFeatures',
	    get: function get() {
	      return (0, _keys2.default)(state.featureEntities);
	    }
	  }, {
	    key: 'queriedFeatures',
	    get: function get() {
	      return (0, _keys2.default)(state.featureQueriedItems);
	    }
	  }]);
	  return LoveholidaysExternalApi;
	}();
	
	var LHX = new LoveholidaysExternalApi();
	
	function resetLHX() {
	  state = initialState();
	
	  LHX.setDefaultProps();
	}
	
	Object.defineProperty(window, 'LHX', {
	  value: LHX
	});
	
	exports.default = LHX;

/***/ },
/* 68 */
[1371, 98],
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 77 */,
/* 78 */,
/* 79 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  minShownDiscount: 10,
	  imagesBaseUrl: 'https://loveholidays-images.global.ssl.fastly.net/images/',
	  defaultBridgeDate: 1443657600000,
	  allFlightOptions: {
	    optionsCount: 20,
	    linkEveryNthOption: 3
	  },
	  paginationDefaults: {
	    optionsCount: 10,
	    neighborCount: 1,
	    startSpreadFromNumberOfPages: 4,
	    displayFirst: true
	  },
	  maxNumberOfRooms: 3,
	  maxRoomGuests: 5,
	  // TODO change adultsOptions to string, this will affect HO, FO, search unit, and other mobile stuff that is using it
	  adultsOptions: [1, 2, 3, 4, 5],
	  childrenOptions: ['0', '1', '2', '3', '4'],
	  minChildAge: 0,
	  maxChildAge: 17,
	  defaultSection: 'description',
	  hotelDetailsSections: {
	    description: { label: 'Overview' },
	    resort: { label: 'Resort Guide' },
	    review: { label: 'Reviews' },
	    location: { label: 'Location' },
	    // qa: { label: 'Q & A' },
	    facilities: { label: 'Facilities' }
	  },
	  maximumCancellationDays: 28,
	  numberOfCalendarMonths: 18,
	  recoverableErrorMessages: ['TNS_3DS_CHECK_FAILED', 'PAYMENT_SYSTEM_ERROR', 'TNS_CC_TOKENISATION_FAILED']
	};

/***/ },
/* 80 */
[1395, 68, 330, 230, 88],
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _splice = __webpack_require__(1335);
	
	var _splice2 = _interopRequireDefault(_splice);
	
	var _getIn = __webpack_require__(485);
	
	var _getIn2 = _interopRequireDefault(_getIn);
	
	var _setIn = __webpack_require__(1334);
	
	var _setIn2 = _interopRequireDefault(_setIn);
	
	var _deepEqual = __webpack_require__(1332);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _deleteIn = __webpack_require__(1333);
	
	var _deleteIn2 = _interopRequireDefault(_deleteIn);
	
	var _keys = __webpack_require__(486);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var structure = {
	  allowsArrayErrors: true,
	  empty: {},
	  emptyList: [],
	  getIn: _getIn2.default,
	  setIn: _setIn2.default,
	  deepEqual: _deepEqual2.default,
	  deleteIn: _deleteIn2.default,
	  forEach: function forEach(items, callback) {
	    return items.forEach(callback);
	  },
	  fromJS: function fromJS(value) {
	    return value;
	  },
	  keys: _keys2.default,
	  size: function size(array) {
	    return array ? array.length : 0;
	  },
	  some: function some(items, callback) {
	    return items.some(callback);
	  },
	  splice: _splice2.default,
	  toJS: function toJS(value) {
	    return value;
	  }
	};
	
	exports.default = structure;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(608);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },
/* 88 */
[1376, 122],
/* 89 */,
/* 90 */,
/* 91 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 92 */,
/* 93 */,
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setHasThirdPartyChannelParamHO = exports.setReasonToHideLandlinePhone = exports.setHasNoHotelResults = exports.setHasNoDestinationResults = exports.showHOFlightUpsell = exports.setViewportDimensions = exports.setNonDimensionNumberOfNights = exports.setNonDimensionDuration = exports.setDepartureAirportQuery = exports.setDestinationQuery = exports.setHotelQuery = exports.setDuration = exports.pandaSearchFormToggle = exports.setSearchResultsTrackingFlag = exports.deletePageScrollY = exports.setPageScrollY = exports.updateSelectedOfferOfDay = exports.bridgeDataLoaded = exports.loadingStartDelayedSpinner = exports.loadingFinish = exports.loadingStart = exports.clearErrors = exports.errorField = exports.setLandlinePhone = exports.TYPES = undefined;
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.setLHXProperty = setLHXProperty;
	
	var _utils = __webpack_require__(8);
	
	var _flightFiltersActions = __webpack_require__(581);
	
	var _api = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPES = exports.TYPES = {
	  LOADING_START_SPINNER: 'LOADING_START_SPINNER',
	  LOADING_START: 'LOADING_START',
	  LOADING_FINISH: 'LOADING_FINISH',
	  UPDATE_SELECTED_OFFER_OF_DAY: 'UPDATE_SELECTED_OFFER_OF_DAY',
	  SET_PAGE_SCROLL_Y: 'SET_PAGE_SCROLL_Y',
	  DELETE_PAGE_SCROLL_Y: 'DELETE_PAGE_SCROLL_Y',
	  ERROR_FIELD: 'ERROR_FIELD',
	  CLEAR_ERRORS: 'CLEAR_ERRORS',
	  SET_SEARCH_RESULTS_TRACKING_FLAG: 'SET_SEARCH_RESULTS_TRACKING_FLAG',
	  PANDA_SEARCH_FORM_TOGGLE: 'PANDA_SEARCH_FORM_TOGGLE',
	  SET_DURATION: 'SET_DURATION',
	  SET_NON_DIMENSION_DURATION: 'SET_NON_DIMENSION_DURATION',
	  SET_NON_DIMENSION_NUMBER_OF_NIGHTS: 'SET_NON_DIMENSION_NUMBER_OF_NIGHTS',
	  SET_VIEWPORT_DIMENSIONS: 'SET_VIEWPORT_DIMENSIONS',
	  SHOW_HO_FLIGHT_UPSELL: 'SHOW_HO_FLIGHT_UPSELL',
	  SET_DESTINATION_QUERY: 'SET_DESTINATION_QUERY',
	  SET_HOTEL_QUERY: 'SET_HOTEL_QUERY',
	  SET_DEPARTURE_QUERY: 'SET_DEPARTURE_QUERY',
	  SET_HAS_NO_DESTINATION_RESULTS: 'SET_HAS_NO_DESTINATION_RESULTS',
	  SET_HAS_NO_HOTEL_RESULTS: 'SET_HAS_NO_HOTEL_RESULTS',
	  LANDLINE_PHONE_REQUEST: 'LANDLINE_PHONE_REQUEST',
	  LANDLINE_PHONE_SUCCESS: 'LANDLINE_PHONE_SUCCESS',
	  LANDLINE_PHONE_FAILURE: 'LANDLINE_PHONE_FAILURE',
	  HIDE_LANDLINE_PHONE: 'HIDE_LANDLINE_PHONE',
	  SET_LHX_PROPERTY: 'SET_LHX_PROPERTY',
	  SET_HAS_THIRD_PARTY_CHANNEL_PARAM_HO: 'SET_HAS_THIRD_PARTY_CHANNEL_PARAM_HO'
	};
	
	var setLandlinePhone = exports.setLandlinePhone = function setLandlinePhone() {
	  return (0, _defineProperty3.default)({}, _api.CALL_API, {
	    types: [TYPES.LANDLINE_PHONE_REQUEST, TYPES.LANDLINE_PHONE_SUCCESS, TYPES.LANDLINE_PHONE_FAILURE],
	    endpoint: '/api/channel'
	  });
	};
	
	/* istanbul ignore next */
	var errorField = exports.errorField = function errorField(field) {
	  return {
	    type: TYPES.ERROR_FIELD,
	    field: field
	  };
	};
	
	/* istanbul ignore next */
	var clearErrors = exports.clearErrors = function clearErrors() {
	  return {
	    type: TYPES.CLEAR_ERRORS
	  };
	};
	
	var loadingStart = exports.loadingStart = function loadingStart() {
	  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'loadingState';
	  return {
	    type: TYPES.LOADING_START_SPINNER,
	    key: key
	  };
	};
	
	var loadingFinish = exports.loadingFinish = function loadingFinish() {
	  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'loadingState';
	  return {
	    type: TYPES.LOADING_FINISH,
	    key: key
	  };
	};
	
	/* istanbul ignore next */
	var loadingStartDelayedSpinner = exports.loadingStartDelayedSpinner = function loadingStartDelayedSpinner() {
	  return function (dispatch, getState) {
	    setTimeout(function () {
	      if (getState().appState.get('loadingState')) {
	        dispatch(loadingStart());
	      }
	    }, 1000);
	
	    dispatch({
	      type: TYPES.LOADING_START
	    });
	  };
	};
	
	/* istanbul ignore next */
	var bridgeDataLoaded = exports.bridgeDataLoaded = function bridgeDataLoaded() {
	  return function (dispatch, getState) {
	    var offer = getState().appState.get('selectedOffer');
	    if (offer) {
	      dispatch((0, _flightFiltersActions.deleteFilters)());
	      var selectedBoardBasis = getState().baseState.get('D_BoardBasis');
	      if (selectedBoardBasis) {
	        selectedBoardBasis.forEach(function (value) {
	          return dispatch((0, _flightFiltersActions.updateBoardBasisFilter)((0, _utils.getBoardBasisCode)(getState().dimensionsEntities.getIn([String(value), 'id'])), true));
	        });
	      }
	      dispatch((0, _flightFiltersActions.updateReturnDateFilter)(offer.get('returnDepartureDate')));
	    }
	  };
	};
	
	var updateSelectedOfferOfDay = exports.updateSelectedOfferOfDay = function updateSelectedOfferOfDay(offer) {
	  return {
	    type: TYPES.UPDATE_SELECTED_OFFER_OF_DAY,
	    offer: offer
	  };
	};
	
	var setPageScrollY = exports.setPageScrollY = function setPageScrollY(pageScrollY) {
	  return {
	    type: TYPES.SET_PAGE_SCROLL_Y,
	    pageScrollY: pageScrollY
	  };
	};
	
	var deletePageScrollY = exports.deletePageScrollY = function deletePageScrollY() {
	  return {
	    type: TYPES.DELETE_PAGE_SCROLL_Y
	  };
	};
	
	var setSearchResultsTrackingFlag = exports.setSearchResultsTrackingFlag = function setSearchResultsTrackingFlag(flag) {
	  return {
	    type: TYPES.SET_SEARCH_RESULTS_TRACKING_FLAG,
	    flag: flag
	  };
	};
	
	var pandaSearchFormToggle = exports.pandaSearchFormToggle = function pandaSearchFormToggle(flag) {
	  return {
	    type: TYPES.PANDA_SEARCH_FORM_TOGGLE,
	    flag: flag
	  };
	};
	
	var setDuration = exports.setDuration = function setDuration(addDimId) {
	  return {
	    type: TYPES.SET_DURATION,
	    addDimId: addDimId
	  };
	};
	
	var setHotelQuery = exports.setHotelQuery = function setHotelQuery(hotelQuery) {
	  return {
	    type: TYPES.SET_HOTEL_QUERY,
	    hotelQuery: hotelQuery
	  };
	};
	
	var setDestinationQuery = exports.setDestinationQuery = function setDestinationQuery(destinationQuery) {
	  return {
	    type: TYPES.SET_DESTINATION_QUERY,
	    destinationQuery: destinationQuery
	  };
	};
	
	var setDepartureAirportQuery = exports.setDepartureAirportQuery = function setDepartureAirportQuery(departureAirportQuery) {
	  return {
	    type: TYPES.SET_DEPARTURE_QUERY,
	    departureAirportQuery: departureAirportQuery
	  };
	};
	
	var setNonDimensionDuration = exports.setNonDimensionDuration = function setNonDimensionDuration(numberOfNights) {
	  return {
	    type: TYPES.SET_NON_DIMENSION_DURATION,
	    numberOfNights: numberOfNights
	  };
	};
	
	var setNonDimensionNumberOfNights = exports.setNonDimensionNumberOfNights = function setNonDimensionNumberOfNights(numberOfNights) {
	  return {
	    type: TYPES.SET_NON_DIMENSION_NUMBER_OF_NIGHTS,
	    numberOfNights: numberOfNights
	  };
	};
	
	var setViewportDimensions = exports.setViewportDimensions = function setViewportDimensions(viewportDimensions, isMobileBreakpoint) {
	  return {
	    type: TYPES.SET_VIEWPORT_DIMENSIONS,
	    viewportDimensions: viewportDimensions,
	    isMobileBreakpoint: isMobileBreakpoint
	  };
	};
	
	var showHOFlightUpsell = exports.showHOFlightUpsell = function showHOFlightUpsell(show) {
	  return {
	    type: TYPES.SHOW_HO_FLIGHT_UPSELL,
	    show: show
	  };
	};
	
	var setHasNoDestinationResults = exports.setHasNoDestinationResults = function setHasNoDestinationResults(hasNoDestinationResults) {
	  return {
	    type: TYPES.SET_HAS_NO_DESTINATION_RESULTS,
	    hasNoDestinationResults: hasNoDestinationResults
	  };
	};
	
	var setHasNoHotelResults = exports.setHasNoHotelResults = function setHasNoHotelResults(hasNoHotelResults) {
	  return {
	    type: TYPES.SET_HAS_NO_HOTEL_RESULTS,
	    hasNoHotelResults: hasNoHotelResults
	  };
	};
	
	var setReasonToHideLandlinePhone = exports.setReasonToHideLandlinePhone = function setReasonToHideLandlinePhone(reasons) {
	  return {
	    type: TYPES.HIDE_LANDLINE_PHONE,
	    reasons: reasons
	  };
	};
	
	function setLHXProperty(property, value) {
	  return {
	    type: TYPES.SET_LHX_PROPERTY,
	    property: property,
	    value: value
	  };
	}
	
	var setHasThirdPartyChannelParamHO = exports.setHasThirdPartyChannelParamHO = function setHasThirdPartyChannelParamHO(isThirdPartyChannelParam) {
	  return {
	    type: TYPES.SET_HAS_THIRD_PARTY_CHANNEL_PARAM_HO,
	    isThirdPartyChannelParam: isThirdPartyChannelParam
	  };
	};

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.privateApi = undefined;
	
	var _dates = __webpack_require__(35);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _panda = __webpack_require__(605);
	
	var _panda2 = _interopRequireDefault(_panda);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_CALENDAR_DAYS_FROM_TODAY = 7;
	
	var privateApi = {
	  getCalendarDatesArray: function getCalendarDatesArray(selectedTimestamp, viewTimestamp, isDayUnavailable) {
	    var selectedDate = _dates2.default.utcDate(selectedTimestamp);
	    var selectedDay = selectedDate.getDate();
	    var selectedMonth = selectedDate.getMonth();
	    var selectedYear = selectedDate.getFullYear();
	
	    var viewDate = _dates2.default.utcDate(viewTimestamp);
	    var viewMonth = viewDate.getMonth();
	    var viewYear = viewDate.getFullYear();
	
	    var viewingSelectedMonth = viewMonth === selectedMonth && viewYear === selectedYear;
	
	    var monthDays = [];
	    var today = new Date();
	    var firstOfViewedMonth = new Date(viewYear, viewMonth, 1);
	    var monthLength = _dates2.default.numDaysInMonth(viewYear, viewMonth);
	
	    var dayOfWeekOfFirst = firstOfViewedMonth.getDay();
	    // take a day off before getting dayOfWeek so that monday=0
	    var dayOfWeek = dayOfWeekOfFirst === 0 ? 6 : dayOfWeekOfFirst - 1;
	
	    for (var i = 0; i < monthLength; i++) {
	      monthDays[i] = {
	        day: i + 1,
	        month: viewMonth,
	        year: viewYear,
	        unavailable: isDayUnavailable(i) || new Date(viewYear, viewMonth, i + 1) < today
	      };
	    }
	    if (viewingSelectedMonth) {
	      monthDays[selectedDay - 1].highlight = 'selected';
	    }
	
	    for (var _i = 0; _i < dayOfWeek; _i++) {
	      monthDays.unshift(null);
	    }
	
	    var remainingDates = 7 - monthDays.length % 7;
	
	    for (var _i2 = 0; _i2 < remainingDates; _i2++) {
	      monthDays.push(null);
	    }
	
	    return monthDays;
	  },
	  getDefaultDate: function getDefaultDate() {
	    return _dates2.default.parseDateStampToCalDate(_dates2.default.addDays(DEFAULT_CALENDAR_DAYS_FROM_TODAY));
	  },
	  getDepartureDate: function getDepartureDate(baseState) {
	    var isPanda = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    var isDP = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    var annualAvailability = arguments[3];
	
	    var queryProps = baseState.getIn(['queryState', 'props'], _immutable2.default.Map());
	
	    var calDate = queryProps.getIn(['calDate', 'value']);
	    var calDateSelected = queryProps.getIn(['calDate', 'selected']);
	    var deptDate = queryProps.getIn(['deptDate', 'value']);
	    var deptDateSelected = queryProps.getIn(['deptDate', 'selected']);
	
	    var date = void 0;
	    // on PandA calDate takes precedence, else deptDate
	    if (!isPanda && deptDate && deptDateSelected) {
	      date = deptDate;
	    } else if (calDateSelected) {
	      date = calDate;
	    } else if (deptDateSelected) {
	      date = deptDate;
	    } else if (isPanda && isDP) {
	      _panda2.default.calculateCalDate({ baseState: baseState, annualAvailability: annualAvailability });
	    } else if (isPanda) {
	      date = this.getDefaultDate();
	    }
	
	    return date;
	  }
	};
	
	exports.privateApi = privateApi;
	
	
	var api = {
	  getCalendarDatesArray: function getCalendarDatesArray(selectedTimestamp, viewTimestamp, isDayUnavailable) {
	    return privateApi.getCalendarDatesArray(selectedTimestamp, viewTimestamp, isDayUnavailable);
	  },
	  getDepartureDate: function getDepartureDate(baseState, isPanda) {
	    return privateApi.getDepartureDate(baseState, isPanda);
	  },
	  getDefaultDate: function getDefaultDate() {
	    return privateApi.getDefaultDate();
	  }
	};
	
	exports.default = api;

/***/ },
/* 96 */
42,
/* 97 */
[1380, 80, 147, 88],
/* 98 */
17,
/* 99 */
[1414, 331, 220],
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1007),
	    getValue = __webpack_require__(1038);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TYPES = exports.TYPES = {
	  SHOW_CONTROL: 'SHOW_CONTROL',
	  HIDE_CONTROL: 'HIDE_CONTROL',
	  TOGGLE_CONTROL: 'TOGGLE_CONTROL'
	};
	
	var showControl = exports.showControl = function showControl(data, content) {
	  return {
	    type: TYPES.SHOW_CONTROL,
	    data: data,
	    content: content
	  };
	};
	var toggleControl = exports.toggleControl = function toggleControl(data, content) {
	  return {
	    type: TYPES.TOGGLE_CONTROL,
	    data: data,
	    content: content
	  };
	};
	var hideControl = exports.hideControl = function hideControl() {
	  return { type: TYPES.HIDE_CONTROL };
	};

/***/ },
/* 121 */
[1375, 168],
/* 122 */
15,
/* 123 */
125,
/* 124 */
[1402, 339, 222],
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(399),
	    copyArray = __webpack_require__(404),
	    isArray = __webpack_require__(76),
	    isSymbol = __webpack_require__(197),
	    stringToPath = __webpack_require__(412),
	    toKey = __webpack_require__(154),
	    toString = __webpack_require__(416);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	}
	
	module.exports = toPath;


/***/ },
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(8);
	
	__webpack_require__(891);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BookPrice = function (_Component) {
	  (0, _inherits3.default)(BookPrice, _Component);
	
	  function BookPrice() {
	    (0, _classCallCheck3.default)(this, BookPrice);
	    return (0, _possibleConstructorReturn3.default)(this, (BookPrice.__proto__ || (0, _getPrototypeOf2.default)(BookPrice)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BookPrice, [{
	    key: 'dividedPrice',
	    value: function dividedPrice(price) {
	      var divisor = this.props.divisor;
	
	      return (price / divisor).toFixed(2);
	    }
	  }, {
	    key: 'formatPrice',
	    value: function formatPrice(price) {
	      var _props = this.props,
	          divisor = _props.divisor,
	          hasCurrencySymbol = _props.hasCurrencySymbol,
	          isRounded = _props.isRounded;
	
	
	      var bookPrice = divisor ? this.dividedPrice(price) : price;
	      var decimalPlace = isRounded ? 0 : 2;
	      return (0, _utils.formatPenceToPounds)(bookPrice, decimalPlace, hasCurrencySymbol);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          hasSmallSuffix = _props2.hasSmallSuffix,
	          isStacked = _props2.isStacked,
	          isStrikeThrough = _props2.isStrikeThrough,
	          isStrong = _props2.isStrong,
	          prefix = _props2.prefix,
	          price = _props2.price,
	          suffix = _props2.suffix,
	          className = _props2.className;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'book-price ' + (isStrikeThrough ? 'book-price--strikethrough' : '') + ' ' + className },
	        isStrong ? _react2.default.createElement(
	          'strong',
	          { className: 'book-price__price book-price__price--strong' },
	          prefix,
	          this.formatPrice(price)
	        ) : _react2.default.createElement(
	          'span',
	          { className: 'book-price__price' },
	          prefix,
	          this.formatPrice(price)
	        ),
	        suffix && _react2.default.createElement(
	          'span',
	          { className: 'book-price__suffix ' + (hasSmallSuffix ? 'book-price__suffix--small' : '') + ' ' + (isStacked ? 'book-price__suffix--is-stacked' : '') },
	          ' ',
	          suffix
	        )
	      );
	    }
	  }]);
	  return BookPrice;
	}(_react.Component);
	
	BookPrice.defaultProps = {
	  hasCurrencySymbol: true,
	  hasSmallSuffix: false,
	  isStacked: false,
	  isStrikeThrough: false,
	  className: '',
	  isStrong: true
	};
	exports.default = BookPrice;

/***/ },
/* 140 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// eslint complains about this not being the default because there's only one constant defined here, assuming this file will grow so diaabling
	var ZERO_DAY_FLEXIBILITY_VALUE = exports.ZERO_DAY_FLEXIBILITY_VALUE = 0;
	var YEAR_FLEXIBILITY_VALUE = exports.YEAR_FLEXIBILITY_VALUE = -1;
	var MONTH_FLEXIBILITY_VALUE = exports.MONTH_FLEXIBILITY_VALUE = -2;
	
	var flexibilityItems = exports.flexibilityItems = [{
	  label: '+/- 0 Days',
	  value: ZERO_DAY_FLEXIBILITY_VALUE
	}, {
	  label: '+/- 1 Day',
	  value: 1
	}, {
	  label: '+/- 3 Days',
	  value: 3
	}, {
	  label: '+/- 5 Days',
	  value: 5
	}, {
	  label: 'Month',
	  value: MONTH_FLEXIBILITY_VALUE
	}];

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updatePrice = exports.setAnnualAvailability = exports.changeCalDateValue = exports.changeDimEntKeyVal = exports.changeNumberOfNights = exports.startLoading = exports.loadAnnualAvailability = exports.TYPES = undefined;
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(32);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _utils = __webpack_require__(8);
	
	var _LHX = __webpack_require__(67);
	
	var _LHX2 = _interopRequireDefault(_LHX);
	
	var _api = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPES = exports.TYPES = {
	  ANNUAL_AVAILABILITY_REQUEST: 'ANNUAL_AVAILABILITY_REQUEST',
	  ANNUAL_AVAILABILITY_SUCCESS: 'ANNUAL_AVAILABILITY_SUCCESS',
	  ANNUAL_AVAILABILITY_FAILURE: 'ANNUAL_AVAILABILITY_FAILURE',
	  ANNUAL_AVAILABILITY_HO_REQUEST: 'ANNUAL_AVAILABILITY_HO_REQUEST',
	  ANNUAL_AVAILABILITY_HO_SUCCESS: 'ANNUAL_AVAILABILITY_HO_SUCCESS',
	  ANNUAL_AVAILABILITY_HO_FAILURE: 'ANNUAL_AVAILABILITY_HO_FAILURE',
	  SET_LOADING_STATUS: 'SET_LOADING_STATUS',
	  CHANGE_NUMBER_OF_NIGHTS: 'CHANGE_NUMBER_OF_NIGHTS',
	  CHANGE_CALDATE_VALUE: 'CHANGE_CALDATE_VALUE',
	  SET_DIMENSION_PROPERTY: 'SET_DIMENSION_PROPERTY',
	  UPDATE_PRICE: 'UPDATE_PRICE'
	};
	
	var loadAnnualAvailability = exports.loadAnnualAvailability = function loadAnnualAvailability(params) {
	  var defaultParams = {
	    url: 'MANDATORY-TO-BE-OVERRIDEN',
	    state: '',
	    flex: '',
	    geoip: _LHX2.default.isEnabled('isGeolocationEnabled') ? 1 : '',
	    groupPricing: 0
	  };
	
	  var mergedParams = (0, _assign2.default)(defaultParams, params);
	
	  if (!mergedParams.state) {
	    mergedParams.state = '';
	  }
	
	  var isHotelOnly = params.view === 'HO';
	
	  var types = isHotelOnly ? [TYPES.ANNUAL_AVAILABILITY_HO_REQUEST, TYPES.ANNUAL_AVAILABILITY_HO_SUCCESS, TYPES.ANNUAL_AVAILABILITY_HO_FAILURE] : [TYPES.ANNUAL_AVAILABILITY_REQUEST, TYPES.ANNUAL_AVAILABILITY_SUCCESS, TYPES.ANNUAL_AVAILABILITY_FAILURE];
	
	  return (0, _defineProperty3.default)({}, _api.CALL_API, {
	    types: types,
	    schema: _api.Schemas.ANNUAL_AVAILABILITY,
	    endpoint: '/api/annual-availability.json?' + (0, _utils.serialize)(mergedParams)
	  });
	};
	
	var startLoading = exports.startLoading = function startLoading() {
	  return {
	    type: TYPES.SET_LOADING_STATUS
	  };
	};
	
	var changeNumberOfNights = exports.changeNumberOfNights = function changeNumberOfNights(addDimId, removeDimId) {
	  return {
	    type: TYPES.CHANGE_NUMBER_OF_NIGHTS,
	    addDimId: addDimId,
	    removeDimId: removeDimId
	  };
	};
	
	var changeDimEntKeyVal = exports.changeDimEntKeyVal = function changeDimEntKeyVal(dimId, key, value) {
	  return {
	    type: TYPES.SET_DIMENSION_PROPERTY,
	    dimId: dimId,
	    key: key,
	    value: value
	  };
	};
	
	var changeCalDateValue = exports.changeCalDateValue = function changeCalDateValue(calDate) {
	  return {
	    type: TYPES.CHANGE_CALDATE_VALUE,
	    calDate: calDate
	  };
	};
	
	var setAnnualAvailability = exports.setAnnualAvailability = function setAnnualAvailability(annualAvailability, view) {
	  return {
	    type: view === 'HO' ? TYPES.ANNUAL_AVAILABILITY_HO_SUCCESS : TYPES.ANNUAL_AVAILABILITY_SUCCESS,
	    response: annualAvailability
	  };
	};
	
	var updatePrice = exports.updatePrice = function updatePrice(availabilityType, calDate, newPrice) {
	  return {
	    type: TYPES.UPDATE_PRICE,
	    availabilityType: availabilityType,
	    calDate: calDate,
	    newPrice: newPrice
	  };
	};

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateParty = exports.setRoomsValidity = exports.changeNumberOfChildren = exports.changeChildAge = exports.changeNumberOfAdults = exports.updateCalDate = exports.changeFieldKey = exports.deleteFieldKey = exports.changeNightFlex = exports.loadBaseState = exports.TYPES = undefined;
	
	var _promise = __webpack_require__(217);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(32);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _utils = __webpack_require__(8);
	
	var _api = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPES = exports.TYPES = {
	  DELETE_BASESTATE_FIELD_KEY: 'DELETE_BASESTATE_FIELD_KEY',
	  CHANGE_BASESTATE_FIELD_KEY: 'CHANGE_BASESTATE_FIELD_KEY',
	  BASE_STATE_REQUEST: 'BASE_STATE_REQUEST',
	  BASE_STATE_SUCCESS: 'BASE_STATE_SUCCESS',
	  BASE_STATE_FAILURE: 'BASE_STATE_FAILURE',
	  CHANGE_NUMBER_OF_ADULTS: 'CHANGE_NUMBER_OF_ADULTS',
	  CHANGE_NUMBER_OF_CHILDREN: 'CHANGE_NUMBER_OF_CHILDREN',
	  CHANGE_CHILD_AGE: 'CHANGE_CHILD_AGE',
	  CHANGE_NIGHT_FLEX: 'CHANGE_NIGHT_FLEX',
	  SET_ROOMS_VALIDITY: 'SET_ROOMS_VALIDITY',
	  UPDATE_PARTY: 'UPDATE_PARTY',
	  UPDATE_CAL_DATE: 'UPDATE_CAL_DATE'
	};
	
	var loadBaseState = exports.loadBaseState = function loadBaseState(params) {
	  var requestObject = (0, _assign2.default)({
	    url: '/holidays/'
	  }, params);
	
	  delete requestObject.type;
	  delete requestObject.currentStateEncoded;
	
	  if (!requestObject.state) delete requestObject.state;
	
	  return (0, _defineProperty3.default)({}, _api.CALL_API, {
	    types: [TYPES.BASE_STATE_REQUEST, TYPES.BASE_STATE_SUCCESS, TYPES.BASE_STATE_FAILURE],
	    schema: _api.Schemas.BASE_STATE,
	    endpoint: '/bridge/baseState?' + (0, _utils.serialize)(requestObject)
	  });
	};
	
	var changeNightFlex = exports.changeNightFlex = function changeNightFlex(value) {
	  return {
	    type: TYPES.CHANGE_NIGHT_FLEX,
	    value: value
	  };
	};
	
	var deleteFieldKey = exports.deleteFieldKey = function deleteFieldKey(field, id) {
	  return {
	    type: TYPES.DELETE_BASESTATE_FIELD_KEY,
	    field: field,
	    id: id
	  };
	};
	
	var changeFieldKey = exports.changeFieldKey = function changeFieldKey(field, id, addition) {
	  return {
	    type: TYPES.CHANGE_BASESTATE_FIELD_KEY,
	    field: field,
	    id: id,
	    addition: addition
	  };
	};
	
	var updateCalDate = exports.updateCalDate = function updateCalDate(calDate) {
	  return {
	    type: TYPES.UPDATE_CAL_DATE,
	    calDate: calDate
	  };
	};
	
	var changeNumberOfAdults = exports.changeNumberOfAdults = function changeNumberOfAdults(roomNum, numAdults) {
	  return {
	    type: TYPES.CHANGE_NUMBER_OF_ADULTS,
	    roomNum: roomNum,
	    numAdults: numAdults
	  };
	};
	
	var changeChildAge = exports.changeChildAge = function changeChildAge(roomNum, childNumber, age) {
	  return function (dispatch, getState) {
	    dispatch({
	      type: TYPES.CHANGE_CHILD_AGE,
	      roomNum: roomNum,
	      childNumber: childNumber,
	      age: age
	    });
	    return _promise2.default.resolve(getState());
	  };
	};
	
	var changeNumberOfChildren = exports.changeNumberOfChildren = function changeNumberOfChildren(roomNum, numChildren) {
	  return {
	    type: TYPES.CHANGE_NUMBER_OF_CHILDREN,
	    roomNum: roomNum,
	    numChildren: numChildren
	  };
	};
	
	var setRoomsValidity = exports.setRoomsValidity = function setRoomsValidity(isValid) {
	  return {
	    type: TYPES.SET_ROOMS_VALIDITY,
	    isValid: isValid
	  };
	};
	
	var updateParty = exports.updateParty = function updateParty(rooms) {
	  return function (dispatch) {
	    dispatch({
	      type: TYPES.UPDATE_PARTY,
	      rooms: rooms
	    });
	    return _promise2.default.resolve();
	  };
	};

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectHireCar = exports.clearSelectedAirlineSeats = exports.selectAirlineSeat = exports.setSendDealResult = exports.sendDeal = exports.updatePaymentPlans = exports.goToToiletPage = exports.TYPES = undefined;
	
	var _promise = __webpack_require__(217);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.loadBook = loadBook;
	exports.loadBookExtras = loadBookExtras;
	exports.postBook = postBook;
	exports.postUserInfo = postUserInfo;
	exports.setRoomOption = setRoomOption;
	exports.setTransferOption = setTransferOption;
	exports.setParkingOption = setParkingOption;
	exports.setInsuranceOption = setInsuranceOption;
	exports.setHasHealthIssues = setHasHealthIssues;
	exports.setExtrasBaggage = setExtrasBaggage;
	exports.addExtrasFlightMeal = addExtrasFlightMeal;
	exports.removeExtrasFlightMeal = removeExtrasFlightMeal;
	exports.setPassengerField = setPassengerField;
	exports.setPassengerFieldSet = setPassengerFieldSet;
	exports.validatePassengerField = validatePassengerField;
	exports.validatePassengerFieldSet = validatePassengerFieldSet;
	exports.setPaymentPlan = setPaymentPlan;
	exports.setPaymentDetails = setPaymentDetails;
	exports.setPaymentMethod = setPaymentMethod;
	exports.validatePaymentDetails = validatePaymentDetails;
	exports.validatePaymentDetailsFieldSet = validatePaymentDetailsFieldSet;
	exports.setAgentWebPriceDelta = setAgentWebPriceDelta;
	exports.changeAgentHOBookingType = changeAgentHOBookingType;
	exports.loadPostcodeLookup = loadPostcodeLookup;
	exports.setAddressFields = setAddressFields;
	exports.clearPostcodeOnlyAddressFields = clearPostcodeOnlyAddressFields;
	exports.setPromoCode = setPromoCode;
	exports.postRebookValidation = postRebookValidation;
	exports.setWaitingForServer = setWaitingForServer;
	exports.postGenerateBraintreeToken = postGenerateBraintreeToken;
	exports.acknowledgeAssistedBookingNotification = acknowledgeAssistedBookingNotification;
	
	var _dates = __webpack_require__(35);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utils = __webpack_require__(8);
	
	var _book = __webpack_require__(215);
	
	var _api = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPES = exports.TYPES = {
	  BOOK_REQUEST: 'BOOK_REQUEST',
	  BOOK_SUCCESS: 'BOOK_SUCCESS',
	  BOOK_FAILURE: 'BOOK_FAILURE',
	  BOOK_SAVE_USER_INFO_REQUEST: 'BOOK_SAVE_USER_INFO_REQUEST',
	  BOOK_SAVE_USER_INFO_SUCCESS: 'BOOK_SAVE_USER_INFO_SUCCESS',
	  BOOK_SAVE_USER_INFO_FAILURE: 'BOOK_SAVE_USER_INFO_FAILURE',
	  REBOOK_VALIDATION_REQUEST: 'REBOOK_VALIDATION_REQUEST',
	  REBOOK_VALIDATION_SUCCESS: 'REBOOK_VALIDATION_SUCCESS',
	  REBOOK_VALIDATION_FAILURE: 'REBOOK_VALIDATION_FAILURE',
	  BOOK_BRAINTREE_TOKEN_REQUEST: 'BOOK_BRAINTREE_TOKEN_REQUEST',
	  BOOK_BRAINTREE_TOKEN_SUCCESS: 'BOOK_BRAINTREE_TOKEN_SUCCESS',
	  BOOK_BRAINTREE_TOKEN_FAILURE: 'BOOK_BRAINTREE_TOKEN_FAILURE',
	  BOOK_EXTRAS_REQUEST: 'BOOK_EXTRAS_REQUEST',
	  BOOK_EXTRAS_SUCCESS: 'BOOK_EXTRAS_SUCCESS',
	  BOOK_EXTRAS_FAILURE: 'BOOK_EXTRAS_FAILURE',
	  BOOK_SET_ROOM_OPTION: 'BOOK_SET_ROOM_OPTION',
	  BOOK_SET_TRANSFER_OPTION: 'BOOK_SET_TRANSFER_OPTION',
	  BOOK_SET_INSURANCE_OPTION: 'BOOK_SET_INSURANCE_OPTION',
	  BOOK_SET_PARKING_OPTION: 'BOOK_SET_PARKING_OPTION',
	  BOOK_SET_HAS_HEALTH_ISSUES: 'BOOK_SET_HAS_HEALTH_ISSUES',
	  BOOK_SET_EXTRAS_BAGGAGE: 'BOOK_SET_EXTRAS_BAGGAGE',
	  BOOK_ADD_EXTRAS_FLIGHT_MEAL: 'BOOK_ADD_EXTRAS_FLIGHT_MEAL',
	  BOOK_REMOVE_EXTRAS_FLIGHT_MEAL: 'BOOK_REMOVE_EXTRAS_FLIGHT_MEAL',
	  BOOK_SET_PASSENGER_FIELD: 'BOOK_SET_PASSENGER_FIELD',
	  BOOK_SET_PASSENGER_FIELD_SET: 'BOOK_SET_PASSENGER_FIELD_SET',
	  BOOK_VALIDATE_PASSENGER_FIELD: 'BOOK_VALIDATE_PASSENGER_FIELD',
	  BOOK_VALIDATE_PASSENGER_FIELD_SET: 'BOOK_VALIDATE_PASSENGER_FIELD_SET',
	  BOOK_VALIDATE_PASSENGER_FORM_VALID_FLAG: 'BOOK_VALIDATE_PASSENGER_FORM_VALID_FLAG',
	  BOOK_SET_PAYMENT_PLAN: 'BOOK_SET_PAYMENT_PLAN',
	  BOOK_SET_PAYMENT_DETAILS: 'BOOK_SET_PAYMENT_DETAILS',
	  BOOK_SET_PAYMENT_METHOD: 'BOOK_SET_PAYMENT_METHOD',
	  BOOK_VALIDATE_PAYMENT_DETAILS: 'BOOK_VALIDATE_PAYMENT_DETAILS',
	  BOOK_VALIDATE_PAYMENT_DETAILS_FIELD_SET: 'BOOK_VALIDATE_PAYMENT_DETAILS_FIELD_SET',
	  BOOK_POSTCODE_LOOKUP_REQUEST: 'BOOK_POSTCODE_LOOKUP_REQUEST',
	  BOOK_POSTCODE_LOOKUP_SUCCESS: 'BOOK_POSTCODE_LOOKUP_SUCCESS',
	  BOOK_POSTCODE_LOOKUP_FAILURE: 'BOOK_POSTCODE_LOOKUP_FAILURE',
	  BOOK_SET_AGENT_WEB_PRICE_DELTA: 'BOOK_SET_AGENT_WEB_PRICE_DELTA',
	  BOOK_CHANGE_AGENT_HO_BOOKING_TYPE: 'BOOK_CHANGE_AGENT_HO_BOOKING_TYPE',
	  BOOK_SET_ADDRESS_FIELDS: 'BOOK_SET_ADDRESS_FIELDS',
	  BOOK_CLEAR_POSTCODE_ONLY_ADDRESS_FIELDS: 'BOOK_CLEAR_POSTCODE_ONLY_ADDRESS_FIELDS',
	  BOOK_SET_PROMOCODE: 'BOOK_SET_PROMOCODE',
	  BOOK_SET_WAITING_FOR_SERVER: 'BOOK_SET_WAITING_FOR_SERVER',
	  BOOK_UPDATE_PAYMENT_PLANS: 'BOOK_UPDATE_PAYMENT_PLANS',
	  ACKNOWLEDGE_ASSISTED_BOOKING_NOTIFICATION: 'ACKNOWLEDGE_ASSISTED_BOOKING_NOTIFICATION',
	  BOOK_SEND_DEAL: 'BOOK_SEND_DEAL',
	  BOOK_SEND_DEAL_RESULT: 'BOOK_SEND_DEAL_RESULT',
	  BOOK_SELECT_AIRLINE_SEAT: 'BOOK_SELECT_AIRLINE_SEAT',
	  BOOK_CLEAR_SELECTED_AIRLINE_SEATS: 'BOOK_CLEAR_SELECTED_AIRLINE_SEATS',
	  BOOK_SELECT_HIRE_CAR: 'BOOK_SELECT_HIRE_CAR'
	};
	
	function loadBook(params) {
	  return (0, _defineProperty3.default)({}, _api.CALL_API, {
	    types: [TYPES.BOOK_REQUEST, TYPES.BOOK_SUCCESS, TYPES.BOOK_FAILURE],
	    schema: _api.Schemas.BOOK,
	    endpoint: '/book/api/?' + (0, _utils.serialize)(params)
	  });
	}
	
	function loadBookExtras(params) {
	  var blankFormData = { booking_info: {} };
	
	  return (0, _defineProperty3.default)({}, _api.CALL_API, {
	    types: [TYPES.BOOK_EXTRAS_REQUEST, TYPES.BOOK_EXTRAS_SUCCESS, TYPES.BOOK_EXTRAS_FAILURE],
	    schema: _api.Schemas.BOOK,
	    endpoint: '/book/api/?' + (0, _utils.serialize)(params),
	    requestOptions: {
	      method: 'PUT',
	      formData: blankFormData
	    }
	  });
	}
	
	function postBook(params) {
	  var formData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return (0, _defineProperty3.default)({}, _api.CALL_API, {
	    types: [TYPES.BOOK_REQUEST, TYPES.BOOK_SUCCESS, TYPES.BOOK_FAILURE],
	    schema: _api.Schemas.BOOK,
	    endpoint: '/book/api/?' + (0, _utils.serialize)(params),
	    requestOptions: {
	      method: 'POST',
	      formData: formData
	    }
	  });
	}
	
	function postUserInfo(params) {
	  var formData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return (0, _defineProperty3.default)({}, _api.CALL_API, {
	    types: [TYPES.BOOK_SAVE_USER_INFO_REQUEST, TYPES.BOOK_SAVE_USER_INFO_SUCCESS, TYPES.BOOK_SAVE_USER_INFO_FAILURE],
	    endpoint: '/book/save-user-info?' + (0, _utils.serialize)(params),
	    requestOptions: {
	      method: 'POST',
	      formData: formData
	    }
	  });
	}
	
	function setRoomOption(partyIndex, id) {
	  return {
	    type: TYPES.BOOK_SET_ROOM_OPTION,
	    partyIndex: partyIndex,
	    id: id
	  };
	}
	
	function setTransferOption(id) {
	  return {
	    type: TYPES.BOOK_SET_TRANSFER_OPTION,
	    id: id
	  };
	}
	
	function setParkingOption(id) {
	  return {
	    type: TYPES.BOOK_SET_PARKING_OPTION,
	    id: id
	  };
	}
	
	function setInsuranceOption(id) {
	  return {
	    type: TYPES.BOOK_SET_INSURANCE_OPTION,
	    id: id
	  };
	}
	
	function setHasHealthIssues(hasHealthIssues) {
	  return {
	    type: TYPES.BOOK_SET_HAS_HEALTH_ISSUES,
	    hasHealthIssues: hasHealthIssues
	  };
	}
	
	function setExtrasBaggage(list) {
	  return {
	    type: TYPES.BOOK_SET_EXTRAS_BAGGAGE,
	    list: list
	  };
	}
	
	function addExtrasFlightMeal(id) {
	  return {
	    type: TYPES.BOOK_ADD_EXTRAS_FLIGHT_MEAL,
	    id: id
	  };
	}
	
	function removeExtrasFlightMeal(id) {
	  return {
	    type: TYPES.BOOK_REMOVE_EXTRAS_FLIGHT_MEAL,
	    id: id
	  };
	}
	
	function updateFormValidFlag(dispatch, getState) {
	  var _getState = getState(),
	      featureFlags = _getState.featureFlags,
	      bookState = _getState.bookState,
	      router = _getState.router;
	
	  if (featureFlags.get('OfferSummaryCTA2') || featureFlags.get('OfferSummaryCTA3')) {
	    var isFormHotelOnly = (0, _utils.isHotelOnly)(router.location.pathname);
	
	    dispatch({
	      type: TYPES.BOOK_VALIDATE_PASSENGER_FORM_VALID_FLAG,
	      fieldSet: isFormHotelOnly ? 'passengerDetailsHO' : 'passengerDetails',
	      passengerIds: bookState.getIn(['booking_info', 'passengers']),
	      fieldKeysByPassenger: isFormHotelOnly ? (0, _book.getFieldKeysByPassengerHO)(bookState) : (0, _book.getFieldKeysByPassenger)(bookState),
	      passengers: bookState.getIn(['entities', 'passengers']),
	      leadPassengerId: bookState.getIn(['booking_info', 'leadPassengerId'], 0),
	      inboundFlightDeptDate: bookState.getIn(['data', 'flight', 'inbound', 'deptDate'])
	    });
	  }
	}
	
	function setPassengerField(_ref5) {
	  var passengerId = _ref5.passengerId,
	      fieldKey = _ref5.fieldKey,
	      value = _ref5.value;
	
	  return function (dispatch, getState) {
	    var result = dispatch({
	      type: TYPES.BOOK_SET_PASSENGER_FIELD,
	      passengerId: passengerId,
	      fieldKey: fieldKey,
	      value: value
	    });
	
	    updateFormValidFlag(dispatch, getState);
	
	    return result;
	  };
	}
	
	function setPassengerFieldSet(_ref6) {
	  var passengerId = _ref6.passengerId,
	      fieldKey = _ref6.fieldKey,
	      value = _ref6.value,
	      fieldSet = _ref6.fieldSet,
	      passengerIds = _ref6.passengerIds,
	      fieldKeysByPassenger = _ref6.fieldKeysByPassenger,
	      passengers = _ref6.passengers,
	      leadPassengerId = _ref6.leadPassengerId,
	      inboundFlightDeptDate = _ref6.inboundFlightDeptDate;
	
	  return function (dispatch, getState) {
	    var result = dispatch({
	      type: TYPES.BOOK_SET_PASSENGER_FIELD_SET,
	      passengerId: passengerId,
	      fieldKey: fieldKey,
	      value: value,
	      fieldSet: fieldSet,
	      passengerIds: passengerIds,
	      fieldKeysByPassenger: fieldKeysByPassenger,
	      passengers: passengers,
	      leadPassengerId: leadPassengerId,
	      inboundFlightDeptDate: inboundFlightDeptDate
	    });
	
	    updateFormValidFlag(dispatch, getState);
	
	    return result;
	  };
	}
	
	function sendUserInfoIfValid(dispatch, getState) {
	  var shouldSendUserDetails = !getState().bookState.get('sentUserInfo');
	
	  if (shouldSendUserDetails) {
	    var _getState2 = getState(),
	        router = _getState2.router,
	        bookValidation = _getState2.bookValidation,
	        bookState = _getState2.bookState;
	
	    var leadPassengerId = bookState.getIn(['booking_info', 'leadPassengerId'], 0);
	    var firstPassengerValidity = bookValidation.getIn(['passengers', '' + leadPassengerId], _immutable2.default.Map());
	    var firstPassenger = bookState.getIn(['entities', 'passengers', '0'], _immutable2.default.Map());
	
	    var allRequiredFieldsValid = ['firstName', 'lastName', 'email', 'telephone'].every(function (key) {
	      return firstPassengerValidity.getIn([key, 'isValid']);
	    });
	
	    if (allRequiredFieldsValid) {
	      var shortref = router.location.query.shortref;
	
	      dispatch(postUserInfo({ shortref: shortref, 'session-id': shortref }, {
	        'adult-0-first_name': firstPassenger.get('firstName'),
	        'adult-0-last_name': firstPassenger.get('lastName'),
	        email: firstPassenger.get('email'),
	        contact: firstPassenger.get('telephone')
	      }));
	    }
	  }
	}
	
	function validatePassengerField(_ref7) {
	  var passengerId = _ref7.passengerId,
	      fieldKey = _ref7.fieldKey,
	      value = _ref7.value;
	
	  return function (dispatch, getState) {
	    dispatch({
	      type: TYPES.BOOK_VALIDATE_PASSENGER_FIELD,
	      passengerId: passengerId,
	      fieldKey: fieldKey,
	      value: value
	    });
	
	    sendUserInfoIfValid(dispatch, getState);
	  };
	}
	
	function validatePassengerFieldSet(_ref8) {
	  var fieldSet = _ref8.fieldSet,
	      passengerIds = _ref8.passengerIds,
	      fieldKeysByPassenger = _ref8.fieldKeysByPassenger,
	      passengers = _ref8.passengers,
	      leadPassengerId = _ref8.leadPassengerId,
	      inboundFlightDeptDate = _ref8.inboundFlightDeptDate;
	
	  return function (dispatch, getState) {
	    dispatch({
	      type: TYPES.BOOK_VALIDATE_PASSENGER_FIELD_SET,
	      fieldSet: fieldSet,
	      passengerIds: passengerIds,
	      fieldKeysByPassenger: fieldKeysByPassenger,
	      passengers: passengers,
	      leadPassengerId: leadPassengerId,
	      inboundFlightDeptDate: inboundFlightDeptDate
	    });
	
	    sendUserInfoIfValid(dispatch, getState);
	
	    return _promise2.default.resolve(getState());
	  };
	}
	
	function setPaymentPlan(id) {
	  return {
	    type: TYPES.BOOK_SET_PAYMENT_PLAN,
	    id: id
	  };
	}
	
	function setPaymentDetails(_ref9) {
	  var fieldKey = _ref9.fieldKey,
	      value = _ref9.value,
	      securityCodeLength = _ref9.securityCodeLength,
	      cardNumberLengthRange = _ref9.cardNumberLengthRange;
	
	  return {
	    type: TYPES.BOOK_SET_PAYMENT_DETAILS,
	    fieldKey: fieldKey,
	    value: value,
	    securityCodeLength: securityCodeLength,
	    cardNumberLengthRange: cardNumberLengthRange
	  };
	}
	
	function setPaymentMethod(value) {
	  return {
	    type: TYPES.BOOK_SET_PAYMENT_METHOD,
	    value: value
	  };
	}
	
	function validatePaymentDetails(_ref10) {
	  var fieldKey = _ref10.fieldKey,
	      value = _ref10.value,
	      securityCodeLength = _ref10.securityCodeLength,
	      cardNumberLengthRange = _ref10.cardNumberLengthRange;
	
	  return {
	    type: TYPES.BOOK_VALIDATE_PAYMENT_DETAILS,
	    fieldKey: fieldKey,
	    value: value,
	    securityCodeLength: securityCodeLength,
	    cardNumberLengthRange: cardNumberLengthRange
	  };
	}
	
	function validatePaymentDetailsFieldSet(_ref11) {
	  var fieldSet = _ref11.fieldSet,
	      fieldKeys = _ref11.fieldKeys,
	      fieldValues = _ref11.fieldValues,
	      securityCodeLength = _ref11.securityCodeLength,
	      cardNumberLengthRange = _ref11.cardNumberLengthRange;
	
	  return function (dispatch, getState) {
	    dispatch({
	      type: TYPES.BOOK_VALIDATE_PAYMENT_DETAILS_FIELD_SET,
	      nowDate: _dates2.default.utcDate(),
	      fieldSet: fieldSet,
	      fieldKeys: fieldKeys,
	      fieldValues: fieldValues,
	      securityCodeLength: securityCodeLength,
	      cardNumberLengthRange: cardNumberLengthRange
	    });
	
	    return _promise2.default.resolve(getState());
	  };
	}
	
	function setAgentWebPriceDelta(agentWebPriceDelta) {
	  return {
	    type: TYPES.BOOK_SET_AGENT_WEB_PRICE_DELTA,
	    agentWebPriceDelta: agentWebPriceDelta
	  };
	}
	
	function changeAgentHOBookingType(value) {
	  return {
	    type: TYPES.BOOK_CHANGE_AGENT_HO_BOOKING_TYPE,
	    value: value
	  };
	}
	
	function loadPostcodeLookup(params) {
	  return (0, _defineProperty3.default)({}, _api.CALL_API, {
	    types: [TYPES.BOOK_POSTCODE_LOOKUP_REQUEST, TYPES.BOOK_POSTCODE_LOOKUP_SUCCESS, TYPES.BOOK_POSTCODE_LOOKUP_FAILURE],
	    endpoint: '/ajax/lookup/?' + (0, _utils.serialize)(params)
	  });
	}
	
	function setAddressFields(_ref13) {
	  var passengerId = _ref13.passengerId,
	      address1 = _ref13.address1,
	      address2 = _ref13.address2,
	      city = _ref13.city,
	      county = _ref13.county;
	
	  return {
	    type: TYPES.BOOK_SET_ADDRESS_FIELDS,
	    passengerId: passengerId,
	    address1: address1,
	    address2: address2,
	    city: city,
	    county: county
	  };
	}
	
	function clearPostcodeOnlyAddressFields(_ref14) {
	  var passengerId = _ref14.passengerId;
	
	  return {
	    type: TYPES.BOOK_CLEAR_POSTCODE_ONLY_ADDRESS_FIELDS,
	    passengerId: passengerId
	  };
	}
	
	function setPromoCode(value) {
	  return {
	    type: TYPES.BOOK_SET_PROMOCODE,
	    value: value
	  };
	}
	
	function postRebookValidation(params) {
	  var formData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return (0, _defineProperty3.default)({}, _api.CALL_API, {
	    types: [TYPES.REBOOK_VALIDATION_REQUEST, TYPES.REBOOK_VALIDATION_SUCCESS, TYPES.REBOOK_VALIDATION_FAILURE],
	    endpoint: '/book/rebooking-validation.json?' + (0, _utils.serialize)(params),
	    requestOptions: {
	      method: 'POST',
	      formData: formData
	    }
	  });
	}
	
	function setWaitingForServer(isWaiting) {
	  return {
	    type: TYPES.BOOK_SET_WAITING_FOR_SERVER,
	    isWaiting: isWaiting
	  };
	}
	
	function postGenerateBraintreeToken() {
	  return (0, _defineProperty3.default)({}, _api.CALL_API, {
	    types: [TYPES.BOOK_BRAINTREE_TOKEN_REQUEST, TYPES.BOOK_BRAINTREE_TOKEN_SUCCESS, TYPES.BOOK_BRAINTREE_TOKEN_FAILURE],
	    endpoint: '/book/api/braintree/generate-token',
	    requestOptions: {
	      method: 'POST',
	      formData: {}
	    }
	  });
	}
	
	var goToToiletPage = exports.goToToiletPage = function goToToiletPage(shortRef) {
	  var channel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	  return function () {
	    var channelParameter = channel ? '&channel=' + channel : '';
	    var pathname = '/book/call-center.html?shortref=' + shortRef + channelParameter;
	
	    (0, _utils.updateWindowLocation)(pathname);
	  };
	};
	
	var updatePaymentPlans = exports.updatePaymentPlans = function updatePaymentPlans(bookResponse) {
	  return {
	    type: TYPES.BOOK_UPDATE_PAYMENT_PLANS,
	    bookResponse: bookResponse
	  };
	};
	
	function acknowledgeAssistedBookingNotification() {
	  return {
	    type: TYPES.ACKNOWLEDGE_ASSISTED_BOOKING_NOTIFICATION
	  };
	}
	
	var sendDeal = exports.sendDeal = function sendDeal() {
	  return {
	    type: TYPES.BOOK_SEND_DEAL
	  };
	};
	
	var setSendDealResult = exports.setSendDealResult = function setSendDealResult(result) {
	  return {
	    type: TYPES.BOOK_SEND_DEAL_RESULT,
	    result: result
	  };
	};
	
	var selectAirlineSeat = exports.selectAirlineSeat = function selectAirlineSeat(direction, passengerId, row, seat) {
	  return {
	    type: TYPES.BOOK_SELECT_AIRLINE_SEAT,
	    direction: direction,
	    passengerId: passengerId,
	    row: row,
	    seat: seat
	  };
	};
	
	var clearSelectedAirlineSeats = exports.clearSelectedAirlineSeats = function clearSelectedAirlineSeats(direction) {
	  return {
	    type: TYPES.BOOK_CLEAR_SELECTED_AIRLINE_SEATS,
	    direction: direction
	  };
	};
	
	var selectHireCar = exports.selectHireCar = function selectHireCar(hireCarId) {
	  var extraIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  return {
	    type: TYPES.BOOK_SELECT_HIRE_CAR,
	    hireCarId: hireCarId,
	    extraIds: extraIds,
	    closeModal: true
	  };
	};

/***/ },
/* 144 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TYPES = exports.TYPES = {
	  SHOW_POPOVER: 'SHOW_POPOVER',
	  HIDE_POPOVER: 'HIDE_POPOVER',
	  TOGGLE_POPOVER: 'TOGGLE_POPOVER'
	};
	
	var showPopover = exports.showPopover = function showPopover(data, content) {
	  return {
	    type: TYPES.SHOW_POPOVER,
	    data: data,
	    content: content
	  };
	};
	var togglePopover = exports.togglePopover = function togglePopover(data, content) {
	  return {
	    type: TYPES.TOGGLE_POPOVER,
	    data: data,
	    content: content
	  };
	};
	var hidePopover = exports.hidePopover = function hidePopover() {
	  return { type: TYPES.HIDE_POPOVER };
	};

/***/ },
/* 145 */
58,
/* 146 */
152,
/* 147 */
106,
/* 148 */
[1416, 220],
/* 149 */
[1431, 649, 334],
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(197);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 155 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var formatName = function formatName(_ref, name) {
	  var sectionPrefix = _ref._reduxForm.sectionPrefix;
	  return sectionPrefix ? sectionPrefix + '.' + name : name;
	};
	exports.default = formatName;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	__webpack_require__(922);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Loading = function (_Component) {
	  (0, _inherits3.default)(Loading, _Component);
	
	  function Loading() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Loading);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Loading.__proto__ || (0, _getPrototypeOf2.default)(Loading)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Loading, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isSmall = _props.isSmall,
	          loadingState = _props.loadingState,
	          position = _props.position,
	          height = _props.height;
	
	      var spinner = _react2.default.createElement(
	        'div',
	        { className: 'loading ' + (isSmall ? 'loading--small' : '') },
	        loadingState === 'spinning' && _react2.default.createElement('div', { className: 'loading__inner loading__inner--is-position-' + position })
	      );
	      return height ? _react2.default.createElement(
	        'div',
	        { className: 'loadingContainer', style: { height: height + 'px' } },
	        spinner
	      ) : spinner;
	    }
	  }]);
	  return Loading;
	}(_react.Component); /* eslint-disable key-spacing, no-multi-spaces */
	
	
	exports.default = Loading;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SlideInFromTheSideModal = exports.SLIDE_DIRECTION_LEFT = exports.SLIDE_DIRECTION_RIGHT = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTimeout = __webpack_require__(465);
	
	var _reactTimeout2 = _interopRequireDefault(_reactTimeout);
	
	__webpack_require__(924);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SLIDE_DIRECTION_RIGHT = exports.SLIDE_DIRECTION_RIGHT = 'right';
	var SLIDE_DIRECTION_LEFT = exports.SLIDE_DIRECTION_LEFT = 'left';
	
	var SlideInFromTheSideModal = exports.SlideInFromTheSideModal = function (_PureComponent) {
	  (0, _inherits3.default)(SlideInFromTheSideModal, _PureComponent);
	
	  function SlideInFromTheSideModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SlideInFromTheSideModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SlideInFromTheSideModal.__proto__ || (0, _getPrototypeOf2.default)(SlideInFromTheSideModal)).call.apply(_ref, [this].concat(args))), _this), _this.modalClose = function (event) {
	      event.preventDefault();
	      _this.props.onModalClose(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SlideInFromTheSideModal, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          modalConfig = _props.modalConfig;
	      var hideCloseButton = modalConfig.hideCloseButton,
	          slideInFromTheSide = modalConfig.slideInFromTheSide;
	      var isClosing = modalConfig.isClosing;
	
	
	      var slideDirectionModifier = slideInFromTheSide === SLIDE_DIRECTION_LEFT ? '--slide-left' : '--slide-right';
	      var style = {
	        width: modalConfig.width || 600
	      };
	
	      return _react2.default.createElement(
	        'section',
	        { style: style, className: 'slide-in-from-the-side-modal slide-in-from-the-side-modal' + slideDirectionModifier + ' ' + (isClosing ? 'slide-in-from-the-side-modal--closing' : '') },
	        _react2.default.createElement('div', { onClick: hideCloseButton ? '' : this.modalClose, className: 'slide-in-from-the-side-modal__screen' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'slide-in-from-the-side-modal__content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'slide-in-from-the-side-modal__header', onClick: this.modalClose },
	            modalConfig.title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slide-in-from-the-side-modal__content__inner' },
	            children
	          )
	        )
	      );
	    }
	  }]);
	  return SlideInFromTheSideModal;
	}(_react.PureComponent);
	
	SlideInFromTheSideModal.defaultProps = {
	  isMobileBreakpoint: false,
	  modalConfig: {}
	};
	exports.default = (0, _reactTimeout2.default)(SlideInFromTheSideModal);

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _Loading = __webpack_require__(164);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	__webpack_require__(927);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Overlay = function (_Component) {
	  (0, _inherits3.default)(Overlay, _Component);
	
	  function Overlay() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Overlay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Overlay.__proto__ || (0, _getPrototypeOf2.default)(Overlay)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Overlay, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'overlay' },
	        _react2.default.createElement('div', { className: 'overlay__inner' }),
	        _react2.default.createElement(_Loading2.default, { position: this.props.loaderPosition, loadingState: this.props.loadingState })
	      );
	    }
	  }]);
	  return Overlay;
	}(_react.Component);
	
	exports.default = Overlay;

/***/ },
/* 167 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PRICE_MATCH = exports.PRICE_MATCH = 'PRICE_MATCH';
	var ATOL = exports.ATOL = 'ATOL';
	var ABTA = exports.ABTA = 'ABTA';
	var WHAT_IS_THIS_PRICE = exports.WHAT_IS_THIS_PRICE = 'WHAT_IS_THIS_PRICE';
	var ZERO_PERCENT = exports.ZERO_PERCENT = 'ZERO_PERCENT';
	var DEPOSIT_FROM = exports.DEPOSIT_FROM = 'DEPOSIT_FROM';
	var PHONE_OPENING_TIME = exports.PHONE_OPENING_TIME = 'PHONE_OPENING_TIME';
	var TERMS_CONDITIONS_AGENCY = exports.TERMS_CONDITIONS_AGENCY = 'TERMS_CONDITIONS_AGENCY';
	var TERMS_CONDITIONS_SUPPLIER = exports.TERMS_CONDITIONS_SUPPLIER = 'TERMS_CONDITIONS_SUPPLIER';
	var FACILITIES_LIST = exports.FACILITIES_LIST = 'FACILITIES_LIST';
	var FACILITIES_OVERVIEW = exports.FACILITIES_OVERVIEW = 'FACILITIES_OVERVIEW';
	var FACILITIES_OVERVIEW_GALLERY = exports.FACILITIES_OVERVIEW_GALLERY = 'FACILITIES_OVERVIEW_GALLERY';
	var PRICE_TRACKER = exports.PRICE_TRACKER = 'PRICE_TRACKER';
	var HAND_LUGGAGE = exports.HAND_LUGGAGE = 'HAND_LUGGAGE';
	var TRANSFER_REMINDER = exports.TRANSFER_REMINDER = 'TRANSFER_REMINDER';
	var ASSISTED_BOOKING_STATUS = exports.ASSISTED_BOOKING_STATUS = 'ASSISTED_BOOKING_STATUS';
	var FREE_HOTEL_AMENDS = exports.FREE_HOTEL_AMENDS = 'FREE_HOTEL_AMENDS';
	var CHECK_DUPLICATE_NAMES = exports.CHECK_DUPLICATE_NAMES = 'CHECK_DUPLICATE_NAMES';
	var EMAIL_DEAL = exports.EMAIL_DEAL = 'EMAIL_DEAL';
	var AIRLINE_PASSENGER_LIST = exports.AIRLINE_PASSENGER_LIST = 'AIRLINE_PASSENGER_LIST';
	var AIRLINE_SEAT_LIST = exports.AIRLINE_SEAT_LIST = 'AIRLINE_SEAT_LIST';
	var ROOM_OPTIONS = exports.ROOM_OPTIONS = 'ROOM_OPTIONS';
	var CAR_HIRE_OPTIONS = exports.CAR_HIRE_OPTIONS = 'CAR_HIRE_OPTIONS';
	var CAR_TERMS_AND_CONDITIONS = exports.CAR_TERMS_AND_CONDITIONS = 'CAR_TERMS_AND_CONDITIONS';

/***/ },
/* 168 */
36,
/* 169 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 170 */
[1407, 80, 96, 38],
/* 171 */
110,
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(654);
	var global = __webpack_require__(41);
	var hide = __webpack_require__(97);
	var Iterators = __webpack_require__(123);
	var TO_STRING_TAG = __webpack_require__(38)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1049),
	    listCacheDelete = __webpack_require__(1050),
	    listCacheGet = __webpack_require__(1051),
	    listCacheHas = __webpack_require__(1052),
	    listCacheSet = __webpack_require__(1053);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 190 */,
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(155);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(405);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1047);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(114);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(276),
	    isLength = __webpack_require__(277);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 196 */,
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(130),
	    isObjectLike = __webpack_require__(115);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _svgInlineReact = __webpack_require__(64);
	
	var _svgInlineReact2 = _interopRequireDefault(_svgInlineReact);
	
	var _utils = __webpack_require__(8);
	
	var _AdultChild = __webpack_require__(1343);
	
	var _AdultChild2 = _interopRequireDefault(_AdultChild);
	
	var _Infant = __webpack_require__(1346);
	
	var _Infant2 = _interopRequireDefault(_Infant);
	
	var _EmptySeatHover = __webpack_require__(1345);
	
	var _EmptySeatHover2 = _interopRequireDefault(_EmptySeatHover);
	
	__webpack_require__(876);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PassengerSeat = function (_PureComponent) {
	  (0, _inherits3.default)(PassengerSeat, _PureComponent);
	
	  function PassengerSeat() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PassengerSeat);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PassengerSeat.__proto__ || (0, _getPrototypeOf2.default)(PassengerSeat)).call.apply(_ref, [this].concat(args))), _this), _this.COUNTER_X_COORD_FOR_ADULT_ICON = 50, _this.COUNTER_X_COORD_FOR_INFANT_ICON = 45, _this.COUNTER_Y_COORD_FOR_ALL_ICONS = 71, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PassengerSeat, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          paxType = _props.paxType,
	          counter = _props.counter,
	          hover = _props.hover;
	
	      var iconSrc = void 0;
	
	      if (hover) {
	        iconSrc = _EmptySeatHover2.default;
	      } else {
	        iconSrc = paxType === 'adultWithInfant' ? _Infant2.default : _AdultChild2.default;
	      }
	
	      var modifier = (0, _utils.camelCaseToHyphenCase)(paxType);
	      var counterX = paxType === 'adultWithInfant' ? this.COUNTER_X_COORD_FOR_INFANT_ICON : this.COUNTER_X_COORD_FOR_ADULT_ICON;
	      var counterY = this.COUNTER_Y_COORD_FOR_ALL_ICONS;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'passenger-seat passenger-seat--' + modifier + ' ' + (hover ? 'passenger-seat--hover' : 'passenger-seat--normal') },
	        _react2.default.createElement(_svgInlineReact2.default, { className: 'passenger-seat__icon passenger-seat__icon--' + modifier, src: iconSrc }),
	        counter !== undefined && _react2.default.createElement(
	          'span',
	          { className: 'passenger-seat__counter-icon' },
	          _react2.default.createElement(
	            'svg',
	            { xmlns: 'http://www.w3.org/2000/svg', version: '1.1', id: 'Layer_1', x: '0', y: '0', width: '100', height: '100', viewBox: '0 0 100 100', enableBackground: 'new 0 0 100 100' },
	            _react2.default.createElement(
	              'text',
	              { fontSize: '22', x: counterX, y: counterY, textAnchor: 'middle' },
	              counter
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return PassengerSeat;
	}(_react.PureComponent);
	
	PassengerSeat.defaultProps = {
	  counter: undefined,
	  hover: false
	};
	exports.default = PassengerSeat;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(56);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _utils = __webpack_require__(8);
	
	var _optimizely = __webpack_require__(30);
	
	var optimizelyUtil = _interopRequireWildcard(_optimizely);
	
	__webpack_require__(892);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BookSelect = function (_Component) {
	  (0, _inherits3.default)(BookSelect, _Component);
	
	  function BookSelect() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, BookSelect);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BookSelect.__proto__ || (0, _getPrototypeOf2.default)(BookSelect)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _this.fireOptimizelyEvent = function () {
	      var data = _this.props.data;
	
	
	      if (data.optimizelyId) {
	        optimizelyUtil.fireEvent('BookSelect' + data.optimizelyId, 'clicked');
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(BookSelect, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          disabled = _props.disabled,
	          hideLabel = _props.hideLabel,
	          isRequiredField = _props.isRequiredField,
	          isSmall = _props.isSmall,
	          isValid = _props.isValid,
	          label = _props.label,
	          message = _props.message,
	          onFieldBlur = _props.onFieldBlur,
	          onFieldChange = _props.onFieldChange,
	          options = _props.options,
	          value = _props.value;
	
	
	      var dataAttributes = data ? (0, _utils.getDataAttributes)(data) : {};
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'book-select ' + (isValid === false ? 'book-select--invalid' : '') + ' ' + (isValid ? 'book-select--valid' : '') + ' ' + (isSmall ? 'book-select--small' : '') },
	        _react2.default.createElement(
	          'label',
	          { className: 'book-select__label-wrap' },
	          _react2.default.createElement(
	            'span',
	            { className: 'book-select__label ' + (hideLabel ? 'book-select__label--hide' : '') },
	            label,
	            isRequiredField ? '*' : ''
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'book-select__select-wrap' },
	            _react2.default.createElement(
	              'select',
	              (0, _extends3.default)({
	                className: 'book-select__select ' + (disabled ? 'book-select__select--disabled' : ''),
	                disabled: disabled,
	                value: value,
	                onChange: onFieldChange,
	                onBlur: onFieldBlur,
	                onFocus: this.fireOptimizelyEvent
	              }, dataAttributes),
	              options.map(function (item, index) {
	                return _react2.default.createElement(
	                  'option',
	                  { key: index, value: item.value, disabled: item.disabled },
	                  item.label
	                );
	              })
	            )
	          ),
	          isValid === false && _react2.default.createElement(
	            'span',
	            { className: 'book-select__message' },
	            message
	          )
	        )
	      );
	    }
	  }]);
	  return BookSelect;
	}(_react.Component);
	
	BookSelect.defaultProps = {
	  data: {},
	  isRequiredField: false,
	  disabled: false
	};
	exports.default = BookSelect;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(32);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(56);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(78);
	
	var _utils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinkSubPage = function (_PureComponent) {
	  (0, _inherits3.default)(LinkSubPage, _PureComponent);
	
	  function LinkSubPage() {
	    (0, _classCallCheck3.default)(this, LinkSubPage);
	    return (0, _possibleConstructorReturn3.default)(this, (LinkSubPage.__proto__ || (0, _getPrototypeOf2.default)(LinkSubPage)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LinkSubPage, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        (0, _extends3.default)({ to: this.url, rel: 'nofollow' }, this.extraProps),
	        this.props.children
	      );
	    }
	  }, {
	    key: 'url',
	    get: function get() {
	      var _props = this.props,
	          to = _props.to,
	          location = _props.location;
	
	      return to === '#' ? to : (0, _utils.getSubPageURL)(to, location);
	    }
	  }, {
	    key: 'extraProps',
	    get: function get() {
	      var extraProps = (0, _assign2.default)({}, this.props);
	      delete extraProps.to;
	      delete extraProps.location;
	      delete extraProps.children;
	      return extraProps;
	    }
	  }]);
	  return LinkSubPage;
	}(_react.PureComponent);
	
	exports.default = LinkSubPage;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	__webpack_require__(944);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tag = function (_Component) {
	  (0, _inherits3.default)(Tag, _Component);
	
	  function Tag() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tag);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tag.__proto__ || (0, _getPrototypeOf2.default)(Tag)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _this.handleClick = function (event) {
	      var _this$props = _this.props,
	          onTagClick = _this$props.onTagClick,
	          onRemove = _this$props.onRemove,
	          id = _this$props.id;
	
	      event.preventDefault();
	
	      if (onTagClick) {
	        onTagClick(event);
	      } else {
	        onRemove(id);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tag, [{
	    key: 'render',
	    value: function render() {
	      var isFullWidth = this.props.isFullWidth;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'tag ' + (isFullWidth && 'tag--full-width') },
	        _react2.default.createElement(
	          'a',
	          { href: '#', onClick: this.handleClick, className: 'tag__link' },
	          _react2.default.createElement(
	            'span',
	            { className: 'tag__label ' + (isFullWidth && 'tag__label--full-width') },
	            this.props.children
	          ),
	          _react2.default.createElement(
	            'i',
	            { className: 'icon-close ' + (isFullWidth && 'icon-close--full-width') },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Close'
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Tag;
	}(_react.Component);
	
	Tag.defaultProps = {
	  isFullWidth: false
	};
	exports.default = Tag;

/***/ },
/* 210 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var vehicleTypes = exports.vehicleTypes = {
	  COMPACT: 'COMPACT',
	  ECONOMY: 'ECONOMY',
	  MINI: 'MINI',
	  STANDARD: 'STANDARD',
	  INTERMEDIATE: 'INTERMEDIATE',
	  INTERMEDIATE_ELITE: 'INTERMEDIATE_ELITE',
	  FULL_SIZE: 'FULL_SIZE',
	  LUXURY: 'LUXURY', // not verified
	  PREMIUM: 'PREMIUM',
	  SUV: 'SUV' // not verified
	};
	
	var fuelPolicies = exports.fuelPolicies = {
	  FULL_TO_FULL: 'FULL_TO_FULL',
	  FULL_TO_EMPTY: 'FULL_TO_EMPTY'
	};
	
	var transmissionTypes = exports.transmissionTypes = {
	  AUTOMATIC: 'AUTOMATIC',
	  MANUAL: 'MANUAL' // not verified
	};
	
	var vehicleTypeGroups = exports.vehicleTypeGroups = [[vehicleTypes.ECONOMY, vehicleTypes.COMPACT, vehicleTypes.MINI], [vehicleTypes.STANDARD, vehicleTypes.INTERMEDIATE, vehicleTypes.INTERMEDIATE_ELITE], [vehicleTypes.FULL_SIZE, vehicleTypes.LUXURY, vehicleTypes.PREMIUM, vehicleTypes.SUV]];

/***/ },
/* 211 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// eslint-disable-next-line import/prefer-default-export
	var flightSeatAttributes = exports.flightSeatAttributes = {
	  INFANTS_ALLOWED: 'INFANTS_ALLOWED',
	  CHILDREN_ALLOWED: 'CHILDREN_ALLOWED',
	  HANDICAP_ACCESS: 'HANDICAP_ACCESS',
	  AISLE: 'AISLE',
	  ABSENT_SEAT: 'ABSENT_SEAT',
	  EXIT_ROW: 'EXIT_ROW'
	};
	
	var nonSeatAttributes = exports.nonSeatAttributes = [flightSeatAttributes.AISLE, flightSeatAttributes.ABSENT_SEAT];

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadDimensions = exports.TYPES = undefined;
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(32);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _utils = __webpack_require__(8);
	
	var _api = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPES = exports.TYPES = {
	  DIMENSIONS_RESULTS_REQUEST: 'DIMENSIONS_RESULTS_REQUEST',
	  DIMENSIONS_RESULTS_SUCCESS: 'DIMENSIONS_RESULTS_SUCCESS',
	  DIMENSIONS_RESULTS_FAILURE: 'DIMENSIONS_RESULTS_FAILURE'
	};
	
	var loadDimensions = exports.loadDimensions = function loadDimensions(params) {
	  var defaultParams = {
	    dimensions: 'NEED_TO_OVERWRITE_THIS',
	    state: 'NEED_TO_OVERWRITE_THIS'
	  };
	  return (0, _defineProperty3.default)({}, _api.CALL_API, {
	    types: [TYPES.DIMENSIONS_RESULTS_REQUEST, TYPES.DIMENSIONS_RESULTS_SUCCESS, TYPES.DIMENSIONS_RESULTS_FAILURE],
	    schema: _api.Schemas.DIMENSIONS,
	    endpoint: '/bridge/dimensions?' + (0, _utils.serialize)((0, _assign2.default)(defaultParams, params))
	  });
	};

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetHotelDetails = exports.loadHotelDetails = exports.setLoadingState = exports.setHotelDetails = exports.TYPES = undefined;
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(32);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _utils = __webpack_require__(8);
	
	var _api = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPES = exports.TYPES = {
	  HOTEL_DETAILS_REQUEST: 'HOTEL_DETAILS_REQUEST',
	  HOTEL_DETAILS_SUCCESS: 'HOTEL_DETAILS_SUCCESS',
	  HOTEL_DETAILS_FAILURE: 'HOTEL_DETAILS_FAILURE',
	  HOTEL_DETAILS_SET_LOADING_STATE: 'HOTEL_DETAILS_SET_LOADING_STATE',
	  RESORT_GUIDE_REQUEST: 'RESORT_GUIDE_REQUEST',
	  RESORT_GUIDE_SUCCESS: 'RESORT_GUIDE_SUCCESS',
	  RESORT_GUIDE_FAILURE: 'RESORT_GUIDE_FAILURE',
	  ROOM_OPTIONS_SUCCESS: 'ROOM_OPTIONS_SUCCESS',
	  RESET_HOTEL_DETAILS: 'RESET_HOTEL_DETAILS'
	};
	
	var setHotelDetails = exports.setHotelDetails = function setHotelDetails(data) {
	  return {
	    type: TYPES.HOTEL_DETAILS_SUCCESS,
	    response: data
	  };
	};
	
	var setLoadingState = exports.setLoadingState = function setLoadingState(data) {
	  return {
	    type: TYPES.HOTEL_DETAILS_SET_LOADING_STATE,
	    data: data
	  };
	};
	
	var loadHotelDetails = exports.loadHotelDetails = function loadHotelDetails(config) {
	  return function (dispatch, getState) {
	    var pageStart = getState().baseState ? getState().baseState.get('pageStart', 0) : 0;
	    var defaultParams = {
	      results: 1,
	      url: '',
	      pageStart: pageStart
	    };
	
	    var params = (0, _assign2.default)(defaultParams, config);
	
	    if (!params.state) {
	      params.state = '';
	    }
	
	    return dispatch((0, _defineProperty3.default)({}, _api.CALL_API, {
	      types: [TYPES.HOTEL_DETAILS_REQUEST, TYPES.HOTEL_DETAILS_SUCCESS, TYPES.HOTEL_DETAILS_FAILURE],
	      schema: _api.Schemas.HOTEL_DETAILS,
	      endpoint: '/bridge/?' + (0, _utils.serialize)(params)
	    }));
	  };
	};
	
	var resetHotelDetails = exports.resetHotelDetails = function resetHotelDetails() {
	  return {
	    type: TYPES.RESET_HOTEL_DETAILS
	  };
	};

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchSearchTopper = exports.updateSearchResults = exports.paginateSearchResults = exports.initSearchResults = exports.loadSearchResults = exports.TYPES = undefined;
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(32);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(79);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _utils = __webpack_require__(8);
	
	var _api = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPES = exports.TYPES = {
	  SEARCH_RESULTS_REQUEST: 'SEARCH_RESULTS_REQUEST',
	  SEARCH_RESULTS_SUCCESS: 'SEARCH_RESULTS_SUCCESS',
	  SEARCH_RESULTS_FAILURE: 'SEARCH_RESULTS_FAILURE',
	  SEARCH_TOPPER_REQUEST: 'SEARCH_TOPPER_REQUEST',
	  SEARCH_TOPPER_SUCCESS: 'SEARCH_TOPPER_SUCCESS',
	  SEARCH_TOPPER_FAILURE: 'SEARCH_TOPPER_FAILURE',
	  SEARCH_RESULTS_INIT: 'SEARCH_RESULTS_INIT',
	  SEARCH_RESULTS_PAGINATE: 'SEARCH_RESULTS_PAGINATE',
	  SEARCH_RESULTS_UPDATE: 'SEARCH_RESULTS_UPDATE'
	};
	
	var loadSearchResults = exports.loadSearchResults = function loadSearchResults(params) {
	  var defaultParams = {
	    page: 1,
	    state: '',
	    url: '/holidays/',
	    pageStart: 0,
	    results: 10,
	    noNav: 1
	  };
	
	  return (0, _defineProperty3.default)({}, _api.CALL_API, {
	    types: [TYPES.SEARCH_RESULTS_REQUEST, TYPES.SEARCH_RESULTS_SUCCESS, TYPES.SEARCH_RESULTS_FAILURE],
	    schema: _api.Schemas.SEARCH_RESULTS,
	    endpoint: '/bridge/?' + (0, _utils.serialize)((0, _assign2.default)(defaultParams, params))
	  });
	};
	
	var initSearchResults = exports.initSearchResults = function initSearchResults(items) {
	  return (0, _assign2.default)({ type: TYPES.SEARCH_RESULTS_INIT }, items);
	};
	
	var paginateSearchResults = exports.paginateSearchResults = function paginateSearchResults(pageStart) {
	  return {
	    type: TYPES.SEARCH_RESULTS_PAGINATE,
	    pageStart: pageStart,
	    page: pageStart / _global2.default.paginationDefaults.optionsCount + 1
	  };
	};
	
	var updateSearchResults = exports.updateSearchResults = function updateSearchResults(location) {
	  return {
	    type: TYPES.SEARCH_RESULTS_UPDATE,
	    location: location
	  };
	};
	
	var fetchSearchTopper = exports.fetchSearchTopper = function fetchSearchTopper(params) {
	  var defaultParams = {
	    landing: 'NEED_TO_OVERWRITE_THIS'
	  };
	
	  return (0, _defineProperty3.default)({}, _api.CALL_API, {
	    types: [TYPES.SEARCH_TOPPER_REQUEST, TYPES.SEARCH_TOPPER_SUCCESS, TYPES.SEARCH_TOPPER_FAILURE],
	    endpoint: '/api/searchTopper?' + (0, _utils.serialize)((0, _assign2.default)(defaultParams, params))
	  });
	};

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parkingTitleByType = exports.transfersTitleByType = undefined;
	
	var _toConsumableArray2 = __webpack_require__(87);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.getInsuranceLabelByType = getInsuranceLabelByType;
	exports.getInsuranceDescriptionByType = getInsuranceDescriptionByType;
	exports.formatTime = formatTime;
	exports.rangeInclusive = rangeInclusive;
	exports.isNumberOrPlusOnly = isNumberOrPlusOnly;
	exports.getCriteoSiteType = getCriteoSiteType;
	exports.initCriteo = initCriteo;
	exports.fireCriteoEvent = fireCriteoEvent;
	exports.fireCriteoEmailEvent = fireCriteoEmailEvent;
	exports.fireCriteoTransactionEvent = fireCriteoTransactionEvent;
	exports.isMinDiscount = isMinDiscount;
	exports.getFieldKeysByPassenger = getFieldKeysByPassenger;
	exports.getFieldKeysByPassengerHO = getFieldKeysByPassengerHO;
	
	var _md = __webpack_require__(1086);
	
	var _md2 = _interopRequireDefault(_md);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _LHX = __webpack_require__(67);
	
	var _LHX2 = _interopRequireDefault(_LHX);
	
	var _utils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getInsuranceLabelByType(type) {
	  return {
	    STANDARD: 'Standard',
	    PREMIER: 'Premier',
	    SINGLE_TRIP: 'Single Trip',
	    ANNUAL_MULTI_TRIP: 'Annual Trip',
	    INDIVIDUAL: 'Individual',
	    FAMILY: 'Family'
	  }[type];
	}
	
	function getInsuranceDescriptionByType(coverType, currency) {
	  var description = null;
	  if (coverType === 'STANDARD') {
	    description = 'Key benefits include ' + currency + '3,000,000 medical expenses, ' + currency + '500 cancellation, ' + currency + '200 personal possessions';
	  } else if (coverType === 'PREMIER') {
	    description = 'Key benefits include ' + currency + '10,000,000 medical expenses, ' + currency + '2,000 cancellation, ' + currency + '1,500 personal possessions';
	  }
	
	  return description;
	}
	
	function formatTime(timeStr) {
	  return timeStr.slice(0, -3);
	}
	
	function rangeInclusive(start, end) {
	  return Array.apply(undefined, (0, _toConsumableArray3.default)(Array(end + 1 - start))).map(function (value, index) {
	    return index + start;
	  });
	}
	
	function isNumberOrPlusOnly(value) {
	  return value.replace(/^[0-9+][0-9]*/, '').length === 0;
	}
	
	function getCriteoSiteType() {
	  // Approach recommended by Criteo if nothing else in place.
	  // https://support.criteo.com/hc/en-us/articles/202806931-Managing-your-different-site-types
	  var userAgent = window.navigator.userAgent;
	  var siteTypeCodes = {
	    desktop: 'd',
	    tablet: 't',
	    mobile: 'm'
	  };
	  var siteType = void 0;
	
	  if (/iPad/.test(userAgent)) {
	    siteType = 'tablet';
	  } else if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(userAgent)) {
	    siteType = 'mobile';
	  } else {
	    siteType = 'desktop';
	  }
	
	  return siteTypeCodes[siteType];
	}
	
	function initCriteo() {
	  var scriptId = 'lh-criteo-script';
	
	  if (!window.document.getElementById(scriptId)) {
	    var script = window.document.createElement('script');
	    script.type = 'text/javascript';
	    script.async = true;
	    script.id = scriptId;
	    script.src = 'https://static.criteo.net/js/ld/ld.js';
	    window.document.head.appendChild(script);
	  }
	}
	
	/* eslint-disable no-console */
	/* istanbul ignore next */
	function fireCriteoEvent(data) {
	  var isLiveEnvironment = _LHX2.default.environment === 'prod' || _LHX2.default.environment === 'staging';
	  var criteoAccount = 4498;
	
	  if (!window.criteo_q && isLiveEnvironment) {
	    initCriteo();
	  }
	
	  var eventPayload = [{ event: 'setAccount', account: criteoAccount }, { event: 'setCustomerId', id: (0, _utils.readCookie)('lvhid') }, { event: 'setSiteType', type: getCriteoSiteType() }, {
	    event: 'viewSearch',
	    checkin_date: data.outboundDeptDate,
	    checkout_date: data.inboundDeptDate,
	    nba: data.numberOfAdults,
	    nbc: data.numberOfChildren,
	    nbr: data.numberOfPassengers
	  }, {
	    event: 'viewBasket',
	    item: [{
	      id: data.masterId,
	      price: data.totalPrice,
	      quantity: 1
	    }]
	  }];
	
	  window.criteo_q = window.criteo_q || [];
	  window.criteo_q.push(eventPayload);
	  if (false) console.debug('fireCriteoEvent', eventPayload);
	}
	
	function fireCriteoEmailEvent(email) {
	  var eventPayload = { event: 'setHashedEmail', email: (0, _md2.default)(email) };
	
	  window.criteo_q = window.criteo_q || [];
	  window.criteo_q.push(eventPayload);
	  if (false) console.debug('fireCriteoEmailEvent', eventPayload);
	}
	
	function fireCriteoTransactionEvent(data) {
	  var eventPayload = {
	    event: 'trackTransaction',
	    id: data.bookingReference,
	    item: [{
	      id: data.masterId,
	      price: data.webSellingPrice && data.webSellingPrice / 100,
	      quantity: 1
	    }]
	  };
	
	  window.criteo_q = window.criteo_q || [];
	  window.criteo_q.push(eventPayload);
	  if (false) console.debug('fireCriteoTransactionEvent', eventPayload);
	}
	/* eslint-enable no-console */
	
	var transfersTitleByType = exports.transfersTitleByType = {
	  SHUTTLE: 'Shuttle Transfer',
	  EXPRESS: 'Express Transfer',
	  PRIVATE: 'Private Transfer',
	  WHEELCHAIR: 'Wheelchair Transfer'
	};
	
	var parkingTitleByType = exports.parkingTitleByType = {
	  ON_AIRPORT: 'On Airport Parking',
	  OFF_AIRPORT: 'Off Airport Parking',
	  VALET_PARKING: 'Meet and Greet Parking'
	};
	
	function isMinDiscount(discountAmount, wasPrice) {
	  var minDiscountFraction = 0.05;
	  return discountAmount > wasPrice * minDiscountFraction;
	}
	
	function getFieldKeysByPassenger(bookState) {
	  var fieldKeys = ['title', 'firstName', 'lastName', 'dateOfBirthDay', 'dateOfBirthMonth', 'dateOfBirthYear'];
	  var leadFieldKeys = fieldKeys.concat(['email', 'confirmEmail', 'telephone', 'address1', 'address2', 'city', 'county', 'postcode']);
	
	  if (bookState.getIn(['booking_info', 'selection', 'parking_selected'], 0) !== 0) {
	    leadFieldKeys = leadFieldKeys.concat(['vehicleMake', 'vehicleModel', 'vehicleRegistration', 'vehicleColour']);
	  }
	
	  var fieldKeysByPassenger = _immutable2.default.Map();
	
	  bookState.getIn(['entities', 'passengers']).forEach(function (passenger) {
	    var passengerId = passenger.get('id');
	    var isLeadPassenger = passengerId === bookState.getIn(['booking_info', 'leadPassengerId'], 0);
	    fieldKeysByPassenger = fieldKeysByPassenger.set('' + passengerId, isLeadPassenger ? leadFieldKeys : fieldKeys);
	  });
	
	  return fieldKeysByPassenger;
	}
	
	function getFieldKeysByPassengerHO(bookState) {
	  var fieldKeys = ['title', 'firstName', 'lastName'];
	  var leadFieldKeys = fieldKeys.concat(['email', 'telephone', 'address1', 'address2', 'city', 'county', 'postcode']);
	
	  var fieldKeysByPassenger = _immutable2.default.Map();
	
	  bookState.getIn(['entities', 'passengers']).forEach(function (passenger) {
	    var passengerId = passenger.get('id');
	    var isLeadPassenger = passengerId === bookState.getIn(['booking_info', 'leadPassengerId'], 0);
	    fieldKeysByPassenger = fieldKeysByPassenger.set('' + passengerId, isLeadPassenger ? leadFieldKeys : fieldKeys);
	  });
	
	  return fieldKeysByPassenger;
	}

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(624), __esModule: true };

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(627), __esModule: true };

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(614);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(613);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 219 */
[1373, 145, 38],
/* 220 */
71,
/* 221 */
[1377, 98, 41],
/* 222 */
238,
/* 223 */
[1392, 168],
/* 224 */
[1394, 68, 643, 222, 226, 221, 329],
/* 225 */
181,
/* 226 */
[1408, 227, 171],
/* 227 */
[1409, 41],
/* 228 */
73,
/* 229 */
[1415, 228],
/* 230 */
[1417, 98],
/* 231 */
[1418, 41, 31, 169, 232, 80],
/* 232 */
[1419, 38],
/* 233 */
[1421, 219, 38, 123, 31],
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */
/***/ function(module, exports) {

	module.exports = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(114),
	    root = __webpack_require__(75);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1054),
	    mapCacheDelete = __webpack_require__(1055),
	    mapCacheGet = __webpack_require__(1056),
	    mapCacheHas = __webpack_require__(1057),
	    mapCacheSet = __webpack_require__(1058);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(189),
	    stackClear = __webpack_require__(1071),
	    stackDelete = __webpack_require__(1072),
	    stackGet = __webpack_require__(1073),
	    stackHas = __webpack_require__(1074),
	    stackSet = __webpack_require__(1075);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1005),
	    isObjectLike = __webpack_require__(115);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 269 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(76),
	    isSymbol = __webpack_require__(197);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 271 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 272 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1004),
	    isObjectLike = __webpack_require__(115);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(75),
	    stubFalse = __webpack_require__(1084);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205)(module)))

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(268);
	
	/**
	 * This method is like `_.isEqual` except that it accepts `customizer` which
	 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	 * are handled by the method instead. The `customizer` is invoked with up to
	 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * function isGreeting(value) {
	 *   return /^h(?:i|ello)$/.test(value);
	 * }
	 *
	 * function customizer(objValue, othValue) {
	 *   if (isGreeting(objValue) && isGreeting(othValue)) {
	 *     return true;
	 *   }
	 * }
	 *
	 * var array = ['hello', 'goodbye'];
	 * var other = ['hi', 'goodbye'];
	 *
	 * _.isEqualWith(array, other, customizer);
	 * // => true
	 */
	function isEqualWith(value, other, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  var result = customizer ? customizer(value, other) : undefined;
	  return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	}
	
	module.exports = isEqualWith;


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(130),
	    isObject = __webpack_require__(91);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 277 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1008),
	    baseUnary = __webpack_require__(1022),
	    nodeUtil = __webpack_require__(1063);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(398),
	    baseKeys = __webpack_require__(1010),
	    isArrayLike = __webpack_require__(195);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var prefix = exports.prefix = '@@redux-form/';
	
	var ARRAY_INSERT = exports.ARRAY_INSERT = prefix + 'ARRAY_INSERT';
	var ARRAY_MOVE = exports.ARRAY_MOVE = prefix + 'ARRAY_MOVE';
	var ARRAY_POP = exports.ARRAY_POP = prefix + 'ARRAY_POP';
	var ARRAY_PUSH = exports.ARRAY_PUSH = prefix + 'ARRAY_PUSH';
	var ARRAY_REMOVE = exports.ARRAY_REMOVE = prefix + 'ARRAY_REMOVE';
	var ARRAY_REMOVE_ALL = exports.ARRAY_REMOVE_ALL = prefix + 'ARRAY_REMOVE_ALL';
	var ARRAY_SHIFT = exports.ARRAY_SHIFT = prefix + 'ARRAY_SHIFT';
	var ARRAY_SPLICE = exports.ARRAY_SPLICE = prefix + 'ARRAY_SPLICE';
	var ARRAY_UNSHIFT = exports.ARRAY_UNSHIFT = prefix + 'ARRAY_UNSHIFT';
	var ARRAY_SWAP = exports.ARRAY_SWAP = prefix + 'ARRAY_SWAP';
	var AUTOFILL = exports.AUTOFILL = prefix + 'AUTOFILL';
	var BLUR = exports.BLUR = prefix + 'BLUR';
	var CHANGE = exports.CHANGE = prefix + 'CHANGE';
	var CLEAR_SUBMIT = exports.CLEAR_SUBMIT = prefix + 'CLEAR_SUBMIT';
	var CLEAR_SUBMIT_ERRORS = exports.CLEAR_SUBMIT_ERRORS = prefix + 'CLEAR_SUBMIT_ERRORS';
	var CLEAR_ASYNC_ERROR = exports.CLEAR_ASYNC_ERROR = prefix + 'CLEAR_ASYNC_ERROR';
	var DESTROY = exports.DESTROY = prefix + 'DESTROY';
	var FOCUS = exports.FOCUS = prefix + 'FOCUS';
	var INITIALIZE = exports.INITIALIZE = prefix + 'INITIALIZE';
	var REGISTER_FIELD = exports.REGISTER_FIELD = prefix + 'REGISTER_FIELD';
	var RESET = exports.RESET = prefix + 'RESET';
	var SET_SUBMIT_FAILED = exports.SET_SUBMIT_FAILED = prefix + 'SET_SUBMIT_FAILED';
	var SET_SUBMIT_SUCCEEDED = exports.SET_SUBMIT_SUCCEEDED = prefix + 'SET_SUBMIT_SUCCEEDED';
	var START_ASYNC_VALIDATION = exports.START_ASYNC_VALIDATION = prefix + 'START_ASYNC_VALIDATION';
	var START_SUBMIT = exports.START_SUBMIT = prefix + 'START_SUBMIT';
	var STOP_ASYNC_VALIDATION = exports.STOP_ASYNC_VALIDATION = prefix + 'STOP_ASYNC_VALIDATION';
	var STOP_SUBMIT = exports.STOP_SUBMIT = prefix + 'STOP_SUBMIT';
	var SUBMIT = exports.SUBMIT = prefix + 'SUBMIT';
	var TOUCH = exports.TOUCH = prefix + 'TOUCH';
	var UNREGISTER_FIELD = exports.UNREGISTER_FIELD = prefix + 'UNREGISTER_FIELD';
	var UNTOUCH = exports.UNTOUCH = prefix + 'UNTOUCH';
	var UPDATE_SYNC_ERRORS = exports.UPDATE_SYNC_ERRORS = prefix + 'UPDATE_SYNC_ERRORS';
	var UPDATE_SYNC_WARNINGS = exports.UPDATE_SYNC_WARNINGS = prefix + 'UPDATE_SYNC_WARNINGS';

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hasError = __webpack_require__(1287);
	
	var _hasError2 = _interopRequireDefault(_hasError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsValid = function createIsValid(structure) {
	  var getIn = structure.getIn,
	      keys = structure.keys;
	
	  var hasError = (0, _hasError2.default)(structure);
	  return function (form, getFormState) {
	    var ignoreSubmitErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      var formState = nonNullGetFormState(state);
	      var syncError = getIn(formState, form + '.syncError');
	      if (syncError) {
	        return false;
	      }
	      if (!ignoreSubmitErrors) {
	        var error = getIn(formState, form + '.error');
	        if (error) {
	          return false;
	        }
	      }
	      var syncErrors = getIn(formState, form + '.syncErrors');
	      var asyncErrors = getIn(formState, form + '.asyncErrors');
	      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + '.submitErrors');
	      if (!syncErrors && !asyncErrors && !submitErrors) {
	        return true;
	      }
	
	      var registeredFields = getIn(formState, form + '.registeredFields');
	      if (!registeredFields) {
	        return true;
	      }
	
	      return !keys(registeredFields).filter(function (name) {
	        return getIn(registeredFields, '[\'' + name + '\'].count') > 0;
	      }).some(function (name) {
	        return hasError(getIn(registeredFields, '[\'' + name + '\']'), syncErrors, asyncErrors, submitErrors);
	      });
	    };
	  };
	};
	exports.default = createIsValid;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.carHireOptionPropType = undefined;
	
	var _values = __webpack_require__(326);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _carHire = __webpack_require__(210);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var carHireOptionPropType = exports.carHireOptionPropType = _reactImmutableProptypes2.default.mapContains({
	  name: _react.PropTypes.string.isRequired,
	  imageUrl: _react.PropTypes.string.isRequired,
	  pricing: _reactImmutableProptypes2.default.mapContains({
	    webPrice: _react.PropTypes.number
	  }),
	  vehicleType: _react.PropTypes.oneOf((0, _values2.default)(_carHire.vehicleTypes)),
	  seats: _react.PropTypes.number,
	  bags: _react.PropTypes.number,
	  doors: _react.PropTypes.number,
	  airConditioning: _react.PropTypes.bool,
	  transmission: _react.PropTypes.oneOf((0, _values2.default)(_carHire.transmissionTypes)),
	  fuelPolicy: _react.PropTypes.oneOf((0, _values2.default)(_carHire.fuelPolicies))
	});

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _svgInlineReact = __webpack_require__(64);
	
	var _svgInlineReact2 = _interopRequireDefault(_svgInlineReact);
	
	var _utils = __webpack_require__(8);
	
	__webpack_require__(923);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Modal = function (_Component) {
	  (0, _inherits3.default)(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.shouldComponentUpdate = _function2.default, _this.modalClose = function (event) {
	      event.preventDefault();
	      _this.props.onModalClose(event);
	    }, _this.modalCloseWithEscape = function (event) {
	      var escapeKeycode = 27;
	
	      if (event.keyCode === escapeKeycode) {
	        _this.props.onModalClose(event);
	      }
	    }, _this.resizeHandler = (0, _utils.debounce)(function () {
	      /* istanbul ignore next */
	      _this.selectDisplayMethod(_this.modalContentRef);
	    }, 300), _this.saveModalContentRef = function (ref) {
	      return _this.modalContentRef = ref;
	    }, _this.saveModalRef = function (ref) {
	      return _this.modalRef = ref;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Modal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.selectDisplayMethod(this.modalContentRef);
	      window.addEventListener('resize', this.resizeHandler);
	      window.addEventListener('keyup', this.modalCloseWithEscape);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.resizeHandler);
	      window.removeEventListener('keyup', this.modalCloseWithEscape);
	    }
	  }, {
	    key: 'selectDisplayMethod',
	    value: function selectDisplayMethod(modalContentRef) {
	      if (this.props.modalConfig.forceFullHeight) {
	        this.setState({
	          display: 'fullHeight'
	        });
	      } else {
	        var topModalPosition = modalContentRef.getBoundingClientRect().top;
	        var modalHeight = modalContentRef.offsetHeight;
	        var contentHeight = topModalPosition + modalHeight;
	        this.setState({
	          display: contentHeight > this.viewportHeight ? 'fullHeight' : 'verticallyCentered'
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          icon = _props.icon,
	          isMobileBreakpoint = _props.isMobileBreakpoint,
	          modalConfig = _props.modalConfig;
	
	
	      var modalStyles = {};
	
	      if (!isMobileBreakpoint) {
	        modalStyles.width = '600px';
	      }
	
	      if (modalConfig.width) {
	        modalStyles.width = modalConfig.width;
	      }
	
	      var hideCloseButton = modalConfig.hideCloseButton;
	
	      return _react2.default.createElement(
	        'section',
	        {
	          className: 'modal ' + (this.state.display === 'fullHeight' ? 'modal--is-full-height' : 'modal--is-vertically-centered'),
	          style: modalStyles,
	          ref: this.saveModalRef
	        },
	        _react2.default.createElement('div', { onClick: hideCloseButton ? '' : this.modalClose, className: 'modal__screen' }),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'modal__content ' + (icon && 'modal__content--is-with-icon')
	          },
	          !hideCloseButton && _react2.default.createElement('a', { href: '#', onClick: this.modalClose, className: 'modal__content__close', title: 'Close' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'modal__content__inner' },
	            _react2.default.createElement(
	              'div',
	              { ref: this.saveModalContentRef },
	              icon && _react2.default.createElement(_svgInlineReact2.default, { className: 'modal__logo', src: icon }),
	              children
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'viewportHeight',
	    get: function get() {
	      /* istanbul ignore next */
	      return window.innerHeight;
	    }
	  }]);
	  return Modal;
	}(_react.Component);
	
	Modal.defaultProps = {
	  isMobileBreakpoint: false,
	  modalConfig: {}
	};
	exports.default = Modal;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _global = __webpack_require__(79);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _dates = __webpack_require__(35);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _calendar = __webpack_require__(95);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _utils = __webpack_require__(8);
	
	var _SearchUnitCustomControlCalendarDay = __webpack_require__(541);
	
	var _SearchUnitCustomControlCalendarDay2 = _interopRequireDefault(_SearchUnitCustomControlCalendarDay);
	
	__webpack_require__(932);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchUnitCustomControlCalendar = function (_Component) {
	  (0, _inherits3.default)(SearchUnitCustomControlCalendar, _Component);
	
	  function SearchUnitCustomControlCalendar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SearchUnitCustomControlCalendar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchUnitCustomControlCalendar.__proto__ || (0, _getPrototypeOf2.default)(SearchUnitCustomControlCalendar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.shouldComponentUpdate = _function2.default, _this.onMonthChange = function (event) {
	      _this.changeMonth(event.currentTarget.value);
	    }, _this.monthCollection = _this.getMonthsCollection(), _this.goToPreviousMonth = function (event) {
	      event.preventDefault();
	      _this.changeMonth(_this.monthCollection[_this.currentMonthIndex - 1].value);
	    }, _this.goToNextMonth = function (event) {
	      event.preventDefault();
	      _this.changeMonth(_this.monthCollection[_this.currentMonthIndex + 1].value);
	    }, _this.isDayUnavailable = function (i) {
	      var _this$props = _this.props,
	          availability = _this$props.availability,
	          isHotelOnly = _this$props.isHotelOnly,
	          type = _this$props.type;
	      // TODO: if isHotelOnly is true, the day on the calendar will always be available
	      // TODO: once the dayOfMonth api supports HotelOnly, this 'isHotelOnly returns false' logic can be removed
	
	      return type === 'search-unit' && !isHotelOnly ? !availability.get(i) : false;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SearchUnitCustomControlCalendar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          loadDayOfMonthData = _props.loadDayOfMonthData,
	          monthViewDayStamp = _props.monthViewDayStamp;
	
	
	      if (loadDayOfMonthData) {
	        loadDayOfMonthData(monthViewDayStamp);
	      }
	    }
	  }, {
	    key: 'getMonthsCollection',
	    value: function getMonthsCollection() {
	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _dates2.default.utcDate();
	
	      date.setDate(1);
	
	      var monthsCollection = [];
	
	      for (var i = 0; i < _global2.default.numberOfCalendarMonths; i++) {
	        var timestamp = Date.UTC(date.getFullYear(), date.getMonth() + i, 1);
	        var calDate = timestamp / _utils.dayInMilliseconds;
	        var monthAndYearText = _dates2.default.format(timestamp, 'MMMM YYYY');
	
	        monthsCollection.push({
	          name: monthAndYearText,
	          value: '' + calDate
	        });
	      }
	
	      return monthsCollection;
	    }
	  }, {
	    key: 'changeMonth',
	    value: function changeMonth(monthViewDayStamp) {
	      var loadDayOfMonthData = this.props.loadDayOfMonthData;
	
	      if (loadDayOfMonthData) {
	        loadDayOfMonthData(monthViewDayStamp);
	      }
	      this.setState({ monthViewDayStamp: monthViewDayStamp });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          appState = _props2.appState,
	          handleDayClick = _props2.handleDayClick,
	          hideLegend = _props2.hideLegend,
	          monthViewDayStamp = _props2.monthViewDayStamp,
	          selectedCalendarDayStamp = _props2.selectedCalendarDayStamp;
	
	
	      var nowTimestamp = _dates2.default.utcDate(Date.now());
	      var nowDaystamp = Math.floor(nowTimestamp / _utils.dayInMilliseconds);
	      var selectedTimestamp = selectedCalendarDayStamp * _utils.dayInMilliseconds;
	      var monthViewTimestamp = (this.state.monthViewDayStamp || monthViewDayStamp || nowDaystamp) * _utils.dayInMilliseconds;
	
	      var timestampToView = monthViewTimestamp || selectedTimestamp || nowTimestamp;
	      var dateToView = new Date(timestampToView);
	      var firstOfMonthToView = dateToView.setDate(1);
	      this.firstOfMonthToViewDayStamp = '' + firstOfMonthToView / _utils.dayInMilliseconds;
	      var datesArray = _calendar2.default.getCalendarDatesArray(selectedTimestamp, timestampToView, this.isDayUnavailable);
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'search-unit-custom-control-calendar' },
	        _react2.default.createElement(
	          'div',
	          { className: 'search-unit-custom-control-calendar__inner' },
	          _react2.default.createElement(
	            'div',
	            { className: 'search-unit-custom-control-calendar__month' },
	            !this.isFirstMonth && _react2.default.createElement(
	              'a',
	              { href: '#', className: 'search-unit-custom-control-calendar__month__prev', onClick: this.goToPreviousMonth },
	              _react2.default.createElement(
	                'span',
	                null,
	                'Previous month'
	              )
	            ),
	            _react2.default.createElement(
	              'select',
	              { onChange: this.onMonthChange, value: Math.ceil(this.firstOfMonthToViewDayStamp) },
	              this.monthCollection.map(function (item, index) {
	                return _react2.default.createElement(
	                  'option',
	                  { value: item.value, key: index },
	                  item.name
	                );
	              })
	            ),
	            !this.isLastMonth && _react2.default.createElement(
	              'a',
	              { href: '#', className: 'search-unit-custom-control-calendar__month__next', onClick: this.goToNextMonth },
	              _react2.default.createElement(
	                'span',
	                null,
	                'Next month'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'table',
	            { className: 'search-unit-custom-control-calendar__table' },
	            _react2.default.createElement(
	              'thead',
	              { className: 'search-unit-custom-control-calendar__table__legend' },
	              _react2.default.createElement(
	                'tr',
	                null,
	                ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'].map(function (day, index) {
	                  return _react2.default.createElement(
	                    'th',
	                    { key: index, className: 'search-unit-custom-control-calendar__table__legend__day' },
	                    day
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              { className: 'search-unit-custom-control-calendar__table__page' },
	              (0, _utils.range)(Math.ceil(datesArray.length / 7)).map(function (val, trIndex) {
	                return _react2.default.createElement(
	                  'tr',
	                  { key: trIndex },
	                  datesArray.splice(0, 7).map(function (date, index) {
	                    return _react2.default.createElement(_SearchUnitCustomControlCalendarDay2.default, {
	                      key: index,
	                      date: date,
	                      handleDayClick: handleDayClick,
	                      appState: appState
	                    });
	                  })
	                );
	              })
	            )
	          ),
	          !hideLegend && _react2.default.createElement(
	            'div',
	            { className: 'search-unit-custom-control-calendar__key' },
	            _react2.default.createElement(
	              'div',
	              { className: 'search-unit-custom-control-calendar__key__dummy-day' },
	              '17'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'search-unit-custom-control-calendar__key__text' },
	              'No holidays available for this date'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'currentMonthIndex',
	    get: function get() {
	      var _this2 = this;
	
	      return this.monthCollection.findIndex(function (element) {
	        return _this2.firstOfMonthToViewDayStamp === element.value;
	      });
	    }
	  }, {
	    key: 'isFirstMonth',
	    get: function get() {
	      return this.currentMonthIndex === 0;
	    }
	  }, {
	    key: 'isLastMonth',
	    get: function get() {
	      return this.currentMonthIndex === this.monthCollection.length - 1;
	    }
	  }]);
	  return SearchUnitCustomControlCalendar;
	}(_react.Component);
	
	SearchUnitCustomControlCalendar.defaultProps = {
	  appState: _immutable2.default.Map(),
	  availability: _immutable2.default.List(),
	  hideLegend: false,
	  isHotelOnly: false
	};
	exports.default = SearchUnitCustomControlCalendar;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _svgInlineReact = __webpack_require__(64);
	
	var _svgInlineReact2 = _interopRequireDefault(_svgInlineReact);
	
	var _search = __webpack_require__(1362);
	
	var _search2 = _interopRequireDefault(_search);
	
	__webpack_require__(938);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchUnitHeader = function (_Component) {
	  (0, _inherits3.default)(SearchUnitHeader, _Component);
	
	  function SearchUnitHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SearchUnitHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchUnitHeader.__proto__ || (0, _getPrototypeOf2.default)(SearchUnitHeader)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _this.handleResetClick = function (event) {
	      var resetSearchForm = _this.props.resetSearchForm;
	
	      event.preventDefault();
	      resetSearchForm();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SearchUnitHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          resetSearchForm = _props.resetSearchForm,
	          title = _props.title,
	          showIcon = _props.showIcon;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'search-unit-header' },
	        !!showIcon && _react2.default.createElement(_svgInlineReact2.default, { src: _search2.default, className: 'search-unit-header__icon' }),
	        !!resetSearchForm && _react2.default.createElement(
	          'a',
	          { href: '#', className: 'search-unit-header__reset', onClick: this.handleResetClick },
	          'reset'
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: 'search-unit-header__title' },
	          title
	        )
	      );
	    }
	  }]);
	  return SearchUnitHeader;
	}(_react.Component);
	
	SearchUnitHeader.defaultProps = {
	  resetSearchForm: null,
	  showIcon: false,
	  title: 'Search holidays'
	};
	exports.default = SearchUnitHeader;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(56);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(87);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectList = __webpack_require__(548);
	
	var _SelectList2 = _interopRequireDefault(_SelectList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectListWithKeySupport = function (_Component) {
	  (0, _inherits3.default)(SelectListWithKeySupport, _Component);
	
	  function SelectListWithKeySupport(props) {
	    (0, _classCallCheck3.default)(this, SelectListWithKeySupport);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SelectListWithKeySupport.__proto__ || (0, _getPrototypeOf2.default)(SelectListWithKeySupport)).call(this, props));
	
	    _this.selectNext = function () {
	      _this.setState({
	        activeIndex: _this.findNextAvailableElement()
	      });
	    };
	
	    _this.selectPrevious = function () {
	      _this.setState({
	        activeIndex: _this.findPreviousAvailableElement()
	      });
	    };
	
	    _this.state = {
	      activeIndex: props.elements.findIndex(function (element) {
	        return !element.unavailable;
	      })
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(SelectListWithKeySupport, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      var elements = props.elements,
	          activeItemIndex = props.activeItemIndex;
	
	      this.setState({
	        activeIndex: activeItemIndex || elements.findIndex(function (element) {
	          return !element.unavailable;
	        })
	      });
	    }
	  }, {
	    key: 'findNextAvailableElement',
	    value: function findNextAvailableElement() {
	      var _this2 = this;
	
	      var elements = this.props.elements;
	
	
	      var nextAvailableElementIndex = elements.findIndex(function (element, index) {
	        return index > _this2.state.activeIndex && !element.unavailable;
	      });
	
	      return nextAvailableElementIndex === -1 ? this.state.activeIndex : nextAvailableElementIndex;
	    }
	  }, {
	    key: 'findPreviousAvailableElement',
	    value: function findPreviousAvailableElement() {
	      var _this3 = this;
	
	      var elements = this.props.elements;
	
	
	      var previousAvailableElementIndex = [].concat((0, _toConsumableArray3.default)(elements)).reverse().findIndex(function (element, index) {
	        return index >= elements.length - _this3.state.activeIndex && !element.unavailable;
	      });
	
	      return previousAvailableElementIndex === -1 ? this.state.activeIndex : elements.length - previousAvailableElementIndex - 1;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_SelectList2.default, (0, _extends3.default)({ activeIndex: this.state.activeIndex }, this.props));
	    }
	  }]);
	  return SelectListWithKeySupport;
	}(_react.Component);
	
	exports.default = SelectListWithKeySupport;

/***/ },
/* 309 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CALENDAR_DATE_FORMAT = exports.CALENDAR_DATE_FORMAT = 'ddd D MMM \'YY';
	var EXPECTED_PRICE_TRACKER_DATE_FORMAT = exports.EXPECTED_PRICE_TRACKER_DATE_FORMAT = 'ddd D MMM YYYY';

/***/ },
/* 310 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var defaultCardFieldLengths = exports.defaultCardFieldLengths = {
	  securityCodeLength: 3,
	  cardNumberLengthRange: '{16}'
	};
	
	var cardOptions = exports.cardOptions = [{
	  value: 'DEL',
	  label: 'Visa Debit',
	  fieldLengths: defaultCardFieldLengths
	}, {
	  value: 'MCD',
	  label: 'Mastercard Debit',
	  fieldLengths: defaultCardFieldLengths
	}, {
	  value: 'MAE',
	  label: 'Maestro',
	  fieldLengths: defaultCardFieldLengths
	}, {
	  value: 'ELC',
	  label: 'Electron',
	  fieldLengths: defaultCardFieldLengths
	}, {
	  value: 'VIS',
	  label: 'Visa Credit',
	  fieldLengths: defaultCardFieldLengths
	}, {
	  value: 'MSC',
	  label: 'Mastercard Credit',
	  fieldLengths: defaultCardFieldLengths
	}, {
	  value: 'AMX',
	  label: 'American Express',
	  fieldLengths: {
	    securityCodeLength: 4,
	    cardNumberLengthRange: '{15}'
	  }
	}];
	
	var PAYMENT_PLAN_TYPES = exports.PAYMENT_PLAN_TYPES = {
	  PAY_IN_FULL: 'PAY_IN_FULL',
	  LOW_DEPOSIT: 'LOW_DEPOSIT',
	  STANDARD_DEPOSIT: 'STANDARD_DEPOSIT',
	  SPREAD_THE_COST: 'SPREAD_THE_COST'
	};

/***/ },
/* 311 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  telephone: /^[+]?[0-9\ ]{7,20}$/,
	  email: /^[^\s]+@[^\s]+\.[^\s]+$/i
	};

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(951);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CustomControlWrapper = function (_Component) {
	  (0, _inherits3.default)(CustomControlWrapper, _Component);
	
	  function CustomControlWrapper() {
	    (0, _classCallCheck3.default)(this, CustomControlWrapper);
	    return (0, _possibleConstructorReturn3.default)(this, (CustomControlWrapper.__proto__ || (0, _getPrototypeOf2.default)(CustomControlWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CustomControlWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          closeCustomControl = _props.closeCustomControl,
	          children = _props.children;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'custom-control' },
	        _react2.default.createElement('div', { onClick: closeCustomControl, className: 'custom-control__screen' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'custom-control__body' },
	          children
	        )
	      );
	    }
	  }]);
	  return CustomControlWrapper;
	}(_react.Component);
	
	exports.default = CustomControlWrapper;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(56);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.withCustomControl = withCustomControl;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _customControlActions = __webpack_require__(120);
	
	var customControlActions = _interopRequireWildcard(_customControlActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    customControlState: state.customControl
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    customControlActionsBound: (0, _redux.bindActionCreators)(customControlActions, dispatch)
	  };
	};
	
	function withCustomControl(WrappedComponent) {
	  return function (_Component) {
	    (0, _inherits3.default)(CustomControlWrapperLayout, _Component);
	
	    function CustomControlWrapperLayout() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      (0, _classCallCheck3.default)(this, CustomControlWrapperLayout);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CustomControlWrapperLayout.__proto__ || (0, _getPrototypeOf2.default)(CustomControlWrapperLayout)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        customControlToken: null
	      }, _this.onShowCustomControl = function () {
	        var token = Math.random().toString();
	        _this.setState({
	          customControlToken: token
	        });
	
	        _this.props.customControlActionsBound.showControl({
	          token: token
	        });
	      }, _this.onHideCustomControl = function () {
	        _this.setState({ customControlToken: null });
	      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(CustomControlWrapperLayout, [{
	      key: 'render',
	      value: function render() {
	        var customControlState = this.props.customControlState;
	
	
	        var stateToken = this.state.customControlToken;
	        var storeToken = customControlState.token;
	
	        var isCustomControlVisible = stateToken === storeToken && stateToken !== null;
	        var wrappedComponentProps = {
	          isCustomControlVisible: isCustomControlVisible,
	          showCustomControl: this.onShowCustomControl,
	          hideCustomControl: this.onHideCustomControl
	        };
	
	        return _react2.default.createElement(WrappedComponent, (0, _extends3.default)({}, wrappedComponentProps, this.props));
	      }
	    }]);
	    return CustomControlWrapperLayout;
	  }(_react.Component);
	}
	
	var wrapWithCustomControl = function wrapWithCustomControl(wrappedComponent) {
	  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(withCustomControl(wrappedComponent));
	};
	
	exports.default = wrapWithCustomControl;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LoadingOverlayLayout = exports.mapStateToProps = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Overlay = __webpack_require__(166);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	__webpack_require__(952);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    isLoading: ownProps.isLoading === undefined ? !!state.appState.get(ownProps.loadingKey, '') : ownProps.isLoading
	  };
	};
	
	var LoadingOverlayLayout = exports.LoadingOverlayLayout = function (_Component) {
	  (0, _inherits3.default)(LoadingOverlayLayout, _Component);
	
	  function LoadingOverlayLayout() {
	    (0, _classCallCheck3.default)(this, LoadingOverlayLayout);
	    return (0, _possibleConstructorReturn3.default)(this, (LoadingOverlayLayout.__proto__ || (0, _getPrototypeOf2.default)(LoadingOverlayLayout)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LoadingOverlayLayout, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isLoading = _props.isLoading,
	          children = _props.children;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'loading-overlay-layout' },
	        isLoading && _react2.default.createElement(_Overlay2.default, { loadingState: 'spinning' }),
	        children
	      );
	    }
	  }]);
	  return LoadingOverlayLayout;
	}(_react.Component);
	
	LoadingOverlayLayout.defaultProps = {
	  isLoading: false,
	  loadingKey: 'loadingState'
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(LoadingOverlayLayout);

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PopoverTriggerLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _popoverActions = __webpack_require__(144);
	
	var popoverActions = _interopRequireWildcard(_popoverActions);
	
	var _optimizely = __webpack_require__(30);
	
	var optimizelyUtil = _interopRequireWildcard(_optimizely);
	
	__webpack_require__(955);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	var mapStateToProps = function mapStateToProps() {
	  return {};
	};
	
	/* istanbul ignore next */
	function mapDispatchToProps(dispatch) {
	  return {
	    popoverActionsBound: (0, _redux.bindActionCreators)(popoverActions, dispatch)
	  };
	}
	
	var PopoverTriggerLayout = exports.PopoverTriggerLayout = function (_Component) {
	  (0, _inherits3.default)(PopoverTriggerLayout, _Component);
	
	  function PopoverTriggerLayout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PopoverTriggerLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverTriggerLayout.__proto__ || (0, _getPrototypeOf2.default)(PopoverTriggerLayout)).call.apply(_ref, [this].concat(args))), _this), _this.showPopover = function (event) {
	      var _this$props = _this.props,
	          popoverActionsBound = _this$props.popoverActionsBound,
	          content = _this$props.content,
	          disabled = _this$props.disabled;
	
	      var optimizelyId = event.currentTarget.dataset.optimizelyId;
	
	      if (!disabled) {
	        popoverActionsBound.showPopover({
	          position: event.currentTarget.dataset.position,
	          boundingClientRect: event.currentTarget.getBoundingClientRect()
	        }, content);
	        _this.mousedOver = true;
	        if (optimizelyId) {
	          optimizelyUtil.fireEvent(optimizelyId, 'clicked');
	        }
	      }
	    }, _this.hidePopover = function () {
	      var popoverActionsBound = _this.props.popoverActionsBound;
	
	      popoverActionsBound.hidePopover();
	      _this.mousedOver = false;
	    }, _this.togglePopover = function (event) {
	      var _this$props2 = _this.props,
	          popoverActionsBound = _this$props2.popoverActionsBound,
	          content = _this$props2.content,
	          disabled = _this$props2.disabled;
	
	      event.preventDefault();
	      if (!_this.mousedOver && !disabled) {
	        popoverActionsBound.togglePopover({
	          position: event.currentTarget.dataset.position,
	          boundingClientRect: event.currentTarget.getBoundingClientRect()
	        }, content);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PopoverTriggerLayout, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.mousedOver) {
	        this.hidePopover();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          position = _props.position,
	          optimizelyId = _props.optimizelyId,
	          extraClass = _props.extraClass;
	
	
	      return _react2.default.createElement(
	        'a',
	        {
	          href: '#',
	          onClick: this.togglePopover,
	          onMouseEnter: this.showPopover,
	          onMouseLeave: this.hidePopover,
	          'data-position': position,
	          'data-optimizely-id': optimizelyId,
	          className: 'popover-trigger ' + (extraClass || '') + ' ' + (label ? 'popover-trigger--underlined' : '')
	        },
	        this.props.children || label
	      );
	    }
	  }]);
	  return PopoverTriggerLayout;
	}(_react.Component);
	
	PopoverTriggerLayout.defaultProps = {
	  disabled: false
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PopoverTriggerLayout);

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calDateChanged = exports.loadCalendarOffers = exports.TYPES = undefined;
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(32);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _utils = __webpack_require__(8);
	
	var _pandaActions = __webpack_require__(585);
	
	var _api = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPES = exports.TYPES = {
	  CALENDAR_OFFERS_REQUEST: 'CALENDAR_OFFERS_REQUEST',
	  CALENDAR_OFFERS_SUCCESS: 'CALENDAR_OFFERS_SUCCESS',
	  CALENDAR_OFFERS_FAILURE: 'CALENDAR_OFFERS_FAILURE'
	};
	
	var loadCalendarOffers = exports.loadCalendarOffers = function loadCalendarOffers(config) {
	  var defaultParams = {
	    calDateFlexibility: 0,
	    calDate: 0,
	    state: 'MANDATORY-TO-BE-OVERRIDEN',
	    url: 'MANDATORY-TO-BE-OVERRIDEN',
	    page: 1,
	    results: 1000,
	    augmentAccom: 'false',
	    minPriceByNights: 'true'
	  };
	
	  var params = (0, _assign2.default)(defaultParams, config);
	
	  return (0, _defineProperty3.default)({}, _api.CALL_API, {
	    types: [TYPES.CALENDAR_OFFERS_REQUEST, TYPES.CALENDAR_OFFERS_SUCCESS, TYPES.CALENDAR_OFFERS_FAILURE],
	    schema: _api.Schemas.CALENDAR_OFFERS,
	    endpoint: '/api/pandaOffers.json?' + (0, _utils.serialize)(params)
	  });
	};
	
	var calDateChanged = exports.calDateChanged = function calDateChanged() {
	  return {
	    type: _pandaActions.TYPES.CAL_DATE_CHANGED
	  };
	};

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadDayOfMonthData = exports.loadCurrentMonthAvailability = exports.TYPES = undefined;
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(32);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _utils = __webpack_require__(8);
	
	var _api = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPES = exports.TYPES = {
	  DAY_OF_MONTH_REQUEST: 'DAY_OF_MONTH_REQUEST',
	  DAY_OF_MONTH_SUCCESS: 'DAY_OF_MONTH_SUCCESS',
	  DAY_OF_MONTH_FAILURE: 'DAY_OF_MONTH_FAILURE',
	  LOAD_CURRENT_MONTH_AVAILABILITY: 'LOAD_CURRENT_MONTH_AVAILABILITY'
	};
	
	var loadCurrentMonthAvailability = exports.loadCurrentMonthAvailability = function loadCurrentMonthAvailability(dayStamp) {
	  return {
	    type: TYPES.LOAD_CURRENT_MONTH_AVAILABILITY,
	    dayStamp: dayStamp
	  };
	};
	
	var loadDayOfMonthData = exports.loadDayOfMonthData = function loadDayOfMonthData(params) {
	  var defaultParams = {
	    url: '/holidays/',
	    state: '',
	    deptDate: 'MANDATORY-TO-BE-OVERRIDEN',
	    deptDateFlexibility: -2,
	    expose: 'D_DayOfMonth'
	  };
	
	  return (0, _defineProperty3.default)({}, _api.CALL_API, {
	    types: [TYPES.DAY_OF_MONTH_REQUEST, TYPES.DAY_OF_MONTH_SUCCESS, TYPES.DAY_OF_MONTH_FAILURE],
	    schema: _api.Schemas.DAY_OF_MONTH,
	    endpoint: '/bridge/dayOfMonth.json?' + (0, _utils.serialize)((0, _assign2.default)(defaultParams, params))
	  });
	};

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadDimensionsAvailability = exports.TYPES = undefined;
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _utils = __webpack_require__(8);
	
	var _api = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPES = exports.TYPES = {
	  DIMENSIONS_AVAILABILITY_REQUEST: 'DIMENSIONS_AVAILABILITY_REQUEST',
	  DIMENSIONS_AVAILABILITY_SUCCESS: 'DIMENSIONS_AVAILABILITY_SUCCESS',
	  DIMENSIONS_AVAILABILITY_FAILURE: 'DIMENSIONS_AVAILABILITY_FAILURE'
	};
	
	var loadDimensionsAvailability = exports.loadDimensionsAvailability = function loadDimensionsAvailability(params) {
	  return (0, _defineProperty3.default)({}, _api.CALL_API, {
	    types: [TYPES.DIMENSIONS_AVAILABILITY_REQUEST, TYPES.DIMENSIONS_AVAILABILITY_SUCCESS, TYPES.DIMENSIONS_AVAILABILITY_FAILURE],
	    endpoint: '/bridge/dimensions/availability?' + (0, _utils.serialize)(params)
	  });
	};

/***/ },
/* 319 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setFeatureFlag = setFeatureFlag;
	var TYPES = exports.TYPES = {
	  SET_FEATURE_FLAG: 'SET_FEATURE_FLAG'
	};
	
	function setFeatureFlag(featureFlag) {
	  return {
	    type: TYPES.SET_FEATURE_FLAG,
	    featureFlag: featureFlag
	  };
	}

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.doSearch = exports.changeFlexbility = exports.resetFilters = exports.sort = exports.searchFiltersInit = exports.rangeChanged = exports.optionChanged = exports.updateDimensions = exports.clearSuggestions = exports.suggestHotels = exports.suggestDestinations = exports.TYPES = undefined;
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(32);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _utils = __webpack_require__(8);
	
	var _api = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPES = exports.TYPES = {
	  SUGGEST_DESTINATIONS_REQUEST: 'SUGGEST_DESTINATIONS_REQUEST',
	  SUGGEST_DESTINATIONS_SUCCESS: 'SUGGEST_DESTINATIONS_SUCCESS',
	  SUGGEST_DESTINATIONS_FAILURE: 'SUGGEST_DESTINATIONS_FAILURE',
	  SUGGEST_HOTELS_REQUEST: 'SUGGEST_HOTELS_REQUEST',
	  SUGGEST_HOTELS_SUCCESS: 'SUGGEST_HOTELS_SUCCESS',
	  SUGGEST_HOTELS_FAILURE: 'SUGGEST_HOTELS_FAILURE',
	  CLEAR_SUGGESTIONS: 'CLEAR_SUGGESTIONS',
	  SEARCH_INIT: 'SEARCH_INIT',
	  SEARCH_SORT: 'SEARCH_SORT',
	  SEARCH_DIMENSION_CHANGE: 'SEARCH_DIMENSION_CHANGE',
	  SEARCH_RANGE_CHANGE: 'SEARCH_RANGE_CHANGE',
	  SEARCH_DIMENSIONS_UPDATE: 'SEARCH_DIMENSIONS_UPDATE',
	  SEARCH_RESET_FILTERS: 'SEARCH_RESET_FILTERS',
	  SEARCH_CHANGE_FLEXIBILITY: 'SEARCH_CHANGE_FLEXIBILITY',
	  SEARCH_DO_SEARCH: 'SEARCH_DO_SEARCH'
	};
	
	var suggestDestinations = exports.suggestDestinations = function suggestDestinations(config) {
	  var defaultParams = {
	    query: '',
	    rows: 5
	  };
	
	  var params = (0, _assign2.default)(defaultParams, config);
	
	  var endpoint = '/search/suggesterAPI/1.0/suggest?' + (0, _utils.serialize)(params);
	
	  return (0, _defineProperty3.default)({}, _api.CALL_API, {
	    types: [TYPES.SUGGEST_DESTINATIONS_REQUEST, TYPES.SUGGEST_DESTINATIONS_SUCCESS, TYPES.SUGGEST_DESTINATIONS_FAILURE],
	    endpoint: endpoint
	  });
	};
	
	var suggestHotels = exports.suggestHotels = function suggestHotels(config) {
	  var defaultParams = {
	    query: '',
	    rows: 10
	  };
	
	  var params = (0, _assign2.default)(defaultParams, config);
	
	  return (0, _defineProperty3.default)({}, _api.CALL_API, {
	    types: [TYPES.SUGGEST_HOTELS_REQUEST, TYPES.SUGGEST_HOTELS_SUCCESS, TYPES.SUGGEST_HOTELS_FAILURE],
	    endpoint: '/search/suggesterAPI/1.0/suggest/hotels?' + (0, _utils.serialize)(params)
	  });
	};
	
	var clearSuggestions = exports.clearSuggestions = function clearSuggestions() {
	  return {
	    type: TYPES.CLEAR_SUGGESTIONS
	  };
	};
	
	var updateDimensions = exports.updateDimensions = function updateDimensions(dimensions) {
	  return {
	    type: TYPES.SEARCH_DIMENSIONS_UPDATE,
	    dimensions: dimensions
	  };
	};
	
	var optionChanged = exports.optionChanged = function optionChanged(dimension, inputType, dimId, location) {
	  return {
	    type: TYPES.SEARCH_DIMENSION_CHANGE,
	    dimension: dimension,
	    inputType: inputType,
	    dimId: dimId,
	    location: location
	  };
	};
	
	var rangeChanged = exports.rangeChanged = function rangeChanged(field, value) {
	  return {
	    type: TYPES.SEARCH_RANGE_CHANGE,
	    field: field,
	    value: value
	  };
	};
	
	var searchFiltersInit = exports.searchFiltersInit = function searchFiltersInit(items) {
	  return (0, _assign2.default)({ type: TYPES.SEARCH_INIT }, items);
	};
	
	var sort = exports.sort = function sort(field, value, location) {
	  return {
	    type: TYPES.SEARCH_SORT,
	    sort: field + ',' + value,
	    location: location
	  };
	};
	
	var resetFilters = exports.resetFilters = function resetFilters(location) {
	  return {
	    type: TYPES.SEARCH_RESET_FILTERS,
	    location: location
	  };
	};
	
	var changeFlexbility = exports.changeFlexbility = function changeFlexbility(deptDateFlexibility, location) {
	  return {
	    type: TYPES.SEARCH_CHANGE_FLEXIBILITY,
	    location: location,
	    deptDateFlexibility: deptDateFlexibility
	  };
	};
	
	var doSearch = exports.doSearch = function doSearch(toLocation) {
	  return {
	    type: TYPES.SEARCH_DO_SEARCH,
	    toLocation: toLocation
	  };
	};

/***/ },
/* 321 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getDimensionsByType = exports.getDimensionsByType = function getDimensionsByType() {
	  var baseState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var dimensionsEntities = arguments[1];
	  var type = arguments[2];
	  return baseState.get('' + type) && baseState.get('' + type).map(function (dimId) {
	    return dimensionsEntities.get('' + dimId);
	  });
	};
	
	var getDimensionLabels = exports.getDimensionLabels = function getDimensionLabels() {
	  var dimensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return dimensions.map(function (dimension) {
	    return dimension.get('label');
	  }).join(', ') || 'none specified';
	};
	
	var rangeValues = {
	  budgetRange: ['£0', '£250', '£500', '£750', '£1k', '£2k+'],
	  numberRange: ['0', '1', '2', '3', '4', '5'],
	  tempRange: ['15', '20', '25', '30', '35', '40']
	};
	
	var getRangeString = exports.getRangeString = function getRangeString(rangeObject, rangeType) {
	  var rangeString = void 0;
	
	  if (rangeObject) {
	    rangeString = rangeValues[rangeType][rangeObject.get('lowerBound')];
	    if (rangeObject.get('upperBound') > rangeObject.get('lowerBound')) {
	      rangeString += ' - ' + rangeValues[rangeType][rangeObject.get('upperBound')];
	    }
	  }
	
	  return rangeString || 'none specified';
	};
	
	var getTopMasterIds = exports.getTopMasterIds = function getTopMasterIds(searchResults, length) {
	  var masterIds = '';
	
	  for (var i = 0; i < length; i += 1) {
	    var masterId = searchResults.getIn([i, 'masterId']);
	    masterIds += masterId ? masterId + ', ' : '';
	  }
	
	  return masterIds.slice(0, -2);
	};
	
	var getUserClassArray = exports.getUserClassArray = function getUserClassArray(userClassString) {
	  return userClassString ? userClassString.split('') : [];
	};

/***/ },
/* 322 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scrollStraightToTop = scrollStraightToTop;
	var smoothScroller = {
	  /* istanbul ignore next */
	  get windowPageYOffset() {
	    return window.pageYOffset;
	  },
	
	  smoothScroll: function smoothScroll(el) {
	    var _this = this;
	
	    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var start = this.windowPageYOffset;
	    var end = void 0;
	
	    if (typeof el === 'number') {
	      end = parseInt(el, 10);
	    } else if (typeof el === 'string') {
	      var element = window.document.querySelector(el);
	
	      if (element) {
	        end = this.getTopOfElement(element, options.offset);
	      }
	    } else {
	      end = this.getTopOfElement(el, options.offset);
	    }
	
	    var startTimestamp = Date.now();
	
	    var sixtyFPS = 1000 / 60;
	    var timeout = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function setTimeoutFallback(fn) {
	      window.setTimeout(fn, sixtyFPS);
	    };
	
	    var step = function step() {
	      var elapsed = Date.now() - startTimestamp;
	      var position = _this.position(start, end, elapsed, duration);
	      window.scroll(0, position);
	
	      if (elapsed <= duration) {
	        timeout(step);
	      }
	    };
	
	    step();
	  },
	  getTopOfElement: function getTopOfElement(element) {
	    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    var top = void 0;
	    if (element.nodeName === 'HTML') {
	      top = -this.windowPageYOffset;
	    } else {
	      top = element.getBoundingClientRect().top + this.windowPageYOffset + offset;
	    }
	
	    return top;
	  },
	  easeInOutCubic: function easeInOutCubic(t) {
	    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
	  },
	  position: function position(start, end, elapsed, duration) {
	    return elapsed > duration ? end : start + (end - start) * this.easeInOutCubic(elapsed / duration);
	  },
	  isSupported: function isSupported() {
	    return window && typeof this.windowPageYOffset === 'number' && window.history.pushState;
	  },
	  smoothScrollWrapper: function smoothScrollWrapper() {
	    if (this.isSupported()) {
	      this.smoothScroll.apply(this, arguments);
	    }
	  },
	  scrollToElement: function scrollToElement(selector, duration, options) {
	    var element = window.document.querySelector(selector);
	
	    if (element) {
	      this.smoothScrollWrapper(element, duration, options);
	    }
	  },
	  scrollToTop: function scrollToTop(duration) {
	    this.scrollToElement('body', duration);
	  },
	  scrollStraightToTop: function scrollStraightToTop() {
	    this.scrollToTop(0);
	  }
	};
	
	function scrollStraightToTop() {
	  smoothScroller.scrollStraightToTop();
	}
	
	exports.default = smoothScroller;

/***/ },
/* 323 */,
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(617), __esModule: true };

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(622), __esModule: true };

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(626), __esModule: true };

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(609);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(324);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ },
/* 328 */
/***/ function(module, exports) {

	var charenc = {
	  // UTF-8 encoding
	  utf8: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
	    }
	  },
	
	  // Binary encoding
	  bin: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      for (var bytes = [], i = 0; i < str.length; i++)
	        bytes.push(str.charCodeAt(i) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      for (var str = [], i = 0; i < bytes.length; i++)
	        str.push(String.fromCharCode(bytes[i]));
	      return str.join('');
	    }
	  }
	};
	
	module.exports = charenc;


/***/ },
/* 329 */
[1381, 41],
/* 330 */
[1382, 88, 122, 221],
/* 331 */
[1383, 145],
/* 332 */
[1384, 123, 38],
/* 333 */
[1386, 68],
/* 334 */
[1388, 169, 49, 343, 97, 96, 123, 638, 170, 338, 38],
/* 335 */
[1389, 38],
/* 336 */
[1397, 146, 147, 99, 230, 96, 330, 88],
/* 337 */
[1399, 339, 222],
/* 338 */
[1400, 96, 148, 226],
/* 339 */
[1401, 96, 99, 632, 226],
/* 340 */
[1403, 49, 31, 122],
/* 341 */
372,
/* 342 */
[1405, 68, 98, 223],
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(97);


/***/ },
/* 344 */
[1410, 68, 168, 38],
/* 345 */
[1412, 121, 636, 329, 221, 41, 145],
/* 346 */
/***/ function(module, exports) {



/***/ },
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SelectList__react-django-template___-hash--base64-5-"};

/***/ },
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(75);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1020),
	    isArguments = __webpack_require__(273),
	    isArray = __webpack_require__(76),
	    isBuffer = __webpack_require__(274),
	    isIndex = __webpack_require__(269),
	    isTypedArray = __webpack_require__(278);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 399 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(192),
	    eq = __webpack_require__(155);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1030);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(403),
	    toKey = __webpack_require__(154);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(76),
	    isKey = __webpack_require__(270),
	    stringToPath = __webpack_require__(412),
	    toString = __webpack_require__(416);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 404 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(114);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(993),
	    arraySome = __webpack_require__(998),
	    cacheHas = __webpack_require__(1023);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 407 */,
/* 408 */,
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(91);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 410 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 411 */,
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1060);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 413 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(398),
	    baseKeysIn = __webpack_require__(1011),
	    isArrayLike = __webpack_require__(195);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(192),
	    baseForOwn = __webpack_require__(1001),
	    baseIteratee = __webpack_require__(1009);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1021);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1)
	var createReactTimeout = __webpack_require__(1250)
	
	module.exports = createReactTimeout(React)


/***/ },
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1288)


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _es6Error = __webpack_require__(872);
	
	var _es6Error2 = _interopRequireDefault(_es6Error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubmissionError = function (_ExtendableError) {
	  _inherits(SubmissionError, _ExtendableError);
	
	  function SubmissionError(errors) {
	    _classCallCheck(this, SubmissionError);
	
	    var _this = _possibleConstructorReturn(this, (SubmissionError.__proto__ || Object.getPrototypeOf(SubmissionError)).call(this, 'Submit Validation Failed'));
	
	    _this.errors = errors;
	    return _this;
	  }
	
	  return SubmissionError;
	}(_es6Error2.default);
	
	exports.default = SubmissionError;

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actionTypes = __webpack_require__(302);
	
	var arrayInsert = function arrayInsert(form, field, index, value) {
	  return {
	    type: _actionTypes.ARRAY_INSERT,
	    meta: { form: form, field: field, index: index },
	    payload: value
	  };
	};
	
	var arrayMove = function arrayMove(form, field, from, to) {
	  return {
	    type: _actionTypes.ARRAY_MOVE,
	    meta: { form: form, field: field, from: from, to: to }
	  };
	};
	
	var arrayPop = function arrayPop(form, field) {
	  return {
	    type: _actionTypes.ARRAY_POP,
	    meta: { form: form, field: field }
	  };
	};
	
	var arrayPush = function arrayPush(form, field, value) {
	  return {
	    type: _actionTypes.ARRAY_PUSH,
	    meta: { form: form, field: field },
	    payload: value
	  };
	};
	
	var arrayRemove = function arrayRemove(form, field, index) {
	  return {
	    type: _actionTypes.ARRAY_REMOVE,
	    meta: { form: form, field: field, index: index }
	  };
	};
	
	var arrayRemoveAll = function arrayRemoveAll(form, field) {
	  return {
	    type: _actionTypes.ARRAY_REMOVE_ALL,
	    meta: { form: form, field: field }
	  };
	};
	
	var arrayShift = function arrayShift(form, field) {
	  return {
	    type: _actionTypes.ARRAY_SHIFT,
	    meta: { form: form, field: field }
	  };
	};
	
	var arraySplice = function arraySplice(form, field, index, removeNum, value) {
	  var action = {
	    type: _actionTypes.ARRAY_SPLICE,
	    meta: { form: form, field: field, index: index, removeNum: removeNum }
	  };
	  if (value !== undefined) {
	    action.payload = value;
	  }
	  return action;
	};
	
	var arraySwap = function arraySwap(form, field, indexA, indexB) {
	  if (indexA === indexB) {
	    throw new Error('Swap indices cannot be equal');
	  }
	  if (indexA < 0 || indexB < 0) {
	    throw new Error('Swap indices cannot be negative');
	  }
	  return { type: _actionTypes.ARRAY_SWAP, meta: { form: form, field: field, indexA: indexA, indexB: indexB } };
	};
	
	var arrayUnshift = function arrayUnshift(form, field, value) {
	  return {
	    type: _actionTypes.ARRAY_UNSHIFT,
	    meta: { form: form, field: field },
	    payload: value
	  };
	};
	
	var autofill = function autofill(form, field, value) {
	  return {
	    type: _actionTypes.AUTOFILL,
	    meta: { form: form, field: field },
	    payload: value
	  };
	};
	
	var blur = function blur(form, field, value, touch) {
	  return {
	    type: _actionTypes.BLUR,
	    meta: { form: form, field: field, touch: touch },
	    payload: value
	  };
	};
	
	var change = function change(form, field, value, touch, persistentSubmitErrors) {
	  return {
	    type: _actionTypes.CHANGE,
	    meta: { form: form, field: field, touch: touch, persistentSubmitErrors: persistentSubmitErrors },
	    payload: value
	  };
	};
	
	var clearSubmit = function clearSubmit(form) {
	  return {
	    type: _actionTypes.CLEAR_SUBMIT,
	    meta: { form: form }
	  };
	};
	
	var clearSubmitErrors = function clearSubmitErrors(form) {
	  return {
	    type: _actionTypes.CLEAR_SUBMIT_ERRORS,
	    meta: { form: form }
	  };
	};
	
	var clearAsyncError = function clearAsyncError(form, field) {
	  return {
	    type: _actionTypes.CLEAR_ASYNC_ERROR,
	    meta: { form: form, field: field }
	  };
	};
	
	var destroy = function destroy() {
	  for (var _len = arguments.length, form = Array(_len), _key = 0; _key < _len; _key++) {
	    form[_key] = arguments[_key];
	  }
	
	  return {
	    type: _actionTypes.DESTROY,
	    meta: { form: form }
	  };
	};
	
	var focus = function focus(form, field) {
	  return {
	    type: _actionTypes.FOCUS,
	    meta: { form: form, field: field }
	  };
	};
	
	var initialize = function initialize(form, values, keepDirty) {
	  var otherMeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  if (keepDirty instanceof Object) {
	    otherMeta = keepDirty;
	    keepDirty = false;
	  }
	  return {
	    type: _actionTypes.INITIALIZE,
	    meta: _extends({ form: form, keepDirty: keepDirty }, otherMeta),
	    payload: values
	  };
	};
	
	var registerField = function registerField(form, name, type) {
	  return {
	    type: _actionTypes.REGISTER_FIELD,
	    meta: { form: form },
	    payload: { name: name, type: type }
	  };
	};
	
	var reset = function reset(form) {
	  return {
	    type: _actionTypes.RESET,
	    meta: { form: form }
	  };
	};
	
	var startAsyncValidation = function startAsyncValidation(form, field) {
	  return {
	    type: _actionTypes.START_ASYNC_VALIDATION,
	    meta: { form: form, field: field }
	  };
	};
	
	var startSubmit = function startSubmit(form) {
	  return {
	    type: _actionTypes.START_SUBMIT,
	    meta: { form: form }
	  };
	};
	
	var stopAsyncValidation = function stopAsyncValidation(form, errors) {
	  return {
	    type: _actionTypes.STOP_ASYNC_VALIDATION,
	    meta: { form: form },
	    payload: errors,
	    error: !!(errors && Object.keys(errors).length)
	  };
	};
	
	var stopSubmit = function stopSubmit(form, errors) {
	  return {
	    type: _actionTypes.STOP_SUBMIT,
	    meta: { form: form },
	    payload: errors,
	    error: !!(errors && Object.keys(errors).length)
	  };
	};
	
	var submit = function submit(form) {
	  return {
	    type: _actionTypes.SUBMIT,
	    meta: { form: form }
	  };
	};
	
	var setSubmitFailed = function setSubmitFailed(form) {
	  for (var _len2 = arguments.length, fields = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    fields[_key2 - 1] = arguments[_key2];
	  }
	
	  return {
	    type: _actionTypes.SET_SUBMIT_FAILED,
	    meta: { form: form, fields: fields },
	    error: true
	  };
	};
	
	var setSubmitSucceeded = function setSubmitSucceeded(form) {
	  for (var _len3 = arguments.length, fields = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    fields[_key3 - 1] = arguments[_key3];
	  }
	
	  return {
	    type: _actionTypes.SET_SUBMIT_SUCCEEDED,
	    meta: { form: form, fields: fields },
	    error: false
	  };
	};
	
	var touch = function touch(form) {
	  for (var _len4 = arguments.length, fields = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    fields[_key4 - 1] = arguments[_key4];
	  }
	
	  return {
	    type: _actionTypes.TOUCH,
	    meta: { form: form, fields: fields }
	  };
	};
	
	var unregisterField = function unregisterField(form, name) {
	  var destroyOnUnmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  return {
	    type: _actionTypes.UNREGISTER_FIELD,
	    meta: { form: form },
	    payload: { name: name, destroyOnUnmount: destroyOnUnmount }
	  };
	};
	
	var untouch = function untouch(form) {
	  for (var _len5 = arguments.length, fields = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    fields[_key5 - 1] = arguments[_key5];
	  }
	
	  return {
	    type: _actionTypes.UNTOUCH,
	    meta: { form: form, fields: fields }
	  };
	};
	
	var updateSyncErrors = function updateSyncErrors(form) {
	  var syncErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var error = arguments[2];
	  return {
	    type: _actionTypes.UPDATE_SYNC_ERRORS,
	    meta: { form: form },
	    payload: { syncErrors: syncErrors, error: error }
	  };
	};
	
	var updateSyncWarnings = function updateSyncWarnings(form) {
	  var syncWarnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var warning = arguments[2];
	  return {
	    type: _actionTypes.UPDATE_SYNC_WARNINGS,
	    meta: { form: form },
	    payload: { syncWarnings: syncWarnings, warning: warning }
	  };
	};
	
	var actions = {
	  arrayInsert: arrayInsert,
	  arrayMove: arrayMove,
	  arrayPop: arrayPop,
	  arrayPush: arrayPush,
	  arrayRemove: arrayRemove,
	  arrayRemoveAll: arrayRemoveAll,
	  arrayShift: arrayShift,
	  arraySplice: arraySplice,
	  arraySwap: arraySwap,
	  arrayUnshift: arrayUnshift,
	  autofill: autofill,
	  blur: blur,
	  change: change,
	  clearSubmit: clearSubmit,
	  clearSubmitErrors: clearSubmitErrors,
	  clearAsyncError: clearAsyncError,
	  destroy: destroy,
	  focus: focus,
	  initialize: initialize,
	  registerField: registerField,
	  reset: reset,
	  startAsyncValidation: startAsyncValidation,
	  startSubmit: startSubmit,
	  stopAsyncValidation: stopAsyncValidation,
	  stopSubmit: stopSubmit,
	  submit: submit,
	  setSubmitFailed: setSubmitFailed,
	  setSubmitSucceeded: setSubmitSucceeded,
	  touch: touch,
	  unregisterField: unregisterField,
	  untouch: untouch,
	  updateSyncErrors: updateSyncErrors,
	  updateSyncWarnings: updateSyncWarnings
	};
	
	exports.default = actions;

/***/ },
/* 475 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var processProps = function processProps(type, props, _value, deepEqual) {
	  var value = props.value;
	
	  if (type === 'checkbox') {
	    return _extends({}, props, {
	      checked: !!value
	    });
	  }
	  if (type === 'radio') {
	    return _extends({}, props, {
	      checked: deepEqual(value, _value),
	      value: _value
	    });
	  }
	  if (type === 'select-multiple') {
	    return _extends({}, props, {
	      value: value || []
	    });
	  }
	  if (type === 'file') {
	    return _extends({}, props, {
	      value: value || undefined
	    });
	  }
	  return props;
	};
	
	var createFieldProps = function createFieldProps(_ref2, name, _ref) {
	  var getIn = _ref2.getIn,
	      toJS = _ref2.toJS,
	      deepEqual = _ref2.deepEqual;
	
	  var asyncError = _ref.asyncError,
	      asyncValidating = _ref.asyncValidating,
	      onBlur = _ref.onBlur,
	      onChange = _ref.onChange,
	      onDrop = _ref.onDrop,
	      onDragStart = _ref.onDragStart,
	      dirty = _ref.dirty,
	      dispatch = _ref.dispatch,
	      onFocus = _ref.onFocus,
	      form = _ref.form,
	      format = _ref.format,
	      initial = _ref.initial,
	      parse = _ref.parse,
	      pristine = _ref.pristine,
	      props = _ref.props,
	      state = _ref.state,
	      submitError = _ref.submitError,
	      submitFailed = _ref.submitFailed,
	      submitting = _ref.submitting,
	      syncError = _ref.syncError,
	      syncWarning = _ref.syncWarning,
	      validate = _ref.validate,
	      value = _ref.value,
	      _value = _ref._value,
	      warn = _ref.warn,
	      custom = _objectWithoutProperties(_ref, ['asyncError', 'asyncValidating', 'onBlur', 'onChange', 'onDrop', 'onDragStart', 'dirty', 'dispatch', 'onFocus', 'form', 'format', 'initial', 'parse', 'pristine', 'props', 'state', 'submitError', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'validate', 'value', '_value', 'warn']);
	
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	
	  var formatFieldValue = function formatFieldValue(value, format) {
	    if (format === null) {
	      return value;
	    }
	    var defaultFormattedValue = value == null ? '' : value;
	    return format ? format(value, name) : defaultFormattedValue;
	  };
	
	  var formattedFieldValue = formatFieldValue(value, format);
	
	  return {
	    input: processProps(custom.type, {
	      name: name,
	      onBlur: onBlur,
	      onChange: onChange,
	      onDragStart: onDragStart,
	      onDrop: onDrop,
	      onFocus: onFocus,
	      value: formattedFieldValue
	    }, _value, deepEqual),
	    meta: _extends({}, toJS(state), {
	      active: !!(state && getIn(state, 'active')),
	      asyncValidating: asyncValidating,
	      autofilled: !!(state && getIn(state, 'autofilled')),
	      dirty: dirty,
	      dispatch: dispatch,
	      error: error,
	      form: form,
	      initial: initial,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: !!submitting,
	      submitFailed: !!submitFailed,
	      touched: !!(state && getIn(state, 'touched')),
	      valid: !error,
	      visited: !!(state && getIn(state, 'visited'))
	    }),
	    custom: _extends({}, custom, props)
	  };
	};
	
	exports.default = createFieldProps;

/***/ },
/* 476 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
	  var initialized = _ref.initialized,
	      trigger = _ref.trigger,
	      pristine = _ref.pristine,
	      syncValidationPasses = _ref.syncValidationPasses;
	
	  if (!syncValidationPasses) {
	    return false;
	  }
	  switch (trigger) {
	    case 'blur':
	      // blurring
	      return true;
	    case 'submit':
	      // submitting, so only async validate if form is dirty or was never initialized
	      // conversely, DON'T async validate if the form is pristine just as it was initialized
	      return !pristine || !initialized;
	    default:
	      return false;
	  }
	};
	exports.default = defaultShouldAsyncValidate;

/***/ },
/* 477 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var defaultShouldError = function defaultShouldError(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	exports.default = defaultShouldError;

/***/ },
/* 478 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var defaultShouldValidate = function defaultShouldValidate(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	exports.default = defaultShouldValidate;

/***/ },
/* 479 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var defaultShouldWarn = function defaultShouldWarn(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	exports.default = defaultShouldWarn;

/***/ },
/* 480 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isEvent = function isEvent(candidate) {
	  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
	};
	
	exports.default = isEvent;

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getValue = __webpack_require__(1283);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	var _isReactNative = __webpack_require__(483);
	
	var _isReactNative2 = _interopRequireDefault(_isReactNative);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onChangeValue = function onChangeValue(event, _ref) {
	  var name = _ref.name,
	      parse = _ref.parse,
	      normalize = _ref.normalize;
	
	  // read value from input
	  var value = (0, _getValue2.default)(event, _isReactNative2.default);
	
	  // parse value if we have a parser
	  if (parse) {
	    value = parse(value, name);
	  }
	
	  // normalize value
	  if (normalize) {
	    value = normalize(name, value);
	  }
	
	  return value;
	};
	
	exports.default = onChangeValue;

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEvent = __webpack_require__(480);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvent = function silenceEvent(event) {
	  var is = (0, _isEvent2.default)(event);
	  if (is) {
	    event.preventDefault();
	  }
	  return is;
	};
	exports.default = silenceEvent;

/***/ },
/* 483 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	
	exports.default = isReactNative;

/***/ },
/* 484 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createIsPristine = function createIsPristine(_ref) {
	  var deepEqual = _ref.deepEqual,
	      empty = _ref.empty,
	      getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      var formState = nonNullGetFormState(state);
	      var initial = getIn(formState, form + '.initial') || empty;
	      var values = getIn(formState, form + '.values') || initial;
	      return deepEqual(initial, values);
	    };
	  };
	};
	
	exports.default = createIsPristine;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(131);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getIn = function getIn(state, field) {
	  if (!state) {
	    return state;
	  }
	
	  var path = (0, _toPath3.default)(field);
	  var length = path.length;
	  if (!length) {
	    return undefined;
	  }
	
	  var result = state;
	  for (var i = 0; i < length && result; ++i) {
	    result = result[path[i]];
	  }
	
	  return result;
	};
	
	exports.default = getIn;

/***/ },
/* 486 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	function keys(value) {
	  if (!value) {
	    return [];
	  }
	
	  if (Array.isArray(value)) {
	    return value.map(function (i) {
	      return i.name;
	    });
	  }
	
	  return Object.keys(value);
	}
	exports.default = keys;

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqualWith2 = __webpack_require__(275);
	
	var _isEqualWith3 = _interopRequireDefault(_isEqualWith2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
	  // https://lodash.com/docs/4.17.4#isEqualWith
	  if (stack) {
	    // Shallow compares
	    // For 1st level, stack === undefined.
	    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
	    // For 2nd level and up, stack !== undefined.
	    //   -> Compare by === operator
	    return objectValue === otherValue;
	  }
	};
	
	var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
	  return !(0, _isEqualWith3.default)(instance.props, nextProps, customizer) || !(0, _isEqualWith3.default)(instance.state, nextState, customizer);
	};
	
	exports.default = shallowCompare;

/***/ },
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(117);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(78);
	
	var _monitoring = __webpack_require__(604);
	
	var _monitoring2 = _interopRequireDefault(_monitoring);
	
	var _Root = __webpack_require__(555);
	
	var _Root2 = _interopRequireDefault(_Root);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bootstrapApp = function bootstrapApp(routes, store, domEl) {
	  // Render the React application to the DOM
	  try {
	    _reactDom2.default.render(_react2.default.createElement(_Root2.default, { history: _reactRouter.browserHistory, routes: routes, store: store }), domEl || window.document.getElementById('root'));
	  } catch (error) {
	    _monitoring2.default.sendError(error);
	
	    /* eslint-disable no-console */
	    if (console && console.error) {
	      console.error(error);
	    }
	    /* eslint-enable no-console */
	  }
	};
	
	exports.default = bootstrapApp;

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _svgInlineReact = __webpack_require__(64);
	
	var _svgInlineReact2 = _interopRequireDefault(_svgInlineReact);
	
	var _flightSeats = __webpack_require__(211);
	
	var _EmptySeat = __webpack_require__(1344);
	
	var _EmptySeat2 = _interopRequireDefault(_EmptySeat);
	
	var _InfantSeat = __webpack_require__(1347);
	
	var _InfantSeat2 = _interopRequireDefault(_InfantSeat);
	
	__webpack_require__(873);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AirlineSeat = function (_PureComponent) {
	  (0, _inherits3.default)(AirlineSeat, _PureComponent);
	
	  function AirlineSeat() {
	    (0, _classCallCheck3.default)(this, AirlineSeat);
	    return (0, _possibleConstructorReturn3.default)(this, (AirlineSeat.__proto__ || (0, _getPrototypeOf2.default)(AirlineSeat)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AirlineSeat, [{
	    key: 'getSeatIcon',
	    value: function getSeatIcon() {
	      var _props = this.props,
	          flightSeat = _props.flightSeat,
	          paxType = _props.paxType;
	
	
	      var seatAttributes = flightSeat.get('flightSeatAttributes') || _immutable2.default.List();
	      var seatIcon = void 0;
	
	      if (!seatAttributes.includes(_flightSeats.flightSeatAttributes.AISLE) && !seatAttributes.includes(_flightSeats.flightSeatAttributes.ABSENT_SEAT)) {
	        if (seatAttributes.includes(_flightSeats.flightSeatAttributes.INFANTS_ALLOWED) && paxType === 'adultWithInfant') {
	          seatIcon = _InfantSeat2.default;
	        } else {
	          seatIcon = _EmptySeat2.default;
	        }
	      }
	
	      return seatIcon;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          flightSeat = _props2.flightSeat,
	          rowNumber = _props2.rowNumber;
	
	      var seatAttributes = flightSeat.get('flightSeatAttributes') || _immutable2.default.List();
	
	      var isAvailable = flightSeat.get('available');
	      var isAisle = seatAttributes.includes(_flightSeats.flightSeatAttributes.AISLE);
	      var seatIcon = this.getSeatIcon();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'airline-seat', onClick: this.handleSeatClick },
	        isAisle && rowNumber,
	        seatIcon && _react2.default.createElement(_svgInlineReact2.default, { className: 'airline-seat__icon airline-seat__icon--' + (isAvailable ? 'available' : 'unavailable'), src: seatIcon })
	      );
	    }
	  }]);
	  return AirlineSeat;
	}(_react.PureComponent);
	
	exports.default = AirlineSeat;

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PassengerList = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _BookPrice = __webpack_require__(139);
	
	var _BookPrice2 = _interopRequireDefault(_BookPrice);
	
	var _bookActions = __webpack_require__(143);
	
	var _PassengerListFlight = __webpack_require__(495);
	
	var _PassengerListFlight2 = _interopRequireDefault(_PassengerListFlight);
	
	__webpack_require__(874);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    flights: state.bookState.getIn(['data', 'flight']),
	    flightSeatsSelection: state.bookState.getIn(['booking_info', 'selection', 'flight_seats']),
	    airlineSeatPassengers: state.bookState.getIn(['booking_info', 'airlineSeatPassenger']),
	    bookSeatPrice: state.bookState.getIn(['priceBreakdown', 'airlineSeatPrice']),
	    numberOfChargeablePassengers: state.bookState.getIn(['data', 'partyInfo', 'numberOfChargeablePassengers'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    clearSelection: function clearSelection(direction) {
	      return dispatch((0, _bookActions.clearSelectedAirlineSeats)(direction));
	    }
	  };
	};
	
	var PassengerList = exports.PassengerList = function (_PureComponent) {
	  (0, _inherits3.default)(PassengerList, _PureComponent);
	
	  function PassengerList() {
	    (0, _classCallCheck3.default)(this, PassengerList);
	    return (0, _possibleConstructorReturn3.default)(this, (PassengerList.__proto__ || (0, _getPrototypeOf2.default)(PassengerList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PassengerList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          flights = _props.flights,
	          openSeatList = _props.openSeatList,
	          flightSeatsSelection = _props.flightSeatsSelection,
	          airlineSeatPassengers = _props.airlineSeatPassengers,
	          bookSeatPrice = _props.bookSeatPrice,
	          numberOfChargeablePassengers = _props.numberOfChargeablePassengers,
	          clearSelection = _props.clearSelection;
	
	
	      var directions = ['outbound', 'inbound'];
	      var hasSeatsSelected = bookSeatPrice > 0;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'passenger-list' },
	        _react2.default.createElement(
	          'div',
	          { className: 'passenger-list__header' },
	          'If you don\'t select your seats now, they\'ll be automatically allocated on check-in.'
	        ),
	        directions.map(function (direction) {
	          var flight = flights.get(direction, _immutable2.default.Map());
	          return flight.get('flightSeatMap') ? _react2.default.createElement(_PassengerListFlight2.default, {
	            direction: direction,
	            flight: flight,
	            key: direction,
	            openSeatList: openSeatList,
	            seatPassengers: airlineSeatPassengers,
	            flightSeatsSelection: flightSeatsSelection.get(direction, _immutable2.default.Map()),
	            clearSelection: clearSelection
	          }) : undefined;
	        }),
	        hasSeatsSelected && _react2.default.createElement(
	          'div',
	          { className: 'passenger-list__price-summary' },
	          _react2.default.createElement(
	            'div',
	            { className: 'passenger-list__price-summary__per-person' },
	            _react2.default.createElement(_BookPrice2.default, { price: bookSeatPrice, divisor: numberOfChargeablePassengers, suffix: 'pp', isStrong: true, hasSmallSuffix: true })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'passenger-list__price-summary__total' },
	            'Total: ',
	            _react2.default.createElement(_BookPrice2.default, { price: bookSeatPrice, isStrong: true })
	          )
	        )
	      );
	    }
	  }]);
	  return PassengerList;
	}(_react.PureComponent);
	
	PassengerList.defaultProps = {
	  bookSeatPrice: 0
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PassengerList);

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _PassengerSeat = __webpack_require__(206);
	
	var _PassengerSeat2 = _interopRequireDefault(_PassengerSeat);
	
	var _CollapsiblePanel = __webpack_require__(521);
	
	var _CollapsiblePanel2 = _interopRequireDefault(_CollapsiblePanel);
	
	var _LinkButton = __webpack_require__(65);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _BookPrice = __webpack_require__(139);
	
	var _BookPrice2 = _interopRequireDefault(_BookPrice);
	
	var _utils = __webpack_require__(8);
	
	var _bookStateUtils = __webpack_require__(592);
	
	var _optimizely = __webpack_require__(30);
	
	__webpack_require__(875);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PassengerListFlight = function (_PureComponent) {
	  (0, _inherits3.default)(PassengerListFlight, _PureComponent);
	
	  function PassengerListFlight() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PassengerListFlight);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PassengerListFlight.__proto__ || (0, _getPrototypeOf2.default)(PassengerListFlight)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelectEveryoneClick = function (event) {
	      event.preventDefault();
	
	      var _this$props = _this.props,
	          openSeatList = _this$props.openSeatList,
	          direction = _this$props.direction;
	
	      (0, _optimizely.fireEvent)('BookSeatSelection' + (0, _utils.capitalize)(direction) + 'AllPassengers', 'clicked');
	
	      openSeatList(direction);
	    }, _this.handleSelectPassengerClick = function (event) {
	      event.preventDefault();
	
	      var _this$props2 = _this.props,
	          openSeatList = _this$props2.openSeatList,
	          direction = _this$props2.direction;
	
	      var currentPassengerIndex = Number(event.currentTarget.dataset.index);
	      (0, _optimizely.fireEvent)('BookSeatSelection' + (0, _utils.capitalize)(direction) + 'SinglePassenger', 'clicked');
	
	      openSeatList(direction, currentPassengerIndex);
	    }, _this.handleClearSelectionClick = function (event) {
	      var _this$props3 = _this.props,
	          clearSelection = _this$props3.clearSelection,
	          direction = _this$props3.direction;
	
	      (0, _optimizely.fireEvent)('BookSeatSelection' + (0, _utils.capitalize)(direction) + 'ClearSelection', 'clicked');
	
	      event.preventDefault();
	
	      clearSelection(direction);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PassengerListFlight, [{
	    key: 'getFlightSeatForPassenger',
	    value: function getFlightSeatForPassenger(passengerSelection) {
	      var flight = this.props.flight;
	
	      return (0, _bookStateUtils.findFlightSeat)(flight, passengerSelection.get('row'), passengerSelection.get('seat'));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          direction = _props.direction,
	          flight = _props.flight,
	          seatPassengers = _props.seatPassengers,
	          flightSeatsSelection = _props.flightSeatsSelection;
	
	
	      var hasSeatsSelected = flightSeatsSelection.size > 0;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'passenger-list-flight' },
	        _react2.default.createElement(
	          _CollapsiblePanel2.default,
	          { label: (0, _utils.capitalize)(direction) + ': ' + flight.get('deptName') + ' > ' + flight.get('arrvName') },
	          _react2.default.createElement(
	            'div',
	            null,
	            hasSeatsSelected && _react2.default.createElement(
	              'div',
	              { className: 'passenger-list-flight__clear-selection-button', onClick: this.handleClearSelectionClick },
	              'Clear all selections'
	            ),
	            seatPassengers.map(function (passenger, index) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'passenger-list-flight__passenger', key: passenger.get('id'), 'data-index': index, onClick: _this2.handleSelectPassengerClick },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'passenger-list-flight__seat-icon' },
	                  _react2.default.createElement(_PassengerSeat2.default, { counter: passenger.get('counter'), paxType: passenger.get('paxType') })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'passenger-list-flight__passenger__details' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'passenger-list-flight__passenger__details__label' },
	                    passenger.get('label'),
	                    ':'
	                  ),
	                  flightSeatsSelection.has('' + passenger.get('id')) ? _react2.default.createElement(
	                    'div',
	                    { className: 'passenger-list-flight__passenger__details__reservation' },
	                    'Seat: ',
	                    flightSeatsSelection.getIn(['' + passenger.get('id'), 'row']),
	                    flightSeatsSelection.getIn(['' + passenger.get('id'), 'seat']),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'passenger-list-flight__passenger__details__reservation__price' },
	                      _react2.default.createElement(_BookPrice2.default, {
	                        price: _this2.getFlightSeatForPassenger(flightSeatsSelection.get('' + passenger.get('id'))).getIn(['flightSeatPrice', 'webPrice'])
	                      })
	                    )
	                  ) : _react2.default.createElement(
	                    'div',
	                    { className: 'passenger-list-flight__passenger__details__reservation' },
	                    'No reservation'
	                  )
	                )
	              );
	            }),
	            _react2.default.createElement(
	              _LinkButton2.default,
	              { onClick: this.handleSelectEveryoneClick, color: 'blue', type: 'secondary' },
	              'Select seats for everyone'
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return PassengerListFlight;
	}(_react.PureComponent);
	
	PassengerListFlight.defaultProps = {
	  seatPassengers: _immutable2.default.List()
	};
	exports.default = PassengerListFlight;

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PassengerListModal = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _modalActions = __webpack_require__(40);
	
	var modalActions = _interopRequireWildcard(_modalActions);
	
	var _PassengerList = __webpack_require__(494);
	
	var _PassengerList2 = _interopRequireDefault(_PassengerList);
	
	var _LinkButton = __webpack_require__(65);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _modal = __webpack_require__(167);
	
	var _SlideInFromTheSideModal = __webpack_require__(165);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    bookSeatPrice: state.bookState.getIn(['priceBreakdown', 'airlineSeatPrice'])
	  };
	};
	
	/* istanbul ignore next */
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    modalActionsBound: (0, _redux.bindActionCreators)(modalActions, dispatch)
	  };
	};
	
	var PassengerListModal = exports.PassengerListModal = function (_PureComponent) {
	  (0, _inherits3.default)(PassengerListModal, _PureComponent);
	
	  function PassengerListModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PassengerListModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PassengerListModal.__proto__ || (0, _getPrototypeOf2.default)(PassengerListModal)).call.apply(_ref, [this].concat(args))), _this), _this.openSeatList = function (direction, passengerIndex) {
	      var type = passengerIndex !== undefined ? 'passenger' : 'all';
	      var selectedPassenger = passengerIndex !== undefined ? passengerIndex : 0;
	
	      _this.props.modalActionsBound.toggleModal(_modal.AIRLINE_SEAT_LIST, {
	        slideInFromTheSide: _SlideInFromTheSideModal.SLIDE_DIRECTION_LEFT,
	        title: 'In-flight Seat Selection',
	        type: type,
	        direction: direction,
	        passengerIndex: selectedPassenger
	      });
	    }, _this.onCloseClick = function (event) {
	      event.preventDefault();
	      _this.props.modalActionsBound.toggleModal();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PassengerListModal, [{
	    key: 'render',
	    value: function render() {
	      var hasSeatsSelected = this.props.bookSeatPrice > 0;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_PassengerList2.default, { openSeatList: this.openSeatList }),
	        _react2.default.createElement(
	          'div',
	          { className: 'passenger-list-sub-page__button-wrapper' },
	          _react2.default.createElement(
	            _LinkButton2.default,
	            {
	              onClick: this.onCloseClick,
	              color: hasSeatsSelected ? undefined : 'blue',
	              type: hasSeatsSelected ? undefined : 'secondary'
	            },
	            hasSeatsSelected ? 'Done' : 'Close'
	          )
	        )
	      );
	    }
	  }]);
	  return PassengerListModal;
	}(_react.PureComponent);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PassengerListModal);

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SeatList = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(16);
	
	var _reactRedux = __webpack_require__(10);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _bookActions = __webpack_require__(143);
	
	var _SeatListRow = __webpack_require__(500);
	
	var _SeatListRow2 = _interopRequireDefault(_SeatListRow);
	
	var _flightSeats = __webpack_require__(211);
	
	var _SeatListRowHeader = __webpack_require__(501);
	
	var _SeatListRowHeader2 = _interopRequireDefault(_SeatListRowHeader);
	
	var _SeatListRowPriceHeader = __webpack_require__(502);
	
	var _SeatListRowPriceHeader2 = _interopRequireDefault(_SeatListRowPriceHeader);
	
	var _optimizely = __webpack_require__(30);
	
	__webpack_require__(877);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    flight: state.bookState.getIn(['data', 'flight', ownProps.direction]),
	    seatPassengers: state.bookState.getIn(['booking_info', 'airlineSeatPassenger'], _immutable2.default.List()),
	    selectedSeats: state.bookState.getIn(['booking_info', 'selection', 'flight_seats', ownProps.direction], _immutable2.default.Map()),
	    isMobileBreakpoint: state.appState.get('isMobileBreakpoint')
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    selectSeat: (0, _redux.bindActionCreators)(_bookActions.selectAirlineSeat, dispatch)
	  };
	};
	
	var SeatList = exports.SeatList = function (_PureComponent) {
	  (0, _inherits3.default)(SeatList, _PureComponent);
	
	  function SeatList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SeatList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SeatList.__proto__ || (0, _getPrototypeOf2.default)(SeatList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hoveredSeat: {}
	    }, _this.handleSeatClick = function (rowNumber, seatNumber) {
	      (0, _optimizely.fireEvent)('BookSeatSelectionSeat', 'clicked');
	      var _this$props = _this.props,
	          selectSeat = _this$props.selectSeat,
	          direction = _this$props.direction,
	          onSeatSelected = _this$props.onSeatSelected,
	          selectedSeats = _this$props.selectedSeats;
	
	      var passengerId = _this.getSeatPassenger().get('id');
	
	      var currentSeatForPassenger = selectedSeats.get('' + passengerId, _immutable2.default.Map());
	
	      if (currentSeatForPassenger.get('row') === rowNumber && currentSeatForPassenger.get('seat') === seatNumber) {
	        selectSeat(direction, passengerId);
	      } else {
	        selectSeat(direction, passengerId, rowNumber, seatNumber);
	        onSeatSelected();
	      }
	    }, _this.onSeatHover = function (rowNumber, seatNumber, hovered) {
	      if (hovered) {
	        _this.setState({
	          hoveredSeat: {
	            rowNumber: rowNumber,
	            seatNumber: seatNumber
	          }
	        });
	      } else {
	        _this.setState({
	          hoveredSeat: {}
	        });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SeatList, [{
	    key: 'getSeatPassenger',
	    value: function getSeatPassenger() {
	      var _props = this.props,
	          seatPassengers = _props.seatPassengers,
	          currentPassengerIndex = _props.currentPassengerIndex;
	
	      return seatPassengers.get(currentPassengerIndex);
	    }
	  }, {
	    key: 'getRowRepresentation',
	    value: function getRowRepresentation(flightRow) {
	      var representation = [];
	      var lastRepresentation = null;
	
	      flightRow.get('flightSeats').forEach(function (flightSeat) {
	        var seatAttributes = flightSeat.get('flightSeatAttributes') || _immutable2.default.List();
	        var isNotASeat = seatAttributes.includes(_flightSeats.flightSeatAttributes.ABSENT_SEAT) || seatAttributes.includes(_flightSeats.flightSeatAttributes.AISLE);
	
	        if (isNotASeat) {
	          lastRepresentation = {
	            isSeat: false,
	            count: 1
	          };
	          representation.push(lastRepresentation);
	        } else {
	          var price = flightSeat.getIn(['flightSeatPrice', 'webPrice']);
	          if (lastRepresentation === null || lastRepresentation.price !== price) {
	            lastRepresentation = {
	              isSeat: true,
	              count: 1,
	              price: price
	            };
	            representation.push(lastRepresentation);
	          } else {
	            lastRepresentation.count++;
	          }
	        }
	      });
	
	      return representation;
	    }
	  }, {
	    key: 'areRowRepresentationsIdentical',
	    value: function areRowRepresentationsIdentical(repA, repB) {
	      if (repA.length !== repB.length) {
	        return false;
	      }
	
	      return repA.every(function (itemA, index) {
	        var itemB = repB[index];
	        if (itemA.isSeat !== itemB.isSeat) {
	          return false;
	        }
	
	        return itemA.price === itemB.price && itemA.count === itemB.count;
	      });
	    }
	  }, {
	    key: 'getStyles',
	    value: function getStyles() {
	      var _props2 = this.props,
	          flight = _props2.flight,
	          isMobileBreakpoint = _props2.isMobileBreakpoint;
	
	
	      var MAX_SEAT_WIDTH = 56;
	      var styles = {};
	      if (!isMobileBreakpoint) {
	        styles.maxWidth = flight.getIn(['flightSeatMap', 'flightRows', '0', 'flightSeats']).size * MAX_SEAT_WIDTH;
	      }
	
	      return styles;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          flight = _props3.flight,
	          direction = _props3.direction;
	      var hoveredSeat = this.state.hoveredSeat;
	
	      var seatPassenger = this.getSeatPassenger();
	      var lastRowRepresentation = null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'seat-list', style: this.getStyles() },
	        _react2.default.createElement(
	          'div',
	          { className: 'seat-list__rows' },
	          _react2.default.createElement(_SeatListRowHeader2.default, { flightRow: flight.getIn(['flightSeatMap', 'flightRows', '0']) }),
	          flight.getIn(['flightSeatMap', 'flightRows']).map(function (flightRow) {
	            var currentRowRepresentation = _this2.getRowRepresentation(flightRow);
	            var rowHoveredSeat = hoveredSeat.rowNumber === flightRow.get('rowNumber') ? hoveredSeat.seatNumber : undefined;
	            var seatListRowPriceHeader = void 0;
	
	            if (lastRowRepresentation === null || !_this2.areRowRepresentationsIdentical(currentRowRepresentation, lastRowRepresentation)) {
	              lastRowRepresentation = currentRowRepresentation;
	              seatListRowPriceHeader = _react2.default.createElement(_SeatListRowPriceHeader2.default, {
	                rowRepresentation: currentRowRepresentation,
	                rowWidth: flightRow.get('flightSeats').size
	              });
	            }
	
	            return _react2.default.createElement(
	              'div',
	              { key: flightRow.get('rowNumber') },
	              seatListRowPriceHeader,
	              _react2.default.createElement(_SeatListRow2.default, {
	                direction: direction,
	                flightRow: flightRow,
	                onSeatClicked: _this2.handleSeatClick,
	                paxType: seatPassenger.get('paxType'),
	                onHover: _this2.onSeatHover,
	                hoveredSeat: rowHoveredSeat
	              })
	            );
	          })
	        )
	      );
	    }
	  }]);
	  return SeatList;
	}(_react.PureComponent);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SeatList);

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SeatListModal = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _modalActions = __webpack_require__(40);
	
	var modalActions = _interopRequireWildcard(_modalActions);
	
	var _modal = __webpack_require__(167);
	
	var _SlideInFromTheSideModal = __webpack_require__(165);
	
	var _SeatList = __webpack_require__(497);
	
	var _SeatList2 = _interopRequireDefault(_SeatList);
	
	var _SeatListNavigationHeader = __webpack_require__(499);
	
	var _SeatListNavigationHeader2 = _interopRequireDefault(_SeatListNavigationHeader);
	
	__webpack_require__(878);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    seatPassengers: state.bookState.getIn(['booking_info', 'airlineSeatPassenger'], _immutable2.default.List())
	  };
	};
	
	/* istanbul ignore next */
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    modalActionsBound: (0, _redux.bindActionCreators)(modalActions, dispatch)
	  };
	};
	
	var SeatListModal = exports.SeatListModal = function (_PureComponent) {
	  (0, _inherits3.default)(SeatListModal, _PureComponent);
	
	  function SeatListModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SeatListModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SeatListModal.__proto__ || (0, _getPrototypeOf2.default)(SeatListModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hasSeatBeenSelected: false
	    }, _this.selectPrevious = function () {
	      var passengerIndex = _this.props.passengerIndex;
	
	
	      if (passengerIndex > 0) {
	        _this.goToPassenger(passengerIndex - 1);
	      }
	    }, _this.onSeatSelected = function () {
	      var _this$props = _this.props,
	          passengerIndex = _this$props.passengerIndex,
	          seatPassengers = _this$props.seatPassengers,
	          type = _this$props.type;
	
	      if (type === 'all' && passengerIndex < seatPassengers.size - 1) {
	        _this.goToNextPage();
	      } else {
	        _this.setState({
	          hasSeatBeenSelected: true
	        });
	      }
	    }, _this.goToNextPage = function () {
	      var _this$props2 = _this.props,
	          passengerIndex = _this$props2.passengerIndex,
	          seatPassengers = _this$props2.seatPassengers,
	          type = _this$props2.type;
	
	      if (type === 'all' && passengerIndex < seatPassengers.size - 1) {
	        _this.goToPassenger(passengerIndex + 1);
	      } else {
	        _this.props.modalActionsBound.toggleModal(_modal.AIRLINE_PASSENGER_LIST, {
	          slideInFromTheSide: _SlideInFromTheSideModal.SLIDE_DIRECTION_LEFT,
	          title: 'In-flight Seat Selection'
	        });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SeatListModal, [{
	    key: 'getSeatPassenger',
	    value: function getSeatPassenger() {
	      var _props = this.props,
	          seatPassengers = _props.seatPassengers,
	          passengerIndex = _props.passengerIndex;
	
	      return seatPassengers.get(passengerIndex);
	    }
	  }, {
	    key: 'goToPassenger',
	    value: function goToPassenger(passengerIndex) {
	      var _props2 = this.props,
	          modalActionsBound = _props2.modalActionsBound,
	          type = _props2.type,
	          direction = _props2.direction;
	
	
	      modalActionsBound.toggleModal(_modal.AIRLINE_SEAT_LIST, {
	        slideInFromTheSide: _SlideInFromTheSideModal.SLIDE_DIRECTION_LEFT,
	        title: 'In-flight Seat Selection',
	        type: type,
	        direction: direction,
	        passengerIndex: passengerIndex
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          seatPassengers = _props3.seatPassengers,
	          direction = _props3.direction,
	          passengerIndex = _props3.passengerIndex,
	          type = _props3.type;
	      var hasSeatBeenSelected = this.state.hasSeatBeenSelected;
	
	
	      var seatPassenger = this.getSeatPassenger();
	      var selectPrevious = type === 'all' && passengerIndex > 0 ? this.selectPrevious : undefined;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'seat-list-modal' },
	        _react2.default.createElement(_SeatListNavigationHeader2.default, {
	          counter: seatPassenger.get('counter'),
	          paxType: seatPassenger.get('paxType'),
	          label: seatPassenger.get('label'),
	          direction: direction,
	          selectNext: this.goToNextPage,
	          selectPrevious: selectPrevious,
	          showDoneButton: hasSeatBeenSelected
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'seat-list-modal__seats' },
	          _react2.default.createElement(_SeatList2.default, {
	            direction: direction,
	            seatPassengers: seatPassengers,
	            currentPassengerIndex: passengerIndex,
	            onSeatSelected: this.onSeatSelected
	          })
	        )
	      );
	    }
	  }]);
	  return SeatListModal;
	}(_react.PureComponent);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SeatListModal);

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PassengerSeat = __webpack_require__(206);
	
	var _PassengerSeat2 = _interopRequireDefault(_PassengerSeat);
	
	var _LinkButton = __webpack_require__(65);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	__webpack_require__(879);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SeatListNavigationHeader = function (_PureComponent) {
	  (0, _inherits3.default)(SeatListNavigationHeader, _PureComponent);
	
	  function SeatListNavigationHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SeatListNavigationHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SeatListNavigationHeader.__proto__ || (0, _getPrototypeOf2.default)(SeatListNavigationHeader)).call.apply(_ref, [this].concat(args))), _this), _this.handlePreviousClick = function (event) {
	      var selectPrevious = _this.props.selectPrevious;
	
	
	      event.preventDefault();
	      if (selectPrevious) {
	        selectPrevious();
	      }
	    }, _this.handleNextClick = function (event) {
	      var selectNext = _this.props.selectNext;
	
	
	      event.preventDefault();
	      if (selectNext) {
	        selectNext();
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SeatListNavigationHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          counter = _props.counter,
	          paxType = _props.paxType,
	          label = _props.label,
	          direction = _props.direction,
	          selectPrevious = _props.selectPrevious,
	          selectNext = _props.selectNext,
	          showDoneButton = _props.showDoneButton;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'seat-list-navigation-header' },
	        _react2.default.createElement('div', { onClick: this.handlePreviousClick, className: 'seat-list-navigation-header__button seat-list-navigation-header__button--' + (selectPrevious ? 'enabled' : 'disabled') + ' seat-list-navigation-header__button--previous' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'seat-list-navigation-header__icon' },
	          _react2.default.createElement(_PassengerSeat2.default, { counter: counter, paxType: paxType })
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'seat-list-navigation-header__text' },
	          'Select ',
	          _react2.default.createElement(
	            'span',
	            { className: 'seat-list-navigation-header__text--shout' },
	            direction
	          ),
	          ' seat for ',
	          _react2.default.createElement(
	            'span',
	            { className: 'seat-list-navigation-header__text--shout' },
	            label
	          ),
	          ':'
	        ),
	        showDoneButton ? _react2.default.createElement(
	          'div',
	          { className: 'seat-list-navigation-header__button seat-list-navigation-header__button--done' },
	          _react2.default.createElement(
	            _LinkButton2.default,
	            { onClick: this.handleNextClick },
	            'Done'
	          )
	        ) : _react2.default.createElement('div', { onClick: this.handleNextClick, className: 'seat-list-navigation-header__button seat-list-navigation-header__button--' + (selectNext ? 'enabled' : 'disabled') + ' seat-list-navigation-header__button--next' })
	      );
	    }
	  }]);
	  return SeatListNavigationHeader;
	}(_react.PureComponent);
	
	SeatListNavigationHeader.defaultProps = {
	  selectNext: undefined,
	  selectPrevious: undefined
	};
	exports.default = SeatListNavigationHeader;

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _SeatListSeat = __webpack_require__(503);
	
	var _SeatListSeat2 = _interopRequireDefault(_SeatListSeat);
	
	__webpack_require__(880);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SeatListRow = function (_PureComponent) {
	  (0, _inherits3.default)(SeatListRow, _PureComponent);
	
	  function SeatListRow() {
	    (0, _classCallCheck3.default)(this, SeatListRow);
	    return (0, _possibleConstructorReturn3.default)(this, (SeatListRow.__proto__ || (0, _getPrototypeOf2.default)(SeatListRow)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SeatListRow, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          flightRow = _props.flightRow,
	          onSeatClicked = _props.onSeatClicked,
	          direction = _props.direction,
	          paxType = _props.paxType,
	          onHover = _props.onHover,
	          hoveredSeat = _props.hoveredSeat;
	
	      var numberOfSeats = flightRow.get('flightSeats').size;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'seat-list-row seat-list-row--size-' + numberOfSeats },
	        flightRow.get('flightSeats').map(function (seat, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: seat.get('seatNumber') || index, className: 'seat-list-row__seat' },
	            _react2.default.createElement(_SeatListSeat2.default, {
	              onClick: onSeatClicked,
	              flightSeat: seat,
	              rowNumber: flightRow.get('rowNumber'),
	              direction: direction,
	              paxType: paxType,
	              onHover: onHover,
	              isHovered: hoveredSeat === seat.get('seatNumber')
	            })
	          );
	        })
	      );
	    }
	  }]);
	  return SeatListRow;
	}(_react.PureComponent);
	
	SeatListRow.defaultProps = {
	  hoveredSeat: undefined
	};
	exports.default = SeatListRow;

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	__webpack_require__(881);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SeatListRowHeader = function (_PureComponent) {
	  (0, _inherits3.default)(SeatListRowHeader, _PureComponent);
	
	  function SeatListRowHeader() {
	    (0, _classCallCheck3.default)(this, SeatListRowHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (SeatListRowHeader.__proto__ || (0, _getPrototypeOf2.default)(SeatListRowHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SeatListRowHeader, [{
	    key: 'render',
	    value: function render() {
	      var flightRow = this.props.flightRow;
	
	      var numberOfSeats = flightRow.get('flightSeats').size;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'seat-list-row-header seat-list-row-header--size-' + numberOfSeats },
	        flightRow.get('flightSeats').map(function (seat, index) {
	          return _react2.default.createElement(
	            'div',
	            { key: index, className: 'seat-list-row-header__seat' },
	            seat.get('seatNumber')
	          );
	        })
	      );
	    }
	  }]);
	  return SeatListRowHeader;
	}(_react.PureComponent);
	
	exports.default = SeatListRowHeader;

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BookPrice = __webpack_require__(139);
	
	var _BookPrice2 = _interopRequireDefault(_BookPrice);
	
	__webpack_require__(882);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SeatListRowPriceHeader = function (_PureComponent) {
	  (0, _inherits3.default)(SeatListRowPriceHeader, _PureComponent);
	
	  function SeatListRowPriceHeader() {
	    (0, _classCallCheck3.default)(this, SeatListRowPriceHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (SeatListRowPriceHeader.__proto__ || (0, _getPrototypeOf2.default)(SeatListRowPriceHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SeatListRowPriceHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          rowRepresentation = _props.rowRepresentation,
	          rowWidth = _props.rowWidth;
	
	
	      return _react2.default.createElement(
	        'p',
	        { className: 'seat-list-row-price-header' },
	        rowRepresentation.map(function (item, index) {
	          var style = {
	            width: 100 / rowWidth * item.count + '%'
	          };
	
	          return _react2.default.createElement(
	            'span',
	            { key: index, style: style, className: 'seat-list-row-price-header__item-wrapper' },
	            _react2.default.createElement(
	              'span',
	              { className: 'seat-list-row-price-header__item seat-list-row-price-header__item--' + (item.isSeat ? 'seat' : 'aisle') },
	              typeof item.price === 'number' && _react2.default.createElement(_BookPrice2.default, { price: item.price, isRounded: true })
	            )
	          );
	        })
	      );
	    }
	  }]);
	  return SeatListRowPriceHeader;
	}(_react.PureComponent);
	
	exports.default = SeatListRowPriceHeader;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SeatListSeat = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _PassengerSeat = __webpack_require__(206);
	
	var _PassengerSeat2 = _interopRequireDefault(_PassengerSeat);
	
	var _PopoverTriggerLayout = __webpack_require__(315);
	
	var _PopoverTriggerLayout2 = _interopRequireDefault(_PopoverTriggerLayout);
	
	var _flightSeats = __webpack_require__(211);
	
	var _AirlineSeat = __webpack_require__(493);
	
	var _AirlineSeat2 = _interopRequireDefault(_AirlineSeat);
	
	__webpack_require__(883);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    selectedSeats: state.bookState.getIn(['booking_info', 'selection', 'flight_seats', ownProps.direction], _immutable2.default.Map()),
	    passengers: state.bookState.getIn(['booking_info', 'airlineSeatPassenger'])
	  };
	};
	
	var SeatListSeat = exports.SeatListSeat = function (_PureComponent) {
	  (0, _inherits3.default)(SeatListSeat, _PureComponent);
	
	  function SeatListSeat() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SeatListSeat);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SeatListSeat.__proto__ || (0, _getPrototypeOf2.default)(SeatListSeat)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      popoverData: undefined,
	      isForbidden: false
	    }, _this.forbiddenChildPopoverContent = {
	      id: 'seat-list-seat__forbidden-child',
	      body: 'Sorry, Children can\'t sit here'
	    }, _this.forbiddenInfantPopoverContent = {
	      id: 'seat-list-seat__forbidden-infant',
	      body: 'This seat is not suitable for an adult carrying an infant'
	    }, _this.exitRowPopoverContent = {
	      id: 'seat-list-seat__exit-row',
	      body: 'You must be over 16 years of age and have no mobility impairments to sit in this seat'
	    }, _this.unavailableSeatPopoverContent = {
	      id: 'seat-list-seat__occupied',
	      body: 'This seat is already taken'
	    }, _this.handleSeatClick = function (event) {
	      event.preventDefault();
	
	      var _this$props = _this.props,
	          rowNumber = _this$props.rowNumber,
	          flightSeat = _this$props.flightSeat,
	          onClick = _this$props.onClick;
	      var isForbidden = _this.state.isForbidden;
	
	
	      if (!isForbidden) {
	        onClick(rowNumber, flightSeat.get('seatNumber'));
	      }
	    }, _this.handleMouseEnter = function () {
	      var _this$props2 = _this.props,
	          rowNumber = _this$props2.rowNumber,
	          flightSeat = _this$props2.flightSeat,
	          onHover = _this$props2.onHover;
	
	      onHover(rowNumber, flightSeat.get('seatNumber'), true);
	    }, _this.handleMouseLeave = function () {
	      var _this$props3 = _this.props,
	          rowNumber = _this$props3.rowNumber,
	          flightSeat = _this$props3.flightSeat,
	          onHover = _this$props3.onHover;
	
	      onHover(rowNumber, flightSeat.get('seatNumber'), false);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SeatListSeat, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          flightSeat = _props.flightSeat,
	          paxType = _props.paxType;
	
	      this.updateSeatState(flightSeat, paxType);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      var flightSeat = newProps.flightSeat,
	          paxType = newProps.paxType;
	
	      this.updateSeatState(flightSeat, paxType);
	    }
	  }, {
	    key: 'updateSeatState',
	    value: function updateSeatState(flightSeat, paxType) {
	      var seatAttributes = flightSeat.get('flightSeatAttributes') || _immutable2.default.List();
	      var popoverData = void 0;
	      var isForbidden = false;
	
	      var isSeatReallyASeat = !_flightSeats.nonSeatAttributes.some(function (nonSeatAttribute) {
	        return seatAttributes.includes(nonSeatAttribute);
	      });
	      var isSeatForbiddenBecauseInfant = paxType === 'adultWithInfant' && !seatAttributes.includes(_flightSeats.flightSeatAttributes.INFANTS_ALLOWED);
	      var isSeatForbiddenBecauseChild = paxType === 'child' && !seatAttributes.includes(_flightSeats.flightSeatAttributes.CHILDREN_ALLOWED);
	
	      if (isSeatReallyASeat) {
	        if (!flightSeat.get('available')) {
	          popoverData = this.unavailableSeatPopoverContent;
	          isForbidden = true;
	        } else if (isSeatForbiddenBecauseChild) {
	          popoverData = this.forbiddenChildPopoverContent;
	          isForbidden = true;
	        } else if (isSeatForbiddenBecauseInfant) {
	          popoverData = this.forbiddenInfantPopoverContent;
	          isForbidden = true;
	        } else if (seatAttributes.includes(_flightSeats.flightSeatAttributes.EXIT_ROW)) {
	          popoverData = this.exitRowPopoverContent;
	        }
	      } else {
	        isForbidden = true;
	      }
	
	      this.setState({
	        popoverData: popoverData,
	        isForbidden: isForbidden
	      });
	    }
	  }, {
	    key: 'getPassenger',
	    value: function getPassenger() {
	      var _props2 = this.props,
	          selectedSeats = _props2.selectedSeats,
	          passengers = _props2.passengers,
	          rowNumber = _props2.rowNumber,
	          flightSeat = _props2.flightSeat,
	          isHovered = _props2.isHovered;
	      var isForbidden = this.state.isForbidden;
	
	
	      var seatPassenger = void 0;
	
	      if (isHovered && !isForbidden) {
	        seatPassenger = _immutable2.default.fromJS({
	          paxType: this.props.paxType
	        });
	      } else {
	        var passengerId = selectedSeats.findKey(function (seat) {
	          return seat.get('row') === rowNumber && seat.get('seat') === flightSeat.get('seatNumber');
	        });
	        if (passengerId !== undefined) {
	          seatPassenger = passengers.find(function (passenger) {
	            return '' + passenger.get('id') === passengerId;
	          });
	        }
	      }
	
	      return seatPassenger;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          flightSeat = _props3.flightSeat,
	          paxType = _props3.paxType,
	          rowNumber = _props3.rowNumber,
	          isHovered = _props3.isHovered;
	      var _state = this.state,
	          popoverData = _state.popoverData,
	          isForbidden = _state.isForbidden;
	
	      var passenger = this.getPassenger();
	
	      var airlineSeat = passenger ? _react2.default.createElement(_PassengerSeat2.default, {
	        counter: passenger.get('counter'),
	        paxType: passenger.get('paxType'),
	        hover: isHovered
	      }) : _react2.default.createElement(_AirlineSeat2.default, {
	        flightSeat: flightSeat,
	        rowNumber: rowNumber,
	        paxType: paxType
	      });
	
	      if (popoverData) {
	        airlineSeat = _react2.default.createElement(
	          _PopoverTriggerLayout2.default,
	          {
	            extraClass: 'seat-list-seat__popover-trigger',
	            content: popoverData,
	            position: 'auto'
	          },
	          airlineSeat
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onClick: this.handleSeatClick,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          tabIndex: isForbidden ? undefined : 0
	        },
	        airlineSeat
	      );
	    }
	  }]);
	  return SeatListSeat;
	}(_react.PureComponent);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SeatListSeat);

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	__webpack_require__(884);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AssistedBookingStatus = function (_Component) {
	  (0, _inherits3.default)(AssistedBookingStatus, _Component);
	
	  function AssistedBookingStatus() {
	    (0, _classCallCheck3.default)(this, AssistedBookingStatus);
	    return (0, _possibleConstructorReturn3.default)(this, (AssistedBookingStatus.__proto__ || (0, _getPrototypeOf2.default)(AssistedBookingStatus)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AssistedBookingStatus, [{
	    key: 'render',
	    value: function render() {
	      var bookingComponentStatuses = this.props.bookingComponentStatuses;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'assisted-booking-status__row assisted-booking-status__row--header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'assisted-booking-status__row__component assisted-booking-status__row--header' },
	            'Component'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'assisted-booking-status__row__supplier assisted-booking-status__row--header' },
	            'Supplier'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'assisted-booking-status__row__status assisted-booking-status__row--header' },
	            'Status'
	          )
	        ),
	        bookingComponentStatuses.map(function (componentStatus) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'assisted-booking-status__row', key: componentStatus.get('component') + '-' + componentStatus.get('supplier') },
	            _react2.default.createElement(
	              'div',
	              { className: 'assisted-booking-status__row__component' },
	              componentStatus.get('component')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'assisted-booking-status__row__supplier' },
	              componentStatus.get('supplier')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'assisted-booking-status__row__status' },
	              componentStatus.get('status')
	            )
	          );
	        })
	      );
	    }
	  }]);
	  return AssistedBookingStatus;
	}(_react.Component);
	
	exports.default = AssistedBookingStatus;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _LinkButton = __webpack_require__(65);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _AssistedBookingStatus = __webpack_require__(504);
	
	var _AssistedBookingStatus2 = _interopRequireDefault(_AssistedBookingStatus);
	
	__webpack_require__(885);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AssistedBookingStatusModal = function (_Component) {
	  (0, _inherits3.default)(AssistedBookingStatusModal, _Component);
	
	  function AssistedBookingStatusModal() {
	    (0, _classCallCheck3.default)(this, AssistedBookingStatusModal);
	    return (0, _possibleConstructorReturn3.default)(this, (AssistedBookingStatusModal.__proto__ || (0, _getPrototypeOf2.default)(AssistedBookingStatusModal)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AssistedBookingStatusModal, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bookingComponentStatuses = _props.bookingComponentStatuses,
	          backUrl = _props.backUrl,
	          onClose = _props.onClose,
	          onBack = _props.onBack;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'assisted-booking-status-modal' },
	        _react2.default.createElement(
	          'div',
	          { className: 'assisted-booking-status-modal__title' },
	          'Assisted Components'
	        ),
	        _react2.default.createElement(_AssistedBookingStatus2.default, { bookingComponentStatuses: bookingComponentStatuses }),
	        _react2.default.createElement(
	          'div',
	          { className: 'assisted-booking-status-modal__info' },
	          'Please make sure you can source the assisted component(s) before continuing with the booking'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'assisted-booking-status-modal__navigation' },
	          _react2.default.createElement(
	            'div',
	            { className: 'assisted-booking-status-modal__navigation__back' },
	            _react2.default.createElement(
	              _LinkButton2.default,
	              {
	                color: 'blue',
	                type: 'secondary',
	                onClick: onBack,
	                to: backUrl,
	                isExternal: true
	              },
	              'Back to search'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'assisted-booking-status-modal__navigation__continue' },
	            _react2.default.createElement(
	              _LinkButton2.default,
	              { onClick: onClose },
	              'Continue'
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return AssistedBookingStatusModal;
	}(_react.Component);
	
	exports.default = AssistedBookingStatusModal;

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(87);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(117);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(886);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultOptionRenderer = function DefaultOption(option) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    option.label
	  );
	};
	
	var defaultTagRenderer = function defaultTagRenderer(option) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    option.label
	  );
	};
	
	var Autocomplete = function (_Component) {
	  (0, _inherits3.default)(Autocomplete, _Component);
	
	  function Autocomplete() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Autocomplete);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Autocomplete.__proto__ || (0, _getPrototypeOf2.default)(Autocomplete)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isOpen: false,
	      focusedOptionIndex: 0,
	      query: ''
	    }, _this.lastMousePos = {
	      x: -1,
	      y: -1
	    }, _this.isOptionVisible = function (option) {
	      var query = _this.state.query;
	
	
	      return query === '' || option.label.toLowerCase().indexOf(query.toLowerCase()) !== -1;
	    }, _this.handleInputBlur = function () {
	      _this.setState({
	        isOpen: false
	      });
	    }, _this.onOptionMouseEnter = function (event) {
	      var option = event.currentTarget;
	      var index = Number(option.dataset.index);
	      var _this$lastMousePos = _this.lastMousePos,
	          x = _this$lastMousePos.x,
	          y = _this$lastMousePos.y;
	
	
	      if (x !== event.screenX || y !== event.screenY) {
	        _this.lastMousePos = {
	          x: event.screenX,
	          y: event.screenY
	        };
	
	        _this.setState({
	          focusedOptionIndex: index
	        });
	      }
	    }, _this.onInputKeyDown = function (event) {
	      var isOpen = _this.state.isOpen;
	
	
	      var arrowUpKeyCode = 38;
	      var arrowDownKeyCode = 40;
	      var enterKeyCode = 13;
	      var tabKeyCode = 9;
	      var backspaceKeyCode = 8;
	      var escapeKeyCode = 27;
	
	      if (event.keyCode === arrowUpKeyCode && isOpen) {
	        event.preventDefault();
	        _this.focusPreviousOption();
	      } else if (event.keyCode === arrowDownKeyCode) {
	        event.preventDefault();
	        if (isOpen) {
	          _this.focusNextOption();
	        } else {
	          _this.setState({
	            isOpen: true,
	            focusedOptionIndex: 0
	          });
	        }
	      } else if (isOpen && event.keyCode === tabKeyCode) {
	        _this.selectCurrentFocusedOption();
	      } else if (event.keyCode === enterKeyCode) {
	        if (isOpen) {
	          _this.selectCurrentFocusedOption();
	        } else {
	          _this.setState({
	            isOpen: true,
	            focusedOptionIndex: 0
	          });
	        }
	      } else if (event.keyCode === backspaceKeyCode && _this.state.query === '') {
	        event.preventDefault();
	
	        if (isOpen) {
	          _this.setState({
	            isOpen: false
	          });
	        } else {
	          var lastSelectedOption = [].concat((0, _toConsumableArray3.default)(_this.props.options)).reverse().find(function (option) {
	            return option.checked;
	          });
	          if (lastSelectedOption) {
	            _this.deselectOption(lastSelectedOption);
	          }
	        }
	      } else if (event.keyCode === escapeKeyCode && isOpen) {
	        event.preventDefault();
	        _this.setState({
	          isOpen: false
	        });
	      }
	    }, _this.onInputChange = function (event) {
	      var selectElement = event.currentTarget;
	      _this.setState({
	        query: selectElement.value,
	        focusedOptionIndex: 0,
	        isOpen: true
	      });
	    }, _this.onInputClick = function (event) {
	      event.preventDefault();
	
	      if (!_this.state.isOpen) {
	        _this.setState({
	          isOpen: true,
	          focusedOptionIndex: 0
	        });
	        _this.inputRef.focus();
	      } else {
	        _this.setState({
	          isOpen: false
	        });
	      }
	    }, _this.onOptionClick = function (event) {
	      var options = _this.props.options;
	
	      event.preventDefault();
	
	      var optionElement = event.currentTarget;
	      var index = Number(optionElement.dataset.index);
	      _this.selectOption(options[index]);
	    }, _this.saveInputRef = function (ref) {
	      return _this.inputRef = ref;
	    }, _this.saveOptionListRef = function (ref) {
	      return _this.optionListRef = ref;
	    }, _this.saveFocusedOptionRef = function (ref) {
	      return _this.focusedOptionRef = ref;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Autocomplete, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.focusedOptionRef && this.optionListRef) {
	        var focusedDOM = _reactDom2.default.findDOMNode(this.focusedOptionRef);
	        var menuDOM = _reactDom2.default.findDOMNode(this.optionListRef);
	        var focusedRect = focusedDOM.getBoundingClientRect();
	        var menuRect = menuDOM.getBoundingClientRect();
	        if (focusedRect.bottom > menuRect.bottom) {
	          menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
	        } else if (focusedRect.top < menuRect.top) {
	          menuDOM.scrollTop = focusedDOM.offsetTop;
	        }
	      }
	    }
	  }, {
	    key: 'getVisibleOptions',
	    value: function getVisibleOptions() {
	      var options = this.props.options;
	
	      return options.filter(this.isOptionVisible);
	    }
	  }, {
	    key: 'focusPreviousOption',
	    value: function focusPreviousOption() {
	      var focusedOptionIndex = this.state.focusedOptionIndex;
	
	      var visibleOptions = this.getVisibleOptions();
	      var previousVisibleOption = function previousVisibleOption(option, index) {
	        return index >= visibleOptions.length - focusedOptionIndex && !option.unavailable;
	      };
	      var newIndex = [].concat((0, _toConsumableArray3.default)(visibleOptions)).reverse().findIndex(previousVisibleOption);
	
	      if (newIndex !== -1) {
	        this.setState({
	          focusedOptionIndex: visibleOptions.length - newIndex - 1
	        });
	      }
	    }
	  }, {
	    key: 'focusNextOption',
	    value: function focusNextOption() {
	      var focusedOptionIndex = this.state.focusedOptionIndex;
	
	      var visibleOptions = this.getVisibleOptions();
	      var newIndex = visibleOptions.findIndex(function (option, index) {
	        return index > focusedOptionIndex && !option.unavailable;
	      });
	
	      if (newIndex !== -1) {
	        this.setState({
	          focusedOptionIndex: newIndex
	        });
	      }
	    }
	  }, {
	    key: 'selectCurrentFocusedOption',
	    value: function selectCurrentFocusedOption() {
	      var visibleOptions = this.getVisibleOptions();
	      this.selectOption(visibleOptions[this.state.focusedOptionIndex]);
	    }
	  }, {
	    key: 'selectOption',
	    value: function selectOption(option) {
	      if (!option.unavailable) {
	        var onOptionSelect = this.props.onOptionSelect;
	
	        onOptionSelect(option);
	        this.inputRef.value = '';
	        this.setState({
	          query: '',
	          isOpen: false
	        });
	      }
	    }
	  }, {
	    key: 'deselectOption',
	    value: function deselectOption(option) {
	      var onOptionDeselect = this.props.onOptionDeselect;
	
	      onOptionDeselect(option);
	    }
	  }, {
	    key: 'renderOptions',
	    value: function renderOptions() {
	      var _this2 = this;
	
	      var _props = this.props,
	          options = _props.options,
	          optionRenderer = _props.optionRenderer;
	      var _state = this.state,
	          focusedOptionIndex = _state.focusedOptionIndex,
	          query = _state.query;
	
	      var visibleIndex = -1;
	
	      return options.map(function (option, index) {
	        var showOption = _this2.isOptionVisible(option);
	
	        if (showOption) {
	          visibleIndex++;
	        }
	
	        var isFocused = visibleIndex === focusedOptionIndex;
	        var ref = isFocused ? _this2.saveFocusedOptionRef : undefined;
	
	        return showOption && _react2.default.createElement(
	          'li',
	          {
	            key: option.value,
	            'data-index': '' + index,
	            onMouseMove: _this2.onOptionMouseEnter,
	            onMouseDown: _this2.onOptionClick,
	            ref: ref,
	            className: 'autocomplete__option-wrapper'
	          },
	          optionRenderer(option, isFocused, query)
	        );
	      }).filter(function (e) {
	        return e;
	      });
	    }
	  }, {
	    key: 'renderTags',
	    value: function renderTags() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          options = _props2.options,
	          tagRenderer = _props2.tagRenderer;
	
	      var tagElements = [];
	
	      options.forEach(function (option) {
	        if (option.checked) {
	          var removeFunc = function removeFunc() {
	            _this3.deselectOption(option);
	          };
	          tagElements.push(_react2.default.createElement(
	            'li',
	            { className: 'autocomplete__tag-wrapper', key: option.value },
	            tagRenderer(option, removeFunc)
	          ));
	        }
	      });
	
	      return tagElements;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          optionsHeight = _props3.optionsHeight,
	          noResultsMessage = _props3.noResultsMessage,
	          placeholder = _props3.placeholder;
	      var isOpen = this.state.isOpen;
	
	      var optionsStyle = {
	        maxHeight: optionsHeight + 'px'
	      };
	
	      var optionElements = this.renderOptions();
	      var tagElements = this.renderTags();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'autocomplete' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'autocomplete__tag-list' },
	          tagElements
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'autocomplete__input-container autocomplete__input-container--' + (tagElements.length === 0 ? 'no-results' : 'with-results') },
	          _react2.default.createElement('input', {
	            className: 'autocomplete__input',
	            ref: this.saveInputRef,
	            onBlur: this.handleInputBlur,
	            onKeyDown: this.onInputKeyDown,
	            onChange: this.onInputChange,
	            onMouseDown: this.onInputClick,
	            placeholder: placeholder
	          })
	        ),
	        isOpen && _react2.default.createElement(
	          'ul',
	          { className: 'autocomplete__option-list', style: optionsStyle, ref: this.saveOptionListRef },
	          optionElements.length ? optionElements : _react2.default.createElement(
	            'li',
	            { className: 'autocomplete__option-list__no-results' },
	            noResultsMessage
	          )
	        )
	      );
	    }
	  }]);
	  return Autocomplete;
	}(_react.Component);
	
	Autocomplete.defaultProps = {
	  options: [],
	  optionsHeight: 200,
	  optionRenderer: defaultOptionRenderer,
	  tagRenderer: defaultTagRenderer,
	  noResultsMessage: 'No matches found',
	  placeholder: 'Search...'
	};
	exports.default = Autocomplete;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(887);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AutocompleteCheckboxOption = function (_Component) {
	  (0, _inherits3.default)(AutocompleteCheckboxOption, _Component);
	
	  function AutocompleteCheckboxOption() {
	    (0, _classCallCheck3.default)(this, AutocompleteCheckboxOption);
	    return (0, _possibleConstructorReturn3.default)(this, (AutocompleteCheckboxOption.__proto__ || (0, _getPrototypeOf2.default)(AutocompleteCheckboxOption)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AutocompleteCheckboxOption, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checked = _props.checked,
	          focused = _props.focused,
	          unavailable = _props.unavailable,
	          children = _props.children;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'autocomplete-checkbox-option ' + (checked ? 'autocomplete-checkbox-option--checked' : '') + ' ' + (unavailable ? 'autocomplete-checkbox-option--unavailable' : '') + ' ' + (focused ? 'autocomplete-checkbox-option--focused' : '') },
	        _react2.default.createElement('input', { className: 'autocomplete-checkbox-option__checkbox', type: 'checkbox', checked: checked, readOnly: true, disabled: unavailable }),
	        children
	      );
	    }
	  }]);
	  return AutocompleteCheckboxOption;
	}(_react.Component);
	
	exports.default = AutocompleteCheckboxOption;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(327);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(888);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AutocompleteQueryTextHighlightOption = function (_Component) {
	  (0, _inherits3.default)(AutocompleteQueryTextHighlightOption, _Component);
	
	  function AutocompleteQueryTextHighlightOption() {
	    (0, _classCallCheck3.default)(this, AutocompleteQueryTextHighlightOption);
	    return (0, _possibleConstructorReturn3.default)(this, (AutocompleteQueryTextHighlightOption.__proto__ || (0, _getPrototypeOf2.default)(AutocompleteQueryTextHighlightOption)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AutocompleteQueryTextHighlightOption, [{
	    key: 'getParts',
	    value: function getParts() {
	      var _props = this.props,
	          label = _props.label,
	          query = _props.query;
	
	
	      var parts = [];
	      var queryIndex = label.toLowerCase().indexOf(query.toLowerCase());
	
	      if (query !== '' && queryIndex !== -1) {
	        parts.push(label.substring(0, queryIndex));
	        parts.push(label.substring(queryIndex, queryIndex + query.length));
	        parts.push(label.substring(queryIndex + query.length));
	      } else {
	        parts.push(label);
	        parts.push('');
	        parts.push('');
	      }
	
	      return parts;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _getParts = this.getParts(),
	          _getParts2 = (0, _slicedToArray3.default)(_getParts, 3),
	          preMatch = _getParts2[0],
	          match = _getParts2[1],
	          postMatch = _getParts2[2];
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: 'autocomplete-query-text-highlight-option__pre-match' },
	          preMatch
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'autocomplete-query-text-highlight-option__query-match' },
	          match
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'autocomplete-query-text-highlight-option__post-match' },
	          postMatch
	        )
	      );
	    }
	  }]);
	  return AutocompleteQueryTextHighlightOption;
	}(_react.Component);
	
	AutocompleteQueryTextHighlightOption.defaultProps = {
	  query: '',
	  label: ''
	};
	exports.default = AutocompleteQueryTextHighlightOption;

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(56);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(8);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	__webpack_require__(889);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BookCheckbox = function (_Component) {
	  (0, _inherits3.default)(BookCheckbox, _Component);
	
	  function BookCheckbox() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, BookCheckbox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BookCheckbox.__proto__ || (0, _getPrototypeOf2.default)(BookCheckbox)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(BookCheckbox, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          placeholder = _props.placeholder,
	          onFieldChange = _props.onFieldChange,
	          isValid = _props.isValid,
	          message = _props.message,
	          data = _props.data,
	          checked = _props.checked;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'book-checkbox ' + (checked ? 'book-checkbox--checked' : '') + ' ' + (isValid === false ? 'book-checkbox--invalid' : '') + ' ' + (isValid ? 'book-checkbox--valid' : '') },
	        _react2.default.createElement(
	          'label',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'book-checkbox__input-wrap' },
	            _react2.default.createElement('input', (0, _extends3.default)({
	              className: 'book-checkbox__input',
	              type: 'checkbox',
	              value: isValid === true ? '' : 'true',
	              onChange: onFieldChange,
	              placeholder: placeholder,
	              checked: checked
	            }, (0, _utils.getDataAttributes)(data)))
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'book-checkbox__label' },
	            label
	          ),
	          isValid === false && !!message && _react2.default.createElement(
	            'span',
	            { className: 'book-checkbox__message' },
	            message
	          )
	        )
	      );
	    }
	  }]);
	  return BookCheckbox;
	}(_react.Component);
	
	BookCheckbox.defaultProps = {
	  isValid: null,
	  data: {}
	};
	exports.default = BookCheckbox;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(56);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(8);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _optimizely = __webpack_require__(30);
	
	var optimizelyUtil = _interopRequireWildcard(_optimizely);
	
	__webpack_require__(890);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Read more here about the autofill https://cloudfour.com/thinks/autofill-what-web-devs-should-know-but-dont/
	var BookInput = function (_Component) {
	  (0, _inherits3.default)(BookInput, _Component);
	
	  function BookInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, BookInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BookInput.__proto__ || (0, _getPrototypeOf2.default)(BookInput)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _this.sixtyFPS = 1000 / 60, _this.checkInputValue = function () {
	      if (_this.input && _this.previousValue !== _this.input.value) {
	        _this.previousValue = _this.input.value;
	
	        var evt = window.document.createEvent('HTMLEvents');
	        evt.initEvent('input', true, true);
	        _this.input.dispatchEvent(evt);
	      }
	      _this.timeout = window.setTimeout(_this.checkInputValue, _this.sixtyFPS);
	    }, _this.fireOptimizelyEvent = function () {
	      var data = _this.props.data;
	
	
	      if (data.optimizelyId) {
	        optimizelyUtil.fireEvent('BookInput' + data.optimizelyId, 'clicked');
	      }
	    }, _this.refInput = function (input) {
	      return _this.input = input;
	    }, _this.input = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(BookInput, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.checkInputValue();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          value = _props.value,
	          placeholder = _props.placeholder,
	          autoComplete = _props.autoComplete,
	          onFieldChange = _props.onFieldChange,
	          onFieldBlur = _props.onFieldBlur,
	          isValid = _props.isValid,
	          message = _props.message,
	          isSmall = _props.isSmall,
	          data = _props.data,
	          onKeyDown = _props.onKeyDown,
	          type = _props.type,
	          autoCapitalize = _props.autoCapitalize,
	          pattern = _props.pattern,
	          nameForAutoComplete = _props.nameForAutoComplete,
	          formName = _props.formName,
	          isRequiredField = _props.isRequiredField;
	
	      /* eslint-disable */
	
	      if (false) console.error('Invalid formName: it must be one single word');
	      /*eslint-enable */
	
	      var sectionName = /[^a-z0-9]/i.test(formName) ? '' : 'section-' + formName + ' ';
	      var autoCompleteValue = !autoComplete || autoComplete === 'off' ? 'off' : '' + sectionName + autoComplete;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'book-input ' + (isValid === false ? 'book-input--invalid' : '') + ' ' + (isSmall ? 'book-input--small' : '') + ' ' + (isValid ? 'book-input--valid' : '') },
	        _react2.default.createElement(
	          'label',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'book-input__label' },
	            label,
	            isRequiredField ? '*' : ''
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'book-input__input-wrap' },
	            _react2.default.createElement('input', (0, _extends3.default)({
	              className: 'book-input__input',
	              type: type,
	              value: this.input.value || value,
	              onChange: onFieldChange,
	              onBlur: onFieldBlur,
	              onFocus: this.fireOptimizelyEvent,
	              onKeyDown: onKeyDown,
	              placeholder: placeholder,
	              autoComplete: autoCompleteValue,
	              name: nameForAutoComplete,
	              ref: this.refInput,
	              autoCapitalize: autoCapitalize,
	              pattern: pattern
	            }, (0, _utils.getDataAttributes)(data)))
	          ),
	          isValid === false && _react2.default.createElement(
	            'span',
	            { className: 'book-input__message' },
	            message
	          )
	        )
	      );
	    }
	  }]);
	  return BookInput;
	}(_react.Component);
	
	BookInput.defaultProps = {
	  isValid: null,
	  data: {},
	  type: 'text',
	  autoCapitalize: 'none',
	  value: '',
	  isRequiredField: false
	};
	exports.default = BookInput;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BookSupplierPrincipals = undefined;
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	__webpack_require__(893);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    bookState: state.bookState
	  };
	};
	
	var BookSupplierPrincipals = exports.BookSupplierPrincipals = function (_Component) {
	  (0, _inherits3.default)(BookSupplierPrincipals, _Component);
	
	  function BookSupplierPrincipals() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, BookSupplierPrincipals);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BookSupplierPrincipals.__proto__ || (0, _getPrototypeOf2.default)(BookSupplierPrincipals)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      showContent: {}
	    }, _this.shouldComponentUpdate = _function2.default, _this.toggleContent = function (event) {
	      event.preventDefault();
	      var index = event.currentTarget.dataset.index;
	      var isVisible = !!_this.state.showContent[index];
	      _this.setState({
	        showContent: (0, _defineProperty3.default)({}, '' + index, !isVisible)
	      });
	    }, _this.getContent = function (index) {
	      return { __html: _this.props.bookState.getIn(['data', 'ETC', '' + index, 'content']) };
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(BookSupplierPrincipals, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var suppliers = this.suppliers;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'book-supplier-principals' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'For all arrangements, your contract will be with the Supplier Principal(s) relevant to your booking. Their Terms and Conditions are detailed below:'
	        ),
	        suppliers && suppliers.size > 0 && suppliers.map(function (supplier, index) {
	          var supplierName = supplier.get('supplierName');
	          var url = supplier.get('url');
	          var supplierLegalName = supplier.getIn(['supplierLegalName', 'principalName']);
	
	          return url ? _react2.default.createElement(
	            'p',
	            { key: index },
	            _react2.default.createElement(
	              'a',
	              { className: 'book-supplier-principals__external-link', href: url, target: '_blank' },
	              supplierName
	            )
	          ) : _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(
	              'a',
	              { href: '#', className: 'book-supplier-principals__extendable-link', onClick: _this2.toggleContent, target: '_blank', 'data-index': index },
	              supplierLegalName + ' Terms & Conditions'
	            ),
	            _this2.state.showContent[index] && _react2.default.createElement('div', { className: 'book-supplier-principals__content', dangerouslySetInnerHTML: _this2.getContent(index) })
	          );
	        })
	      );
	    }
	  }, {
	    key: 'suppliers',
	    get: function get() {
	      return this.props.bookState.getIn(['data', 'ETC']);
	    }
	  }]);
	  return BookSupplierPrincipals;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(BookSupplierPrincipals);

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(87);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _calendar = __webpack_require__(95);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _optimizely = __webpack_require__(30);
	
	var optimizelyUtil = _interopRequireWildcard(_optimizely);
	
	var _utils = __webpack_require__(8);
	
	var _dates = __webpack_require__(35);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _BookSelect = __webpack_require__(207);
	
	var _BookSelect2 = _interopRequireDefault(_BookSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarMonthSelect = function (_Component) {
	  (0, _inherits3.default)(CalendarMonthSelect, _Component);
	
	  function CalendarMonthSelect() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarMonthSelect);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarMonthSelect.__proto__ || (0, _getPrototypeOf2.default)(CalendarMonthSelect)).call.apply(_ref, [this].concat(args))), _this), _this.onMonthChange = function (event) {
	      var onClickDate = _this.props.onClickDate;
	
	      optimizelyUtil.fireEvent('CalendarMonthSelect', 'clicked');
	      onClickDate(event.currentTarget.value);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarMonthSelect, [{
	    key: 'getCheapestDayOfMonth',
	    value: function getCheapestDayOfMonth(monthObj) {
	      return monthObj.reduce(function (cheapest, price, day) {
	        var isCheaper = !cheapest.price || price < cheapest.price;
	        return isCheaper ? { price: price, day: day } : cheapest;
	      }, {}).day;
	    }
	
	    // taken from PandaCalendar
	
	  }, {
	    key: 'getAvailableMonthsCollection',
	
	
	    // taken from PandaCalendar
	    value: function getAvailableMonthsCollection() {
	      var _this2 = this;
	
	      var _props = this.props,
	          annualAvailability = _props.annualAvailability,
	          baseState = _props.baseState,
	          availabilityType = _props.availabilityType;
	
	
	      var hotelOnlyAvailability = annualAvailability.get(availabilityType, _immutable2.default.Map());
	      var yearKeys = hotelOnlyAvailability.keySeq().toArray();
	      var calDateFromBaseState = _calendar2.default.getDepartureDate(baseState, true) * _utils.dayInMilliseconds;
	      var calDateMonthAndYearText = _dates2.default.format(calDateFromBaseState, 'MMMM YYYY');
	
	      var availableMonthsCollection = [];
	      yearKeys.sort().map(function (year) {
	        var yearObj = hotelOnlyAvailability.get('' + year, _immutable2.default.List());
	
	        if (yearObj.size) {
	          yearObj.map(function (item, monthNum) {
	            if (item) {
	              var cheapestDayOfMonth = _this2.getCheapestDayOfMonth(item);
	              var cheapestOfMonthDate = new Date(Date.UTC(year, monthNum, cheapestDayOfMonth));
	              var calDate = cheapestOfMonthDate.getTime() / _utils.dayInMilliseconds;
	              var monthAndYearText = _dates2.default.format(cheapestOfMonthDate, 'MMMM YYYY');
	
	              availableMonthsCollection.push({
	                label: monthAndYearText,
	                value: calDate,
	                checked: monthAndYearText === calDateMonthAndYearText
	              });
	            }
	          });
	        }
	      });
	
	      var selectedMonthIsAvailable = availableMonthsCollection.find(function (month) {
	        return month.label === calDateMonthAndYearText;
	      });
	
	      // if the current month is not available, ask the user to select a new month
	      if (!selectedMonthIsAvailable) {
	        availableMonthsCollection = [{ label: 'Select Month' }].concat((0, _toConsumableArray3.default)(availableMonthsCollection));
	      }
	
	      return availableMonthsCollection;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var availableMonthsCollection = this.getAvailableMonthsCollection();
	      var currentMonth = availableMonthsCollection[this.currentMonthIndex] || {};
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'calendar-month-select' },
	        _react2.default.createElement(_BookSelect2.default, {
	          onFieldChange: this.onMonthChange,
	          label: '',
	          value: currentMonth.value,
	          options: availableMonthsCollection,
	          hideLabel: true,
	          disabled: this.props.disabled
	        })
	      );
	    }
	  }, {
	    key: 'currentMonthIndex',
	    get: function get() {
	      var availableMonthsCollection = this.getAvailableMonthsCollection();
	      return availableMonthsCollection.findIndex(function (element) {
	        return !!element.checked;
	      });
	    }
	  }]);
	  return CalendarMonthSelect;
	}(_react.Component);
	
	CalendarMonthSelect.defaultProps = {
	  availabilityType: 'dp',
	  disabled: false
	};
	exports.default = CalendarMonthSelect;

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CarFeatureList = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _shortTransmissionLab, _longTransmissionLabe;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _svgInlineReact = __webpack_require__(64);
	
	var _svgInlineReact2 = _interopRequireDefault(_svgInlineReact);
	
	var _PopoverTriggerLayout = __webpack_require__(315);
	
	var _PopoverTriggerLayout2 = _interopRequireDefault(_PopoverTriggerLayout);
	
	var _carHire = __webpack_require__(210);
	
	var _FeatureSeats = __webpack_require__(1352);
	
	var _FeatureSeats2 = _interopRequireDefault(_FeatureSeats);
	
	var _FeatureBags = __webpack_require__(1349);
	
	var _FeatureBags2 = _interopRequireDefault(_FeatureBags);
	
	var _FeatureDoors = __webpack_require__(1350);
	
	var _FeatureDoors2 = _interopRequireDefault(_FeatureDoors);
	
	var _FeatureAirCon = __webpack_require__(1348);
	
	var _FeatureAirCon2 = _interopRequireDefault(_FeatureAirCon);
	
	var _FeatureTransmission = __webpack_require__(1353);
	
	var _FeatureTransmission2 = _interopRequireDefault(_FeatureTransmission);
	
	var _FeatureFuelPolicy = __webpack_require__(1351);
	
	var _FeatureFuelPolicy2 = _interopRequireDefault(_FeatureFuelPolicy);
	
	__webpack_require__(894);
	
	__webpack_require__(895);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shortTransmissionLabels = (_shortTransmissionLab = {}, (0, _defineProperty3.default)(_shortTransmissionLab, _carHire.transmissionTypes.AUTOMATIC, 'Auto'), (0, _defineProperty3.default)(_shortTransmissionLab, _carHire.transmissionTypes.MANUAL, 'Man'), _shortTransmissionLab);
	
	var longTransmissionLabels = (_longTransmissionLabe = {}, (0, _defineProperty3.default)(_longTransmissionLabe, _carHire.transmissionTypes.AUTOMATIC, 'Automatic'), (0, _defineProperty3.default)(_longTransmissionLabe, _carHire.transmissionTypes.MANUAL, 'Manual'), _longTransmissionLabe);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isMobileBreakpoint: state.appState.get('isMobileBreakpoint')
	  };
	};
	
	var CarFeatureList = exports.CarFeatureList = function (_Component) {
	  (0, _inherits3.default)(CarFeatureList, _Component);
	
	  function CarFeatureList() {
	    var _ref, _popoverLabel, _desktopLabel, _mobileLabel;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CarFeatureList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CarFeatureList.__proto__ || (0, _getPrototypeOf2.default)(CarFeatureList)).call.apply(_ref, [this].concat(args))), _this), _this.features = [{
	      key: 'seats',
	      popoverLabel: function popoverLabel(v) {
	        return 'Fits ' + v + ' people';
	      },
	      desktopLabel: function desktopLabel(v) {
	        return 'x ' + v;
	      },
	      icon: _FeatureSeats2.default
	    }, {
	      key: 'bags',
	      popoverLabel: function popoverLabel(v) {
	        return 'Space for ' + v + ' bag' + (v > 1 ? 's' : '');
	      },
	      desktopLabel: function desktopLabel(v) {
	        return 'x ' + v;
	      },
	      icon: _FeatureBags2.default
	    }, {
	      key: 'doors',
	      popoverLabel: function popoverLabel(v) {
	        return v + ' door';
	      },
	      desktopLabel: function desktopLabel(v) {
	        return 'x ' + v;
	      },
	      icon: _FeatureDoors2.default
	    }, {
	      key: 'airConditioning',
	      popoverLabel: function popoverLabel(v) {
	        return (v ? '' : 'No ') + 'Air Conditioning';
	      },
	      desktopLabel: function desktopLabel(v) {
	        return '' + (v ? 'A/C' : 'No A/C');
	      },
	      icon: _FeatureAirCon2.default
	    }, {
	      key: 'transmission',
	      popoverLabel: function popoverLabel(v) {
	        return longTransmissionLabels[v];
	      },
	      desktopLabel: function desktopLabel(v) {
	        return longTransmissionLabels[v];
	      },
	      mobileLabel: function mobileLabel(v) {
	        return shortTransmissionLabels[v];
	      },
	      icon: _FeatureTransmission2.default
	    }, {
	      key: 'fuelPolicy',
	      popoverLabel: (_popoverLabel = {}, (0, _defineProperty3.default)(_popoverLabel, _carHire.fuelPolicies.FULL_TO_EMPTY, 'Fuel policy: Full to Empty'), (0, _defineProperty3.default)(_popoverLabel, _carHire.fuelPolicies.FULL_TO_FULL, 'Fuel policy: Full to Full'), _popoverLabel),
	      desktopLabel: (_desktopLabel = {}, (0, _defineProperty3.default)(_desktopLabel, _carHire.fuelPolicies.FULL_TO_EMPTY, 'Full to Empty'), (0, _defineProperty3.default)(_desktopLabel, _carHire.fuelPolicies.FULL_TO_FULL, 'Full to Full'), _desktopLabel),
	      mobileLabel: (_mobileLabel = {}, (0, _defineProperty3.default)(_mobileLabel, _carHire.fuelPolicies.FULL_TO_EMPTY, 'Empty'), (0, _defineProperty3.default)(_mobileLabel, _carHire.fuelPolicies.FULL_TO_FULL, 'Full'), _mobileLabel),
	      icon: _FeatureFuelPolicy2.default
	    }], _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CarFeatureList, [{
	    key: 'getLabelText',
	    value: function getLabelText(feature, value) {
	      var isMobileBreakpoint = this.props.isMobileBreakpoint;
	
	      var mobileLabelSpec = feature.mobileLabel || feature.desktopLabel;
	      var labelSpec = isMobileBreakpoint ? mobileLabelSpec : feature.desktopLabel;
	
	      return this.getLabelSpecText(labelSpec, value);
	    }
	  }, {
	    key: 'getLabelSpecText',
	    value: function getLabelSpecText(labelSpec, value) {
	      return typeof labelSpec === 'function' ? labelSpec(value) : labelSpec[value];
	    }
	  }, {
	    key: 'getPopoverData',
	    value: function getPopoverData() {
	      var _this2 = this;
	
	      var carHireOption = this.props.carHireOption;
	
	
	      return {
	        id: 'car-feature-list__popover',
	        body: _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            'Car specification:'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'car-feature-list__popover__feature-list' },
	            this.features.map(function (feature) {
	              return _react2.default.createElement(
	                'li',
	                { key: feature.key, className: 'car-feature-list__popover__feature', 'data-feature': feature.key },
	                _react2.default.createElement(_svgInlineReact2.default, { src: feature.icon, className: 'car-feature-list__popover__icon' }),
	                _this2.getLabelSpecText(feature.popoverLabel, carHireOption.get(feature.key))
	              );
	            })
	          )
	        )
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          carHireOption = _props.carHireOption,
	          isMobileBreakpoint = _props.isMobileBreakpoint;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'car-feature-list' },
	        _react2.default.createElement(
	          _PopoverTriggerLayout2.default,
	          { content: this.getPopoverData(), position: 'auto', disabled: isMobileBreakpoint },
	          this.features.map(function (feature) {
	            return _react2.default.createElement(
	              'div',
	              { key: feature.key, className: 'car-feature-list__feature', 'data-feature': feature.key },
	              _react2.default.createElement(_svgInlineReact2.default, { src: feature.icon, className: 'car-feature-list__feature__icon' }),
	              _this3.getLabelText(feature, carHireOption.get(feature.key))
	            );
	          })
	        )
	      );
	    }
	  }]);
	  return CarFeatureList;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(CarFeatureList);

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shapes = __webpack_require__(304);
	
	var _BookPrice = __webpack_require__(139);
	
	var _BookPrice2 = _interopRequireDefault(_BookPrice);
	
	var _LinkButton = __webpack_require__(65);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _HireCarInfo = __webpack_require__(519);
	
	var _HireCarInfo2 = _interopRequireDefault(_HireCarInfo);
	
	__webpack_require__(896);
	
	__webpack_require__(897);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CarHireOption = function (_Component) {
	  (0, _inherits3.default)(CarHireOption, _Component);
	
	  function CarHireOption() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CarHireOption);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CarHireOption.__proto__ || (0, _getPrototypeOf2.default)(CarHireOption)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelectClick = function (event) {
	      var _this$props = _this.props,
	          carHireOption = _this$props.carHireOption,
	          onSelectClick = _this$props.onSelectClick;
	
	
	      event.preventDefault();
	      onSelectClick(carHireOption);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CarHireOption, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          carHireOption = _props.carHireOption,
	          numberOfDays = _props.numberOfDays;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'car-hire-option' },
	        _react2.default.createElement(_HireCarInfo2.default, { carHireOption: carHireOption }),
	        _react2.default.createElement(
	          'div',
	          { className: 'car-hire-option__price' },
	          _react2.default.createElement(_BookPrice2.default, {
	            price: carHireOption.getIn(['pricing', 'webPrice']),
	            divisor: numberOfDays,
	            suffix: 'per day',
	            hasSmallSuffix: true
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'car-hire-option__select' },
	          _react2.default.createElement(
	            _LinkButton2.default,
	            { color: 'blue', onClick: this.handleSelectClick },
	            'Select'
	          )
	        )
	      );
	    }
	  }]);
	  return CarHireOption;
	}(_react.Component);
	
	exports.default = CarHireOption;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _dates = __webpack_require__(35);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	__webpack_require__(898);
	
	__webpack_require__(899);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CarHireOptionsHeader = function (_Component) {
	  (0, _inherits3.default)(CarHireOptionsHeader, _Component);
	
	  function CarHireOptionsHeader() {
	    (0, _classCallCheck3.default)(this, CarHireOptionsHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (CarHireOptionsHeader.__proto__ || (0, _getPrototypeOf2.default)(CarHireOptionsHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CarHireOptionsHeader, [{
	    key: 'render',
	    value: function render() {
	      var firstCarHireOption = this.props.firstCarHireOption;
	
	
	      var dateFormat = 'ddd D MMM YYYY';
	      var pickupDate = _dates2.default.format(_dates2.default.isoStringToDate(firstCarHireOption.get('pickupDate')), dateFormat);
	      var dropoffDate = _dates2.default.format(_dates2.default.isoStringToDate(firstCarHireOption.get('dropoffDate')), dateFormat);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'car-hire-options-header' },
	        _react2.default.createElement(
	          'div',
	          { className: 'car-hire-options-header__dates' },
	          _react2.default.createElement(
	            'div',
	            { className: 'car-hire-options-header__date', 'data-item': 'pickup' },
	            'Pick up: ',
	            pickupDate,
	            ' - ',
	            firstCarHireOption.get('pickupTime')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'car-hire-options-header__date', 'data-item': 'dropoff' },
	            'Drop off: ',
	            dropoffDate,
	            ' - ',
	            firstCarHireOption.get('dropoffTime')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'car-hire-options-header__age-info' },
	          'The main driver must be at least 25 years old'
	        )
	      );
	    }
	  }]);
	  return CarHireOptionsHeader;
	}(_react.Component);
	
	exports.default = CarHireOptionsHeader;

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CarHireOptionsList = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _carHire = __webpack_require__(210);
	
	var _LoadingOverlayLayout = __webpack_require__(314);
	
	var _LoadingOverlayLayout2 = _interopRequireDefault(_LoadingOverlayLayout);
	
	var _CarHireOption = __webpack_require__(514);
	
	var _CarHireOption2 = _interopRequireDefault(_CarHireOption);
	
	var _CarHireOptionsHeader = __webpack_require__(515);
	
	var _CarHireOptionsHeader2 = _interopRequireDefault(_CarHireOptionsHeader);
	
	var _bookActions = __webpack_require__(143);
	
	var _modalActions = __webpack_require__(40);
	
	var modalActions = _interopRequireWildcard(_modalActions);
	
	var _optimizely = __webpack_require__(30);
	
	var optimizelyUtil = _interopRequireWildcard(_optimizely);
	
	__webpack_require__(900);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    carHireOptions: state.bookState.getIn(['entities', 'carHires']),
	    isMobileBreakpoint: state.appState.get('isMobileBreakpoint'),
	    numberOfNights: state.bookState.getIn(['data', 'num_nights'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    selectHireCar: function selectHireCar(carId) {
	      return dispatch((0, _bookActions.selectHireCar)(carId));
	    },
	    toggleModal: (0, _redux.bindActionCreators)(modalActions.toggleModal, dispatch)
	  };
	};
	
	var CarHireOptionsList = exports.CarHireOptionsList = function (_Component) {
	  (0, _inherits3.default)(CarHireOptionsList, _Component);
	
	  function CarHireOptionsList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CarHireOptionsList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CarHireOptionsList.__proto__ || (0, _getPrototypeOf2.default)(CarHireOptionsList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      firstThreeOptions: []
	    }, _this.handleSelectOption = function (hireCar) {
	      var vehicleType = hireCar.get('vehicleType');
	      var groupIndex = _carHire.vehicleTypeGroups.findIndex(function (group) {
	        return group.includes(vehicleType);
	      });
	
	      optimizelyUtil.fireEvent('OfferSummaryCarHireGroup' + (groupIndex + 1), 'clicked');
	      _this.props.selectHireCar(hireCar.get('id'));
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CarHireOptionsList, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateFirstThreeOptions(this.props.carHireOptions);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.carHireOptions !== this.props.carHireOptions) {
	        this.updateFirstThreeOptions(newProps.carHireOptions);
	      }
	    }
	  }, {
	    key: 'updateFirstThreeOptions',
	    value: function updateFirstThreeOptions(carHireOptions) {
	      var groupsCheapest = _immutable2.default.List();
	      carHireOptions.forEach(function (carHireOption) {
	        var vehicleType = carHireOption.get('vehicleType');
	        var groupIndex = _carHire.vehicleTypeGroups.findIndex(function (group) {
	          return group.includes(vehicleType);
	        });
	        if (groupsCheapest.get(groupIndex) === undefined) {
	          groupsCheapest = groupsCheapest.set(groupIndex, carHireOption);
	        } else {
	          var currentCheapest = groupsCheapest.getIn([groupIndex, 'pricing', 'webPrice']);
	          var currentOptionPrice = carHireOption.getIn(['pricing', 'webPrice']);
	
	          if (currentOptionPrice < currentCheapest) {
	            groupsCheapest = groupsCheapest.set(groupIndex, carHireOption);
	          }
	        }
	      });
	
	      this.setState({
	        firstThreeOptions: groupsCheapest.filter(function (v) {
	          return v;
	        })
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          numberOfNights = _props.numberOfNights,
	          carHireOptions = _props.carHireOptions;
	      var firstThreeOptions = this.state.firstThreeOptions;
	
	
	      var numberOfDays = numberOfNights + 1;
	
	      return _react2.default.createElement(
	        _LoadingOverlayLayout2.default,
	        { loadingKey: 'loadingPaymentPlans' },
	        _react2.default.createElement(
	          'div',
	          { className: 'car-hire-options-list' },
	          _react2.default.createElement(_CarHireOptionsHeader2.default, { firstCarHireOption: carHireOptions.first() }),
	          firstThreeOptions.map(function (carHireOption) {
	            return _react2.default.createElement(
	              'div',
	              { key: carHireOption.get('id'), className: 'car-hire-options-list__option' },
	              _react2.default.createElement(_CarHireOption2.default, {
	                carHireOption: carHireOption,
	                numberOfDays: numberOfDays,
	                onSelectClick: _this2.handleSelectOption
	              })
	            );
	          })
	        )
	      );
	    }
	  }]);
	  return CarHireOptionsList;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CarHireOptionsList);

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CarHireProviderLogo = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	__webpack_require__(901);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    assetRoot: state.appState.get('assetRoot')
	  };
	};
	
	var CarHireProviderLogo = exports.CarHireProviderLogo = function (_Component) {
	  (0, _inherits3.default)(CarHireProviderLogo, _Component);
	
	  function CarHireProviderLogo() {
	    (0, _classCallCheck3.default)(this, CarHireProviderLogo);
	    return (0, _possibleConstructorReturn3.default)(this, (CarHireProviderLogo.__proto__ || (0, _getPrototypeOf2.default)(CarHireProviderLogo)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CarHireProviderLogo, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          assetRoot = _props.assetRoot,
	          provider = _props.provider,
	          providerCode = _props.providerCode;
	
	      var imageStyle = {};
	
	      if (providerCode) {
	        imageStyle.backgroundImage = 'url(' + assetRoot + '/car-hire-providers/150x64-logo-' + providerCode.toLowerCase() + '.png)';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'car-hire-provider-logo', style: imageStyle },
	        provider
	      );
	    }
	  }]);
	  return CarHireProviderLogo;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(CarHireProviderLogo);

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CarHireTermsAndConditions = exports.mapStateToProps = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _utils = __webpack_require__(8);
	
	__webpack_require__(902);
	
	__webpack_require__(903);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    car: state.bookState.getIn(['entities', 'carHires', '' + ownProps.carId])
	  };
	};
	
	var CarHireTermsAndConditions = exports.CarHireTermsAndConditions = function (_Component) {
	  (0, _inherits3.default)(CarHireTermsAndConditions, _Component);
	
	  function CarHireTermsAndConditions() {
	    (0, _classCallCheck3.default)(this, CarHireTermsAndConditions);
	    return (0, _possibleConstructorReturn3.default)(this, (CarHireTermsAndConditions.__proto__ || (0, _getPrototypeOf2.default)(CarHireTermsAndConditions)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CarHireTermsAndConditions, [{
	    key: 'getProtocol',
	    value: function getProtocol() {
	      return window.location.protocol;
	    }
	  }, {
	    key: 'getTermsAndConditionsUrl',
	    value: function getTermsAndConditionsUrl() {
	      var car = this.props.car;
	
	
	      var url = car.get('termsAndConditions');
	      return url.replace(/^http[s]?:/, this.getProtocol());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'car-hire-terms-and-conditions ' + ((0, _utils.isIpad)() ? 'car-hire-terms-and-conditions--ipad' : '') },
	        _react2.default.createElement('iframe', {
	          className: 'car-hire-terms-and-conditions__external-terms',
	          src: this.getTermsAndConditionsUrl(),
	          scrolling: (0, _utils.isIpad)() ? 'no' : 'auto'
	        })
	      );
	    }
	  }]);
	  return CarHireTermsAndConditions;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(CarHireTermsAndConditions);

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HireCarInfo = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _shapes = __webpack_require__(304);
	
	var _CarFeatureList = __webpack_require__(513);
	
	var _CarFeatureList2 = _interopRequireDefault(_CarFeatureList);
	
	var _utils = __webpack_require__(8);
	
	var _modalActions = __webpack_require__(40);
	
	var _modal = __webpack_require__(167);
	
	var _SlideInFromTheSideModal = __webpack_require__(165);
	
	var _CarHireProviderLogo = __webpack_require__(517);
	
	var _CarHireProviderLogo2 = _interopRequireDefault(_CarHireProviderLogo);
	
	var _optimizely = __webpack_require__(30);
	
	var optimizelyUtil = _interopRequireWildcard(_optimizely);
	
	__webpack_require__(904);
	
	__webpack_require__(905);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onOpenTermsAndConditions: function onOpenTermsAndConditions(carId) {
	      return dispatch((0, _modalActions.openSubModal)(_modal.CAR_TERMS_AND_CONDITIONS, {
	        subPageIfMobile: 'car-hire-terms',
	        slideInFromTheSide: _SlideInFromTheSideModal.SLIDE_DIRECTION_LEFT,
	        title: 'Terms and Conditions',
	        width: 800,
	        carId: carId
	      }));
	    }
	  };
	};
	
	var HireCarInfo = exports.HireCarInfo = function (_Component) {
	  (0, _inherits3.default)(HireCarInfo, _Component);
	
	  function HireCarInfo() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, HireCarInfo);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = HireCarInfo.__proto__ || (0, _getPrototypeOf2.default)(HireCarInfo)).call.apply(_ref, [this].concat(args))), _this), _this.handleTermsAndConditionsClick = function (event) {
	      event.preventDefault();
	
	      var _this$props = _this.props,
	          carHireOption = _this$props.carHireOption,
	          onOpenTermsAndConditions = _this$props.onOpenTermsAndConditions;
	
	      optimizelyUtil.fireEvent('OfferSummaryCarHireTermsAndConditions', 'clicked');
	      onOpenTermsAndConditions(carHireOption.get('id'));
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(HireCarInfo, [{
	    key: 'render',
	    value: function render() {
	      var carHireOption = this.props.carHireOption;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'hire-car-info' },
	        _react2.default.createElement(
	          'div',
	          { className: 'hire-car-info__images' },
	          _react2.default.createElement('img', { className: 'hire-car-info__car-image', src: carHireOption.get('imageUrl') }),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_CarHireProviderLogo2.default, {
	              provider: carHireOption.get('provider'),
	              providerCode: carHireOption.get('providerCode')
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'hire-car-info__details' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hire-car-info__name' },
	            (0, _utils.camelCase)(carHireOption.get('name'))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'hire-car-info__features' },
	            _react2.default.createElement(_CarFeatureList2.default, { carHireOption: carHireOption })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'hire-car-info__terms-link' },
	            _react2.default.createElement(
	              'a',
	              { href: carHireOption.get('termsAndConditions'), onClick: this.handleTermsAndConditionsClick },
	              'Full Terms and Conditions'
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return HireCarInfo;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(HireCarInfo);

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _touchEvents = __webpack_require__(606);
	
	var _touchEvents2 = _interopRequireDefault(_touchEvents);
	
	var _global = __webpack_require__(79);
	
	var _global2 = _interopRequireDefault(_global);
	
	__webpack_require__(906);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Carousel = function (_Component) {
	  (0, _inherits3.default)(Carousel, _Component);
	
	  function Carousel() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Carousel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Carousel.__proto__ || (0, _getPrototypeOf2.default)(Carousel)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _this.onUserTouchStart = function () {
	      _this.carouselElement.style.transition = 'none';
	    }, _this.onUserTouchMove = function (event) {
	      event.preventDefault();
	
	      var xCoordinateDifference = _this.userTouch.xCoordinateLatest - _this.userTouch.xCoordinateStart;
	      var newTranslateValue = _this.translateXValue + xCoordinateDifference;
	
	      _this.carouselElement.style.transform = _this.getTransformStyleAttribute(newTranslateValue);
	      _this.carouselElement.style.WebkitTransform = _this.getTransformStyleAttribute(newTranslateValue);
	    }, _this.onUserTouchEnd = function () {
	      _this.carouselElement.style.transition = 'transform 0.5s';
	
	      _this.controlPingBack();
	
	      if (_this.userTouch.isStationary) {
	        _this.props.toggleControlsAreActive();
	      } else if (_this.userTouch.xDirection === 'left') {
	        _this.props.onClickNext();
	      } else {
	        _this.props.onClickPrevious();
	      }
	    }, _this.onThumbnailClick = function (event) {
	      var _this$props = _this.props,
	          isThumbnails = _this$props.isThumbnails,
	          isInline = _this$props.isInline,
	          onClickThumbnail = _this$props.onClickThumbnail;
	
	      event.preventDefault();
	      if (onClickThumbnail && isThumbnails || isInline) {
	        onClickThumbnail(event);
	      }
	    }, _this.getCarouselContainerElement = function (ref) {
	      _this.carouselContainerElement = ref;
	    }, _this.getCarouselElement = function (ref) {
	      _this.carouselElement = ref;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Carousel, [{
	    key: 'componentDidMount',
	
	
	    /* istanbul ignore next */
	    value: function componentDidMount() {
	      this.userTouch = new _touchEvents2.default(this.carouselContainerElement, {
	        touchstartCallback: this.onUserTouchStart,
	        touchmoveCallback: this.onUserTouchMove,
	        touchendCallback: this.onUserTouchEnd
	      });
	
	      this.userTouch.init();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      /* istanbul ignore next */
	      this.userTouch.destroy();
	    }
	  }, {
	    key: 'controlPingBack',
	    value: function controlPingBack() {
	      if (this.userTouch.isStationary || this.props.isFirstImage && this.userTouch.xDirection === 'right' || this.props.isLastImage && this.userTouch.xDirection === 'left') {
	        this.carouselElement.style.transform = this.getTransformStyleAttribute(this.translateXValue);
	      }
	    }
	  }, {
	    key: 'getTransformStyleAttribute',
	    value: function getTransformStyleAttribute(translateValue) {
	      var _props = this.props,
	          isInline = _props.isInline,
	          isSlideshow = _props.isSlideshow;
	
	      return 'translate3d(' + translateValue + 'px, ' + (!isInline && !isSlideshow ? '-50%' : '0') + ', 0)';
	    }
	  }, {
	    key: 'getSlideImageUrlByIndex',
	    value: function getSlideImageUrlByIndex(index) {
	      var _props2 = this.props,
	          images = _props2.images,
	          imageType = _props2.imageType,
	          isSlideshow = _props2.isSlideshow;
	
	
	      var imagesArray = images.toJS();
	      var imagePathname = typeof imagesArray[index] === 'string' ? imagesArray[index] : imagesArray[index].location;
	
	      // inspirational images default to DGA if INS is unavailable
	      var isImageTypeAvailable = images.getIn(['' + index, 'sizes', imageType], false);
	      var isInspirational = imageType === 'INS';
	      var imageCode = isSlideshow && isInspirational && !isImageTypeAvailable ? 'DGA' : imageType;
	
	      imagePathname = imagePathname.replace(/(^.+)(\.[A-Z]{3})(\.jpg)$/, '$1$3').replace('.jpg', '.' + imageCode + '.jpg');
	
	      var isFullURL = imagePathname.indexOf('http') === 0;
	
	      return '' + (isFullURL ? '' : _global2.default.imagesBaseUrl) + imagePathname;
	    }
	  }, {
	    key: 'renderSlide',
	    value: function renderSlide(slideIndex) {
	      var _props3 = this.props,
	          currentItemIndex = _props3.currentItemIndex,
	          images = _props3.images,
	          imageWidth = _props3.imageWidth,
	          isDesktop = _props3.isDesktop,
	          isSlideshow = _props3.isSlideshow,
	          isThumbnails = _props3.isThumbnails,
	          showCounter = _props3.showCounter;
	
	
	      var slideStyles = isDesktop ? {} : {
	        width: imageWidth
	      };
	
	      if (isSlideshow || isThumbnails) {
	        var imageAspectRatio = 1.86;
	        slideStyles.height = isThumbnails ? imageWidth : Math.round(imageWidth / imageAspectRatio);
	      }
	
	      var imageUrl = this.getSlideImageUrlByIndex(slideIndex);
	
	      var totalSlides = images.size;
	
	      return _react2.default.createElement(
	        'li',
	        { className: 'carousel__list__slide ' + (currentItemIndex === slideIndex && 'carousel__list__slide--active'), key: 'image-' + slideIndex, style: slideStyles },
	        _react2.default.createElement(
	          'a',
	          { href: '#', onClick: this.onThumbnailClick, 'data-index': slideIndex },
	          _react2.default.createElement('img', { itemProp: 'photo', className: 'carousel__list__slide__image', src: imageUrl, alt: 'hotel photo' })
	        ),
	        showCounter && _react2.default.createElement(
	          'span',
	          { className: 'carousel__list__slide__status' },
	          '[',
	          currentItemIndex + 1,
	          ' / ',
	          totalSlides,
	          ']'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          currentItemIndex = _props4.currentItemIndex,
	          imageWidth = _props4.imageWidth,
	          images = _props4.images,
	          isDesktop = _props4.isDesktop,
	          isInline = _props4.isInline,
	          isSlideshow = _props4.isSlideshow,
	          isThumbnails = _props4.isThumbnails;
	
	
	      this.translateXValue = imageWidth * currentItemIndex * -1;
	
	      var totalSlides = images.size;
	
	      var carouselStyles = isInline ? {
	        width: imageWidth + 'px'
	      } : {};
	
	      if (isSlideshow) {
	        carouselStyles.width = imageWidth;
	      }
	
	      var carouselListStyles = isDesktop || isSlideshow || isThumbnails ? {} : {
	        WebkitTransform: this.getTransformStyleAttribute(this.translateXValue),
	        transform: this.getTransformStyleAttribute(this.translateXValue),
	        width: imageWidth * totalSlides
	      };
	
	      if (isSlideshow) {
	        carouselListStyles.width = imageWidth * totalSlides;
	      }
	
	      if (isThumbnails) {
	        carouselListStyles.width = (imageWidth + 9) * (totalSlides + 1);
	      }
	
	      var className = void 0;
	
	      if (isDesktop) {
	        className = 'carousel--desktop';
	      } else if (isInline) {
	        className = 'carousel--inline';
	      } else if (isSlideshow) {
	        className = 'carousel--slideshow';
	      } else if (isThumbnails) {
	        className = 'carousel--thumbnails';
	      } else {
	        className = 'carousel--mobile';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'carousel ' + className, ref: this.getCarouselContainerElement, style: carouselStyles },
	        _react2.default.createElement(
	          'ul',
	          { className: 'carousel__list', style: carouselListStyles, ref: this.getCarouselElement },
	          images.map(function (img, index) {
	            return _this2.renderSlide(index);
	          })
	        )
	      );
	    }
	  }]);
	  return Carousel;
	}(_react.Component);
	
	Carousel.defaultProps = {
	  imageType: 'DGA' };
	exports.default = Carousel;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(907);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CollapsiblePanel = function (_Component) {
	  (0, _inherits3.default)(CollapsiblePanel, _Component);
	
	  function CollapsiblePanel() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CollapsiblePanel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CollapsiblePanel.__proto__ || (0, _getPrototypeOf2.default)(CollapsiblePanel)).call.apply(_ref, [this].concat(args))), _this), _this.handleLabelClick = function () {
	      _this.setState({
	        isOpen: !_this.state.isOpen
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CollapsiblePanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var startClosed = this.props.startClosed;
	
	      this.setState({
	        isOpen: !startClosed
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          children = _props.children;
	      var isOpen = this.state.isOpen;
	
	
	      var modifier = isOpen ? 'open' : 'closed';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'collapsible-panel' },
	        _react2.default.createElement(
	          'button',
	          { className: 'collapsible-panel__label collapsible-panel__label--' + modifier, onClick: this.handleLabelClick },
	          label
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'collapsible-panel__content collapsible-panel__content--' + modifier },
	          children
	        )
	      );
	    }
	  }]);
	  return CollapsiblePanel;
	}(_react.Component);
	
	CollapsiblePanel.defaultProps = {
	  startClosed: false
	};
	exports.default = CollapsiblePanel;

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _utils = __webpack_require__(8);
	
	__webpack_require__(908);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CustomControl = function (_Component) {
	  (0, _inherits3.default)(CustomControl, _Component);
	
	  function CustomControl() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CustomControl);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CustomControl.__proto__ || (0, _getPrototypeOf2.default)(CustomControl)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _this.closeControlWithEscape = function (event) {
	      var closeCustomControl = _this.props.closeCustomControl;
	
	      var escapeKeycode = 27;
	
	      if (event.keyCode === escapeKeycode && closeCustomControl) {
	        closeCustomControl(event);
	      }
	    }, _this.closeControl = function (event) {
	      event.preventDefault();
	      var closeCustomControl = _this.props.closeCustomControl;
	
	
	      closeCustomControl(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CustomControl, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('keyup', this.closeControlWithEscape);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('keyup', this.closeControlWithEscape);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          body = _props.body,
	          position = _props.position,
	          customControlState = _props.customControlState,
	          hAlign = _props.hAlign,
	          closeCustomControl = _props.closeCustomControl,
	          width = _props.width,
	          height = _props.height;
	
	
	      var coordinates = (0, _utils.getCoordinatesRelativeToDocument)(customControlState.boundingClientRect);
	      var dimensionStyles = { width: customControlState.width || 300, maxHeight: height };
	      var positionStyles = {};
	
	      if ((position === 'top' || position === 'bottom') && customControlState.boundingClientRect) {
	        if (hAlign === 'left') {
	          positionStyles.left = coordinates.left;
	        } else if (hAlign === 'center') {
	          positionStyles.left = coordinates.left - width / 2 + customControlState.boundingClientRect.width / 2;
	        }
	      }
	
	      if (position === 'top' && customControlState.boundingClientRect) {
	        positionStyles.top = coordinates.top + customControlState.boundingClientRect.height;
	      }
	
	      if (position === 'bottom' && customControlState.boundingClientRect) {
	        positionStyles.top = coordinates.top;
	      }
	
	      if (position === 'right' && customControlState.boundingClientRect) {
	        positionStyles.left = coordinates.left + customControlState.boundingClientRect.width;
	        positionStyles.top = coordinates.top;
	      }
	
	      if (customControlState.yOffset) {
	        positionStyles.top += customControlState.yOffset;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'custom-control' },
	        _react2.default.createElement('div', { onClick: closeCustomControl, className: 'custom-control__screen' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'custom-control__inner', style: positionStyles, 'data-custom-control-wrapper': true },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'custom-control__content custom-control__content--' + position + ' custom-control__content--' + (height !== 'auto' && 'fixed-height') + ' ' + (customControlState.hasTopArrow ? 'custom-control__content--has-top-arrow' : ''),
	              style: dimensionStyles
	            },
	            customControlState.hasCloseButton && _react2.default.createElement('a', { href: '#', onClick: this.closeControl, className: 'custom-control__close' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'custom-control__text' },
	              typeof body === 'string' ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: body } }) : body
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return CustomControl;
	}(_react.Component);
	
	CustomControl.defaultProps = {
	  body: '',
	  position: 'top',
	  hAlign: 'center',
	  customControlState: {},
	  width: 300,
	  height: 'auto'
	};
	exports.default = CustomControl;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(909);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CustomControlPopoverWrapper = function (_Component) {
	  (0, _inherits3.default)(CustomControlPopoverWrapper, _Component);
	
	  function CustomControlPopoverWrapper() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CustomControlPopoverWrapper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CustomControlPopoverWrapper.__proto__ || (0, _getPrototypeOf2.default)(CustomControlPopoverWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.handleClose = function (event) {
	      var closeCustomControl = _this.props.closeCustomControl;
	
	      event.preventDefault();
	      closeCustomControl();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CustomControlPopoverWrapper, [{
	    key: 'getPopOverLeftPosition',
	    value: function getPopOverLeftPosition() {
	      var _props = this.props,
	          alignRight = _props.alignRight,
	          coordinatesOfAssociatedElement = _props.coordinatesOfAssociatedElement,
	          width = _props.width;
	
	      var iconCenterFromRightInPixels = 25;
	
	      var leftPosition = 'auto';
	
	      if (coordinatesOfAssociatedElement.width && alignRight) {
	        leftPosition = coordinatesOfAssociatedElement.left + coordinatesOfAssociatedElement.width - width / 2 - iconCenterFromRightInPixels;
	      } else if (coordinatesOfAssociatedElement.width) {
	        leftPosition = coordinatesOfAssociatedElement.left + (width - coordinatesOfAssociatedElement.width) / -2;
	      }
	
	      return leftPosition;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          closeCustomControl = _props2.closeCustomControl,
	          width = _props2.width;
	
	
	      var style = {
	        left: this.getPopOverLeftPosition(),
	        width: width
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'custom-control-popover-wrapper', style: style },
	        closeCustomControl && _react2.default.createElement('button', { className: 'custom-control-popover-wrapper__close-button', onClick: this.handleClose }),
	        children
	      );
	    }
	  }]);
	  return CustomControlPopoverWrapper;
	}(_react.Component);
	
	CustomControlPopoverWrapper.defaultProps = {
	  alignRight: false,
	  closeCustomControl: undefined,
	  coordinatesOfAssociatedElement: {}
	};
	exports.default = CustomControlPopoverWrapper;

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _dates = __webpack_require__(35);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _utils = __webpack_require__(8);
	
	var _calendar = __webpack_require__(95);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _CalendarMonthSelect = __webpack_require__(512);
	
	var _CalendarMonthSelect2 = _interopRequireDefault(_CalendarMonthSelect);
	
	var _PandaCalendar = __webpack_require__(537);
	
	var _PandaCalendar2 = _interopRequireDefault(_PandaCalendar);
	
	__webpack_require__(910);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatePickerWithPrices = function (_Component) {
	  (0, _inherits3.default)(DatePickerWithPrices, _Component);
	
	  function DatePickerWithPrices() {
	    (0, _classCallCheck3.default)(this, DatePickerWithPrices);
	    return (0, _possibleConstructorReturn3.default)(this, (DatePickerWithPrices.__proto__ || (0, _getPrototypeOf2.default)(DatePickerWithPrices)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(DatePickerWithPrices, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          annualAvailability = _props.annualAvailability,
	          annualAvailabilityType = _props.annualAvailabilityType,
	          appState = _props.appState,
	          baseState = _props.baseState,
	          featureFlags = _props.featureFlags,
	          handleDayClick = _props.handleDayClick,
	          handleMonthClick = _props.handleMonthClick,
	          numberOfChargeablePassengers = _props.numberOfChargeablePassengers;
	
	
	      var availability = annualAvailability.get(annualAvailabilityType, _immutable2.default.Map());
	      var availabilityExists = !!availability.size;
	      var calDate = _calendar2.default.getDepartureDate(baseState, true);
	      var duration = Number(baseState.getIn(['queryState', 'props', 'duration', 'value'], _dates.DEFAULT_HOTEL_ONLY_DURATION));
	      var isAppStateLoading = appState.get('loadingState');
	      var selectedMonth = _dates2.default.format(calDate * _utils.dayInMilliseconds, 'MMMM');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'date-picker-with-prices' },
	        _react2.default.createElement(
	          'div',
	          { className: 'date-picker-with-prices__month-picker' },
	          _react2.default.createElement(_CalendarMonthSelect2.default, {
	            annualAvailability: annualAvailability,
	            availabilityType: 'ho',
	            baseState: baseState,
	            onClickDate: handleMonthClick,
	            disabled: !availabilityExists
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'date-picker-with-prices__date-picker' },
	          _react2.default.createElement(_PandaCalendar2.default, {
	            annualAvailability: availability,
	            appState: appState,
	            baseState: baseState,
	            disableFooter: true,
	            disableHeader: true,
	            disableIcons: true,
	            featureFlags: featureFlags,
	            noResults: !isAppStateLoading && !availabilityExists,
	            numberOfChargeablePassengers: numberOfChargeablePassengers,
	            numberOfNights: duration,
	            offer: appState.get('selectedOffer'),
	            onClickDate: handleDayClick,
	            onlyHighlightSelectedDate: true
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'date-picker-with-prices__key' },
	          _react2.default.createElement(
	            'p',
	            { className: 'date-picker-with-prices__key__items' },
	            _react2.default.createElement(
	              'span',
	              { className: 'date-picker-with-prices__key__item date-picker-with-prices__key__item--selected' },
	              'Selected Date'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'date-picker-with-prices__key__item date-picker-with-prices__key__item--cheapest' },
	              'Cheapest in ',
	              selectedMonth
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'date-picker-with-prices__key__text' },
	            ((0, _utils.isCurrencyEur)() ? '€' : '£') + ' Price shown is per person for ' + duration + ' night' + (duration > 1 ? 's' : '')
	          )
	        )
	      );
	    }
	  }]);
	  return DatePickerWithPrices;
	}(_react.Component);
	
	DatePickerWithPrices.defaultProps = {
	  annualAvailabilityType: 'ho',
	  displayPerNightPricing: false
	};
	exports.default = DatePickerWithPrices;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _LinkButton = __webpack_require__(65);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	__webpack_require__(911);
	
	__webpack_require__(912);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DuplicateNamesModal = function (_Component) {
	  (0, _inherits3.default)(DuplicateNamesModal, _Component);
	
	  function DuplicateNamesModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DuplicateNamesModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DuplicateNamesModal.__proto__ || (0, _getPrototypeOf2.default)(DuplicateNamesModal)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _this.goBack = function (e) {
	      e.preventDefault();
	      _this.props.onGoBack();
	    }, _this.continueSubmit = function (e) {
	      e.preventDefault();
	      _this.props.onContinue();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DuplicateNamesModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'duplicate-names-modal' },
	        _react2.default.createElement(
	          'span',
	          null,
	          'There seem to be duplicate information on the details that you have provided. Please revisit all the passengers\' details and make sure all the information is correct before proceeding.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'duplicate-names-modal__buttons-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'duplicate-names-modal__buttons-container__button-secondary' },
	            _react2.default.createElement(
	              _LinkButton2.default,
	              { onClick: this.goBack, type: 'secondary', color: 'blue' },
	              'Back to details'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'duplicate-names-modal__buttons-container__button-primary' },
	            _react2.default.createElement(
	              _LinkButton2.default,
	              { onClick: this.continueSubmit, type: 'primary', color: 'blue' },
	              'Continue booking'
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return DuplicateNamesModal;
	}(_react.Component);
	
	exports.default = DuplicateNamesModal;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EmailDeal = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _validationRegexes = __webpack_require__(311);
	
	var _validationRegexes2 = _interopRequireDefault(_validationRegexes);
	
	var _immutable3 = __webpack_require__(472);
	
	var _FormInputWithValidation = __webpack_require__(530);
	
	var _FormInputWithValidation2 = _interopRequireDefault(_FormInputWithValidation);
	
	var _LinkButton = __webpack_require__(65);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	__webpack_require__(913);
	
	__webpack_require__(914);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmailDeal = exports.EmailDeal = function (_Component) {
	  (0, _inherits3.default)(EmailDeal, _Component);
	
	  function EmailDeal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EmailDeal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EmailDeal.__proto__ || (0, _getPrototypeOf2.default)(EmailDeal)).call.apply(_ref, [this].concat(args))), _this), _this.addRecipient = function (fields) {
	      return function (event) {
	        event.preventDefault();
	        fields.push(_immutable2.default.fromJS({}));
	      };
	    }, _this.renderRecipients = function (_ref2) {
	      var fields = _ref2.fields;
	      return _react2.default.createElement(
	        'div',
	        { className: 'email-deal__additional-recipients' },
	        fields.length > 0 && _react2.default.createElement(
	          'h4',
	          null,
	          'Additional email addresses:'
	        ),
	        fields.map(function (recipient) {
	          return _react2.default.createElement(
	            'div',
	            { key: recipient, className: 'email-deal__additional-recipients__recipient' },
	            _react2.default.createElement(_immutable3.Field, { name: recipient + '.emailAddress', component: _FormInputWithValidation2.default, type: 'text', placeholder: 'Email Address' }),
	            _react2.default.createElement(_immutable3.Field, { name: recipient + '.name', component: _FormInputWithValidation2.default, type: 'text', placeholder: 'Name' })
	          );
	        }),
	        _react2.default.createElement(
	          _LinkButton2.default,
	          { color: 'blue', type: 'secondary', onClick: _this.addRecipient(fields) },
	          'Add additional travellers'
	        )
	      );
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EmailDeal, [{
	    key: 'render',
	    value: function render() {
	      var isMobileBreakpoint = this.props.isMobileBreakpoint;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'email-deal' },
	        _react2.default.createElement(
	          'form',
	          { onSubmit: this.handleSubmit },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Email this deal'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'email-deal__sender ' + (!isMobileBreakpoint ? 'email-deal__sender--modal-view' : '') },
	            _react2.default.createElement(
	              'h3',
	              { className: 'email-deal__sender__title' },
	              'Your Contact Details'
	            ),
	            _react2.default.createElement(_immutable3.Field, { name: 'emailAddress', component: _FormInputWithValidation2.default, type: 'text', placeholder: 'Email Address' }),
	            _react2.default.createElement(_immutable3.Field, { name: 'name', component: _FormInputWithValidation2.default, type: 'text', placeholder: 'Name' }),
	            _react2.default.createElement(_immutable3.FieldArray, { name: 'recipients', component: this.renderRecipients }),
	            _react2.default.createElement(
	              _LinkButton2.default,
	              { color: 'blue', onClick: this.props.handleSubmit },
	              'Send deal'
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return EmailDeal;
	}(_react.Component);
	
	EmailDeal.validateRecipient = function (values) {
	  var errors = _immutable2.default.fromJS({});
	
	  if (values && values.get('emailAddress', '') !== '') {
	    if (!_validationRegexes2.default.email.test(values.get('emailAddress'))) {
	      errors = errors.set('emailAddress', 'Invalid email address');
	    }
	  } else {
	    errors = errors.set('emailAddress', 'Required');
	  }
	
	  if (values && values.get('name', '') === '') {
	    errors = errors.set('name', 'Required');
	  }
	
	  if (values.has('recipients')) {
	    errors = errors.set('recipients', values.get('recipients').map(function (recipient) {
	      var recipientErrors = _immutable2.default.fromJS({});
	      if (recipient.has('emailAddress')) {
	        if (!_validationRegexes2.default.email.test(recipient.get('emailAddress'))) {
	          recipientErrors = recipientErrors.set('emailAddress', 'Invalid email address');
	        }
	
	        if (!recipient.has('name')) {
	          recipientErrors = recipientErrors.set('name', 'Required');
	        }
	      } else if (recipient.has('name')) {
	        recipientErrors = recipientErrors.set('emailAddress', 'Required');
	      }
	
	      return recipientErrors;
	    }));
	  }
	
	  return errors.toJS();
	};
	
	var EmailDealForm = (0, _immutable3.reduxForm)({ form: 'email-deal', validate: EmailDeal.validateRecipient })(EmailDeal);
	exports.default = EmailDealForm;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EmailDealResult = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LinkButton = __webpack_require__(65);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _reactTimeout = __webpack_require__(465);
	
	var _reactTimeout2 = _interopRequireDefault(_reactTimeout);
	
	__webpack_require__(915);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmailDealResult = exports.EmailDealResult = function (_Component) {
	  (0, _inherits3.default)(EmailDealResult, _Component);
	
	  function EmailDealResult() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EmailDealResult);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EmailDealResult.__proto__ || (0, _getPrototypeOf2.default)(EmailDealResult)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      timeUntilClose: 5
	    }, _this.tick = function () {
	      var timeUntilClose = _this.state.timeUntilClose;
	
	      if (timeUntilClose > 1) {
	        _this.setState({ timeUntilClose: timeUntilClose - 1 });
	        _this.props.setTimeout(_this.tick, 1000);
	      } else {
	        _this.props.close();
	      }
	    }, _this.handleCloseClick = function (event) {
	      event.preventDefault();
	      _this.props.close();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EmailDealResult, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.setTimeout(this.tick, 1000);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var emailDealResult = this.props.emailDealResult;
	      var timeUntilClose = this.state.timeUntilClose;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'email-deal-result' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Deal sent'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'email-deal-result__message' },
	          emailDealResult && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              'You have successfully shared your basket'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'This window will close in ',
	              timeUntilClose,
	              ' seconds'
	            )
	          ),
	          !emailDealResult && _react2.default.createElement(
	            'div',
	            null,
	            'There was an error. Please try again later'
	          )
	        ),
	        _react2.default.createElement(
	          _LinkButton2.default,
	          { color: 'blue', type: 'secondary', onClick: this.handleCloseClick },
	          'Close Window'
	        )
	      );
	    }
	  }]);
	  return EmailDealResult;
	}(_react.Component);
	
	exports.default = (0, _reactTimeout2.default)(EmailDealResult);

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BookInput = __webpack_require__(510);
	
	var _BookInput2 = _interopRequireDefault(_BookInput);
	
	var _BookCheckbox = __webpack_require__(509);
	
	var _BookCheckbox2 = _interopRequireDefault(_BookCheckbox);
	
	var _svgInlineReact = __webpack_require__(64);
	
	var _svgInlineReact2 = _interopRequireDefault(_svgInlineReact);
	
	var _bell = __webpack_require__(1354);
	
	var _bell2 = _interopRequireDefault(_bell);
	
	__webpack_require__(916);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmailSignUp = function (_PureComponent) {
	  (0, _inherits3.default)(EmailSignUp, _PureComponent);
	
	  function EmailSignUp() {
	    (0, _classCallCheck3.default)(this, EmailSignUp);
	    return (0, _possibleConstructorReturn3.default)(this, (EmailSignUp.__proto__ || (0, _getPrototypeOf2.default)(EmailSignUp)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(EmailSignUp, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          email = _props.email,
	          formName = _props.formName,
	          fullName = _props.fullName,
	          onEmailBlur = _props.onEmailBlur,
	          onNameBlur = _props.onNameBlur,
	          onSubmit = _props.onSubmit,
	          setEmailField = _props.setEmailField,
	          setNameField = _props.setNameField,
	          setSubscribe = _props.setSubscribe,
	          subscribe = _props.subscribe,
	          validation = _props.validation,
	          displayDisclaimer = _props.displayDisclaimer;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'email-sign-up' },
	        _react2.default.createElement(
	          'form',
	          { action: 'POST', onSubmit: onSubmit },
	          _react2.default.createElement(_BookInput2.default, {
	            autoCapitalize: 'words',
	            data: {
	              fieldKey: 'fullName'
	            },
	            formName: formName,
	            isValid: validation.confirmName.isValid(fullName),
	            label: 'Name:',
	            message: validation.confirmName.message,
	            onFieldBlur: onNameBlur,
	            onFieldChange: setNameField,
	            value: fullName
	          }),
	          _react2.default.createElement(_BookInput2.default, {
	            data: {
	              fieldKey: 'email'
	            },
	            formName: formName,
	            isValid: validation.confirmEmail.isValid(email),
	            label: 'Your Email:',
	            message: validation.confirmEmail.message,
	            onFieldBlur: onEmailBlur,
	            onFieldChange: setEmailField,
	            type: 'email',
	            value: email
	          }),
	          _react2.default.createElement(_BookCheckbox2.default, {
	            label: ' Sign up to our offer emails',
	            onFieldChange: setSubscribe,
	            checked: subscribe
	          }),
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'email-sign-up__submit-button' },
	            _react2.default.createElement(_svgInlineReact2.default, { src: _bell2.default, className: 'email-sign-up__submit-button__icon' }),
	            'Sign up for Price Alerts'
	          ),
	          displayDisclaimer && _react2.default.createElement(
	            'p',
	            { className: 'email-sign-up__disclaimer' },
	            'Please note that elements of your holiday may change over the the next 7 days. As a result it may be difficult to track an exact like-for-like holiday price. Please make sure when booking that all details match your original requirements.'
	          )
	        )
	      );
	    }
	  }]);
	  return EmailSignUp;
	}(_react.PureComponent);
	
	EmailSignUp.defaultProps = {
	  displayDisclaimer: false
	};
	exports.default = EmailSignUp;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _LinkSubPage = __webpack_require__(208);
	
	var _LinkSubPage2 = _interopRequireDefault(_LinkSubPage);
	
	__webpack_require__(917);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FauxSelect = function (_Component) {
	  (0, _inherits3.default)(FauxSelect, _Component);
	
	  function FauxSelect() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FauxSelect);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FauxSelect.__proto__ || (0, _getPrototypeOf2.default)(FauxSelect)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _this.handleClick = function (event) {
	      var _this$props = _this.props,
	          url = _this$props.url,
	          onPageChange = _this$props.onPageChange,
	          onClick = _this$props.onClick;
	
	
	      if (url === '#') {
	        event.preventDefault();
	      }
	
	      if (onPageChange) {
	        onPageChange(event);
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FauxSelect, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          type = _props.type,
	          align = _props.align,
	          isOnSearchUnit = _props.isOnSearchUnit,
	          url = _props.url,
	          disabled = _props.disabled,
	          inline = _props.inline,
	          error = _props.error,
	          noArrow = _props.noArrow,
	          label = _props.label,
	          reportSelectFieldClicked = _props.reportSelectFieldClicked,
	          removeFromTabOrder = _props.removeFromTabOrder,
	          location = _props.location;
	
	
	      var tabIndex = removeFromTabOrder ? -1 : 0;
	
	      var fauxSelectInnerClassName = 'faux-select__inner ';
	
	      if (align) {
	        fauxSelectInnerClassName += 'faux-select__inner--align-' + align + ' ';
	      }
	
	      if (type) {
	        fauxSelectInnerClassName += 'faux-select__inner--' + type + ' ';
	      }
	
	      var labelElement = _react2.default.createElement(
	        'label',
	        { className: 'faux-select__label ' + (isOnSearchUnit ? 'faux-select__label--is-on-search-unit' : '') },
	        disabled ? _react2.default.createElement(
	          'span',
	          { className: 'faux-select__link faux-select__link--is-disabled' },
	          label
	        ) : _react2.default.createElement(
	          _LinkSubPage2.default,
	          { to: url, location: location, className: 'faux-select__link', onClick: this.handleClick },
	          label
	        )
	      );
	
	      var controlClassName = 'faux-select__link ' + (noArrow && 'no-arrow');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'faux-select ' + (inline ? 'faux-select--is-inline' : '') + ' ' + (error ? 'faux-select--is-error' : '') },
	        label && labelElement,
	        _react2.default.createElement(
	          'div',
	          { className: fauxSelectInnerClassName + ' faux-select__inner__' + type, onClick: reportSelectFieldClicked },
	          disabled ? _react2.default.createElement(
	            'div',
	            { className: controlClassName + ' faux-select__link--is-disabled' },
	            this.props.children
	          ) : _react2.default.createElement(
	            _LinkSubPage2.default,
	            { to: url, location: location, className: controlClassName, onClick: this.handleClick, tabIndex: tabIndex },
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	  return FauxSelect;
	}(_react.Component);
	
	FauxSelect.defaultProps = {
	  url: '#'
	};
	exports.default = FauxSelect;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(56);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(472);
	
	var _Input = __webpack_require__(531);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	__webpack_require__(918);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormInputWithValidation = function (_Component) {
	  (0, _inherits3.default)(FormInputWithValidation, _Component);
	
	  function FormInputWithValidation() {
	    (0, _classCallCheck3.default)(this, FormInputWithValidation);
	    return (0, _possibleConstructorReturn3.default)(this, (FormInputWithValidation.__proto__ || (0, _getPrototypeOf2.default)(FormInputWithValidation)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FormInputWithValidation, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          input = _props.input,
	          meta = _props.meta,
	          placeholder = _props.placeholder;
	      var touched = meta.touched,
	          error = meta.error;
	
	
	      var showValidationError = error && touched;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-input-with-validation' },
	        _react2.default.createElement(_Input2.default, (0, _extends3.default)({}, input, { invalid: showValidationError, placeholder: placeholder })),
	        showValidationError && _react2.default.createElement(
	          'div',
	          { className: 'form-input-with-validation__message' },
	          error
	        )
	      );
	    }
	  }]);
	  return FormInputWithValidation;
	}(_react.Component);
	
	FormInputWithValidation.defaultProps = {
	  placeholder: null
	};
	exports.default = FormInputWithValidation;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(56);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(32);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(919);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Input = function (_Component) {
	  (0, _inherits3.default)(Input, _Component);
	
	  function Input() {
	    (0, _classCallCheck3.default)(this, Input);
	    return (0, _possibleConstructorReturn3.default)(this, (Input.__proto__ || (0, _getPrototypeOf2.default)(Input)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Input, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          invalid = _props.invalid;
	
	      var childProps = (0, _assign2.default)({}, this.props);
	      delete childProps.invalid;
	      delete childProps.className;
	
	      var invalidClassName = invalid ? className + '--invalid' : '';
	
	      return _react2.default.createElement('input', (0, _extends3.default)({
	        className: className + ' ' + invalidClassName
	      }, childProps));
	    }
	  }]);
	  return Input;
	}(_react.Component);
	
	Input.defaultProps = {
	  className: 'input',
	  invalid: false,
	  onBlur: undefined,
	  onChange: undefined,
	  onDragStart: undefined,
	  onDrop: undefined,
	  onFocus: undefined,
	  placeholder: undefined,
	  value: undefined
	};
	exports.default = Input;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(117);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _svgInlineReact = __webpack_require__(64);
	
	var _svgInlineReact2 = _interopRequireDefault(_svgInlineReact);
	
	var _Tag = __webpack_require__(209);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _LinkSubPage = __webpack_require__(208);
	
	var _LinkSubPage2 = _interopRequireDefault(_LinkSubPage);
	
	var _calendar = __webpack_require__(1355);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	__webpack_require__(921);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinkInput = function (_Component) {
	  (0, _inherits3.default)(LinkInput, _Component);
	
	  function LinkInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, LinkInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LinkInput.__proto__ || (0, _getPrototypeOf2.default)(LinkInput)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _this.saveLinkRef = function (ref) {
	      return _this.linkRef = ref;
	    }, _this.handleClick = function (event) {
	      var _this$props = _this.props,
	          url = _this$props.url,
	          onClick = _this$props.onClick,
	          reportSearchFieldClicked = _this$props.reportSearchFieldClicked;
	
	
	      if (url === '#') {
	        event.preventDefault();
	      }
	
	      if (onClick) {
	        onClick(event, _reactDom2.default.findDOMNode(_this.linkRef));
	      }
	
	      if (reportSearchFieldClicked) {
	        reportSearchFieldClicked(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(LinkInput, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          url = _props.url,
	          hasTag = _props.hasTag,
	          hasCalendarIcon = _props.hasCalendarIcon,
	          children = _props.children,
	          placeholder = _props.placeholder,
	          location = _props.location,
	          label = _props.label,
	          onTagClick = _props.onTagClick;
	
	      var text = children || placeholder;
	      return _react2.default.createElement(
	        'div',
	        { className: 'link-input', ref: this.saveLinkRef },
	        label && _react2.default.createElement(
	          _LinkSubPage2.default,
	          { to: url, location: location, className: 'link-input__label', onClick: this.handleClick, tabIndex: '-1' },
	          label
	        ),
	        hasTag ? _react2.default.createElement(
	          'div',
	          { className: 'link-input__input link-input__input--tag' },
	          _react2.default.createElement(
	            _Tag2.default,
	            { onTagClick: onTagClick },
	            text
	          ),
	          hasCalendarIcon && _react2.default.createElement(
	            _LinkSubPage2.default,
	            {
	              to: url,
	              location: location,
	              onClick: this.handleClick,
	              className: 'link-input__cal-icon__link'
	            },
	            _react2.default.createElement(_svgInlineReact2.default, { src: _calendar2.default, className: 'cal-icon' })
	          )
	        ) : _react2.default.createElement(
	          _LinkSubPage2.default,
	          {
	            to: url,
	            location: location,
	            className: 'link-input__input ' + (children ? '' : 'link-input__input--is-placeholder'),
	            onClick: this.handleClick
	          },
	          text,
	          hasCalendarIcon && _react2.default.createElement(_svgInlineReact2.default, { src: _calendar2.default, className: 'cal-icon' })
	        )
	      );
	    }
	  }]);
	  return LinkInput;
	}(_react.Component);
	
	LinkInput.defaultProps = {
	  placeholder: 'Any',
	  url: '#'
	};
	exports.default = LinkInput;

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.modalTypes = undefined;
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _modalTypes;
	
	exports.getHtmlContent = getHtmlContent;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modal = __webpack_require__(167);
	
	var constants = _interopRequireWildcard(_modal);
	
	var _utils = __webpack_require__(8);
	
	var _RoomFacilitiesOverlayLayout = __webpack_require__(570);
	
	var _RoomFacilitiesOverlayLayout2 = _interopRequireDefault(_RoomFacilitiesOverlayLayout);
	
	var _PriceTrackerSignUpLayout = __webpack_require__(569);
	
	var _PriceTrackerSignUpLayout2 = _interopRequireDefault(_PriceTrackerSignUpLayout);
	
	var _BookTransferReminderLayout = __webpack_require__(562);
	
	var _BookTransferReminderLayout2 = _interopRequireDefault(_BookTransferReminderLayout);
	
	var _BookHandLuggageModalLayout = __webpack_require__(561);
	
	var _BookHandLuggageModalLayout2 = _interopRequireDefault(_BookHandLuggageModalLayout);
	
	var _BookFreeHotelAmendsLayout = __webpack_require__(560);
	
	var _BookFreeHotelAmendsLayout2 = _interopRequireDefault(_BookFreeHotelAmendsLayout);
	
	var _BookSupplierPrincipals = __webpack_require__(511);
	
	var _BookSupplierPrincipals2 = _interopRequireDefault(_BookSupplierPrincipals);
	
	var _ResponsiveGallery = __webpack_require__(540);
	
	var _ResponsiveGallery2 = _interopRequireDefault(_ResponsiveGallery);
	
	var _DuplicateNamesModal = __webpack_require__(525);
	
	var _DuplicateNamesModal2 = _interopRequireDefault(_DuplicateNamesModal);
	
	var _OpeningHoursModal = __webpack_require__(535);
	
	var _OpeningHoursModal2 = _interopRequireDefault(_OpeningHoursModal);
	
	var _PassengerListModal = __webpack_require__(496);
	
	var _PassengerListModal2 = _interopRequireDefault(_PassengerListModal);
	
	var _SeatListModal = __webpack_require__(498);
	
	var _SeatListModal2 = _interopRequireDefault(_SeatListModal);
	
	var _CarHireOptionsList = __webpack_require__(516);
	
	var _CarHireOptionsList2 = _interopRequireDefault(_CarHireOptionsList);
	
	var _CarHireTermsAndConditions = __webpack_require__(518);
	
	var _CarHireTermsAndConditions2 = _interopRequireDefault(_CarHireTermsAndConditions);
	
	var _AssistedBookingStatusLayout = __webpack_require__(559);
	
	var _AssistedBookingStatusLayout2 = _interopRequireDefault(_AssistedBookingStatusLayout);
	
	var _EmailDealLayout = __webpack_require__(565);
	
	var _EmailDealLayout2 = _interopRequireDefault(_EmailDealLayout);
	
	var _RoomOptionsLayout = __webpack_require__(571);
	
	var _RoomOptionsLayout2 = _interopRequireDefault(_RoomOptionsLayout);
	
	var _atol = __webpack_require__(1357);
	
	var _atol2 = _interopRequireDefault(_atol);
	
	var _abta = __webpack_require__(1356);
	
	var _abta2 = _interopRequireDefault(_abta);
	
	var _price_match = __webpack_require__(1361);
	
	var _price_match2 = _interopRequireDefault(_price_match);
	
	var _monthly_payments = __webpack_require__(1359);
	
	var _monthly_payments2 = _interopRequireDefault(_monthly_payments);
	
	var _depositFrom = __webpack_require__(1358);
	
	var _depositFrom2 = _interopRequireDefault(_depositFrom);
	
	var _phone_opening_time = __webpack_require__(1360);
	
	var _phone_opening_time2 = _interopRequireDefault(_phone_opening_time);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var depositPP = 29;
	var depositPPFormatted = (0, _utils.formatPrice)(depositPP);
	
	function getHtmlContent(id) {
	  var html = document.getElementById(id);
	  return html ? { __html: html.innerHTML } : false;
	}
	
	var modalTypes = exports.modalTypes = (_modalTypes = {}, (0, _defineProperty3.default)(_modalTypes, constants.ATOL, {
	  icon: _atol2.default,
	  content: _react2.default.createElement(
	    'article',
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'You can be confident that your holiday is fully ATOL protected, giving you financial protection. We are fully covered by this scheme, giving you complete peace of mind. Our ATOL number is 10989.'
	    )
	  )
	}), (0, _defineProperty3.default)(_modalTypes, constants.ABTA, {
	  icon: _abta2.default,
	  content: _react2.default.createElement(
	    'article',
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'We strive to offer the highest possible standard of service. As full members of ABTA (membership number P6847), we always operate in compliance with the strict Code of Conduct and standards of service. Our customers\u2019 trust is our top priority.'
	    )
	  )
	}), (0, _defineProperty3.default)(_modalTypes, constants.PRICE_MATCH, {
	  icon: _price_match2.default,
	  content: _react2.default.createElement(
	    'article',
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'We want you to love your holiday without worrying about the price. We track millions of prices every day to make sure we offer you the lowest price every time. In addition, we offer a Price Match Guarantee. If you find the same flight and hotel deal anywhere else online, we will match it, subject to standard T&Cs.'
	    )
	  )
	}), (0, _defineProperty3.default)(_modalTypes, constants.WHAT_IS_THIS_PRICE, {
	  content: _react2.default.createElement(
	    'article',
	    null,
	    _react2.default.createElement(
	      'h4',
	      { className: 'modal__content__title' },
	      'What is included in this price?'
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'modal__content__list' },
	      _react2.default.createElement(
	        'li',
	        { className: 'modal__content__list__el' },
	        _react2.default.createElement('i', { className: 'tick-icon', 'aria-hidden': 'true' }),
	        ' Return Flights'
	      ),
	      _react2.default.createElement(
	        'li',
	        { className: 'modal__content__list__el' },
	        _react2.default.createElement('i', { className: 'tick-icon', 'aria-hidden': 'true' }),
	        ' Hotel Accommodation'
	      ),
	      _react2.default.createElement(
	        'li',
	        { className: 'modal__content__list__el' },
	        _react2.default.createElement('i', { className: 'tick-icon', 'aria-hidden': 'true' }),
	        ' Selected Board Basis'
	      ),
	      !(0, _utils.isDomainIe)() && _react2.default.createElement(
	        'li',
	        { className: 'modal__content__list__el' },
	        _react2.default.createElement('i', { className: 'tick-icon', 'aria-hidden': 'true' }),
	        ' Atol and ABTA Protection'
	      ),
	      _react2.default.createElement(
	        'li',
	        { className: 'modal__content__list__el' },
	        _react2.default.createElement('i', { className: 'tick-icon', 'aria-hidden': 'true' }),
	        ' No Booking Fees'
	      ),
	      _react2.default.createElement(
	        'li',
	        { className: 'modal__content__list__el' },
	        _react2.default.createElement('i', { className: 'tick-icon', 'aria-hidden': 'true' }),
	        ' Price Match Guarantee'
	      ),
	      _react2.default.createElement(
	        'li',
	        { className: 'modal__content__list__el' },
	        _react2.default.createElement('i', { className: 'plus-icon', 'aria-hidden': 'true' }),
	        ' Optional Transfer'
	      ),
	      _react2.default.createElement(
	        'li',
	        { className: 'modal__content__list__el' },
	        _react2.default.createElement('i', { className: 'plus-icon', 'aria-hidden': 'true' }),
	        ' Optional Baggage'
	      )
	    )
	  )
	}), (0, _defineProperty3.default)(_modalTypes, constants.ZERO_PERCENT, {
	  icon: _monthly_payments2.default,
	  content: _react2.default.createElement(
	    'article',
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'Don\u2019t be out of pocket. By booking with us, you can spread the cost of your holiday. Just pay a low deposit (starting from ',
	      depositPPFormatted,
	      'pp) and then 0% monthly payments, up until 14 days before you depart.'
	    )
	  )
	}), (0, _defineProperty3.default)(_modalTypes, constants.DEPOSIT_FROM, {
	  icon: _depositFrom2.default,
	  content: _react2.default.createElement(
	    'article',
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'Enjoy the holiday countdown without the financial worry. With us, you can book your holiday with a low deposit from just ',
	      depositPPFormatted,
	      ' per person and pay the final balance up to 14 days before departure. '
	    )
	  )
	}), (0, _defineProperty3.default)(_modalTypes, constants.PHONE_OPENING_TIME, {
	  icon: _phone_opening_time2.default,
	  content: _react2.default.createElement(
	    'article',
	    null,
	    _react2.default.createElement(_OpeningHoursModal2.default, null)
	  )
	}), (0, _defineProperty3.default)(_modalTypes, constants.TERMS_CONDITIONS_AGENCY, {
	  content: _react2.default.createElement(
	    'article',
	    null,
	    getHtmlContent('TCContent') && _react2.default.createElement('div', { dangerouslySetInnerHTML: getHtmlContent('TCContent') })
	  )
	}), (0, _defineProperty3.default)(_modalTypes, constants.TERMS_CONDITIONS_SUPPLIER, {
	  content: _react2.default.createElement(
	    'article',
	    null,
	    _react2.default.createElement(_BookSupplierPrincipals2.default, null)
	  )
	}), (0, _defineProperty3.default)(_modalTypes, constants.FACILITIES_LIST, function (modal) {
	  return {
	    content: _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Facilities'
	      ),
	      _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: modal.config.content } })
	    )
	  };
	}), (0, _defineProperty3.default)(_modalTypes, constants.FACILITIES_OVERVIEW, function (modal) {
	  return {
	    content: _react2.default.createElement(_RoomFacilitiesOverlayLayout2.default, {
	      facilities: modal.config.facilities,
	      images: modal.config.images,
	      overlayText: modal.config.overlayText,
	      width: modal.config.width,
	      slideWidth: modal.config.slideWidth,
	      title: modal.config.title,
	      mainImageType: modal.config.mainImageType,
	      thumbnailImageType: modal.config.thumbnailImageType,
	      disableThumbnails: modal.config.disableThumbnails
	    })
	  };
	}), (0, _defineProperty3.default)(_modalTypes, constants.FACILITIES_OVERVIEW_GALLERY, function (modal) {
	  return {
	    content: _react2.default.createElement(_ResponsiveGallery2.default, {
	      images: modal.config.images,
	      mainImageType: modal.config.mainImageType,
	      loopImages: modal.config.loopImages
	    })
	  };
	}), (0, _defineProperty3.default)(_modalTypes, constants.PRICE_TRACKER, function (modal) {
	  return {
	    content: _react2.default.createElement(_PriceTrackerSignUpLayout2.default, {
	      location: modal.config.location,
	      isCheapestFlight: modal.config.isCheapestFlight,
	      isModal: modal.config.isModal
	    })
	  };
	}), (0, _defineProperty3.default)(_modalTypes, constants.HAND_LUGGAGE, function (modal) {
	  return {
	    content: _react2.default.createElement(_BookHandLuggageModalLayout2.default, {
	      airlineBaggage: modal.config.airlineBaggage
	    })
	  };
	}), (0, _defineProperty3.default)(_modalTypes, constants.TRANSFER_REMINDER, function (modal) {
	  return {
	    content: _react2.default.createElement(_BookTransferReminderLayout2.default, {
	      onSubmit: modal.config.onSubmit
	    })
	  };
	}), (0, _defineProperty3.default)(_modalTypes, constants.FREE_HOTEL_AMENDS, function (modal) {
	  return {
	    content: _react2.default.createElement(_BookFreeHotelAmendsLayout2.default, {
	      onSubmit: modal.config.onSubmit
	    })
	  };
	}), (0, _defineProperty3.default)(_modalTypes, constants.CHECK_DUPLICATE_NAMES, function (modal) {
	  return {
	    content: _react2.default.createElement(_DuplicateNamesModal2.default, {
	      onSubmit: modal.config.onSubmit,
	      onGoBack: modal.config.toggleModalBound,
	      onContinue: function onContinue() {
	        modal.config.toggleModalBound();modal.config.postForm();
	      }
	    })
	  };
	}), (0, _defineProperty3.default)(_modalTypes, constants.ASSISTED_BOOKING_STATUS, function () {
	  return {
	    content: _react2.default.createElement(_AssistedBookingStatusLayout2.default, null)
	  };
	}), (0, _defineProperty3.default)(_modalTypes, constants.EMAIL_DEAL, function () {
	  return {
	    content: _react2.default.createElement(_EmailDealLayout2.default, null)
	  };
	}), (0, _defineProperty3.default)(_modalTypes, constants.ROOM_OPTIONS, function () {
	  return {
	    content: _react2.default.createElement(_RoomOptionsLayout2.default, null)
	  };
	}), (0, _defineProperty3.default)(_modalTypes, constants.AIRLINE_PASSENGER_LIST, function () {
	  return {
	    content: _react2.default.createElement(_PassengerListModal2.default, null)
	  };
	}), (0, _defineProperty3.default)(_modalTypes, constants.AIRLINE_SEAT_LIST, function (modal) {
	  return {
	    content: _react2.default.createElement(_SeatListModal2.default, modal.config)
	  };
	}), (0, _defineProperty3.default)(_modalTypes, constants.CAR_HIRE_OPTIONS, function (modal) {
	  return {
	    content: _react2.default.createElement(_CarHireOptionsList2.default, modal.config)
	  };
	}), (0, _defineProperty3.default)(_modalTypes, constants.CAR_TERMS_AND_CONDITIONS, function (modal) {
	  return {
	    content: _react2.default.createElement(_CarHireTermsAndConditions2.default, modal.config)
	  };
	}), _modalTypes);
	
	var getModalData = function getModalData(modal) {
	  var modalData = modalTypes[modal.name];
	  return typeof modalData === 'function' ? modalData(modal) : modalData;
	};
	
	exports.default = getModalData;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(8);
	
	var _dates = __webpack_require__(35);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	__webpack_require__(925);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MonthCalendar = function (_Component) {
	  (0, _inherits3.default)(MonthCalendar, _Component);
	
	  function MonthCalendar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, MonthCalendar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MonthCalendar.__proto__ || (0, _getPrototypeOf2.default)(MonthCalendar)).call.apply(_ref, [this].concat(args))), _this), _this.handleMonthClick = function (event) {
	      event.preventDefault();
	
	      var value = event.currentTarget.dataset.value;
	      _this.props.onSelectMonth(value);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(MonthCalendar, [{
	    key: 'getMonthsCollection',
	    value: function getMonthsCollection() {
	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _dates2.default.utcDate();
	      var numberOfMonths = this.props.numberOfMonths;
	
	
	      date.setDate(1);
	      var monthsCollection = [];
	
	      for (var i = 0; i < numberOfMonths; i++) {
	        var timestamp = Date.UTC(date.getFullYear(), date.getMonth() + i, 1);
	        var calDate = timestamp / _utils.dayInMilliseconds;
	        var monthAndYearText = _dates2.default.format(timestamp, 'MMM YYYY');
	
	        monthsCollection.push({
	          name: monthAndYearText,
	          value: '' + calDate
	        });
	      }
	
	      return monthsCollection;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var months = this.getMonthsCollection();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'month-calendar' },
	        _react2.default.createElement(
	          'div',
	          { className: 'month-calendar__months' },
	          months.map(function (_ref2) {
	            var name = _ref2.name,
	                value = _ref2.value;
	            return _react2.default.createElement(
	              'div',
	              { key: value, className: 'month-calendar__month' },
	              _react2.default.createElement(
	                'button',
	                { className: 'month-calendar__month-button', 'data-value': value, onClick: _this2.handleMonthClick },
	                name
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	  return MonthCalendar;
	}(_react.Component);
	
	MonthCalendar.defaultProps = {
	  numberOfMonths: 15
	};
	exports.default = MonthCalendar;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OpeningHoursModal = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	__webpack_require__(926);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    appState: state.appState
	  };
	};
	
	var OpeningHoursModal = exports.OpeningHoursModal = function (_Component) {
	  (0, _inherits3.default)(OpeningHoursModal, _Component);
	
	  function OpeningHoursModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, OpeningHoursModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = OpeningHoursModal.__proto__ || (0, _getPrototypeOf2.default)(OpeningHoursModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.shouldComponentUpdate = _function2.default, _this.toggleSalesTeamHours = function (event) {
	      event.preventDefault();
	      _this.setState({
	        toggleSalesTeamHours: !_this.state.toggleSalesTeamHours
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(OpeningHoursModal, [{
	    key: 'render',
	    value: function render() {
	      var appState = this.props.appState;
	
	
	      var landlinePhone = appState.get('landlinePhone');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'opening-hours-modal' },
	        this.state.toggleSalesTeamHours ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            { className: 'opening-hours-modal__heading' },
	            'After Sales Team'
	          ),
	          _react2.default.createElement(
	            'a',
	            { className: 'opening-hours-modal__number', href: 'tel:01903 258 288' },
	            '01903 258 288'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'opening-hours-modal__list' },
	            _react2.default.createElement(
	              'li',
	              { className: 'opening-hours-modal__list__el' },
	              _react2.default.createElement(
	                'span',
	                { className: 'opening-hours-modal__list__el__days' },
	                'Monday to Sunday:'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'opening-hours-modal__list__el__time' },
	                '9am to 5pm'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '#', className: 'opening-hours-modal__view-toggle', onClick: this.toggleSalesTeamHours },
	              'New Booking Information'
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            { className: 'opening-hours-modal__heading' },
	            'New Booking Information'
	          ),
	          landlinePhone && _react2.default.createElement(
	            'a',
	            { className: 'opening-hours-modal__number', href: 'tel:' + landlinePhone },
	            landlinePhone
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'opening-hours-modal__list' },
	            _react2.default.createElement(
	              'li',
	              { className: 'opening-hours-modal__list__el' },
	              _react2.default.createElement(
	                'span',
	                { className: 'opening-hours-modal__list__el__days' },
	                'Monday to Friday:'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'opening-hours-modal__list__el__time' },
	                '8am to 11pm'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'opening-hours-modal__list__el' },
	              _react2.default.createElement(
	                'span',
	                { className: 'opening-hours-modal__list__el__days' },
	                'Saturday:'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'opening-hours-modal__list__el__time' },
	                '8am to 10pm'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'opening-hours-modal__list__el' },
	              _react2.default.createElement(
	                'span',
	                { className: 'opening-hours-modal__list__el__days' },
	                'Sunday:'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'opening-hours-modal__list__el__time' },
	                '9am to 10pm'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'opening-hours-modal__list__el' },
	              _react2.default.createElement(
	                'span',
	                { className: 'opening-hours-modal__list__el__days' },
	                'Bank Holidays:'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'opening-hours-modal__list__el__time' },
	                '10am to 10pm'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '#', className: 'opening-hours-modal__view-toggle', onClick: this.toggleSalesTeamHours },
	              'Customer Service Information'
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return OpeningHoursModal;
	}(_react.Component);
	
	OpeningHoursModal.defaultProps = {
	  appState: _immutable2.default.Map()
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(OpeningHoursModal);

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.baseClass = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _utils = __webpack_require__(8);
	
	var _Loading = __webpack_require__(164);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _BookPrice = __webpack_require__(139);
	
	var _BookPrice2 = _interopRequireDefault(_BookPrice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var baseClass = exports.baseClass = 'panda-calendar__table__page__day';
	
	var highlightMapModifiers = {
	  unavailable: 'is-unavailable',
	  selected: 'is-during-duration',
	  depart: 'is-departure',
	  checkin: 'is-check-in',
	  return: 'is-return-date'
	};
	
	function getHighlight(date) {
	  var highlights = '';
	
	  if (date.highlight) {
	    highlights += ' ' + baseClass + '--' + highlightMapModifiers[date.highlight];
	  }
	
	  if (date.cheapest) {
	    highlights += ' ' + baseClass + '--is-cheapest';
	  }
	
	  return '' + baseClass + highlights;
	}
	
	var CalDate = function (_Component) {
	  (0, _inherits3.default)(CalDate, _Component);
	
	  function CalDate() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalDate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalDate.__proto__ || (0, _getPrototypeOf2.default)(CalDate)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _this.handleDateClick = function (e) {
	      e.preventDefault();
	      var theDate = _this.props.date;
	      var calDate = Date.UTC(theDate.year, theDate.month, theDate.day) / _utils.dayInMilliseconds;
	      _this.props.onClickDate(calDate);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalDate, [{
	    key: 'isCurrentMonth',
	    value: function isCurrentMonth(month) {
	      return month === this.props.date.month;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          date = _props.date,
	          showPlaneIcon = _props.showPlaneIcon,
	          showPricePerNight = _props.showPricePerNight,
	          numberOfNights = _props.numberOfNights;
	
	
	      var isSpinning = date && date.highlight === 'depart' && this.props.appState.get('loadingState');
	
	      var divisor = showPricePerNight ? numberOfNights : 1;
	
	      var listItem = void 0;
	
	      if (date) {
	        var dateContents = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'time',
	            {
	              dateTime: date.year + '-' + (date.month + 1) + '-' + date.day,
	              className: '' + (showPlaneIcon ? baseClass + '__number ' + baseClass + '__number--plane' : baseClass + '__number')
	            },
	            date.day
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: baseClass + '__price' },
	            !isSpinning && !!date.price && _react2.default.createElement(_BookPrice2.default, { price: date.price, isRounded: true, isStrong: false, divisor: divisor })
	          )
	        );
	
	        listItem = _react2.default.createElement(
	          'td',
	          { className: getHighlight(date) + ' ' + (this.isCurrentMonth(date.month) ? '' : baseClass + '--is-not-this-month') },
	          date.price && date.highlight !== 'depart' ? _react2.default.createElement(
	            'a',
	            {
	              href: '#',
	              className: baseClass + '__link',
	              onClick: this.handleDateClick
	            },
	            dateContents
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            dateContents
	          ),
	          date.highlight === 'depart' && _react2.default.createElement(_Loading2.default, { loadingState: this.props.appState.get('loadingState'), isSmall: true })
	        );
	      } else {
	        listItem = _react2.default.createElement(
	          'td',
	          { className: baseClass + '--is-not-this-month ' + baseClass },
	          _react2.default.createElement('time', { className: '' + (showPlaneIcon ? baseClass + '__number ' + baseClass + '__number--plane' : baseClass + '__number') }),
	          _react2.default.createElement('div', { className: baseClass + '__price' })
	        );
	      }
	
	      return listItem;
	    }
	  }]);
	  return CalDate;
	}(_react.Component);
	
	exports.default = CalDate;

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _FauxSelect = __webpack_require__(529);
	
	var _FauxSelect2 = _interopRequireDefault(_FauxSelect);
	
	var _BookSelect = __webpack_require__(207);
	
	var _BookSelect2 = _interopRequireDefault(_BookSelect);
	
	var _calendar = __webpack_require__(95);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _dates = __webpack_require__(35);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _utils = __webpack_require__(8);
	
	var _optimizely = __webpack_require__(30);
	
	var optimizelyUtil = _interopRequireWildcard(_optimizely);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _global = __webpack_require__(79);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _Date = __webpack_require__(536);
	
	var _Date2 = _interopRequireDefault(_Date);
	
	__webpack_require__(928);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PandaCalendar = function (_Component) {
	  (0, _inherits3.default)(PandaCalendar, _Component);
	
	  function PandaCalendar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PandaCalendar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PandaCalendar.__proto__ || (0, _getPrototypeOf2.default)(PandaCalendar)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _this.onMonthChange = function (event) {
	      var onClickDate = _this.props.onClickDate;
	
	
	      onClickDate(event.currentTarget.value);
	    }, _this.handleCalendarInteraction = function () {
	      optimizelyUtil.fireEvent('PandaCalendar', 'clicked');
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PandaCalendar, [{
	    key: 'getCalendarDatesArray',
	    value: function getCalendarDatesArray(selectedYear, selectedMonth) {
	      var monthDays = [];
	      var firstOfSelectedMonth = new Date(selectedYear, selectedMonth, 1);
	      var monthLength = _dates2.default.numDaysInMonth(selectedYear, selectedMonth);
	
	      var dayOfWeekOfFirst = firstOfSelectedMonth.getDay();
	      // take a day off before getting dayOfWeek so that monday=0
	      var dayOfWeek = dayOfWeekOfFirst === 0 ? 6 : dayOfWeekOfFirst - 1;
	
	      for (var i = 0; i < monthLength; i++) {
	        monthDays[i] = {
	          day: i + 1,
	          year: selectedYear,
	          month: selectedMonth
	        };
	      }
	
	      for (var _i = 0; _i < dayOfWeek; _i++) {
	        monthDays.unshift(null);
	      }
	
	      var remainingDates = 7 - monthDays.length % 7;
	
	      if (remainingDates !== 7) {
	        for (var _i2 = 0; _i2 < remainingDates; _i2++) {
	          monthDays.push(null);
	        }
	      }
	
	      return monthDays;
	    }
	  }, {
	    key: 'getBlankCalendarDatesArray',
	    value: function getBlankCalendarDatesArray() {
	      var monthDays = [];
	      var rows = 5;
	      var numDays = 7 * rows;
	
	      for (var i = 0; i < numDays; i++) {
	        monthDays.push(null);
	      }
	
	      return monthDays;
	    }
	  }, {
	    key: 'poundsToPence',
	    value: function poundsToPence(price) {
	      return price && price * 100;
	    }
	  }, {
	    key: 'perPersonToTotalPrice',
	    value: function perPersonToTotalPrice(price) {
	      var numberOfChargeablePassengers = this.props.numberOfChargeablePassengers;
	
	      return price * numberOfChargeablePassengers;
	    }
	  }, {
	    key: 'attachPricesAndHighlightsToMonth',
	    value: function attachPricesAndHighlightsToMonth(datesArray, monthWithPrices, departureTime) {
	      var _this2 = this;
	
	      var _props = this.props,
	          isPriceInPence = _props.isPriceInPence,
	          numberOfNights = _props.numberOfNights,
	          offer = _props.offer,
	          onlyHighlightSelectedDate = _props.onlyHighlightSelectedDate,
	          showPricePerNight = _props.showPricePerNight;
	
	
	      var multipleDaysInMs = _utils.dayInMilliseconds * numberOfNights;
	
	      datesArray.map(function (date) {
	        if (date) {
	          date.price = monthWithPrices.get('' + date.day);
	
	          date.highlight = '';
	
	          if (!date.price) {
	            date.highlight = 'unavailable';
	          } else if (!isPriceInPence) {
	            // we need the price in pence
	            date.price = _this2.poundsToPence(date.price);
	          }
	
	          if (showPricePerNight) {
	            date.price = _this2.perPersonToTotalPrice(date.price);
	          }
	
	          var theDate = new Date(Date.UTC(date.year, date.month, date.day));
	          var iterationTime = theDate.getTime();
	          var returnTime = departureTime + multipleDaysInMs;
	
	          if (iterationTime > departureTime && iterationTime < returnTime && !onlyHighlightSelectedDate) {
	            date.highlight = 'selected';
	          } else if (iterationTime === departureTime) {
	            date.highlight = onlyHighlightSelectedDate ? 'checkin' : 'depart';
	
	            // use the offer price if it's available
	            var discountPrice = offer.get('discountPrice', false);
	            var discountPriceInPence = isPriceInPence ? discountPrice : _this2.poundsToPence(discountPrice);
	            date.price = discountPrice ? discountPriceInPence : date.price;
	          } else if (iterationTime === returnTime && !onlyHighlightSelectedDate) {
	            date.highlight = 'return';
	          }
	        }
	      });
	    }
	  }, {
	    key: 'getMonthAvailabilityObject',
	    value: function getMonthAvailabilityObject(baseStateTime) {
	      var datesArray = this.getBlankCalendarDatesArray();
	
	      if (baseStateTime) {
	        var selectedDate = new Date(baseStateTime);
	        var selectedMonth = selectedDate.getMonth();
	        var selectedYear = selectedDate.getFullYear();
	
	        var annualAvailabilityMonth = this.props.annualAvailability.getIn(['' + selectedYear, '' + selectedMonth]);
	
	        if (annualAvailabilityMonth) {
	          datesArray = this.getCalendarDatesArray(selectedYear, selectedMonth);
	          this.attachPricesAndHighlightsToMonth(datesArray, annualAvailabilityMonth, baseStateTime);
	
	          this.flagCheapestOfMonth(datesArray);
	        }
	      }
	
	      return datesArray;
	    }
	  }, {
	    key: 'flagCheapestOfMonth',
	    value: function flagCheapestOfMonth(datesArray) {
	      var arrayOfPrices = datesArray.filter(function (date) {
	        return !!date;
	      }).map(function (date) {
	        return (0, _utils.round)(date.price);
	      }).filter(function (price) {
	        return !isNaN(price);
	      });
	
	      var cheapestPrice = Math.min.apply(null, arrayOfPrices);
	
	      datesArray.map(function (date) {
	        if (date && cheapestPrice === (0, _utils.round)(date.price)) {
	          date.cheapest = true;
	        }
	      });
	    }
	  }, {
	    key: 'getCheapestDayOfMonth',
	    value: function getCheapestDayOfMonth(monthObj) {
	      var cheapestDay = void 0;
	      var cheapestPrice = void 0;
	
	      monthObj.map(function (price, day) {
	        if (!cheapestPrice || price < cheapestPrice) {
	          cheapestPrice = price;
	          cheapestDay = day;
	        }
	      });
	
	      return cheapestDay;
	    }
	  }, {
	    key: 'getCalDate',
	    value: function getCalDate() {
	      var _props2 = this.props,
	          annualAvailability = _props2.annualAvailability,
	          baseState = _props2.baseState,
	          isDP = _props2.isDP;
	
	
	      var isPanda = true;
	
	      return _calendar2.default.getDepartureDate(baseState, isPanda, isDP, annualAvailability);
	    }
	  }, {
	    key: 'getAvailableMonthsCollection',
	    value: function getAvailableMonthsCollection() {
	      var _this3 = this;
	
	      var annualAvailability = this.props.annualAvailability;
	
	      var yearKeys = annualAvailability.keySeq().toArray();
	
	      var availableMonthsCollection = [];
	      var calDateFromBaseState = this.getCalDate() * _utils.dayInMilliseconds;
	      var calDateMonthAndYearText = _dates2.default.format(calDateFromBaseState, 'MMMM YYYY');
	
	      yearKeys.sort().map(function (year) {
	        var yearObj = annualAvailability.get('' + year, _immutable2.default.List());
	
	        if (yearObj.size) {
	          yearObj.map(function (item, monthNum) {
	            if (item) {
	              var cheapestDayOfMonth = _this3.getCheapestDayOfMonth(item);
	              var cheapestOfMonthDate = new Date(Date.UTC(year, monthNum, cheapestDayOfMonth));
	              var calDate = cheapestOfMonthDate.getTime() / _utils.dayInMilliseconds;
	              var monthAndYearText = _dates2.default.format(cheapestOfMonthDate, 'MMMM YYYY');
	
	              availableMonthsCollection.push({
	                label: monthAndYearText,
	                value: calDate,
	                checked: monthAndYearText === calDateMonthAndYearText
	              });
	            }
	          });
	        }
	      });
	
	      return availableMonthsCollection;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          appState = _props3.appState,
	          baseState = _props3.baseState,
	          disableFooter = _props3.disableFooter,
	          disableHeader = _props3.disableHeader,
	          disableIcons = _props3.disableIcons,
	          featureFlags = _props3.featureFlags,
	          isMobileUI = _props3.isMobileUI,
	          noResults = _props3.noResults,
	          numberOfNights = _props3.numberOfNights,
	          onClickDate = _props3.onClickDate,
	          onPageChange = _props3.onPageChange,
	          showPricePerNight = _props3.showPricePerNight;
	
	
	      var baseStateTime = this.getCalDate() * _utils.dayInMilliseconds;
	      var dateCollection = this.getMonthAvailabilityObject(baseStateTime);
	      var availableMonthsCollection = this.getAvailableMonthsCollection();
	      var currentMonth = availableMonthsCollection[this.currentMonthIndex] || {};
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'panda-calendar' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panda-calendar__inner' },
	          isMobileUI ? _react2.default.createElement(
	            'div',
	            { className: 'panda-calendar__month' },
	            _react2.default.createElement(
	              _FauxSelect2.default,
	              {
	                label: featureFlags.get('PandaCalendarLabelV1') ? 'Change selected date:' : 'Select a date',
	                url: 'change-month',
	                location: location,
	                align: 'center',
	                onPageChange: onPageChange,
	                disabled: noResults
	              },
	              !baseStateTime || baseStateTime === _global2.default.defaultBridgeDate ? 'Loading' : _dates2.default.format(baseStateTime, 'MMMM YYYY')
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            !disableHeader && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h3',
	                { className: 'panda-calendar__heading' },
	                'Selected date'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'panda-calendar__month' },
	                _react2.default.createElement(_BookSelect2.default, {
	                  onFieldChange: this.onMonthChange,
	                  label: 'Month:',
	                  value: currentMonth.value,
	                  options: availableMonthsCollection,
	                  hideLabel: true
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'table',
	            { className: 'panda-calendar__table', onClick: this.handleCalendarInteraction },
	            _react2.default.createElement(
	              'thead',
	              { className: 'panda-calendar__table__legend' },
	              _react2.default.createElement(
	                'tr',
	                null,
	                ['M', 'T', 'W', 'T', 'F', 'S', 'S'].map(function (day, index) {
	                  return _react2.default.createElement(
	                    'th',
	                    { key: index, className: 'panda-calendar__table__legend__day' },
	                    day
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              { className: 'panda-calendar__table__page' },
	              (0, _utils.range)(Math.ceil(dateCollection.length / 7)).map(function (val, trIndex) {
	                return _react2.default.createElement(
	                  'tr',
	                  { key: trIndex },
	                  dateCollection.splice(0, 7).map(function (date, index) {
	                    return _react2.default.createElement(_Date2.default, {
	                      appState: appState,
	                      baseState: baseState,
	                      date: date,
	                      key: index,
	                      numberOfNights: numberOfNights,
	                      onClickDate: onClickDate,
	                      showPricePerNight: showPricePerNight,
	                      showPlaneIcon: !disableIcons
	                    });
	                  })
	                );
	              })
	            )
	          ),
	          !disableFooter && _react2.default.createElement(
	            'div',
	            { className: 'panda-calendar__footer' },
	            _react2.default.createElement(
	              'span',
	              { className: 'panda-calendar__footer__key' },
	              (0, _utils.isCurrencyEur)() ? '€' : '£'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'panda-calendar__footer__text' },
	              ' = Cheapest'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'currentMonthIndex',
	    get: function get() {
	      var availableMonthsCollection = this.getAvailableMonthsCollection();
	
	      return availableMonthsCollection.findIndex(function (element) {
	        return !!element.checked;
	      });
	    }
	  }]);
	  return PandaCalendar;
	}(_react.Component);
	
	PandaCalendar.defaultProps = {
	  annualAvailability: _immutable2.default.Map(),
	  appState: _immutable2.default.Map(),
	  baseState: _immutable2.default.Map(),
	  disableFooter: false,
	  disableHeader: false,
	  disableIcons: false,
	  isDP: false,
	  isMobileUI: false,
	  offer: _immutable2.default.Map(),
	  onClickDate: false,
	  onlyHighlightSelectedDate: false,
	  showPricePerNight: false
	};
	exports.default = PandaCalendar;

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(8);
	
	__webpack_require__(929);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Popover = function (_Component) {
	  (0, _inherits3.default)(Popover, _Component);
	
	  function Popover() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Popover);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).call.apply(_ref, [this].concat(args))), _this), _this.handleWindowResize = function () {
	      _this.forceUpdate();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Popover, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.debouncedResizeHandler = (0, _utils.debounce)(this.handleWindowResize, 150);
	      window.addEventListener('resize', this.debouncedResizeHandler);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.debouncedResizeHandler);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          body = _props.body,
	          popoverState = _props.popoverState,
	          hasCloseButton = _props.hasCloseButton,
	          closePopover = _props.closePopover;
	
	      var position = this.props.position;
	
	      var boundingClientRect = popoverState.relativeRef ? popoverState.relativeRef.getBoundingClientRect() : popoverState.boundingClientRect;
	      var coordinates = (0, _utils.getCoordinatesRelativeToDocument)(boundingClientRect);
	
	      var pointerSize = 15;
	      var popoverWidth = 300;
	
	      var positionStyles = {};
	
	      if (position === 'auto') {
	        position = boundingClientRect.top < window.innerHeight / 2 ? 'top' : 'bottom';
	      }
	
	      if ((position === 'top' || position === 'bottom') && boundingClientRect) {
	        positionStyles.left = coordinates.left - popoverWidth / 2 + boundingClientRect.width / 2;
	      }
	
	      if (position === 'top' && boundingClientRect) {
	        positionStyles.top = coordinates.top + boundingClientRect.height + pointerSize;
	      }
	
	      if (position === 'bottom' && boundingClientRect) {
	        positionStyles.top = coordinates.top - pointerSize;
	      }
	
	      if ((position === 'left' || position === 'right') && boundingClientRect) {
	        positionStyles.top = coordinates.top;
	      }
	
	      if (position === 'left' && boundingClientRect) {
	        positionStyles.left = coordinates.left - popoverWidth - pointerSize;
	      }
	
	      if (position === 'right' && boundingClientRect) {
	        positionStyles.left = coordinates.left + boundingClientRect.width + pointerSize;
	      }
	
	      if (popoverState.yOffset) {
	        positionStyles.top += popoverState.yOffset;
	      }
	
	      var pointyThingStyles = {};
	
	      // Now adjust the position if we have gone off the left or right of the screen
	      if (['top', 'bottom'].includes(position)) {
	        var adjustX = 0;
	
	        if (popoverWidth + positionStyles.left > window.innerWidth) {
	          adjustX = window.innerWidth - (positionStyles.left + popoverWidth);
	          positionStyles.left += adjustX;
	        } else if (positionStyles.left < 0) {
	          adjustX = (positionStyles.left - 8) * -1;
	          positionStyles.left += adjustX;
	        }
	
	        pointyThingStyles.left = popoverWidth / 2 - adjustX;
	      }
	
	      // -component added as unique name to prevent conflicts within website project Hotel Only Multi-Room
	      // Remove -component if website project CSS is removed
	      return _react2.default.createElement(
	        'div',
	        { className: 'popover-component', style: positionStyles },
	        _react2.default.createElement(
	          'div',
	          { className: 'popover-component__content popover-component__content--' + position },
	          _react2.default.createElement('div', { className: 'popover-component__content__pointy-thing popover-component__content__pointy-thing--' + position, style: pointyThingStyles }),
	          hasCloseButton && _react2.default.createElement(
	            'a',
	            { href: '#', className: 'popover-component__close-button', onClick: closePopover },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Close'
	            )
	          ),
	          !!title && _react2.default.createElement(
	            'h3',
	            { className: 'popover-component__title' },
	            title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'popover-component__text' },
	            typeof body === 'string' ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: body } }) : body
	          )
	        )
	      );
	    }
	  }]);
	  return Popover;
	}(_react.Component);
	
	Popover.defaultProps = {
	  title: '',
	  body: '',
	  position: 'top',
	  popoverState: {}
	};
	exports.default = Popover;

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	__webpack_require__(930);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PriceTrackerSummary = function (_Component) {
	  (0, _inherits3.default)(PriceTrackerSummary, _Component);
	
	  function PriceTrackerSummary() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PriceTrackerSummary);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PriceTrackerSummary.__proto__ || (0, _getPrototypeOf2.default)(PriceTrackerSummary)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PriceTrackerSummary, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          boardBasis = _props.boardBasis,
	          destination = _props.destination,
	          duration = _props.duration,
	          flightDetails = _props.flightDetails,
	          hotelName = _props.hotelName,
	          isCheapestFlight = _props.isCheapestFlight;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'price-tracker-summary' },
	        _react2.default.createElement(
	          'div',
	          { className: 'price-tracker-summary__hotel-details' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'price-tracker-summary__hotel-details__hotel-name' },
	            hotelName
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'in ',
	            destination
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            duration,
	            ' nights, ',
	            boardBasis
	          )
	        ),
	        !!flightDetails && _react2.default.createElement(
	          'div',
	          { className: 'price-tracker-summary__flight-details' },
	          _react2.default.createElement(
	            'div',
	            { className: 'price-tracker-summary__flight-details__outbound' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Outbound:'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              flightDetails.outboundDate
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              flightDetails.outboundDepartureTime,
	              ' ',
	              flightDetails.outboundDepartureName,
	              ' - ',
	              flightDetails.outboundArrivalTime,
	              ' ',
	              flightDetails.outboundArrivalName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'price-tracker-summary__flight-details__inbound' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Inbound:'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              flightDetails.inboundDate
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              flightDetails.inboundDepartureTime,
	              ' ',
	              flightDetails.inboundDepartureName,
	              ' - ',
	              flightDetails.inboundArrivalTime,
	              ' ',
	              flightDetails.inboundArrivalName
	            )
	          )
	        ),
	        isCheapestFlight && _react2.default.createElement(
	          'div',
	          { className: 'price-tracker-summary__cheapest-flight' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            '+ Cheapest Flight'
	          )
	        )
	      );
	    }
	  }]);
	  return PriceTrackerSummary;
	}(_react.Component);
	
	exports.default = PriceTrackerSummary;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ResponsiveGallery = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _global = __webpack_require__(79);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _svgInlineReact = __webpack_require__(64);
	
	var _svgInlineReact2 = _interopRequireDefault(_svgInlineReact);
	
	var _modalActions = __webpack_require__(40);
	
	var _optimizely = __webpack_require__(30);
	
	var optimizelyUtil = _interopRequireWildcard(_optimizely);
	
	var _close = __webpack_require__(1366);
	
	var _close2 = _interopRequireDefault(_close);
	
	__webpack_require__(931);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    appState: state.appState
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    toggleModalBound: function toggleModalBound() {
	      return dispatch((0, _modalActions.toggleModal)(''));
	    }
	  };
	}
	
	var ResponsiveGallery = exports.ResponsiveGallery = function (_Component) {
	  (0, _inherits3.default)(ResponsiveGallery, _Component);
	
	  function ResponsiveGallery() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ResponsiveGallery);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ResponsiveGallery.__proto__ || (0, _getPrototypeOf2.default)(ResponsiveGallery)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      currentImageIndex: 0
	    }, _this.shouldComponentUpdate = _function2.default, _this.onPrevClick = function (event) {
	      var _this$props = _this.props,
	          images = _this$props.images,
	          loopImages = _this$props.loopImages;
	
	      var prevFromFirst = loopImages ? images.size - 1 : 0;
	
	      if (event) {
	        event.preventDefault();
	      }
	
	      _this.setState({
	        currentImageIndex: _this.currentImageIndex !== 0 ? _this.currentImageIndex - 1 : prevFromFirst
	      });
	    }, _this.onNextClick = function (event) {
	      var _this$props2 = _this.props,
	          images = _this$props2.images,
	          loopImages = _this$props2.loopImages;
	
	      var nextFromLast = loopImages ? 0 : images.size - 1;
	
	      if (event) {
	        event.preventDefault();
	      }
	
	      _this.setState({
	        currentImageIndex: _this.currentImageIndex < images.size - 1 ? _this.currentImageIndex + 1 : nextFromLast
	      });
	    }, _this.closeModal = function (event) {
	      event.preventDefault();
	      _this.props.toggleModalBound(event);
	    }, _this.closeModalWithEscape = function (event) {
	      var escapeKeycode = 27;
	
	      if (event.keyCode === escapeKeycode) {
	        _this.props.toggleModalBound(event);
	      }
	    }, _this.trackOptimizely = function () {
	      optimizelyUtil.fireEvent('HotelDetailsGallery', 'clicked');
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ResponsiveGallery, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('keyup', this.closeModalWithEscape);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('keyup', this.closeModalWithEscape);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          images = _props.images,
	          loopImages = _props.loopImages;
	
	
	      return images && !!images.size && _react2.default.createElement(
	        'div',
	        { className: 'responsive-gallery', onClick: this.trackOptimizely },
	        _react2.default.createElement('a', { href: '#', className: 'responsive-gallery__screen', onClick: this.closeModal }),
	        _react2.default.createElement(
	          'div',
	          { className: 'responsive-gallery__inner' },
	          _react2.default.createElement(
	            'a',
	            { href: '#', className: 'responsive-gallery__control responsive-gallery__control--prev ' + (!loopImages && this.isFirstImage && 'responsive-gallery__control--disabled'), onClick: this.onPrevClick },
	            _react2.default.createElement(
	              'span',
	              { className: 'responsive-gallery__control__icon' },
	              'previous'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'responsive-gallery__content' },
	            _react2.default.createElement(
	              'a',
	              { href: '#', onClick: this.closeModal, className: 'responsive-gallery__content__close' },
	              _react2.default.createElement(_svgInlineReact2.default, { src: _close2.default, className: 'responsive-gallery__content__close__icon' })
	            ),
	            _react2.default.createElement('img', { src: this.currentImageUrl, itemProp: 'photo', className: 'responsive-gallery__content__image' }),
	            _react2.default.createElement(
	              'p',
	              { className: 'responsive-gallery__content__status' },
	              this.currentImageDisplayIndex,
	              ' of ',
	              this.totalImages
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: '#', className: 'responsive-gallery__control responsive-gallery__control--next ' + (!loopImages && this.isLastImage && 'responsive-gallery__control--disabled'), onClick: this.onNextClick },
	            _react2.default.createElement(
	              'span',
	              { className: 'responsive-gallery__control__icon' },
	              'next'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'isFirstImage',
	    get: function get() {
	      return this.state.currentImageIndex === 0;
	    }
	  }, {
	    key: 'isLastImage',
	    get: function get() {
	      var images = this.props.images;
	
	      return this.state.currentImageIndex === images.size - 1;
	    }
	  }, {
	    key: 'currentImageUrl',
	    get: function get() {
	      var _props2 = this.props,
	          images = _props2.images,
	          mainImageType = _props2.mainImageType;
	
	      var index = this.currentImageIndex;
	
	      var imagesArray = images.toJS();
	      var availableImageType = images.getIn(['' + index, 'sizes', mainImageType], false) ? mainImageType : 'DGA';
	
	      var imagePathname = typeof imagesArray[index] === 'string' ? imagesArray[index] : imagesArray[index].location;
	      imagePathname = imagePathname ? imagePathname.replace(/(^.+)(\.[A-Z]{3})(\.jpg)$/, '$1$3').replace('.jpg', '.' + availableImageType + '.jpg') : '';
	
	      var isFullURL = imagePathname.indexOf('http') === 0;
	
	      return '' + (isFullURL ? '' : _global2.default.imagesBaseUrl) + imagePathname;
	    }
	  }, {
	    key: 'totalImages',
	    get: function get() {
	      var images = this.props.images;
	
	      return images.size;
	    }
	  }, {
	    key: 'currentImageIndex',
	    get: function get() {
	      return this.state.currentImageIndex;
	    }
	  }, {
	    key: 'currentImageDisplayIndex',
	    get: function get() {
	      return this.state.currentImageIndex + 1;
	    }
	  }]);
	  return ResponsiveGallery;
	}(_react.Component);
	
	ResponsiveGallery.defaultProps = {
	  images: _immutable2.default.Map(),
	  mainImageType: 'FLX',
	  loopImages: true
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResponsiveGallery);

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _utils = __webpack_require__(8);
	
	var _Loading = __webpack_require__(164);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	__webpack_require__(933);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchUnitCustomControlCalendarDay = function (_Component) {
	  (0, _inherits3.default)(SearchUnitCustomControlCalendarDay, _Component);
	
	  function SearchUnitCustomControlCalendarDay() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SearchUnitCustomControlCalendarDay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchUnitCustomControlCalendarDay.__proto__ || (0, _getPrototypeOf2.default)(SearchUnitCustomControlCalendarDay)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _this.handleDateClick = function (e) {
	      var handleDayClick = _this.props.handleDayClick;
	
	      e.preventDefault();
	      var theDate = _this.props.date;
	      var calDate = Date.UTC(theDate.year, theDate.month, theDate.day) / _utils.dayInMilliseconds;
	      handleDayClick(calDate);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SearchUnitCustomControlCalendarDay, [{
	    key: 'render',
	    value: function render() {
	      var date = this.props.date;
	
	      var listItem = void 0;
	
	      if (date) {
	        var dateContents = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'time',
	            {
	              dateTime: date.year + '-' + (date.month + 1) + '-' + date.day,
	              className: 'search-unit-custom-control-calendar-day__number'
	            },
	            date.day
	          )
	        );
	
	        listItem = _react2.default.createElement(
	          'td',
	          { className: this.highlight },
	          date.highlight === 'selected' || date.unavailable ? _react2.default.createElement(
	            'div',
	            { className: 'search-unit-custom-control-calendar-day__link' },
	            dateContents
	          ) : _react2.default.createElement(
	            'a',
	            {
	              href: '',
	              className: 'search-unit-custom-control-calendar-day__link',
	              onClick: this.handleDateClick
	            },
	            dateContents
	          ),
	          date.highlight === 'depart' && _react2.default.createElement(_Loading2.default, { loadingState: this.props.appState.get('loadingState'), isSmall: true })
	        );
	      } else {
	        listItem = _react2.default.createElement(
	          'td',
	          { className: 'search-unit-custom-control-calendar-day search-unit-custom-control-calendar-day--not-this-month' },
	          _react2.default.createElement(
	            'time',
	            { className: 'search-unit-custom-control-calendar-day__number' },
	            '--'
	          )
	        );
	      }
	
	      return listItem;
	    }
	  }, {
	    key: 'highlight',
	    get: function get() {
	      var date = this.props.date;
	
	      var highlights = '';
	
	      if (date.highlight) {
	        highlights += ' search-unit-custom-control-calendar-day--selected';
	      }
	
	      if (date.unavailable) {
	        highlights += ' search-unit-custom-control-calendar-day--unavailable';
	      } else {
	        highlights += ' search-unit-custom-control-calendar-day--available';
	      }
	
	      return 'search-unit-custom-control-calendar-day' + highlights;
	    }
	  }]);
	  return SearchUnitCustomControlCalendarDay;
	}(_react.Component);
	
	exports.default = SearchUnitCustomControlCalendarDay;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _Toggle = __webpack_require__(552);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _SearchUnitCustomControlCalendar = __webpack_require__(306);
	
	var _SearchUnitCustomControlCalendar2 = _interopRequireDefault(_SearchUnitCustomControlCalendar);
	
	var _MonthCalendar = __webpack_require__(534);
	
	var _MonthCalendar2 = _interopRequireDefault(_MonthCalendar);
	
	var _searchUnit = __webpack_require__(140);
	
	var _optimizely = __webpack_require__(30);
	
	var optimizelyUtil = _interopRequireWildcard(_optimizely);
	
	__webpack_require__(934);
	
	__webpack_require__(935);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchUnitCustomControlCalendarToggle = function (_Component) {
	  (0, _inherits3.default)(SearchUnitCustomControlCalendarToggle, _Component);
	
	  function SearchUnitCustomControlCalendarToggle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SearchUnitCustomControlCalendarToggle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchUnitCustomControlCalendarToggle.__proto__ || (0, _getPrototypeOf2.default)(SearchUnitCustomControlCalendarToggle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      showMonthCalendar: false
	    }, _this.toggleMonthCalendar = function () {
	      _this.setState({
	        showMonthCalendar: !_this.state.showMonthCalendar
	      });
	      optimizelyUtil.fireEvent('SearchByDayOrByMonthPickerToggle', 'clicked');
	    }, _this.handleSpecificDateClick = function () {
	      _this.setState({
	        showMonthCalendar: false
	      });
	    }, _this.handleWholeMonthClick = function () {
	      _this.setState({
	        showMonthCalendar: true
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SearchUnitCustomControlCalendarToggle, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var selectedFlexibility = this.props.selectedFlexibility;
	
	      if (selectedFlexibility === _searchUnit.MONTH_FLEXIBILITY_VALUE) {
	        this.setState({
	          showMonthCalendar: true
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          availability = _props.availability,
	          loadDayOfMonthData = _props.loadDayOfMonthData,
	          dimensionsEntities = _props.dimensionsEntities,
	          dimensionsResult = _props.dimensionsResult,
	          monthViewDayStamp = _props.monthViewDayStamp,
	          selectedCalendarDayStamp = _props.selectedCalendarDayStamp,
	          hideLegend = _props.hideLegend,
	          handleDayClick = _props.handleDayClick,
	          handleMonthClick = _props.handleMonthClick,
	          type = _props.type;
	      var showMonthCalendar = this.state.showMonthCalendar;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'search-unit-custom-control-calendar-toggle' },
	        _react2.default.createElement(
	          'div',
	          { className: 'search-unit-custom-control-calendar-toggle__heading' },
	          _react2.default.createElement(
	            'div',
	            { className: 'search-unit-custom-control-calendar-toggle__heading__specific-date' },
	            _react2.default.createElement(
	              'button',
	              { className: 'search-unit-custom-control-calendar-toggle__heading__button', onClick: this.handleSpecificDateClick },
	              'Specific date'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'search-unit-custom-control-calendar-toggle__heading__specific-date__flexibility' },
	              this.flexibilityLabel
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'search-unit-custom-control-calendar-toggle__heading__toggle' },
	            _react2.default.createElement(
	              'div',
	              { className: 'search-unit-custom-control-calendar-toggle__heading__toggle-wrapper' },
	              _react2.default.createElement(_Toggle2.default, { onChange: this.toggleMonthCalendar, checked: showMonthCalendar })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'search-unit-custom-control-calendar-toggle__heading__whole-month' },
	            _react2.default.createElement(
	              'button',
	              { className: 'search-unit-custom-control-calendar-toggle__heading__button', onClick: this.handleWholeMonthClick },
	              'Whole month'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          showMonthCalendar && _react2.default.createElement(_MonthCalendar2.default, {
	            onSelectMonth: handleMonthClick
	          }),
	          !showMonthCalendar && _react2.default.createElement(_SearchUnitCustomControlCalendar2.default, {
	            monthViewDayStamp: monthViewDayStamp,
	            handleDayClick: handleDayClick,
	            selectedCalendarDayStamp: selectedCalendarDayStamp,
	            loadDayOfMonthData: loadDayOfMonthData,
	            dimensionsEntities: dimensionsEntities,
	            dimensionsResult: dimensionsResult,
	            availability: availability,
	            type: type,
	            hideLegend: hideLegend
	          })
	        )
	      );
	    }
	  }, {
	    key: 'flexibilityLabel',
	    get: function get() {
	      var selectedFlexibility = this.props.selectedFlexibility;
	
	      var hiddenFlexibilityValues = [_searchUnit.ZERO_DAY_FLEXIBILITY_VALUE, _searchUnit.MONTH_FLEXIBILITY_VALUE];
	      var flexibility = _searchUnit.flexibilityItems.find(function (item) {
	        return item.value === selectedFlexibility;
	      });
	      return flexibility && !hiddenFlexibilityValues.includes(flexibility.value) ? flexibility.label : '';
	    }
	  }]);
	  return SearchUnitCustomControlCalendarToggle;
	}(_react.Component);
	
	exports.default = SearchUnitCustomControlCalendarToggle;

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tag = __webpack_require__(209);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _Autocomplete = __webpack_require__(506);
	
	var _Autocomplete2 = _interopRequireDefault(_Autocomplete);
	
	var _AutocompleteCheckboxOption = __webpack_require__(507);
	
	var _AutocompleteCheckboxOption2 = _interopRequireDefault(_AutocompleteCheckboxOption);
	
	var _AutocompleteQueryTextHighlightOption = __webpack_require__(508);
	
	var _AutocompleteQueryTextHighlightOption2 = _interopRequireDefault(_AutocompleteQueryTextHighlightOption);
	
	__webpack_require__(936);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchUnitDepartureAirport = function (_Component) {
	  (0, _inherits3.default)(SearchUnitDepartureAirport, _Component);
	
	  function SearchUnitDepartureAirport() {
	    (0, _classCallCheck3.default)(this, SearchUnitDepartureAirport);
	    return (0, _possibleConstructorReturn3.default)(this, (SearchUnitDepartureAirport.__proto__ || (0, _getPrototypeOf2.default)(SearchUnitDepartureAirport)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SearchUnitDepartureAirport, [{
	    key: 'renderOption',
	    value: function renderOption(option, isFocused, query) {
	      return _react2.default.createElement(
	        _AutocompleteCheckboxOption2.default,
	        { checked: option.checked, unavailable: option.unavailable, focused: isFocused },
	        _react2.default.createElement(_AutocompleteQueryTextHighlightOption2.default, { label: option.label, query: query })
	      );
	    }
	  }, {
	    key: 'renderTag',
	    value: function renderTag(option, deselect) {
	      return _react2.default.createElement(
	        _Tag2.default,
	        { isFullWidth: true, onTagClick: deselect },
	        option.label
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          options = _props.options,
	          addDepartureAirport = _props.addDepartureAirport,
	          removeDepartureAirport = _props.removeDepartureAirport;
	
	
	      var hasSelectedAirports = !!options.find(function (option) {
	        return option.checked;
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'search-unit-departure' },
	        _react2.default.createElement(
	          'label',
	          { className: 'search-unit-departure__label' },
	          'Departure Airport:'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'search-unit-departure__field' },
	          _react2.default.createElement(
	            'div',
	            { className: 'search-unit-departure__input__wrapper' },
	            _react2.default.createElement(_Autocomplete2.default, {
	              options: options,
	              onOptionSelect: addDepartureAirport,
	              onOptionDeselect: removeDepartureAirport,
	              optionRenderer: this.renderOption,
	              tagRenderer: this.renderTag,
	              placeholder: hasSelectedAirports ? '+ Add another' : 'Any'
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return SearchUnitDepartureAirport;
	}(_react.Component);
	
	exports.default = SearchUnitDepartureAirport;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(117);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _Tag = __webpack_require__(209);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	__webpack_require__(937);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchUnitDestination = function (_Component) {
	  (0, _inherits3.default)(SearchUnitDestination, _Component);
	
	  function SearchUnitDestination() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SearchUnitDestination);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchUnitDestination.__proto__ || (0, _getPrototypeOf2.default)(SearchUnitDestination)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _this.saveComponentRef = function (ref) {
	      return _this.linkRef = ref;
	    }, _this.onInputChange = function (event) {
	      var onInputChange = _this.props.onInputChange;
	
	
	      onInputChange(event, _reactDom2.default.findDOMNode(_this.linkRef));
	    }, _this.handleOnBlur = function (event) {
	      var onBlur = _this.props.onBlur;
	
	      if (onBlur) {
	        onBlur(event);
	      }
	    }, _this.handleOnClick = function (event) {
	      var _this$props = _this.props,
	          onClick = _this$props.onClick,
	          reportSearchFieldClicked = _this$props.reportSearchFieldClicked;
	
	
	      if (reportSearchFieldClicked) {
	        reportSearchFieldClicked(event);
	      }
	
	      if (onClick) {
	        onClick(event, _reactDom2.default.findDOMNode(_this.linkRef));
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SearchUnitDestination, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          addAnotherPlaceholder = _props.addAnotherPlaceholder,
	          hasNoResults = _props.hasNoResults,
	          isDisabled = _props.isDisabled,
	          onKeyDown = _props.onKeyDown,
	          onRemove = _props.onRemove,
	          queryValue = _props.queryValue,
	          selectedElements = _props.selectedElements;
	
	
	      var isFlex = this.props.type === 'flex';
	
	      return _react2.default.createElement(
	        'div',
	        { onClick: this.handleOnClick, className: 'search-unit-destination', ref: this.saveComponentRef },
	        _react2.default.createElement(
	          'label',
	          { className: 'search-unit-destination__label' },
	          'Destination(s) or Hotel:'
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'search-unit-destination__inner ' + (isDisabled ? 'search-unit-destination__inner--is-disabled' : '') + ' ' + (isFlex ? 'search-unit-destination__inner--is-flex' : '')
	          },
	          !!selectedElements.length && _react2.default.createElement(
	            'div',
	            { className: 'search-unit-destination__inner__list-wrapper' + (isFlex ? ' search-unit-destination__inner__list-wrapper--is-flex' : '') },
	            _react2.default.createElement(
	              'ul',
	              { className: 'search-unit-destination__inner__list ' + (isFlex ? 'search-unit-destination__inner__list--is-flex' : '') },
	              selectedElements.map(function () {
	                var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	                var index = arguments[1];
	                return element.label && _react2.default.createElement(
	                  'li',
	                  {
	                    key: index,
	                    className: 'search-unit-destination__inner__list__el' + (isFlex ? ' search-unit-destination__inner__list__el--is-flex' : '')
	                  },
	                  _react2.default.createElement(
	                    _Tag2.default,
	                    { id: element.dimValId || element.id, onRemove: onRemove },
	                    element.label
	                  )
	                );
	              }),
	              isFlex && _react2.default.createElement(
	                'li',
	                { className: 'search-unit-destination__inner__list__el search-unit-destination__inner__list__el--is-placeholder' },
	                addAnotherPlaceholder
	              )
	            )
	          ),
	          _react2.default.createElement('input', {
	            type: 'text',
	            onChange: this.onInputChange,
	            className: 'search-unit-destination__input',
	            placeholder: this.placeholder,
	            value: queryValue,
	            onKeyDown: onKeyDown,
	            onBlur: this.handleOnBlur
	          }),
	          hasNoResults && _react2.default.createElement(
	            'div',
	            { className: 'search-unit-destination__inner__no-results' },
	            'No matches found'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'placeholder',
	    get: function get() {
	      var selectedElements = this.props.selectedElements;
	
	      return selectedElements.length ? '+ Add another' : 'Search e.g. Spain, Eden Resort';
	    }
	  }]);
	  return SearchUnitDestination;
	}(_react.Component);
	
	SearchUnitDestination.defaultProps = {
	  addAnotherPlaceholder: 'Add another',
	  hasNoResults: true,
	  isEverywhereEnabled: false,
	  labelStyle: 'panda',
	  placeholder: 'Any',
	  queryValue: '',
	  selectedElements: [],
	  type: 'fix'
	};
	exports.default = SearchUnitDestination;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(117);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	__webpack_require__(939);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchUnitHotelName = function (_Component) {
	  (0, _inherits3.default)(SearchUnitHotelName, _Component);
	
	  function SearchUnitHotelName() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SearchUnitHotelName);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchUnitHotelName.__proto__ || (0, _getPrototypeOf2.default)(SearchUnitHotelName)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _this.saveComponentRef = function (ref) {
	      return _this.linkRef = ref;
	    }, _this.onInputChange = function (event) {
	      var onInputChange = _this.props.onInputChange;
	
	      onInputChange(event, _reactDom2.default.findDOMNode(_this.linkRef));
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  /* istanbul ignore next */
	
	
	  (0, _createClass3.default)(SearchUnitHotelName, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isDisabled = _props.isDisabled,
	          queryValue = _props.queryValue;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'search-unit-hotel-name', ref: this.saveComponentRef },
	        _react2.default.createElement(
	          'div',
	          { className: 'search-unit-hotel-name__inner ' + (isDisabled ? 'search-unit-hotel-name__inner--is-disabled' : '') },
	          _react2.default.createElement('input', {
	            type: 'text',
	            onChange: this.onInputChange,
	            className: 'search-unit-hotel-name__input',
	            placeholder: 'Start typing a hotel name',
	            value: queryValue
	          })
	        )
	      );
	    }
	  }]);
	  return SearchUnitHotelName;
	}(_react.Component);
	
	SearchUnitHotelName.defaultProps = {
	  hasNoResults: true,
	  queryValue: '',
	  isDisabled: false
	};
	exports.default = SearchUnitHotelName;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(940);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchUnitPopOver = function (_Component) {
	  (0, _inherits3.default)(SearchUnitPopOver, _Component);
	
	  function SearchUnitPopOver() {
	    (0, _classCallCheck3.default)(this, SearchUnitPopOver);
	    return (0, _possibleConstructorReturn3.default)(this, (SearchUnitPopOver.__proto__ || (0, _getPrototypeOf2.default)(SearchUnitPopOver)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SearchUnitPopOver, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          onClick = _props.onClick,
	          isMobile = _props.isMobile;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'search-unit-popover ' + (isMobile ? 'search-unit-popover--mobile' : '') },
	        _react2.default.createElement(
	          'div',
	          { onMouseDown: onClick, className: 'search-unit-popover__content' },
	          children
	        )
	      );
	    }
	  }]);
	  return SearchUnitPopOver;
	}(_react.Component);
	
	exports.default = SearchUnitPopOver;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _global = __webpack_require__(79);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _utils = __webpack_require__(8);
	
	__webpack_require__(941);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchUnitRooms = function (_Component) {
	  (0, _inherits3.default)(SearchUnitRooms, _Component);
	
	  function SearchUnitRooms() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SearchUnitRooms);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchUnitRooms.__proto__ || (0, _getPrototypeOf2.default)(SearchUnitRooms)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      expandedRoomIndex: 0
	    }, _this.shouldComponentUpdate = _function2.default, _this.onNumberOfAdultsChange = function (event) {
	      var searchUnitActionsBound = _this.props.searchUnitActionsBound;
	
	      var roomNumber = Number(event.currentTarget.getAttribute('data-room-number'));
	
	      var numberOfAdults = event.currentTarget.value;
	
	      searchUnitActionsBound.changeNumberOfAdults(roomNumber, numberOfAdults, _this.partyRefs[roomNumber], _this.childrenAgesRefs);
	    }, _this.onNumberOfChildrenChange = function (event) {
	      var searchUnitActionsBound = _this.props.searchUnitActionsBound;
	
	      var roomNumber = Number(event.currentTarget.getAttribute('data-room-number'));
	      var numChildren = Number(event.currentTarget.value);
	
	      if (numChildren > 0) {
	        _this.setState({
	          expandedRoomIndex: roomNumber
	        });
	      }
	
	      searchUnitActionsBound.changeNumberOfChildren(roomNumber, numChildren, _this.partyRefs[roomNumber], _this.childrenAgesRefs);
	    }, _this.onChildAgeChange = function (event) {
	      var roomNumber = Number(event.currentTarget.getAttribute('data-room-number'));
	      var childNumber = Number(event.currentTarget.getAttribute('data-child-number'));
	      var searchUnitActionsBound = _this.props.searchUnitActionsBound;
	
	      var childAge = event.currentTarget.value;
	
	      searchUnitActionsBound.changeChildAge(roomNumber, childNumber, childAge, _this.partyRefs[roomNumber], _this.childrenAgesRefs);
	    }, _this.savePartyRefs = function (ref) {
	      if (ref === null) {
	        return;
	      }
	
	      var roomNumber = Number(ref.getAttribute('data-room-number'));
	
	      _this.partyRefs = _this.partyRefs || [];
	      _this.partyRefs[roomNumber] = ref;
	    }, _this.childAgeSelectRef = function (ref) {
	      _this.childrenAgesRefs = _this.childrenAgesRefs || [];
	      var maxNumberOfAgeSelects = 4;
	
	      if (_this.childrenAgesRefs.length < maxNumberOfAgeSelects) {
	        _this.childrenAgesRefs.push(ref);
	      }
	    }, _this.addRoom = function (event) {
	      event.preventDefault();
	      var searchUnitActionsBound = _this.props.searchUnitActionsBound;
	
	
	      searchUnitActionsBound.addRoom();
	    }, _this.removeRoom = function (event) {
	      var roomNumber = Number(event.currentTarget.getAttribute('data-room-number'));
	      event.preventDefault();
	
	      var searchUnitActionsBound = _this.props.searchUnitActionsBound;
	
	
	      searchUnitActionsBound.removeRoom(roomNumber);
	    }, _this.expandRoom = function (event) {
	      var searchUnitActionsBound = _this.props.searchUnitActionsBound;
	
	      var roomNumber = Number(event.currentTarget.getAttribute('data-room-number'));
	      event.preventDefault();
	
	      searchUnitActionsBound.resetChildCountIfNotAllAgesSet(_this.state.expandedRoomIndex);
	
	      _this.setState({
	        expandedRoomIndex: roomNumber
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SearchUnitRooms, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var baseState = this.props.baseState;
	
	      var rooms = baseState.getIn(['queryState', 'props', 'rooms'], _immutable2.default.List());
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'search-unit-rooms' },
	        rooms.map(function (room, roomIndex) {
	          var adultsCount = room.getIn(['nAdt', 'value']) || 0;
	          var childAges = room.getIn(['cdn', 'arrayValue'], _immutable2.default.List());
	          var isRoomExpanded = roomIndex === _this2.state.expandedRoomIndex;
	
	          return _react2.default.createElement(
	            'div',
	            { key: roomIndex, className: 'search-unit-rooms__wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'search-unit-rooms__room', ref: _this2.savePartyRefs, 'data-room-number': roomIndex },
	              roomIndex > 0 && _react2.default.createElement(
	                'div',
	                { className: 'search-unit-rooms__room__number' },
	                'Room ',
	                roomIndex + 1,
	                ':'
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'search-unit-rooms__room__adults' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'search-unit-rooms__room__adults__label' },
	                  'Adults:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { onChange: _this2.onNumberOfAdultsChange, value: Number(adultsCount), 'data-room-number': roomIndex },
	                  _global2.default.adultsOptions.map(function (numAdults, i) {
	                    return _react2.default.createElement(
	                      'option',
	                      { value: numAdults, key: i },
	                      numAdults
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'search-unit-rooms__room__children' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'search-unit-rooms__room__children__label' },
	                  'Child 0-17:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { onChange: _this2.onNumberOfChildrenChange, value: childAges.size, 'data-room-number': roomIndex },
	                  _global2.default.childrenOptions.map(function (numChildren, i) {
	                    return _react2.default.createElement(
	                      'option',
	                      { value: numChildren, key: i },
	                      numChildren
	                    );
	                  })
	                )
	              )
	            ),
	            isRoomExpanded ? _react2.default.createElement(
	              'div',
	              { className: 'search-unit-rooms__child-ages ' + (childAges.size === 0 ? 'search-unit-rooms__child-ages--hidden' : '') },
	              (0, _utils.range)(0, 4).map(function (item, childIndex) {
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'search-unit-rooms__child-ages__age', ref: _this2.childAgeSelectRef, key: childIndex },
	                  _react2.default.createElement(
	                    'label',
	                    {
	                      className: 'search-unit-rooms__child-ages__age__inner ' + (childIndex < childAges.size ? '' : 'search-unit-rooms__child-ages__age__inner--hidden')
	                    },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'search-unit-rooms__child-ages__age__label' },
	                      'Child ',
	                      childIndex + 1,
	                      ':'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'search-unit-rooms__child-ages__age__select' },
	                      _react2.default.createElement(
	                        'select',
	                        { onChange: _this2.onChildAgeChange, 'data-room-number': roomIndex, 'data-child-number': childIndex, value: String(childAges.get(childIndex)) },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '-1' },
	                          'Select Age'
	                        ),
	                        (0, _utils.range)(0, _global2.default.maxChildAge + 1).map(function (age, ageIndex) {
	                          return _react2.default.createElement(
	                            'option',
	                            { value: '' + age, key: ageIndex },
	                            age
	                          );
	                        })
	                      )
	                    )
	                  )
	                );
	              })
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'search-unit-rooms__child-ages--collapsed' },
	              childAges.size !== 0 && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: '#', onClick: _this2.expandRoom, 'data-room-number': roomIndex },
	                  'edit'
	                ),
	                ' Child Ages: ',
	                childAges.join(', ')
	              )
	            ),
	            rooms.size > 1 && _react2.default.createElement(
	              'a',
	              { href: '#', onClick: _this2.removeRoom, className: 'search-unit-rooms__remove-room', 'data-room-number': roomIndex },
	              '- Remove room'
	            )
	          );
	        }),
	        rooms.size < _global2.default.maxNumberOfRooms && _react2.default.createElement(
	          'div',
	          { className: 'search-unit-rooms__add-room' },
	          baseState.get('areRoomsValid') === false ? _react2.default.createElement(
	            'span',
	            { className: 'search-unit-rooms__add-room__link search-unit-rooms__add-room__link--disabled' },
	            '+ Add another room'
	          ) : _react2.default.createElement(
	            'a',
	            { href: '#', onClick: this.addRoom, className: 'search-unit-rooms__add-room__link' },
	            '+ Add another room'
	          )
	        )
	      );
	    }
	  }]);
	  return SearchUnitRooms;
	}(_react.Component);
	
	exports.default = SearchUnitRooms;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(56);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _Overlay = __webpack_require__(166);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _utils = __webpack_require__(8);
	
	__webpack_require__(382);
	
	var _SelectListItem = __webpack_require__(549);
	
	var _SelectListItem2 = _interopRequireDefault(_SelectListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectList = function (_Component) {
	  (0, _inherits3.default)(SelectList, _Component);
	
	  function SelectList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SelectList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SelectList.__proto__ || (0, _getPrototypeOf2.default)(SelectList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      filterText: ''
	    }, _this.shouldComponentUpdate = _function2.default, _this.scrollToActiveElement = function (ref) {
	      var checkParentOnSelect = _this.props.checkParentOnSelect;
	
	
	      if (ref) {
	        if (ref.scrollIntoViewIfNeeded) {
	          ref.scrollIntoViewIfNeeded();
	        } else if (checkParentOnSelect) {
	          var parent = ref.parentNode;
	          while (!parent.hasAttribute('data-custom-control-wrapper') && parent !== document.body) {
	            parent = parent.parentNode;
	          }
	
	          if (parent !== document.body) {
	            (0, _utils.scrollIfNotVisible)(ref, parent);
	          }
	        } else {
	          ref.scrollIntoView();
	        }
	      }
	    }, _this.allChange = function (event) {
	      event.preventDefault();
	      var allButtonChecked = event.currentTarget.attributes['data-checked'].value === 'false';
	
	      var changeElements = function changeElements(elements) {
	        elements.forEach(function (element) {
	          if (element.checked !== allButtonChecked) {
	            _this.props.onItemChange(element.value, allButtonChecked);
	          }
	          if (element.elements) {
	            changeElements(element.elements);
	          }
	        });
	      };
	
	      changeElements(_this.props.elements);
	    }, _this.updateTextFilter = function (event) {
	      _this.setState({ filterText: event.currentTarget.value });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SelectList, [{
	    key: 'areAllChecked',
	    value: function areAllChecked(elements) {
	      return elements.every(function (element) {
	        return element.checked;
	      });
	    }
	  }, {
	    key: 'renderAllButton',
	    value: function renderAllButton() {
	      var _props = this.props,
	          type = _props.type,
	          controlPosition = _props.controlPosition;
	
	      var areAllChecked = this.areAllChecked(this.props.elements);
	      return _react2.default.createElement(
	        'li',
	        { className: 'select-list__list__element select-list__list__element--control-' + (type !== 'empty' && controlPosition) },
	        _react2.default.createElement(
	          'a',
	          { href: '#', onClick: this.allChange, 'data-checked': areAllChecked, className: 'select-list__list__element__link select-list__list__element__link--nesting-level-1' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'select-list__list__element__span' },
	              'All'
	            ),
	            _react2.default.createElement('span', { className: 'select-list__list__element__checkbox' + (areAllChecked ? '--is-checked' : '') })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderList',
	    value: function renderList(elements, nestingLevel) {
	      var _this2 = this;
	
	      var hasTextFilter = this.props.hasTextFilter;
	
	      var list = void 0;
	      var filteredElements = elements;
	
	      if (hasTextFilter && elements) {
	        var filterText = this.state.filterText.toLowerCase();
	        filteredElements = elements.filter(function (element) {
	          return element.name.toLowerCase().match(filterText);
	        });
	      }
	
	      if (filteredElements && filteredElements.length) {
	        list = _react2.default.createElement(
	          'ul',
	          { className: 'select-list__list' },
	          this.props.includeAllButton && nestingLevel === 1 && this.renderAllButton(),
	          filteredElements.map(function (element, idx) {
	            return _this2.renderElement(element, idx, nestingLevel);
	          })
	        );
	      } else if (hasTextFilter && filteredElements && !filteredElements.length) {
	        list = _react2.default.createElement(
	          'p',
	          { className: 'select-list__no-elements' },
	          'No matches found'
	        );
	      }
	
	      return list;
	    }
	  }, {
	    key: 'renderElement',
	    value: function renderElement(element, idx, nestingLevel) {
	      var _props2 = this.props,
	          type = _props2.type,
	          controlPosition = _props2.controlPosition,
	          activeIndex = _props2.activeIndex,
	          query = _props2.query,
	          onItemChange = _props2.onItemChange,
	          darkerBlueHotelBackground = _props2.darkerBlueHotelBackground;
	
	      var darkerBlueClassModifier = darkerBlueHotelBackground && element.contentType === 'HOTEL' ? 'select-list__list__element--dark-blue-hotel' : '';
	      return _react2.default.createElement(
	        'li',
	        {
	          key: idx,
	          ref: activeIndex === idx && this.scrollToActiveElement,
	          className: '          select-list__list__element           select-list__list__element--control-' + (type !== 'empty' && controlPosition) + '           ' + (activeIndex === idx && 'select-list__list__element--active') + '           ' + darkerBlueClassModifier + '         '
	        },
	        _react2.default.createElement(_SelectListItem2.default, (0, _extends3.default)({}, element, {
	          nestingLevel: nestingLevel,
	          type: type,
	          query: query,
	          onItemChange: onItemChange
	        })),
	        this.renderList(element.elements, nestingLevel + 1)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          elements = _props3.elements,
	          appState = _props3.appState,
	          hasTextFilter = _props3.hasTextFilter,
	          reducedPadding = _props3.reducedPadding;
	
	      var nestingLevelStart = 1;
	      var loadingState = appState.get('loadingState');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'select-list ' + (hasTextFilter && 'select-list--has-text-filter') + ' ' + (reducedPadding ? 'select-list--reduced-padding' : '') },
	        loadingState && _react2.default.createElement(_Overlay2.default, { loaderPosition: 'fixed', loadingState: loadingState }),
	        hasTextFilter && _react2.default.createElement(
	          'div',
	          { className: 'select-list__text-filter' },
	          _react2.default.createElement('input', { autoFocus: true, onChange: this.updateTextFilter })
	        ),
	        elements.length ? this.renderList(elements, nestingLevelStart) : _react2.default.createElement(
	          'p',
	          { className: 'select-list__no-elements' },
	          this.props.emptyElementsMessage
	        )
	      );
	    }
	  }]);
	  return SelectList;
	}(_react.Component); /* eslint-disable key-spacing, no-multi-spaces */
	
	
	SelectList.defaultProps = {
	  appState: _immutable2.default.Map(),
	  controlPosition: 'right',
	  elements: [],
	  emptyElementsMessage: 'No items',
	  hasTextFilter: false,
	  includeAllButton: false,
	  query: '',
	  type: ''
	};
	exports.default = SelectList;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _svgInlineReact = __webpack_require__(64);
	
	var _svgInlineReact2 = _interopRequireDefault(_svgInlineReact);
	
	__webpack_require__(382);
	
	var _hotel = __webpack_require__(1363);
	
	var _hotel2 = _interopRequireDefault(_hotel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectListItem = function (_Component) {
	  (0, _inherits3.default)(SelectListItem, _Component);
	
	  function SelectListItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SelectListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SelectListItem.__proto__ || (0, _getPrototypeOf2.default)(SelectListItem)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _this.itemClick = function (event) {
	      var onItemChange = _this.props.onItemChange;
	
	      var dataset = event.currentTarget.dataset;
	      if (!!onItemChange && dataset.type !== 'link') {
	        event.preventDefault();
	        onItemChange(dataset.value, dataset.checked === 'false');
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SelectListItem, [{
	    key: 'getName',
	    value: function getName() {
	      var _props = this.props,
	          query = _props.query,
	          nestingLevel = _props.nestingLevel;
	      var name = this.props.name;
	
	      if (query !== '') {
	        name = name.replace(new RegExp(query, 'i'), '<span class="select-list__list__element__query">$&</span>');
	      }
	      return { __html: '' + (nestingLevel > 1 ? '- ' : '') + name };
	    }
	  }, {
	    key: 'renderTextSpan',
	    value: function renderTextSpan() {
	      var _props2 = this.props,
	          unavailable = _props2.unavailable,
	          checked = _props2.checked,
	          type = _props2.type,
	          contentType = _props2.contentType,
	          component = _props2.component;
	
	      // if the content is a hotel, display a hotel icon
	
	      var isHotel = contentType === 'HOTEL';
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        component || _react2.default.createElement('span', {
	          className: 'select-list__list__element__span\n              ' + (unavailable && !checked ? 'select-list__list__element__span--is-unavailable' : '') + '\n              ' + (isHotel ? 'select-list__list__element__span--with-icon' : ''),
	          dangerouslySetInnerHTML: this.getName()
	        }),
	        type !== 'empty' && _react2.default.createElement('span', {
	          className: 'select-list__list__element__' + type + (checked ? '--is-checked' : '')
	        }),
	        isHotel && _react2.default.createElement(_svgInlineReact2.default, { src: _hotel2.default, className: 'select-list__list__element__icon' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          checked = _props3.checked,
	          contentType = _props3.contentType,
	          href = _props3.href,
	          nestingLevel = _props3.nestingLevel,
	          type = _props3.type,
	          unavailable = _props3.unavailable,
	          value = _props3.value;
	
	
	      var className = 'select-list__list__element__link select-list__list__element__link--nesting-level-' + (type !== 'empty' && nestingLevel);
	
	      return !unavailable || checked && type === 'checkbox' ? _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'a',
	          {
	            href: href || '#',
	            onClick: this.itemClick,
	            className: className,
	            'data-value': value,
	            'data-checked': checked,
	            'data-type': contentType === 'HOTEL' ? 'link' : 'select'
	          },
	          this.renderTextSpan()
	        )
	      ) : _react2.default.createElement(
	        'div',
	        { className: className },
	        this.renderTextSpan()
	      );
	    }
	  }]);
	  return SelectListItem;
	}(_react.Component); /* eslint-disable key-spacing, no-multi-spaces */
	
	
	SelectListItem.defaultProps = {
	  checked: false,
	  contentType: '',
	  href: '#',
	  nestingLevel: 0,
	  query: '',
	  type: '',
	  unavailable: false,
	  value: ''
	};
	exports.default = SelectListItem;

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _Carousel = __webpack_require__(520);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	__webpack_require__(942);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Slideshow = function (_Component) {
	  (0, _inherits3.default)(Slideshow, _Component);
	
	  function Slideshow() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Slideshow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Slideshow.__proto__ || (0, _getPrototypeOf2.default)(Slideshow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      currentSlideIndex: 0
	    }, _this.shouldComponentUpdate = _function2.default, _this.onClickNext = function (event) {
	      var images = _this.props.images;
	      if (event) {
	        event.preventDefault();
	      }
	      var numOfImages = images.size;
	      _this.setState({
	        currentSlideIndex: (_this.state.currentSlideIndex + numOfImages + 1) % numOfImages
	      });
	    }, _this.onClickPrev = function (event) {
	      var images = _this.props.images;
	      if (event) {
	        event.preventDefault();
	      }
	      var numOfImages = images.size;
	      _this.setState({
	        currentSlideIndex: (_this.state.currentSlideIndex + numOfImages - 1) % numOfImages
	      });
	    }, _this.onClickThumbnail = function (event) {
	      /* istanbul ignore else  */
	      if (event) {
	        event.preventDefault();
	        var newSlideIndex = Number(event.currentTarget.dataset.index);
	        _this.setState({
	          currentSlideIndex: newSlideIndex
	        });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Slideshow, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          images = _props.images,
	          toggleControlsAreActive = _props.toggleControlsAreActive,
	          slideWidth = _props.slideWidth,
	          overlayText = _props.overlayText,
	          disableThumbnails = _props.disableThumbnails;
	
	      var thumbsCarouselWidth = slideWidth;
	      var showThumbnailControls = images.size > 1;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'slideshow' },
	        _react2.default.createElement(
	          'div',
	          { className: 'slideshow__main-image' },
	          _react2.default.createElement(_Carousel2.default, {
	            images: images,
	            imageWidth: slideWidth,
	            currentItemIndex: this.state.currentSlideIndex,
	            onClickNext: this.onClickNext,
	            onClickPrevious: this.onClickPrev,
	            toggleControlsAreActive: toggleControlsAreActive,
	            isFirstImage: this.isFirstImage,
	            isLastImage: this.isLastImage,
	            isSlideshow: true,
	            imageType: this.props.mainImageType
	          }),
	          showThumbnailControls && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('a', { href: '#', className: 'slideshow__main-image__controller slideshow__main-image__controller--back', onClick: this.onClickPrev }),
	            _react2.default.createElement('a', { href: '#', className: 'slideshow__main-image__controller slideshow__main-image__controller--next', onClick: this.onClickNext })
	          )
	        ),
	        showThumbnailControls && _react2.default.createElement(
	          'div',
	          { className: 'slideshow__controller-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'slideshow__image-counter' },
	            this.state.currentSlideIndex + 1,
	            '/',
	            images.size
	          ),
	          !disableThumbnails && _react2.default.createElement(_Carousel2.default, {
	            images: images,
	            imageWidth: 70,
	            viewWidth: thumbsCarouselWidth,
	            currentItemIndex: this.state.currentSlideIndex,
	            onClickNext: this.onClickNext,
	            onClickPrevious: this.onClickPrev,
	            onClickThumbnail: this.onClickThumbnail,
	            toggleControlsAreActive: toggleControlsAreActive,
	            isFirstImage: this.isFirstImage,
	            isLastImage: this.isLastImage,
	            isThumbnails: true,
	            imageType: this.props.thumbnailImageType
	          })
	        ),
	        !!overlayText && _react2.default.createElement(
	          'div',
	          { className: 'slideshow__overlay-text' },
	          overlayText
	        )
	      );
	    }
	  }, {
	    key: 'isFirstImage',
	    get: function get() {
	      return this.state.currentSlideIndex === 0;
	    }
	  }, {
	    key: 'isLastImage',
	    get: function get() {
	      var images = this.props.images;
	      var numOfImages = images.size;
	      return this.state.currentSlideIndex === numOfImages - 1;
	    }
	  }]);
	  return Slideshow;
	}(_react.Component);
	
	Slideshow.defaultProps = {
	  mainImageType: 'RGXL',
	  thumbnailImageType: 'RTB',
	  disableThumbnails: false
	};
	exports.default = Slideshow;

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.baseClass = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _function = __webpack_require__(14);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _reactRouter = __webpack_require__(78);
	
	var _utils = __webpack_require__(8);
	
	var _smoothScroller = __webpack_require__(322);
	
	var _smoothScroller2 = _interopRequireDefault(_smoothScroller);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	__webpack_require__(943);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var baseClass = exports.baseClass = 'subpage-masthead';
	
	var SubpageMasthead = function (_Component) {
	  (0, _inherits3.default)(SubpageMasthead, _Component);
	
	  function SubpageMasthead() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SubpageMasthead);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SubpageMasthead.__proto__ || (0, _getPrototypeOf2.default)(SubpageMasthead)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _this.onClickHandler = function (event) {
	      event.preventDefault();
	      _this.props.customOnClick(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SubpageMasthead, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _smoothScroller2.default.scrollStraightToTop();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          ctaType = _props.ctaType,
	          backUrl = _props.backUrl,
	          customOnClick = _props.customOnClick;
	
	      var buttonClassName = baseClass + '__button';
	      var buttonContent = void 0;
	
	      if (ctaType === 'back') {
	        buttonClassName = buttonClassName + '--back';
	        buttonContent = _react2.default.createElement('i', { className: 'chevron-left-icon' });
	      } else {
	        buttonContent = this.props.buttonContent;
	      }
	
	      return _react2.default.createElement(
	        'header',
	        { className: '' + baseClass },
	        children && children.props ? children : _react2.default.createElement(
	          'h1',
	          { className: baseClass + '__title' },
	          children
	        ),
	        !this.props.appState.get('loadingState') && customOnClick ? _react2.default.createElement(
	          'a',
	          { href: '#', className: buttonClassName, onClick: this.onClickHandler },
	          buttonContent
	        ) : _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            to: backUrl || (0, _utils.getParentRouteURL)(this.props.location),
	            onClick: this.props.btnOnClick,
	            className: buttonClassName
	          },
	          buttonContent
	        )
	      );
	    }
	  }]);
	  return SubpageMasthead;
	}(_react.Component);
	
	SubpageMasthead.defaultProps = {
	  buttonContent: 'Done',
	  appState: _immutable2.default.Map()
	};
	exports.default = SubpageMasthead;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(945);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Toggle = function (_Component) {
	  (0, _inherits3.default)(Toggle, _Component);
	
	  function Toggle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Toggle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Toggle.__proto__ || (0, _getPrototypeOf2.default)(Toggle)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
	      _this.props.onChange();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Toggle, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var id = 'checkbox-' + Math.random();
	      this.setState({ id: id });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var checked = this.props.checked;
	      var id = this.state.id;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'toggle' },
	        _react2.default.createElement('input', {
	          id: id,
	          className: 'toggle__checkbox',
	          type: 'checkbox',
	          checked: checked,
	          onChange: this.handleClick
	        }),
	        _react2.default.createElement('label', { className: 'toggle__label', htmlFor: id })
	      );
	    }
	  }]);
	  return Toggle;
	}(_react.Component);
	
	Toggle.defaultProps = {
	  checked: false
	};
	exports.default = Toggle;

/***/ },
/* 553 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var temporaryFeatures = {
	  // [featureKey]: '[set date YYYY-MM-DD]',
	};
	
	exports.default = temporaryFeatures;

/***/ },
/* 554 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var userClassAssignment = {
	  PaypalFee: 'V'
	};
	
	exports.default = userClassAssignment;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _reactRouter = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Root = function (_React$Component) {
	  (0, _inherits3.default)(Root, _React$Component);
	
	  function Root() {
	    (0, _classCallCheck3.default)(this, Root);
	    return (0, _possibleConstructorReturn3.default)(this, (Root.__proto__ || (0, _getPrototypeOf2.default)(Root)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Root, [{
	    key: 'render',
	    value: function render() {
	      /* istanbul ignore next */
	      return _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: this.props.store },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '100%' } },
	          this.content,
	          this.devTools
	        )
	      );
	    }
	  }, {
	    key: 'content',
	    get: function get() {
	      /* istanbul ignore next */
	      return _react2.default.createElement(
	        _reactRouter.Router,
	        { history: this.props.history },
	        this.props.routes
	      );
	    }
	  }, {
	    key: 'devTools',
	    get: function get() {
	      // greatly simplifies setup of redux dev tools
	      /* eslint global-require: 0 */
	      /* istanbul ignore next */
	      if (false) {
	        if (__DEBUG_NEW_WINDOW__) {
	          if (window.devToolsExtension) {
	            window.devToolsExtension.open();
	          } else {
	            require('../redux/utils/createDevToolsWindow').default(this.props.store);
	          }
	        } else if (!window.devToolsExtension) {
	          var DevTools = require('containers/DevTools').default;
	          return _react2.default.createElement(DevTools, null);
	        }
	      }
	    }
	  }]);
	  return Root;
	}(_react2.default.Component);
	
	exports.default = Root;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LHX = __webpack_require__(67);
	
	var _LHX2 = _interopRequireDefault(_LHX);
	
	var _initializeWindowResizeListener = __webpack_require__(558);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Initialize the global LHX object used to push configuration changes
	exports.default = function (store) {
	  _LHX2.default.connectToStore(store);
	  (0, _initializeWindowResizeListener.initializeWindowResizeListener)(store, window, screen);
	};

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = initializeBrowserHistoryListener;
	
	var _reactRouter = __webpack_require__(78);
	
	var _locationActions = __webpack_require__(583);
	
	var _utils = __webpack_require__(8);
	
	function initializeBrowserHistoryListener(store) {
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var settings = {
	    isUpdateWebtrendsEnabled: false
	  };
	
	  var previous = {
	    pathname: '',
	    hash: ''
	  };
	
	  function updateStore(location, locationChanged, hashChanged) {
	    if (locationChanged) store.dispatch((0, _locationActions.routeLocationDidUpdate)(location));
	    if (hashChanged) store.dispatch((0, _locationActions.routeHashDidUpdate)(location));
	  }
	
	  function updateWebtrends(location, locationChanged, hashChanged, vievHashAttrExists) {
	    var onPandaPage = location.pathname.includes('/holidays/availability/');
	
	    if (hashChanged && (!locationChanged || vievHashAttrExists) && onPandaPage) {
	      (0, _utils.fireWebtrendsPageView)((0, _utils.getWebTrendsEventType)(location.hash));
	    }
	  }
	
	  function hasChanged(location, type) {
	    var changed = location[type] !== previous[type];
	    if (changed) previous[type] = location[type];
	    return changed;
	  }
	
	  function onLocationChange(location) {
	    var vievHashAttrExists = !!(0, _utils.hash2Obj)(previous.hash).view;
	    var hashChanged = hasChanged(location, 'hash');
	    var locationChanged = hasChanged(location, 'pathname');
	
	    updateStore(location, locationChanged, hashChanged);
	
	    if (settings.isUpdateWebtrendsEnabled) {
	      updateWebtrends(location, locationChanged, hashChanged, vievHashAttrExists);
	    }
	  }
	
	  if (config.isUpdateWebtrendsEnabled === false) {
	    settings.isUpdateWebtrendsEnabled = false;
	  }
	
	  _reactRouter.browserHistory.listen(onLocationChange);
	}

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initializeWindowResizeListener = undefined;
	
	var _appStateActions = __webpack_require__(94);
	
	var _utils = __webpack_require__(8);
	
	var initializeWindowResizeListener = exports.initializeWindowResizeListener = function initializeWindowResizeListener(store, theWindow, theScreen) {
	  function handleWindowResize() {
	    var viewportDetails = {
	      width: theScreen.width < theWindow.innerWidth ? theScreen.width : theWindow.innerWidth,
	      height: theWindow.innerHeight
	    };
	
	    var mobileBreakpoint = viewportDetails.width <= 760;
	    var isAndroid = /Android/.test(window.navigator.userAgent);
	    var isMobileBreakpoint = mobileBreakpoint || isAndroid;
	
	    store.dispatch((0, _appStateActions.setViewportDimensions)(viewportDetails, isMobileBreakpoint));
	  }
	
	  handleWindowResize();
	  var debouncedResizeHandler = (0, _utils.debounce)(handleWindowResize, 150);
	  theWindow.addEventListener('resize', debouncedResizeHandler);
	};

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AssistedBookingStatusLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _AssistedBookingStatusModal = __webpack_require__(505);
	
	var _AssistedBookingStatusModal2 = _interopRequireDefault(_AssistedBookingStatusModal);
	
	var _modalActions = __webpack_require__(40);
	
	var _bookActions = __webpack_require__(143);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    bookState: state.bookState,
	    backUrl: state.bookState.getIn(['data', 'availability_url'])
	  };
	};
	
	/* istanbul ignore next */
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    toggleModalBound: (0, _redux.bindActionCreators)(_modalActions.toggleModal, dispatch),
	    acknowledgeAssistedBookingNotificationBound: (0, _redux.bindActionCreators)(_bookActions.acknowledgeAssistedBookingNotification, dispatch)
	  };
	};
	
	var AssistedBookingStatusLayout = exports.AssistedBookingStatusLayout = function (_Component) {
	  (0, _inherits3.default)(AssistedBookingStatusLayout, _Component);
	
	  function AssistedBookingStatusLayout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AssistedBookingStatusLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AssistedBookingStatusLayout.__proto__ || (0, _getPrototypeOf2.default)(AssistedBookingStatusLayout)).call.apply(_ref, [this].concat(args))), _this), _this.onClose = function (event) {
	      var _this$props = _this.props,
	          toggleModalBound = _this$props.toggleModalBound,
	          acknowledgeAssistedBookingNotificationBound = _this$props.acknowledgeAssistedBookingNotificationBound;
	
	
	      event.preventDefault();
	      acknowledgeAssistedBookingNotificationBound();
	      toggleModalBound();
	    }, _this.onBack = function () {
	      var toggleModalBound = _this.props.toggleModalBound;
	
	      toggleModalBound();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AssistedBookingStatusLayout, [{
	    key: 'render',
	    value: function render() {
	      var bookState = this.props.bookState;
	
	
	      var bookingComponentStatuses = bookState.getIn(['data', 'booking_component_statuses']);
	      var backUrl = bookState.getIn(['data', 'availability_url']);
	
	      return _react2.default.createElement(_AssistedBookingStatusModal2.default, {
	        bookingComponentStatuses: bookingComponentStatuses,
	        backUrl: backUrl,
	        onBack: this.onBack,
	        onClose: this.onClose
	      });
	    }
	  }]);
	  return AssistedBookingStatusLayout;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AssistedBookingStatusLayout);

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BookFreeHotelAmendsLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _modalActions = __webpack_require__(40);
	
	var _optimizely = __webpack_require__(30);
	
	var optimizelyUtil = _interopRequireWildcard(_optimizely);
	
	__webpack_require__(946);
	
	__webpack_require__(947);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps() {
	  return {};
	};
	
	/* istanbul ignore next */
	function mapDispatchToProps(dispatch) {
	  return {
	    toggleModalBound: (0, _redux.bindActionCreators)(_modalActions.toggleModal, dispatch)
	  };
	}
	
	var BookFreeHotelAmendsLayout = exports.BookFreeHotelAmendsLayout = function (_Component) {
	  (0, _inherits3.default)(BookFreeHotelAmendsLayout, _Component);
	
	  function BookFreeHotelAmendsLayout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, BookFreeHotelAmendsLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BookFreeHotelAmendsLayout.__proto__ || (0, _getPrototypeOf2.default)(BookFreeHotelAmendsLayout)).call.apply(_ref, [this].concat(args))), _this), _this.close = function () {
	      var toggleModalBound = _this.props.toggleModalBound;
	
	
	      toggleModalBound();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(BookFreeHotelAmendsLayout, [{
	    key: 'render',
	    value: function render() {
	      optimizelyUtil.fireEvent('BookFreeHotelAmendsModal', 'displayed');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'book-free-hotel-amends-modal' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'We understand that sometimes you need to make changes to your hotel booking. At loveholidays we want to give you maximum flexibility and great value so we will not charge you an admin fee to make any change to your accommodation.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'The only fee that you could be liable to is the cost difference between your current accommodation and your new one. All changes can be requested in the manage my booking section of the website.'
	        ),
	        _react2.default.createElement(
	          'button',
	          { onClick: this.close, className: 'book-free-hotel-amends-modal__close' },
	          'Close'
	        )
	      );
	    }
	  }]);
	  return BookFreeHotelAmendsLayout;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BookFreeHotelAmendsLayout);

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BookHandLuggageModalLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _modalActions = __webpack_require__(40);
	
	var _optimizely = __webpack_require__(30);
	
	var optimizelyUtil = _interopRequireWildcard(_optimizely);
	
	__webpack_require__(948);
	
	__webpack_require__(949);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps() {
	  return {};
	};
	
	/* istanbul ignore next */
	function mapDispatchToProps(dispatch) {
	  return {
	    toggleModalBound: (0, _redux.bindActionCreators)(_modalActions.toggleModal, dispatch)
	  };
	}
	
	var BookHandLuggageModalLayout = exports.BookHandLuggageModalLayout = function (_Component) {
	  (0, _inherits3.default)(BookHandLuggageModalLayout, _Component);
	
	  function BookHandLuggageModalLayout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, BookHandLuggageModalLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BookHandLuggageModalLayout.__proto__ || (0, _getPrototypeOf2.default)(BookHandLuggageModalLayout)).call.apply(_ref, [this].concat(args))), _this), _this.close = function () {
	      var toggleModalBound = _this.props.toggleModalBound;
	
	      toggleModalBound();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(BookHandLuggageModalLayout, [{
	    key: 'render',
	    value: function render() {
	      var airlineBaggage = this.props.airlineBaggage;
	
	      optimizelyUtil.fireEvent('BookHandLuggageModal', 'displayed');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'book-hand-luggage-modal-layout' },
	        'Most airlines now charge extra for hold luggage. Your booking includes ',
	        airlineBaggage.get('hand_bags'),
	        ' hand luggage item per person.',
	        _react2.default.createElement(
	          'div',
	          { className: 'book-hand-luggage-modal-layout__details' },
	          _react2.default.createElement(
	            'div',
	            { className: 'book-hand-luggage-modal-layout__details__label' },
	            'Hand luggage size:'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'book-hand-luggage-modal-layout__details__field' },
	            airlineBaggage.get('hand_size')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'book-hand-luggage-modal-layout__details' },
	          _react2.default.createElement(
	            'div',
	            { className: 'book-hand-luggage-modal-layout__details__label' },
	            'Hand luggage max weight:'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'book-hand-luggage-modal-layout__details__field' },
	            airlineBaggage.get('hand_weight').replace(' in one bag', '')
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { onClick: this.close, className: 'book-hand-luggage-modal-layout__close' },
	          'Close'
	        )
	      );
	    }
	  }]);
	  return BookHandLuggageModalLayout;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BookHandLuggageModalLayout);

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BookTransferReminderLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _smoothScroller = __webpack_require__(322);
	
	var _smoothScroller2 = _interopRequireDefault(_smoothScroller);
	
	var _modalActions = __webpack_require__(40);
	
	var _utils = __webpack_require__(8);
	
	var _optimizely = __webpack_require__(30);
	
	var optimizelyUtil = _interopRequireWildcard(_optimizely);
	
	__webpack_require__(950);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps() {
	  return {};
	};
	
	/* istanbul ignore next */
	function mapDispatchToProps(dispatch) {
	  return {
	    toggleModalBound: (0, _redux.bindActionCreators)(_modalActions.toggleModal, dispatch)
	  };
	}
	
	var BookTransferReminderLayout = exports.BookTransferReminderLayout = function (_Component) {
	  (0, _inherits3.default)(BookTransferReminderLayout, _Component);
	
	  function BookTransferReminderLayout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, BookTransferReminderLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BookTransferReminderLayout.__proto__ || (0, _getPrototypeOf2.default)(BookTransferReminderLayout)).call.apply(_ref, [this].concat(args))), _this), _this.scrollToTransfers = function () {
	      var toggleModalBound = _this.props.toggleModalBound;
	
	
	      toggleModalBound();
	      _smoothScroller2.default.smoothScroll('.book-radio-list--transfer', 500, { offset: -20 });
	      optimizelyUtil.fireEvent('BookTransferReminderAddTransfer', 'clicked');
	    }, _this.continueBookingFlow = function (event) {
	      var _this$props = _this.props,
	          toggleModalBound = _this$props.toggleModalBound,
	          onSubmit = _this$props.onSubmit;
	
	
	      optimizelyUtil.fireEvent('BookTransferReminderContinue', 'clicked');
	      toggleModalBound();
	      onSubmit(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(BookTransferReminderLayout, [{
	    key: 'render',
	    value: function render() {
	      (0, _utils.setSessionVariable)('transferReminderDisplayed', true);
	      optimizelyUtil.fireEvent('BookTransferReminder', 'displayed');
	
	      return _react2.default.createElement(
	        'form',
	        { action: 'POST', onSubmit: this.continueBookingFlow, className: 'book-transfer-reminder' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'book-transfer-reminder__title' },
	          'No transfer added'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'book-transfer-reminder__text' },
	          'You haven\'t added a transfer.'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'book-transfer-reminder__text' },
	          'Make things easier by adding a transfer now.'
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'book-transfer-reminder__btn--close book-transfer-reminder__btn', onClick: this.scrollToTransfers },
	          'Add transfer'
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'book-transfer-reminder__btn--continue book-transfer-reminder__btn' },
	          'I will make my own arrangements'
	        )
	      );
	    }
	  }]);
	  return BookTransferReminderLayout;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BookTransferReminderLayout);

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CoreLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _optimizely = __webpack_require__(30);
	
	var optimizelyUtil = _interopRequireWildcard(_optimizely);
	
	var _CustomControlLayout = __webpack_require__(564);
	
	var _CustomControlLayout2 = _interopRequireDefault(_CustomControlLayout);
	
	var _ModalLayout = __webpack_require__(566);
	
	var _ModalLayout2 = _interopRequireDefault(_ModalLayout);
	
	var _NotificationsLayout = __webpack_require__(567);
	
	var _NotificationsLayout2 = _interopRequireDefault(_NotificationsLayout);
	
	var _PopoverLayout = __webpack_require__(568);
	
	var _PopoverLayout2 = _interopRequireDefault(_PopoverLayout);
	
	var _content = __webpack_require__(533);
	
	var _content2 = _interopRequireDefault(_content);
	
	__webpack_require__(966);
	
	__webpack_require__(965);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    baseState: state.baseState,
	    featureFlags: state.featureFlags,
	    modal: state.modal,
	    isMobileBreakpoint: state.appState.get('isMobileBreakpoint', true)
	  };
	};
	
	var CoreLayout = exports.CoreLayout = function (_Component) {
	  (0, _inherits3.default)(CoreLayout, _Component);
	
	  function CoreLayout() {
	    (0, _classCallCheck3.default)(this, CoreLayout);
	    return (0, _possibleConstructorReturn3.default)(this, (CoreLayout.__proto__ || (0, _getPrototypeOf2.default)(CoreLayout)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CoreLayout, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.onRouteChange();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.onRouteChange();
	    }
	  }, {
	    key: 'onRouteChange',
	    value: function onRouteChange() {
	      var location = this.props.location;
	
	
	      if (location.action === 'POP' || location.action === 'PUSH') {
	        var userAttributes = {
	          type: 'user',
	          attributes: {
	            device_type: optimizelyUtil.getDeviceType()
	          }
	        };
	
	        if (this.searchHasChildren()) {
	          userAttributes.attributes.search_with_children = true;
	        }
	
	        optimizelyUtil.push(userAttributes);
	      }
	    }
	  }, {
	    key: 'searchHasChildren',
	    value: function searchHasChildren() {
	      var baseState = this.props.baseState;
	
	      var getChildrenFromBaseState = ['queryState', 'props', 'cdn', 'arrayValue'];
	      var children = baseState.getIn(getChildrenFromBaseState, _immutable2.default.fromJS([]));
	
	      return children.size;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var modal = this.props.modal;
	
	      var modalData = modal && modal.name && !modal.config.isSubPage && (0, _content2.default)(modal);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'core-layout ' + this.featureFlagsClassName + ' ' + this.layoutClassName },
	        _react2.default.createElement(_NotificationsLayout2.default, null),
	        this.props.children,
	        modalData && _react2.default.createElement(
	          _ModalLayout2.default,
	          { icon: modalData.icon, modalConfig: modal.config },
	          modalData.content
	        ),
	        _react2.default.createElement(_PopoverLayout2.default, null),
	        _react2.default.createElement(_CustomControlLayout2.default, null)
	      );
	    }
	  }, {
	    key: 'featureFlagsClassName',
	    get: function get() {
	      var featureFlags = this.props.featureFlags;
	
	      var classNameList = featureFlags.get('classNameList').toJS();
	      classNameList = classNameList.map(function (className) {
	        return 'core-layout--' + className;
	      });
	
	      return classNameList.join(' ');
	    }
	  }, {
	    key: 'layoutClassName',
	    get: function get() {
	      var isMobileBreakpoint = this.props.isMobileBreakpoint;
	
	      return isMobileBreakpoint ? 'core-layout--mobile' : 'core-layout--desktop';
	    }
	  }]);
	  return CoreLayout;
	}(_react.Component);
	
	CoreLayout.defaultProps = {
	  baseState: _immutable2.default.fromJS({}),
	  featureFlags: _immutable2.default.fromJS({
	    classNameList: []
	  })
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(CoreLayout);

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomControlLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _customControlActions = __webpack_require__(120);
	
	var customControlActions = _interopRequireWildcard(_customControlActions);
	
	var _CustomControl = __webpack_require__(522);
	
	var _CustomControl2 = _interopRequireDefault(_CustomControl);
	
	var _utils = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    customControlState: state.customControl || {}
	  };
	};
	
	/* istanbul ignore next */
	function mapDispatchToProps(dispatch) {
	  return {
	    customControlActionsBound: (0, _redux.bindActionCreators)(customControlActions, dispatch)
	  };
	}
	
	var CustomControlLayout = exports.CustomControlLayout = function (_Component) {
	  (0, _inherits3.default)(CustomControlLayout, _Component);
	
	  function CustomControlLayout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CustomControlLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CustomControlLayout.__proto__ || (0, _getPrototypeOf2.default)(CustomControlLayout)).call.apply(_ref, [this].concat(args))), _this), _this.handleWindowResize = function () {
	      var customControlActionsBound = _this.props.customControlActionsBound;
	
	      customControlActionsBound.hideControl();
	    }, _this.closeCustomControl = function (event) {
	      var customControlActionsBound = _this.props.customControlActionsBound;
	
	      event.preventDefault();
	      customControlActionsBound.hideControl();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CustomControlLayout, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.debouncedResizeHandler = (0, _utils.debounce)(this.handleWindowResize, 150);
	      window.addEventListener('resize', this.debouncedResizeHandler);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.debouncedResizeHandler);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var customControlState = this.props.customControlState;
	
	
	      var body = customControlState.body;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        body && _react2.default.createElement(_CustomControl2.default, {
	          closeCustomControl: this.closeCustomControl,
	          customControlState: customControlState,
	          body: body,
	          position: customControlState.position,
	          hAlign: customControlState.hAlign,
	          width: customControlState.width,
	          height: customControlState.height
	        })
	      );
	    }
	  }]);
	  return CustomControlLayout;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CustomControlLayout);

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EmailDealLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _bookActions = __webpack_require__(143);
	
	var _modalActions = __webpack_require__(40);
	
	var _LoadingOverlayLayout = __webpack_require__(314);
	
	var _LoadingOverlayLayout2 = _interopRequireDefault(_LoadingOverlayLayout);
	
	var _EmailDeal = __webpack_require__(526);
	
	var _EmailDeal2 = _interopRequireDefault(_EmailDeal);
	
	var _EmailDealResult = __webpack_require__(527);
	
	var _EmailDealResult2 = _interopRequireDefault(_EmailDealResult);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    initialValues: {
	      emailAddress: state.bookState.getIn(['entities', 'passengers', '0', 'email']),
	      name: state.bookState.getIn(['entities', 'passengers', '0', 'firstName'])
	    },
	    emailDealResult: state.bookState.get('emailDealResult'),
	    isMobileBreakpoint: state.appState.get('isMobileBreakpoint'),
	    appState: state.appState
	  };
	};
	
	/* istanbul ignore next */
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onSubmit: (0, _redux.bindActionCreators)(_bookActions.sendDeal, dispatch),
	    closeModal: (0, _redux.bindActionCreators)(_modalActions.toggleModal, dispatch)
	  };
	};
	
	var EmailDealLayout = exports.EmailDealLayout = function (_Component) {
	  (0, _inherits3.default)(EmailDealLayout, _Component);
	
	  function EmailDealLayout() {
	    (0, _classCallCheck3.default)(this, EmailDealLayout);
	    return (0, _possibleConstructorReturn3.default)(this, (EmailDealLayout.__proto__ || (0, _getPrototypeOf2.default)(EmailDealLayout)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(EmailDealLayout, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        isMobileBreakpoint: this.props.isMobileBreakpoint
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var isMobileBreakpoint = this.state.isMobileBreakpoint;
	      var _props = this.props,
	          emailDealResult = _props.emailDealResult,
	          closeModal = _props.closeModal,
	          initialValues = _props.initialValues,
	          onSubmit = _props.onSubmit,
	          appState = _props.appState;
	
	
	      return emailDealResult === undefined ? _react2.default.createElement(
	        _LoadingOverlayLayout2.default,
	        { isLoading: appState.get('savingEmailDeal', false) },
	        _react2.default.createElement(_EmailDeal2.default, { initialValues: initialValues, onSubmit: onSubmit, isMobileBreakpoint: isMobileBreakpoint })
	      ) : _react2.default.createElement(_EmailDealResult2.default, { emailDealResult: emailDealResult, close: closeModal });
	    }
	  }]);
	  return EmailDealLayout;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EmailDealLayout);

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _Modal = __webpack_require__(305);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _SlideInFromTheSideModal = __webpack_require__(165);
	
	var _SlideInFromTheSideModal2 = _interopRequireDefault(_SlideInFromTheSideModal);
	
	var _modalActions = __webpack_require__(40);
	
	__webpack_require__(953);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    appState: state.appState
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return {
	    toggleModalBound: function toggleModalBound() {
	      return dispatch((0, _modalActions.toggleModal)(''));
	    }
	  };
	}
	
	var ModalLayout = exports.ModalLayout = function (_Component) {
	  (0, _inherits3.default)(ModalLayout, _Component);
	
	  function ModalLayout() {
	    (0, _classCallCheck3.default)(this, ModalLayout);
	    return (0, _possibleConstructorReturn3.default)(this, (ModalLayout.__proto__ || (0, _getPrototypeOf2.default)(ModalLayout)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ModalLayout, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          appState = _props.appState,
	          children = _props.children,
	          icon = _props.icon,
	          modalConfig = _props.modalConfig,
	          toggleModalBound = _props.toggleModalBound;
	
	
	      var ModalComponent = _Modal2.default;
	      if (modalConfig && modalConfig.slideInFromTheSide) {
	        ModalComponent = _SlideInFromTheSideModal2.default;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal-layout' },
	        (!modalConfig || !modalConfig.isStandaloneModal) && _react2.default.createElement(
	          ModalComponent,
	          {
	            icon: icon,
	            onModalClose: toggleModalBound,
	            modalConfig: modalConfig,
	            isMobileBreakpoint: appState.get('isMobileBreakpoint')
	          },
	          children
	        ),
	        !!modalConfig && modalConfig.isStandaloneModal && _react2.default.createElement(
	          'div',
	          { className: 'modal-layout__standalone' },
	          children
	        )
	      );
	    }
	  }]);
	  return ModalLayout;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ModalLayout);

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NotificationsLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _notificationsActions = __webpack_require__(584);
	
	var notificationsActions = _interopRequireWildcard(_notificationsActions);
	
	var _LHX = __webpack_require__(67);
	
	var _LHX2 = _interopRequireDefault(_LHX);
	
	var _utils = __webpack_require__(8);
	
	__webpack_require__(954);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    notifications: state.notifications
	  };
	};
	
	/* istanbul ignore next */
	function mapDispatchToProps(dispatch) {
	  return {
	    notificationsActionsBound: (0, _redux.bindActionCreators)(notificationsActions, dispatch)
	  };
	}
	
	var NotificationsLayout = exports.NotificationsLayout = function (_Component) {
	  (0, _inherits3.default)(NotificationsLayout, _Component);
	
	  function NotificationsLayout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, NotificationsLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NotificationsLayout.__proto__ || (0, _getPrototypeOf2.default)(NotificationsLayout)).call.apply(_ref, [this].concat(args))), _this), _this.closeNotification = function (event) {
	      var notificationsActionsBound = _this.props.notificationsActionsBound;
	
	      event.preventDefault();
	      notificationsActionsBound.toggleNotification('');
	    }, _this.messages = {
	      BASKET_EXPIRED: _react2.default.createElement(
	        'em',
	        null,
	        'We\u2019re sorry but because there was no interaction for over 15 minutes we\u2019ve had to restart this purchase. We do this to ensure we give you the best possible price at the time of booking.'
	      ),
	      NO_EXTRAS: _react2.default.createElement(
	        'em',
	        null,
	        'No extras available for this booking.'
	      ),
	      CONNECTION_ERROR: _react2.default.createElement(
	        'em',
	        null,
	        'This holiday can only be booked over the phone at this time. To continue with this booking, or to check other offers in this hotel, please speak to one of our friendly team at our call centre using the numbers below and quote the reference number provided.',
	        _react2.default.createElement(
	          'strong',
	          null,
	          ' Call ',
	          _LHX2.default.landlinePhone,
	          ' to speak to one of our friendly advisers.'
	        ),
	        !(0, _utils.isDomainIe)() && _react2.default.createElement(
	          'span',
	          null,
	          _LHX2.default.isPhoneEnabled ? _react2.default.createElement(
	            'span',
	            null,
	            ' Calls to 0800 numbers are normally free of charge from landlines but charges may apply from mobile phones; calls to 01 numbers from mobile phones are often included in your inclusive minutes.'
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            ' Calls to 0844 numbers will be charged at 5p per minute from BT Landlines.'
	          )
	        )
	      )
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(NotificationsLayout, [{
	    key: 'render',
	    value: function render() {
	      var notifications = this.props.notifications;
	
	      var message = notifications && notifications.name && this.messages[notifications.name];
	
	      return message ? _react2.default.createElement(
	        'div',
	        { className: 'notifications-layout' },
	        _react2.default.createElement(
	          'div',
	          { className: 'notifications-layout__inner' },
	          _react2.default.createElement(
	            'span',
	            null,
	            message
	          ),
	          _react2.default.createElement('a', { href: '#', className: 'notifications-layout__close', onClick: this.closeNotification, title: 'Close' })
	        )
	      ) : _react2.default.createElement('span', null);
	    }
	  }]);
	  return NotificationsLayout;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NotificationsLayout);

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PopoverLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _popoverActions = __webpack_require__(144);
	
	var popoverActions = _interopRequireWildcard(_popoverActions);
	
	var _Popover = __webpack_require__(538);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _Modal = __webpack_require__(305);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _utils = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    popoverState: state.popover || {},
	    modal: state.modal
	  };
	};
	
	/* istanbul ignore next */
	function mapDispatchToProps(dispatch) {
	  return {
	    popoverActionsBound: (0, _redux.bindActionCreators)(popoverActions, dispatch)
	  };
	}
	
	var PopoverLayout = exports.PopoverLayout = function (_Component) {
	  (0, _inherits3.default)(PopoverLayout, _Component);
	
	  function PopoverLayout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PopoverLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverLayout.__proto__ || (0, _getPrototypeOf2.default)(PopoverLayout)).call.apply(_ref, [this].concat(args))), _this), _this.closePopover = function (event) {
	      var popoverActionsBound = _this.props.popoverActionsBound;
	
	      event.preventDefault();
	      popoverActionsBound.hidePopover();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PopoverLayout, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          popoverState = _props.popoverState,
	          modal = _props.modal;
	
	
	      var body = popoverState.body;
	      var isModalOpen = modal && modal.name && !modal.config.isSubPage;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        body && ((0, _utils.isIpad)() && !isModalOpen ? _react2.default.createElement(
	          _Modal2.default,
	          { onModalClose: this.closePopover },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              null,
	              popoverState.title
	            ),
	            typeof body === 'string' ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: body } }) : body
	          )
	        ) : _react2.default.createElement(_Popover2.default, {
	          closePopover: this.closePopover,
	          popoverState: popoverState,
	          title: popoverState.title,
	          hasCloseButton: popoverState.hasCloseButton,
	          body: body,
	          position: popoverState.position
	        }))
	      );
	    }
	  }]);
	  return PopoverLayout;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PopoverLayout);

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PriceTrackerSignUpLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _svgInlineReact = __webpack_require__(64);
	
	var _svgInlineReact2 = _interopRequireDefault(_svgInlineReact);
	
	var _dates = __webpack_require__(309);
	
	var _utils = __webpack_require__(8);
	
	var _book = __webpack_require__(215);
	
	var _dates2 = __webpack_require__(35);
	
	var _dates3 = _interopRequireDefault(_dates2);
	
	var _optimizely = __webpack_require__(30);
	
	var optimizelyUtil = _interopRequireWildcard(_optimizely);
	
	var _dataLayerHelpers = __webpack_require__(321);
	
	var _gtm = __webpack_require__(602);
	
	var _LHX = __webpack_require__(67);
	
	var _LHX2 = _interopRequireDefault(_LHX);
	
	var _priceTrackerActions = __webpack_require__(586);
	
	var priceTrackerActions = _interopRequireWildcard(_priceTrackerActions);
	
	var _tagActions = __webpack_require__(587);
	
	var tagActions = _interopRequireWildcard(_tagActions);
	
	var _PriceTrackerSummary = __webpack_require__(539);
	
	var _PriceTrackerSummary2 = _interopRequireDefault(_PriceTrackerSummary);
	
	var _LinkButton = __webpack_require__(65);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _EmailSignUp = __webpack_require__(528);
	
	var _EmailSignUp2 = _interopRequireDefault(_EmailSignUp);
	
	var _SubpageMasthead = __webpack_require__(551);
	
	var _SubpageMasthead2 = _interopRequireDefault(_SubpageMasthead);
	
	var _Loading = __webpack_require__(164);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _validationRegexes = __webpack_require__(311);
	
	var _validationRegexes2 = _interopRequireDefault(_validationRegexes);
	
	__webpack_require__(957);
	
	__webpack_require__(956);
	
	var _bell = __webpack_require__(1364);
	
	var _bell2 = _interopRequireDefault(_bell);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    appState: state.appState,
	    baseState: state.baseState,
	    bookState: state.bookState,
	    hotelDetails: state.hotelDetails,
	    priceTracker: state.priceTracker,
	    featureFlags: state.featureFlags
	  };
	};
	
	/* istanbul ignore next */
	function mapDispatchToProps(dispatch) {
	  return {
	    priceTrackerActionsBound: (0, _redux.bindActionCreators)(priceTrackerActions, dispatch),
	    tagActionsBound: (0, _redux.bindActionCreators)(tagActions, dispatch)
	  };
	}
	
	var PriceTrackerSignUpLayout = exports.PriceTrackerSignUpLayout = function (_Component) {
	  (0, _inherits3.default)(PriceTrackerSignUpLayout, _Component);
	
	  function PriceTrackerSignUpLayout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PriceTrackerSignUpLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PriceTrackerSignUpLayout.__proto__ || (0, _getPrototypeOf2.default)(PriceTrackerSignUpLayout)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      emailModified: false,
	      fullNameModified: false,
	      submitted: false
	    }, _this.fireOptimizely = function (message) {
	      optimizelyUtil.fireEvent('PriceTrackerSignUp', message);
	    }, _this.isValidName = function (value) {
	      return value.length > 2;
	    }, _this.isValidEmail = function (value) {
	      return _validationRegexes2.default.email.test(value) && value.length > 5;
	    }, _this.onSubmit = function (event) {
	      event.preventDefault();
	
	      if (_this.isFormValid) {
	        var _this2 = _this,
	            backURL = _this2.backURL,
	            calDate = _this2.calDate,
	            endpoint = _this2.endpoint,
	            offerSummary = _this2.offerSummary,
	            optimizelyParams = _this2.optimizelyParams,
	            props = _this2.props,
	            replaceUrlParam = _this2.replaceUrlParam,
	            userClass = _this2.userClass;
	        var priceTrackerActionsBound = props.priceTrackerActionsBound,
	            appState = props.appState,
	            priceTracker = props.priceTracker,
	            tagActionsBound = props.tagActionsBound,
	            _location = props.location,
	            route = props.route;
	
	        var pageToTrackUrl = replaceUrlParam(backURL, 'calDate', calDate);
	        pageToTrackUrl = replaceUrlParam(pageToTrackUrl, 'ch', 'sha');
	
	        optimizelyParams.forEach(function (item) {
	          pageToTrackUrl = replaceUrlParam(pageToTrackUrl, item[0], item[1]);
	        });
	
	        var formData = {
	          email: priceTracker.get('email'),
	          userClass: userClass,
	          name: priceTracker.get('fullName'),
	          pageToTrackUrl: pageToTrackUrl,
	          subscribeToNewsletter: priceTracker.get('newsletterSubscription'),
	          hotelName: offerSummary.hotelName,
	          resort: offerSummary.destination,
	          nights: offerSummary.duration,
	          offerState: offerSummary.offerState,
	          boardBasis: offerSummary.boardBasis,
	          outbound: {
	            flightNumber: offerSummary.flightDetails.outboundFlightNumber,
	            departureDate: offerSummary.flightDetails.outboundDate,
	            arrivalDate: offerSummary.flightDetails.outboundArrivalDate,
	            departureTime: offerSummary.flightDetails.outboundDepartureTime,
	            arrivalTime: offerSummary.flightDetails.outboundArrivalTime,
	            airport: offerSummary.flightDetails.outboundDepartureName
	          },
	          inbound: {
	            flightNumber: offerSummary.flightDetails.inboundFlightNumber,
	            departureDate: offerSummary.flightDetails.inboundDate,
	            arrivalDate: offerSummary.flightDetails.inboundArrivalDate,
	            departureTime: offerSummary.flightDetails.inboundDepartureTime,
	            arrivalTime: offerSummary.flightDetails.inboundArrivalTime,
	            airport: offerSummary.flightDetails.inboundDepartureName
	          },
	          price: appState.getIn(['selectedOffer', 'price'])
	        };
	
	        priceTrackerActionsBound.postSignUp(formData, endpoint);
	
	        if (priceTracker.get('newsletterSubscription')) {
	          tagActionsBound.fireGTMEvent(_gtm.GTM_EVENT_NAMES.TRACK_PRICE_TRACKER, _location, route);
	        }
	
	        _this.setState({
	          submitted: true
	        });
	      } else {
	        _this.setState({
	          emailModified: true,
	          fullNameModified: true
	        });
	      }
	    }, _this.onNameBlur = function () {
	      _this.setState({
	        fullNameModified: true
	      });
	    }, _this.onEmailBlur = function () {
	      _this.setState({
	        emailModified: true
	      });
	    }, _this.toggleSubscribe = function () {
	      var _this$props = _this.props,
	          priceTracker = _this$props.priceTracker,
	          priceTrackerActionsBound = _this$props.priceTrackerActionsBound;
	
	      priceTrackerActionsBound.setNewsletterSubscription(!priceTracker.get('newsletterSubscription'));
	    }, _this.setNameField = function (event) {
	      _this.props.priceTrackerActionsBound.setFullName(event.currentTarget.value);
	    }, _this.setEmailField = function (event) {
	      _this.props.priceTrackerActionsBound.setEmail(event.currentTarget.value);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PriceTrackerSignUpLayout, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fireOptimizely('clicked');
	    }
	  }, {
	    key: 'replaceUrlParam',
	    value: function replaceUrlParam(url, paramName) {
	      var paramValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	      var pattern = new RegExp('\\b(' + paramName + '=).*?(&|$)');
	      var finalUrl = url;
	      if (url.search(pattern) >= 0) {
	        finalUrl = url.replace(pattern, '$1' + paramValue + '$2');
	      } else {
	        finalUrl = '' + url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
	      }
	
	      return finalUrl;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var offerSummary = this.offerSummary;
	
	      var submitted = this.state.submitted;
	      var _props = this.props,
	          isModal = _props.isModal,
	          priceTracker = _props.priceTracker,
	          routes = _props.routes;
	
	      var isBookRoute = routes.some(function (route) {
	        return route.pageName === 'book';
	      });
	      var isInBookPage = isBookRoute || isModal;
	      var priceAlertDays = isInBookPage ? '7' : '30';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'price-tracker-signup' },
	        !isModal && _react2.default.createElement(
	          _SubpageMasthead2.default,
	          { location: location, ctaType: 'back', backUrl: this.backURL },
	          _react2.default.createElement(
	            'div',
	            { className: 'price-tracker-signup__heading__title' },
	            _react2.default.createElement(_svgInlineReact2.default, { src: _bell2.default, className: 'price-tracker-signup__heading__icon' }),
	            priceAlertDays,
	            ' Day Price Alert'
	          )
	        ),
	        !this.isData && _react2.default.createElement(
	          'div',
	          { className: 'price-tracker-signup__message--loading' },
	          _react2.default.createElement(_Loading2.default, { loadingState: 'spinning' })
	        ),
	        !submitted && this.isData && _react2.default.createElement(_PriceTrackerSummary2.default, {
	          boardBasis: offerSummary.boardBasis,
	          destination: offerSummary.destination,
	          duration: offerSummary.duration,
	          offerState: offerSummary.offerState,
	          flightDetails: offerSummary.flightDetails,
	          hotelName: offerSummary.hotelName,
	          isCheapestFlight: offerSummary.isCheapestFlight
	        }),
	        !submitted && this.isData && _react2.default.createElement(_EmailSignUp2.default, {
	          email: priceTracker.get('email', ''),
	          formName: 'emailSignUp',
	          fullName: priceTracker.get('fullName', ''),
	          onEmailBlur: this.onEmailBlur,
	          onNameBlur: this.onNameBlur,
	          onSubmit: this.onSubmit,
	          setEmailField: this.setEmailField,
	          setNameField: this.setNameField,
	          setSubscribe: this.toggleSubscribe,
	          subscribe: priceTracker.get('newsletterSubscription', true),
	          validation: this.validation,
	          displayDisclaimer: isInBookPage
	        }),
	        submitted && this.isSuccess && _react2.default.createElement(
	          'div',
	          { className: 'price-tracker-signup__message--success' },
	          _react2.default.createElement(
	            'div',
	            { className: 'price-tracker-signup__message__text' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Thank you for signing up for Price Alerts!'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Be sure to look out for emails in your inbox.'
	            )
	          ),
	          !isModal && _react2.default.createElement(
	            _LinkButton2.default,
	            { to: this.backURL, type: 'secondary', size: 'small' },
	            'Click here to close now'
	          )
	        ),
	        submitted && this.isError && _react2.default.createElement(
	          'div',
	          { className: 'price-tracker-signup__message--error' },
	          _react2.default.createElement(
	            'div',
	            { className: 'price-tracker-signup__message__text' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Oops! Something has gone wrong.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Please try again.'
	            )
	          )
	        ),
	        submitted && this.isLoading && _react2.default.createElement(
	          'div',
	          { className: 'price-tracker-signup__message--loading' },
	          _react2.default.createElement(_Loading2.default, { loadingState: 'spinning' })
	        )
	      );
	    }
	  }, {
	    key: 'validation',
	    get: function get() {
	      var _this3 = this;
	
	      var _state = this.state,
	          emailModified = _state.emailModified,
	          fullNameModified = _state.fullNameModified;
	
	      return {
	        confirmName: {
	          isValid: function isValid(value) {
	            return !fullNameModified ? null : _this3.isValidName(value);
	          },
	          message: 'Please provide a valid name'
	        },
	        confirmEmail: {
	          isValid: function isValid(value) {
	            return !emailModified ? null : _this3.isValidEmail(value);
	          },
	          message: 'Please provide a valid email address'
	        }
	      };
	    }
	  }, {
	    key: 'isLoading',
	    get: function get() {
	      return this.props.priceTracker.get('request') === 'pending';
	    }
	  }, {
	    key: 'isSuccess',
	    get: function get() {
	      var isSuccessful = this.props.priceTracker.get('request') === 'success';
	      if (isSuccessful) {
	        this.fireOptimizely('selected');
	      }
	      return isSuccessful;
	    }
	  }, {
	    key: 'isError',
	    get: function get() {
	      return this.props.priceTracker.get('request') === 'failure';
	    }
	  }, {
	    key: 'isData',
	    get: function get() {
	      var _props2 = this.props,
	          appState = _props2.appState,
	          bookState = _props2.bookState;
	
	      return !!appState.get('selectedOffer') || !!bookState.get('data');
	    }
	  }, {
	    key: 'isFormValid',
	    get: function get() {
	      var _state2 = this.state,
	          emailModified = _state2.emailModified,
	          fullNameModified = _state2.fullNameModified;
	      var priceTracker = this.props.priceTracker;
	      var _validation = this.validation,
	          confirmName = _validation.confirmName,
	          confirmEmail = _validation.confirmEmail;
	
	      return emailModified && fullNameModified && confirmName.isValid(priceTracker.get('fullName')) && confirmEmail.isValid(priceTracker.get('email'));
	    }
	  }, {
	    key: 'endpoint',
	    get: function get() {
	      var location = this.props.location;
	
	      var url = '/api/pricetracker/email';
	      return location.pathname.split('/')[1] === 'book' ? '/book' + url : url;
	    }
	  }, {
	    key: 'optimizelyParams',
	    get: function get() {
	      var optimizely = window.optimizely.data;
	      var optimizelyState = !!optimizely && !!optimizely.state ? optimizely.state : {};
	      var activeExperiments = optimizelyState.activeExperiments || [];
	      var variationMap = optimizelyState.variationMap || {};
	      return activeExperiments.map(function (id) {
	        return ['optimizely_x' + id, variationMap[id]];
	      });
	    }
	  }, {
	    key: 'userClass',
	    get: function get() {
	      var userClass = (0, _dataLayerHelpers.getUserClassArray)(_LHX2.default.userClass);
	      return userClass ? userClass.join('') : '';
	    }
	  }, {
	    key: 'inboundArrivalName',
	    get: function get() {
	      var _props3 = this.props,
	          appState = _props3.appState,
	          bookState = _props3.bookState;
	
	      return bookState.getIn(['data', 'flight', 'inbound', 'arrvName']) || appState.getIn(['selectedOffer', 'departureAirport']);
	    }
	  }, {
	    key: 'inboundArrivalTime',
	    get: function get() {
	      var _props4 = this.props,
	          appState = _props4.appState,
	          bookState = _props4.bookState;
	
	      return (0, _book.formatTime)(bookState.getIn(['data', 'flight', 'inbound', 'arrvTime'], '')) || appState.getIn(['selectedOffer', 'returnArrivalTime']);
	    }
	  }, {
	    key: 'inboundDate',
	    get: function get() {
	      var _props5 = this.props,
	          appState = _props5.appState,
	          bookState = _props5.bookState;
	
	      var inboundDate = bookState.getIn(['data', 'flight', 'inbound', 'deptDate']) || appState.getIn(['selectedOffer', 'returnDepartureDate']);
	      return _dates3.default.format(inboundDate, _dates.EXPECTED_PRICE_TRACKER_DATE_FORMAT);
	    }
	  }, {
	    key: 'inboundArrivalDate',
	    get: function get() {
	      var _props6 = this.props,
	          appState = _props6.appState,
	          bookState = _props6.bookState;
	
	      var inboundDate = bookState.getIn(['data', 'flight', 'inbound', 'arrvDate']) || appState.getIn(['selectedOffer', 'returnArrivalDate']);
	      return _dates3.default.format(inboundDate, _dates.EXPECTED_PRICE_TRACKER_DATE_FORMAT);
	    }
	  }, {
	    key: 'inboundDepartureName',
	    get: function get() {
	      var _props7 = this.props,
	          appState = _props7.appState,
	          bookState = _props7.bookState;
	
	      return bookState.getIn(['data', 'flight', 'inbound', 'deptName']) || appState.getIn(['selectedOffer', 'returnAirport']);
	    }
	  }, {
	    key: 'inboundDepartureTime',
	    get: function get() {
	      var _props8 = this.props,
	          appState = _props8.appState,
	          bookState = _props8.bookState;
	
	      return (0, _book.formatTime)(bookState.getIn(['data', 'flight', 'inbound', 'deptTime'], '')) || appState.getIn(['selectedOffer', 'returnDepartureTime']);
	    }
	  }, {
	    key: 'inboundFlightNumber',
	    get: function get() {
	      var _props9 = this.props,
	          appState = _props9.appState,
	          bookState = _props9.bookState;
	
	      return bookState.getIn(['data', 'flight', 'inbound', 'number']) || appState.getIn(['selectedOffer', 'returnFlightNumber']);
	    }
	  }, {
	    key: 'outboundArrivalName',
	    get: function get() {
	      var _props10 = this.props,
	          appState = _props10.appState,
	          bookState = _props10.bookState;
	
	      return bookState.getIn(['data', 'flight', 'outbound', 'arrvName']) || appState.getIn(['selectedOffer', 'returnAirport']);
	    }
	  }, {
	    key: 'outboundArrivalTime',
	    get: function get() {
	      var _props11 = this.props,
	          appState = _props11.appState,
	          bookState = _props11.bookState;
	
	      return (0, _book.formatTime)(bookState.getIn(['data', 'flight', 'outbound', 'arrvTime'], '')) || appState.getIn(['selectedOffer', 'arrivalTime']);
	    }
	  }, {
	    key: 'outboundArrivalDate',
	    get: function get() {
	      var _props12 = this.props,
	          appState = _props12.appState,
	          bookState = _props12.bookState;
	
	      var inboundDate = bookState.getIn(['data', 'flight', 'outbound', 'arrvDate']) || appState.getIn(['selectedOffer', 'arrivalDate']);
	      return _dates3.default.format(inboundDate, _dates.EXPECTED_PRICE_TRACKER_DATE_FORMAT);
	    }
	  }, {
	    key: 'outboundDate',
	    get: function get() {
	      var _props13 = this.props,
	          appState = _props13.appState,
	          bookState = _props13.bookState;
	
	      var inboundDate = bookState.getIn(['data', 'flight', 'outbound', 'deptDate']) || appState.getIn(['selectedOffer', 'departureDate']);
	      return _dates3.default.format(inboundDate, _dates.EXPECTED_PRICE_TRACKER_DATE_FORMAT);
	    }
	  }, {
	    key: 'outboundDepartureName',
	    get: function get() {
	      var _props14 = this.props,
	          appState = _props14.appState,
	          bookState = _props14.bookState;
	
	      return bookState.getIn(['data', 'flight', 'outbound', 'deptName']) || appState.getIn(['selectedOffer', 'departureAirport']);
	    }
	  }, {
	    key: 'outboundDepartureTime',
	    get: function get() {
	      var _props15 = this.props,
	          appState = _props15.appState,
	          bookState = _props15.bookState;
	
	      return (0, _book.formatTime)(bookState.getIn(['data', 'flight', 'outbound', 'deptTime'], '')) || appState.getIn(['selectedOffer', 'departureTime']);
	    }
	  }, {
	    key: 'outboundFlightNumber',
	    get: function get() {
	      var _props16 = this.props,
	          appState = _props16.appState,
	          bookState = _props16.bookState;
	
	      return bookState.getIn(['data', 'flight', 'outbound', 'number']) || appState.getIn(['selectedOffer', 'flightNumber']);
	    }
	  }, {
	    key: 'destination',
	    get: function get() {
	      var _props17 = this.props,
	          hotelDetails = _props17.hotelDetails,
	          bookState = _props17.bookState;
	
	      var area = hotelDetails.get('D_DestLevel3') || hotelDetails.get('D_DestLevel2');
	      var destination = hotelDetails.get('D_Resort') + ', ' + area;
	      return bookState.getIn(['data', 'destination']) || destination;
	    }
	  }, {
	    key: 'hotelName',
	    get: function get() {
	      var _props18 = this.props,
	          hotelDetails = _props18.hotelDetails,
	          bookState = _props18.bookState;
	
	      return bookState.getIn(['data', 'hotel_name']) || hotelDetails.get('name');
	    }
	  }, {
	    key: 'boardBasis',
	    get: function get() {
	      var _props19 = this.props,
	          appState = _props19.appState,
	          bookState = _props19.bookState;
	
	      var roomId = bookState.getIn(['booking_info', 'selection', 'room_selected', 0]);
	      return (0, _utils.getBoardBasisLabel)(bookState.getIn(['entities', 'rooms', '' + roomId, 'board_basis'])) || appState.getIn(['selectedOffer', 'boardBasis']);
	    }
	  }, {
	    key: 'duration',
	    get: function get() {
	      var _props20 = this.props,
	          appState = _props20.appState,
	          bookState = _props20.bookState;
	
	      return bookState.getIn(['data', 'num_nights']) || appState.getIn(['selectedOffer', 'nights']);
	    }
	  }, {
	    key: 'offerState',
	    get: function get() {
	      var appState = this.props.appState;
	
	      return appState.getIn(['selectedOffer', 'offerState']);
	    }
	  }, {
	    key: 'calDate',
	    get: function get() {
	      var _props21 = this.props,
	          bookState = _props21.bookState,
	          baseState = _props21.baseState;
	
	
	      var baseDate = baseState.get('calDateValue');
	      var bookDate = new Date(bookState.getIn(['data', 'flight', 'outbound', 'deptDate']));
	
	      return baseDate || Date.UTC(bookDate.getFullYear(), bookDate.getMonth(), bookDate.getDate()) / _utils.dayInMilliseconds;
	    }
	  }, {
	    key: 'backURL',
	    get: function get() {
	      var location = this.props.location;
	
	      var urlPrefix = void 0;
	
	      if (location.pathname.split('/')[1] === 'book') {
	        urlPrefix = '/book/flight-and-hotel/offer-summary';
	      } else {
	        urlPrefix = location.pathname.split('/sub-page/price-tracker')[0];
	      }
	
	      var origin = window.location.protocol + '//' + window.location.host;
	      return '' + origin + urlPrefix + '.html' + location.search;
	    }
	  }, {
	    key: 'offerSummary',
	    get: function get() {
	      var flightDetails = {
	        inboundArrivalName: this.inboundArrivalName,
	        inboundArrivalTime: this.inboundArrivalTime,
	        inboundArrivalDate: this.inboundArrivalDate,
	        inboundDate: this.inboundDate,
	        inboundDepartureName: this.inboundDepartureName,
	        inboundDepartureTime: this.inboundDepartureTime,
	        inboundFlightNumber: this.inboundFlightNumber,
	        outboundArrivalName: this.outboundArrivalName,
	        outboundArrivalTime: this.outboundArrivalTime,
	        outboundArrivalDate: this.outboundArrivalDate,
	        outboundDate: this.outboundDate,
	        outboundDepartureName: this.outboundDepartureName,
	        outboundDepartureTime: this.outboundDepartureTime,
	        outboundFlightNumber: this.outboundFlightNumber
	      };
	
	      return {
	        boardBasis: this.boardBasis,
	        destination: this.destination,
	        duration: this.duration,
	        offerState: this.offerState,
	        flightDetails: flightDetails,
	        hotelName: this.hotelName,
	        isCheapestFlight: this.props.isCheapestFlight
	      };
	    }
	  }]);
	  return PriceTrackerSignUpLayout;
	}(_react.Component);
	
	PriceTrackerSignUpLayout.defaultProps = {
	  appState: _immutable2.default.Map(),
	  baseState: _immutable2.default.Map(),
	  bookState: _immutable2.default.Map(),
	  featureFlags: _immutable2.default.Map(),
	  hotelDetails: _immutable2.default.Map(),
	  priceTracker: _immutable2.default.Map(),
	  route: {},
	  routes: []
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PriceTrackerSignUpLayout);

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RoomFacilitiesOverlayLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _galleryActions = __webpack_require__(582);
	
	var galleryActions = _interopRequireWildcard(_galleryActions);
	
	var _Slideshow = __webpack_require__(550);
	
	var _Slideshow2 = _interopRequireDefault(_Slideshow);
	
	__webpack_require__(958);
	
	__webpack_require__(959);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	function mapStateToProps(state) {
	  return {
	    isMobileBreakpoint: state.appState.get('isMobileBreakpoint')
	  };
	}
	
	/* istanbul ignore next */
	function mapDispatchToProps(dispatch) {
	  return {
	    galleryActionsBound: (0, _redux.bindActionCreators)(galleryActions, dispatch)
	  };
	}
	
	var RoomFacilitiesOverlayLayout = exports.RoomFacilitiesOverlayLayout = function (_Component) {
	  (0, _inherits3.default)(RoomFacilitiesOverlayLayout, _Component);
	
	  function RoomFacilitiesOverlayLayout() {
	    (0, _classCallCheck3.default)(this, RoomFacilitiesOverlayLayout);
	    return (0, _possibleConstructorReturn3.default)(this, (RoomFacilitiesOverlayLayout.__proto__ || (0, _getPrototypeOf2.default)(RoomFacilitiesOverlayLayout)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RoomFacilitiesOverlayLayout, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          facilities = _props.facilities,
	          galleryActionsBound = _props.galleryActionsBound,
	          images = _props.images,
	          isMobileBreakpoint = _props.isMobileBreakpoint,
	          overlayText = _props.overlayText,
	          slideWidth = _props.slideWidth,
	          title = _props.title,
	          mainImageType = _props.mainImageType,
	          thumbnailImageType = _props.thumbnailImageType,
	          disableThumbnails = _props.disableThumbnails;
	
	
	      var showImages = !!images && !!images.size && !isMobileBreakpoint;
	      var modelPaddingLeftAndRight = 50;
	      var slideShowSlideWidth = slideWidth - modelPaddingLeftAndRight;
	      var hasFacilities = !!facilities && facilities.size > 0;
	
	      return _react2.default.createElement(
	        'article',
	        { className: 'room-facilities-overlay-layout__facilities-overview' },
	        showImages && _react2.default.createElement(
	          'div',
	          { className: 'room-facilities-overlay-layout__facilities-overview__slideshow ' + (!hasFacilities ? 'room-facilities-overlay-layout__facilities-overview__slideshow--no-facilities' : '') },
	          _react2.default.createElement(_Slideshow2.default, {
	            slideWidth: slideShowSlideWidth,
	            images: images,
	            overlayText: overlayText,
	            toggleControlsAreActive: galleryActionsBound.toggleControlsAreActive,
	            mainImageType: mainImageType,
	            thumbnailImageType: thumbnailImageType,
	            disableThumbnails: disableThumbnails
	          })
	        ),
	        _react2.default.createElement(
	          'h3',
	          { className: 'room-facilities-overlay-layout__facilities-overview__title' },
	          title
	        ),
	        hasFacilities && _react2.default.createElement(
	          'div',
	          { className: 'room-facilities-overlay-layout__facilities-overview__container-list ' + (showImages ? 'room-facilities-overlay-layout__facilities-overview__container-list--has-image' : '') },
	          _react2.default.createElement(
	            'div',
	            { className: 'room-facilities-overlay-layout__facilities-overview__list' },
	            _react2.default.createElement(
	              'ul',
	              null,
	              facilities.map(function (facility, index) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: index },
	                  facility
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return RoomFacilitiesOverlayLayout;
	}(_react.Component);
	
	RoomFacilitiesOverlayLayout.defaultProps = {
	  disableThumbnails: false,
	  facilities: _immutable2.default.List(),
	  mainImageType: 'RGXL',
	  slideWidth: 500,
	  thumbnailImageType: 'RTB'
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RoomFacilitiesOverlayLayout);

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RoomOptionsLayout = undefined;
	
	var _toConsumableArray2 = __webpack_require__(87);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _Overlay = __webpack_require__(166);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _modalActions = __webpack_require__(40);
	
	var _baseStateActions = __webpack_require__(142);
	
	var baseStateActions = _interopRequireWildcard(_baseStateActions);
	
	var _calendar = __webpack_require__(95);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _global = __webpack_require__(79);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _utils = __webpack_require__(8);
	
	__webpack_require__(960);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    appState: state.appState,
	    baseState: state.baseState
	  };
	};
	
	/* istanbul ignore next */
	function mapDispatchToProps(dispatch) {
	  return {
	    baseStateActionsBound: (0, _redux.bindActionCreators)(baseStateActions, dispatch),
	    toggleModalBound: function toggleModalBound() {
	      return dispatch((0, _modalActions.toggleModal)(''));
	    }
	  };
	}
	
	var RoomOptionsLayout = exports.RoomOptionsLayout = function (_Component) {
	  (0, _inherits3.default)(RoomOptionsLayout, _Component);
	
	  function RoomOptionsLayout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RoomOptionsLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RoomOptionsLayout.__proto__ || (0, _getPrototypeOf2.default)(RoomOptionsLayout)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.onApplyClick = function (event) {
	      var _this$props = _this.props,
	          baseState = _this$props.baseState,
	          baseStateActionsBound = _this$props.baseStateActionsBound,
	          toggleModalBound = _this$props.toggleModalBound;
	
	
	      var calDate = _calendar2.default.getDepartureDate(baseState, true);
	      var originalNumberOfRooms = _this.getRoomsFromBaseState().size;
	      var newRooms = _this.state.rooms;
	      var newNumberOfRooms = newRooms.size;
	
	      var baseStateRequest = {
	        calDate: calDate,
	        state: baseState.get('currentStateEncoded')
	      };
	
	      newRooms.forEach(function (room, index) {
	        var numberOfAdults = newRooms.getIn([index, 'nAdt', 'value']);
	        var childAges = newRooms.getIn([index, 'cdn', 'arrayValue'], _immutable2.default.List()).join(',');
	        baseStateRequest['rooms[' + index + '].nAdt'] = numberOfAdults;
	        baseStateRequest['rooms[' + index + '].cdn'] = childAges;
	      });
	
	      if (newNumberOfRooms < originalNumberOfRooms) {
	        (0, _utils.range)(newNumberOfRooms, originalNumberOfRooms).forEach(function (room, index) {
	          baseStateRequest['rooms[' + (index + newNumberOfRooms) + ']'] = 'removed';
	        });
	      }
	
	      baseStateActionsBound.loadBaseState(baseStateRequest).then(function () {
	        toggleModalBound(event);
	      });
	    }, _this.onCancelClick = function (event) {
	      _this.props.toggleModalBound(event);
	    }, _this.onNumberOfAdultsChange = function (roomIndex) {
	      return function (event) {
	        var value = event.currentTarget.value;
	        var rooms = _this.state.rooms.setIn([roomIndex, 'nAdt', 'value'], Number(value));
	        _this.setState({ rooms: rooms });
	      };
	    }, _this.onNumberOfChildrenChange = function (roomIndex) {
	      return function (event) {
	        var value = Number(event.currentTarget.value);
	        var childAges = _this.state.rooms.getIn([roomIndex, 'cdn', 'arrayValue'], _immutable2.default.List());
	        var numberOfChildren = childAges.size;
	
	        if (numberOfChildren > value) {
	          childAges = childAges.slice(0, value);
	        } else if (numberOfChildren < value) {
	          var newChildren = new Array(value - numberOfChildren).fill('tbc');
	          childAges = _immutable2.default.fromJS([].concat((0, _toConsumableArray3.default)(childAges.toJS()), (0, _toConsumableArray3.default)(newChildren)));
	        }
	
	        var rooms = _this.state.rooms.setIn([roomIndex, 'cdn', 'arrayValue'], childAges);
	        _this.setState({ rooms: rooms });
	      };
	    }, _this.onChildAgeChange = function (roomIndex, childAgeIndex) {
	      return function (event) {
	        var value = event.currentTarget.value;
	        var rooms = _this.state.rooms.setIn([roomIndex, 'cdn', 'arrayValue', childAgeIndex], value);
	        _this.setState({ rooms: rooms });
	      };
	    }, _this.onRemoveRoomClick = function (roomIndex) {
	      return function () {
	        var rooms = _this.state.rooms.filter(function (room, index) {
	          return index !== roomIndex;
	        });
	        _this.setState({ rooms: rooms });
	      };
	    }, _this.onAddRoomClick = function () {
	      var newRoom = _immutable2.default.fromJS({
	        cdn: {
	          arrayValue: []
	        },
	        nAdt: {
	          value: 2
	        }
	      });
	
	      var rooms = _this.state.rooms.push(newRoom);
	      _this.setState({ rooms: rooms });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RoomOptionsLayout, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var rooms = this.getRoomsFromBaseState();
	      this.setState({ rooms: rooms });
	    }
	  }, {
	    key: 'getRoomsFromBaseState',
	    value: function getRoomsFromBaseState() {
	      var baseState = this.props.baseState;
	
	      return baseState.getIn(['queryState', 'props', 'rooms'], _immutable2.default.List());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var appState = this.props.appState;
	
	
	      var isLoading = appState.get('loadingState');
	
	      var rooms = this.state.rooms;
	
	      var errorInParty = false;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'room-options-layout' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'room-options-layout__title' },
	          'Specify Party Size'
	        ),
	        isLoading && _react2.default.createElement(_Overlay2.default, { loadingState: isLoading }),
	        _react2.default.createElement(
	          'div',
	          { className: 'room-options-layout__rooms' },
	          rooms.map(function (room, roomIndex) {
	            var adultsCount = room.getIn(['nAdt', 'value'], 0);
	            var childAges = room.getIn(['cdn', 'arrayValue'], _immutable2.default.List());
	
	            var isErrorWithRoom = childAges.some(function (age) {
	              return age === 'tbc';
	            });
	            var isTooManyPeopleInRoom = adultsCount + childAges.size > 5;
	
	            if (isErrorWithRoom || isTooManyPeopleInRoom) {
	              errorInParty = true;
	            }
	
	            return _react2.default.createElement(
	              'div',
	              { className: 'room-options-layout__room__wrapper', key: roomIndex },
	              _react2.default.createElement(
	                'div',
	                { className: 'room-options-layout__room__selects' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'room-options-layout__room__section__people' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'room-options-layout__room__title' },
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      'Room ',
	                      roomIndex + 1
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'room-options-layout__room__adults' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'room-options-layout__room__adults__label' },
	                      'Adults:'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      {
	                        className: 'room-options-layout__room__adults__select',
	                        onChange: _this2.onNumberOfAdultsChange(roomIndex),
	                        value: Number(adultsCount)
	                      },
	                      _global2.default.adultsOptions.map(function (numAdults, i) {
	                        return _react2.default.createElement(
	                          'option',
	                          { value: numAdults, key: i },
	                          numAdults
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'room-options-layout__room__children' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'room-options-layout__room__children__label' },
	                      'Children:'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      {
	                        className: 'room-options-layout__room__children__select',
	                        onChange: _this2.onNumberOfChildrenChange(roomIndex),
	                        value: childAges.size
	                      },
	                      _global2.default.childrenOptions.map(function (numChildren, i) {
	                        return _react2.default.createElement(
	                          'option',
	                          { value: numChildren, key: i },
	                          numChildren
	                        );
	                      })
	                    )
	                  )
	                ),
	                !!childAges.size && _react2.default.createElement(
	                  'div',
	                  { className: 'room-options-layout__room__section__ages' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'room-options-layout__room__title' },
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      'Child Ages'
	                    )
	                  ),
	                  childAges.map(function (childAge, childAgeIndex) {
	                    var isErrorWithAge = childAge === 'tbc';
	
	                    return _react2.default.createElement(
	                      'label',
	                      { className: 'room-options-layout__room__children-age', key: childAgeIndex },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'room-options-layout__room__children__label' },
	                        'Child ',
	                        childAgeIndex + 1,
	                        ':'
	                      ),
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          className: 'room-options-layout__room__children-age__select ' + (isErrorWithAge ? 'room-options-layout__children-age__room__select--error' : ''),
	                          value: childAge,
	                          onChange: _this2.onChildAgeChange(roomIndex, childAgeIndex)
	                        },
	                        _react2.default.createElement('option', { value: 'tbc' }),
	                        (0, _utils.range)(0, _global2.default.maxChildAge + 1).map(function (age, ageIndex) {
	                          return _react2.default.createElement(
	                            'option',
	                            { value: '' + age, key: ageIndex },
	                            age
	                          );
	                        })
	                      )
	                    );
	                  })
	                )
	              ),
	              rooms.size > 1 && _react2.default.createElement(
	                'button',
	                {
	                  onClick: _this2.onRemoveRoomClick(roomIndex),
	                  className: 'room-options-layout__room__remove'
	                },
	                '- Remove room'
	              ),
	              isErrorWithRoom && _react2.default.createElement(
	                'div',
	                { className: 'room-options-layout__error' },
	                'Please ensure all the children have an age.'
	              ),
	              isTooManyPeopleInRoom && _react2.default.createElement(
	                'div',
	                { className: 'room-options-layout__error' },
	                'The maximum number of people allowed in this room is 5.'
	              )
	            );
	          }),
	          rooms.size < 3 && _react2.default.createElement(
	            'div',
	            { className: 'room-options-layout__button-group' },
	            _react2.default.createElement(
	              'button',
	              {
	                onClick: this.onAddRoomClick,
	                className: 'room-options-layout__room__add'
	              },
	              '+ Add another room'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'room-options-layout__button-group' },
	            _react2.default.createElement(
	              'button',
	              {
	                onClick: this.onCancelClick,
	                className: 'room-options-layout__button room-options-layout__button--cancel'
	              },
	              'Cancel'
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                onClick: this.onApplyClick,
	                className: 'room-options-layout__button room-options-layout__button--apply ' + (errorInParty ? 'room-options-layout__button--disabled' : ''),
	                disabled: errorInParty
	              },
	              'Apply'
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return RoomOptionsLayout;
	}(_react.Component);
	
	RoomOptionsLayout.defaultProps = {
	  appState: _immutable2.default.Map(),
	  baseState: _immutable2.default.Map()
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RoomOptionsLayout);

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchUnitCalendarLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _calendarOfferActions = __webpack_require__(316);
	
	var calendarOfferActions = _interopRequireWildcard(_calendarOfferActions);
	
	var _searchUnitActions = __webpack_require__(66);
	
	var searchUnitActions = _interopRequireWildcard(_searchUnitActions);
	
	var _customControlActions = __webpack_require__(120);
	
	var customControlActions = _interopRequireWildcard(_customControlActions);
	
	var _annualAvailabilityActions = __webpack_require__(141);
	
	var annualAvailabilityActions = _interopRequireWildcard(_annualAvailabilityActions);
	
	var _searchUnit = __webpack_require__(140);
	
	var _utils = __webpack_require__(8);
	
	var _dates = __webpack_require__(35);
	
	var _SearchUnitCustomControlCalendar = __webpack_require__(306);
	
	var _SearchUnitCustomControlCalendar2 = _interopRequireDefault(_SearchUnitCustomControlCalendar);
	
	var _SearchUnitCustomControlCalendarToggle = __webpack_require__(542);
	
	var _SearchUnitCustomControlCalendarToggle2 = _interopRequireDefault(_SearchUnitCustomControlCalendarToggle);
	
	var _DatePickerWithPrices = __webpack_require__(524);
	
	var _DatePickerWithPrices2 = _interopRequireDefault(_DatePickerWithPrices);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    appState: state.appState,
	    annualAvailability: state.annualAvailability,
	    baseState: state.baseState,
	    hotelDetails: state.hotelDetails,
	    dimensionsEntities: state.dimensionsEntities,
	    dimensionsResult: state.dimensionsResult,
	    featureFlags: state.featureFlags
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    calendarOfferActionsBound: (0, _redux.bindActionCreators)(calendarOfferActions, dispatch),
	    searchUnitActionsBound: (0, _redux.bindActionCreators)(searchUnitActions, dispatch),
	    customControlActionsBound: (0, _redux.bindActionCreators)(customControlActions, dispatch),
	    annualAvailabilityActionsBound: (0, _redux.bindActionCreators)(annualAvailabilityActions, dispatch)
	  };
	};
	
	var SearchUnitCalendarLayout = exports.SearchUnitCalendarLayout = function (_Component) {
	  (0, _inherits3.default)(SearchUnitCalendarLayout, _Component);
	
	  function SearchUnitCalendarLayout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SearchUnitCalendarLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchUnitCalendarLayout.__proto__ || (0, _getPrototypeOf2.default)(SearchUnitCalendarLayout)).call.apply(_ref, [this].concat(args))), _this), _this.onCalendarDateClick = function (calDate) {
	      var _this$props = _this.props,
	          calendarOfferActionsBound = _this$props.calendarOfferActionsBound,
	          searchUnitActionsBound = _this$props.searchUnitActionsBound,
	          customControlActionsBound = _this$props.customControlActionsBound,
	          baseState = _this$props.baseState,
	          isWholeMonthCalendarEnabled = _this$props.isWholeMonthCalendarEnabled;
	
	
	      calendarOfferActionsBound.calDateChanged();
	
	      var selectedFlexibility = baseState.getIn(['queryState', 'props', 'deptDateFlexibility', 'value']);
	      if (isWholeMonthCalendarEnabled && selectedFlexibility === _searchUnit.MONTH_FLEXIBILITY_VALUE) {
	        searchUnitActionsBound.setDepartureDateAndFlexibility(calDate, 0);
	      } else {
	        searchUnitActionsBound.setDepartureDate(calDate);
	      }
	      customControlActionsBound.hideControl();
	    }, _this.onCalendarMonthClick = function (calDate) {
	      var _this$props2 = _this.props,
	          calendarOfferActionsBound = _this$props2.calendarOfferActionsBound,
	          customControlActionsBound = _this$props2.customControlActionsBound,
	          searchUnitActionsBound = _this$props2.searchUnitActionsBound,
	          showPricing = _this$props2.showPricing;
	
	
	      calendarOfferActionsBound.calDateChanged();
	      searchUnitActionsBound.setDepartureDateAndFlexibility(calDate, _searchUnit.MONTH_FLEXIBILITY_VALUE);
	
	      if (!showPricing) {
	        customControlActionsBound.hideControl();
	      }
	    }, _this.onClearDate = function () {
	      var _this$props3 = _this.props,
	          searchUnitActionsBound = _this$props3.searchUnitActionsBound,
	          isWholeMonthCalendarEnabled = _this$props3.isWholeMonthCalendarEnabled;
	
	      if (isWholeMonthCalendarEnabled) {
	        searchUnitActionsBound.clearDepartureDateAndFlexibility();
	      } else {
	        searchUnitActionsBound.clearDepartureDate();
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SearchUnitCalendarLayout, [{
	    key: 'displayPerNightPricing',
	    value: function displayPerNightPricing() {
	      var _props = this.props,
	          featureFlags = _props.featureFlags,
	          appState = _props.appState,
	          hotelDetails = _props.hotelDetails;
	
	      var matchThirdPartyPricingOnCalendar = featureFlags.get('HotelOnlyMatchThirdPartyPricesOnCalendar', false);
	      var isHotelIndexed = hotelDetails.getIn(['hotelOnly', 'indexed'], false);
	      var hasThirdPartyChannel = appState.get('hasThirdPartyChannelParamHO') && !isHotelIndexed;
	
	      return !!hasThirdPartyChannel && matchThirdPartyPricingOnCalendar;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          annualAvailability = _props2.annualAvailability,
	          annualAvailabilityActionsBound = _props2.annualAvailabilityActionsBound,
	          appState = _props2.appState,
	          baseState = _props2.baseState,
	          customControlActionsBound = _props2.customControlActionsBound,
	          dimensionsEntities = _props2.dimensionsEntities,
	          dimensionsResult = _props2.dimensionsResult,
	          featureFlags = _props2.featureFlags,
	          hotelDetails = _props2.hotelDetails,
	          isHotelOnly = _props2.isHotelOnly,
	          isWholeMonthCalendarEnabled = _props2.isWholeMonthCalendarEnabled,
	          loadDayOfMonthData = _props2.loadDayOfMonthData,
	          searchUnitActionsBound = _props2.searchUnitActionsBound,
	          selectedDate = _props2.selectedDate,
	          showPricing = _props2.showPricing;
	
	
	      var selectedFlexibility = baseState.getIn(['queryState', 'props', 'deptDateFlexibility', 'value']);
	      var duration = baseState.getIn(['queryState', 'props', 'duration', 'value']);
	
	      var showCalendarWithPricing = showPricing && duration <= _dates.HOTEL_ONLY_INDEX_MAX_SUPPORTED_DAYS;
	      var showCalendarWithWholeMonth = isWholeMonthCalendarEnabled && !showPricing;
	      var showDefaultCalendar = !isWholeMonthCalendarEnabled && (!showPricing || duration > _dates.HOTEL_ONLY_INDEX_MAX_SUPPORTED_DAYS);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'search-unit-calendar-layout' },
	        showCalendarWithPricing && _react2.default.createElement(_DatePickerWithPrices2.default, {
	          annualAvailability: annualAvailability,
	          annualAvailabilityType: 'ho',
	          appState: appState,
	          baseState: baseState,
	          displayPerNightPricing: this.displayPerNightPricing(),
	          featureFlags: featureFlags,
	          hotelDetail: hotelDetails,
	          handleDayClick: this.onCalendarDateClick,
	          handleMonthClick: this.onCalendarMonthClick,
	          annualAvailabilityActionsBound: annualAvailabilityActionsBound,
	          searchUnitActionsBound: searchUnitActionsBound,
	          customControlActionsBound: customControlActionsBound,
	          numberOfChargeablePassengers: baseState.get('numberOfChargeablePassengers')
	        }),
	        showCalendarWithWholeMonth && _react2.default.createElement(_SearchUnitCustomControlCalendarToggle2.default, {
	          availability: this.availabilityList,
	          dimensionsEntities: dimensionsEntities,
	          dimensionsResult: dimensionsResult,
	          handleDayClick: this.onCalendarDateClick,
	          handleMonthClick: this.onCalendarMonthClick,
	          hideLegend: isHotelOnly,
	          loadDayOfMonthData: loadDayOfMonthData,
	          monthViewDayStamp: (0, _utils.getMonthToShowForCalendar)(selectedDate),
	          selectedCalendarDayStamp: selectedDate,
	          selectedFlexibility: selectedFlexibility,
	          type: 'search-unit'
	        }),
	        showDefaultCalendar && _react2.default.createElement(_SearchUnitCustomControlCalendar2.default, {
	          availability: this.availabilityList,
	          dimensionsEntities: dimensionsEntities,
	          dimensionsResult: dimensionsResult,
	          handleDayClick: this.onCalendarDateClick,
	          hideLegend: isHotelOnly,
	          isHotelOnly: isHotelOnly,
	          loadDayOfMonthData: loadDayOfMonthData,
	          monthViewDayStamp: (0, _utils.getMonthToShowForCalendar)(selectedDate),
	          selectedCalendarDayStamp: selectedDate,
	          type: 'search-unit'
	        })
	      );
	    }
	  }, {
	    key: 'availabilityList',
	    get: function get() {
	      var _props3 = this.props,
	          dimensionsEntities = _props3.dimensionsEntities,
	          dimensionsResult = _props3.dimensionsResult;
	
	      var dayOfMonthAvailabilityIds = dimensionsResult.get('D_DayOfMonth') || _immutable2.default.List();
	      return dayOfMonthAvailabilityIds.map(function (id) {
	        return dimensionsEntities.get('' + id) && dimensionsEntities.getIn(['' + id, 'available']);
	      });
	    }
	  }]);
	  return SearchUnitCalendarLayout;
	}(_react.Component);
	
	SearchUnitCalendarLayout.defaultProps = {
	  isHotelOnly: false,
	  showPricing: false,
	  isWholeMonthCalendarEnabled: false
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchUnitCalendarLayout);

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchUnitDepartureAirportLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _SearchUnitDepartureAirport = __webpack_require__(543);
	
	var _SearchUnitDepartureAirport2 = _interopRequireDefault(_SearchUnitDepartureAirport);
	
	var _appStateActions = __webpack_require__(94);
	
	var appStateActions = _interopRequireWildcard(_appStateActions);
	
	var _customControlActions = __webpack_require__(120);
	
	var customControlActions = _interopRequireWildcard(_customControlActions);
	
	var _searchUnitActions = __webpack_require__(66);
	
	var searchUnitActions = _interopRequireWildcard(_searchUnitActions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    appState: state.appState,
	    baseState: state.baseState,
	    dimensionsEntities: state.dimensionsEntities,
	    dimensionsResult: state.dimensionsResult
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    appStateActionsBound: (0, _redux.bindActionCreators)(appStateActions, dispatch),
	    customControlActionsBound: (0, _redux.bindActionCreators)(customControlActions, dispatch),
	    searchUnitActionsBound: (0, _redux.bindActionCreators)(searchUnitActions, dispatch)
	  };
	};
	
	var SearchUnitDepartureAirportLayout = exports.SearchUnitDepartureAirportLayout = function (_Component) {
	  (0, _inherits3.default)(SearchUnitDepartureAirportLayout, _Component);
	
	  function SearchUnitDepartureAirportLayout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SearchUnitDepartureAirportLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchUnitDepartureAirportLayout.__proto__ || (0, _getPrototypeOf2.default)(SearchUnitDepartureAirportLayout)).call.apply(_ref, [this].concat(args))), _this), _this.onDepartureAirportClick = function (airport) {
	      var searchUnitActionsBound = _this.props.searchUnitActionsBound;
	
	
	      searchUnitActionsBound.addDepartureAirport(Number(airport.value));
	    }, _this.onRemoveDepartureAirport = function (airport) {
	      var searchUnitActionsBound = _this.props.searchUnitActionsBound;
	
	
	      searchUnitActionsBound.removeDepartureAirport(Number(airport.value));
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SearchUnitDepartureAirportLayout, [{
	    key: 'getAllOutboundAirports',
	    value: function getAllOutboundAirports() {
	      var _props = this.props,
	          baseState = _props.baseState,
	          dimensionsEntities = _props.dimensionsEntities,
	          dimensionsResult = _props.dimensionsResult;
	
	      var availableAirportIds = dimensionsResult.get('D_DepartureAirport');
	      var availableAirports = [];
	
	      availableAirports.push({
	        label: 'Any',
	        value: '-1',
	        checked: false,
	        unavailable: false
	      });
	
	      if (availableAirportIds) {
	        availableAirportIds.map(function (dimId) {
	          var obj = dimensionsEntities.get('' + dimId);
	          var departureAirports = baseState.get('D_DepartureAirport');
	          availableAirports.push({
	            label: '' + obj.get('label'),
	            value: '' + dimId,
	            checked: departureAirports ? departureAirports.includes(dimId) : false,
	            unavailable: !obj.get('available')
	          });
	        });
	      }
	
	      return availableAirports;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'search-unit-departure-airport-layout' },
	        _react2.default.createElement(_SearchUnitDepartureAirport2.default, {
	          options: this.getAllOutboundAirports(),
	          addDepartureAirport: this.onDepartureAirportClick,
	          removeDepartureAirport: this.onRemoveDepartureAirport
	        })
	      );
	    }
	  }]);
	  return SearchUnitDepartureAirportLayout;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchUnitDepartureAirportLayout);

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchUnitDepartureDateLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _searchUnitActions = __webpack_require__(66);
	
	var searchUnitActions = _interopRequireWildcard(_searchUnitActions);
	
	var _SearchUnitCalendarLayout = __webpack_require__(572);
	
	var _SearchUnitCalendarLayout2 = _interopRequireDefault(_SearchUnitCalendarLayout);
	
	var _optimizely = __webpack_require__(30);
	
	var optimizelyUtil = _interopRequireWildcard(_optimizely);
	
	var _dates = __webpack_require__(35);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _calendar = __webpack_require__(95);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _LinkInput = __webpack_require__(532);
	
	var _LinkInput2 = _interopRequireDefault(_LinkInput);
	
	var _dates3 = __webpack_require__(309);
	
	var _searchUnit = __webpack_require__(140);
	
	var _utils = __webpack_require__(8);
	
	var _CustomControlWrapperLayout = __webpack_require__(313);
	
	var _CustomControlWrapperLayout2 = _interopRequireDefault(_CustomControlWrapperLayout);
	
	var _CustomControlWrapper = __webpack_require__(312);
	
	var _CustomControlWrapper2 = _interopRequireDefault(_CustomControlWrapper);
	
	var _CustomControlPopoverWrapper = __webpack_require__(523);
	
	var _CustomControlPopoverWrapper2 = _interopRequireDefault(_CustomControlPopoverWrapper);
	
	__webpack_require__(961);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    appState: state.appState,
	    baseState: state.baseState,
	    featureFlags: state.featureFlags,
	    hotelOnly: state.hotelOnly
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    searchUnitActionsBound: (0, _redux.bindActionCreators)(searchUnitActions, dispatch)
	  };
	};
	
	var SearchUnitDepartureDateLayout = exports.SearchUnitDepartureDateLayout = function (_Component) {
	  (0, _inherits3.default)(SearchUnitDepartureDateLayout, _Component);
	
	  function SearchUnitDepartureDateLayout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SearchUnitDepartureDateLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchUnitDepartureDateLayout.__proto__ || (0, _getPrototypeOf2.default)(SearchUnitDepartureDateLayout)).call.apply(_ref, [this].concat(args))), _this), _this.showCalendarControl = function () {
	      _this.props.showCustomControl();
	    }, _this.onClearDate = function () {
	      var _this$props = _this.props,
	          searchUnitActionsBound = _this$props.searchUnitActionsBound,
	          baseState = _this$props.baseState,
	          isWholeMonthCalendarEnabled = _this$props.isWholeMonthCalendarEnabled;
	
	
	      var selectedFlexibility = baseState.getIn(['queryState', 'props', 'deptDateFlexibility', 'value']);
	      if (isWholeMonthCalendarEnabled && selectedFlexibility === _searchUnit.MONTH_FLEXIBILITY_VALUE) {
	        searchUnitActionsBound.clearDepartureDateAndFlexibility();
	      } else {
	        searchUnitActionsBound.clearDepartureDate();
	      }
	    }, _this.onFlexibilityChange = function (event) {
	      var searchUnitActionsBound = _this.props.searchUnitActionsBound;
	
	      var value = event.currentTarget.value;
	
	      searchUnitActionsBound.setDepartureDateFlexibility(value);
	      _this.reportFlexibilityChanged();
	    }, _this.saveInputRef = function (ref) {
	      _this.inputRef = ref;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SearchUnitDepartureDateLayout, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          baseState = _props.baseState,
	          disableFlexibility = _props.disableFlexibility,
	          isPanda = _props.isPanda;
	
	
	      if (!isPanda) {
	        var isDateSelected = baseState.getIn(['queryState', 'props', 'deptDate', 'selected']);
	        var isFlexibilitySet = baseState.getIn(['queryState', 'props', 'deptDateFlexibility', 'selected']);
	
	        if (isDateSelected && !isFlexibilitySet && !disableFlexibility) {
	          this.setDefaultFlexibility();
	        }
	      }
	    }
	  }, {
	    key: 'setDefaultFlexibility',
	    value: function setDefaultFlexibility() {
	      var _props2 = this.props,
	          featureFlags = _props2.featureFlags,
	          searchUnitActionsBound = _props2.searchUnitActionsBound;
	
	      var isFlexi3DaysEnabled = featureFlags.get('SearchUnitFlexi3DaysEnabled');
	
	      if (isFlexi3DaysEnabled) {
	        searchUnitActionsBound.setDepartureDateFlexibility(3);
	      }
	    }
	  }, {
	    key: 'reportFlexibilityChanged',
	    value: function reportFlexibilityChanged() {
	      var featureFlags = this.props.featureFlags;
	
	      var message = featureFlags.get('SearchUnitFlexi3DaysEnabled') ? '3Days' : '0Days';
	      optimizelyUtil.fireEvent('SearchUnitFlexibilitySelect' + message, 'clicked');
	    }
	  }, {
	    key: 'getDeptDate',
	    value: function getDeptDate() {
	      var _props3 = this.props,
	          baseState = _props3.baseState,
	          isPanda = _props3.isPanda;
	
	      return parseInt(_calendar2.default.getDepartureDate(baseState, isPanda), 10);
	    }
	  }, {
	    key: 'getVisibleFlexibilityItems',
	    value: function getVisibleFlexibilityItems() {
	      var isWholeMonthCalendarEnabled = this.props.isWholeMonthCalendarEnabled;
	
	      var visibleFlexibilityItems = _searchUnit.flexibilityItems;
	      if (isWholeMonthCalendarEnabled) {
	        visibleFlexibilityItems = visibleFlexibilityItems.filter(function (_ref2) {
	          var value = _ref2.value;
	          return value !== _searchUnit.MONTH_FLEXIBILITY_VALUE;
	        });
	      }
	
	      return visibleFlexibilityItems;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          baseState = _props4.baseState,
	          disableAnyDate = _props4.disableAnyDate,
	          disableFlexibility = _props4.disableFlexibility,
	          isCustomControlVisible = _props4.isCustomControlVisible,
	          isWholeMonthCalendarEnabled = _props4.isWholeMonthCalendarEnabled,
	          labelText = _props4.labelText,
	          location = _props4.location;
	
	
	      var deptDate = this.getDeptDate();
	      var selectedFlexibility = baseState.getIn(['queryState', 'props', 'deptDateFlexibility', 'value']);
	      var format = selectedFlexibility === _searchUnit.MONTH_FLEXIBILITY_VALUE && isWholeMonthCalendarEnabled ? 'MMM YY' : _dates3.CALENDAR_DATE_FORMAT;
	      var datePickerValue = deptDate ? _dates2.default.format(deptDate * _utils.dayInMilliseconds, format) : '';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'search-unit-departure-date-layout' },
	        datePickerValue ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { ref: this.saveInputRef },
	            _react2.default.createElement(
	              _LinkInput2.default,
	              {
	                hasCalendarIcon: true,
	                hasTag: !disableAnyDate,
	                label: labelText,
	                location: location,
	                onClick: this.showCalendarControl,
	                onTagClick: this.onClearDate
	              },
	              datePickerValue
	            )
	          ),
	          isCustomControlVisible && this.calendarControl,
	          !disableFlexibility && (selectedFlexibility !== _searchUnit.MONTH_FLEXIBILITY_VALUE || !isWholeMonthCalendarEnabled) && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'search-unit-departure-date-layout__flexibility-label' },
	              'Flexibility:'
	            ),
	            _react2.default.createElement(
	              'select',
	              { className: 'search-unit-departure-date-layout__flexibility', onChange: this.onFlexibilityChange, value: selectedFlexibility },
	              this.getVisibleFlexibilityItems().map(function (_ref3) {
	                var label = _ref3.label,
	                    value = _ref3.value;
	                return _react2.default.createElement(
	                  'option',
	                  { key: value, value: value },
	                  label
	                );
	              })
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { ref: this.saveInputRef },
	          _react2.default.createElement(_LinkInput2.default, {
	            hasCalendarIcon: true,
	            label: labelText,
	            location: location,
	            onClick: this.showCalendarControl,
	            onTagClick: this.onClearDate,
	            placeholder: (disableAnyDate ? 'Select' : 'Any') + ' Date'
	          }),
	          isCustomControlVisible && this.calendarControl
	        )
	      );
	    }
	  }, {
	    key: 'calendarControl',
	    get: function get() {
	      var _props5 = this.props,
	          appState = _props5.appState,
	          baseState = _props5.baseState,
	          hideCustomControl = _props5.hideCustomControl,
	          isHotelOnly = _props5.isHotelOnly,
	          isWholeMonthCalendarEnabled = _props5.isWholeMonthCalendarEnabled,
	          isDatePickerWithPricesEnabled = _props5.isDatePickerWithPricesEnabled,
	          searchUnitActionsBound = _props5.searchUnitActionsBound;
	
	
	      var width = appState.get('isMobileBreakpoint') ? 270 : 380;
	      var inputRefBounds = this.inputRef.getBoundingClientRect();
	      var coordinatesOfAssociatedElement = {
	        top: this.inputRef.offsetTop,
	        left: this.inputRef.offsetLeft,
	        width: inputRefBounds.width,
	        height: inputRefBounds.height
	      };
	
	      var loadDayOfMonthData = isHotelOnly ? undefined : searchUnitActionsBound.loadDayOfMonthData;
	
	      return _react2.default.createElement(
	        _CustomControlWrapper2.default,
	        { closeCustomControl: hideCustomControl },
	        _react2.default.createElement(
	          _CustomControlPopoverWrapper2.default,
	          { coordinatesOfAssociatedElement: coordinatesOfAssociatedElement, width: width, alignRight: true },
	          _react2.default.createElement(_SearchUnitCalendarLayout2.default, {
	            baseState: baseState,
	            isHotelOnly: isHotelOnly,
	            isWholeMonthCalendarEnabled: !isHotelOnly && isWholeMonthCalendarEnabled,
	            loadDayOfMonthData: loadDayOfMonthData,
	            selectedDate: this.getDeptDate(),
	            showPricing: isDatePickerWithPricesEnabled
	          })
	        )
	      );
	    }
	  }]);
	  return SearchUnitDepartureDateLayout;
	}(_react.Component);
	
	SearchUnitDepartureDateLayout.defaultProps = {
	  defaultDate: 0,
	  disableAnyDate: false,
	  disableFlexibility: false,
	  featureFlags: _immutable2.default.Map(),
	  isDatePickerWithPricesEnabled: false,
	  isHotelOnly: false,
	  isPanda: false,
	  isWholeMonthCalendarEnabled: false,
	  labelText: 'Depart:',
	  location: {}
	};
	exports.default = (0, _CustomControlWrapperLayout2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchUnitDepartureDateLayout));

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchUnitDestinationLayout = undefined;
	
	var _toConsumableArray2 = __webpack_require__(87);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(56);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _SelectListWithKeySupport = __webpack_require__(308);
	
	var _SelectListWithKeySupport2 = _interopRequireDefault(_SelectListWithKeySupport);
	
	var _SearchUnitDestination = __webpack_require__(544);
	
	var _SearchUnitDestination2 = _interopRequireDefault(_SearchUnitDestination);
	
	var _SearchUnitPopOver = __webpack_require__(546);
	
	var _SearchUnitPopOver2 = _interopRequireDefault(_SearchUnitPopOver);
	
	var _appStateActions = __webpack_require__(94);
	
	var appStateActions = _interopRequireWildcard(_appStateActions);
	
	var _baseStateActions = __webpack_require__(142);
	
	var baseStateActions = _interopRequireWildcard(_baseStateActions);
	
	var _searchUnitActions = __webpack_require__(66);
	
	var searchUnitActions = _interopRequireWildcard(_searchUnitActions);
	
	var _customControlActions = __webpack_require__(120);
	
	var customControlActions = _interopRequireWildcard(_customControlActions);
	
	var _optimizely = __webpack_require__(30);
	
	var optimizelyUtil = _interopRequireWildcard(_optimizely);
	
	var _utils = __webpack_require__(8);
	
	var _svgInlineReact = __webpack_require__(64);
	
	var _svgInlineReact2 = _interopRequireDefault(_svgInlineReact);
	
	var _earthGlobe = __webpack_require__(1365);
	
	var _earthGlobe2 = _interopRequireDefault(_earthGlobe);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    appState: state.appState,
	    baseState: state.baseState,
	    baseStateActionsBound: state.baseState,
	    dimensionsEntities: state.dimensionsEntities,
	    featureFlags: state.featureFlags,
	    search: state.search,
	    customControlVisible: state.customControl.id === 'suggestedDestinations'
	  };
	};
	
	/* istanbul ignore next */
	function mapDispatchToProps(dispatch) {
	  return {
	    appStateActionsBound: (0, _redux.bindActionCreators)(appStateActions, dispatch),
	    baseStateActionsBound: (0, _redux.bindActionCreators)(baseStateActions, dispatch),
	    customControlActionsBound: (0, _redux.bindActionCreators)(customControlActions, dispatch),
	    searchUnitActionsBound: (0, _redux.bindActionCreators)(searchUnitActions, dispatch)
	  };
	}
	
	var SearchUnitDestinationLayout = exports.SearchUnitDestinationLayout = function (_Component) {
	  (0, _inherits3.default)(SearchUnitDestinationLayout, _Component);
	
	  function SearchUnitDestinationLayout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SearchUnitDestinationLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchUnitDestinationLayout.__proto__ || (0, _getPrototypeOf2.default)(SearchUnitDestinationLayout)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isEverywherePopOverVisible: false
	    }, _this.onDestinationClick = function (dimId) {
	      var searchUnitActionsBound = _this.props.searchUnitActionsBound;
	
	
	      var activeIndex = _this.selectListRef.state.activeIndex - 1;
	      searchUnitActionsBound.addDestination(dimId).then(function () {
	        _this.selectListRef.state.activeIndex = activeIndex;
	        _this.showSuggestedDestinationsControl();
	        _this.selectListRef.selectNext();
	      });
	    }, _this.onHotelClick = function (url) {
	      (0, _utils.updateWindowLocation)(url);
	    }, _this.getSuggestions = function () {
	      var searchUnitActionsBound = _this.props.searchUnitActionsBound;
	
	      var rows = _this.textVal ? { rows: 10 } : { rows: 20 };
	      var query = _this.textVal ? _this.textVal : '*';
	      var searchParams = (0, _extends3.default)({}, rows, {
	        query: query
	      });
	      if ((0, _utils.isDomainIe)()) {
	        searchParams.filterQuery = 'locale:en-IE';
	      }
	      searchUnitActionsBound.suggestDestinations(searchParams).then(_this.showSuggestedDestinationsControl);
	    }, _this.saveSelectListRef = function (ref) {
	      _this.selectListRef = ref;
	    }, _this.showSuggestedDestinationsControl = function () {
	      var _this$props = _this.props,
	          customControlActionsBound = _this$props.customControlActionsBound,
	          appState = _this$props.appState;
	
	      var suggestedDestinations = _this.suggestedHotelsAndDestinations;
	
	      if (suggestedDestinations.length) {
	        var controlContent = {
	          id: 'suggestedDestinations',
	          body: _react2.default.createElement(_SelectListWithKeySupport2.default, {
	            ref: _this.saveSelectListRef,
	            controlPosition: 'left',
	            onItemChange: _this.onDestinationClick,
	            emptyElementsMessage: '',
	            type: 'empty',
	            elements: _this.suggestedHotelsAndDestinations,
	            appState: appState,
	            activeItemIndex: _this.selectListRef ? _this.selectListRef.state.activeIndex : undefined,
	            reducedPadding: true,
	            darkerBlueHotelBackground: true,
	            checkParentOnSelect: true
	          })
	        };
	
	        customControlActionsBound.showControl({
	          height: 400,
	          width: 500,
	          hAlign: 'left',
	          boundingClientRect: _this.destinationElementRef.getBoundingClientRect()
	        }, controlContent);
	      } else {
	        customControlActionsBound.hideControl();
	      }
	    }, _this.onKeyDown = function (event) {
	      var arrowUpKeyCode = 38;
	      var arrowDownKeyCode = 40;
	      var enterKeyCode = 13;
	      var tabKeyCode = 9;
	      var escKeyCode = 27;
	
	      if (_this.selectListRef) {
	        if (event.keyCode === arrowUpKeyCode) {
	          _this.selectListRef.selectPrevious();
	          event.preventDefault();
	        } else if (event.keyCode === arrowDownKeyCode) {
	          _this.selectListRef.selectNext();
	          event.preventDefault();
	        } else if (event.keyCode === tabKeyCode || event.keyCode === enterKeyCode) {
	          var selectedDestination = _this.suggestedHotelsAndDestinations[_this.selectListRef.state.activeIndex];
	          if (selectedDestination) {
	            if (selectedDestination.contentType === 'HOTEL') {
	              _this.onHotelClick(selectedDestination.href);
	            } else {
	              _this.onDestinationClick(selectedDestination.value, false);
	            }
	          }
	        } else if (event.keyCode === escKeyCode) {
	          _this.props.appStateActionsBound.setDestinationQuery('');
	          _this.textVal = '';
	        }
	      }
	    }, _this.getSuggestionsDebounced = (0, _utils.debounce)(_this.getSuggestions, 400), _this.onInputChange = function (event, elementRef) {
	      var appStateActionsBound = _this.props.appStateActionsBound;
	
	
	      appStateActionsBound.setDestinationQuery(event.currentTarget.value);
	      _this.textVal = event.currentTarget.value;
	
	      if (_this.textVal.length > 0) {
	        _this.hideEverywherePopOver();
	      } else {
	        _this.getSuggestions();
	      }
	
	      _this.destinationElementRef = elementRef;
	      _this.getSuggestionsDebounced();
	    }, _this.onRemoveDestination = function (dimId) {
	      var _this$props2 = _this.props,
	          baseStateActionsBound = _this$props2.baseStateActionsBound,
	          searchUnitActionsBound = _this$props2.searchUnitActionsBound;
	
	      baseStateActionsBound.deleteFieldKey('D_Destination', dimId);
	      searchUnitActionsBound.removeDestination(dimId);
	    }, _this.onEverywherePopOverClick = function () {
	      var _this$props3 = _this.props,
	          appStateActionsBound = _this$props3.appStateActionsBound,
	          searchUnitActionsBound = _this$props3.searchUnitActionsBound;
	
	      var everywhereDimVal = 214;
	
	      appStateActionsBound.setDestinationQuery('');
	      searchUnitActionsBound.addDestination(everywhereDimVal);
	
	      optimizelyUtil.fireEvent('SearchDestinationEverywherePopOver', 'clicked');
	
	      _this.hideEverywherePopOver();
	    }, _this.onSearchUnitDestinationBlur = function () {
	      _this.hideEverywherePopOver();
	      _this.blurred = true;
	    }, _this.showEverywherePopOver = function () {
	      if (!_this.selectedDestinations.length && _this.isEverywhereEnabled()) {
	        optimizelyUtil.fireEvent('SearchDestinationEverywherePopOver', 'displayed');
	        _this.setState({ isEverywherePopOverVisible: true });
	      }
	    }, _this.displayResults = function (event, elementRef) {
	      _this.destinationElementRef = elementRef;
	      _this.getSuggestions();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SearchUnitDestinationLayout, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _props = this.props,
	          appStateActionsBound = _props.appStateActionsBound,
	          customControlVisible = _props.customControlVisible;
	
	
	      if (this.blurred && !customControlVisible) {
	        appStateActionsBound.setDestinationQuery('');
	        this.textVal = '';
	        this.blurred = false;
	      }
	    }
	  }, {
	    key: 'hideEverywherePopOver',
	    value: function hideEverywherePopOver() {
	      this.setState({ isEverywherePopOverVisible: false });
	    }
	  }, {
	    key: 'isEverywhereEnabled',
	    value: function isEverywhereEnabled() {
	      var featureFlags = this.props.featureFlags;
	
	      return featureFlags.get('SearchDestinationEverywhereEnabled');
	    }
	  }, {
	    key: 'isEverywherePopOverVisible',
	    value: function isEverywherePopOverVisible() {
	      return this.isEverywhereEnabled() && this.state.isEverywherePopOverVisible;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var appState = this.props.appState;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'search-unit-destination-layout' },
	        _react2.default.createElement(_SearchUnitDestination2.default, {
	          hasNoResults: appState.get('hasNoDestinationResults'),
	          onBlur: this.onSearchUnitDestinationBlur,
	          onClick: this.isEverywhereEnabled() ? this.showEverywherePopOver : this.displayResults,
	          onInputChange: this.onInputChange,
	          onKeyDown: this.onKeyDown,
	          onRemove: this.onRemoveDestination,
	          queryValue: appState.get('destinationQuery'),
	          selectedElements: this.selectedDestinations,
	          isEverywhereEnabled: this.isEverywhereEnabled()
	        }),
	        this.isEverywherePopOverVisible() && _react2.default.createElement(
	          _SearchUnitPopOver2.default,
	          { onClick: this.onEverywherePopOverClick },
	          _react2.default.createElement(_svgInlineReact2.default, { className: 'search-unit-popover__icon', src: _earthGlobe2.default }),
	          _react2.default.createElement(
	            'h3',
	            { className: 'search-unit-popover__title' },
	            'Flexible?'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'search-unit-popover__text' },
	            'Search \'Any Destination\''
	          )
	        )
	      );
	    }
	  }, {
	    key: 'anyDestination',
	    get: function get() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'select-list__list__flexible' },
	        _react2.default.createElement(_svgInlineReact2.default, { className: 'select-list__list__flexible__icon', src: _earthGlobe2.default }),
	        _react2.default.createElement(
	          'span',
	          { className: 'select-list__list__element__span' },
	          _react2.default.createElement(
	            'b',
	            null,
	            'Flexible?'
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'select-list__list__element__span' },
	          ' Search \'Any Destination\''
	        )
	      );
	    }
	  }, {
	    key: 'suggestedDestinations',
	    get: function get() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          search = _props2.search,
	          dimensionsEntities = _props2.dimensionsEntities,
	          baseState = _props2.baseState;
	
	      return search.toArray().filter(function (suggestion) {
	        var isHotel = suggestion.get('type') === 'HOTEL';
	        var selectedDestinations = baseState.get('D_Destination', _immutable2.default.List());
	        var isSelected = selectedDestinations.includes(suggestion.get('dimensionValueId'));
	
	        return !isHotel && !isSelected;
	      }).map(function (suggestion) {
	        var dimValId = '' + suggestion.get('dimensionValueId');
	        var component = suggestion.get('type') === 'ANY' ? _this2.anyDestination : undefined;
	
	        return {
	          name: '' + suggestion.get('label'),
	          value: dimValId,
	          unavailable: !dimensionsEntities.getIn([dimValId, 'available']),
	          component: component
	        };
	      });
	    }
	  }, {
	    key: 'suggestedHotels',
	    get: function get() {
	      var search = this.props.search;
	
	      return search.toArray().filter(function (suggestion) {
	        return suggestion.get('type') === 'HOTEL';
	      }).map(function (suggestion) {
	        return {
	          name: '<b>' + suggestion.get('label') + '</b>, in ' + suggestion.get('location'),
	          value: suggestion.get('dimensionValueId'),
	          href: suggestion.get('detailURL'),
	          contentType: suggestion.get('type')
	        };
	      });
	    }
	  }, {
	    key: 'suggestedHotelsAndDestinations',
	    get: function get() {
	      return [].concat((0, _toConsumableArray3.default)(this.suggestedDestinations), (0, _toConsumableArray3.default)(this.suggestedHotels));
	    }
	  }, {
	    key: 'selectedDestinations',
	    get: function get() {
	      var _this3 = this;
	
	      var baseState = this.props.baseState;
	
	      var destinations = baseState.get('D_Destination');
	      return destinations ? destinations.toArray().map(function (id) {
	        return _this3.props.dimensionsEntities.toJSON()[id];
	      }) : [];
	    }
	  }]);
	  return SearchUnitDestinationLayout;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchUnitDestinationLayout);

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchUnitFlightPlusHotelLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _BookSelect = __webpack_require__(207);
	
	var _BookSelect2 = _interopRequireDefault(_BookSelect);
	
	var _searchUnitActions = __webpack_require__(66);
	
	var searchUnitActions = _interopRequireWildcard(_searchUnitActions);
	
	var _utils = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    dimensionsEntities: state.dimensionsEntities,
	    dimensionsResult: state.dimensionsResult,
	    baseState: state.baseState
	  };
	};
	
	/* istanbul ignore next */
	function mapDispatchToProps(dispatch) {
	  return {
	    searchUnitActionsBound: (0, _redux.bindActionCreators)(searchUnitActions, dispatch)
	  };
	}
	
	var SearchUnitFlightPlusHotelLayout = exports.SearchUnitFlightPlusHotelLayout = function (_Component) {
	  (0, _inherits3.default)(SearchUnitFlightPlusHotelLayout, _Component);
	
	  function SearchUnitFlightPlusHotelLayout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SearchUnitFlightPlusHotelLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchUnitFlightPlusHotelLayout.__proto__ || (0, _getPrototypeOf2.default)(SearchUnitFlightPlusHotelLayout)).call.apply(_ref, [this].concat(args))), _this), _this.onDurationChange = function (event) {
	      var searchUnitActionsBound = _this.props.searchUnitActionsBound;
	
	      var dimId = event.currentTarget.value;
	
	      var isFlexDim = dimId.indexOf('-flexNights') > -1;
	      var addDimId = isFlexDim ? dimId.replace('-flexNights', '') : dimId;
	
	      searchUnitActionsBound.setDuration(addDimId, isFlexDim);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SearchUnitFlightPlusHotelLayout, [{
	    key: 'render',
	    value: function render() {
	      var baseState = this.props.baseState;
	
	      var selectedNightsDimIds = baseState.get('D_Nights', _immutable2.default.List());
	      var isFlexDurationSelected = baseState.getIn(['queryState', 'props', 'nightFlex', 'set']);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'search-unit-duration-layout' },
	        _react2.default.createElement(_BookSelect2.default, {
	          onFieldChange: this.onDurationChange,
	          label: 'Duration:',
	          value: '' + selectedNightsDimIds.first() + (isFlexDurationSelected ? '-flexNights' : ''),
	          options: this.durationOptions
	        })
	      );
	    }
	  }, {
	    key: 'durationOptions',
	    get: function get() {
	      var _props = this.props,
	          dimensionsEntities = _props.dimensionsEntities,
	          dimensionsResult = _props.dimensionsResult;
	
	
	      var availableNightIds = dimensionsResult.get('D_Nights');
	      var availableNights = [];
	      var availableFlexibleNights = [];
	
	      if (availableNightIds) {
	        availableNightIds.map(function (dimId) {
	          var obj = dimensionsEntities.get('' + dimId);
	
	          availableNights.push({
	            label: obj.get('label') + ' Nights',
	            value: dimId,
	            disabled: !obj.get('available')
	          });
	
	          var flexibleDurationLabel = (0, _utils.getFlexDurationNights)(dimId);
	
	          /* istanbul ignore else */
	          if (flexibleDurationLabel) {
	            availableFlexibleNights.push({
	              label: flexibleDurationLabel + ' Nights',
	              value: dimId + '-flexNights',
	              disabled: !obj.get('available')
	            });
	          }
	        });
	      }
	      return availableNights.concat(availableFlexibleNights);
	    }
	  }]);
	  return SearchUnitFlightPlusHotelLayout;
	}(_react.Component);
	
	SearchUnitFlightPlusHotelLayout.defaultProps = {};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchUnitFlightPlusHotelLayout);

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchUnitHotelNameLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _CustomControlWrapperLayout = __webpack_require__(313);
	
	var _CustomControlWrapperLayout2 = _interopRequireDefault(_CustomControlWrapperLayout);
	
	var _CustomControlWrapper = __webpack_require__(312);
	
	var _CustomControlWrapper2 = _interopRequireDefault(_CustomControlWrapper);
	
	var _SelectListWithKeySupport = __webpack_require__(308);
	
	var _SelectListWithKeySupport2 = _interopRequireDefault(_SelectListWithKeySupport);
	
	var _SearchUnitHotelName = __webpack_require__(545);
	
	var _SearchUnitHotelName2 = _interopRequireDefault(_SearchUnitHotelName);
	
	var _utils = __webpack_require__(8);
	
	var _appStateActions = __webpack_require__(94);
	
	var appStateActions = _interopRequireWildcard(_appStateActions);
	
	var _searchUnitActions = __webpack_require__(66);
	
	var searchUnitActions = _interopRequireWildcard(_searchUnitActions);
	
	__webpack_require__(962);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    appState: state.appState,
	    search: state.search
	  };
	};
	
	/* istanbul ignore next */
	function mapDispatchToProps(dispatch) {
	  return {
	    appStateActionsBound: (0, _redux.bindActionCreators)(appStateActions, dispatch),
	    searchUnitActionsBound: (0, _redux.bindActionCreators)(searchUnitActions, dispatch)
	  };
	}
	
	var SearchUnitHotelNameLayout = exports.SearchUnitHotelNameLayout = function (_Component) {
	  (0, _inherits3.default)(SearchUnitHotelNameLayout, _Component);
	
	  function SearchUnitHotelNameLayout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SearchUnitHotelNameLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchUnitHotelNameLayout.__proto__ || (0, _getPrototypeOf2.default)(SearchUnitHotelNameLayout)).call.apply(_ref, [this].concat(args))), _this), _this.getSuggestions = function () {
	      var _this$props = _this.props,
	          appStateActionsBound = _this$props.appStateActionsBound,
	          searchUnitActionsBound = _this$props.searchUnitActionsBound,
	          showCustomControl = _this$props.showCustomControl;
	
	
	      if (_this.userTextInput && _this.userTextInput.length > 1) {
	        var params = {
	          query: _this.userTextInput,
	          rows: _this.isMobile() ? 5 : 10
	        };
	
	        if ((0, _utils.isDomainIe)()) {
	          params.filterQuery = 'locale:en-IE';
	        }
	
	        searchUnitActionsBound.suggestHotels(params).then(showCustomControl);
	      } else {
	        appStateActionsBound.setHasNoHotelResults(false);
	      }
	    }, _this.saveSelectListRef = function (ref) {
	      _this.selectListRef = ref;
	    }, _this.getSuggestionsDebounced = (0, _utils.debounce)(_this.getSuggestions, 400), _this.onInputChange = function (event, elementRef) {
	      var appStateActionsBound = _this.props.appStateActionsBound;
	
	
	      appStateActionsBound.setHotelQuery(event.currentTarget.value);
	      _this.userTextInput = event.currentTarget.value;
	      _this.hotelElementRef = elementRef;
	      _this.getSuggestionsDebounced();
	    }, _this.onKeyDown = function (event) {
	      var arrowUpKeyCode = 38;
	      var arrowDownKeyCode = 40;
	      var enterKeyCode = 13;
	      var tabKeyCode = 9;
	
	      if (_this.selectListRef) {
	        if (event.keyCode === arrowUpKeyCode) {
	          _this.selectListRef.selectPrevious();
	          event.preventDefault();
	        } else if (event.keyCode === arrowDownKeyCode) {
	          _this.selectListRef.selectNext();
	          event.preventDefault();
	        } else if (event.keyCode === tabKeyCode || event.keyCode === enterKeyCode) {
	          _this.enterUrl();
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SearchUnitHotelNameLayout, [{
	    key: 'getHotelItem',
	    value: function getHotelItem(suggestion) {
	      return {
	        name: '<b>' + suggestion.get('label') + '</b>, in ' + suggestion.get('location'),
	        value: suggestion.get('dimensionValueId'),
	        href: suggestion.get('detailURL'),
	        contentType: suggestion.get('type')
	      };
	    }
	  }, {
	    key: 'isMobile',
	    value: function isMobile() {
	      return this.props.appState.get('isMobileBreakpoint');
	    }
	  }, {
	    key: 'enterUrl',
	    value: function enterUrl() {
	      var activeIndex = this.selectListRef.state.activeIndex;
	      var url = this.props.search.getIn(['' + activeIndex, 'detailURL']);
	      (0, _utils.updateWindowLocation)(url);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          appState = _props.appState,
	          hideCustomControl = _props.hideCustomControl;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'search-unit-hotel-layout', onKeyDown: this.onKeyDown },
	        _react2.default.createElement(_SearchUnitHotelName2.default, {
	          onInputChange: this.onInputChange,
	          queryValue: appState.get('hotelQuery')
	        }),
	        this.props.isCustomControlVisible && _react2.default.createElement(
	          _CustomControlWrapper2.default,
	          { closeCustomControl: hideCustomControl },
	          _react2.default.createElement(
	            'div',
	            { className: 'search-unit-hotel-layout__select' },
	            _react2.default.createElement(_SelectListWithKeySupport2.default, {
	              ref: this.saveSelectListRef,
	              controlPosition: 'left',
	              emptyElementsMessage: 'No matches found',
	              type: 'empty',
	              elements: this.suggestedHotels,
	              appState: appState
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'suggestedHotels',
	    get: function get() {
	      var _this2 = this;
	
	      var search = this.props.search;
	
	      return search.toArray().map(function (suggestion) {
	        return _this2.getHotelItem(suggestion);
	      });
	    }
	  }]);
	  return SearchUnitHotelNameLayout;
	}(_react.Component);
	
	SearchUnitHotelNameLayout.defaultProps = {
	  search: []
	};
	exports.default = (0, _CustomControlWrapperLayout2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchUnitHotelNameLayout));

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchUnitStandaloneHotelLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _SearchUnitHeader = __webpack_require__(307);
	
	var _SearchUnitHeader2 = _interopRequireDefault(_SearchUnitHeader);
	
	var _SearchUnitHotelNameLayout = __webpack_require__(577);
	
	var _SearchUnitHotelNameLayout2 = _interopRequireDefault(_SearchUnitHotelNameLayout);
	
	var _searchUnitActions = __webpack_require__(66);
	
	var searchUnitActions = _interopRequireWildcard(_searchUnitActions);
	
	__webpack_require__(963);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	var mapStateToProps = function mapStateToProps() {
	  return {};
	};
	
	/* istanbul ignore next */
	function mapDispatchToProps(dispatch) {
	  return {
	    searchUnitActionsBound: (0, _redux.bindActionCreators)(searchUnitActions, dispatch)
	  };
	}
	
	var SearchUnitStandaloneHotelLayout = exports.SearchUnitStandaloneHotelLayout = function (_Component) {
	  (0, _inherits3.default)(SearchUnitStandaloneHotelLayout, _Component);
	
	  function SearchUnitStandaloneHotelLayout() {
	    (0, _classCallCheck3.default)(this, SearchUnitStandaloneHotelLayout);
	    return (0, _possibleConstructorReturn3.default)(this, (SearchUnitStandaloneHotelLayout.__proto__ || (0, _getPrototypeOf2.default)(SearchUnitStandaloneHotelLayout)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SearchUnitStandaloneHotelLayout, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          searchUnitActionsBound = _props.searchUnitActionsBound,
	          location = _props.location;
	
	      searchUnitActionsBound.getSearchUnitData(location.query.state);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'search-unit-standalone-hotel-layout' },
	        _react2.default.createElement(_SearchUnitHeader2.default, { title: 'Hotel Name Search', showIcon: true }),
	        _react2.default.createElement(
	          'div',
	          { className: 'search-unit-standalone-hotel-layout__inner' },
	          _react2.default.createElement(_SearchUnitHotelNameLayout2.default, null)
	        )
	      );
	    }
	  }]);
	  return SearchUnitStandaloneHotelLayout;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchUnitStandaloneHotelLayout);

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchUnitStandaloneLayout = undefined;
	
	var _getPrototypeOf = __webpack_require__(5);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(20);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _Overlay = __webpack_require__(166);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _SearchUnitHeader = __webpack_require__(307);
	
	var _SearchUnitHeader2 = _interopRequireDefault(_SearchUnitHeader);
	
	var _SearchUnitRooms = __webpack_require__(547);
	
	var _SearchUnitRooms2 = _interopRequireDefault(_SearchUnitRooms);
	
	var _SearchUnitDestinationLayout = __webpack_require__(575);
	
	var _SearchUnitDestinationLayout2 = _interopRequireDefault(_SearchUnitDestinationLayout);
	
	var _SearchUnitDurationLayout = __webpack_require__(576);
	
	var _SearchUnitDurationLayout2 = _interopRequireDefault(_SearchUnitDurationLayout);
	
	var _SearchUnitDepartureAirportLayout = __webpack_require__(573);
	
	var _SearchUnitDepartureAirportLayout2 = _interopRequireDefault(_SearchUnitDepartureAirportLayout);
	
	var _SearchUnitDepartureDateLayout = __webpack_require__(574);
	
	var _SearchUnitDepartureDateLayout2 = _interopRequireDefault(_SearchUnitDepartureDateLayout);
	
	var _LinkButton = __webpack_require__(65);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _searchUnitActions = __webpack_require__(66);
	
	var searchUnitActions = _interopRequireWildcard(_searchUnitActions);
	
	var _optimizely = __webpack_require__(30);
	
	var optimizelyUtil = _interopRequireWildcard(_optimizely);
	
	var _calendar = __webpack_require__(95);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _dates = __webpack_require__(35);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _utils = __webpack_require__(8);
	
	var _searchUnit = __webpack_require__(140);
	
	__webpack_require__(964);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* istanbul ignore next */
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    baseState: state.baseState,
	    loadingState: state.appState.get('loadingState'),
	    searchWholeMonthCalendar: state.featureFlags.get('SearchWholeMonthCalendar')
	  };
	};
	
	/* istanbul ignore next */
	function mapDispatchToProps(dispatch) {
	  return {
	    searchUnitActionsBound: (0, _redux.bindActionCreators)(searchUnitActions, dispatch)
	  };
	}
	
	var SearchUnitStandaloneLayout = exports.SearchUnitStandaloneLayout = function (_PureComponent) {
	  (0, _inherits3.default)(SearchUnitStandaloneLayout, _PureComponent);
	
	  function SearchUnitStandaloneLayout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SearchUnitStandaloneLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchUnitStandaloneLayout.__proto__ || (0, _getPrototypeOf2.default)(SearchUnitStandaloneLayout)).call.apply(_ref, [this].concat(args))), _this), _this.resetSearchForm = function () {
	      var searchUnitActionsBound = _this.props.searchUnitActionsBound;
	
	
	      searchUnitActionsBound.resetSearchForm();
	    }, _this.onSearchClick = function () {
	      if (_this.isEverywhereSelected) {
	        optimizelyUtil.fireEvent('SearchSubmitWithEverywhere', 'clicked');
	      }
	      if (_this.isWholeMonthSelected) {
	        optimizelyUtil.fireEvent('SearchByMonth', 'clicked');
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SearchUnitStandaloneLayout, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          searchUnitActionsBound = _props.searchUnitActionsBound,
	          location = _props.location;
	
	      searchUnitActionsBound.getSearchUnitData(location.query.state);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          baseState = _props2.baseState,
	          loadingState = _props2.loadingState,
	          searchUnitActionsBound = _props2.searchUnitActionsBound,
	          searchWholeMonthCalendar = _props2.searchWholeMonthCalendar;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'search-unit-standalone-layout' },
	        loadingState && _react2.default.createElement(_Overlay2.default, { loadingState: loadingState }),
	        _react2.default.createElement(_SearchUnitHeader2.default, { resetSearchForm: this.resetSearchForm }),
	        _react2.default.createElement(
	          'div',
	          { className: 'search-unit-standalone-layout__inner' },
	          _react2.default.createElement(
	            'div',
	            { className: 'search-unit-standalone-layout__destination' },
	            _react2.default.createElement(
	              'div',
	              { className: 'search-unit-standalone-layout__destination__inner' },
	              _react2.default.createElement(_SearchUnitDestinationLayout2.default, null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'search-unit-standalone-layout__dept-airport' },
	            _react2.default.createElement(_SearchUnitDepartureAirportLayout2.default, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'search-unit-standalone-layout__dept-date' },
	            _react2.default.createElement(_SearchUnitDepartureDateLayout2.default, {
	              isWholeMonthCalendarEnabled: searchWholeMonthCalendar
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'search-unit-standalone-layout__duration' },
	            _react2.default.createElement(_SearchUnitDurationLayout2.default, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'search-unit-standalone-layout__rooms' },
	            _react2.default.createElement(_SearchUnitRooms2.default, {
	              baseState: baseState,
	              searchUnitActionsBound: searchUnitActionsBound
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'search-unit-standalone-layout__cta' },
	            _react2.default.createElement(
	              'div',
	              { className: 'search-unit-standalone-layout__cta__inner' },
	              _react2.default.createElement(
	                _LinkButton2.default,
	                { type: 'chevrons-on-left', align: 'left', isExternal: true, to: '/holidays/?state=' + baseState.get('currentStateEncoded'), onClick: this.onSearchClick },
	                'Search'
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'isEverywhereSelected',
	    get: function get() {
	      var baseState = this.props.baseState;
	
	      var selectedDestinations = baseState.get('D_Destination', _immutable2.default.List());
	      var everywhereDimVal = 214;
	
	      return selectedDestinations.first() === everywhereDimVal;
	    }
	  }, {
	    key: 'isWholeMonthSelected',
	    get: function get() {
	      var _props3 = this.props,
	          baseState = _props3.baseState,
	          searchWholeMonthCalendar = _props3.searchWholeMonthCalendar;
	
	      var flexibility = baseState.getIn(['queryState', 'props', 'deptDateFlexibility', 'value']);
	      var isWholeMonthFlexibility = flexibility === _searchUnit.MONTH_FLEXIBILITY_VALUE;
	      var departureDateTimestamp = _calendar2.default.getDepartureDate(baseState, false) * _utils.dayInMilliseconds;
	      var isDepartureFirstDayOfMonth = _dates2.default.format(departureDateTimestamp, 'DD') === '01';
	
	      return searchWholeMonthCalendar && isWholeMonthFlexibility && isDepartureFirstDayOfMonth;
	    }
	  }]);
	  return SearchUnitStandaloneLayout;
	}(_react.PureComponent);
	
	SearchUnitStandaloneLayout.defaultProps = {
	  baseState: _immutable2.default.Map(),
	  loadingState: '',
	  searchWholeMonthCalendar: false
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchUnitStandaloneLayout);

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(323);
	
	var _initializeBrowserHistoryListener = __webpack_require__(557);
	
	var _initializeBrowserHistoryListener2 = _interopRequireDefault(_initializeBrowserHistoryListener);
	
	var _configureSearchUnitStore = __webpack_require__(588);
	
	var _configureSearchUnitStore2 = _interopRequireDefault(_configureSearchUnitStore);
	
	var _initialize = __webpack_require__(556);
	
	var _initialize2 = _interopRequireDefault(_initialize);
	
	var _searchUnit = __webpack_require__(601);
	
	var _searchUnit2 = _interopRequireDefault(_searchUnit);
	
	var _bootstrapApp = __webpack_require__(492);
	
	var _bootstrapApp2 = _interopRequireDefault(_bootstrapApp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _initialize2.default)(_configureSearchUnitStore2.default);
	(0, _bootstrapApp2.default)(_searchUnit2.default, _configureSearchUnitStore2.default);
	
	(0, _initializeBrowserHistoryListener2.default)(_configureSearchUnitStore2.default, {
	  isUpdateWebtrendsEnabled: false
	});

/***/ },
/* 581 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TYPES = exports.TYPES = {
	  UPDATE_OUTBOUND_FILTER: 'UPDATE_OUTBOUND_FILTER',
	  UPDATE_INBOUND_FILTER: 'UPDATE_INBOUND_FILTER',
	  UPDATE_AIRPORT_FILTER: 'UPDATE_AIRPORT_FILTER',
	  UPDATE_AIRLINE_FILTER: 'UPDATE_AIRLINE_FILTER',
	  UPDATE_BOARD_BASIS_FILTER: 'UPDATE_BOARD_BASIS_FILTER',
	  UPDATE_RETURN_DATE_FILTER: 'UPDATE_RETURN_DATE_FILTER',
	  DELETE_FILTER: 'DELETE_FILTER',
	  DELETE_FILTERS: 'DELETE_FILTERS'
	};
	
	var updateOutboundFilter = exports.updateOutboundFilter = function updateOutboundFilter(value) {
	  return {
	    type: TYPES.UPDATE_OUTBOUND_FILTER,
	    value: value
	  };
	};
	
	var updateInboundFilter = exports.updateInboundFilter = function updateInboundFilter(value) {
	  return {
	    type: TYPES.UPDATE_INBOUND_FILTER,
	    value: value
	  };
	};
	
	var updateAirportFilter = exports.updateAirportFilter = function updateAirportFilter(value, checked) {
	  return {
	    type: TYPES.UPDATE_AIRPORT_FILTER,
	    value: value,
	    checked: checked
	  };
	};
	
	var updateAirlineFilter = exports.updateAirlineFilter = function updateAirlineFilter(value, checked) {
	  return {
	    type: TYPES.UPDATE_AIRLINE_FILTER,
	    value: value,
	    checked: checked
	  };
	};
	
	var updateBoardBasisFilter = exports.updateBoardBasisFilter = function updateBoardBasisFilter(value, checked) {
	  return {
	    type: TYPES.UPDATE_BOARD_BASIS_FILTER,
	    value: value,
	    checked: checked
	  };
	};
	
	var updateReturnDateFilter = exports.updateReturnDateFilter = function updateReturnDateFilter(value) {
	  return {
	    type: TYPES.UPDATE_RETURN_DATE_FILTER,
	    value: value
	  };
	};
	
	var deleteFilter = exports.deleteFilter = function deleteFilter(field) {
	  return {
	    type: TYPES.DELETE_FILTER,
	    field: field
	  };
	};
	
	var deleteFilters = exports.deleteFilters = function deleteFilters() {
	  return {
	    type: TYPES.DELETE_FILTERS
	  };
	};

/***/ },
/* 582 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TYPES = exports.TYPES = {
	  GALLERY_CAROUSEL_NAVIGATE_PREVIOUS: 'GALLERY_CAROUSEL_NAVIGATE_PREVIOUS',
	  GALLERY_CAROUSEL_NAVIGATE_NEXT: 'GALLERY_CAROUSEL_NAVIGATE_NEXT',
	  GALLERY_CAROUSEL_VIEWPORT_RESIZE: 'GALLERY_CAROUSEL_VIEWPORT_RESIZE',
	  GALLERY_CAROUSEL_TOGGLE_CONTROLS: 'GALLERY_CAROUSEL_TOGGLE_CONTROLS',
	  GALLERY_CAROUSEL_RESET: 'GALLERY_CAROUSEL_RESET'
	};
	
	var navigatePrevious = exports.navigatePrevious = function navigatePrevious() {
	  return {
	    type: TYPES.GALLERY_CAROUSEL_NAVIGATE_PREVIOUS
	  };
	};
	
	var navigateNext = exports.navigateNext = function navigateNext() {
	  return {
	    type: TYPES.GALLERY_CAROUSEL_NAVIGATE_NEXT
	  };
	};
	
	var viewportResize = exports.viewportResize = function viewportResize(viewportDetails) {
	  return {
	    type: TYPES.GALLERY_CAROUSEL_VIEWPORT_RESIZE,
	    viewportDetails: viewportDetails
	  };
	};
	
	var toggleControlsAreActive = exports.toggleControlsAreActive = function toggleControlsAreActive() {
	  return {
	    type: TYPES.GALLERY_CAROUSEL_TOGGLE_CONTROLS
	  };
	};
	
	var reset = exports.reset = function reset() {
	  return {
	    type: TYPES.GALLERY_CAROUSEL_RESET
	  };
	};

/***/ },
/* 583 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TYPES = exports.TYPES = {
	  LOCATION_UPDATED: 'LOCATION_UPDATED',
	  HASH_UPDATED: 'HASH_UPDATED'
	};
	
	var routeLocationDidUpdate = exports.routeLocationDidUpdate = function routeLocationDidUpdate(location) {
	  return {
	    type: TYPES.LOCATION_UPDATED,
	    location: location
	  };
	};
	
	var routeHashDidUpdate = exports.routeHashDidUpdate = function routeHashDidUpdate(location) {
	  return {
	    type: TYPES.HASH_UPDATED,
	    location: location
	  };
	};

/***/ },
/* 584 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TYPES = exports.TYPES = {
	  TOGGLE_NOTIFICATION: 'TOGGLE_NOTIFICATION'
	};
	
	var toggleNotification = exports.toggleNotification = function toggleNotification(notification) {
	  return { type: TYPES.TOGGLE_NOTIFICATION, notification: notification };
	};

/***/ },
/* 585 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TYPES = exports.TYPES = {
	  RESET_PANDA_DATA: 'RESET_PANDA_DATA',
	  CAL_DATE_CHANGED: 'CAL_DATE_CHANGED'
	};
	
	var resetPandaData = exports.resetPandaData = function resetPandaData() {
	  return {
	    type: TYPES.RESET_PANDA_DATA
	  };
	};

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setNewsletterSubscription = exports.setEmail = exports.setFullName = exports.TYPES = undefined;
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.postSignUp = postSignUp;
	
	var _api = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPES = exports.TYPES = {
	  PRICETRACKER_REQUEST: 'PRICETRACKER_REQUEST',
	  PRICETRACKER_SUCCESS: 'PRICETRACKER_SUCCESS',
	  PRICETRACKER_FAILURE: 'PRICETRACKER_FAILURE',
	  PRICETRACKER_SET_FULL_NAME: 'PRICETRACKER_SET_FULL_NAME',
	  PRICETRACKER_SET_EMAIL: 'PRICETRACKER_SET_EMAIL',
	  PRICETRACKER_SET_NEWSLETTER_SUBSCRIPTION: 'PRICETRACKER_SET_NEWSLETTER_SUBSCRIPTION'
	};
	
	function postSignUp() {
	  var formData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var endpoint = arguments[1];
	
	  return (0, _defineProperty3.default)({}, _api.CALL_API, {
	    types: [TYPES.PRICETRACKER_REQUEST, TYPES.PRICETRACKER_SUCCESS, TYPES.PRICETRACKER_FAILURE],
	    endpoint: endpoint,
	    requestOptions: {
	      method: 'POST',
	      formData: formData
	    }
	  });
	}
	
	var setFullName = exports.setFullName = function setFullName(payload) {
	  return {
	    type: TYPES.PRICETRACKER_SET_FULL_NAME,
	    payload: payload
	  };
	};
	
	var setEmail = exports.setEmail = function setEmail(payload) {
	  return {
	    type: TYPES.PRICETRACKER_SET_EMAIL,
	    payload: payload
	  };
	};
	
	var setNewsletterSubscription = exports.setNewsletterSubscription = function setNewsletterSubscription(payload) {
	  return {
	    type: TYPES.PRICETRACKER_SET_NEWSLETTER_SUBSCRIPTION,
	    payload: payload
	  };
	};

/***/ },
/* 587 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TYPES = exports.TYPES = {
	  FIRE_GTM_EVENT: 'FIRE_GTM_EVENT'
	};
	
	var fireGTMEvent = exports.fireGTMEvent = function fireGTMEvent(eventName, location, route) {
	  return {
	    type: TYPES.FIRE_GTM_EVENT,
	    shortRef: location.query.shortref,
	    bookType: route.bookType,
	    eventName: eventName
	  };
	};

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.configureStore = configureStore;
	
	var _redux = __webpack_require__(16);
	
	var _reactRouter = __webpack_require__(78);
	
	var _reactRouterRedux = __webpack_require__(298);
	
	var _reduxThunk = __webpack_require__(488);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _history = __webpack_require__(392);
	
	var _api = __webpack_require__(37);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _rootSearchUnitReducer = __webpack_require__(600);
	
	var _rootSearchUnitReducer2 = _interopRequireDefault(_rootSearchUnitReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var history = (0, _reactRouter.useRouterHistory)(_history.createHistory)({ basename: '' });
	
	function configureStore() {
	  var initState = window.__INITIAL_STATE__ || {};
	
	  // Sync with router via history instance (main.js)
	  var routerMiddleware = (0, _reactRouterRedux.syncHistory)(history);
	
	  var middleware = (0, _redux.applyMiddleware)(_reduxThunk2.default, _api2.default, routerMiddleware);
	
	  /* istanbul ignore if */
	  if (false) {
	    // ignore debug code
	    // eslint-disable-next-line global-require
	    var devTools = window.devToolsExtension ? window.devToolsExtension() : require('containers/DevTools').default.instrument();
	    middleware = (0, _redux.compose)(middleware, devTools);
	  }
	
	  // Create final store and subscribe router in debug env ie. for devtools
	  var store = middleware(_redux.createStore)(_rootSearchUnitReducer2.default, initState);
	
	  /* istanbul ignore if */
	  if (false) routerMiddleware.listenForReplays(store, function (_ref) {
	    var router = _ref.router;
	    return router.location;
	  });
	
	  /* istanbul ignore if */
	  if (false) {
	    module.hot.accept('./rootSearchUnitReducer', function () {
	      // ignore debug code
	      // eslint-disable-next-line global-require
	      var nextRootReducer = require('./rootSearchUnitReducer').default;
	
	      store.replaceReducer(nextRootReducer);
	    });
	  }
	  return store;
	}
	
	exports.default = configureStore();

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.privateUtils = undefined;
	
	var _utils = __webpack_require__(8);
	
	var privateUtils = {
	  addIdToArrayItems: function addIdToArrayItems(arrayObject) {
	    arrayObject.map(function (item, index) {
	      item.id = index;
	    });
	
	    return arrayObject;
	  },
	  addPassengerIds: function addPassengerIds(info) {
	    if ((0, _utils.checkForNestedProperty)(info, 'passenger_details.0.0') && !(0, _utils.checkForNestedProperty)(info, 'passenger_details.0.0.id')) {
	      var index = 0;
	
	      info.passenger_details.forEach(function (room) {
	        room.forEach(function (passenger) {
	          passenger.id = index;
	          index += 1;
	        });
	      });
	    }
	  },
	  createPassenger: function createPassenger(id, paxType) {
	    return {
	      id: id,
	      paxType: paxType
	    };
	  },
	  getReservedIds: function getReservedIds(passengers) {
	    var reservedIds = [];
	
	    passengers.map(function (passenger) {
	      reservedIds.push(passenger.id);
	    });
	
	    return reservedIds;
	  },
	  getPassengerTypeTotals: function getPassengerTypeTotals(passengers) {
	    var passengerTypeTotals = {
	      adult: 0,
	      child: 0,
	      infant: 0
	    };
	
	    passengers.map(function (passenger) {
	      passengerTypeTotals[passenger.paxType] += 1;
	    });
	
	    return passengerTypeTotals;
	  },
	  addPartyInfo: function addPartyInfo(resultJson) {
	    var data = resultJson.data || {};
	
	    if (data.party) {
	      this.addIdToArrayItems(data.party);
	
	      data.partyInfo = {
	        numberOfPassengers: 0,
	        numberOfChargeablePassengers: 0,
	        numberOfAdults: 0,
	        numberOfChildren: 0,
	        numberOfInfants: 0
	      };
	
	      data.party.map(function (partyRoomInfo) {
	        data.partyInfo.numberOfPassengers += partyRoomInfo.num_adults + partyRoomInfo.num_children + partyRoomInfo.num_infants;
	        data.partyInfo.numberOfChargeablePassengers += partyRoomInfo.num_adults + partyRoomInfo.num_children;
	        data.partyInfo.numberOfAdults += partyRoomInfo.num_adults;
	        data.partyInfo.numberOfChildren += partyRoomInfo.num_children;
	        data.partyInfo.numberOfInfants += partyRoomInfo.num_infants;
	      });
	    }
	  },
	  addFlightMealInfo: function addFlightMealInfo(resultJson) {
	    if ((0, _utils.checkForNestedProperty)(resultJson, 'data.extras.flightMeals.options') && resultJson.data.extras.flightMeals.options) {
	      this.addIdToArrayItems(resultJson.data.extras.flightMeals.options);
	    }
	  },
	  addPassengers: function addPassengers(resultJson) {
	    var info = resultJson.booking_info || {};
	
	    info.passengers = [];
	
	    if (info.passenger_details) {
	      info.passenger_details.map(function (roomPassengers) {
	        return info.passengers = info.passengers.concat(roomPassengers);
	      });
	    }
	  },
	  addPassengersByRoom: function addPassengersByRoom(resultJson) {
	    var info = resultJson.booking_info || {};
	
	    info.passengersByRoom = {};
	
	    if (info.passenger_details) {
	      info.passenger_details.map(function (roomPassengers, index) {
	        var adults = roomPassengers.filter(function (passengerItem) {
	          return passengerItem.paxType === 'adult';
	        });
	        var children = roomPassengers.filter(function (passengerItem) {
	          return passengerItem.paxType === 'child';
	        });
	        var infants = roomPassengers.filter(function (passengerItem) {
	          return passengerItem.paxType === 'infant';
	        });
	
	        info.passengersByRoom[index] = {};
	        info.passengersByRoom[index].all = roomPassengers;
	        info.passengersByRoom[index].adults = adults;
	        info.passengersByRoom[index].children = children;
	        info.passengersByRoom[index].infants = infants;
	      });
	    }
	  },
	  addLeadPassengerIdFromPassengers: function addLeadPassengerIdFromPassengers(resultJson) {
	    var info = resultJson.booking_info || {};
	
	    info.leadPassengerId = 0;
	
	    if (info.passengers) {
	      info.passengers.map(function (passengerItem) {
	        if (passengerItem.is_lead) {
	          info.leadPassengerId = passengerItem.id;
	        }
	      });
	    }
	  },
	  populatePlaceholderPassengers: function populatePlaceholderPassengers(resultJson) {
	    var _this = this;
	
	    var info = resultJson.booking_info || {};
	    var data = resultJson.data || {};
	
	    if (data.party) {
	      data.party.map(function (partyRoomInfo, index) {
	        info.passengersByRoom[index] = info.passengersByRoom[index] || {};
	        var room = info.passengersByRoom[index];
	
	        var rangeIds = (0, _utils.range)(data.partyInfo.numberOfPassengers);
	        var reservedIds = _this.getReservedIds(info.passengers);
	        var availableIds = rangeIds.filter(function (id) {
	          return !reservedIds.includes(id);
	        });
	
	        var currentPassengerTypeTotals = _this.getPassengerTypeTotals(room.all || []);
	
	        var numRequiredAdults = partyRoomInfo.num_adults - currentPassengerTypeTotals.adult;
	        var adults = Array(numRequiredAdults).fill('adult').map(function (paxType) {
	          return _this.createPassenger(availableIds.shift(), paxType);
	        });
	
	        var numRequiredChildren = partyRoomInfo.num_children - currentPassengerTypeTotals.child;
	        var children = Array(numRequiredChildren).fill('child').map(function (paxType) {
	          return _this.createPassenger(availableIds.shift(), paxType);
	        });
	
	        var numRequiredInfants = partyRoomInfo.num_infants - currentPassengerTypeTotals.infant;
	        var infants = Array(numRequiredInfants).fill('infant').map(function (paxType) {
	          return _this.createPassenger(availableIds.shift(), paxType);
	        });
	
	        room.adults = room.adults ? room.adults.concat(adults) : adults;
	        room.children = room.children ? room.children.concat(children) : children;
	        room.infants = room.infants ? room.infants.concat(infants) : infants;
	
	        room.all = room.all ? room.all.concat(adults, children, infants) : adults.concat(children, infants);
	
	        info.passengers = info.passengers.concat(adults, children, infants);
	      });
	    }
	  },
	  addIdToRoomPricingOptions: function addIdToRoomPricingOptions(resultJson) {
	    var data = resultJson.data || {};
	
	    if (data.room_pricing_options) {
	      data.room_pricing_options.map(function (room) {
	        if (room.restrictions && room.restrictions[0] && typeof room.restrictions[0].id === 'number') {
	          room.id = room.restrictions[0].id;
	        }
	      });
	    }
	  },
	  addRoomRestrictionsAndFlattenRoomPricingOptionsRestrictions: function addRoomRestrictionsAndFlattenRoomPricingOptionsRestrictions(resultJson) {
	    var data = resultJson.data || {};
	
	    data.roomRestrictions = [];
	
	    if (data.room_pricing_options) {
	      data.room_pricing_options.map(function (room) {
	        if (room.restrictions) {
	          room.restrictions.map(function (restriction, index) {
	            restriction.roomId = room.id;
	            data.roomRestrictions.push(restriction);
	            room.restrictions[index] = restriction.id;
	          });
	        }
	      });
	    }
	  }
	};
	
	exports.privateUtils = privateUtils;
	
	
	var api = {
	  updateBookJson: function updateBookJson() {
	    var resultJson = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var info = resultJson.booking_info || {};
	
	    /* istanbul ignore if  */
	    if (!info.passenger_details && info.passenger_autofill) {
	      info.passenger_details = info.passenger_autofill;
	    }
	
	    delete info.passenger_autofill;
	
	    privateUtils.addPassengerIds(info);
	    privateUtils.addPartyInfo(resultJson);
	    privateUtils.addFlightMealInfo(resultJson);
	    privateUtils.addPassengers(resultJson);
	    privateUtils.addPassengersByRoom(resultJson);
	    delete info.passenger_details;
	    privateUtils.addLeadPassengerIdFromPassengers(resultJson);
	    privateUtils.populatePlaceholderPassengers(resultJson);
	
	    privateUtils.addIdToRoomPricingOptions(resultJson);
	    privateUtils.addRoomRestrictionsAndFlattenRoomPricingOptionsRestrictions(resultJson);
	  }
	};
	
	exports.default = api;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _handleActions;
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reduxActions = __webpack_require__(85);
	
	var _appStateActions = __webpack_require__(94);
	
	var _annualAvailabilityActions = __webpack_require__(141);
	
	var _baseStateActions = __webpack_require__(142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.fromJS({
	  loadingState: 'loading',
	  shouldSearchResultsTrackingEventsFire: true,
	  pandaSearchFormActive: false,
	  destinationQuery: '',
	  hasNoDestinationResults: false,
	  departureAirportQuery: '',
	  reasonsToHideLandlinePhone: {
	    bookPriceTooLow: true,
	    disabledForLocation: true
	  },
	  showPhoneNumber: false
	});
	
	exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.ERROR_FIELD, function (state, action) {
	  return state.setIn(['errorFields', '' + action.field], true);
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.CLEAR_ERRORS, function (state) {
	  return state.set('errorFields', _immutable2.default.Map());
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.LOADING_FINISH, function (state, action) {
	  return state.set(action.key, '');
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.LOADING_START_SPINNER, function (state, action) {
	  return state.set(action.key, 'spinning');
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.LOADING_START, function (state, action) {
	  return state.set(action.key, 'initiated');
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.UPDATE_SELECTED_OFFER_OF_DAY, function (state, action) {
	  return state.set('selectedOffer', action.offer);
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.SET_PAGE_SCROLL_Y, function (state, action) {
	  return state.set('pageScrollY', action.pageScrollY);
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.DELETE_PAGE_SCROLL_Y, function (state) {
	  return state.delete('pageScrollY');
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.SET_SEARCH_RESULTS_TRACKING_FLAG, function (state, action) {
	  return state.set('shouldSearchResultsTrackingEventsFire', action.flag);
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.PANDA_SEARCH_FORM_TOGGLE, function (state, action) {
	  return state.set('pandaSearchFormActive', action.flag);
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.SET_NON_DIMENSION_NUMBER_OF_NIGHTS, function (state, action) {
	  return state.set('nonDimensionNumberOfNights', action.numberOfNights);
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.SET_VIEWPORT_DIMENSIONS, function (state, action) {
	  return state.set('viewportDimensions', _immutable2.default.fromJS(action.viewportDimensions)).set('isMobileBreakpoint', action.isMobileBreakpoint);
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.SET_DESTINATION_QUERY, function (state, action) {
	  return state.set('destinationQuery', action.destinationQuery);
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.SET_HOTEL_QUERY, function (state, action) {
	  return state.set('hotelQuery', action.hotelQuery);
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.SET_DEPARTURE_QUERY, function (state, action) {
	  return state.set('departureAirportQuery', action.departureAirportQuery);
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.SET_HAS_NO_DESTINATION_RESULTS, function (state, action) {
	  return state.set('hasNoDestinationResults', action.hasNoDestinationResults);
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.SET_HAS_NO_HOTEL_RESULTS, function (state, action) {
	  return state.set('hasNoHotelResults', action.hasNoHotelResults);
	}), (0, _defineProperty3.default)(_handleActions, _annualAvailabilityActions.TYPES.CHANGE_NUMBER_OF_NIGHTS, function (state) {
	  return state.set('nonDimensionNumberOfNights', 0);
	}), (0, _defineProperty3.default)(_handleActions, _annualAvailabilityActions.TYPES.SET_DIMENSION_PROPERTY, function (state) {
	  return state.set('nonDimensionNumberOfNights', 0);
	}), (0, _defineProperty3.default)(_handleActions, _baseStateActions.TYPES.DELETE_BASESTATE_FIELD_KEY, function (state) {
	  return state.set('nonDimensionNumberOfNights', 0);
	}), (0, _defineProperty3.default)(_handleActions, _baseStateActions.TYPES.CHANGE_BASESTATE_FIELD_KEY, function (state) {
	  return state.set('nonDimensionNumberOfNights', 0);
	}), (0, _defineProperty3.default)(_handleActions, _baseStateActions.TYPES.BASE_STATE_SUCCESS, function (state) {
	  return state.set('nonDimensionNumberOfNights', 0);
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.SHOW_HO_FLIGHT_UPSELL, function (state, action) {
	  return state.set('isHOFlightUpsellShown', action.show);
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.SET_LHX_PROPERTY, function (state, action) {
	  return state.set(action.property, _immutable2.default.fromJS(action.value));
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.LANDLINE_PHONE_SUCCESS, function (state, action) {
	  return state.set('landlinePhone', action.response.result.booking_number);
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.HIDE_LANDLINE_PHONE, function (state, action) {
	  var isCurrentlyShown = state.get('showLandlinePhone');
	
	  var newState = state.mergeIn(['reasonsToHideLandlinePhone'], _immutable2.default.fromJS(action.reasons));
	  var shouldNowBeShown = !newState.get('reasonsToHideLandlinePhone').some(function (reason) {
	    return reason;
	  });
	
	  return newState.set('showLandlinePhone', isCurrentlyShown || shouldNowBeShown);
	}), (0, _defineProperty3.default)(_handleActions, _appStateActions.TYPES.SET_HAS_THIRD_PARTY_CHANNEL_PARAM_HO, function (state, action) {
	  return state.set('hasThirdPartyChannelParamHO', action.isThirdPartyChannelParam);
	}), _handleActions), initialState);

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _handleActions;
	
	exports.calculateNumberOfChargeablePassengers = calculateNumberOfChargeablePassengers;
	exports.removeGroupedDimensionsByType = removeGroupedDimensionsByType;
	exports.groupDimensionsByType = groupDimensionsByType;
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reduxActions = __webpack_require__(85);
	
	var _annualAvailabilityActions = __webpack_require__(141);
	
	var _calendarOfferActions = __webpack_require__(316);
	
	var _utils = __webpack_require__(8);
	
	var _baseStateActions = __webpack_require__(142);
	
	var _searchResultsActions = __webpack_require__(214);
	
	var _hotelDetailsActions = __webpack_require__(213);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map();
	
	function calculateNumberOfChargeablePassengers(response) {
	  var numberOfAdults = response.getIn(['queryState', 'props', 'nAdt', 'value']);
	  var childrenArray = response.getIn(['queryState', 'props', 'cdn', 'arrayValue'], _immutable2.default.List());
	  var numberOfChildren = childrenArray.size - (0, _utils.getNumberOfInfants)(childrenArray);
	
	  return response.set('numberOfChargeablePassengers', numberOfAdults + numberOfChildren);
	}
	
	function removeGroupedDimensionsByType(state) {
	  var groups = ['D_Destination', 'D_DepartureAirport', 'D_BoardBasis', 'D_Nights', 'D_RoomConfiguration', 'D_HolidayType', 'D_DayOfMonth', 'D_PCM_Hotel_Facilities', 'D_PCM_Pool', 'D_PCM_Kids'];
	  return state.withMutations(function (mutatedState) {
	    groups.forEach(function (group) {
	      return mutatedState.delete(group);
	    });
	  });
	}
	
	/* istanbul ignore next */
	function groupDimensionsByType(action, baseStateDimensions) {
	  var dimensionsByType = {};
	  baseStateDimensions.map(function (dimId) {
	    var dimensionEntity = action.response.entities.dimensions[dimId];
	    var dimensionType = dimensionEntity.dimension;
	
	    if (!dimensionsByType[dimensionType]) {
	      dimensionsByType[dimensionType] = [];
	    }
	
	    dimensionsByType[dimensionType].push(dimId);
	  });
	
	  return dimensionsByType;
	}
	
	function deleteFieldKey(state, action) {
	  var field = state.get(action.field).filter(function (id) {
	    return id !== Number(action.id);
	  });
	  return state.set(action.field, field);
	}
	
	function addFieldKey(state, action) {
	  var field = state.get(action.field);
	  return state.get(action.field) ? state.setIn([action.field, field.size], Number(action.id)) : state.set(action.field, _immutable2.default.fromJS([Number(action.id)]));
	}
	
	function changeFieldKey(state, action) {
	  return action.addition ? addFieldKey(state, action) : deleteFieldKey(state, action);
	}
	
	function changeNightFlex(state, action) {
	  return state.setIn(['queryState', 'props', 'nightFlex', 'set'], action.value);
	}
	
	/* istanbul ignore next */
	function reducerCallback(state, action) {
	  var response = state;
	
	  if ((0, _utils.checkForNestedProperty)(action, 'response.result.baseState')) {
	    var baseState = action.response.result.baseState;
	    response = removeGroupedDimensionsByType(state);
	    response = response.merge(baseState, groupDimensionsByType(action, baseState.dimensions));
	    response = calculateNumberOfChargeablePassengers(response);
	  }
	
	  return response;
	}
	
	function filterCallback(state, action) {
	  if (action.response.result && action.response.result.baseState) {
	    delete action.response.result.baseState.pageStart;
	    delete action.response.result.baseState.numAggregateRecs;
	  }
	
	  return reducerCallback(state, action);
	}
	
	/* istanbul ignore next */
	exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty3.default)(_handleActions, _annualAvailabilityActions.TYPES.ANNUAL_AVAILABILITY_SUCCESS, filterCallback), (0, _defineProperty3.default)(_handleActions, _searchResultsActions.TYPES.SEARCH_RESULTS_SUCCESS, reducerCallback), (0, _defineProperty3.default)(_handleActions, _hotelDetailsActions.TYPES.HOTEL_DETAILS_SUCCESS, reducerCallback), (0, _defineProperty3.default)(_handleActions, _baseStateActions.TYPES.SET_ROOMS_VALIDITY, function (state, action) {
	  return state.set('areRoomsValid', action.isValid);
	}), (0, _defineProperty3.default)(_handleActions, _baseStateActions.TYPES.BASE_STATE_SUCCESS, filterCallback), (0, _defineProperty3.default)(_handleActions, _baseStateActions.TYPES.DELETE_BASESTATE_FIELD_KEY, deleteFieldKey), (0, _defineProperty3.default)(_handleActions, _baseStateActions.TYPES.CHANGE_BASESTATE_FIELD_KEY, changeFieldKey), (0, _defineProperty3.default)(_handleActions, _baseStateActions.TYPES.CHANGE_NIGHT_FLEX, changeNightFlex), (0, _defineProperty3.default)(_handleActions, _baseStateActions.TYPES.UPDATE_CAL_DATE, function (state, action) {
	  var response = state;
	  response = response.setIn(['queryState', 'props', 'calDate', 'value'], Number(action.calDate));
	  response = response.setIn(['queryState', 'props', 'calDate', 'selected'], true);
	  response = response.setIn(['queryState', 'props', 'deptDate', 'value'], Number(action.calDate));
	  return response;
	}), (0, _defineProperty3.default)(_handleActions, _baseStateActions.TYPES.UPDATE_PARTY, function (state, action) {
	  var response = state;
	  var nAdt = 0;
	  var cdn = [];
	
	  var rooms = action.rooms.map(function (room) {
	    return {
	      cdn: {
	        arrayValue: room.children ? room.children.split(',').map(function (child) {
	          return Number(child);
	        }) : []
	      },
	      nAdt: {
	        value: room.adults
	      }
	    };
	  });
	
	  action.rooms.forEach(function (room) {
	    nAdt += room.adults;
	    cdn = room.children ? cdn.concat(room.children.split(',')) : cdn;
	  });
	
	  response = response.setIn(['queryState', 'props', 'rooms'], _immutable2.default.fromJS(rooms));
	  response = response.setIn(['queryState', 'props', 'nAdt', 'value'], nAdt);
	  response = response.setIn(['queryState', 'props', 'cdn', 'arrayValue'], _immutable2.default.fromJS(cdn.map(function (child) {
	    return Number(child);
	  })));
	  response = calculateNumberOfChargeablePassengers(response);
	  return response;
	}), (0, _defineProperty3.default)(_handleActions, _baseStateActions.TYPES.CHANGE_NUMBER_OF_CHILDREN, function (state, action) {
	  var response = state;
	
	  var childAges = state.getIn(['queryState', 'props', 'rooms', action.roomNum, 'cdn', 'arrayValue'], _immutable2.default.List()).toJS();
	
	  var unsetChildAges = new Array(action.numChildren).fill('-1');
	  var newChildAges = unsetChildAges.map(function (element, i) {
	    return childAges[i] !== undefined ? childAges[i] : element;
	  });
	
	  response = response.setIn(['queryState', 'props', 'rooms', action.roomNum, 'cdn', 'arrayValue'], _immutable2.default.fromJS(newChildAges));
	
	  response = calculateNumberOfChargeablePassengers(response);
	  return response;
	}), (0, _defineProperty3.default)(_handleActions, _calendarOfferActions.TYPES.CALENDAR_OFFERS_SUCCESS, function (state, action) {
	  var response = state;
	  if ((0, _utils.checkForNestedProperty)(action, 'response.result.json.baseState')) {
	    var baseState = action.response.result.json.baseState;
	    delete baseState.pageStart;
	    delete baseState.numAggregateRecs;
	
	    response = removeGroupedDimensionsByType(state);
	    response = response.merge(baseState, groupDimensionsByType(action, baseState.dimensions));
	    response = calculateNumberOfChargeablePassengers(response);
	  }
	  return response;
	}), (0, _defineProperty3.default)(_handleActions, _annualAvailabilityActions.TYPES.CHANGE_CALDATE_VALUE, function (state, action) {
	  return state.set('calDateValue', action.calDate);
	}), (0, _defineProperty3.default)(_handleActions, _baseStateActions.TYPES.CHANGE_NUMBER_OF_ADULTS, function (state, action) {
	  var response = state;
	  response = response.setIn(['queryState', 'props', 'rooms', action.roomNum, 'nAdt', 'value'], Number(action.numAdults));
	  response = calculateNumberOfChargeablePassengers(response);
	
	  return response;
	}), (0, _defineProperty3.default)(_handleActions, _baseStateActions.TYPES.CHANGE_CHILD_AGE, function (state, action) {
	  var response = state;
	  response = response.setIn(['queryState', 'props', 'rooms', action.roomNum, 'cdn', 'arrayValue', action.childNumber], action.age);
	  response = calculateNumberOfChargeablePassengers(response);
	
	  return response;
	}), (0, _defineProperty3.default)(_handleActions, _annualAvailabilityActions.TYPES.CHANGE_NUMBER_OF_NIGHTS, function (state, action) {
	  return state.setIn(['D_Nights', 0], action.addDimId);
	}), _handleActions), initialState);

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getHotelPriceObject = getHotelPriceObject;
	exports.paymentPlanPriorityScore = paymentPlanPriorityScore;
	exports.getFlightMealsPrice = getFlightMealsPrice;
	exports.findFlightSeat = findFlightSeat;
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _payment = __webpack_require__(310);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getHotelPriceObject(bookState) {
	  var roomSelectionIds = bookState.getIn(['booking_info', 'selection', 'room_selected'], _immutable2.default.List());
	  var hotelPrice = {
	    webPrice: 0,
	    retailPrice: 0,
	    nettPrice: 0
	  };
	
	  roomSelectionIds.forEach(function (roomSelectionId) {
	    var pricing = bookState.getIn(['entities', 'roomRestrictions', '' + roomSelectionId, 'pricing']);
	
	    hotelPrice.webPrice += pricing.get('webPrice');
	    hotelPrice.retailPrice += pricing.get('retailPrice');
	    hotelPrice.nettPrice += pricing.get('nettPrice');
	  });
	
	  return hotelPrice;
	}
	
	function paymentPlanPriorityScore(bookState, planId) {
	  var paymentPlan = bookState.getIn(['entities', 'paymentPlans', '' + planId]);
	  var isAvailable = paymentPlan.get('availability') === 'AVAILABLE';
	  var sortOrder = [_payment.PAYMENT_PLAN_TYPES.SPREAD_THE_COST, _payment.PAYMENT_PLAN_TYPES.LOW_DEPOSIT, _payment.PAYMENT_PLAN_TYPES.STANDARD_DEPOSIT, _payment.PAYMENT_PLAN_TYPES.PAY_IN_FULL];
	  var index = sortOrder.indexOf(planId);
	  var score = index === -1 ? sortOrder.length + 1 : index;
	
	  if (!isAvailable) {
	    score += sortOrder.length;
	  }
	
	  return score;
	}
	
	function getFlightMealsPrice(bookState) {
	  var selectedFlightMealIds = bookState.getIn(['booking_info', 'selection', 'extras', 'flightMeals']) || _immutable2.default.List();
	  var meals = bookState.getIn(['entities', 'flightMeals']) || _immutable2.default.List();
	  var total = 0;
	
	  selectedFlightMealIds.map(function (id) {
	    total += meals.getIn(['' + id, 'pricing', 'webPrice'], 0);
	  });
	
	  return total;
	}
	
	function findFlightSeat(flightDirection, rowNumber, seatNumber) {
	  var flightSeat = void 0;
	
	  var flightRow = flightDirection.getIn(['flightSeatMap', 'flightRows'], _immutable2.default.List()).find(function (row) {
	    return row.get('rowNumber') === rowNumber;
	  });
	  if (flightRow) {
	    flightSeat = flightRow.get('flightSeats').find(function (seat) {
	      return seat.get('seatNumber') === seatNumber;
	    });
	  }
	
	  return flightSeat;
	}

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(32);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _handleActions;
	
	var _customControlActions = __webpack_require__(120);
	
	var _reduxActions = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {};
	
	exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty3.default)(_handleActions, _customControlActions.TYPES.SHOW_CONTROL, function (state, action) {
	  return (0, _assign2.default)({}, action.content, action.data);
	}), (0, _defineProperty3.default)(_handleActions, _customControlActions.TYPES.HIDE_CONTROL, function () {
	  return initialState;
	}), (0, _defineProperty3.default)(_handleActions, _customControlActions.TYPES.TOGGLE_CONTROL, function (state, action) {
	  var newState = initialState;
	
	  if (action.content.id !== state.id) {
	    newState = (0, _assign2.default)({}, action.content, action.data);
	  }
	
	  return newState;
	}), _handleActions), initialState);

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(216);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _toConsumableArray2 = __webpack_require__(87);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _values = __webpack_require__(326);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _handleActions;
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reduxActions = __webpack_require__(85);
	
	var _annualAvailabilityActions = __webpack_require__(141);
	
	var _searchResultsActions = __webpack_require__(214);
	
	var _dayOfMonthActions = __webpack_require__(317);
	
	var _dimensionsActions = __webpack_require__(212);
	
	var _dimensionsAvailabilityActions = __webpack_require__(318);
	
	var _searchUnitActions = __webpack_require__(66);
	
	var _hotelDetailsActions = __webpack_require__(213);
	
	var _utils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map();
	
	function reducerCallback(state, action) {
	  var response = state;
	
	  if ((0, _utils.checkForNestedProperty)(action, 'response.entities.dimensions')) {
	    response = state.mergeDeep(action.response.entities.dimensions);
	  }
	
	  return response;
	}
	
	var dayOfMonthSuccess = function dayOfMonthSuccess(state, action) {
	  var response = state;
	
	  if ((0, _utils.checkForNestedProperty)(action, 'response.entities.dimensions')) {
	    response = state.merge(action.response.entities.dimensions);
	  }
	
	  return response;
	};
	
	exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty3.default)(_handleActions, _annualAvailabilityActions.TYPES.ANNUAL_AVAILABILITY_SUCCESS, reducerCallback), (0, _defineProperty3.default)(_handleActions, _searchResultsActions.TYPES.SEARCH_RESULTS_SUCCESS, reducerCallback), (0, _defineProperty3.default)(_handleActions, _dimensionsActions.TYPES.DIMENSIONS_RESULTS_SUCCESS, reducerCallback), (0, _defineProperty3.default)(_handleActions, _hotelDetailsActions.TYPES.HOTEL_DETAILS_SUCCESS, reducerCallback), (0, _defineProperty3.default)(_handleActions, _dayOfMonthActions.TYPES.DAY_OF_MONTH_SUCCESS, dayOfMonthSuccess), (0, _defineProperty3.default)(_handleActions, _searchUnitActions.TYPES.DAY_OF_MONTH_SUCCESS, dayOfMonthSuccess), (0, _defineProperty3.default)(_handleActions, _annualAvailabilityActions.TYPES.CHANGE_NUMBER_OF_NIGHTS, function (state, action) {
	  return state.setIn([action.addDimId, 'selected'], true).setIn([action.removeDimId, 'selected'], false).setIn([action.removeDimId, 'available'], true);
	}), (0, _defineProperty3.default)(_handleActions, _annualAvailabilityActions.TYPES.SET_DIMENSION_PROPERTY, function (state, action) {
	  return state.setIn([action.dimId, action.key], action.value);
	}), (0, _defineProperty3.default)(_handleActions, _dimensionsAvailabilityActions.TYPES.DIMENSIONS_AVAILABILITY_SUCCESS, function (state, action) {
	  var response = state;
	  if ((0, _utils.checkForNestedProperty)(action, 'response.result.availability')) {
	    var availability = action.response.result.availability;
	    var availableDimIds = [];
	
	    (0, _values2.default)(availability).forEach(function (obj) {
	      availableDimIds.push.apply(availableDimIds, (0, _toConsumableArray3.default)((0, _keys2.default)(obj)));
	    });
	
	    response = state.withMutations(function (mutatedState) {
	      mutatedState.forEach(function (dim, dimId) {
	        mutatedState.setIn([dimId, 'available'], availableDimIds.indexOf(dimId) > -1);
	      });
	    });
	  }
	
	  return response;
	}), _handleActions), initialState);

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _handleActions;
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reduxActions = __webpack_require__(85);
	
	var _annualAvailabilityActions = __webpack_require__(141);
	
	var _searchResultsActions = __webpack_require__(214);
	
	var _dimensionsActions = __webpack_require__(212);
	
	var _dayOfMonthActions = __webpack_require__(317);
	
	var _searchUnitActions = __webpack_require__(66);
	
	var _hotelDetailsActions = __webpack_require__(213);
	
	var _utils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map();
	
	function reducerCallback(state, action) {
	  var response = state;
	  if ((0, _utils.checkForNestedProperty)(action, 'response.result.dimensions')) {
	    response = state.merge(action.response.result.dimensions);
	  }
	
	  return response;
	}
	
	exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty3.default)(_handleActions, _annualAvailabilityActions.TYPES.ANNUAL_AVAILABILITY_SUCCESS, reducerCallback), (0, _defineProperty3.default)(_handleActions, _searchResultsActions.TYPES.SEARCH_RESULTS_SUCCESS, reducerCallback), (0, _defineProperty3.default)(_handleActions, _dimensionsActions.TYPES.DIMENSIONS_RESULTS_SUCCESS, reducerCallback), (0, _defineProperty3.default)(_handleActions, _dayOfMonthActions.TYPES.DAY_OF_MONTH_SUCCESS, reducerCallback), (0, _defineProperty3.default)(_handleActions, _searchUnitActions.TYPES.DAY_OF_MONTH_SUCCESS, reducerCallback), (0, _defineProperty3.default)(_handleActions, _hotelDetailsActions.TYPES.HOTEL_DETAILS_SUCCESS, reducerCallback), _handleActions), initialState);

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reduxActions = __webpack_require__(85);
	
	var _featureFlagActions = __webpack_require__(319);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var classNameAssignment = {
	  MobileSearchNoBackground: 'no-background',
	  BookPassengerDetailsOnOneLine: 'details-on-one-line',
	  BookPaypalWithoutTab: 'paypal-without-tab',
	  InterstitialModalNewLogos: 'interstitial-new-logos-desktop'
	};
	
	var initialState = _immutable2.default.fromJS({
	  classNameList: []
	});
	
	exports.default = (0, _reduxActions.handleActions)((0, _defineProperty3.default)({}, _featureFlagActions.TYPES.SET_FEATURE_FLAG, function (state, _ref) {
	  var featureFlag = _ref.featureFlag;
	
	  var newState = state;
	
	  if (classNameAssignment[featureFlag]) {
	    newState = newState.set('classNameList', newState.get('classNameList').push(classNameAssignment[featureFlag]));
	  }
	
	  return newState.set(featureFlag, true);
	}), initialState);

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(32);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = modalReducer;
	
	var _modalActions = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function modalReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _modalActions.TYPES.TOGGLE_MODAL:
	      return {
	        name: action.modal,
	        config: action.config
	      };
	    case _modalActions.TYPES.SET_MODAL_CLOSING:
	      return (0, _assign2.default)({}, state, {
	        config: (0, _assign2.default)({}, state.config, {
	          isClosing: true
	        })
	      });
	    default:
	      return state;
	  }
	}

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(32);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _handleActions;
	
	var _popoverActions = __webpack_require__(144);
	
	var _reduxActions = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {};
	
	exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty3.default)(_handleActions, _popoverActions.TYPES.SHOW_POPOVER, function (state, action) {
	  return (0, _assign2.default)({}, action.content, action.data);
	}), (0, _defineProperty3.default)(_handleActions, _popoverActions.TYPES.HIDE_POPOVER, function () {
	  return initialState;
	}), (0, _defineProperty3.default)(_handleActions, _popoverActions.TYPES.TOGGLE_POPOVER, function (state, action) {
	  var newState = initialState;
	
	  if (action.content.id !== state.id) {
	    newState = (0, _assign2.default)({}, action.content, action.data);
	  }
	
	  return newState;
	}), _handleActions), initialState);

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _handleActions;
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reduxActions = __webpack_require__(85);
	
	var _searchActions = __webpack_require__(320);
	
	var _utils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.List();
	
	exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty3.default)(_handleActions, _searchActions.TYPES.SUGGEST_DESTINATIONS_SUCCESS, function (state, action) {
	  var response = state;
	
	  if ((0, _utils.checkForNestedProperty)(action, 'response.result')) {
	    response = _immutable2.default.fromJS(action.response.result);
	  }
	
	  return response;
	}), (0, _defineProperty3.default)(_handleActions, _searchActions.TYPES.SUGGEST_HOTELS_SUCCESS, function (state, action) {
	  var response = state;
	
	  if ((0, _utils.checkForNestedProperty)(action, 'response.result')) {
	    response = _immutable2.default.fromJS(action.response.result);
	  }
	
	  return response;
	}), (0, _defineProperty3.default)(_handleActions, _searchActions.TYPES.CLEAR_SUGGESTIONS, function () {
	  return initialState;
	}), _handleActions), initialState);

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(16);
	
	var _reactRouterRedux = __webpack_require__(298);
	
	var _appStateReducer = __webpack_require__(590);
	
	var _appStateReducer2 = _interopRequireDefault(_appStateReducer);
	
	var _baseStateReducer = __webpack_require__(591);
	
	var _baseStateReducer2 = _interopRequireDefault(_baseStateReducer);
	
	var _customControlReducer = __webpack_require__(593);
	
	var _customControlReducer2 = _interopRequireDefault(_customControlReducer);
	
	var _dimensionsEntitiesReducer = __webpack_require__(594);
	
	var _dimensionsEntitiesReducer2 = _interopRequireDefault(_dimensionsEntitiesReducer);
	
	var _dimensionsResultReducer = __webpack_require__(595);
	
	var _dimensionsResultReducer2 = _interopRequireDefault(_dimensionsResultReducer);
	
	var _modalReducer = __webpack_require__(597);
	
	var _modalReducer2 = _interopRequireDefault(_modalReducer);
	
	var _popoverReducer = __webpack_require__(598);
	
	var _popoverReducer2 = _interopRequireDefault(_popoverReducer);
	
	var _searchReducer = __webpack_require__(599);
	
	var _searchReducer2 = _interopRequireDefault(_searchReducer);
	
	var _featureFlagsReducer = __webpack_require__(596);
	
	var _featureFlagsReducer2 = _interopRequireDefault(_featureFlagsReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  appState: _appStateReducer2.default,
	  baseState: _baseStateReducer2.default,
	  customControl: _customControlReducer2.default,
	  dimensionsEntities: _dimensionsEntitiesReducer2.default,
	  dimensionsResult: _dimensionsResultReducer2.default,
	  featureFlags: _featureFlagsReducer2.default,
	  modal: _modalReducer2.default,
	  popover: _popoverReducer2.default,
	  router: _reactRouterRedux.routeReducer,
	  search: _searchReducer2.default
	});

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(78);
	
	var _CoreLayout = __webpack_require__(563);
	
	var _CoreLayout2 = _interopRequireDefault(_CoreLayout);
	
	var _SearchUnitStandaloneLayout = __webpack_require__(579);
	
	var _SearchUnitStandaloneLayout2 = _interopRequireDefault(_SearchUnitStandaloneLayout);
	
	var _SearchUnitStandaloneHotelLayout = __webpack_require__(578);
	
	var _SearchUnitStandaloneHotelLayout2 = _interopRequireDefault(_SearchUnitStandaloneHotelLayout);
	
	var _optimizely = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// NOTE: here we're making use of the `resolve.root` configuration
	// option in webpack, which allows us to specify import paths as if
	// they were from the root of the ~/src directory. This makes it
	// very easy to navigate to files regardless of how deeply nested
	// your current file is.
	exports.default = _react2.default.createElement(
	  _reactRouter.Route,
	  { path: '/', component: _CoreLayout2.default, onEnter: _optimizely.activate },
	  _react2.default.createElement(_reactRouter.Route, { path: 'hotels*', component: _SearchUnitStandaloneHotelLayout2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'sem/**/*.html', component: _SearchUnitStandaloneLayout2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: '*', component: _SearchUnitStandaloneLayout2.default }),
	  _react2.default.createElement(_reactRouter.IndexRoute, { component: _SearchUnitStandaloneLayout2.default })
	);

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GTM_EVENT_NAMES = undefined;
	
	var _extends2 = __webpack_require__(56);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(21);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _eventFactories;
	
	exports.getTrackPandaEvent = getTrackPandaEvent;
	exports.getTrackTransEvent = getTrackTransEvent;
	exports.getTrackPurchaseEvent = getTrackPurchaseEvent;
	exports.getTrackLeadPassengerEvent = getTrackLeadPassengerEvent;
	exports.getTrackPriceTrackerEvent = getTrackPriceTrackerEvent;
	exports.getTrackShortlistSubmitEvent = getTrackShortlistSubmitEvent;
	exports.getTrackConfirmationEvent = getTrackConfirmationEvent;
	exports.fireEvent = fireEvent;
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utils = __webpack_require__(8);
	
	var _book = __webpack_require__(215);
	
	var _dates = __webpack_require__(35);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _dataLayerHelpers = __webpack_require__(321);
	
	var _LHX = __webpack_require__(67);
	
	var _LHX2 = _interopRequireDefault(_LHX);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isEnablePurchaseTracking = function isEnablePurchaseTracking(state) {
	  return state.bookState.getIn(['mode']) !== 'agent' && _LHX2.default.environment === 'prod' && (0, _utils.readCookie)('lastBookingRef') !== state.bookState.getIn(['status', 'booking_reference']);
	};
	var getBaseStateQueryProps = function getBaseStateQueryProps(state) {
	  return state.baseState.getIn(['queryState', 'props'], _immutable2.default.Map());
	};
	var getBookingReference = function getBookingReference(state) {
	  return state.bookState.getIn(['status', 'booking_reference']);
	};
	var getCheckInDate = function getCheckInDate(state) {
	  return state.bookState.getIn(['data', 'check_in_date']);
	};
	var getCity = function getCity(state) {
	  return state.bookState.getIn(['entities', 'passengers', '0', 'city'], '');
	};
	var getCountryCode = function getCountryCode() {
	  return (0, _utils.isDomainIe)() ? 'IE' : 'UK';
	};
	var getCounty = function getCounty(state) {
	  return state.bookState.getIn(['entities', 'passengers', '0', 'county']);
	};
	var getCurrency = function getCurrency() {
	  return (0, _utils.isCurrencyEur)() ? 'EUR' : 'GBP';
	};
	var getCurrencySymbol = function getCurrencySymbol() {
	  return (0, _utils.isCurrencyEur)() ? '€' : '£';
	};
	var getCheapestOfferOfDay = function getCheapestOfferOfDay(state) {
	  return state.appState.get('selectedOffer');
	};
	var getDepartureCode = function getDepartureCode(state, bookType) {
	  return bookType !== 'hotel-only' ? state.bookState.getIn(['data', 'flight', 'outbound', 'deptCode']) : '';
	};
	var getDepartureDate = function getDepartureDate(state) {
	  return state.bookState.getIn(['data', 'flight', 'outbound', 'deptDate']);
	};
	var getDestinationAirportCode = function getDestinationAirportCode(state) {
	  return state.bookState.getIn(['data', 'flight', 'outbound', 'arrvCode']);
	};
	var getDestinationAirportName = function getDestinationAirportName(state) {
	  return state.bookState.getIn(['data', 'flight', 'outbound', 'arrvName']);
	};
	var getExpectedRevenue = function getExpectedRevenue(state) {
	  return state.bookState.getIn(['tracking', 'expected_revenue']) / 100;
	};
	var getHoldLuggagePrice = function getHoldLuggagePrice(state) {
	  return state.bookState.getIn(['priceBreakdown', 'baggagePrice']);
	};
	var getHotelDetailsMasterId = function getHotelDetailsMasterId(state) {
	  return state.hotelDetails.get('masterId', '');
	};
	var getHotelLargeImage = function getHotelLargeImage(state) {
	  return state.bookState.getIn(['data', 'hotelLargeImageUrl']);
	};
	var getHotelSmallImage = function getHotelSmallImage(state) {
	  return state.bookState.getIn(['data', 'hotelSmallImageUrl']);
	};
	var getHotelStarRating = function getHotelStarRating(state) {
	  return state.bookState.getIn(['data', 'star_rating']);
	};
	var getHotelName = function getHotelName(state) {
	  return state.bookState.getIn(['data', 'hotel_name']);
	};
	var getInboundDepartureDate = function getInboundDepartureDate(state) {
	  return state.bookState.getIn(['data', 'flight', 'inbound', 'deptDate']);
	};
	var getInboundDepartureTime = function getInboundDepartureTime(state) {
	  return state.bookState.getIn(['data', 'flight', 'inbound', 'deptTime']);
	};
	var getInboundAirline = function getInboundAirline(state) {
	  return state.bookState.getIn(['data', 'flight', 'inbound', 'airline']);
	};
	var getInboundArrivalDate = function getInboundArrivalDate(state) {
	  return state.bookState.getIn(['data', 'flight', 'inbound', 'arrvDate']);
	};
	var getInboundArrivalTime = function getInboundArrivalTime(state) {
	  return state.bookState.getIn(['data', 'flight', 'inbound', 'arrvTime']);
	};
	var getInsuranceTypeId = function getInsuranceTypeId(state) {
	  return state.bookState.getIn(['booking_info', 'selection', 'insurance_selected']);
	};
	var getInsuranceType = function getInsuranceType(state) {
	  return state.bookState.getIn(['entities', 'insurance', '' + getInsuranceTypeId(state), 'coverType']);
	};
	var getInsurancePrice = function getInsurancePrice(state) {
	  return state.bookState.getIn(['priceBreakdown', 'insurancePrice']);
	};
	var getLeadPassengerID = function getLeadPassengerID(state) {
	  return state.bookState.getIn(['booking_info', 'leadPassengerId']).toString();
	};
	var getLeadPassengerDateOfBirthDay = function getLeadPassengerDateOfBirthDay(state) {
	  return state.bookState.getIn(['entities', 'passengers', getLeadPassengerID(state), 'dateOfBirthDay']);
	};
	var getLeadPassengerDateOfBirthMonth = function getLeadPassengerDateOfBirthMonth(state) {
	  return state.bookState.getIn(['entities', 'passengers', getLeadPassengerID(state), 'dateOfBirthMonth']);
	};
	var getLeadPassengerDateOfBirthYear = function getLeadPassengerDateOfBirthYear(state) {
	  return state.bookState.getIn(['entities', 'passengers', getLeadPassengerID(state), 'dateOfBirthYear']);
	};
	var getInsuranceDescription = function getInsuranceDescription(state) {
	  return (0, _book.getInsuranceDescriptionByType)(getInsuranceType(state), getCurrencySymbol());
	};
	var getLeadPassengerEmail = function getLeadPassengerEmail(state) {
	  return state.bookState.getIn(['entities', 'passengers', getLeadPassengerID(state), 'email']);
	};
	var getLeadPassengerSubscribe = function getLeadPassengerSubscribe(state) {
	  return state.bookState.getIn(['entities', 'passengers', getLeadPassengerID(state), 'subscribe'], false).toString();
	};
	var getLeadPassengerFirstName = function getLeadPassengerFirstName(state) {
	  return state.bookState.getIn(['entities', 'passengers', getLeadPassengerID(state), 'firstName']);
	};
	var getLeadPassengerLastName = function getLeadPassengerLastName(state) {
	  return state.bookState.getIn(['entities', 'passengers', getLeadPassengerID(state), 'lastName']);
	};
	var getLeadPassengerTitle = function getLeadPassengerTitle(state) {
	  return state.bookState.getIn(['entities', 'passengers', getLeadPassengerID(state), 'title']);
	};
	var getMasterId = function getMasterId(state) {
	  return state.bookState.getIn(['data', 'master_id']);
	};
	var getNumberOfAdults = function getNumberOfAdults(state) {
	  return state.bookState.getIn(['data', 'partyInfo', 'numberOfAdults']);
	};
	var getNumberOfChargeablePassengers = function getNumberOfChargeablePassengers(state) {
	  return state.bookState.getIn(['data', 'partyInfo', 'numberOfChargeablePassengers']);
	};
	var getNumberOfChildren = function getNumberOfChildren(state) {
	  return state.bookState.getIn(['data', 'partyInfo', 'numberOfChildren']);
	};
	var getNumberOfHoldLuggage = function getNumberOfHoldLuggage(state) {
	  return (state.bookState.getIn(['booking_info', 'selection', 'extras', 'baggage']) || _immutable2.default.List()).size;
	};
	var getNumberOfNights = function getNumberOfNights(state) {
	  return state.bookState.getIn(['data', 'num_nights']);
	};
	var getNumberOfRooms = function getNumberOfRooms(state) {
	  return (state.bookState.getIn(['booking_info', 'selection', 'room_selected']) || _immutable2.default.List()).size;
	};
	var getOriginAirportCode = function getOriginAirportCode(state) {
	  return state.bookState.getIn(['data', 'flight', 'outbound', 'deptCode']);
	};
	var getOriginAirportName = function getOriginAirportName(state) {
	  return state.bookState.getIn(['data', 'flight', 'outbound', 'deptName']);
	};
	var getOutboundAirline = function getOutboundAirline(state) {
	  return state.bookState.getIn(['data', 'flight', 'outbound', 'airline']);
	};
	var getOutboundDepartureDate = function getOutboundDepartureDate(state) {
	  return state.bookState.getIn(['data', 'flight', 'outbound', 'deptDate']);
	};
	var getOutboundDepartureTime = function getOutboundDepartureTime(state) {
	  return state.bookState.getIn(['data', 'flight', 'outbound', 'deptTime']);
	};
	var getOutboundArrivalDate = function getOutboundArrivalDate(state) {
	  return state.bookState.getIn(['data', 'flight', 'outbound', 'arrvDate']);
	};
	var getOutboundArrivalTime = function getOutboundArrivalTime(state) {
	  return state.bookState.getIn(['data', 'flight', 'outbound', 'arrvTime']);
	};
	var getPaymentPlan = function getPaymentPlan(state) {
	  return state.bookState.getIn(['booking_info', 'payment_details', 'deposit']);
	};
	var getPhgCommissionTier = function getPhgCommissionTier(state) {
	  return state.bookState.getIn(['tracking', 'phg_commission_tiers']);
	};
	var getResort = function getResort(state) {
	  return state.bookState.getIn(['data', 'destination']);
	};
	var getTotalNow = function getTotalNow(state) {
	  return state.bookState.getIn(['priceBreakdown', 'totalPrice']);
	};
	var getTotalWas = function getTotalWas(state) {
	  return state.bookState.getIn(['priceBreakdown', 'totalWasPrice']);
	};
	var getTransferPrice = function getTransferPrice(state) {
	  return state.bookState.getIn(['priceBreakdown', 'transferPrice']);
	};
	var getTransferTypeId = function getTransferTypeId(state) {
	  return state.bookState.getIn(['booking_info', 'selection', 'transfer_selected']);
	};
	var getTransferType = function getTransferType(state) {
	  return state.bookState.getIn(['entities', 'transfers', '' + getTransferTypeId(state), 'type']);
	};
	var getParkingPrice = function getParkingPrice(state) {
	  return state.bookState.getIn(['priceBreakdown', 'parkingPrice']);
	};
	var getParkingTypeId = function getParkingTypeId(state) {
	  return state.bookState.getIn(['booking_info', 'selection', 'parking_selected']);
	};
	var getParkingType = function getParkingType(state) {
	  return state.bookState.getIn(['entities', 'parking', '' + getParkingTypeId(state), 'type']);
	};
	var getTransactionAffiliation = function getTransactionAffiliation(bookType) {
	  return bookType === 'hotel-only' ? 'HOTEL_ONLY' : 'DYN_PACKAGE';
	};
	var getTransactionCurrency = getCurrencySymbol;
	var getTransactionId = getBookingReference;
	var getTransactionShipping = function getTransactionShipping() {
	  return '';
	};
	var getTransactionTax = function getTransactionTax() {
	  return '';
	};
	var getTransactionTotal = getExpectedRevenue;
	var getTransactionProducts = function getTransactionProducts(state) {
	  return [{
	    id: '' + getMasterId(state),
	    name: state.bookState.getIn(['data', 'hotel_name']),
	    sku: '' + getMasterId(state),
	    category: state.bookState.getIn(['tracking', 'resort']),
	    price: getTransactionTotal(state),
	    quantity: '1'
	  }];
	};
	var getWebSellingPrice = function getWebSellingPrice(state) {
	  return state.bookState.getIn(['tracking', 'web_selling_price']) / 100;
	};
	
	var getCheckOutDate = function getCheckOutDate(state) {
	  return _dates2.default.format(_dates2.default.addDays(getNumberOfNights(state), _dates2.default.isoStringToDate(getCheckInDate(state))), 'YYYY-MM-DD');
	};
	var getPricePerPerson = function getPricePerPerson(state) {
	  return getTotalNow(state) / getNumberOfChargeablePassengers(state);
	};
	
	var getPriceTrackerFullName = function getPriceTrackerFullName(state) {
	  return state.priceTracker.get('fullName');
	};
	var getPriceTrackerEmail = function getPriceTrackerEmail(state) {
	  return state.priceTracker.get('email');
	};
	var getPriceTrackerNewsletterSubscription = function getPriceTrackerNewsletterSubscription(state) {
	  return state.priceTracker.get('newsletterSubscription');
	};
	
	var getShortlistEmail = function getShortlistEmail(state) {
	  return state.shortlist.get('mainRecipientEmail');
	};
	var getShortlistNewsletterSubscription = function getShortlistNewsletterSubscription(state) {
	  return state.shortlist.get('newsletterSubscription');
	};
	
	var getSelectedBoardBasis = function getSelectedBoardBasis(state) {
	  var boardBasisCode = state.bookState.getIn(['entities', 'rooms', '' + [state.bookState.getIn(['booking_info', 'selection', 'room_selected', '0'])], 'board_basis']);
	  return state.bookState.getIn(['data', 'board_basis_config', boardBasisCode, 'name']);
	};
	
	var getLeadPassengerDateOfBirth = function getLeadPassengerDateOfBirth(state) {
	  // this is currently in the format dd/mm/yyyy
	  var dateOfBirth = [];
	  dateOfBirth[0] = ('0' + getLeadPassengerDateOfBirthDay(state)).substr(-2);
	  dateOfBirth[1] = ('0' + getLeadPassengerDateOfBirthMonth(state)).substr(-2);
	  dateOfBirth[2] = getLeadPassengerDateOfBirthYear(state);
	  return dateOfBirth.join('/');
	};
	
	function getRoomTypeAndPrice(state, roomNumber) {
	  var roomId = state.bookState.getIn(['booking_info', 'selection', 'room_selected', roomNumber]);
	  var description = void 0;
	  var price = void 0;
	  var roomData = {};
	
	  var id = state.bookState.getIn(['entities', 'roomRestrictions', '' + roomId, 'roomId']);
	  description = state.bookState.getIn(['entities', 'roomPricingOptions', '' + roomId, 'description']);
	  price = (0, _utils.penceToPounds)(state.bookState.getIn(['entities', 'roomRestrictions', '' + id, 'pricing', 'webPrice']));
	
	  if (description && price) {
	    var _roomData;
	
	    roomData = (_roomData = {}, (0, _defineProperty3.default)(_roomData, 'room' + roomNumber + 'Type', description), (0, _defineProperty3.default)(_roomData, 'room' + roomNumber + 'Price', price), _roomData);
	  }
	
	  return roomData;
	}
	
	var GTM_EVENT_NAMES = exports.GTM_EVENT_NAMES = {
	  TRACK_TRANS: 'TRACK_TRANS',
	  TRACK_PURCHASE: 'TRACK_PURCHASE',
	  TRACK_CONF: 'TRACK_CONF',
	  TRACK_LEAD_PASSENGER: 'TRACK_LEAD_PASSENGER',
	  TRACK_PRICE_TRACKER: 'TRACK_PRICE_TRACKER',
	  TRACK_SHORTLIST_SUBMIT: 'TRACK_SHORTLIST_SUBMIT',
	  TRACK_PANDA: 'TRACK_PANDA'
	};
	
	function getTrackPandaEvent(state) {
	  var cheapestOfferOfDay = getCheapestOfferOfDay(state);
	  var baseQuery = getBaseStateQueryProps(state);
	
	  var data = {
	    codeBase: 'react',
	    userClass: (0, _dataLayerHelpers.getUserClassArray)(_LHX2.default.userClass),
	    page: {
	      pageInfo: {
	        search: {
	          hotels: {
	            adults: baseQuery.getIn(['nAdt', 'value']),
	            children: baseQuery.getIn(['cdn', 'arrayValue'], _immutable2.default.List()).size,
	            nights: baseQuery.getIn(['duration', 'value']),
	            rooms: baseQuery.get('rooms', _immutable2.default.List()).size
	          },
	          customer: {
	            brand: getCountryCode()
	          }
	        }
	      }
	    },
	    product: [{
	      productInfo: {
	        productID: String(getHotelDetailsMasterId(state))
	      }
	    }],
	    transaction: {
	      total: {
	        priceBookTodayFor: ''
	      },
	      currency: getCurrencySymbol(state)
	    },
	    event: 'trackPanda'
	  };
	
	  if (cheapestOfferOfDay) {
	    data.page.pageInfo.search.hotels.checkIn = _dates2.default.format(cheapestOfferOfDay.get('arrivalDate'), 'YYYY-MM-DD');
	    data.page.pageInfo.search.hotels.boardBasis = String(cheapestOfferOfDay.get('boardBasis'));
	    data.transaction.total.transactionTotal = cheapestOfferOfDay.get('totalDiscountPrice');
	    data.transaction.total.priceWas = cheapestOfferOfDay.get('retailPrice');
	    data.transaction.total.transactionPerPerson = cheapestOfferOfDay.get('price');
	  }
	
	  return data;
	}
	
	function getTrackTransEvent(state, shortRef, bookType) {
	  return {
	    brand: getCountryCode(),
	    transactionId: getTransactionId(state),
	    transactionAffiliation: getTransactionAffiliation(bookType),
	    transactionTotal: String(getTransactionTotal(state)),
	    transactionCurrency: getTransactionCurrency(state),
	    transactionTax: getTransactionTax(),
	    transactionShipping: getTransactionShipping(),
	    transactionProducts: getTransactionProducts(state),
	    event: 'trackTrans'
	  };
	}
	
	function getTrackPurchaseEvent(state, shortRef, bookType) {
	  return {
	    enable_purchase_tracking: isEnablePurchaseTracking(state) ? 'True' : 'False',
	    tracking_reference: getBookingReference(state),
	    shortref: shortRef,
	    expected_revenue: String(getExpectedRevenue(state)),
	    web_selling_price: String(getWebSellingPrice(state)),
	    masterId: String(getMasterId(state)),
	    num_children: getNumberOfChildren(state),
	    num_adults: getNumberOfAdults(state),
	    num_nights: getNumberOfNights(state),
	    checkin_date: getDepartureDate(state),
	    dept_code: getDepartureCode(state, bookType),
	    destination_urlencode: encodeURIComponent(state.bookState.getIn(['data', 'destination'])),
	    phg_commission_tier: getPhgCommissionTier(state),
	    event: 'trackPurchase'
	  };
	}
	
	function getTrackLeadPassengerEvent(state) {
	  return {
	    leadPassengerTitle: getLeadPassengerTitle(state),
	    leadPassengerFirstName: getLeadPassengerFirstName(state),
	    leadPassengerLastName: getLeadPassengerLastName(state),
	    leadPassengerEmail: getLeadPassengerEmail(state),
	    leadPassengerSubscribe: getLeadPassengerSubscribe(state),
	    leadPassengerDateOfBirth: getLeadPassengerDateOfBirth(state),
	    event: 'trackLeadPassenger'
	  };
	}
	
	function getTrackPriceTrackerEvent(state) {
	  return {
	    priceTrackerFullName: getPriceTrackerFullName(state),
	    priceTrackerEmail: getPriceTrackerEmail(state),
	    priceTrackerNewsletterSubscription: getPriceTrackerNewsletterSubscription(state),
	    event: 'trackPriceTracker'
	  };
	}
	
	function getTrackShortlistSubmitEvent(state) {
	  return {
	    shortlistEmail: getShortlistEmail(state),
	    shortlistNewsletterSubscription: getShortlistNewsletterSubscription(state),
	    event: 'trackShortlistSubmit'
	  };
	}
	
	function getTrackConfirmationEvent(state, shortRef, bookType) {
	  return {
	    event: 'trackConf',
	    codeBase: 'react',
	    confirmationData: (0, _extends3.default)({}, getRoomTypeAndPrice(state, 0), getRoomTypeAndPrice(state, 1), getRoomTypeAndPrice(state, 2), getRoomTypeAndPrice(state, 3), {
	      affiliationId: (0, _utils.readCookie)('lvh_ch'),
	      boardBasis: getSelectedBoardBasis(state),
	      checkInDate: getCheckInDate(state),
	      checkOutDate: getCheckOutDate(state),
	      city: getCity(state).replace(/,.*/, ''),
	      county: getCounty(state),
	      currency: getCurrency(),
	      destinationAirportCode: getDestinationAirportCode(state),
	      destinationAirportName: getDestinationAirportName(state),
	      expected_revenue: String(getExpectedRevenue(state)),
	      hotelLargeImage: getHotelLargeImage(state),
	      hotelName: getHotelName(state),
	      hotelSmallImage: getHotelSmallImage(state),
	      hotelStarRating: getHotelStarRating(state),
	      inboundAirline: getInboundAirline(state),
	      inboundArrvDate: '' + getInboundArrivalDate(state),
	      inboundArrvDateTime: getInboundArrivalDate(state) + ' ' + getInboundArrivalTime(state),
	      inboundDeptDateTime: getInboundDepartureDate(state) + ' ' + getInboundDepartureTime(state),
	      insuranceDescription: getInsuranceDescription(state),
	      insurancePrice: (0, _utils.penceToPounds)(getInsurancePrice(state)),
	      insuranceType: getInsuranceType(state),
	      luggagePrice: (0, _utils.penceToPounds)(getHoldLuggagePrice(state)),
	      lvhId: (0, _utils.readCookie)('lvhid'),
	      masterId: getMasterId(state),
	      numberOfAdults: getNumberOfAdults(state),
	      numberOfChildren: getNumberOfChildren(state),
	      numberOfHoldLuggage: getNumberOfHoldLuggage(state),
	      numberOfNights: getNumberOfNights(state),
	      numberOfRooms: getNumberOfRooms(state),
	      originAirportCode: getOriginAirportCode(state),
	      originAirportName: getOriginAirportName(state),
	      outboundAirline: getOutboundAirline(state),
	      outboundArrvDateTime: getOutboundArrivalDate(state) + ' ' + getOutboundArrivalTime(state),
	      outboundDeptDate: '' + getOutboundDepartureDate(state),
	      outboundDeptDateTime: getOutboundDepartureDate(state) + ' ' + getOutboundDepartureTime(state),
	      paymentPlan: getPaymentPlan(state),
	      parkingPrice: (0, _utils.penceToPounds)(getParkingPrice(state)),
	      parkingType: getParkingType(state),
	      pricePerPerson: (0, _utils.penceToPounds)(getPricePerPerson(state)),
	      resort: getResort(state),
	      total: (0, _utils.penceToPounds)(getTotalNow(state)),
	      totalNow: (0, _utils.penceToPounds)(getTotalNow(state)),
	      totalWas: (0, _utils.penceToPounds)(getTotalWas(state)),
	      transactionId: getTransactionId(state),
	      transactionTotal: String(getTransactionTotal(state)),
	      transactionAffiliation: getTransactionAffiliation(bookType),
	      transferPrice: (0, _utils.penceToPounds)(getTransferPrice(state)),
	      transferType: getTransferType(state)
	    }),
	    userClass: (0, _dataLayerHelpers.getUserClassArray)(_LHX2.default.userClass)
	  };
	}
	
	var eventFactories = (_eventFactories = {}, (0, _defineProperty3.default)(_eventFactories, GTM_EVENT_NAMES.TRACK_TRANS, getTrackTransEvent), (0, _defineProperty3.default)(_eventFactories, GTM_EVENT_NAMES.TRACK_PURCHASE, getTrackPurchaseEvent), (0, _defineProperty3.default)(_eventFactories, GTM_EVENT_NAMES.TRACK_CONF, getTrackConfirmationEvent), (0, _defineProperty3.default)(_eventFactories, GTM_EVENT_NAMES.TRACK_LEAD_PASSENGER, getTrackLeadPassengerEvent), (0, _defineProperty3.default)(_eventFactories, GTM_EVENT_NAMES.TRACK_PRICE_TRACKER, getTrackPriceTrackerEvent), (0, _defineProperty3.default)(_eventFactories, GTM_EVENT_NAMES.TRACK_SHORTLIST_SUBMIT, getTrackShortlistSubmitEvent), (0, _defineProperty3.default)(_eventFactories, GTM_EVENT_NAMES.TRACK_PANDA, getTrackPandaEvent), _eventFactories);
	
	function fireEvent(eventName, state, shortRef, bookType) {
	  if (eventFactories[eventName]) {
	    var event = eventFactories[eventName](state, shortRef, bookType);
	    window.dataLayer = window.dataLayer || [];
	    window.dataLayer.push(event);
	  }
	}

/***/ },
/* 603 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getItem = getItem;
	exports.setItem = setItem;
	exports.removeItem = removeItem;
	var KEYS = exports.KEYS = {
	  shortlist: 'shortlist',
	  currentStateEncoded: 'currentStateEncoded',
	  currentStateEncodedTimestamp: 'currentStateEncodedTimestamp',
	  recentHotels: 'recentHotels',
	  recentSearches: 'recentSearches'
	};
	
	/* istanbul ignore next */
	function getItem(key) {
	  if (typeof key === 'undefined') {
	    throw new Error('LocalStorage key is undefined');
	  }
	
	  try {
	    return window.localStorage.getItem(key);
	  } catch (e) {
	    // This is to satisfy Safari in private mode: Message: SecurityError: DOM Exception 18
	  }
	}
	
	/* istanbul ignore next */
	function setItem(key, value) {
	  if (typeof key === 'undefined') {
	    throw new Error('LocalStorage key is undefined');
	  }
	
	  if (typeof value !== 'string' && typeof value !== 'number') {
	    throw new Error('LocalStorage value should be a string or a number');
	  }
	
	  try {
	    window.localStorage.setItem(key, value);
	  } catch (e) {
	    // Safari, in Private Browsing Mode, looks like it supports localStorage but all calls to setItem
	    // throw QuotaExceededError. We're going to detect this and just silently drop any calls to setItem
	    // to avoid the entire page breaking
	  }
	}
	
	/* istanbul ignore next */
	function removeItem(key) {
	  if (typeof key === 'undefined') {
	    throw new Error('LocalStorage key is undefined');
	  }
	
	  if (window.localStorage && window.localStorage.removeItem) {
	    window.localStorage.removeItem(key);
	  }
	}

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(1120);
	
	var _LHX = __webpack_require__(67);
	
	var _LHX2 = _interopRequireDefault(_LHX);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// raygun4js creates a global instance of Raygun on the window
	var Raygun = window.Raygun;
	
	/* eslint-disable */
	var internetExplorerJscriptVersion = new Function('/*@cc_on return @_jscript_version; @*/')();
	/*eslint-enable */
	var isUnsupportedJscriptVersion = typeof internetExplorerJscriptVersion !== 'undefined' && Number(internetExplorerJscriptVersion) < 11;
	
	var isRaygunEnabled = function isRaygunEnabled() {
	  return !isUnsupportedJscriptVersion && (_LHX2.default.environment === 'prod' || _LHX2.default.environment === 'staging');
	};
	var raygunAPIKey = _LHX2.default.environment === 'prod' ? 'AEjFXx0CivlITWTWI3wxKQ==' : 'WDHeyKeMiYXIyQsgXr01Pg==';
	var raygunOptions = {
	  ignoreAjaxAbort: true,
	  ignore3rdPartyErrors: true
	};
	
	if (isRaygunEnabled()) {
	  Raygun.init(raygunAPIKey, raygunOptions).attach().setVersion(_LHX2.default.version).saveIfOffline(true);
	}
	
	/* eslint-disable */
	if (false) {
	  var logMethod = console.warn ? 'warn' : 'log';
	  console[logMethod]('WARNING! Raygun error reporting is disabled for this browser');
	}
	/*eslint-enable */
	
	exports.default = {
	  sendError: function sendError(error) {
	    if (isRaygunEnabled()) {
	      Raygun.send(error);
	    }
	  }
	};

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.privateUtils = undefined;
	
	var _utils = __webpack_require__(8);
	
	var _dates = __webpack_require__(35);
	
	var _dates2 = _interopRequireDefault(_dates);
	
	var _immutable = __webpack_require__(9);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _searchUnit = __webpack_require__(140);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var privateUtils = {
	  getAnnualAvailabilityWithJustOneMonth: function getAnnualAvailabilityWithJustOneMonth(props, calDate) {
	    var annualAvailability = props.annualAvailability;
	
	    var calDateDate = _dates2.default.utcDate(calDate * _utils.dayInMilliseconds);
	    var selectedYear = calDateDate.getFullYear();
	    var selectedMonth = calDateDate.getMonth();
	    var monthAvailability = annualAvailability.getIn(['' + selectedYear, '' + selectedMonth]);
	    var annualAvailabilityJS = {};
	    annualAvailabilityJS[selectedYear] = {};
	    annualAvailabilityJS[selectedYear][selectedMonth] = monthAvailability;
	
	    return _immutable2.default.fromJS(annualAvailabilityJS);
	  },
	  isInRange: function isInRange(dayStamp, compareDayStamp, flex) {
	    return dayStamp >= compareDayStamp - flex && dayStamp <= compareDayStamp + flex;
	  },
	  getCheapestCalDate: function getCheapestCalDate(props) {
	    var _this = this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var availability = options.availability || props.annualAvailability;
	    var cheapestDay = {};
	
	    var yearKeys = availability.keySeq().toArray().filter(function (item) {
	      return Number(item);
	    });
	
	    yearKeys.sort().forEach(function (yearKey) {
	      var monthKeys = availability.get('' + yearKey).keySeq().toArray();
	
	      monthKeys.sort().forEach(function (monthKey) {
	        var annualAvailabilityMonth = availability.getIn(['' + yearKey, '' + monthKey]);
	
	        if (annualAvailabilityMonth) {
	          var dayKeys = annualAvailabilityMonth.keySeq().toArray();
	
	          dayKeys.sort().forEach(function (dayKey) {
	            var price = annualAvailabilityMonth.get('' + dayKey);
	            var date = Date.UTC(yearKey, monthKey, dayKey);
	            var dayStamp = date / _utils.dayInMilliseconds;
	
	            if (!options.flexibility || options.flexibility && _this.isInRange(options.deptDate, dayStamp, options.flexibility)) {
	              if (!cheapestDay.price || price && price < cheapestDay.price) {
	                cheapestDay.price = price;
	                cheapestDay.calDate = dayStamp;
	              }
	            }
	          });
	        }
	      });
	    });
	
	    return cheapestDay.calDate;
	  },
	  calculateCalDate: function calculateCalDate(props) {
	    var baseState = props.baseState;
	
	    var flexibility = baseState.getIn(['queryState', 'props', 'deptDateFlexibility', 'value']);
	    var calDate = void 0;
	
	    if (baseState.getIn(['queryState', 'props', 'calDate', 'selected'], false)) {
	      calDate = baseState.getIn(['queryState', 'props', 'calDate', 'value']);
	    }
	
	    if (!calDate && baseState.getIn(['queryState', 'props', 'deptDate', 'selected'])) {
	      calDate = baseState.getIn(['queryState', 'props', 'deptDate', 'value']);
	
	      if (calDate && flexibility === _searchUnit.MONTH_FLEXIBILITY_VALUE) {
	        var availability = this.getAnnualAvailabilityWithJustOneMonth(props, calDate);
	        calDate = this.getCheapestCalDate(props, { availability: availability });
	      } else if (calDate && flexibility && flexibility > 0) {
	        calDate = this.getCheapestCalDate(props, { deptDate: calDate, flexibility: flexibility });
	      }
	    }
	
	    // Cheapest day out of all months in all years
	    if (!calDate) {
	      calDate = this.getCheapestCalDate(props);
	    }
	
	    return calDate;
	  }
	};
	
	exports.privateUtils = privateUtils;
	
	
	var api = {
	  calculateCalDate: function calculateCalDate(props) {
	    return privateUtils.calculateCalDate(props);
	  },
	  calculateDPCalDate: function calculateDPCalDate(props) {
	    var location = props.location;
	
	    // calDate from path. caldate - in case caldate is lowercase in path
	
	    return location.query.calDate || location.query.caldate || privateUtils.calculateCalDate(props);
	  },
	  calculateFlightOnlyCalDate: function calculateFlightOnlyCalDate(props) {
	    return privateUtils.calculateCalDate(props);
	  }
	};
	
	exports.default = api;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.constants = undefined;
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(4);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var constants = exports.constants = {
	  TOUCHSTART: 'touchstart',
	  TOUCHMOVE: 'touchmove',
	  TOUCHEND: 'touchend'
	};
	
	var UserTouchController = function () {
	  function UserTouchController(element, _ref) {
	    var touchstartCallback = _ref.touchstartCallback,
	        touchmoveCallback = _ref.touchmoveCallback,
	        touchendCallback = _ref.touchendCallback,
	        _ref$tolerance = _ref.tolerance,
	        tolerance = _ref$tolerance === undefined ? 5 : _ref$tolerance;
	    (0, _classCallCheck3.default)(this, UserTouchController);
	
	    this.element = element;
	    this.touchstart = touchstartCallback;
	    this.touchmove = touchmoveCallback;
	    this.touchend = touchendCallback;
	    this.tolerance = tolerance;
	  }
	
	  (0, _createClass3.default)(UserTouchController, [{
	    key: 'trackTouchPosition',
	    value: function trackTouchPosition(event, type) {
	      this['xCoordinate' + type] = event.touches[0].pageX;
	      this['yCoordinate' + type] = event.touches[0].pageY;
	    }
	
	    /* istanbul ignore next */
	
	  }, {
	    key: 'trackTouchDirection',
	    value: function trackTouchDirection() {
	      this.xDirection = this.calculateXDirection();
	      this.yDirection = this.calculateYDirection();
	      this.isStationary = this.calculateIsStationary();
	    }
	  }, {
	    key: 'calculateXDirection',
	    value: function calculateXDirection() {
	      var direction = void 0;
	
	      if (this.xCoordinateStart <= this.xCoordinateLatest) {
	        direction = 'right';
	      } else {
	        direction = 'left';
	      }
	
	      return direction;
	    }
	  }, {
	    key: 'calculateYDirection',
	    value: function calculateYDirection() {
	      var direction = void 0;
	
	      if (this.yCoordinateStart <= this.yCoordinateLatest) {
	        direction = 'down';
	      } else {
	        direction = 'up';
	      }
	
	      return direction;
	    }
	  }, {
	    key: 'calculateIsStationary',
	    value: function calculateIsStationary() {
	      var isStationary = void 0;
	
	      if (Math.abs(this.xCoordinateStart - this.xCoordinateLatest) <= this.tolerance && Math.abs(this.yCoordinateStart - this.yCoordinateLatest) <= this.tolerance) {
	        isStationary = true;
	      } else {
	        isStationary = false;
	      }
	
	      return isStationary;
	    }
	  }, {
	    key: 'onTouchStart',
	    value: function onTouchStart(event) {
	      this.trackTouchPosition(event, 'Start');
	      this.trackTouchPosition(event, 'Latest');
	
	      if (this.touchstart) {
	        this.touchstart(event);
	      }
	    }
	  }, {
	    key: 'onTouchMove',
	    value: function onTouchMove(event) {
	      this.trackTouchPosition(event, 'Latest');
	
	      if (this.touchmove) {
	        this.touchmove(event);
	      }
	    }
	  }, {
	    key: 'onTouchEnd',
	    value: function onTouchEnd(event) {
	      this.trackTouchDirection();
	
	      if (this.touchend) {
	        this.touchend(event);
	      }
	    }
	  }, {
	    key: 'addEventListeners',
	    value: function addEventListeners() {
	      this.element.addEventListener(constants.TOUCHSTART, this.onTouchStart.bind(this));
	      this.element.addEventListener(constants.TOUCHMOVE, this.onTouchMove.bind(this));
	      this.element.addEventListener(constants.TOUCHEND, this.onTouchEnd.bind(this));
	    }
	  }, {
	    key: 'removeEventListeners',
	    value: function removeEventListeners() {
	      /* istanbul ignore next */
	      this.element.removeEventListener(constants.TOUCHSTART, this.onTouchStart.bind(this));
	      this.element.removeEventListener(constants.TOUCHMOVE, this.onTouchMove.bind(this));
	      this.element.removeEventListener(constants.TOUCHEND, this.onTouchEnd.bind(this));
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.removeEventListeners();
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      this.addEventListeners();
	    }
	  }]);
	  return UserTouchController;
	}();
	
	exports.default = UserTouchController;

/***/ },
/* 607 */,
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(616), __esModule: true };

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(618), __esModule: true };

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(619), __esModule: true };

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(621), __esModule: true };

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(625), __esModule: true };

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(628), __esModule: true };

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(629), __esModule: true };

/***/ },
/* 615 */,
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(149);
	__webpack_require__(653);
	module.exports = __webpack_require__(31).Array.from;


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(172);
	__webpack_require__(149);
	module.exports = __webpack_require__(651);


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(172);
	__webpack_require__(149);
	module.exports = __webpack_require__(652);


/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(31);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(655);
	module.exports = __webpack_require__(31).Object.assign;


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(656);
	var $Object = __webpack_require__(31).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(657);
	var $Object = __webpack_require__(31).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(658);
	module.exports = __webpack_require__(31).Object.getPrototypeOf;


/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(659);
	module.exports = __webpack_require__(31).Object.keys;


/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(660);
	module.exports = __webpack_require__(31).Object.setPrototypeOf;


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(663);
	module.exports = __webpack_require__(31).Object.values;


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(346);
	__webpack_require__(149);
	__webpack_require__(172);
	__webpack_require__(661);
	__webpack_require__(664);
	__webpack_require__(665);
	module.exports = __webpack_require__(31).Promise;


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(662);
	__webpack_require__(346);
	__webpack_require__(666);
	__webpack_require__(667);
	module.exports = __webpack_require__(31).Symbol;


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(149);
	__webpack_require__(172);
	module.exports = __webpack_require__(232).f('iterator');


/***/ },
/* 630 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 631 */
100,
/* 632 */
[1372, 99, 229, 650],
/* 633 */
[1374, 80, 147],
/* 634 */
[1378, 124, 225, 146],
/* 635 */
[1379, 121, 333, 332, 68, 229, 233],
/* 636 */
357,
/* 637 */
[1385, 145],
/* 638 */
[1387, 224, 147, 170, 97, 38],
/* 639 */
360,
/* 640 */
[1390, 171, 98, 96, 80, 122],
/* 641 */
[1391, 41, 345, 145],
/* 642 */
[1393, 124, 225, 146, 148, 331, 122],
/* 643 */
[1396, 80, 68, 124, 88],
/* 644 */
[1398, 99, 337],
/* 645 */
[1404, 124, 99, 146],
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(97);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ },
/* 647 */
[1406, 98, 68, 121, 336],
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(41);
	var core = __webpack_require__(31);
	var dP = __webpack_require__(80);
	var DESCRIPTORS = __webpack_require__(88);
	var SPECIES = __webpack_require__(38)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 649 */
[1411, 228, 220],
/* 650 */
[1413, 228],
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(68);
	var get = __webpack_require__(233);
	module.exports = __webpack_require__(31).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(219);
	var ITERATOR = __webpack_require__(38)('iterator');
	var Iterators = __webpack_require__(123);
	module.exports = __webpack_require__(31).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ },
/* 653 */
[1422, 121, 49, 148, 333, 332, 229, 633, 233, 335],
/* 654 */
[1423, 630, 639, 123, 99, 334],
/* 655 */
[1424, 49, 642],
/* 656 */
[1425, 49, 224],
/* 657 */
[1426, 49, 88, 80],
/* 658 */
[1427, 148, 338, 340],
/* 659 */
[1428, 148, 124, 340],
/* 660 */
[1429, 49, 647],
/* 661 */
[1430, 169, 41, 121, 219, 49, 98, 168, 631, 635, 344, 345, 641, 223, 341, 342, 38, 646, 170, 648, 31, 335],
/* 662 */
[1432, 41, 96, 88, 49, 343, 640, 122, 227, 170, 171, 38, 232, 231, 634, 637, 68, 99, 230, 147, 224, 644, 336, 80, 124, 337, 146, 225, 169, 97],
/* 663 */
[1433, 49, 645],
/* 664 */
[1434, 49, 31, 41, 344, 342],
/* 665 */
[1435, 49, 223, 341],
/* 666 */
[1436, 231],
/* 667 */
[1437, 231],
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(381);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 868 */
/***/ function(module, exports) {

	(function() {
	  var base64map
	      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
	
	  crypt = {
	    // Bit-wise rotation left
	    rotl: function(n, b) {
	      return (n << b) | (n >>> (32 - b));
	    },
	
	    // Bit-wise rotation right
	    rotr: function(n, b) {
	      return (n << (32 - b)) | (n >>> b);
	    },
	
	    // Swap big-endian to little-endian and vice versa
	    endian: function(n) {
	      // If number given, swap endian
	      if (n.constructor == Number) {
	        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
	      }
	
	      // Else, assume array and swap all items
	      for (var i = 0; i < n.length; i++)
	        n[i] = crypt.endian(n[i]);
	      return n;
	    },
	
	    // Generate an array of any length of random bytes
	    randomBytes: function(n) {
	      for (var bytes = []; n > 0; n--)
	        bytes.push(Math.floor(Math.random() * 256));
	      return bytes;
	    },
	
	    // Convert a byte array to big-endian 32-bit words
	    bytesToWords: function(bytes) {
	      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
	        words[b >>> 5] |= bytes[i] << (24 - b % 32);
	      return words;
	    },
	
	    // Convert big-endian 32-bit words to a byte array
	    wordsToBytes: function(words) {
	      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
	        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a hex string
	    bytesToHex: function(bytes) {
	      for (var hex = [], i = 0; i < bytes.length; i++) {
	        hex.push((bytes[i] >>> 4).toString(16));
	        hex.push((bytes[i] & 0xF).toString(16));
	      }
	      return hex.join('');
	    },
	
	    // Convert a hex string to a byte array
	    hexToBytes: function(hex) {
	      for (var bytes = [], c = 0; c < hex.length; c += 2)
	        bytes.push(parseInt(hex.substr(c, 2), 16));
	      return bytes;
	    },
	
	    // Convert a byte array to a base-64 string
	    bytesToBase64: function(bytes) {
	      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
	        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
	        for (var j = 0; j < 4; j++)
	          if (i * 8 + j * 6 <= bytes.length * 8)
	            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
	          else
	            base64.push('=');
	      }
	      return base64.join('');
	    },
	
	    // Convert a base-64 string to a byte array
	    base64ToBytes: function(base64) {
	      // Remove non-base-64 characters
	      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
	
	      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
	          imod4 = ++i % 4) {
	        if (imod4 == 0) continue;
	        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
	            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
	            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
	      }
	      return bytes;
	    }
	  };
	
	  module.exports = crypt;
	})();


/***/ },
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _extendableBuiltin(cls) {
	  function ExtendableBuiltin() {
	    cls.apply(this, arguments);
	  }
	
	  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
	    constructor: {
	      value: cls,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (Object.setPrototypeOf) {
	    Object.setPrototypeOf(ExtendableBuiltin, cls);
	  } else {
	    ExtendableBuiltin.__proto__ = cls;
	  }
	
	  return ExtendableBuiltin;
	}
	
	var ExtendableError = function (_extendableBuiltin2) {
	  _inherits(ExtendableError, _extendableBuiltin2);
	
	  function ExtendableError() {
	    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    _classCallCheck(this, ExtendableError);
	
	    // extending Error is weird and does not propagate `message`
	    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));
	
	    Object.defineProperty(_this, 'message', {
	      configurable: true,
	      enumerable: false,
	      value: message,
	      writable: true
	    });
	
	    Object.defineProperty(_this, 'name', {
	      configurable: true,
	      enumerable: false,
	      value: _this.constructor.name,
	      writable: true
	    });
	
	    if (Error.hasOwnProperty('captureStackTrace')) {
	      Error.captureStackTrace(_this, _this.constructor);
	      return _possibleConstructorReturn(_this);
	    }
	
	    Object.defineProperty(_this, 'stack', {
	      configurable: true,
	      enumerable: false,
	      value: new Error(message).stack,
	      writable: true
	    });
	    return _this;
	  }
	
	  return ExtendableError;
	}(_extendableBuiltin(Error));
	
	exports.default = ExtendableError;
	module.exports = exports['default'];


/***/ },
/* 873 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"AirlineSeat__react-django-template___-hash--base64-5-"};

/***/ },
/* 874 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"PassengerList__react-django-template___-hash--base64-5-"};

/***/ },
/* 875 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"PassengerListFlight__react-django-template___-hash--base64-5-"};

/***/ },
/* 876 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"PassengerSeat__react-django-template___-hash--base64-5-"};

/***/ },
/* 877 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SeatList__react-django-template___-hash--base64-5-"};

/***/ },
/* 878 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SeatListModal__react-django-template___-hash--base64-5-"};

/***/ },
/* 879 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SeatListNavigationHeader__react-django-template___-hash--base64-5-"};

/***/ },
/* 880 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SeatListRow__react-django-template___-hash--base64-5-"};

/***/ },
/* 881 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SeatListRowHeader__react-django-template___-hash--base64-5-"};

/***/ },
/* 882 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SeatListRowPriceHeader__react-django-template___-hash--base64-5-"};

/***/ },
/* 883 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SeatListSeat__react-django-template___-hash--base64-5-"};

/***/ },
/* 884 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"AssistedBookingStatus__react-django-template___-hash--base64-5-"};

/***/ },
/* 885 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"AssistedBookingStatusModal__react-django-template___-hash--base64-5-"};

/***/ },
/* 886 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"Autocomplete__react-django-template___-hash--base64-5-"};

/***/ },
/* 887 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"AutocompleteCheckboxOption__react-django-template___-hash--base64-5-"};

/***/ },
/* 888 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"AutocompleteQueryTextHighlightOption__react-django-template___-hash--base64-5-"};

/***/ },
/* 889 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"BookCheckbox__react-django-template___-hash--base64-5-"};

/***/ },
/* 890 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"BookInput__react-django-template___-hash--base64-5-"};

/***/ },
/* 891 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"BookPrice__react-django-template___-hash--base64-5-"};

/***/ },
/* 892 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"BookSelect__react-django-template___-hash--base64-5-"};

/***/ },
/* 893 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"BookSupplierPrincipals__react-django-template___-hash--base64-5-"};

/***/ },
/* 894 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"CarFeatureList-desktop__react-django-template___-hash--base64-5-"};

/***/ },
/* 895 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"CarFeatureList-mobile__react-django-template___-hash--base64-5-"};

/***/ },
/* 896 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"CarHireOption-desktop__react-django-template___-hash--base64-5-"};

/***/ },
/* 897 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"CarHireOption-mobile__react-django-template___-hash--base64-5-"};

/***/ },
/* 898 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"CarHireOptionsHeader-desktop__react-django-template___-hash--base64-5-"};

/***/ },
/* 899 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"CarHireOptionsHeader-mobile__react-django-template___-hash--base64-5-"};

/***/ },
/* 900 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"CarHireOptionsList__react-django-template___-hash--base64-5-"};

/***/ },
/* 901 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"CarHireProviderLogo__react-django-template___-hash--base64-5-"};

/***/ },
/* 902 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"CarHireTermsAndConditions-desktop__react-django-template___-hash--base64-5-"};

/***/ },
/* 903 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"CarHireTermsAndConditions-mobile__react-django-template___-hash--base64-5-"};

/***/ },
/* 904 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"HireCarInfo-desktop__react-django-template___-hash--base64-5-"};

/***/ },
/* 905 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"HireCarInfo-mobile__react-django-template___-hash--base64-5-"};

/***/ },
/* 906 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"Carousel__react-django-template___-hash--base64-5-"};

/***/ },
/* 907 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"CollapsiblePanel__react-django-template___-hash--base64-5-"};

/***/ },
/* 908 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"CustomControl__react-django-template___-hash--base64-5-"};

/***/ },
/* 909 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"CustomControlPopoverWrapper__react-django-template___-hash--base64-5-"};

/***/ },
/* 910 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"DatePickerWithPrices__react-django-template___-hash--base64-5-"};

/***/ },
/* 911 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"DuplicateNamesModal-desktop__react-django-template___-hash--base64-5-"};

/***/ },
/* 912 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"DuplicateNamesModal-mobile__react-django-template___-hash--base64-5-"};

/***/ },
/* 913 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"EmailDeal-desktop__react-django-template___-hash--base64-5-"};

/***/ },
/* 914 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"EmailDeal-mobile__react-django-template___-hash--base64-5-"};

/***/ },
/* 915 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"EmailDealResult__react-django-template___-hash--base64-5-"};

/***/ },
/* 916 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"EmailSignUp__react-django-template___-hash--base64-5-"};

/***/ },
/* 917 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"FauxSelect__react-django-template___-hash--base64-5-"};

/***/ },
/* 918 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"FormInputWithValidation__react-django-template___-hash--base64-5-"};

/***/ },
/* 919 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"Input__react-django-template___-hash--base64-5-"};

/***/ },
/* 920 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"LinkButton__react-django-template___-hash--base64-5-"};

/***/ },
/* 921 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"LinkInput__react-django-template___-hash--base64-5-"};

/***/ },
/* 922 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"Loading__react-django-template___-hash--base64-5-"};

/***/ },
/* 923 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"Modal__react-django-template___-hash--base64-5-"};

/***/ },
/* 924 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SlideInFromTheSideModal__react-django-template___-hash--base64-5-"};

/***/ },
/* 925 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"MonthCalendar__react-django-template___-hash--base64-5-"};

/***/ },
/* 926 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"OpeningHoursModal__react-django-template___-hash--base64-5-"};

/***/ },
/* 927 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"Overlay__react-django-template___-hash--base64-5-"};

/***/ },
/* 928 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"PandaCalendar__react-django-template___-hash--base64-5-"};

/***/ },
/* 929 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"Popover__react-django-template___-hash--base64-5-"};

/***/ },
/* 930 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"PriceTrackerSummary__react-django-template___-hash--base64-5-"};

/***/ },
/* 931 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"ResponsiveGallery__react-django-template___-hash--base64-5-"};

/***/ },
/* 932 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SearchUnitCustomControlCalendar__react-django-template___-hash--base64-5-"};

/***/ },
/* 933 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SearchUnitCustomControlCalendarDay__react-django-template___-hash--base64-5-"};

/***/ },
/* 934 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SearchUnitCustomControlCalendarToggle-desktop__react-django-template___-hash--base64-5-"};

/***/ },
/* 935 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SearchUnitCustomControlCalendarToggle-mobile__react-django-template___-hash--base64-5-"};

/***/ },
/* 936 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SearchUnitDepartureAirport__react-django-template___-hash--base64-5-"};

/***/ },
/* 937 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SearchUnitDestination__react-django-template___-hash--base64-5-"};

/***/ },
/* 938 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SearchUnitHeader__react-django-template___-hash--base64-5-"};

/***/ },
/* 939 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SearchUnitHotelName__react-django-template___-hash--base64-5-"};

/***/ },
/* 940 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SearchUnitPopOver__react-django-template___-hash--base64-5-"};

/***/ },
/* 941 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SearchUnitRooms__react-django-template___-hash--base64-5-"};

/***/ },
/* 942 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"Slideshow__react-django-template___-hash--base64-5-"};

/***/ },
/* 943 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SubpageMasthead__react-django-template___-hash--base64-5-"};

/***/ },
/* 944 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"Tag__react-django-template___-hash--base64-5-"};

/***/ },
/* 945 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"Toggle__react-django-template___-hash--base64-5-"};

/***/ },
/* 946 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"BookFreeHotelAmendsLayout-desktop__react-django-template___-hash--base64-5-"};

/***/ },
/* 947 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"BookFreeHotelAmendsLayout-mobile__react-django-template___-hash--base64-5-"};

/***/ },
/* 948 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"BookHandLuggageModalLayout-desktop__react-django-template___-hash--base64-5-"};

/***/ },
/* 949 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"BookHandLuggageModalLayout-mobile__react-django-template___-hash--base64-5-"};

/***/ },
/* 950 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"BookTransferReminderLayout__react-django-template___-hash--base64-5-"};

/***/ },
/* 951 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"CustomControlWrapper__react-django-template___-hash--base64-5-"};

/***/ },
/* 952 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"LoadingOverlayLayout__react-django-template___-hash--base64-5-"};

/***/ },
/* 953 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"ModalLayout-desktop__react-django-template___-hash--base64-5-"};

/***/ },
/* 954 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"NotificationsLayout__react-django-template___-hash--base64-5-"};

/***/ },
/* 955 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"PopoverTrigger__react-django-template___-hash--base64-5-"};

/***/ },
/* 956 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"PriceTrackerSignUpLayout-desktop__react-django-template___-hash--base64-5-"};

/***/ },
/* 957 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"PriceTrackerSignUpLayout-mobile__react-django-template___-hash--base64-5-"};

/***/ },
/* 958 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"RoomFacilitiesOverlayLayout-desktop__react-django-template___-hash--base64-5-"};

/***/ },
/* 959 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"RoomFacilitiesOverlayLayout-mobile__react-django-template___-hash--base64-5-"};

/***/ },
/* 960 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"RoomOptionsLayout__react-django-template___-hash--base64-5-"};

/***/ },
/* 961 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SearchUnitDepartureDateLayout__react-django-template___-hash--base64-5-"};

/***/ },
/* 962 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SearchUnitHotelNameLayout__react-django-template___-hash--base64-5-"};

/***/ },
/* 963 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SearchUnitStandaloneHotelLayout__react-django-template___-hash--base64-5-"};

/***/ },
/* 964 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-django-template":"SearchUnitStandaloneLayout__react-django-template___-hash--base64-5-"};

/***/ },
/* 965 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 966 */
965,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */
/***/ function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ },
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(114),
	    root = __webpack_require__(75);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1040),
	    hashDelete = __webpack_require__(1041),
	    hashGet = __webpack_require__(1042),
	    hashHas = __webpack_require__(1043),
	    hashSet = __webpack_require__(1044);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(114),
	    root = __webpack_require__(75);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(114),
	    root = __webpack_require__(75);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(266),
	    setCacheAdd = __webpack_require__(1066),
	    setCacheHas = __webpack_require__(1067);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(114),
	    root = __webpack_require__(75);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 995 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 996 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 997 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 998 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(192),
	    eq = __webpack_require__(155);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(91);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(401),
	    keys = __webpack_require__(279);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(997),
	    isArray = __webpack_require__(76);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 1003 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(130),
	    isObjectLike = __webpack_require__(115);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(267),
	    equalArrays = __webpack_require__(406),
	    equalByTag = __webpack_require__(1031),
	    equalObjects = __webpack_require__(1032),
	    getTag = __webpack_require__(1037),
	    isArray = __webpack_require__(76),
	    isBuffer = __webpack_require__(274),
	    isTypedArray = __webpack_require__(278);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(267),
	    baseIsEqual = __webpack_require__(268);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(276),
	    isMasked = __webpack_require__(1048),
	    isObject = __webpack_require__(91),
	    toSource = __webpack_require__(413);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(130),
	    isLength = __webpack_require__(277),
	    isObjectLike = __webpack_require__(115);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1012),
	    baseMatchesProperty = __webpack_require__(1013),
	    identity = __webpack_require__(272),
	    isArray = __webpack_require__(76),
	    property = __webpack_require__(1082);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(271),
	    nativeKeys = __webpack_require__(1061);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(91),
	    isPrototype = __webpack_require__(271),
	    nativeKeysIn = __webpack_require__(1062);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1006),
	    getMatchData = __webpack_require__(1034),
	    matchesStrictComparable = __webpack_require__(410);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(268),
	    get = __webpack_require__(1077),
	    hasIn = __webpack_require__(1078),
	    isKey = __webpack_require__(270),
	    isStrictComparable = __webpack_require__(409),
	    matchesStrictComparable = __webpack_require__(410),
	    toKey = __webpack_require__(154);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(267),
	    assignMergeValue = __webpack_require__(400),
	    baseFor = __webpack_require__(401),
	    baseMergeDeep = __webpack_require__(1015),
	    isObject = __webpack_require__(91),
	    keysIn = __webpack_require__(414);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(400),
	    cloneBuffer = __webpack_require__(1025),
	    cloneTypedArray = __webpack_require__(1026),
	    copyArray = __webpack_require__(404),
	    initCloneObject = __webpack_require__(1045),
	    isArguments = __webpack_require__(273),
	    isArray = __webpack_require__(76),
	    isArrayLikeObject = __webpack_require__(1079),
	    isBuffer = __webpack_require__(274),
	    isFunction = __webpack_require__(276),
	    isObject = __webpack_require__(91),
	    isPlainObject = __webpack_require__(196),
	    isTypedArray = __webpack_require__(278),
	    toPlainObject = __webpack_require__(1085);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ },
/* 1016 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(402);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(272),
	    overRest = __webpack_require__(1065),
	    setToString = __webpack_require__(1069);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1076),
	    defineProperty = __webpack_require__(405),
	    identity = __webpack_require__(272);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 1020 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(190),
	    arrayMap = __webpack_require__(399),
	    isArray = __webpack_require__(76),
	    isSymbol = __webpack_require__(197);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 1022 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 1023 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(397);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(75);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205)(module)))

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(1024);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(999),
	    baseAssignValue = __webpack_require__(192);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(75);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(1018),
	    isIterateeCall = __webpack_require__(1046);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 1030 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(190),
	    Uint8Array = __webpack_require__(397),
	    eq = __webpack_require__(155),
	    equalArrays = __webpack_require__(406),
	    mapToArray = __webpack_require__(1059),
	    setToArray = __webpack_require__(1068);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(1033);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(1002),
	    getSymbols = __webpack_require__(1036),
	    keys = __webpack_require__(279);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(409),
	    keys = __webpack_require__(279);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 1035 */,
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(996),
	    stubArray = __webpack_require__(1083);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(989),
	    Map = __webpack_require__(265),
	    Promise = __webpack_require__(991),
	    Set = __webpack_require__(992),
	    WeakMap = __webpack_require__(994),
	    baseGetTag = __webpack_require__(130),
	    toSource = __webpack_require__(413);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 1038 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(403),
	    isArguments = __webpack_require__(273),
	    isArray = __webpack_require__(76),
	    isIndex = __webpack_require__(269),
	    isLength = __webpack_require__(277),
	    toKey = __webpack_require__(154);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(194);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 1041 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(194);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(194);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(194);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(1000),
	    getPrototype = __webpack_require__(408),
	    isPrototype = __webpack_require__(271);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(155),
	    isArrayLike = __webpack_require__(195),
	    isIndex = __webpack_require__(269),
	    isObject = __webpack_require__(91);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 1047 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1028);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 1049 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(191);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(191);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(191);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(191);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(990),
	    ListCache = __webpack_require__(189),
	    Map = __webpack_require__(265);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(193);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(193);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(193);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(193);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 1059 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1080);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(411);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 1062 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(407);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205)(module)))

/***/ },
/* 1064 */,
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(995);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 1066 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 1067 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 1068 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(1019),
	    shortOut = __webpack_require__(1070);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 1070 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(189);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 1072 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 1073 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 1074 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(189),
	    Map = __webpack_require__(265),
	    MapCache = __webpack_require__(266);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 1076 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(402);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1003),
	    hasPath = __webpack_require__(1039);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(195),
	    isObjectLike = __webpack_require__(115);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(266);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(1014),
	    createAssigner = __webpack_require__(1029);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1016),
	    basePropertyDeep = __webpack_require__(1017),
	    isKey = __webpack_require__(270),
	    toKey = __webpack_require__(154);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 1083 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 1084 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(1027),
	    keysIn = __webpack_require__(414);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	(function(){
	  var crypt = __webpack_require__(868),
	      utf8 = __webpack_require__(328).utf8,
	      isBuffer = __webpack_require__(985),
	      bin = __webpack_require__(328).bin,
	
	  // The core
	  md5 = function (message, options) {
	    // Convert to byte array
	    if (message.constructor == String)
	      if (options && options.encoding === 'binary')
	        message = bin.stringToBytes(message);
	      else
	        message = utf8.stringToBytes(message);
	    else if (isBuffer(message))
	      message = Array.prototype.slice.call(message, 0);
	    else if (!Array.isArray(message))
	      message = message.toString();
	    // else, assume byte array already
	
	    var m = crypt.bytesToWords(message),
	        l = message.length * 8,
	        a =  1732584193,
	        b = -271733879,
	        c = -1732584194,
	        d =  271733878;
	
	    // Swap endian
	    for (var i = 0; i < m.length; i++) {
	      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
	             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
	    }
	
	    // Padding
	    m[l >>> 5] |= 0x80 << (l % 32);
	    m[(((l + 64) >>> 9) << 4) + 14] = l;
	
	    // Method shortcuts
	    var FF = md5._ff,
	        GG = md5._gg,
	        HH = md5._hh,
	        II = md5._ii;
	
	    for (var i = 0; i < m.length; i += 16) {
	
	      var aa = a,
	          bb = b,
	          cc = c,
	          dd = d;
	
	      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
	      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
	      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
	      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
	      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
	      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
	      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
	      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
	      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
	      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
	      c = FF(c, d, a, b, m[i+10], 17, -42063);
	      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
	      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
	      d = FF(d, a, b, c, m[i+13], 12, -40341101);
	      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
	      b = FF(b, c, d, a, m[i+15], 22,  1236535329);
	
	      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
	      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
	      c = GG(c, d, a, b, m[i+11], 14,  643717713);
	      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
	      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
	      d = GG(d, a, b, c, m[i+10],  9,  38016083);
	      c = GG(c, d, a, b, m[i+15], 14, -660478335);
	      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
	      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
	      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
	      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
	      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
	      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
	      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
	      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
	      b = GG(b, c, d, a, m[i+12], 20, -1926607734);
	
	      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
	      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
	      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
	      b = HH(b, c, d, a, m[i+14], 23, -35309556);
	      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
	      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
	      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
	      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
	      a = HH(a, b, c, d, m[i+13],  4,  681279174);
	      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
	      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
	      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
	      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
	      d = HH(d, a, b, c, m[i+12], 11, -421815835);
	      c = HH(c, d, a, b, m[i+15], 16,  530742520);
	      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);
	
	      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
	      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
	      c = II(c, d, a, b, m[i+14], 15, -1416354905);
	      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
	      a = II(a, b, c, d, m[i+12],  6,  1700485571);
	      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
	      c = II(c, d, a, b, m[i+10], 15, -1051523);
	      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
	      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
	      d = II(d, a, b, c, m[i+15], 10, -30611744);
	      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
	      b = II(b, c, d, a, m[i+13], 21,  1309151649);
	      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
	      d = II(d, a, b, c, m[i+11], 10, -1120210379);
	      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
	      b = II(b, c, d, a, m[i+ 9], 21, -343485551);
	
	      a = (a + aa) >>> 0;
	      b = (b + bb) >>> 0;
	      c = (c + cc) >>> 0;
	      d = (d + dd) >>> 0;
	    }
	
	    return crypt.endian([a, b, c, d]);
	  };
	
	  // Auxiliary functions
	  md5._ff  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._gg  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._hh  = function (a, b, c, d, x, s, t) {
	    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._ii  = function (a, b, c, d, x, s, t) {
	    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	
	  // Package private blocksize
	  md5._blocksize = 16;
	  md5._digestsize = 16;
	
	  module.exports = function (message, options) {
	    if (message === undefined || message === null)
	      throw new Error('Illegal argument ' + message);
	
	    var digestbytes = crypt.wordsToBytes(md5(message, options));
	    return options && options.asBytes ? digestbytes :
	        options && options.asString ? bin.bytesToString(digestbytes) :
	        crypt.bytesToHex(digestbytes);
	  };
	
	})();


/***/ },
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! Raygun4js - v2.5.3 - 2017-02-14
	* https://github.com/MindscapeHQ/raygun4js
	* Copyright (c) 2017 MindscapeHQ; Licensed MIT */
	// https://github.com/umdjs/umd/blob/master/templates/returnExportsGlobal.js
	
	(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return (root.Raygun = factory());
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = factory();
	    } else {
	        // Browser globals
	        root.Raygun = factory();
	    }
	}(this, function () {
	
	  var windw = this;
	
	  // Similar approach as the snippet, creates the rg4js proxy function, which is exported in umd.outro.js once the
	  // script is executed, and later overwritten by the loader once it's finished
	  (function(wind) { wind['RaygunObject'] = 'rg4js';
	  wind[wind['RaygunObject']] = wind[wind['RaygunObject']] || function() {
	      if (wind && typeof wind['Raygun'] === 'undefined' || document.readyState !== 'complete') {
	        // onload hasn't been called, cache the commands just like the snippet
	        (wind[wind['RaygunObject']].o = wind[wind['RaygunObject']].o || []).push(arguments)
	      } else {
	        // onload has been called and provider has executed, call the executor proxy function
	        wind[wind['RaygunObject']](arguments[0], arguments[1]);
	      }
	      
	  }})(windw);
	(function(window, undefined) {
	
	
	var TraceKit = {};
	var _oldTraceKit = window.TraceKit;
	
	// global reference to slice
	var _slice = [].slice;
	var UNKNOWN_FUNCTION = '?';
	
	
	/**
	 * _has, a better form of hasOwnProperty
	 * Example: _has(MainHostObject, property) === true/false
	 *
	 * @param {Object} host object to check property
	 * @param {string} key to check
	 */
	function _has(object, key) {
	    return Object.prototype.hasOwnProperty.call(object, key);
	}
	
	function _isUndefined(what) {
	    return typeof what === 'undefined';
	}
	
	/**
	 * TraceKit.noConflict: Export TraceKit out to another variable
	 * Example: var TK = TraceKit.noConflict()
	 */
	TraceKit.noConflict = function noConflict() {
	    window.TraceKit = _oldTraceKit;
	    return TraceKit;
	};
	
	/**
	 * TraceKit.wrap: Wrap any function in a TraceKit reporter
	 * Example: func = TraceKit.wrap(func);
	 *
	 * @param {Function} func Function to be wrapped
	 * @return {Function} The wrapped func
	 */
	TraceKit.wrap = function traceKitWrapper(func) {
	    function wrapped() {
	        try {
	            return func.apply(this, arguments);
	        } catch (e) {
	            TraceKit.report(e);
	            throw e;
	        }
	    }
	    return wrapped;
	};
	
	/**
	 * TraceKit.report: cross-browser processing of unhandled exceptions
	 *
	 * Syntax:
	 *   TraceKit.report.subscribe(function(stackInfo) { ... })
	 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
	 *   TraceKit.report(exception)
	 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
	 *
	 * Supports:
	 *   - Firefox: full stack trace with line numbers, plus column number
	 *              on top frame; column number is not guaranteed
	 *   - Opera:   full stack trace with line and column numbers
	 *   - Chrome:  full stack trace with line and column numbers
	 *   - Safari:  line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *   - IE:      line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *
	 * In theory, TraceKit should work on all of the following versions:
	 *   - IE5.5+ (only 8.0 tested)
	 *   - Firefox 0.9+ (only 3.5+ tested)
	 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
	 *     Exceptions Have Stacktrace to be enabled in opera:config)
	 *   - Safari 3+ (only 4+ tested)
	 *   - Chrome 1+ (only 5+ tested)
	 *   - Konqueror 3.5+ (untested)
	 *
	 * Requires TraceKit.computeStackTrace.
	 *
	 * Tries to catch all unhandled exceptions and report them to the
	 * subscribed handlers. Please note that TraceKit.report will rethrow the
	 * exception. This is REQUIRED in order to get a useful stack trace in IE.
	 * If the exception does not reach the top of the browser, you will only
	 * get a stack trace from the point where TraceKit.report was called.
	 *
	 * Handlers receive a stackInfo object as described in the
	 * TraceKit.computeStackTrace docs.
	 */
	TraceKit.report = (function reportModuleWrapper() {
	    var handlers = [],
	        lastException = null,
	        lastExceptionStack = null;
	
	    /**
	     * Add a crash handler.
	     * @param {Function} handler
	     */
	    function subscribe(handler) {
	        installGlobalHandler();
	        handlers.push(handler);
	    }
	
	    /**
	     * Remove a crash handler.
	     * @param {Function} handler
	     */
	    function unsubscribe(handler) {
	        for (var i = handlers.length - 1; i >= 0; --i) {
	            if (handlers[i] === handler) {
	                handlers.splice(i, 1);
	            }
	        }
	    }
	
	    /**
	     * Dispatch stack information to all handlers.
	     * @param {Object.<string, *>} stack
	     */
	    function notifyHandlers(stack, windowError) {
	        var exception = null;
	        if (windowError && !TraceKit.collectWindowErrors) {
	          return;
	        }
	        for (var i in handlers) {
	            if (_has(handlers, i)) {
	                try {
	                    handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
	                } catch (inner) {
	                    exception = inner;
	                }
	            }
	        }
	
	        if (exception) {
	            throw exception;
	        }
	    }
	
	    var _oldOnerrorHandler, _onErrorHandlerInstalled;
	
	    /**
	     * Ensures all global unhandled exceptions are recorded.
	     * Supported by Gecko and IE.
	     * @param {string} message Error message.
	     * @param {string} url URL of script that generated the exception.
	     * @param {(number|string)} lineNo The line number at which the error
	     * occurred.
	     */
	    function traceKitWindowOnError(message, url, lineNo, columnNo, errorObj) {
	        var stack = null;
	
	        if (errorObj) {
	          stack = TraceKit.computeStackTrace(errorObj);
	        }
	        else
	        {
	            if (lastExceptionStack) {
	                TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
	                stack = lastExceptionStack;
	                lastExceptionStack = null;
	                lastException = null;
	            } else {
	                var location = {
	                    'url': url,
	                    'line': lineNo,
	                    'column': columnNo
	                };
	                location.func = TraceKit.computeStackTrace.guessFunctionName(location.url, location.line);
	                location.context = TraceKit.computeStackTrace.gatherContext(location.url, location.line);
	                stack = {
	                    'mode': 'onerror',
	                    'message': message,
	                    'url': document.location.href,
	                    'stack': [location],
	                    'useragent': navigator.userAgent
	                };
	            }
	        }
	
	        notifyHandlers(stack, 'from window.onerror');
	
	        if (_oldOnerrorHandler) {
	            return _oldOnerrorHandler.apply(this, arguments);
	        }
	
	        return false;
	    }
	
	    function installGlobalHandler ()
	    {
	        if (_onErrorHandlerInstalled === true) {
	           return;
	        }
	        _oldOnerrorHandler = window.onerror;
	        window.onerror = traceKitWindowOnError;
	        _onErrorHandlerInstalled = true;
	    }
	
	    /**
	     * Reports an unhandled Error to TraceKit.
	     * @param {Error} ex
	     */
	    function report(ex) {
	        var args = _slice.call(arguments, 1);
	        if (lastExceptionStack) {
	            if (lastException === ex) {
	                return; // already caught by an inner catch block, ignore
	            } else {
	                var s = lastExceptionStack;
	                lastExceptionStack = null;
	                lastException = null;
	                notifyHandlers.apply(null, [s, null].concat(args));
	            }
	        }
	
	        var stack = TraceKit.computeStackTrace(ex);
	        lastExceptionStack = stack;
	        lastException = ex;
	
	        // If the stack trace is incomplete, wait for 2 seconds for
	        // slow slow IE to see if onerror occurs or not before reporting
	        // this exception; otherwise, we will end up with an incomplete
	        // stack trace
	        window.setTimeout(function () {
	            if (lastException === ex) {
	                lastExceptionStack = null;
	                lastException = null;
	                notifyHandlers.apply(null, [stack, null].concat(args));
	            }
	        }, (stack.incomplete ? 2000 : 0));
	
	        throw ex; // re-throw to propagate to the top level (and cause window.onerror)
	    }
	
	    report.subscribe = subscribe;
	    report.unsubscribe = unsubscribe;
	    return report;
	}());
	
	/**
	 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
	 *
	 * Syntax:
	 *   s = TraceKit.computeStackTrace.ofCaller([depth])
	 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
	 * Returns:
	 *   s.name              - exception name
	 *   s.message           - exception message
	 *   s.stack[i].url      - JavaScript or HTML file URL
	 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
	 *   s.stack[i].args     - arguments passed to the function, if known
	 *   s.stack[i].line     - line number, if known
	 *   s.stack[i].column   - column number, if known
	 *   s.stack[i].context  - an array of source code lines; the middle element corresponds to the correct line#
	 *   s.mode              - 'stack', 'stacktrace', 'multiline', 'callers', 'onerror', or 'failed' -- method used to collect the stack trace
	 *
	 * Supports:
	 *   - Firefox:  full stack trace with line numbers and unreliable column
	 *               number on top frame
	 *   - Opera 10: full stack trace with line and column numbers
	 *   - Opera 9-: full stack trace with line numbers
	 *   - Chrome:   full stack trace with line and column numbers
	 *   - Safari:   line and column number for the topmost stacktrace element
	 *               only
	 *   - IE:       no line numbers whatsoever
	 *
	 * Tries to guess names of anonymous functions by looking for assignments
	 * in the source code. In IE and Safari, we have to guess source file names
	 * by searching for function bodies inside all page scripts. This will not
	 * work for scripts that are loaded cross-domain.
	 * Here be dragons: some function names may be guessed incorrectly, and
	 * duplicate functions may be mismatched.
	 *
	 * TraceKit.computeStackTrace should only be used for tracing purposes.
	 * Logging of unhandled exceptions should be done with TraceKit.report,
	 * which builds on top of TraceKit.computeStackTrace and provides better
	 * IE support by utilizing the window.onerror event to retrieve information
	 * about the top of the stack.
	 *
	 * Note: In IE and Safari, no stack trace is recorded on the Error object,
	 * so computeStackTrace instead walks its *own* chain of callers.
	 * This means that:
	 *  * in Safari, some methods may be missing from the stack trace;
	 *  * in IE, the topmost function in the stack trace will always be the
	 *    caller of computeStackTrace.
	 *
	 * This is okay for tracing (because you are likely to be calling
	 * computeStackTrace from the function you want to be the topmost element
	 * of the stack trace anyway), but not okay for logging unhandled
	 * exceptions (because your catch block will likely be far away from the
	 * inner function that actually caused the exception).
	 *
	 * Tracing example:
	 *     function trace(message) {
	 *         var stackInfo = TraceKit.computeStackTrace.ofCaller();
	 *         var data = message + "\n";
	 *         for(var i in stackInfo.stack) {
	 *             var item = stackInfo.stack[i];
	 *             data += (item.func || '[anonymous]') + "() in " + item.url + ":" + (item.line || '0') + "\n";
	 *         }
	 *         if (window.console)
	 *             console.info(data);
	 *         else
	 *             alert(data);
	 *     }
	 */
	TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
	    var debug = false,
	        sourceCache = {};
	
	    /**
	     * Attempts to retrieve source code via XMLHttpRequest, which is used
	     * to look up anonymous function names.
	     * @param {string} url URL of source code.
	     * @return {string} Source contents.
	     */
	    function loadSource(url) {
	        if (typeof url !== 'string') {
	          return [];
	        }
	
	        return ''; // Remote fetching disabled due to deprecated synchronous XHR support in browsers
	    }
	
	    /**
	     * Retrieves source code from the source code cache.
	     * @param {string} url URL of source code.
	     * @return {Array.<string>} Source contents.
	     */
	    function getSource(url) {
	        if (!_has(sourceCache, url)) {
	            // URL needs to be able to fetched within the acceptable domain.  Otherwise,
	            // cross-domain errors will be triggered.
	            var source = '';
	
	            url = url || "";
	
	            if (url.indexOf && url.indexOf(document.domain) !== -1) {
	                source = loadSource(url);
	            }
	            sourceCache[url] = source ? source.split('\n') : [];
	        }
	
	        return sourceCache[url];
	    }
	
	    /**
	     * Tries to use an externally loaded copy of source code to determine
	     * the name of a function by looking at the name of the variable it was
	     * assigned to, if any.
	     * @param {string} url URL of source code.
	     * @param {(string|number)} lineNo Line number in source code.
	     * @return {string} The function name, if discoverable.
	     */
	    function guessFunctionName(url, lineNo) {
	        var reFunctionArgNames = /function ([^(]*)\(([^)]*)\)/,
	            reGuessFunction = /['"]?([0-9A-Za-z$_]+)['"]?\s*[:=]\s*(function|eval|new Function)/,
	            line = '',
	            maxLines = 10,
	            source = getSource(url),
	            m;
	
	        if (!source.length) {
	            return UNKNOWN_FUNCTION;
	        }
	
	        // Walk backwards from the first line in the function until we find the line which
	        // matches the pattern above, which is the function definition
	        for (var i = 0; i < maxLines; ++i) {
	            line = source[lineNo - i] + line;
	
	            if (!_isUndefined(line)) {
	                if ((m = reGuessFunction.exec(line))) {
	                    return m[1];
	                } else if ((m = reFunctionArgNames.exec(line))) {
	                    return m[1];
	                }
	            }
	        }
	
	        return UNKNOWN_FUNCTION;
	    }
	
	    /**
	     * Retrieves the surrounding lines from where an exception occurred.
	     * @param {string} url URL of source code.
	     * @param {(string|number)} line Line number in source code to centre
	     * around for context.
	     * @return {?Array.<string>} Lines of source code.
	     */
	    function gatherContext(url, line) {
	        var source = getSource(url);
	
	        if (!source.length) {
	            return null;
	        }
	
	        var context = [],
	            // linesBefore & linesAfter are inclusive with the offending line.
	            // if linesOfContext is even, there will be one extra line
	            //   *before* the offending line.
	            linesBefore = Math.floor(TraceKit.linesOfContext / 2),
	            // Add one extra line if linesOfContext is odd
	            linesAfter = linesBefore + (TraceKit.linesOfContext % 2),
	            start = Math.max(0, line - linesBefore - 1),
	            end = Math.min(source.length, line + linesAfter - 1);
	
	        line -= 1; // convert to 0-based index
	
	        for (var i = start; i < end; ++i) {
	            if (!_isUndefined(source[i])) {
	                context.push(source[i]);
	            }
	        }
	
	        return context.length > 0 ? context : null;
	    }
	
	    /**
	     * Escapes special characters, except for whitespace, in a string to be
	     * used inside a regular expression as a string literal.
	     * @param {string} text The string.
	     * @return {string} The escaped string literal.
	     */
	    function escapeRegExp(text) {
	        return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, '\\$&');
	    }
	
	    /**
	     * Escapes special characters in a string to be used inside a regular
	     * expression as a string literal. Also ensures that HTML entities will
	     * be matched the same as their literal friends.
	     * @param {string} body The string.
	     * @return {string} The escaped string.
	     */
	    function escapeCodeAsRegExpForMatchingInsideHTML(body) {
	        return escapeRegExp(body).replace('<', '(?:<|&lt;)').replace('>', '(?:>|&gt;)').replace('&', '(?:&|&amp;)').replace('"', '(?:"|&quot;)').replace(/\s+/g, '\\s+');
	    }
	
	    /**
	     * Determines where a code fragment occurs in the source code.
	     * @param {RegExp} re The function definition.
	     * @param {Array.<string>} urls A list of URLs to search.
	     * @return {?Object.<string, (string|number)>} An object containing
	     * the url, line, and column number of the defined function.
	     */
	    function findSourceInUrls(re, urls) {
	        var source, m;
	        for (var i = 0, j = urls.length; i < j; ++i) {
	            // console.log('searching', urls[i]);
	            if ((source = getSource(urls[i])).length) {
	                source = source.join('\n');
	                if ((m = re.exec(source))) {
	                    // console.log('Found function in ' + urls[i]);
	
	                    return {
	                        'url': urls[i],
	                        'line': source.substring(0, m.index).split('\n').length,
	                        'column': m.index - source.lastIndexOf('\n', m.index) - 1
	                    };
	                }
	            }
	        }
	
	        // console.log('no match');
	
	        return null;
	    }
	
	    /**
	     * Determines at which column a code fragment occurs on a line of the
	     * source code.
	     * @param {string} fragment The code fragment.
	     * @param {string} url The URL to search.
	     * @param {(string|number)} line The line number to examine.
	     * @return {?number} The column number.
	     */
	    function findSourceInLine(fragment, url, line) {
	        var source = getSource(url),
	            re = new RegExp('\\b' + escapeRegExp(fragment) + '\\b'),
	            m;
	
	        line -= 1;
	
	        if (source && source.length > line && (m = re.exec(source[line]))) {
	            return m.index;
	        }
	
	        return null;
	    }
	
	    /**
	     * Determines where a function was defined within the source code.
	     * @param {(Function|string)} func A function reference or serialized
	     * function definition.
	     * @return {?Object.<string, (string|number)>} An object containing
	     * the url, line, and column number of the defined function.
	     */
	    function findSourceByFunctionBody(func) {
	        var urls = [window.location.href],
	            scripts = document.getElementsByTagName('script'),
	            body,
	            code = '' + func,
	            codeRE = /^function(?:\s+([\w$]+))?\s*\(([\w\s,]*)\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,
	            eventRE = /^function on([\w$]+)\s*\(event\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,
	            re,
	            parts,
	            result;
	
	        for (var i = 0; i < scripts.length; ++i) {
	            var script = scripts[i];
	            if (script.src) {
	                urls.push(script.src);
	            }
	        }
	
	        if (!(parts = codeRE.exec(code))) {
	            re = new RegExp(escapeRegExp(code).replace(/\s+/g, '\\s+'));
	        }
	
	        // not sure if this is really necessary, but I don’t have a test
	        // corpus large enough to confirm that and it was in the original.
	        else {
	            var name = parts[1] ? '\\s+' + parts[1] : '',
	                args = parts[2].split(',').join('\\s*,\\s*');
	
	            body = escapeRegExp(parts[3]).replace(/;$/, ';?'); // semicolon is inserted if the function ends with a comment.replace(/\s+/g, '\\s+');
	            re = new RegExp('function' + name + '\\s*\\(\\s*' + args + '\\s*\\)\\s*{\\s*' + body + '\\s*}');
	        }
	
	        // look for a normal function definition
	        if ((result = findSourceInUrls(re, urls))) {
	            return result;
	        }
	
	        // look for an old-school event handler function
	        if ((parts = eventRE.exec(code))) {
	            var event = parts[1];
	            body = escapeCodeAsRegExpForMatchingInsideHTML(parts[2]);
	
	            // look for a function defined in HTML as an onXXX handler
	            re = new RegExp('on' + event + '=[\\\'"]\\s*' + body + '\\s*[\\\'"]', 'i');
	
	            if ((result = findSourceInUrls(re, urls[0]))) {
	                return result;
	            }
	
	            // look for ???
	            re = new RegExp(body);
	
	            if ((result = findSourceInUrls(re, urls))) {
	                return result;
	            }
	        }
	
	        return null;
	    }
	
	    // Contents of Exception in various browsers.
	    //
	    // SAFARI:
	    // ex.message = Can't find variable: qq
	    // ex.line = 59
	    // ex.sourceId = 580238192
	    // ex.sourceURL = http://...
	    // ex.expressionBeginOffset = 96
	    // ex.expressionCaretOffset = 98
	    // ex.expressionEndOffset = 98
	    // ex.name = ReferenceError
	    //
	    // FIREFOX:
	    // ex.message = qq is not defined
	    // ex.fileName = http://...
	    // ex.lineNumber = 59
	    // ex.stack = ...stack trace... (see the example below)
	    // ex.name = ReferenceError
	    //
	    // CHROME:
	    // ex.message = qq is not defined
	    // ex.name = ReferenceError
	    // ex.type = not_defined
	    // ex.arguments = ['aa']
	    // ex.stack = ...stack trace...
	    //
	    // INTERNET EXPLORER:
	    // ex.message = ...
	    // ex.name = ReferenceError
	    //
	    // OPERA:
	    // ex.message = ...message... (see the example below)
	    // ex.name = ReferenceError
	    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
	    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
	
	    /**
	     * Computes stack trace information from the stack property.
	     * Chrome and Gecko use this property.
	     * Added WinJS regex for Raygun4JS's offline caching support
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceFromStackProp(ex) {
	        if (!ex.stack) {
	            return null;
	        }
	
	        var chrome = /^\s*at (.*?) ?\(((?:file|https?|\s*|blob|chrome-extension|native|webpack|eval).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
	            gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i,
	            winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
	            lines = ex.stack.split('\n'),
	            stack = [],
	            parts,
	            element,
	            reference = /^(.*) is undefined$/.exec(ex.message);
	
	        for (var i = 0, j = lines.length; i < j; ++i) {
	            if ((parts = gecko.exec(lines[i]))) {
	                element = {
	                    'url': parts[3],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': parts[2] ? parts[2].split(',') : '',
	                    'line': +parts[4],
	                    'column': parts[5] ? +parts[5] : null
	                };
	            } else if ((parts = chrome.exec(lines[i]))) {
	                element = {
	                    'url': parts[2],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'line': +parts[3],
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else if ((parts = winjs.exec(lines[i]))) {
	              element = {
	                'url': parts[2],
	                'func': parts[1] || UNKNOWN_FUNCTION,
	                'line': +parts[3],
	                'column': parts[4] ? +parts[4] : null
	              };
	            } else {
	                continue;
	            }
	
	            if (!element.func && element.line) {
	                element.func = guessFunctionName(element.url, element.line);
	            }
	
	            if (element.line) {
	                element.context = gatherContext(element.url, element.line);
	            }
	
	            stack.push(element);
	        }
	
	        if (stack[0] && stack[0].line && !stack[0].column && reference) {
	            stack[0].column = findSourceInLine(reference[1], stack[0].url, stack[0].line);
	        } else if (!stack[0].column && typeof ex.columnNumber !== 'undefined') {
	            // Firefox column number
	            stack[0].column = ex.columnNumber + 1;
	        }
	
	        if (!stack.length) {
	            return null;
	        }
	
	        return {
	            'mode': 'stack',
	            'name': ex.name,
	            'message': ex.message,
	            'url': document.location.href,
	            'stack': stack,
	            'useragent': navigator.userAgent
	        };
	    }
	
	    /**
	     * Computes stack trace information from the stacktrace property.
	     * Opera 10 uses this property.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceFromStacktraceProp(ex) {
	        // Access and store the stacktrace property before doing ANYTHING
	        // else to it because Opera is not very good at providing it
	        // reliably in other circumstances.
	        var stacktrace = ex.stacktrace;
	
	        var testRE = / line (\d+), column (\d+) in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\) in (.*):\s*$/i,
	            lines = stacktrace !== null ? stacktrace.split('\n') : stacktrace,
	            stack = [],
	            parts;
	
	        for (var i = 0, j = lines.length; i < j; i += 2) {
	            if ((parts = testRE.exec(lines[i]))) {
	                var element = {
	                    'line': +parts[1],
	                    'column': +parts[2],
	                    'func': parts[3] || parts[4],
	                    'args': parts[5] ? parts[5].split(',') : [],
	                    'url': parts[6]
	                };
	
	                if (!element.func && element.line) {
	                    element.func = guessFunctionName(element.url, element.line);
	                }
	                if (element.line) {
	                    try {
	                        element.context = gatherContext(element.url, element.line);
	                    } catch (exc) {}
	                }
	
	                if (!element.context) {
	                    element.context = [lines[i + 1]];
	                }
	
	                stack.push(element);
	            }
	        }
	
	        if (!stack.length) {
	            return null;
	        }
	
	        return {
	            'mode': 'stacktrace',
	            'name': ex.name,
	            'message': ex.message,
	            'url': document.location.href,
	            'stack': stack,
	            'useragent': navigator.userAgent
	        };
	    }
	
	    /**
	     * NOT TESTED.
	     * Computes stack trace information from an error message that includes
	     * the stack trace.
	     * Opera 9 and earlier use this method if the option to show stack
	     * traces is turned on in opera:config.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack information.
	     */
	    function computeStackTraceFromOperaMultiLineMessage(ex) {
	        // Opera includes a stack trace into the exception message. An example is:
	        //
	        // Statement on line 3: Undefined variable: undefinedFunc
	        // Backtrace:
	        //   Line 3 of linked script file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.js: In function zzz
	        //         undefinedFunc(a);
	        //   Line 7 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function yyy
	        //           zzz(x, y, z);
	        //   Line 3 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function xxx
	        //           yyy(a, a, a);
	        //   Line 1 of function script
	        //     try { xxx('hi'); return false; } catch(ex) { TraceKit.report(ex); }
	        //   ...
	
	        var lines = ex.message.split('\n');
	        if (lines.length < 4) {
	            return null;
	        }
	
	        var lineRE1 = /^\s*Line (\d+) of linked script ((?:file|http|https)\S+)(?:: in function (\S+))?\s*$/i,
	            lineRE2 = /^\s*Line (\d+) of inline#(\d+) script in ((?:file|http|https)\S+)(?:: in function (\S+))?\s*$/i,
	            lineRE3 = /^\s*Line (\d+) of function script\s*$/i,
	            stack = [],
	            scripts = document.getElementsByTagName('script'),
	            inlineScriptBlocks = [],
	            parts,
	            i,
	            len,
	            source;
	
	        for (i in scripts) {
	            if (_has(scripts, i) && !scripts[i].src) {
	                inlineScriptBlocks.push(scripts[i]);
	            }
	        }
	
	        for (i = 2, len = lines.length; i < len; i += 2) {
	            var item = null;
	            if ((parts = lineRE1.exec(lines[i]))) {
	                item = {
	                    'url': parts[2],
	                    'func': parts[3],
	                    'line': +parts[1]
	                };
	            } else if ((parts = lineRE2.exec(lines[i]))) {
	                item = {
	                    'url': parts[3],
	                    'func': parts[4]
	                };
	                var relativeLine = (+parts[1]); // relative to the start of the <SCRIPT> block
	                var script = inlineScriptBlocks[parts[2] - 1];
	                if (script) {
	                    source = getSource(item.url);
	                    if (source) {
	                        source = source.join('\n');
	                        var pos = source.indexOf(script.innerText);
	                        if (pos >= 0) {
	                            item.line = relativeLine + source.substring(0, pos).split('\n').length;
	                        }
	                    }
	                }
	            } else if ((parts = lineRE3.exec(lines[i]))) {
	                var url = window.location.href.replace(/#.*$/, ''),
	                    line = parts[1];
	                var re = new RegExp(escapeCodeAsRegExpForMatchingInsideHTML(lines[i + 1]));
	                source = findSourceInUrls(re, [url]);
	                item = {
	                    'url': url,
	                    'line': source ? source.line : line,
	                    'func': ''
	                };
	            }
	
	            if (item) {
	                if (!item.func) {
	                    item.func = guessFunctionName(item.url, item.line);
	                }
	                var context = gatherContext(item.url, item.line);
	                var midline = (context ? context[Math.floor(context.length / 2)] : null);
	                if (context && midline.replace(/^\s*/, '') === lines[i + 1].replace(/^\s*/, '')) {
	                    item.context = context;
	                } else {
	                    // if (context) alert("Context mismatch. Correct midline:\n" + lines[i+1] + "\n\nMidline:\n" + midline + "\n\nContext:\n" + context.join("\n") + "\n\nURL:\n" + item.url);
	                    item.context = [lines[i + 1]];
	                }
	                stack.push(item);
	            }
	        }
	        if (!stack.length) {
	            return null; // could not parse multiline exception message as Opera stack trace
	        }
	
	        return {
	            'mode': 'multiline',
	            'name': ex.name,
	            'message': lines[0],
	            'url': document.location.href,
	            'stack': stack,
	            'useragent': navigator.userAgent
	        };
	    }
	
	    /**
	     * Adds information about the first frame to incomplete stack traces.
	     * Safari and IE require this to get complete data on the first frame.
	     * @param {Object.<string, *>} stackInfo Stack trace information from
	     * one of the compute* methods.
	     * @param {string} url The URL of the script that caused an error.
	     * @param {(number|string)} lineNo The line number of the script that
	     * caused an error.
	     * @param {string=} message The error generated by the browser, which
	     * hopefully contains the name of the object that caused the error.
	     * @return {boolean} Whether or not the stack information was
	     * augmented.
	     */
	    function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
	        var initial = {
	            'url': url,
	            'line': lineNo
	        };
	
	        if (initial.url && initial.line) {
	            stackInfo.incomplete = false;
	
	            if (!initial.func) {
	                initial.func = guessFunctionName(initial.url, initial.line);
	            }
	
	            if (!initial.context) {
	                initial.context = gatherContext(initial.url, initial.line);
	            }
	
	            var reference = / '([^']+)' /.exec(message);
	            if (reference) {
	                initial.column = findSourceInLine(reference[1], initial.url, initial.line);
	            }
	
	            if (stackInfo.stack.length > 0) {
	                if (stackInfo.stack[0].url === initial.url) {
	                    if (stackInfo.stack[0].line === initial.line) {
	                        return false; // already in stack trace
	                    } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
	                        stackInfo.stack[0].line = initial.line;
	                        stackInfo.stack[0].context = initial.context;
	                        return false;
	                    }
	                }
	            }
	
	            stackInfo.stack.unshift(initial);
	            stackInfo.partial = true;
	            return true;
	        } else {
	            stackInfo.incomplete = true;
	        }
	
	        return false;
	    }
	
	    /**
	     * Computes stack trace information by walking the arguments.caller
	     * chain at the time the exception occurred. This will cause earlier
	     * frames to be missed but is the only way to get any stack trace in
	     * Safari and IE. The top frame is restored by
	     * {@link augmentStackTraceWithInitialElement}.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceByWalkingCallerChain(ex, depth) {
	        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
	            stack = [],
	            funcs = {},
	            recursion = false,
	            parts,
	            item,
	            source;
	
	        for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
	            if (curr === computeStackTrace || curr === TraceKit.report) {
	                // console.log('skipping internal function');
	                continue;
	            }
	
	            item = {
	                'url': null,
	                'func': UNKNOWN_FUNCTION,
	                'line': null,
	                'column': null
	            };
	
	            if (curr.name) {
	                item.func = curr.name;
	            } else if ((parts = functionName.exec(curr.toString()))) {
	                item.func = parts[1];
	            }
	
	            if (typeof item.func === 'undefined') {
	              try {
	                item.func = parts.input.substring(0, parts.input.indexOf('{'))
	              } catch (e) { }
	            }
	
	            if ((source = findSourceByFunctionBody(curr))) {
	                item.url = source.url;
	                item.line = source.line;
	
	                if (item.func === UNKNOWN_FUNCTION) {
	                    item.func = guessFunctionName(item.url, item.line);
	                }
	
	                var reference = / '([^']+)' /.exec(ex.message || ex.description);
	                if (reference) {
	                    item.column = findSourceInLine(reference[1], source.url, source.line);
	                }
	            }
	
	            if (funcs['' + curr]) {
	                recursion = true;
	            }else{
	                funcs['' + curr] = true;
	            }
	
	            stack.push(item);
	        }
	
	        if (depth) {
	            // console.log('depth is ' + depth);
	            // console.log('stack is ' + stack.length);
	            stack.splice(0, depth);
	        }
	
	        var result = {
	            'mode': 'callers',
	            'name': ex.name,
	            'message': ex.message,
	            'url': document.location.href,
	            'stack': stack,
	            'useragent': navigator.userAgent
	        };
	        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
	        return result;
	    }
	
	    /**
	     * Computes a stack trace for an exception.
	     * @param {Error} ex
	     * @param {(string|number)=} depth
	     */
	    function computeStackTrace(ex, depth) {
	        var stack = null;
	        depth = (depth == null ? 0 : +depth);
	
	        try {
	            // This must be tried first because Opera 10 *destroys*
	            // its stacktrace property if you try to access the stack
	            // property first!!
	            stack = computeStackTraceFromStacktraceProp(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (debug) {
	                throw e;
	            }
	        }
	
	        try {
	            stack = computeStackTraceFromStackProp(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (debug) {
	                throw e;
	            }
	        }
	
	        try {
	            stack = computeStackTraceFromOperaMultiLineMessage(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (debug) {
	                throw e;
	            }
	        }
	
	        try {
	            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (debug) {
	                throw e;
	            }
	        }
	
	        return {
	            'mode': 'failed'
	        };
	    }
	
	    /**
	     * Logs a stacktrace starting from the previous call and working down.
	     * @param {(number|string)=} depth How many frames deep to trace.
	     * @return {Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceOfCaller(depth) {
	        depth = (depth == null ? 0 : +depth) + 1; // "+ 1" because "ofCaller" should drop one frame
	        try {
	            throw new Error();
	        } catch (ex) {
	            return computeStackTrace(ex, depth + 1);
	        }
	    }
	
	    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
	    computeStackTrace.guessFunctionName = guessFunctionName;
	    computeStackTrace.gatherContext = gatherContext;
	    computeStackTrace.ofCaller = computeStackTraceOfCaller;
	
	    return computeStackTrace;
	}());
	
	/**
	 * Extends support for global error handling for asynchronous browser
	 * functions. Adopted from Closure Library's errorhandler.js
	 */
	TraceKit.extendToAsynchronousCallbacks = function () {
	    var _helper = function _helper(fnName) {
	        var originalFn = window[fnName];
	        window[fnName] = function traceKitAsyncExtension() {
	            // Make a copy of the arguments
	            var args = _slice.call(arguments);
	            var originalCallback = args[0];
	            if (typeof (originalCallback) === 'function') {
	                args[0] = TraceKit.wrap(originalCallback);
	            }
	            // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
	            // also only supports 2 argument and doesn't care what "this" is, so we
	            // can just call the original function directly.
	            if (originalFn.apply) {
	                return originalFn.apply(this, args);
	            } else {
	                return originalFn(args[0], args[1]);
	            }
	        };
	    };
	
	    _helper('setTimeout');
	    _helper('setInterval');
	};
	
	//Default options:
	if (!TraceKit.remoteFetching) {
	  TraceKit.remoteFetching = true;
	}
	if (!TraceKit.collectWindowErrors) {
	  TraceKit.collectWindowErrors = true;
	}
	if (!TraceKit.linesOfContext || TraceKit.linesOfContext < 1) {
	  // 5 lines before, the offending line, 5 lines after
	  TraceKit.linesOfContext = 11;
	}
	
	
	
	// Export to global object
	window.TraceKit = TraceKit;
	
	}(window));
	
	(function traceKitAsyncForjQuery($, TraceKit) {
	  'use strict';
	  // quit if jQuery isn't on the page
	  if (!$ || !$.event || !$.event.add) {
	    return;
	  }
	
	  var _oldEventAdd = $.event.add;
	  $.event.add = function traceKitEventAdd(elem, types, handler, data, selector) {
	    if (typeof handler !== 'function' && typeof handler.handler !== 'function') {
	      return _oldEventAdd.call(this, elem, types, handler, data, selector);
	    }
	
	    var _handler;
	
	    if (handler.handler) {
	      _handler = handler.handler;
	      handler.handler = TraceKit.wrap(handler.handler);
	    } else {
	      _handler = handler;
	      handler = TraceKit.wrap(handler);
	    }
	
	    // If the handler we are attaching doesn’t have the same guid as
	    // the original, it will never be removed when someone tries to
	    // unbind the original function later. Technically as a result of
	    // this our guids are no longer globally unique, but whatever, that
	    // never hurt anybody RIGHT?!
	    if (_handler.guid) {
	      handler.guid = _handler.guid;
	    } else {
	      handler.guid = _handler.guid = $.guid++;
	    }
	
	    return _oldEventAdd.call(this, elem, types, handler, data, selector);
	  };
	
	  var _oldReady = $.fn.ready;
	  $.fn.ready = function traceKitjQueryReadyWrapper(fn) {
	    return _oldReady.call(this, TraceKit.wrap(fn));
	  };
	
	  var _oldAjax = $.ajax;
	  $.ajax = function traceKitAjaxWrapper(url, options) {
	    if (typeof url === "object") {
	      options = url;
	      url = undefined;
	    }
	
	    options = options || {};
	
	    var keys = ['complete', 'error', 'success'], key;
	    while(key = keys.pop()) {
	      if ($.isFunction(options[key])) {
	        options[key] = TraceKit.wrap(options[key]);
	      }
	    }
	
	    try {
	      return (url) ? _oldAjax.call(this, url, options) : _oldAjax.call(this, options);
	    } catch (e) {
	      TraceKit.report(e);
	      throw e;
	    }
	  };
	
	}(window.jQuery, window.TraceKit));
	
	var raygunFactory = function (window, $, undefined) {
	    // pull local copy of TraceKit to handle stack trace collection
	    var _traceKit = TraceKit,
	        _raygun = window.Raygun,
	        _raygunApiKey,
	        _debugMode = false,
	        _allowInsecureSubmissions = false,
	        _ignoreAjaxAbort = false,
	        _ignoreAjaxError = false,
	        _enableOfflineSave = false,
	        _ignore3rdPartyErrors = false,
	        _disableAnonymousUserTracking = false,
	        _disableErrorTracking = false,
	        _disablePulse = true,
	        _wrapAsynchronousCallbacks = false,
	        _customData = {},
	        _tags = [],
	        _user,
	        _version,
	        _filteredKeys,
	        _whitelistedScriptDomains = [],
	        _beforeSendCallback,
	        _groupingKeyCallback,
	        _beforeXHRCallback,
	        _afterSendCallback,
	        _raygunApiUrl = 'https://api.raygun.io',
	        _excludedHostnames = null,
	        _excludedUserAgents = null,
	        _filterScope = 'customData',
	        _rum = null,
	        _pulseMaxVirtualPageDuration = null,
	        _pulseIgnoreUrlCasing = true,
	        $document;
	
	
	    var Raygun =
	    {
	        noConflict: function () {
	            window.Raygun = _raygun;
	            return Raygun;
	        },
	
	        constructNewRaygun: function () {
	            var rgInstance = window.raygunFactory(window, window.jQuery);
	            window.raygunJsUrlFactory(window, rgInstance);
	
	            return rgInstance;
	        },
	
	        init: function (key, options, customdata) {
	            _raygunApiKey = key;
	            _traceKit.remoteFetching = false;
	
	            if (customdata) {
	                _customData = customdata;
	            }
	
	            if ($) {
	                $document = $(document);
	            }
	
	            if (options) {
	                _allowInsecureSubmissions = options.allowInsecureSubmissions || false;
	                _ignoreAjaxAbort = options.ignoreAjaxAbort || false;
	                _ignoreAjaxError = options.ignoreAjaxError || false;
	                _disableAnonymousUserTracking = options.disableAnonymousUserTracking || false;
	                _disableErrorTracking = options.disableErrorTracking || false;
	                _disablePulse = options.disablePulse === undefined ? true : options.disablePulse;
	                _excludedHostnames = options.excludedHostnames || false;
	                _excludedUserAgents = options.excludedUserAgents || false;
	                _pulseMaxVirtualPageDuration = options.pulseMaxVirtualPageDuration || null;
	                _pulseIgnoreUrlCasing = options.pulseIgnoreUrlCasing || false;
	
	                if (options.apiUrl) {
	                    _raygunApiUrl = options.apiUrl;
	                }
	
	                if (typeof options.wrapAsynchronousCallbacks !== 'undefined') {
	                    _wrapAsynchronousCallbacks = options.wrapAsynchronousCallbacks;
	                }
	
	                if (options.debugMode) {
	                    _debugMode = options.debugMode;
	                }
	
	                if (options.ignore3rdPartyErrors) {
	                    _ignore3rdPartyErrors = true;
	                }
	
	                if (options.apiEndpoint) {
	                    _raygunApiUrl = options.apiEndpoint;
	                }
	            }
	
	            ensureUser();
	
	            if (Raygun.RealUserMonitoring !== undefined && !_disablePulse) {
	                var startRum = function () {
	                    _rum = new Raygun.RealUserMonitoring(_raygunApiKey, _raygunApiUrl, makePostCorsRequest, _user, _version, _excludedHostnames, _excludedUserAgents, _debugMode, _pulseMaxVirtualPageDuration, _pulseIgnoreUrlCasing);
	                    _rum.attach();
	                };
	
	                if (options && options.from === 'onLoad') {
	                    startRum();
	                } else {
	                    if (window.addEventListener) {
	                        window.addEventListener('load', startRum);
	                    } else {
	                        window.attachEvent('onload', startRum);
	                    }
	                }
	            }
	
	            sendSavedErrors();
	
	            return Raygun;
	        },
	
	        withCustomData: function (customdata) {
	            _customData = customdata;
	            return Raygun;
	        },
	
	        withTags: function (tags) {
	            _tags = tags;
	            return Raygun;
	        },
	
	        attach: function () {
	            if (!isApiKeyConfigured() || _disableErrorTracking) {
	                return Raygun;
	            }
	
	            if (window.RaygunObject && window[window.RaygunObject] && window[window.RaygunObject].q) {
	                window.onerror = null;
	            }
	
	            _traceKit.report.subscribe(processUnhandledException);
	
	            if (_wrapAsynchronousCallbacks) {
	                _traceKit.extendToAsynchronousCallbacks();
	            }
	
	            if ($document && $document.ajaxError && !_ignoreAjaxError) {
	                $document.ajaxError(processJQueryAjaxError);
	            }
	            return Raygun;
	        },
	
	        detach: function () {
	            _traceKit.report.unsubscribe(processUnhandledException);
	            if ($document) {
	                $document.unbind('ajaxError', processJQueryAjaxError);
	            }
	            return Raygun;
	        },
	
	        send: function (ex, customData, tags) {
	            if (_disableErrorTracking) {
	                _private.log('Error not sent due to disabled error tracking');
	                return Raygun;
	            }
	
	            try {
	                processUnhandledException(
	                    _traceKit.computeStackTrace(ex),
	                    {
	                        customData: typeof _customData === 'function' ?
	                            merge(_customData(), customData) :
	                            merge(_customData, customData),
	                        tags: typeof _tags === 'function' ?
	                            mergeArray(_tags(), tags) :
	                            mergeArray(_tags, tags)
	                    },
	                    true
	                );
	            }
	            catch (traceKitException) {
	                if (ex !== traceKitException) {
	                    throw traceKitException;
	                }
	            }
	            return Raygun;
	        },
	
	        setUser: function (user, isAnonymous, email, fullName, firstName, uuid) {
	            _user = {
	                'Identifier': user
	            };
	            if (typeof isAnonymous === 'boolean') {
	                _user['IsAnonymous'] = isAnonymous;
	            }
	            if (email) {
	                _user['Email'] = email;
	            }
	            if (fullName) {
	                _user['FullName'] = fullName;
	            }
	            if (firstName) {
	                _user['FirstName'] = firstName;
	            }
	            if (uuid) {
	                _user['UUID'] = uuid;
	            }
	
	            if (_rum !== undefined && _rum !== null) {
	                _rum.setUser(_user);
	            }
	
	            return Raygun;
	        },
	
	        resetAnonymousUser: function () {
	            _private.clearCookie('raygun4js-userid');
	        },
	
	        setVersion: function (version) {
	            _version = version;
	            return Raygun;
	        },
	
	        saveIfOffline: function (enableOffline) {
	            if (typeof enableOffline !== 'undefined' && typeof enableOffline === 'boolean') {
	                _enableOfflineSave = enableOffline;
	            }
	
	            return Raygun;
	        },
	
	        filterSensitiveData: function (filteredKeys) {
	            _filteredKeys = filteredKeys;
	            return Raygun;
	        },
	
	        setFilterScope: function (scope) {
	            if (scope === 'customData' || scope === 'all') {
	                _filterScope = scope;
	            }
	            return Raygun;
	        },
	
	        whitelistCrossOriginDomains: function (whitelist) {
	            _whitelistedScriptDomains = whitelist;
	            return Raygun;
	        },
	
	        onBeforeSend: function (callback) {
	            _beforeSendCallback = callback;
	            return Raygun;
	        },
	
	        groupingKey: function (callback) {
	            _groupingKeyCallback = callback;
	            return Raygun;
	        },
	
	        onBeforeXHR: function (callback) {
	            _beforeXHRCallback = callback;
	            return Raygun;
	        },
	
	        onAfterSend: function (callback) {
	            _afterSendCallback = callback;
	            return Raygun;
	        },
	
	        // Public Pulse functions
	
	        endSession: function () {
	            if (Raygun.RealUserMonitoring !== undefined && _rum) {
	                _rum.endSession();
	            }
	        },
	
	        trackEvent: function (type, options) {
	            if (Raygun.RealUserMonitoring !== undefined && _rum) {
	                if (type === 'pageView' && options.path) {
	                    _rum.virtualPageLoaded(options.path);
	                }
	            }
	        }
	
	    };
	
	    var _private = Raygun._private = Raygun._private || {},
	        _seal = Raygun._seal = Raygun._seal || function () {
	                delete Raygun._private;
	                delete Raygun._seal;
	                delete Raygun._unseal;
	            },
	        _unseal = Raygun._unseal = Raygun._unseal || function () {
	                Raygun._private = _private;
	                Raygun._seal = _seal;
	                Raygun._unseal = _unseal;
	            };
	
	    _private.getUuid = function () {
	        function _p8(s) {
	            var p = (Math.random().toString(16) + "000000000").substr(2, 8);
	            return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
	        }
	
	        return _p8() + _p8(true) + _p8(true) + _p8();
	    };
	
	    _private.createCookie = function (name, value, hours) {
	        var expires;
	        if (hours) {
	            var date = new Date();
	            date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
	            expires = "; expires=" + date.toGMTString();
	        }
	        else {
	            expires = "";
	        }
	
	        document.cookie = name + "=" + value + expires + "; path=/";
	    };
	
	    _private.readCookie = function (name) {
	        var nameEQ = name + "=";
	        var ca = document.cookie.split(';');
	        for (var i = 0; i < ca.length; i++) {
	            var c = ca[i];
	            while (c.charAt(0) === ' ') {
	                c = c.substring(1, c.length);
	            }
	            if (c.indexOf(nameEQ) === 0) {
	                return c.substring(nameEQ.length, c.length);
	            }
	        }
	        return null;
	    };
	
	    _private.clearCookie = function (key) {
	        _private.createCookie(key, '', -1);
	    };
	
	    _private.log = function (message, data) {
	        if (window.console && window.console.log && _debugMode) {
	            window.console.log(message);
	
	            if (data) {
	                window.console.log(data);
	            }
	        }
	    };
	
	    /* internals */
	
	    function truncateURL(url) {
	        // truncate after fourth /, or 24 characters, whichever is shorter
	        // /api/1/diagrams/xyz/server becomes
	        // /api/1/diagrams/...
	        var truncated = url;
	        var path = url.split('//')[1];
	
	        if (path) {
	            var queryStart = path.indexOf('?');
	            var sanitizedPath = path.toString().substring(0, queryStart);
	            var truncated_parts = sanitizedPath.split('/').slice(0, 4).join('/');
	            var truncated_length = sanitizedPath.substring(0, 48);
	            truncated = truncated_parts.length < truncated_length.length ?
	                truncated_parts : truncated_length;
	            if (truncated !== sanitizedPath) {
	                truncated += '..';
	            }
	        }
	
	        return truncated;
	    }
	
	    function processJQueryAjaxError(event, jqXHR, ajaxSettings, thrownError) {
	        var message = 'AJAX Error: ' +
	            (jqXHR.statusText || 'unknown') + ' ' +
	            (ajaxSettings.type || 'unknown') + ' ' +
	            (truncateURL(ajaxSettings.url) || 'unknown');
	
	        // ignore ajax abort if set in the options
	        if (_ignoreAjaxAbort) {
	            if (jqXHR.status === 0 || !jqXHR.getAllResponseHeaders()) {
	                return;
	            }
	        }
	
	        Raygun.send(thrownError || event.type, {
	            status: jqXHR.status,
	            statusText: jqXHR.statusText,
	            type: ajaxSettings.type,
	            url: ajaxSettings.url,
	            ajaxErrorMessage: message,
	            contentType: ajaxSettings.contentType,
	            requestData: ajaxSettings.data && ajaxSettings.data.slice ? ajaxSettings.data.slice(0, 10240) : undefined,
	            responseData: jqXHR.responseText && jqXHR.responseText.slice ? jqXHR.responseText.slice(0, 10240) : undefined,
	            activeTarget: event.target && event.target.activeElement && event.target.activeElement.outerHTML && event.target.activeElement.outerHTML.slice ? event.target.activeElement.outerHTML.slice(0, 10240) : undefined
	        });
	    }
	
	
	    function isApiKeyConfigured() {
	        if (_raygunApiKey && _raygunApiKey !== '') {
	            return true;
	        }
	        _private.log("Raygun API key has not been configured, make sure you call Raygun.init(yourApiKey)");
	        return false;
	    }
	
	    function merge(o1, o2) {
	        var a, o3 = {};
	        for (a in o1) {
	            o3[a] = o1[a];
	        }
	        for (a in o2) {
	            o3[a] = o2[a];
	        }
	        return o3;
	    }
	
	    function mergeArray(t0, t1) {
	        if (t1 != null) {
	            return t0.concat(t1);
	        }
	        return t0;
	    }
	
	    function forEach(set, func) {
	        for (var i = 0; i < set.length; i++) {
	            func.call(null, i, set[i]);
	        }
	    }
	
	    function isEmpty(o) {
	        for (var p in o) {
	            if (o.hasOwnProperty(p)) {
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function contains(array, obj) {
	        var i = array.length;
	        while (i--) {
	            if (array[i] === obj) {
	                return true;
	            }
	        }
	        return false;
	    }
	
	    function getRandomInt() {
	        return Math.floor(Math.random() * 9007199254740993);
	    }
	
	    function getViewPort() {
	        var e = document.documentElement,
	            g = document.getElementsByTagName('body')[0],
	            x = window.innerWidth || e.clientWidth || g.clientWidth,
	            y = window.innerHeight || e.clientHeight || g.clientHeight;
	        return {width: x, height: y};
	    }
	
	    function offlineSave(url, data) {
	        var dateTime = new Date().toJSON();
	
	        try {
	            var key = 'raygunjs+' + _raygunApiKey + '=' + dateTime + '=' + getRandomInt();
	
	            if (typeof localStorage[key] === 'undefined') {
	                localStorage[key] = JSON.stringify({url: url, data: data});
	            }
	        } catch (e) {
	            _private.log('Raygun4JS: LocalStorage full, cannot save exception');
	        }
	    }
	
	    function localStorageAvailable() {
	        try {
	            return ('localStorage' in window) && window['localStorage'] !== null;
	        } catch (e) {
	            return false;
	        }
	    }
	
	    function sendSavedErrors() {
	        if (localStorageAvailable() && localStorage && localStorage.length > 0) {
	            for (var key in localStorage) {
	
	                // TODO: Remove (0,9) substring after a given amount of time, only there for legacy reasons
	                if (key.substring(0, 9) === 'raygunjs=' || key.substring(0, 33) === 'raygunjs+' + _raygunApiKey) {
	                    try {
	                        var payload = JSON.parse(localStorage[key]);
	                        makePostCorsRequest(payload.url, payload.data);
	                    } catch (e) {
	                        _private.log('Raygun4JS: Invalid JSON object in LocalStorage');
	                    }
	
	                    try {
	                        localStorage.removeItem(key);
	                    } catch (e) {
	                        _private.log('Raygun4JS: Unable to remove error');
	                    }
	                }
	            }
	        }
	    }
	
	    function callAfterSend(response) {
	        if (typeof _afterSendCallback === 'function') {
	            _afterSendCallback(response);
	        }
	    }
	
	    function ensureUser() {
	        if (!_user && !_disableAnonymousUserTracking) {
	            var userKey = 'raygun4js-userid';
	            var rgUserId = _private.readCookie(userKey);
	            var anonymousUuid;
	
	            if (!rgUserId) {
	                anonymousUuid = _private.getUuid();
	
	                _private.createCookie(userKey, anonymousUuid, 24 * 31);
	            } else {
	                anonymousUuid = rgUserId;
	            }
	
	            Raygun.setUser(anonymousUuid, true, null, null, null, anonymousUuid);
	        }
	    }
	
	    function filterValue(key, value) {
	        if (_filteredKeys) {
	            for (var i = 0; i < _filteredKeys.length; i++) {
	                if (typeof _filteredKeys[i] === 'object' && typeof _filteredKeys[i].exec === 'function') {
	                    if (_filteredKeys[i].exec(key) !== null) {
	                        return '[removed by filter]';
	                    }
	                }
	                else if (_filteredKeys[i] === key) {
	                    return '[removed by filter]';
	                }
	            }
	        }
	
	        return value;
	    }
	
	    function filterObject(reference, parentKey) {
	        if (reference == null) {
	            return reference;
	        }
	
	        if (Object.prototype.toString.call(reference) !== '[object Object]') {
	            return reference;
	        }
	
	        var filteredObject = {};
	
	        for (var propertyName in reference) {
	            var propertyValue = reference[propertyName];
	
	            if (Object.prototype.toString.call(propertyValue) === '[object Object]') {
	                if (parentKey !== 'Details' || propertyName !== 'Client') {
	                    filteredObject[propertyName] = filterObject(filterValue(propertyName, propertyValue), propertyName);
	                } else {
	                    filteredObject[propertyName] = propertyValue;
	                }
	            } else if (Object.prototype.toString.call(propertyValue) !== '[object Function]') {
	                if (typeof parentKey !== 'undefined') {
	                    filteredObject[propertyName] = filterValue(propertyName, propertyValue);
	                } else if (propertyName === 'OccurredOn') {
	                    filteredObject[propertyName] = propertyValue;
	                }
	            }
	        }
	
	        return filteredObject;
	    }
	
	    function processUnhandledException(stackTrace, options, userTriggered) {
	        var scriptError = 'Script error';
	
	        var stack = [],
	            qs = {};
	
	        if (_ignore3rdPartyErrors) {
	            if (!stackTrace.stack || !stackTrace.stack.length) {
	                _private.log('Raygun4JS: Cancelling send due to null stacktrace');
	                return;
	            }
	
	            var domain = _private.parseUrl('domain');
	
	            var msg = scriptError;
	            if (stackTrace.message) {
	                msg = stackTrace.message;
	            } else if (options && options.status) {
	                msg = options.status;
	            }
	
	            if (typeof msg === 'undefined') {
	                msg = scriptError;
	            }
	
	            if (msg.substring(0, scriptError.length) === scriptError &&
	                stackTrace.stack[0].url !== null &&
	                stackTrace.stack[0].url.indexOf(domain) === -1 &&
	                (stackTrace.stack[0].line === 0 || stackTrace.stack[0].func === '?')) {
	                _private.log('Raygun4JS: cancelling send due to third-party script error with no stacktrace and message');
	                return;
	            }
	
	
	            if (stackTrace.stack[0].url !== null && stackTrace.stack[0].url.indexOf(domain) === -1) {
	                var allowedDomainFound = false;
	
	                for (var i in _whitelistedScriptDomains) {
	                    if (stackTrace.stack[0].url.indexOf(_whitelistedScriptDomains[i]) > -1) {
	                        allowedDomainFound = true;
	                    }
	                }
	
	                if (!allowedDomainFound) {
	                    _private.log('Raygun4JS: cancelling send due to error on non-origin, non-whitelisted domain');
	
	                    return;
	                }
	            }
	        }
	
	        if (_excludedHostnames instanceof Array) {
	            for (var hostIndex in _excludedHostnames) {
	                if (_excludedHostnames.hasOwnProperty(hostIndex)) {
	                    if (window.location.hostname && window.location.hostname.match(_excludedHostnames[hostIndex])) {
	                        _private.log('Raygun4JS: cancelling send as error originates from an excluded hostname');
	
	                        return;
	                    }
	                }
	            }
	        }
	
	        if (_excludedUserAgents instanceof Array) {
	            for (var userAgentIndex in _excludedUserAgents) {
	                if (_excludedUserAgents.hasOwnProperty(userAgentIndex)) {
	                    if (navigator.userAgent.match(_excludedUserAgents[userAgentIndex])) {
	                        _private.log('Raygun4JS: cancelling send as error originates from an excluded user agent');
	
	                        return;
	                    }
	                }
	            }
	        }
	
	        if (navigator.userAgent.match("RaygunPulseInsightsCrawler"))
	        {
	            return;
	        }
	
	        if (stackTrace.stack && stackTrace.stack.length) {
	            forEach(stackTrace.stack, function (i, frame) {
	                stack.push({
	                    'LineNumber': frame.line,
	                    'ColumnNumber': frame.column,
	                    'ClassName': 'line ' + frame.line + ', column ' + frame.column,
	                    'FileName': frame.url,
	                    'MethodName': frame.func || '[anonymous]'
	                });
	            });
	        }
	
	        var queryString = _private.parseUrl('?');
	
	        if (queryString.length > 0) {
	            forEach(queryString.split('&'), function (i, segment) {
	                var parts = segment.split('=');
	                if (parts && parts.length === 2) {
	                    var key = decodeURIComponent(parts[0]);
	                    var value = filterValue(key, parts[1]);
	
	                    qs[key] = value;
	                }
	            });
	        }
	
	        if (options === undefined) {
	            options = {};
	        }
	
	        if (isEmpty(options.customData)) {
	            if (typeof _customData === 'function') {
	                options.customData = _customData();
	            } else {
	                options.customData = _customData;
	            }
	        }
	
	        if (isEmpty(options.tags)) {
	            if (typeof _tags === 'function') {
	                options.tags = _tags();
	            } else {
	                options.tags = _tags;
	            }
	        }
	
	        if (!userTriggered) {
	            if (!options.tags) {
	                options.tags = [];
	            }
	        
	            if (!contains(options.tags, 'UnhandledException')) {
	                options.tags.push('UnhandledException');
	            }
	        }
	
	        var screen = window.screen || {width: getViewPort().width, height: getViewPort().height, colorDepth: 8};
	        var custom_message = options.customData && options.customData.ajaxErrorMessage;
	
	        var finalCustomData;
	        if (_filterScope === 'customData') {
	            finalCustomData = filterObject(options.customData, 'UserCustomData');
	        } else {
	            finalCustomData = options.customData;
	        }
	
	        try {
	            JSON.stringify(finalCustomData);
	        } catch (e) {
	            var m = 'Cannot add custom data; may contain circular reference';
	            finalCustomData = {error: m};
	            _private.log('Raygun4JS: ' + m);
	        }
	
	        var finalMessage = scriptError;
	        if (custom_message) {
	            finalMessage = custom_message;
	        } else if (stackTrace.message) {
	            finalMessage = stackTrace.message;
	        } else if (options && options.status) {
	            finalMessage = options.status;
	        }
	
	        if (typeof finalMessage === 'undefined') {
	            finalMessage = scriptError;
	        }
	
	        if (finalMessage && (typeof finalMessage === 'string')) {
	            finalMessage = finalMessage.substring(0, 512);
	        }
	
	        var payload = {
	            'OccurredOn': new Date(),
	            'Details': {
	                'Error': {
	                    'ClassName': stackTrace.name,
	                    'Message': finalMessage,
	                    'StackTrace': stack
	                },
	                'Environment': {
	                    'UtcOffset': new Date().getTimezoneOffset() / -60.0,
	                    'User-Language': navigator.userLanguage,
	                    'Document-Mode': document.documentMode,
	                    'Browser-Width': getViewPort().width,
	                    'Browser-Height': getViewPort().height,
	                    'Screen-Width': screen.width,
	                    'Screen-Height': screen.height,
	                    'Color-Depth': screen.colorDepth,
	                    'Browser': navigator.appCodeName,
	                    'Browser-Name': navigator.appName,
	                    'Browser-Version': navigator.appVersion,
	                    'Platform': navigator.platform
	                },
	                'Client': {
	                    'Name': 'raygun-js',
	                    'Version': '2.5.3'
	                },
	                'UserCustomData': finalCustomData,
	                'Tags': options.tags,
	                'Request': {
	                    'Url': [location.protocol, '//', location.host, location.pathname, location.hash].join(''),
	                    'QueryString': qs,
	                    'Headers': {
	                        'User-Agent': navigator.userAgent,
	                        'Referer': document.referrer,
	                        'Host': document.domain
	                    }
	                },
	                'Version': _version || 'Not supplied'
	            }
	        };
	
	        payload.Details.User = _user;
	
	        if (_filterScope === 'all') {
	            payload = filterObject(payload);
	        }
	
	        if (typeof _groupingKeyCallback === 'function') {
	            _private.log('Raygun4JS: calling custom grouping key');
	            payload.Details.GroupingKey = _groupingKeyCallback(payload, stackTrace, options);
	        }
	
	        if (typeof _beforeSendCallback === 'function') {
	            var mutatedPayload = _beforeSendCallback(payload);
	
	            if (mutatedPayload) {
	                sendToRaygun(mutatedPayload);
	            }
	        } else {
	            sendToRaygun(payload);
	        }
	    }
	
	    function sendToRaygun(data) {
	        if (!isApiKeyConfigured()) {
	            return;
	        }
	
	        _private.log('Sending exception data to Raygun:', data);
	        var url = _raygunApiUrl + '/entries?apikey=' + encodeURIComponent(_raygunApiKey);
	        makePostCorsRequest(url, JSON.stringify(data));
	    }
	
	    // Create the XHR object.
	    function createCORSRequest(method, url) {
	        var xhr;
	
	        xhr = new window.XMLHttpRequest();
	
	        if ("withCredentials" in xhr) {
	            // XHR for Chrome/Firefox/Opera/Safari.
	            xhr.open(method, url, true);
	
	        } else if (window.XDomainRequest) {
	            // XDomainRequest for IE.
	            if (_allowInsecureSubmissions) {
	                // remove 'https:' and use relative protocol
	                // this allows IE8 to post messages when running
	                // on http
	                url = url.slice(6);
	            }
	
	            xhr = new window.XDomainRequest();
	            xhr.open(method, url);
	        }
	
	        xhr.timeout = 10000;
	
	        return xhr;
	    }
	
	    // Make the actual CORS request.
	    function makePostCorsRequest(url, data) {
	        var xhr = createCORSRequest('POST', url, data);
	
	        if (typeof _beforeXHRCallback === 'function') {
	            _beforeXHRCallback(xhr);
	        }
	
	        _private.log("Is offline enabled? " + _enableOfflineSave);
	
	        if ('withCredentials' in xhr) {
	
	            xhr.onreadystatechange = function () {
	                if (xhr.readyState !== 4) {
	                    return;
	                }
	
	                if (xhr.status === 202) {
	                    sendSavedErrors();
	                } else if (_enableOfflineSave && xhr.status !== 403 && xhr.status !== 400 && xhr.status !== 429) {
	                    offlineSave(url, data);
	                }
	            };
	
	            xhr.onload = function () {
	                _private.log('posted to Raygun');
	
	                callAfterSend(this);
	            };
	
	        } else if (window.XDomainRequest) {
	            xhr.ontimeout = function () {
	                if (_enableOfflineSave) {
	                    _private.log('Raygun: saved locally');
	                    offlineSave(url, data);
	                }
	            };
	
	            xhr.onload = function () {
	                _private.log('posted to Raygun');
	                
	                sendSavedErrors();
	                callAfterSend(this);
	            };
	        }
	
	        xhr.onerror = function () {
	            _private.log('failed to post to Raygun');
	
	            callAfterSend(this);
	        };
	
	        if (!xhr) {
	            _private.log('CORS not supported');
	            return;
	        }
	
	        xhr.send(data);
	    }
	
	    if (!window.Raygun) {
	        window.Raygun = Raygun;
	    }
	
	    // Mozilla's toISOString() shim for IE8
	    if (!Date.prototype.toISOString) {
	        (function () {
	            function pad(number) {
	                var r = String(number);
	                if (r.length === 1) {
	                    r = '0' + r;
	                }
	                return r;
	            }
	
	            Date.prototype.toISOString = function () {
	                return this.getUTCFullYear() + '-' + pad(this.getUTCMonth() + 1) + '-' + pad(this.getUTCDate()) + 'T' + pad(this.getUTCHours()) + ':' + pad(this.getUTCMinutes()) + ':' + pad(this.getUTCSeconds()) + '.' + String((this.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5) + 'Z';
	            };
	        }());
	    }
	
	    // Mozilla's bind() shim for IE8
	    if (!Function.prototype.bind) {
	        Function.prototype.bind = function (oThis) {
	            if (typeof this !== 'function') {
	                throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
	            }
	
	            var aArgs = Array.prototype.slice.call(arguments, 1),
	                fToBind = this,
	                FNOP = function () {
	                },
	                fBound = function () {
	                    return fToBind.apply(this instanceof FNOP && oThis ? this : oThis,
	                        aArgs.concat(Array.prototype.slice.call(arguments)));
	                };
	
	            FNOP.prototype = this.prototype;
	            fBound.prototype = new FNOP();
	
	            return fBound;
	        };
	    }
	
	    return Raygun;
	};
	
	window.__instantiatedRaygun = raygunFactory(window, window.jQuery);
	
	var raygunRumFactory = function (window, $, Raygun) {
	    Raygun.RealUserMonitoring = function (apiKey, apiUrl, makePostCorsRequest, user, version, excludedHostNames, excludedUserAgents, debugMode, maxVirtualPageDuration, ignoreUrlCasing) {
	        var self = this;
	        var _private = {};
	
	        this.cookieName = 'raygun4js-sid';
	        this.apiKey = apiKey;
	        this.apiUrl = apiUrl;
	        this.debugMode = debugMode;
	        this.excludedHostNames = excludedHostNames;
	        this.excludedUserAgents = excludedUserAgents;
	        this.maxVirtualPageDuration = maxVirtualPageDuration || 1800000; // 30 minutes
	        this.ignoreUrlCasing = ignoreUrlCasing;
	
	        this.makePostCorsRequest = function (url, data) {
	            if (self.excludedUserAgents instanceof Array) {
	                for (var userAgentIndex in self.excludedUserAgents) {
	                    if (self.excludedUserAgents.hasOwnProperty(userAgentIndex)) {
	                        if (navigator.userAgent.match(self.excludedUserAgents[userAgentIndex])) {
	                            if (self.debugMode) {
	                                log('Raygun4JS: cancelling send as error originates from an excluded user agent');
	                            }
	
	                            return;
	                        }
	                    }
	                }
	            }
	
	            if (self.excludedHostNames instanceof Array) {
	                for (var hostIndex in self.excludedHostNames) {
	                    if (self.excludedHostNames.hasOwnProperty(hostIndex)) {
	                        if (window.location.hostname && window.location.hostname.match(self.excludedHostNames[hostIndex])) {
	                            log('Raygun4JS: cancelling send as error originates from an excluded hostname');
	
	                            return;
	                        }
	                    }
	                }
	            }
	
	            if (navigator.userAgent.match("RaygunPulseInsightsCrawler"))
	            {
	                return;
	            }
	
	            makePostCorsRequest(url, data);
	        };
	        this.sessionId = null;
	        this.virtualPage = null;
	        this.user = user;
	        this.version = version;
	        this.heartBeatInterval = null;
	        this.offset = 0;
	
	        this.attach = function () {
	            getSessionId(function (isNewSession) {
	                self.pageLoaded(isNewSession);
	            });
	
	            var clickHandler = function () {
	                this.updateCookieTimestamp();
	            }.bind(_private);
	
	            var unloadHandler = function () {
	                var data = [];
	                extractChildData(data);
	
	                if (self.pendingVirtualPage) {
	                    data.push(self.pendingVirtualPage);
	                    extractChildData(data, true);
	                }
	
	                if (data.length > 0) {
	                    var payload = {
	                        eventData: [{
	                            sessionId: self.sessionId,
	                            timestamp: new Date().toISOString(),
	                            type: 'web_request_timing',
	                            user: self.user,
	                            version: self.version || 'Not supplied',
	                            device: navigator.userAgent,
	                            data: JSON.stringify(data)
	                        }]
	                    };
	
	                    self.makePostCorsRequest(self.apiUrl + '/events?apikey=' + encodeURIComponent(self.apiKey), JSON.stringify(payload));
	                }
	            };
	
	            var visibilityChangeHandler = function () {
	                if (document.visibilityState === 'visible') {
	                    this.updateCookieTimestamp();
	                }
	
	            }.bind(_private);
	
	            if (window.addEventListener) {
	                window.addEventListener('click', clickHandler);
	                document.addEventListener('visibilitychange', visibilityChangeHandler);
	                window.addEventListener('beforeunload', unloadHandler);
	            } else if (window.attachEvent) {
	                document.attachEvent('onclick', clickHandler);
	            }
	        };
	
	        this.pageLoaded = function (isNewSession) {
	            // Only create a session if we don't have one.
	            if (isNewSession) {
	                var payload = {
	                    eventData: [{
	                        sessionId: self.sessionId,
	                        timestamp: new Date().toISOString(),
	                        type: 'session_start',
	                        user: self.user,
	                        version: self.version || 'Not supplied',
	                        device: navigator.userAgent
	                    }]
	                };
	
	                self.makePostCorsRequest(self.apiUrl + '/events?apikey=' + encodeURIComponent(self.apiKey), JSON.stringify(payload));
	            }
	
	            self.sendPerformance(true, true);
	            self.heartBeat();
	
	            if (typeof window.performance === 'object' && typeof window.performance.now === 'function') {
	                self.initalStaticPageLoadTimestamp = window.performance.now();
	            } else {
	                self.initalStaticPageLoadTimestamp = 0;
	            }
	        };
	
	        this.setUser = function (user) {
	            self.user = user;
	        };
	
	        this.endSession = function () {
	            var payload = {
	                eventData: [{
	                    sessionId: self.sessionId,
	                    timestamp: new Date().toISOString(),
	                    type: 'session_end'
	
	                }]
	            };
	
	            self.makePostCorsRequest(self.apiUrl + '/events?apikey=' + encodeURIComponent(self.apiKey), JSON.stringify(payload));
	        };
	
	        this.heartBeat = function () {
	            self.heartBeatInterval = setInterval(function () {
	                var data = [];
	                var payload;
	
	                extractChildData(data, self.virtualPage);
	
	                if (data.length > 0) {
	                    var dataJson = JSON.stringify(data);
	
	                    if (stringToByteLength(dataJson) < 128000) { // 128kB payload size
	                        payload = {
	                            eventData: [{
	                                sessionId: self.sessionId,
	                                timestamp: new Date().toISOString(),
	                                type: 'web_request_timing',
	                                user: self.user,
	                                version: self.version || 'Not supplied',
	                                device: navigator.userAgent,
	                                data: dataJson
	                            }]
	                        };
	                    }
	                }
	
	                if (payload !== undefined) {
	                    self.makePostCorsRequest(self.apiUrl + '/events?apikey=' + encodeURIComponent(self.apiKey), JSON.stringify(payload));
	                }
	            }, 30 * 1000); // 30 seconds between heartbeats
	        };
	
	        this.virtualPageLoaded = function (path) {
	            var firstVirtualLoad = this.virtualPage == null;
	
	            if (typeof path === 'string') {
	                if (path.length > 0 && path[0] !== '/') {
	                    path = path + '/';
	                }
	
	                if (path.length > 800) {
	                    path = path.substring(0, 800);
	                }
	
	                this.virtualPage = path;
	            }
	
	            if (firstVirtualLoad) {
	                this.sendPerformance(true, false);
	            } else {
	                this.sendPerformance(false, false);
	            }
	
	            if (typeof path === 'string') {
	                if (typeof window.performance === 'object' && typeof window.performance.now === 'function') {
	                    this.previousVirtualPageLoadTimestamp = window.performance.now();
	                } else {
	                    this.previousVirtualPageLoadTimestamp = 0;
	                }
	            }
	        };
	
	        this.sendPerformance = function (flush, firstLoad) {
	            var performanceData = getPerformanceData(this.virtualPage, flush, firstLoad);
	
	            if (performanceData === null) {
	                return;
	            }
	
	            var payload = {
	                eventData: [{
	                    sessionId: self.sessionId,
	                    timestamp: new Date().toISOString(),
	                    type: 'web_request_timing',
	                    user: self.user,
	                    version: self.version || 'Not supplied',
	                    device: navigator.userAgent,
	                    data: JSON.stringify(performanceData)
	                }]
	            };
	
	            self.makePostCorsRequest(self.apiUrl + '/events?apikey=' + encodeURIComponent(self.apiKey), JSON.stringify(payload));
	        };
	
	        function stringToByteLength(str) {
	            var m = encodeURIComponent(str).match(/%[89ABab]/g);
	            return str.length + (m ? m.length : 0);
	        }
	
	        function getSessionId(callback) {
	            var existingCookie = readCookie(self.cookieName);
	
	            var nullCookie = existingCookie === null;
	            var legacyCookie = typeof exisitingCookie === 'string' &&
	                existingCookie.length > 0 &&
	                existingCookie.indexOf('timestamp') === -1;
	            var expiredCookie = null;
	
	            if (!nullCookie && !legacyCookie) {
	                var existingTimestamp = new Date(readSessionCookieElement(existingCookie, 'timestamp'));
	                var halfHrAgo = new Date(new Date() - 30 * 60000);
	                expiredCookie = existingTimestamp < halfHrAgo;
	            }
	
	            if (nullCookie || legacyCookie || expiredCookie) {
	                self.sessionId = randomKey(32);
	                createCookie(self.cookieName, self.sessionId);
	                callback(true);
	            } else {
	                var sessionCookie = readCookie(self.cookieName);
	                var id = readSessionCookieElement(sessionCookie, 'id');
	
	                if (id === 'undefined') {
	                    self.sessionId = randomKey(32);
	                    createCookie(self.cookieName, self.sessionId);
	                    callback(true);
	                } else {
	                    self.sessionId = id;
	                    callback(false);
	                }
	            }
	        }
	
	        function createCookie(name, value, hours) {
	            var expires;
	            var lastActivityTimestamp;
	
	            if (hours) {
	                var date = new Date();
	                date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
	                expires = "; expires=" + date.toGMTString();
	            }
	            else {
	                expires = "";
	            }
	
	            lastActivityTimestamp = new Date().toISOString();
	
	            document.cookie = name + "=id|" + value + "&timestamp|" + lastActivityTimestamp + expires + "; path=/";
	        }
	
	        function readSessionCookieElement(cookieString, element) {
	            var set = cookieString.split(/[|&]/);
	
	            if (element === 'id') {
	                return set[1];
	            } else if (element === 'timestamp') {
	                return set[3];
	            }
	        }
	
	        function readCookie(name) {
	            var nameEQ = name + "=";
	            var ca = document.cookie.split(';');
	            for (var i = 0; i < ca.length; i++) {
	                var c = ca[i];
	                while (c.charAt(0) === ' ') {
	                    c = c.substring(1, c.length);
	                }
	                if (c.indexOf(nameEQ) === 0) {
	                    return c.substring(nameEQ.length, c.length);
	                }
	            }
	            return null;
	        }
	
	        function updateCookieTimestamp() {
	            var existingCookie = readCookie(self.cookieName);
	
	            var expiredCookie;
	            if (existingCookie) {
	                var timestamp = new Date(readSessionCookieElement(existingCookie, 'timestamp'));
	                var halfHrAgo = new Date(new Date() - 30 * 60000); // 30 mins
	                expiredCookie = timestamp < halfHrAgo;
	            }
	            else {
	                expiredCookie = true;
	            }
	
	            if (expiredCookie) {
	                self.sessionId = randomKey(32);
	            }
	
	            createCookie(self.cookieName, self.sessionId);
	
	            if (expiredCookie) {
	                self.pageLoaded(true);
	            }
	        }
	
	        function maxFiveMinutes(milliseconds) {
	            return Math.min(milliseconds, 300000);
	        }
	
	        function sanitizeNaNs(data) {
	            for (var i in data) {
	                if (isNaN(data[i]) && typeof data[i] !== 'string') {
	                    data[i] = 0;
	                }
	            }
	
	            return data;
	        }
	
	        function generateVirtualEncodedTimingData(previousVirtualPageLoadTimestamp, initalStaticPageLoadTimestamp) {
	            var now;
	            if (typeof window.performance === 'object' && typeof window.performance.now === 'function') {
	                now = window.performance.now();
	            } else {
	                now = 0;
	            }
	
	            return {
	                t: 'v',
	                du: Math.min(self.maxVirtualPageDuration, now - (previousVirtualPageLoadTimestamp || initalStaticPageLoadTimestamp)),
	                o: Math.min(self.maxVirtualPageDuration, now - initalStaticPageLoadTimestamp)
	            };
	        }
	
	        function getEncodedTimingData(timing, offset) {
	            var data = {
	                du: timing.duration,
	                t: 'p'
	            };
	
	            data.a = offset + timing.fetchStart;
	
	            if (timing.domainLookupStart && timing.domainLookupStart > 0) {
	                data.b = (offset + timing.domainLookupStart) - data.a;
	            }
	
	            if (timing.domainLookupEnd && timing.domainLookupEnd > 0) {
	                data.c = (offset + timing.domainLookupEnd) - data.a;
	            }
	
	            if (timing.connectStart && timing.connectStart > 0) {
	                data.d = (offset + timing.connectStart) - data.a;
	            }
	
	            if (timing.connectEnd && timing.connectEnd > 0) {
	                data.e = (offset + timing.connectEnd) - data.a;
	            }
	
	            if (timing.responseStart && timing.responseStart > 0) {
	                data.f = (offset + timing.responseStart) - data.a;
	            }
	
	            if (timing.responseEnd && timing.responseEnd > 0) {
	                data.g = (offset + timing.responseEnd) - data.a;
	            }
	
	            if (timing.domLoading && timing.domLoading > 0) {
	                data.h = (offset + timing.domLoading) - data.a;
	            }
	
	            if (timing.domInteractive && timing.domInteractive > 0) {
	                data.i = (offset + timing.domInteractive) - data.a;
	            }
	
	            if (timing.domContentLoadedEventEnd && timing.domContentLoadedEventEnd > 0) {
	                data.j = (offset + timing.domContentLoadedEventEnd) - data.a;
	            }
	
	            if (timing.domComplete && timing.domComplete > 0) {
	                data.k = maxFiveMinutes((offset + timing.domComplete) - data.a);
	            }
	
	            if (timing.loadEventStart && timing.loadEventStart > 0) {
	                data.l = (offset + timing.loadEventStart) - data.a;
	            }
	
	            if (timing.loadEventEnd && timing.loadEventEnd > 0) {
	                data.m = (offset + timing.loadEventEnd) - data.a;
	            }
	
	            if (timing.secureConnectionStart && timing.secureConnectionStart > 0) {
	                data.n = (offset + (timing.secureConnectionStart - timing.connectStart)) - data.a;
	            }
	
	            data = sanitizeNaNs(data);
	
	            return data;
	        }
	
	        function getSecondaryEncodedTimingData(timing, offset) {
	            var data = {
	                du: maxFiveMinutes(timing.duration).toFixed(2),
	                t: timing.initiatorType === 'xmlhttprequest' ? 'x' : timing.duration === 0.0 ? 'e' : 'c',
	                a: (offset + timing.fetchStart).toFixed(2)
	            };
	
	            if (timing.domainLookupStart && timing.domainLookupStart > 0) {
	                data.b = (offset + timing.domainLookupStart) - data.a;
	            }
	
	            if (timing.domainLookupEnd && timing.domainLookupEnd > 0) {
	                data.c = (offset + timing.domainLookupEnd) - data.a;
	            }
	
	            if (timing.connectStart && timing.connectStart > 0) {
	                data.d = (offset + timing.connectStart) - data.a;
	            }
	
	            if (timing.connectEnd && timing.connectEnd > 0) {
	                data.e = (offset + timing.connectEnd) - data.a;
	            }
	
	            if (timing.responseStart && timing.responseStart > 0) {
	                data.f = (offset + timing.responseStart) - data.a;
	            }
	
	            if (timing.responseEnd && timing.responseEnd > 0) {
	                data.g = (offset + timing.responseEnd) - data.a;
	            }
	
	            if (timing.secureConnectionStart && timing.secureConnectionStart > 0) {
	                data.n = (offset + (timing.secureConnectionStart - timing.connectStart)) - data.a;
	            }
	
	            data = sanitizeNaNs(data);
	
	            return data;
	        }
	
	        function getPrimaryTimingData() {
	            var pathName = window.location.pathname;
	
	            if (self.ignoreUrlCasing) {
	                pathName = pathName.toLowerCase();
	            }
	
	            var url = window.location.protocol + '//' + window.location.host + pathName;
	
	            if (url.length > 800) {
	                url = url.substring(0, 800);
	            }
	
	            return {
	                url: url,
	                userAgent: navigator.userAgent,
	                timing: getEncodedTimingData(window.performance.timing, 0),
	                size: 0
	            };
	        }
	
	        function getVirtualPrimaryTimingData(virtualPage, previousVirtualPageLoadTimestamp, initalStaticPageLoadTimestamp) {
	            if (self.ignoreUrlCasing) {
	                virtualPage = virtualPage.toLowerCase();
	            }
	
	            var url = window.location.protocol + '//' + window.location.host + virtualPage;
	
	            if (url.length > 800) {
	                url = url.substring(0, 800);
	            }
	
	            return {
	                url: url,
	                userAgent: navigator.userAgent,
	                timing: generateVirtualEncodedTimingData(previousVirtualPageLoadTimestamp, initalStaticPageLoadTimestamp),
	                size: 0
	            };
	        }
	
	        function getSecondaryTimingData(timing, fromZero) {
	            var url = timing.name.split('?')[0];
	
	            if (self.ignoreUrlCasing) {
	                url = url.toLowerCase();
	            }
	
	            if (url.length > 800) {
	                url = url.substring(0, 800);
	            }
	
	            return {
	                url: url,
	                timing: getSecondaryEncodedTimingData(timing, fromZero ? 0 : window.performance.timing.navigationStart),
	                size: timing.decodedBodySize || 0
	            };
	        }
	
	        function extractChildData(collection, fromVirtualPage) {
	            if (window.performance === undefined || !window.performance.getEntries) {
	                return;
	            }
	
	            try {
	                var resources = window.performance.getEntries();
	
	                for (var i = self.offset; i < resources.length; i++) {
	                    var segment = resources[i].name.split('?')[0];
	
	                    // swallow any calls to Raygun itself
	                    if (segment.indexOf(self.apiUrl) === 0) {
	                        continue;
	                    }
	
	                    // Other ignored calls
	                    if (segment.indexOf('favicon.ico') > 0) {
	                        continue;
	                    }
	                    if (segment.indexOf('about:blank') === 0) {
	                        continue;
	                    }
	                    if (segment[0] === 'j' && segment.indexOf('avascript:') === 1) {
	                        continue;
	                    }
	                    if (segment.indexOf('chrome-extension://') === 0) {
	                        continue;
	                    }
	                    if (segment.indexOf('res://') === 0) {
	                        continue;
	                    }
	                    if (segment.indexOf('file://') === 0) {
	                        continue;
	                    }
	
	                    collection.push(getSecondaryTimingData(resources[i], fromVirtualPage));
	                }
	
	                self.offset = resources.length;
	            }
	            catch (e) {
	            }
	        }
	
	        function getPerformanceData(virtualPage, flush, firstLoad) {
	            if (window.performance === undefined || window.performance.timing === undefined ||
	                window.performance.timing.fetchStart === undefined || isNaN(window.performance.timing.fetchStart)) {
	                return null;
	            }
	
	            var data = [];
	
	            if (flush) {
	                // Called by the static onLoad event being fired, persist itself
	                if (firstLoad) {
	                    data.push(getPrimaryTimingData());
	                }
	
	                // Called during both the static load event and the flush on the first virtual load call
	                extractChildData(data);
	            }
	
	            if (virtualPage) {
	                // A previous virtual load was stored, persist it and its children up until now
	                if (self.pendingVirtualPage) {
	                    data.push(self.pendingVirtualPage);
	                    extractChildData(data, true);
	                }
	
	                var firstVirtualLoad = self.pendingVirtualPage == null;
	
	                // Store the current virtual load so it can be sent upon the next one
	                self.pendingVirtualPage = getVirtualPrimaryTimingData(
	                    virtualPage,
	                    self.previousVirtualPageLoadTimestamp,
	                    self.initalStaticPageLoadTimestamp
	                );
	
	                // Prevent sending an empty payload for the first virtual load as we don't know when it will end
	                if (!firstVirtualLoad && data.length > 0) {
	                    return data;
	                }
	            }
	
	            return data;
	        }
	
	        function randomKey(length) {
	            return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
	        }
	
	        function log(message, data) {
	            if (window.console && window.console.log && self.debugMode) {
	                window.console.log(message);
	
	                if (data) {
	                    window.console.log(data);
	                }
	            }
	        }
	
	        _private.updateCookieTimestamp = updateCookieTimestamp;
	    };
	};
	
	raygunRumFactory(window, window.jQuery, window.__instantiatedRaygun);
	
	// js-url - see LICENSE file
	
	var raygunJsUrlFactory = function (window, Raygun) {
	
	  Raygun._private.parseUrl = function(arg, url) {
	    function isNumeric(arg) {
	      return !isNaN(parseFloat(arg)) && isFinite(arg);
	    }
	
	    return (function(arg, url) {
	        var _ls = url || window.location.toString();
	
	        if (!arg) { return _ls; }
	        else { arg = arg.toString(); }
	
	        if (_ls.substring(0,2) === '//') { _ls = 'http:' + _ls; }
	        else if (_ls.split('://').length === 1) { _ls = 'http://' + _ls; }
	
	        url = _ls.split('/');
	        var _l = {auth:''}, host = url[2].split('@');
	
	        if (host.length === 1) { host = host[0].split(':'); }
	        else { _l.auth = host[0]; host = host[1].split(':'); }
	
	        _l.protocol=url[0];
	        _l.hostname=host[0];
	        _l.port=(host[1] || ((_l.protocol.split(':')[0].toLowerCase() === 'https') ? '443' : '80'));
	        _l.pathname=( (url.length > 3 ? '/' : '') + url.slice(3, url.length).join('/').split('?')[0].split('#')[0]);
	        var _p = _l.pathname;
	
	        if (_p.charAt(_p.length-1) === '/') { _p=_p.substring(0, _p.length-1); }
	        var _h = _l.hostname, _hs = _h.split('.'), _ps = _p.split('/');
	
	        if (arg === 'hostname') { return _h; }
	        else if (arg === 'domain') {
	            if (/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(_h)) { return _h; }
	            return _hs.slice(-2).join('.');
	        }
	        //else if (arg === 'tld') { return _hs.slice(-1).join('.'); }
	        else if (arg === 'sub') { return _hs.slice(0, _hs.length - 2).join('.'); }
	        else if (arg === 'port') { return _l.port; }
	        else if (arg === 'protocol') { return _l.protocol.split(':')[0]; }
	        else if (arg === 'auth') { return _l.auth; }
	        else if (arg === 'user') { return _l.auth.split(':')[0]; }
	        else if (arg === 'pass') { return _l.auth.split(':')[1] || ''; }
	        else if (arg === 'path') { return _l.pathname; }
	        else if (arg.charAt(0) === '.')
	        {
	            arg = arg.substring(1);
	            if(isNumeric(arg)) {arg = parseInt(arg, 10); return _hs[arg < 0 ? _hs.length + arg : arg-1] || ''; }
	        }
	        else if (isNumeric(arg)) { arg = parseInt(arg, 10); return _ps[arg < 0 ? _ps.length + arg : arg] || ''; }
	        else if (arg === 'file') { return _ps.slice(-1)[0]; }
	        else if (arg === 'filename') { return _ps.slice(-1)[0].split('.')[0]; }
	        else if (arg === 'fileext') { return _ps.slice(-1)[0].split('.')[1] || ''; }
	        else if (arg.charAt(0) === '?' || arg.charAt(0) === '#')
	        {
	            var params = _ls, param = null;
	
	            if(arg.charAt(0) === '?') { params = (params.split('?')[1] || '').split('#')[0]; }
	            else if(arg.charAt(0) === '#') { params = (params.split('#')[1] || ''); }
	
	            if(!arg.charAt(1)) { return params; }
	
	            arg = arg.substring(1);
	            params = params.split('&');
	
	            for(var i=0,ii=params.length; i<ii; i++)
	            {
	                param = params[i].split('=');
	                if(param[0] === arg) { return param[1] || ''; }
	            }
	
	            return null;
	        }
	
	        return '';
	    })(arg, url);
	};
	
	};
	
	raygunJsUrlFactory(window, window.__instantiatedRaygun);
	window.__instantiatedRaygun._seal();
	(function (window, Raygun) {
	  if (!window['RaygunObject'] || !window[window['RaygunObject']]) {
	    return;
	  }
	
	  var snippetOptions = window[window['RaygunObject']].o;
	  var hasLoaded = false,
	    errorQueue,
	    delayedCommands = [],
	    apiKey,
	    options,
	    attach,
	    enablePulse,
	    noConflict;
	
	var snippetOnErrorSignature = ["function (b,c,d,f,g){", "||(g=new Error(b)),a[e].q=a[e].q||[]"];
	
	  errorQueue = window[window['RaygunObject']].q;
	  var rg = Raygun;
	
	  var delayedExecutionFunctions = ['trackEvent', 'send'];
	
	  var parseSnippetOptions = function () {
	    snippetOptions = window[window['RaygunObject']].o;
	    
	    for (var i in snippetOptions) {
	      var pair = snippetOptions[i];
	      if (pair) {
	        if (delayedExecutionFunctions.indexOf(pair[0]) === -1) {
	          // Config pair, can execute immediately
	          executor(pair);
	        } else {
	          // Action (posting) pair which requires lib to be fully parsed, delay till after Raygun obj has been init'd
	          delayedCommands.push(pair);
	        }
	      }
	    }
	  };
	
	  var executor = function (pair) {
	    var key = pair[0];
	    var value = pair[1];
	
	    if (key) {
	      switch (key) {
	        // Immediate execution config functions
	        case 'noConflict':
	          noConflict = value;
	          break;
	        case 'apiKey':
	          apiKey = value;
	          hasLoaded = true;
	          break;
	        case 'options':
	          options = value;
	          break;
	        case 'attach':
	        case 'enableCrashReporting':
	          attach = value;
	          hasLoaded = true;
	          break;
	        case 'enablePulse':
	          enablePulse = value;
	          hasLoaded = true;
	          break;
	        case 'detach':
	          rg.detach();
	          break;
	        case 'getRaygunInstance':
	          return rg;
	        case 'setUser':
	          rg.setUser(value.identifier, value.isAnonymous, value.email, value.fullName, value.firstName, value.uuid);
	          break;
	        case 'onBeforeSend':
	          rg.onBeforeSend(value);
	          break;
	        case 'onBeforeXHR':
	          rg.onBeforeXHR(value);
	          break;
	        case 'onAfterSend':
	          rg.onAfterSend(value);
	          break;
	        case 'withCustomData':
	          rg.withCustomData(value);
	          break;
	        case 'withTags':
	          rg.withTags(value);
	          break;
	        case 'setVersion':
	          rg.setVersion(value);
	          break;
	        case 'filterSensitiveData':
	          rg.filterSensitiveData(value);
	          break;
	        case 'setFilterScope':
	          rg.setFilterScope(value);
	          break;
	        case 'whitelistCrossOriginDomains':
	          rg.whitelistCrossOriginDomains(value);
	          break;
	        case 'saveIfOffline':
	          if (typeof value === 'boolean') {
	            rg.saveIfOffline(value);
	          }
	          break;
	        case 'groupingKey':
	          rg.groupingKey(value);
	          break;
	
	        // Delayed execution functions
	        case 'send':
	          var error, tags, customData;
	          if (value.error) {
	            error = value.error;
	
	            if (value.tags) {
	              tags = value.tags;
	            }
	            if (value.customData) {
	              customData = value.customData;
	            }
	          } else {
	            error = value;
	          }
	          rg.send(error, customData, tags);
	          break;
	        case 'trackEvent':
	          if (value.type && value.path) {
	            rg.trackEvent(value.type, { path: value.path });
	          }
	          break;
	      }
	    }
	  };
	
	  var onLoadHandler = function () {
	    parseSnippetOptions();
	
	    if (noConflict) {
	      rg = Raygun.noConflict();
	    }
	    
	    if (apiKey) {
	      if (!options) {
	        options = {};
	      }
	
	      if (enablePulse) {
	        options.disablePulse = false;
	      }
	
	      options.from = 'onLoad';
	      rg.init(apiKey, options, null);
	    }
	
	    if (attach) {
	      rg.attach();
	
	      errorQueue = window[window['RaygunObject']].q;
	      for (var j in errorQueue) {
	        rg.send(errorQueue[j].e, { handler: 'From Raygun4JS snippet global error handler' });
	      }
	    } else if (typeof window.onerror === 'function') {
	      var onerrorSignature = window.onerror.toString(); 
	      if (onerrorSignature.indexOf(snippetOnErrorSignature[0]) !== -1 && onerrorSignature.indexOf(snippetOnErrorSignature[1]) !== -1) {
	        window.onerror = null;
	      }
	    }
	
	    for (var commandIndex in delayedCommands) {
	      executor(delayedCommands[commandIndex]);
	    }
	
	    delayedCommands = [];
	
	    window[window['RaygunObject']] = function () {
	      return executor(arguments);
	    };
	    window[window['RaygunObject']].q = errorQueue;
	  };
	
	  if (document.readyState === 'complete') {
	    onLoadHandler();
	  } else if (window.addEventListener) {
	    window.addEventListener('load', onLoadHandler);
	  } else {
	    window.attachEvent('onload', onLoadHandler);
	  }
	
	})(window, window.__instantiatedRaygun);
	
	try 
	{ 
	    delete window.__instantiatedRaygun;
	} 
	catch(e) 
	{ 
	    window["__instantiatedRaygun"] = undefined; 
	}
	    
	    return window.rg4js;
	}));

/***/ },
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var createReactClass = __webpack_require__(867)
	var objectAssign = __webpack_require__(23)
	
	var createReactTimeout = function (React) {
	  var GLOBAL = typeof window === 'undefined' ? global : window
	
	  var setter = function (_setter, _clearer, array) {
	    return function (callback, delta) {
	      var id = _setter(function () {
	        _clearer.call(this, id)
	        callback.apply(this, arguments)
	      }.bind(this), delta)
	
	      if (!this[array]) {
	        this[array] = [id]
	      } else {
	        this[array].push(id)
	      }
	      return id
	    }
	  }
	
	  var clearer = function (_clearer, array) {
	    return function (id) {
	      if (this[array]) {
	        var index = this[array].indexOf(id)
	        if (index !== -1) {
	          this[array].splice(index, 1)
	        }
	      }
	      _clearer(id)
	    }
	  }
	
	  var _timeouts = '_ReactTimeout_timeouts'
	  var _clearTimeout = clearer(GLOBAL.clearTimeout, _timeouts)
	  var _setTimeout = setter(GLOBAL.setTimeout, _clearTimeout, _timeouts)
	
	  var _intervals = '_ReactTimeout_intervals'
	  var _clearInterval = clearer(GLOBAL.clearInterval, _intervals)
	  var _setInterval = setter(GLOBAL.setInterval, function () {}, _intervals)
	
	  var _immediates = '_ReactTimeout_immediates'
	  var _clearImmediate = clearer(GLOBAL.clearImmediate, _immediates)
	  var _setImmediate = setter(GLOBAL.setImmediate, _clearImmediate, _immediates)
	
	  var _rafs = '_ReactTimeout_rafs'
	  var _cancelAnimationFrame = clearer(GLOBAL.cancelAnimationFrame, _rafs)
	  var _requestAnimationFrame = setter(GLOBAL.requestAnimationFrame, _cancelAnimationFrame, _rafs)
	
	  var cloneArray = function (a) {
	    return (!a || typeof a.slice !== 'function') ? [] : a.slice(0)
	  }
	
	  var ReactTimeout = function (SourceComponent) {
	    return createReactClass({
	      displayName: 'ReactTimeout',
	
	      setTimeout: _setTimeout,
	      clearTimeout: _clearTimeout,
	
	      setInterval: _setInterval,
	      clearInterval: _clearInterval,
	
	      setImmediate: _setImmediate,
	      clearImmediate: _clearImmediate,
	
	      requestAnimationFrame: _requestAnimationFrame,
	      cancelAnimationFrame: _cancelAnimationFrame,
	
	      componentWillUnmount: function () {
	        cloneArray(this[_timeouts]).forEach(this.clearTimeout)
	        cloneArray(this[_intervals]).forEach(this.clearInterval)
	        cloneArray(this[_immediates]).forEach(this.clearImmediate)
	        cloneArray(this[_rafs]).forEach(this.cancelAnimationFrame)
	      },
	
	      render: function () {
	        return React.createElement(
	          SourceComponent,
	          objectAssign(
	            {},
	            this.props,
	            {
	              setTimeout: this.setTimeout,
	              clearTimeout: this.clearTimeout,
	
	              setInterval: this.setInterval,
	              clearInterval: this.clearInterval,
	
	              setImmediate: this.setImmediate,
	              clearImmediate: this.clearImmediate,
	
	              requestAnimationFrame: this.requestAnimationFrame,
	              cancelAnimationFrame: this.cancelAnimationFrame
	            }))
	      }
	    })
	  }
	
	  return ReactTimeout
	}
	
	module.exports = createReactTimeout
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(10);
	
	var _createFieldProps2 = __webpack_require__(475);
	
	var _createFieldProps3 = _interopRequireDefault(_createFieldProps2);
	
	var _onChangeValue = __webpack_require__(481);
	
	var _onChangeValue2 = _interopRequireDefault(_onChangeValue);
	
	var _eventConsts = __webpack_require__(1336);
	
	var _plain = __webpack_require__(86);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _isReactNative = __webpack_require__(483);
	
	var _isReactNative2 = _interopRequireDefault(_isReactNative);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	var isObject = function isObject(entity) {
	  return entity && (typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) === 'object';
	};
	
	var isFunction = function isFunction(entity) {
	  return entity && typeof entity === 'function';
	};
	
	var eventPreventDefault = function eventPreventDefault(event) {
	  if (isObject(event) && isFunction(event.preventDefault)) {
	    event.preventDefault();
	  }
	};
	
	var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
	  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
	    return event.dataTransfer.getData(key);
	  }
	};
	
	var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
	  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
	    event.dataTransfer.setData(key, value);
	  }
	};
	
	var createConnectedField = function createConnectedField(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    var error = _plain2.default.getIn(syncErrors, name);
	    // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	    return error && error._error ? error._error : error;
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = getIn(syncWarnings, name);
	    // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	    return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedField = function (_Component) {
	    _inherits(ConnectedField, _Component);
	
	    function ConnectedField() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, ConnectedField);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedField.__proto__ || Object.getPrototypeOf(ConnectedField)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
	        return _this.ref = ref;
	      }, _this.isPristine = function () {
	        return _this.props.pristine;
	      }, _this.getValue = function () {
	        return _this.props.value;
	      }, _this.handleChange = function (event) {
	        var _this$props = _this.props,
	            name = _this$props.name,
	            dispatch = _this$props.dispatch,
	            parse = _this$props.parse,
	            normalize = _this$props.normalize,
	            onChange = _this$props.onChange,
	            _reduxForm = _this$props._reduxForm,
	            previousValue = _this$props.value;
	
	        var newValue = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize });
	
	        var defaultPrevented = false;
	        if (onChange) {
	          // Can't seem to find a way to extend Event in React Native,
	          // thus I simply avoid adding preventDefault() in a RN environment
	          // to prevent the following error:
	          // `One of the sources for assign has an enumerable key on the prototype chain`
	          // Reference: https://github.com/facebook/react-native/issues/5507
	          if (!_isReactNative2.default) {
	            onChange(_extends({}, event, {
	              preventDefault: function preventDefault() {
	                defaultPrevented = true;
	                return eventPreventDefault(event);
	              }
	            }), newValue, previousValue);
	          } else {
	            onChange(event, newValue, previousValue);
	          }
	        }
	        if (!defaultPrevented) {
	          // dispatch change action
	          dispatch(_reduxForm.change(name, newValue));
	        }
	      }, _this.handleFocus = function (event) {
	        var _this$props2 = _this.props,
	            name = _this$props2.name,
	            dispatch = _this$props2.dispatch,
	            onFocus = _this$props2.onFocus,
	            _reduxForm = _this$props2._reduxForm;
	
	
	        var defaultPrevented = false;
	        if (onFocus) {
	          if (!_isReactNative2.default) {
	            onFocus(_extends({}, event, {
	              preventDefault: function preventDefault() {
	                defaultPrevented = true;
	                return eventPreventDefault(event);
	              }
	            }));
	          } else {
	            onFocus(event);
	          }
	        }
	
	        if (!defaultPrevented) {
	          dispatch(_reduxForm.focus(name));
	        }
	      }, _this.handleBlur = function (event) {
	        var _this$props3 = _this.props,
	            name = _this$props3.name,
	            dispatch = _this$props3.dispatch,
	            parse = _this$props3.parse,
	            normalize = _this$props3.normalize,
	            onBlur = _this$props3.onBlur,
	            _reduxForm = _this$props3._reduxForm,
	            _value = _this$props3._value,
	            previousValue = _this$props3.value;
	
	        var newValue = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize });
	
	        // for checkbox and radio, if the value property of checkbox or radio equals
	        // the value passed by blur event, then fire blur action with previousValue.
	        if (newValue === _value && _value !== undefined) {
	          newValue = previousValue;
	        }
	
	        var defaultPrevented = false;
	        if (onBlur) {
	          if (!_isReactNative2.default) {
	            onBlur(_extends({}, event, {
	              preventDefault: function preventDefault() {
	                defaultPrevented = true;
	                return eventPreventDefault(event);
	              }
	            }), newValue, previousValue);
	          } else {
	            onBlur(event, newValue, previousValue);
	          }
	        }
	
	        if (!defaultPrevented) {
	          // dispatch blur action
	          dispatch(_reduxForm.blur(name, newValue));
	
	          // call post-blur callback
	          if (_reduxForm.asyncValidate) {
	            _reduxForm.asyncValidate(name, newValue);
	          }
	        }
	      }, _this.handleDragStart = function (event) {
	        var _this$props4 = _this.props,
	            onDragStart = _this$props4.onDragStart,
	            value = _this$props4.value;
	
	        eventDataTransferSetData(event, _eventConsts.dataKey, value == null ? '' : value);
	
	        if (onDragStart) {
	          onDragStart(event);
	        }
	      }, _this.handleDrop = function (event) {
	        var _this$props5 = _this.props,
	            name = _this$props5.name,
	            dispatch = _this$props5.dispatch,
	            onDrop = _this$props5.onDrop,
	            _reduxForm = _this$props5._reduxForm,
	            previousValue = _this$props5.value;
	
	        var newValue = eventDataTransferGetData(event, _eventConsts.dataKey);
	
	        var defaultPrevented = false;
	        if (onDrop) {
	          onDrop(_extends({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return eventPreventDefault(event);
	            }
	          }), newValue, previousValue);
	        }
	
	        if (!defaultPrevented) {
	          // dispatch change action
	          dispatch(_reduxForm.change(name, newValue));
	          eventPreventDefault(event);
	        }
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ConnectedField, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this2 = this;
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        // if we have children, we MUST update in React 16
	        // https://twitter.com/erikras/status/915866544558788608
	        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	        }));
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.ref;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            component = _props.component,
	            withRef = _props.withRef,
	            name = _props.name,
	            _reduxForm = _props._reduxForm,
	            normalize = _props.normalize,
	            onBlur = _props.onBlur,
	            onChange = _props.onChange,
	            onFocus = _props.onFocus,
	            onDragStart = _props.onDragStart,
	            onDrop = _props.onDrop,
	            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'normalize', 'onBlur', 'onChange', 'onFocus', 'onDragStart', 'onDrop']);
	
	        var _createFieldProps = (0, _createFieldProps3.default)(structure, name, _extends({}, rest, {
	          form: _reduxForm.form,
	          onBlur: this.handleBlur,
	          onChange: this.handleChange,
	          onDrop: this.handleDrop,
	          onDragStart: this.handleDragStart,
	          onFocus: this.handleFocus
	        })),
	            custom = _createFieldProps.custom,
	            props = _objectWithoutProperties(_createFieldProps, ['custom']);
	
	        if (withRef) {
	          custom.ref = this.saveRef;
	        }
	        if (typeof component === 'string') {
	          var input = props.input,
	              meta = props.meta; // eslint-disable-line no-unused-vars
	          // flatten input into other props
	
	          return (0, _react.createElement)(component, _extends({}, input, custom));
	        } else {
	          return (0, _react.createElement)(component, _extends({}, props, custom));
	        }
	      }
	    }]);
	
	    return ConnectedField;
	  }(_react.Component);
	
	  ConnectedField.propTypes = {
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	    props: _propTypes2.default.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    var initialState = getIn(formState, 'initial.' + name);
	    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	    var value = getIn(formState, 'values.' + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(formState, 'asyncErrors.' + name),
	      asyncValidating: getIn(formState, 'asyncValidating') === name,
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, 'fields.' + name),
	      submitError: getIn(formState, 'submitErrors.' + name),
	      submitFailed: getIn(formState, 'submitFailed'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      initial: initial,
	      value: value,
	      _value: ownProps.value // save value passed in (for checkboxes)
	    };
	  }, undefined, undefined, { withRef: true });
	  return connector(ConnectedField);
	};
	
	exports.default = createConnectedField;

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mapValues2 = __webpack_require__(415);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _createFieldArrayProps = __webpack_require__(1275);
	
	var _createFieldArrayProps2 = _interopRequireDefault(_createFieldArrayProps);
	
	var _plain = __webpack_require__(86);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm', 'value'];
	
	var createConnectedFieldArray = function createConnectedFieldArray(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn,
	      size = structure.size;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    // For an array, the error can _ONLY_ be under _error.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return _plain2.default.getIn(syncErrors, name + '._error');
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    // For an array, the warning can _ONLY_ be under _warning.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return getIn(syncWarnings, name + '._warning');
	  };
	
	  var ConnectedFieldArray = function (_Component) {
	    _inherits(ConnectedFieldArray, _Component);
	
	    function ConnectedFieldArray() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, ConnectedFieldArray);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedFieldArray.__proto__ || Object.getPrototypeOf(ConnectedFieldArray)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
	        _this.ref = ref;
	      }, _this.getValue = function (index) {
	        return _this.props.value && getIn(_this.props.value, String(index));
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ConnectedFieldArray, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this2 = this;
	
	        // Update if the elements of the value array was updated.
	        var thisValue = this.props.value;
	        var nextValue = nextProps.value;
	
	        if (thisValue && nextValue) {
	          var nextValueItemsSame = nextValue.every(function (val) {
	            return thisValue.includes(val);
	          });
	          var nextValueItemsOrderChanged = nextValue.some(function (val, index) {
	            return val !== thisValue[index];
	          });
	          if (thisValue.length !== nextValue.length || nextValueItemsSame && nextValueItemsOrderChanged || nextProps.rerenderOnEveryChange && thisValue.some(function (val, index) {
	            return !deepEqual(val, nextValue[index]);
	          })) {
	            return true;
	          }
	        }
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        // if we have children, we MUST update in React 16
	        // https://twitter.com/erikras/status/915866544558788608
	        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          // useful to debug rerenders
	          // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	          //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	          // }
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	        }));
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.ref;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            component = _props.component,
	            withRef = _props.withRef,
	            name = _props.name,
	            _reduxForm = _props._reduxForm,
	            validate = _props.validate,
	            warn = _props.warn,
	            rerenderOnEveryChange = _props.rerenderOnEveryChange,
	            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'validate', 'warn', 'rerenderOnEveryChange']);
	
	        var props = (0, _createFieldArrayProps2.default)(structure, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
	        if (withRef) {
	          props.ref = this.saveRef;
	        }
	        return (0, _react.createElement)(component, props);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.props.dirty;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.props.pristine;
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.props.value;
	      }
	    }]);
	
	    return ConnectedFieldArray;
	  }(_react.Component);
	
	  ConnectedFieldArray.propTypes = {
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	    props: _propTypes2.default.object,
	    rerenderOnEveryChange: _propTypes2.default.bool
	  };
	
	  ConnectedFieldArray.defaultProps = {
	    rerenderOnEveryChange: false
	  };
	
	  ConnectedFieldArray.contextTypes = {
	    _reduxForm: _propTypes2.default.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    var initial = getIn(formState, 'initial.' + name) || initialValues && getIn(initialValues, name);
	    var value = getIn(formState, 'values.' + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(formState, 'asyncErrors.' + name + '._error'),
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, 'fields.' + name),
	      submitError: getIn(formState, 'submitErrors.' + name + '._error'),
	      submitFailed: getIn(formState, 'submitFailed'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      value: value,
	      length: size(value)
	    };
	  }, function (dispatch, ownProps) {
	    var name = ownProps.name,
	        _reduxForm = ownProps._reduxForm;
	    var arrayInsert = _reduxForm.arrayInsert,
	        arrayMove = _reduxForm.arrayMove,
	        arrayPop = _reduxForm.arrayPop,
	        arrayPush = _reduxForm.arrayPush,
	        arrayRemove = _reduxForm.arrayRemove,
	        arrayRemoveAll = _reduxForm.arrayRemoveAll,
	        arrayShift = _reduxForm.arrayShift,
	        arraySplice = _reduxForm.arraySplice,
	        arraySwap = _reduxForm.arraySwap,
	        arrayUnshift = _reduxForm.arrayUnshift;
	
	    return (0, _mapValues3.default)({
	      arrayInsert: arrayInsert,
	      arrayMove: arrayMove,
	      arrayPop: arrayPop,
	      arrayPush: arrayPush,
	      arrayRemove: arrayRemove,
	      arrayRemoveAll: arrayRemoveAll,
	      arrayShift: arrayShift,
	      arraySplice: arraySplice,
	      arraySwap: arraySwap,
	      arrayUnshift: arrayUnshift
	    }, function (actionCreator) {
	      return (0, _redux.bindActionCreators)(actionCreator.bind(null, name), dispatch);
	    });
	  }, undefined, { withRef: true });
	  return connector(ConnectedFieldArray);
	};
	
	exports.default = createConnectedFieldArray;

/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(10);
	
	var _createFieldProps2 = __webpack_require__(475);
	
	var _createFieldProps3 = _interopRequireDefault(_createFieldProps2);
	
	var _plain = __webpack_require__(86);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _onChangeValue = __webpack_require__(481);
	
	var _onChangeValue2 = _interopRequireDefault(_onChangeValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	var createConnectedFields = function createConnectedFields(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn,
	      size = structure.size;
	
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	    return _plain2.default.getIn(syncErrors, name + '._error') || _plain2.default.getIn(syncErrors, name);
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = getIn(syncWarnings, name);
	    // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	    return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedFields = function (_Component) {
	    _inherits(ConnectedFields, _Component);
	
	    function ConnectedFields(props) {
	      _classCallCheck(this, ConnectedFields);
	
	      var _this = _possibleConstructorReturn(this, (ConnectedFields.__proto__ || Object.getPrototypeOf(ConnectedFields)).call(this, props));
	
	      _this.onChangeFns = {};
	      _this.onFocusFns = {};
	      _this.onBlurFns = {};
	
	      _this.prepareEventHandlers = function (_ref) {
	        var names = _ref.names;
	        return names.forEach(function (name) {
	          _this.onChangeFns[name] = function (event) {
	            return _this.handleChange(name, event);
	          };
	          _this.onFocusFns[name] = function () {
	            return _this.handleFocus(name);
	          };
	          _this.onBlurFns[name] = function (event) {
	            return _this.handleBlur(name, event);
	          };
	        });
	      };
	
	      _this.handleChange = function (name, event) {
	        var _this$props = _this.props,
	            dispatch = _this$props.dispatch,
	            parse = _this$props.parse,
	            _reduxForm = _this$props._reduxForm;
	
	        var value = (0, _onChangeValue2.default)(event, { name: name, parse: parse });
	
	        dispatch(_reduxForm.change(name, value));
	      };
	
	      _this.handleFocus = function (name) {
	        var _this$props2 = _this.props,
	            dispatch = _this$props2.dispatch,
	            _reduxForm = _this$props2._reduxForm;
	
	        dispatch(_reduxForm.focus(name));
	      };
	
	      _this.handleBlur = function (name, event) {
	        var _this$props3 = _this.props,
	            dispatch = _this$props3.dispatch,
	            parse = _this$props3.parse,
	            _reduxForm = _this$props3._reduxForm;
	
	        var value = (0, _onChangeValue2.default)(event, { name: name, parse: parse });
	
	        // dispatch blur action
	        dispatch(_reduxForm.blur(name, value));
	
	        // call post-blur callback
	        if (_reduxForm.asyncValidate) {
	          _reduxForm.asyncValidate(name, value);
	        }
	      };
	
	      _this.prepareEventHandlers(props);
	      return _this;
	    }
	
	    _createClass(ConnectedFields, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
	          return !_this2.props._fields[nextName];
	        }))) {
	          // names has changed. The cached event handlers need to be updated
	          this.prepareEventHandlers(nextProps);
	        }
	      }
	    }, {
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this3 = this;
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        // if we have children, we MUST update in React 16
	        // https://twitter.com/erikras/status/915866544558788608
	        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
	        }));
	      }
	    }, {
	      key: 'isDirty',
	      value: function isDirty() {
	        var _fields = this.props._fields;
	
	        return Object.keys(_fields).some(function (name) {
	          return _fields[name].dirty;
	        });
	      }
	    }, {
	      key: 'getValues',
	      value: function getValues() {
	        var _fields = this.props._fields;
	
	        return Object.keys(_fields).reduce(function (accumulator, name) {
	          return _plain2.default.setIn(accumulator, name, _fields[name].value);
	        }, {});
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.refs.renderedComponent;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this4 = this;
	
	        var _props = this.props,
	            component = _props.component,
	            withRef = _props.withRef,
	            _fields = _props._fields,
	            _reduxForm = _props._reduxForm,
	            rest = _objectWithoutProperties(_props, ['component', 'withRef', '_fields', '_reduxForm']);
	
	        var sectionPrefix = _reduxForm.sectionPrefix,
	            form = _reduxForm.form;
	
	        var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
	          var connectedProps = _fields[name];
	
	          var _createFieldProps = (0, _createFieldProps3.default)(structure, name, _extends({}, connectedProps, rest, {
	            form: form,
	            onBlur: _this4.onBlurFns[name],
	            onChange: _this4.onChangeFns[name],
	            onFocus: _this4.onFocusFns[name]
	          })),
	              custom = _createFieldProps.custom,
	              fieldProps = _objectWithoutProperties(_createFieldProps, ['custom']);
	
	          accumulator.custom = custom;
	          var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
	          return _plain2.default.setIn(accumulator, fieldName, fieldProps);
	        }, {}),
	            custom = _Object$keys$reduce.custom,
	            props = _objectWithoutProperties(_Object$keys$reduce, ['custom']);
	
	        if (withRef) {
	          props.ref = 'renderedComponent';
	        }
	
	        return (0, _react.createElement)(component, _extends({}, props, custom));
	      }
	    }]);
	
	    return ConnectedFields;
	  }(_react.Component);
	
	  ConnectedFields.propTypes = {
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	    _fields: _propTypes2.default.object.isRequired,
	    props: _propTypes2.default.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var names = ownProps.names,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    return {
	      _fields: names.reduce(function (accumulator, name) {
	        var initialState = getIn(formState, 'initial.' + name);
	        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	        var value = getIn(formState, 'values.' + name);
	        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	        var submitting = getIn(formState, 'submitting');
	        var pristine = value === initial;
	        accumulator[name] = {
	          asyncError: getIn(formState, 'asyncErrors.' + name),
	          asyncValidating: getIn(formState, 'asyncValidating') === name,
	          dirty: !pristine,
	          initial: initial,
	          pristine: pristine,
	          state: getIn(formState, 'fields.' + name),
	          submitError: getIn(formState, 'submitErrors.' + name),
	          submitFailed: getIn(formState, 'submitFailed'),
	          submitting: submitting,
	          syncError: syncError,
	          syncWarning: syncWarning,
	          value: value,
	          _value: ownProps.value // save value passed in (for checkboxes)
	        };
	        return accumulator;
	      }, {})
	    };
	  }, undefined, undefined, { withRef: true });
	  return connector(ConnectedFields);
	};
	
	exports.default = createConnectedFields;

/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Form = function (_Component) {
	  _inherits(Form, _Component);
	
	  function Form(props, context) {
	    _classCallCheck(this, Form);
	
	    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));
	
	    if (!context._reduxForm) {
	      throw new Error('Form must be inside a component decorated with reduxForm()');
	    }
	    return _this;
	  }
	
	  _createClass(Form, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.context._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('form', this.props);
	    }
	  }]);
	
	  return Form;
	}(_react.Component);
	
	Form.propTypes = {
	  onSubmit: _propTypes2.default.func.isRequired
	};
	Form.contextTypes = {
	  _reduxForm: _propTypes2.default.object
	};
	
	exports.default = Form;

/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _prefixName = __webpack_require__(163);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormSection = function (_Component) {
	  _inherits(FormSection, _Component);
	
	  function FormSection(props, context) {
	    _classCallCheck(this, FormSection);
	
	    var _this = _possibleConstructorReturn(this, (FormSection.__proto__ || Object.getPrototypeOf(FormSection)).call(this, props, context));
	
	    if (!context._reduxForm) {
	      throw new Error('FormSection must be inside a component decorated with reduxForm()');
	    }
	    return _this;
	  }
	
	  _createClass(FormSection, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var context = this.context,
	          name = this.props.name;
	
	      return {
	        _reduxForm: _extends({}, context._reduxForm, {
	          sectionPrefix: (0, _prefixName2.default)(context, name)
	        })
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          name = _props.name,
	          component = _props.component,
	          rest = _objectWithoutProperties(_props, ['children', 'name', 'component']);
	
	      if (_react2.default.isValidElement(children)) {
	        return children;
	      }
	
	      return (0, _react.createElement)(component, _extends({}, rest, {
	        children: children
	      }));
	    }
	  }]);
	
	  return FormSection;
	}(_react.Component);
	
	FormSection.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
	};
	
	FormSection.defaultProps = {
	  component: 'div'
	};
	
	FormSection.childContextTypes = {
	  _reduxForm: _propTypes2.default.object.isRequired
	};
	
	FormSection.contextTypes = {
	  _reduxForm: _propTypes2.default.object
	};
	
	exports.default = FormSection;

/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPromise = __webpack_require__(264);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var asyncValidation = function asyncValidation(fn, start, stop, field) {
	  start(field);
	  var promise = fn();
	  if (!(0, _isPromise2.default)(promise)) {
	    throw new Error('asyncValidate function passed to reduxForm must return a promise');
	  }
	  var handleErrors = function handleErrors(rejected) {
	    return function (errors) {
	      if (errors && Object.keys(errors).length) {
	        stop(errors);
	        return errors;
	      } else if (rejected) {
	        stop();
	        throw new Error('Asynchronous validation promise was rejected without errors.');
	      }
	      stop();
	      return Promise.resolve();
	    };
	  };
	  return promise.then(handleErrors(false), handleErrors(true));
	};
	exports.default = asyncValidation;

/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedField = __webpack_require__(1267);
	
	var _ConnectedField2 = _interopRequireDefault(_ConnectedField);
	
	var _shallowCompare = __webpack_require__(487);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	var _prefixName = __webpack_require__(163);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	var _plain = __webpack_require__(86);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createField = function createField(structure) {
	  var ConnectedField = (0, _ConnectedField2.default)(structure);
	
	  var setIn = structure.setIn;
	
	  var Field = function (_Component) {
	    _inherits(Field, _Component);
	
	    function Field(props, context) {
	      _classCallCheck(this, Field);
	
	      var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props, context));
	
	      _this.saveRef = function (ref) {
	        return _this.ref = ref;
	      };
	
	      _this.normalize = function (name, value) {
	        var normalize = _this.props.normalize;
	
	        if (!normalize) {
	          return value;
	        }
	        var previousValues = _this.context._reduxForm.getValues();
	        var previousValue = _this.value;
	        var nextValues = setIn(previousValues, name, value);
	        return normalize(value, previousValue, nextValues, previousValues);
	      };
	
	      if (!context._reduxForm) {
	        throw new Error('Field must be inside a component decorated with reduxForm()');
	      }
	      return _this;
	    }
	
	    _createClass(Field, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        return (0, _shallowCompare2.default)(this, nextProps);
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var _this2 = this;
	
	        this.context._reduxForm.register(this.name, 'Field', function () {
	          return _this2.props.validate;
	        }, function () {
	          return _this2.props.warn;
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps, nextContext) {
	        var oldName = (0, _prefixName2.default)(this.context, this.props.name);
	        var newName = (0, _prefixName2.default)(nextContext, nextProps.name);
	
	        if (oldName !== newName ||
	        // use deepEqual here because they could be a function or an array of functions
	        !_plain2.default.deepEqual(this.props.validate, nextProps.validate) || !_plain2.default.deepEqual(this.props.warn, nextProps.warn)) {
	          // unregister old name
	          this.context._reduxForm.unregister(oldName);
	          // register new name
	          this.context._reduxForm.register(newName, 'Field', function () {
	            return nextProps.validate;
	          }, function () {
	            return nextProps.warn;
	          });
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.context._reduxForm.unregister(this.name);
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Field');
	        return this.ref ? this.ref.getWrappedInstance().getRenderedComponent() : undefined;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return (0, _react.createElement)(ConnectedField, _extends({}, this.props, {
	          name: this.name,
	          normalize: this.normalize,
	          _reduxForm: this.context._reduxForm,
	          ref: this.saveRef
	        }));
	      }
	    }, {
	      key: 'name',
	      get: function get() {
	        return (0, _prefixName2.default)(this.context, this.props.name);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return !this.pristine;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return !!(this.ref && this.ref.getWrappedInstance().isPristine());
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.ref && this.ref.getWrappedInstance().getValue();
	      }
	    }]);
	
	    return Field;
	  }(_react.Component);
	
	  Field.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	    format: _propTypes2.default.func,
	    normalize: _propTypes2.default.func,
	    onBlur: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    onDragStart: _propTypes2.default.func,
	    onDrop: _propTypes2.default.func,
	    parse: _propTypes2.default.func,
	    props: _propTypes2.default.object,
	    validate: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
	    warn: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
	    withRef: _propTypes2.default.bool
	  };
	  Field.contextTypes = {
	    _reduxForm: _propTypes2.default.object
	  };
	
	  return Field;
	};
	
	exports.default = createField;

/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedFieldArray = __webpack_require__(1268);
	
	var _ConnectedFieldArray2 = _interopRequireDefault(_ConnectedFieldArray);
	
	var _prefixName = __webpack_require__(163);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var toArray = function toArray(value) {
	  return Array.isArray(value) ? value : [value];
	};
	
	var wrapError = function wrapError(fn, key) {
	  return fn && function () {
	    var validators = toArray(fn);
	    for (var i = 0; i < validators.length; i++) {
	      var result = validators[i].apply(validators, arguments);
	      if (result) {
	        return _defineProperty({}, key, result);
	      }
	    }
	  };
	};
	
	var createFieldArray = function createFieldArray(structure) {
	  var ConnectedFieldArray = (0, _ConnectedFieldArray2.default)(structure);
	
	  var FieldArray = function (_Component) {
	    _inherits(FieldArray, _Component);
	
	    function FieldArray(props, context) {
	      _classCallCheck(this, FieldArray);
	
	      var _this = _possibleConstructorReturn(this, (FieldArray.__proto__ || Object.getPrototypeOf(FieldArray)).call(this, props, context));
	
	      _this.saveRef = function (ref) {
	        _this.ref = ref;
	      };
	
	      if (!context._reduxForm) {
	        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
	      }
	      return _this;
	    }
	
	    _createClass(FieldArray, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var _this2 = this;
	
	        this.context._reduxForm.register(this.name, 'FieldArray', function () {
	          return wrapError(_this2.props.validate, '_error');
	        }, function () {
	          return wrapError(_this2.props.warn, '_warning');
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps, nextContext) {
	        var oldName = (0, _prefixName2.default)(this.context, this.props.name);
	        var newName = (0, _prefixName2.default)(nextContext, nextProps.name);
	
	        if (oldName !== newName) {
	          // unregister old name
	          this.context._reduxForm.unregister(oldName);
	          // register new name
	          this.context._reduxForm.register(newName, 'FieldArray');
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.context._reduxForm.unregister(this.name);
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to FieldArray');
	        return this.ref && this.ref.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return (0, _react.createElement)(ConnectedFieldArray, _extends({}, this.props, {
	          name: this.name,
	          _reduxForm: this.context._reduxForm,
	          ref: this.saveRef
	        }));
	      }
	    }, {
	      key: 'name',
	      get: function get() {
	        return (0, _prefixName2.default)(this.context, this.props.name);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return !this.ref || this.ref.getWrappedInstance().dirty;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return !!(this.ref && this.ref.getWrappedInstance().pristine);
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.ref ? this.ref.getWrappedInstance().value : undefined;
	      }
	    }]);
	
	    return FieldArray;
	  }(_react.Component);
	
	  FieldArray.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    component: _propTypes2.default.func.isRequired,
	    props: _propTypes2.default.object,
	    validate: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
	    warn: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
	    withRef: _propTypes2.default.bool
	  };
	  FieldArray.contextTypes = {
	    _reduxForm: _propTypes2.default.object
	  };
	
	  return FieldArray;
	};
	
	exports.default = createFieldArray;

/***/ },
/* 1275 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var createFieldArrayProps = function createFieldArrayProps(_ref2, name, form, sectionPrefix, getValue, _ref) {
	  var getIn = _ref2.getIn;
	
	  var arrayInsert = _ref.arrayInsert,
	      arrayMove = _ref.arrayMove,
	      arrayPop = _ref.arrayPop,
	      arrayPush = _ref.arrayPush,
	      arrayRemove = _ref.arrayRemove,
	      arrayRemoveAll = _ref.arrayRemoveAll,
	      arrayShift = _ref.arrayShift,
	      arraySplice = _ref.arraySplice,
	      arraySwap = _ref.arraySwap,
	      arrayUnshift = _ref.arrayUnshift,
	      asyncError = _ref.asyncError,
	      dirty = _ref.dirty,
	      length = _ref.length,
	      pristine = _ref.pristine,
	      submitError = _ref.submitError,
	      state = _ref.state,
	      submitFailed = _ref.submitFailed,
	      submitting = _ref.submitting,
	      syncError = _ref.syncError,
	      syncWarning = _ref.syncWarning,
	      value = _ref.value,
	      props = _ref.props,
	      rest = _objectWithoutProperties(_ref, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncError', 'dirty', 'length', 'pristine', 'submitError', 'state', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'value', 'props']);
	
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	  var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
	  var finalProps = _extends({
	    fields: {
	      _isFieldArray: true,
	      forEach: function forEach(callback) {
	        return (value || []).forEach(function (item, index) {
	          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
	        });
	      },
	      get: getValue,
	      getAll: function getAll() {
	        return value;
	      },
	      insert: arrayInsert,
	      length: length,
	      map: function map(callback) {
	        return (value || []).map(function (item, index) {
	          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
	        });
	      },
	      move: arrayMove,
	      name: name,
	      pop: function pop() {
	        arrayPop();
	        return getIn(value, String(length - 1));
	      },
	      push: arrayPush,
	      reduce: function reduce(callback, initial) {
	        return (value || []).reduce(function (accumulator, item, index) {
	          return callback(accumulator, fieldName + '[' + index + ']', index, finalProps.fields);
	        }, initial);
	      },
	      remove: arrayRemove,
	      removeAll: arrayRemoveAll,
	      shift: function shift() {
	        arrayShift();
	        return getIn(value, '0');
	      },
	      swap: arraySwap,
	      unshift: arrayUnshift
	    },
	    meta: {
	      dirty: dirty,
	      error: error,
	      form: form,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: submitting,
	      submitFailed: submitFailed,
	      valid: !error
	    }
	  }, props, rest);
	  return finalProps;
	};
	exports.default = createFieldArrayProps;

/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedFields = __webpack_require__(1269);
	
	var _ConnectedFields2 = _interopRequireDefault(_ConnectedFields);
	
	var _shallowCompare = __webpack_require__(487);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	var _plain = __webpack_require__(86);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _prefixName = __webpack_require__(163);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validateNameProp = function validateNameProp(prop) {
	  if (!prop) {
	    return new Error('No "names" prop was specified <Fields/>');
	  }
	  if (!Array.isArray(prop) && !prop._isFieldArray) {
	    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
	  }
	};
	
	var createFields = function createFields(structure) {
	  var ConnectedFields = (0, _ConnectedFields2.default)(structure);
	
	  var Fields = function (_Component) {
	    _inherits(Fields, _Component);
	
	    function Fields(props, context) {
	      _classCallCheck(this, Fields);
	
	      var _this = _possibleConstructorReturn(this, (Fields.__proto__ || Object.getPrototypeOf(Fields)).call(this, props, context));
	
	      if (!context._reduxForm) {
	        throw new Error('Fields must be inside a component decorated with reduxForm()');
	      }
	      return _this;
	    }
	
	    _createClass(Fields, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        return (0, _shallowCompare2.default)(this, nextProps);
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var error = validateNameProp(this.props.names);
	        if (error) {
	          throw error;
	        }
	        var context = this.context;
	        var register = context._reduxForm.register;
	
	        this.names.forEach(function (name) {
	          return register(name, 'Field');
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (!_plain2.default.deepEqual(this.props.names, nextProps.names)) {
	          var context = this.context;
	          var _context$_reduxForm = context._reduxForm,
	              register = _context$_reduxForm.register,
	              unregister = _context$_reduxForm.unregister;
	          // unregister old name
	
	          this.props.names.forEach(function (name) {
	            return unregister((0, _prefixName2.default)(context, name));
	          });
	          // register new name
	          nextProps.names.forEach(function (name) {
	            return register((0, _prefixName2.default)(context, name), 'Field');
	          });
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var context = this.context;
	        var unregister = context._reduxForm.unregister;
	
	        this.props.names.forEach(function (name) {
	          return unregister((0, _prefixName2.default)(context, name));
	        });
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Fields');
	        return this.refs.connected.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var context = this.context;
	
	        return (0, _react.createElement)(ConnectedFields, _extends({}, this.props, {
	          names: this.props.names.map(function (name) {
	            return (0, _prefixName2.default)(context, name);
	          }),
	          _reduxForm: this.context._reduxForm,
	          ref: 'connected'
	        }));
	      }
	    }, {
	      key: 'names',
	      get: function get() {
	        var context = this.context;
	
	        return this.props.names.map(function (name) {
	          return (0, _prefixName2.default)(context, name);
	        });
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().isDirty();
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return !this.dirty;
	      }
	    }, {
	      key: 'values',
	      get: function get() {
	        return this.refs.connected && this.refs.connected.getWrappedInstance().getValues();
	      }
	    }]);
	
	    return Fields;
	  }(_react.Component);
	
	  Fields.propTypes = {
	    names: function names(props, propName) {
	      return validateNameProp(props[propName]);
	    },
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	    format: _propTypes2.default.func,
	    parse: _propTypes2.default.func,
	    props: _propTypes2.default.object,
	    withRef: _propTypes2.default.bool
	  };
	  Fields.contextTypes = {
	    _reduxForm: _propTypes2.default.object
	  };
	
	  return Fields;
	};
	
	exports.default = createFields;

/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _plain = __webpack_require__(86);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFormValueSelector = function createFormValueSelector(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    (0, _invariant2.default)(form, 'Form value must be specified');
	    var nonNullGetFormState = getFormState || function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        fields[_key - 1] = arguments[_key];
	      }
	
	      (0, _invariant2.default)(fields.length, 'No fields specified');
	      return fields.length === 1 ? // only selecting one field, so return its value
	      getIn(nonNullGetFormState(state), form + '.values.' + fields[0]) : // selecting many fields, so return an object of field values
	      fields.reduce(function (accumulator, field) {
	        var value = getIn(nonNullGetFormState(state), form + '.values.' + field);
	        return value === undefined ? accumulator : _plain2.default.setIn(accumulator, field, value);
	      }, {});
	    };
	  };
	};
	
	exports.default = createFormValueSelector;

/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(10);
	
	var _prefixName = __webpack_require__(163);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createValues = function createValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (firstArg) {
	    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      rest[_key - 1] = arguments[_key];
	    }
	
	    // create a class that reads current form name and creates a selector
	    // return
	    return function (Component) {
	      var FormValues = function (_React$Component) {
	        _inherits(FormValues, _React$Component);
	
	        function FormValues(props, context) {
	          _classCallCheck(this, FormValues);
	
	          var _this = _possibleConstructorReturn(this, (FormValues.__proto__ || Object.getPrototypeOf(FormValues)).call(this, props, context));
	
	          if (!context._reduxForm) {
	            throw new Error('formValues() must be used inside a React tree decorated with reduxForm()');
	          }
	          var valuesMap = void 0;
	          var resolvedFirstArg = typeof firstArg === 'function' ? firstArg(props) : firstArg;
	          if (typeof resolvedFirstArg === 'string') {
	            valuesMap = [resolvedFirstArg].concat(_toConsumableArray(rest)).map(function (k) {
	              return {
	                prop: k,
	                path: k
	              };
	            });
	          } else {
	            var config = resolvedFirstArg;
	            valuesMap = Object.keys(config).map(function (k) {
	              return {
	                prop: k,
	                path: config[k]
	              };
	            });
	          }
	          if (!valuesMap.length) {
	            throw new Error('formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...}) or formValues((props) => name) or formValues((props) => ({propName1: propPath1, ...}))');
	          }
	          var formValuesSelector = function formValuesSelector(_, _ref2) {
	            var sectionPrefix = _ref2.sectionPrefix;
	
	            // Yes, we're only using connect() for listening to updates.
	            // The second argument needs to be there so that connect calls
	            // the selector when props change
	            var getValues = _this.context._reduxForm.getValues;
	
	            var props = {};
	            var values = getValues();
	            valuesMap.forEach(function (_ref3) {
	              var prop = _ref3.prop,
	                  path = _ref3.path;
	              return props[prop] = getIn(values, (0, _prefixName2.default)(_this.context, path));
	            });
	            return props;
	          };
	          _this.Component = (0, _reactRedux.connect)(formValuesSelector, function () {
	            return {};
	          } // ignore dispatch
	          )(function (_ref4) {
	            var sectionPrefix = _ref4.sectionPrefix,
	                otherProps = _objectWithoutProperties(_ref4, ['sectionPrefix']);
	
	            return _react2.default.createElement(Component, otherProps);
	          });
	          return _this;
	        }
	
	        _createClass(FormValues, [{
	          key: 'render',
	          value: function render() {
	            var Component = this.Component;
	
	            return _react2.default.createElement(Component
	            // so that the connected component updates props when sectionPrefix has changed
	            , _extends({ sectionPrefix: this.context._reduxForm.sectionPrefix
	            }, this.props));
	          }
	        }]);
	
	        return FormValues;
	      }(_react2.default.Component);
	
	      FormValues.contextTypes = {
	        _reduxForm: _propTypes2.default.object
	      };
	      return FormValues;
	    };
	  };
	};
	
	exports.default = createValues;

/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionTypes = __webpack_require__(302);
	
	var _deleteInWithCleanUp = __webpack_require__(1282);
	
	var _deleteInWithCleanUp2 = _interopRequireDefault(_deleteInWithCleanUp);
	
	var _plain = __webpack_require__(86);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var isReduxFormAction = function isReduxFormAction(action) {
	  return action && action.type && action.type.length > _actionTypes.prefix.length && action.type.substring(0, _actionTypes.prefix.length) === _actionTypes.prefix;
	};
	
	function createReducer(structure) {
	  var _behaviors;
	
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      forEach = structure.forEach,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      deleteIn = structure.deleteIn,
	      fromJS = structure.fromJS,
	      keys = structure.keys,
	      size = structure.size,
	      some = structure.some,
	      splice = structure.splice;
	
	  var deleteInWithCleanUp = (0, _deleteInWithCleanUp2.default)(structure);
	  var plainDeleteInWithCleanUp = (0, _deleteInWithCleanUp2.default)(_plain2.default);
	  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
	    var existing = getIn(state, key + '.' + field);
	    return existing || force ? setIn(state, key + '.' + field, splice(existing, index, removeNum, value)) : state;
	  };
	  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
	    var slice = getIn(state, key);
	    var existing = _plain2.default.getIn(slice, field);
	    return existing || force ? setIn(state, key, _plain2.default.setIn(slice, field, _plain2.default.splice(existing, index, removeNum, value))) : state;
	  };
	  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
	  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
	    var result = state;
	    var nonValuesValue = value != null ? empty : undefined;
	    result = doSplice(result, 'values', field, index, removeNum, value, true);
	    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
	    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
	    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
	    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
	    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
	    return result;
	  };
	
	  var behaviors = (_behaviors = {}, _defineProperty(_behaviors, _actionTypes.ARRAY_INSERT, function (state, _ref) {
	    var _ref$meta = _ref.meta,
	        field = _ref$meta.field,
	        index = _ref$meta.index,
	        payload = _ref.payload;
	
	    return arraySplice(state, field, index, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_MOVE, function (state, _ref2) {
	    var _ref2$meta = _ref2.meta,
	        field = _ref2$meta.field,
	        from = _ref2$meta.from,
	        to = _ref2$meta.to;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    var result = state;
	    if (length) {
	      rootKeys.forEach(function (key) {
	        var path = key + '.' + field;
	        if (getIn(result, path)) {
	          var value = getIn(result, path + '[' + from + ']');
	          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
	          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
	        }
	      });
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_POP, function (state, _ref3) {
	    var field = _ref3.meta.field;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, length - 1, 1) : state;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_PUSH, function (state, _ref4) {
	    var field = _ref4.meta.field,
	        payload = _ref4.payload;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return arraySplice(state, field, length, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_REMOVE, function (state, _ref5) {
	    var _ref5$meta = _ref5.meta,
	        field = _ref5$meta.field,
	        index = _ref5$meta.index;
	
	    return arraySplice(state, field, index, 1);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_REMOVE_ALL, function (state, _ref6) {
	    var field = _ref6.meta.field;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, 0, length) : state;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SHIFT, function (state, _ref7) {
	    var field = _ref7.meta.field;
	
	    return arraySplice(state, field, 0, 1);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SPLICE, function (state, _ref8) {
	    var _ref8$meta = _ref8.meta,
	        field = _ref8$meta.field,
	        index = _ref8$meta.index,
	        removeNum = _ref8$meta.removeNum,
	        payload = _ref8.payload;
	
	    return arraySplice(state, field, index, removeNum, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SWAP, function (state, _ref9) {
	    var _ref9$meta = _ref9.meta,
	        field = _ref9$meta.field,
	        indexA = _ref9$meta.indexA,
	        indexB = _ref9$meta.indexB;
	
	    var result = state;
	    rootKeys.forEach(function (key) {
	      var valueA = getIn(result, key + '.' + field + '[' + indexA + ']');
	      var valueB = getIn(result, key + '.' + field + '[' + indexB + ']');
	      if (valueA !== undefined || valueB !== undefined) {
	        result = setIn(result, key + '.' + field + '[' + indexA + ']', valueB);
	        result = setIn(result, key + '.' + field + '[' + indexB + ']', valueA);
	      }
	    });
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_UNSHIFT, function (state, _ref10) {
	    var field = _ref10.meta.field,
	        payload = _ref10.payload;
	
	    return arraySplice(state, field, 0, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.AUTOFILL, function (state, _ref11) {
	    var field = _ref11.meta.field,
	        payload = _ref11.payload;
	
	    var result = state;
	    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
	    result = deleteInWithCleanUp(result, 'submitErrors.' + field);
	    result = setIn(result, 'fields.' + field + '.autofilled', true);
	    result = setIn(result, 'values.' + field, payload);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.BLUR, function (state, _ref12) {
	    var _ref12$meta = _ref12.meta,
	        field = _ref12$meta.field,
	        touch = _ref12$meta.touch,
	        payload = _ref12.payload;
	
	    var result = state;
	    var initial = getIn(result, 'initial.' + field);
	    if (initial === undefined && payload === '') {
	      result = deleteInWithCleanUp(result, 'values.' + field);
	    } else if (payload !== undefined) {
	      result = setIn(result, 'values.' + field, payload);
	    }
	    if (field === getIn(result, 'active')) {
	      result = deleteIn(result, 'active');
	    }
	    result = deleteIn(result, 'fields.' + field + '.active');
	    if (touch) {
	      result = setIn(result, 'fields.' + field + '.touched', true);
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.CHANGE, function (state, _ref13) {
	    var _ref13$meta = _ref13.meta,
	        field = _ref13$meta.field,
	        touch = _ref13$meta.touch,
	        persistentSubmitErrors = _ref13$meta.persistentSubmitErrors,
	        payload = _ref13.payload;
	
	    var result = state;
	    var initial = getIn(result, 'initial.' + field);
	    if (initial === undefined && payload === '') {
	      result = deleteInWithCleanUp(result, 'values.' + field);
	    } else if (payload !== undefined) {
	      result = setIn(result, 'values.' + field, payload);
	    }
	    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
	    if (!persistentSubmitErrors) {
	      result = deleteInWithCleanUp(result, 'submitErrors.' + field);
	    }
	    result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
	    if (touch) {
	      result = setIn(result, 'fields.' + field + '.touched', true);
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.CLEAR_SUBMIT, function (state) {
	    return deleteIn(state, 'triggerSubmit');
	  }), _defineProperty(_behaviors, _actionTypes.CLEAR_SUBMIT_ERRORS, function (state) {
	    var result = state;
	    result = deleteInWithCleanUp(result, 'submitErrors');
	    result = deleteIn(result, 'error');
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.CLEAR_ASYNC_ERROR, function (state, _ref14) {
	    var field = _ref14.meta.field;
	
	    return deleteIn(state, 'asyncErrors.' + field);
	  }), _defineProperty(_behaviors, _actionTypes.FOCUS, function (state, _ref15) {
	    var field = _ref15.meta.field;
	
	    var result = state;
	    var previouslyActive = getIn(state, 'active');
	    result = deleteIn(result, 'fields.' + previouslyActive + '.active');
	    result = setIn(result, 'fields.' + field + '.visited', true);
	    result = setIn(result, 'fields.' + field + '.active', true);
	    result = setIn(result, 'active', field);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.INITIALIZE, function (state, _ref16) {
	    var payload = _ref16.payload,
	        _ref16$meta = _ref16.meta,
	        keepDirty = _ref16$meta.keepDirty,
	        keepSubmitSucceeded = _ref16$meta.keepSubmitSucceeded;
	
	    var mapData = fromJS(payload);
	    var result = empty; // clean all field state
	
	    // persist old warnings, they will get recalculated if the new form values are different from the old values
	    var warning = getIn(state, 'warning');
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    }
	    var syncWarnings = getIn(state, 'syncWarnings');
	    if (syncWarnings) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    }
	
	    // persist old errors, they will get recalculated if the new form values are different from the old values
	    var error = getIn(state, 'error');
	    if (error) {
	      result = setIn(result, 'error', error);
	    }
	    var syncErrors = getIn(state, 'syncErrors');
	    if (syncErrors) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    }
	
	    var registeredFields = getIn(state, 'registeredFields');
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	
	    var previousValues = getIn(state, 'values');
	    var previousInitialValues = getIn(state, 'initial');
	    var newInitialValues = mapData;
	
	    var newValues = previousValues;
	
	    if (keepDirty && registeredFields) {
	      if (!deepEqual(newInitialValues, previousInitialValues)) {
	        //
	        // Keep the value of dirty fields while updating the value of
	        // pristine fields. This way, apps can reinitialize forms while
	        // avoiding stomping on user edits.
	        //
	        // Note 1: The initialize action replaces all initial values
	        // regardless of keepDirty.
	        //
	        // Note 2: When a field is dirty, keepDirty is enabled, and the field
	        // value is the same as the new initial value for the field, the
	        // initialize action causes the field to become pristine. That effect
	        // is what we want.
	        //
	        forEach(keys(registeredFields), function (name) {
	          var previousInitialValue = getIn(previousInitialValues, name);
	          var previousValue = getIn(previousValues, name);
	
	          if (deepEqual(previousValue, previousInitialValue)) {
	            // Overwrite the old pristine value with the new pristine value
	            var newInitialValue = getIn(newInitialValues, name);
	
	            // This check prevents any 'setIn' call that would create useless
	            // nested objects, since the path to the new field value would
	            // evaluate to the same (especially for undefined values)
	            if (getIn(newValues, name) !== newInitialValue) {
	              newValues = setIn(newValues, name, newInitialValue);
	            }
	          }
	        });
	
	        forEach(keys(newInitialValues), function (name) {
	          var previousInitialValue = getIn(previousInitialValues, name);
	          if (typeof previousInitialValue === 'undefined') {
	            // Add new values at the root level.
	            var newInitialValue = getIn(newInitialValues, name);
	            newValues = setIn(newValues, name, newInitialValue);
	          }
	        });
	      }
	    } else {
	      newValues = newInitialValues;
	    }
	
	    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
	      result = setIn(result, 'submitSucceeded', true);
	    }
	    result = setIn(result, 'values', newValues);
	    result = setIn(result, 'initial', newInitialValues);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.REGISTER_FIELD, function (state, _ref17) {
	    var _ref17$payload = _ref17.payload,
	        name = _ref17$payload.name,
	        type = _ref17$payload.type;
	
	    var key = 'registeredFields[\'' + name + '\']';
	    var field = getIn(state, key);
	    if (field) {
	      var count = getIn(field, 'count') + 1;
	      field = setIn(field, 'count', count);
	    } else {
	      field = fromJS({ name: name, type: type, count: 1 });
	    }
	    return setIn(state, key, field);
	  }), _defineProperty(_behaviors, _actionTypes.RESET, function (state) {
	    var result = empty;
	    var registeredFields = getIn(state, 'registeredFields');
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	    var values = getIn(state, 'initial');
	    if (values) {
	      result = setIn(result, 'values', values);
	      result = setIn(result, 'initial', values);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SUBMIT, function (state) {
	    return setIn(state, 'triggerSubmit', true);
	  }), _defineProperty(_behaviors, _actionTypes.START_ASYNC_VALIDATION, function (state, _ref18) {
	    var field = _ref18.meta.field;
	
	    return setIn(state, 'asyncValidating', field || true);
	  }), _defineProperty(_behaviors, _actionTypes.START_SUBMIT, function (state) {
	    return setIn(state, 'submitting', true);
	  }), _defineProperty(_behaviors, _actionTypes.STOP_ASYNC_VALIDATION, function (state, _ref19) {
	    var payload = _ref19.payload;
	
	    var result = state;
	    result = deleteIn(result, 'asyncValidating');
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = _objectWithoutProperties(payload, ['_error']);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      }
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
	      }
	    } else {
	      result = deleteIn(result, 'error');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.STOP_SUBMIT, function (state, _ref20) {
	    var payload = _ref20.payload;
	
	    var result = state;
	    result = deleteIn(result, 'submitting');
	    result = deleteIn(result, 'submitFailed');
	    result = deleteIn(result, 'submitSucceeded');
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = _objectWithoutProperties(payload, ['_error']);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      } else {
	        result = deleteIn(result, 'error');
	      }
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
	      } else {
	        result = deleteIn(result, 'submitErrors');
	      }
	      result = setIn(result, 'submitFailed', true);
	    } else {
	      result = setIn(result, 'submitSucceeded', true);
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'submitErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SET_SUBMIT_FAILED, function (state, _ref21) {
	    var fields = _ref21.meta.fields;
	
	    var result = state;
	    result = setIn(result, 'submitFailed', true);
	    result = deleteIn(result, 'submitSucceeded');
	    result = deleteIn(result, 'submitting');
	    fields.forEach(function (field) {
	      return result = setIn(result, 'fields.' + field + '.touched', true);
	    });
	    if (fields.length) {
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SET_SUBMIT_SUCCEEDED, function (state) {
	    var result = state;
	    result = deleteIn(result, 'submitFailed');
	    result = setIn(result, 'submitSucceeded', true);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.TOUCH, function (state, _ref22) {
	    var fields = _ref22.meta.fields;
	
	    var result = state;
	    fields.forEach(function (field) {
	      return result = setIn(result, 'fields.' + field + '.touched', true);
	    });
	    result = setIn(result, 'anyTouched', true);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UNREGISTER_FIELD, function (state, _ref23) {
	    var _ref23$payload = _ref23.payload,
	        name = _ref23$payload.name,
	        destroyOnUnmount = _ref23$payload.destroyOnUnmount;
	
	    var result = state;
	    var key = 'registeredFields[\'' + name + '\']';
	    var field = getIn(result, key);
	    if (!field) {
	      return result;
	    }
	
	    var count = getIn(field, 'count') - 1;
	    if (count <= 0 && destroyOnUnmount) {
	      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
	      result = deleteIn(result, key);
	      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
	        result = deleteIn(result, 'registeredFields');
	      }
	      var syncErrors = getIn(result, 'syncErrors');
	      if (syncErrors) {
	        syncErrors = plainDeleteInWithCleanUp(syncErrors, name);
	        if (_plain2.default.deepEqual(syncErrors, _plain2.default.empty)) {
	          result = deleteIn(result, 'syncErrors');
	        } else {
	          result = setIn(result, 'syncErrors', syncErrors);
	        }
	      }
	      var syncWarnings = getIn(result, 'syncWarnings');
	      if (syncWarnings) {
	        syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);
	        if (_plain2.default.deepEqual(syncWarnings, _plain2.default.empty)) {
	          result = deleteIn(result, 'syncWarnings');
	        } else {
	          result = setIn(result, 'syncWarnings', syncWarnings);
	        }
	      }
	      result = deleteInWithCleanUp(result, 'submitErrors.' + name);
	      result = deleteInWithCleanUp(result, 'asyncErrors.' + name);
	    } else {
	      field = setIn(field, 'count', count);
	      result = setIn(result, key, field);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UNTOUCH, function (state, _ref24) {
	    var fields = _ref24.meta.fields;
	
	    var result = state;
	    fields.forEach(function (field) {
	      return result = deleteIn(result, 'fields.' + field + '.touched');
	    });
	    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
	      return getIn(result, 'fields.' + key + '.touched');
	    });
	    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UPDATE_SYNC_ERRORS, function (state, _ref25) {
	    var _ref25$payload = _ref25.payload,
	        syncErrors = _ref25$payload.syncErrors,
	        error = _ref25$payload.error;
	
	    var result = state;
	    if (error) {
	      result = setIn(result, 'error', error);
	      result = setIn(result, 'syncError', true);
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'syncError');
	    }
	    if (Object.keys(syncErrors).length) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    } else {
	      result = deleteIn(result, 'syncErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UPDATE_SYNC_WARNINGS, function (state, _ref26) {
	    var _ref26$payload = _ref26.payload,
	        syncWarnings = _ref26$payload.syncWarnings,
	        warning = _ref26$payload.warning;
	
	    var result = state;
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    } else {
	      result = deleteIn(result, 'warning');
	    }
	    if (Object.keys(syncWarnings).length) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    } else {
	      result = deleteIn(result, 'syncWarnings');
	    }
	    return result;
	  }), _behaviors);
	
	  var reducer = function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	    var action = arguments[1];
	
	    var behavior = behaviors[action.type];
	    return behavior ? behavior(state, action) : state;
	  };
	
	  var byForm = function byForm(reducer) {
	    return function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };
	
	      var form = action && action.meta && action.meta.form;
	      if (!form || !isReduxFormAction(action)) {
	        return state;
	      }
	      if (action.type === _actionTypes.DESTROY && action.meta && action.meta.form) {
	        return action.meta.form.reduce(function (result, form) {
	          return deleteInWithCleanUp(result, form);
	        }, state);
	      }
	      var formState = getIn(state, form);
	      var result = reducer(formState, action);
	      return result === formState ? state : setIn(state, form, result);
	    };
	  };
	
	  /**
	   * Adds additional functionality to the reducer
	   */
	  function decorate(target) {
	    target.plugin = function (reducers) {
	      var _this = this;
	
	      // use 'function' keyword to enable 'this'
	      return decorate(function () {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };
	
	        var callPlugin = function callPlugin(processed, key) {
	          var previousState = getIn(processed, key);
	          var nextState = reducers[key](previousState, action, getIn(state, key));
	          return nextState !== previousState ? setIn(processed, key, nextState) : processed;
	        };
	
	        var processed = _this(state, action); // run through redux-form reducer
	        var form = action && action.meta && action.meta.form;
	
	        if (form) {
	          // this is an action aimed at forms, so only give it to the specified form's plugin
	          return reducers[form] ? callPlugin(processed, form) : processed;
	        } else {
	          // this is not a form-specific action, so send it to all the plugins
	          return Object.keys(reducers).reduce(callPlugin, processed);
	        }
	      });
	    };
	
	    return target;
	  }
	
	  return decorate(byForm(reducer));
	}
	
	exports.default = createReducer;

/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge4 = __webpack_require__(1081);
	
	var _merge5 = _interopRequireDefault(_merge4);
	
	var _mapValues2 = __webpack_require__(415);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _hoistNonReactStatics = __webpack_require__(1338);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPromise = __webpack_require__(264);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(10);
	
	var _redux = __webpack_require__(16);
	
	var _actions = __webpack_require__(474);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _asyncValidation = __webpack_require__(1272);
	
	var _asyncValidation2 = _interopRequireDefault(_asyncValidation);
	
	var _defaultShouldAsyncValidate = __webpack_require__(476);
	
	var _defaultShouldAsyncValidate2 = _interopRequireDefault(_defaultShouldAsyncValidate);
	
	var _defaultShouldValidate = __webpack_require__(478);
	
	var _defaultShouldValidate2 = _interopRequireDefault(_defaultShouldValidate);
	
	var _defaultShouldError = __webpack_require__(477);
	
	var _defaultShouldError2 = _interopRequireDefault(_defaultShouldError);
	
	var _defaultShouldWarn = __webpack_require__(479);
	
	var _defaultShouldWarn2 = _interopRequireDefault(_defaultShouldWarn);
	
	var _silenceEvent = __webpack_require__(482);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	var _silenceEvents = __webpack_require__(1284);
	
	var _silenceEvents2 = _interopRequireDefault(_silenceEvents);
	
	var _generateValidator = __webpack_require__(1285);
	
	var _generateValidator2 = _interopRequireDefault(_generateValidator);
	
	var _handleSubmit = __webpack_require__(1286);
	
	var _handleSubmit2 = _interopRequireDefault(_handleSubmit);
	
	var _isValid = __webpack_require__(303);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _plain = __webpack_require__(86);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _getDisplayName = __webpack_require__(1337);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
	};
	
	// extract field-specific actions
	
	var arrayInsert = _actions2.default.arrayInsert,
	    arrayMove = _actions2.default.arrayMove,
	    arrayPop = _actions2.default.arrayPop,
	    arrayPush = _actions2.default.arrayPush,
	    arrayRemove = _actions2.default.arrayRemove,
	    arrayRemoveAll = _actions2.default.arrayRemoveAll,
	    arrayShift = _actions2.default.arrayShift,
	    arraySplice = _actions2.default.arraySplice,
	    arraySwap = _actions2.default.arraySwap,
	    arrayUnshift = _actions2.default.arrayUnshift,
	    blur = _actions2.default.blur,
	    change = _actions2.default.change,
	    focus = _actions2.default.focus,
	    formActions = _objectWithoutProperties(_actions2.default, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'blur', 'change', 'focus']);
	
	var arrayActions = {
	  arrayInsert: arrayInsert,
	  arrayMove: arrayMove,
	  arrayPop: arrayPop,
	  arrayPush: arrayPush,
	  arrayRemove: arrayRemove,
	  arrayRemoveAll: arrayRemoveAll,
	  arrayShift: arrayShift,
	  arraySplice: arraySplice,
	  arraySwap: arraySwap,
	  arrayUnshift: arrayUnshift
	};
	
	var propsToNotUpdateFor = [].concat(_toConsumableArray(Object.keys(_actions2.default)), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);
	
	var checkSubmit = function checkSubmit(submit) {
	  if (!submit || typeof submit !== 'function') {
	    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
	  }
	  return submit;
	};
	
	/**
	 * The decorator that is the main API to redux-form
	 */
	var createReduxForm = function createReduxForm(structure) {
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      keys = structure.keys,
	      fromJS = structure.fromJS;
	
	  var isValid = (0, _isValid2.default)(structure);
	  return function (initialConfig) {
	    var config = _extends({
	      touchOnBlur: true,
	      touchOnChange: false,
	      persistentSubmitErrors: false,
	      destroyOnUnmount: true,
	      shouldAsyncValidate: _defaultShouldAsyncValidate2.default,
	      shouldValidate: _defaultShouldValidate2.default,
	      shouldError: _defaultShouldError2.default,
	      shouldWarn: _defaultShouldWarn2.default,
	      enableReinitialize: false,
	      keepDirtyOnReinitialize: false,
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      },
	      pure: true,
	      forceUnregisterOnUnmount: false
	    }, initialConfig);
	
	    return function (WrappedComponent) {
	      var Form = function (_Component) {
	        _inherits(Form, _Component);
	
	        function Form() {
	          var _ref;
	
	          var _temp, _this, _ret;
	
	          _classCallCheck(this, Form);
	
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.destroyed = false, _this.fieldValidators = {}, _this.lastFieldValidatorKeys = [], _this.fieldWarners = {}, _this.lastFieldWarnerKeys = [], _this.innerOnSubmit = undefined, _this.submitPromise = undefined, _this.getValues = function () {
	            return _this.props.values;
	          }, _this.isValid = function () {
	            return _this.props.valid;
	          }, _this.isPristine = function () {
	            return _this.props.pristine;
	          }, _this.register = function (name, type, getValidator, getWarner) {
	            _this.props.registerField(name, type);
	            if (getValidator) {
	              _this.fieldValidators[name] = getValidator;
	            }
	            if (getWarner) {
	              _this.fieldWarners[name] = getWarner;
	            }
	          }, _this.unregister = function (name) {
	            if (!_this.destroyed) {
	              if (_this.props.destroyOnUnmount || _this.props.forceUnregisterOnUnmount) {
	                _this.props.unregisterField(name);
	                delete _this.fieldValidators[name];
	                delete _this.fieldWarners[name];
	              } else {
	                _this.props.unregisterField(name, false);
	              }
	            }
	          }, _this.getFieldList = function (options) {
	            var registeredFields = _this.props.registeredFields;
	            var list = [];
	            if (!registeredFields) {
	              return list;
	            }
	            var keySeq = keys(registeredFields);
	            if (options && options.excludeFieldArray) {
	              keySeq = keySeq.filter(function (name) {
	                return getIn(registeredFields, '[\'' + name + '\'].type') !== 'FieldArray';
	              });
	            }
	            return fromJS(keySeq.reduce(function (acc, key) {
	              acc.push(key);
	              return acc;
	            }, list));
	          }, _this.getValidators = function () {
	            var validators = {};
	            Object.keys(_this.fieldValidators).forEach(function (name) {
	              var validator = _this.fieldValidators[name]();
	              if (validator) {
	                validators[name] = validator;
	              }
	            });
	            return validators;
	          }, _this.generateValidator = function () {
	            var validators = _this.getValidators();
	            return Object.keys(validators).length ? (0, _generateValidator2.default)(validators, structure) : undefined;
	          }, _this.getWarners = function () {
	            var warners = {};
	            Object.keys(_this.fieldWarners).forEach(function (name) {
	              var warner = _this.fieldWarners[name]();
	              if (warner) {
	                warners[name] = warner;
	              }
	            });
	            return warners;
	          }, _this.generateWarner = function () {
	            var warners = _this.getWarners();
	            return Object.keys(warners).length ? (0, _generateValidator2.default)(warners, structure) : undefined;
	          }, _this.asyncValidate = function (name, value) {
	            var _this$props = _this.props,
	                asyncBlurFields = _this$props.asyncBlurFields,
	                asyncErrors = _this$props.asyncErrors,
	                asyncValidate = _this$props.asyncValidate,
	                dispatch = _this$props.dispatch,
	                initialized = _this$props.initialized,
	                pristine = _this$props.pristine,
	                shouldAsyncValidate = _this$props.shouldAsyncValidate,
	                startAsyncValidation = _this$props.startAsyncValidation,
	                stopAsyncValidation = _this$props.stopAsyncValidation,
	                syncErrors = _this$props.syncErrors,
	                values = _this$props.values;
	
	            var submitting = !name;
	            if (asyncValidate) {
	              var valuesToValidate = submitting ? values : setIn(values, name, value);
	              var syncValidationPasses = submitting || !getIn(syncErrors, name);
	              var isBlurredField = !submitting && (!asyncBlurFields || ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]')));
	              if ((isBlurredField || submitting) && shouldAsyncValidate({
	                asyncErrors: asyncErrors,
	                initialized: initialized,
	                trigger: submitting ? 'submit' : 'blur',
	                blurredField: name,
	                pristine: pristine,
	                syncValidationPasses: syncValidationPasses
	              })) {
	                return (0, _asyncValidation2.default)(function () {
	                  return asyncValidate(valuesToValidate, dispatch, _this.props, name);
	                }, startAsyncValidation, stopAsyncValidation, name);
	              }
	            }
	          }, _this.submitCompleted = function (result) {
	            delete _this.submitPromise;
	            return result;
	          }, _this.submitFailed = function (error) {
	            delete _this.submitPromise;
	            return error;
	          }, _this.listenToSubmit = function (promise) {
	            if (!(0, _isPromise2.default)(promise)) {
	              return promise;
	            }
	            _this.submitPromise = promise;
	            return promise.then(_this.submitCompleted, _this.submitFailed);
	          }, _this.submit = function (submitOrEvent) {
	            var _this$props2 = _this.props,
	                onSubmit = _this$props2.onSubmit,
	                blur = _this$props2.blur,
	                change = _this$props2.change,
	                dispatch = _this$props2.dispatch;
	
	
	            if (!submitOrEvent || (0, _silenceEvent2.default)(submitOrEvent)) {
	              // submitOrEvent is an event: fire submit if not already submitting
	              if (!_this.submitPromise) {
	                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
	                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) {
	                  // will call "submitOrEvent is the submit function" block below
	                  return _this.innerOnSubmit();
	                } else {
	                  return _this.listenToSubmit((0, _handleSubmit2.default)(checkSubmit(onSubmit), _extends({}, _this.props, (0, _redux.bindActionCreators)({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
	                }
	              }
	            } else {
	              // submitOrEvent is the submit function: return deferred submit thunk
	              return (0, _silenceEvents2.default)(function () {
	                return !_this.submitPromise && _this.listenToSubmit((0, _handleSubmit2.default)(checkSubmit(submitOrEvent), _extends({}, _this.props, (0, _redux.bindActionCreators)({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
	              });
	            }
	          }, _this.reset = function () {
	            return _this.props.reset();
	          }, _temp), _possibleConstructorReturn(_this, _ret);
	        }
	
	        _createClass(Form, [{
	          key: 'getChildContext',
	          value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	              _reduxForm: _extends({}, this.props, {
	                getFormState: function getFormState(state) {
	                  return getIn(_this2.props.getFormState(state), _this2.props.form);
	                },
	                asyncValidate: this.asyncValidate,
	                getValues: this.getValues,
	                sectionPrefix: undefined,
	                register: this.register,
	                unregister: this.unregister,
	                registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
	                  return _this2.innerOnSubmit = innerOnSubmit;
	                }
	              })
	            };
	          }
	        }, {
	          key: 'initIfNeeded',
	          value: function initIfNeeded(nextProps) {
	            var enableReinitialize = this.props.enableReinitialize;
	
	            if (nextProps) {
	              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
	                var _keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
	                this.props.initialize(nextProps.initialValues, _keepDirty, {
	                  lastInitialValues: this.props.initialValues
	                });
	              }
	            } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
	              this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize);
	            }
	          }
	        }, {
	          key: 'updateSyncErrorsIfNeeded',
	          value: function updateSyncErrorsIfNeeded(nextSyncErrors, nextError, lastSyncErrors) {
	            var _props = this.props,
	                error = _props.error,
	                updateSyncErrors = _props.updateSyncErrors;
	
	            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
	            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
	            if (!(noErrors && nextNoErrors) && (!_plain2.default.deepEqual(lastSyncErrors, nextSyncErrors) || !_plain2.default.deepEqual(error, nextError))) {
	              updateSyncErrors(nextSyncErrors, nextError);
	            }
	          }
	        }, {
	          key: 'clearSubmitPromiseIfNeeded',
	          value: function clearSubmitPromiseIfNeeded(nextProps) {
	            var submitting = this.props.submitting;
	
	            if (this.submitPromise && submitting && !nextProps.submitting) {
	              delete this.submitPromise;
	            }
	          }
	        }, {
	          key: 'submitIfNeeded',
	          value: function submitIfNeeded(nextProps) {
	            var _props2 = this.props,
	                clearSubmit = _props2.clearSubmit,
	                triggerSubmit = _props2.triggerSubmit;
	
	            if (!triggerSubmit && nextProps.triggerSubmit) {
	              clearSubmit();
	              this.submit();
	            }
	          }
	        }, {
	          key: 'validateIfNeeded',
	          value: function validateIfNeeded(nextProps) {
	            var _props3 = this.props,
	                shouldValidate = _props3.shouldValidate,
	                shouldError = _props3.shouldError,
	                validate = _props3.validate,
	                values = _props3.values;
	
	            var fieldLevelValidate = this.generateValidator();
	            if (validate || fieldLevelValidate) {
	              var initialRender = nextProps === undefined;
	              var fieldValidatorKeys = Object.keys(this.getValidators());
	              var validateParams = {
	                values: values,
	                nextProps: nextProps,
	                props: this.props,
	                initialRender: initialRender,
	                lastFieldValidatorKeys: this.lastFieldValidatorKeys,
	                fieldValidatorKeys: fieldValidatorKeys,
	                structure: structure
	              };
	              var shouldValidateResult = shouldValidate(validateParams);
	              var shouldErrorResult = shouldError(validateParams);
	
	              if (shouldValidateResult || shouldErrorResult) {
	                var propsToValidate = initialRender || !nextProps ? this.props : nextProps;
	
	                var _merge2 = (0, _merge5.default)(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
	                    _error = _merge2._error,
	                    nextSyncErrors = _objectWithoutProperties(_merge2, ['_error']);
	
	                this.lastFieldValidatorKeys = fieldValidatorKeys;
	                this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
	              }
	            }
	          }
	        }, {
	          key: 'updateSyncWarningsIfNeeded',
	          value: function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning, lastSyncWarnings) {
	            var _props4 = this.props,
	                warning = _props4.warning,
	                syncWarnings = _props4.syncWarnings,
	                updateSyncWarnings = _props4.updateSyncWarnings;
	
	            var noWarnings = (!syncWarnings || !Object.keys(syncWarnings).length) && !warning;
	            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
	            if (!(noWarnings && nextNoWarnings) && (!_plain2.default.deepEqual(lastSyncWarnings, nextSyncWarnings) || !_plain2.default.deepEqual(warning, nextWarning))) {
	              updateSyncWarnings(nextSyncWarnings, nextWarning);
	            }
	          }
	        }, {
	          key: 'warnIfNeeded',
	          value: function warnIfNeeded(nextProps) {
	            var _props5 = this.props,
	                shouldValidate = _props5.shouldValidate,
	                shouldWarn = _props5.shouldWarn,
	                warn = _props5.warn,
	                values = _props5.values;
	
	            var fieldLevelWarn = this.generateWarner();
	            if (warn || fieldLevelWarn) {
	              var initialRender = nextProps === undefined;
	              var fieldWarnerKeys = Object.keys(this.getWarners());
	              var validateParams = {
	                values: values,
	                nextProps: nextProps,
	                props: this.props,
	                initialRender: initialRender,
	                lastFieldValidatorKeys: this.lastFieldWarnerKeys,
	                fieldValidatorKeys: fieldWarnerKeys,
	                structure: structure
	              };
	              var shouldWarnResult = shouldWarn(validateParams);
	              var shouldValidateResult = shouldValidate(validateParams);
	
	              if (shouldValidateResult || shouldWarnResult) {
	                var propsToWarn = initialRender || !nextProps ? this.props : nextProps;
	
	                var _merge3 = (0, _merge5.default)(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
	                    _warning = _merge3._warning,
	                    nextSyncWarnings = _objectWithoutProperties(_merge3, ['_warning']);
	
	                this.lastFieldWarnerKeys = fieldWarnerKeys;
	                this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
	              }
	            }
	          }
	        }, {
	          key: 'componentWillMount',
	          value: function componentWillMount() {
	            this.initIfNeeded();
	            this.validateIfNeeded();
	            this.warnIfNeeded();
	            (0, _invariant2.default)(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
	          }
	        }, {
	          key: 'componentWillReceiveProps',
	          value: function componentWillReceiveProps(nextProps) {
	            this.initIfNeeded(nextProps);
	            this.validateIfNeeded(nextProps);
	            this.warnIfNeeded(nextProps);
	            this.clearSubmitPromiseIfNeeded(nextProps);
	            this.submitIfNeeded(nextProps);
	            var onChange = nextProps.onChange,
	                values = nextProps.values,
	                dispatch = nextProps.dispatch;
	
	            if (onChange && !deepEqual(values, this.props.values)) {
	              onChange(values, dispatch, nextProps);
	            }
	          }
	        }, {
	          key: 'shouldComponentUpdate',
	          value: function shouldComponentUpdate(nextProps) {
	            var _this3 = this;
	
	            if (!this.props.pure) return true;
	            var _config$immutableProp = config.immutableProps,
	                immutableProps = _config$immutableProp === undefined ? [] : _config$immutableProp;
	            // if we have children, we MUST update in React 16
	            // https://twitter.com/erikras/status/915866544558788608
	
	            return !!(this.props.children || nextProps.children || Object.keys(nextProps).some(function (prop) {
	              // useful to debug rerenders
	              // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	              //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	              // }
	              if (~immutableProps.indexOf(prop)) {
	                return _this3.props[prop] !== nextProps[prop];
	              }
	              return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
	            }));
	          }
	        }, {
	          key: 'componentWillUnmount',
	          value: function componentWillUnmount() {
	            var _props6 = this.props,
	                destroyOnUnmount = _props6.destroyOnUnmount,
	                destroy = _props6.destroy;
	
	            if (destroyOnUnmount) {
	              this.destroyed = true;
	              destroy();
	            }
	          }
	        }, {
	          key: 'render',
	          value: function render() {
	            // remove some redux-form config-only props
	            /* eslint-disable no-unused-vars */
	            var _props7 = this.props,
	                anyTouched = _props7.anyTouched,
	                arrayInsert = _props7.arrayInsert,
	                arrayMove = _props7.arrayMove,
	                arrayPop = _props7.arrayPop,
	                arrayPush = _props7.arrayPush,
	                arrayRemove = _props7.arrayRemove,
	                arrayRemoveAll = _props7.arrayRemoveAll,
	                arrayShift = _props7.arrayShift,
	                arraySplice = _props7.arraySplice,
	                arraySwap = _props7.arraySwap,
	                arrayUnshift = _props7.arrayUnshift,
	                asyncErrors = _props7.asyncErrors,
	                asyncValidate = _props7.asyncValidate,
	                asyncValidating = _props7.asyncValidating,
	                blur = _props7.blur,
	                change = _props7.change,
	                clearSubmit = _props7.clearSubmit,
	                destroy = _props7.destroy,
	                destroyOnUnmount = _props7.destroyOnUnmount,
	                forceUnregisterOnUnmount = _props7.forceUnregisterOnUnmount,
	                dirty = _props7.dirty,
	                dispatch = _props7.dispatch,
	                enableReinitialize = _props7.enableReinitialize,
	                error = _props7.error,
	                focus = _props7.focus,
	                form = _props7.form,
	                getFormState = _props7.getFormState,
	                initialize = _props7.initialize,
	                initialized = _props7.initialized,
	                initialValues = _props7.initialValues,
	                invalid = _props7.invalid,
	                keepDirtyOnReinitialize = _props7.keepDirtyOnReinitialize,
	                pristine = _props7.pristine,
	                propNamespace = _props7.propNamespace,
	                registeredFields = _props7.registeredFields,
	                registerField = _props7.registerField,
	                reset = _props7.reset,
	                setSubmitFailed = _props7.setSubmitFailed,
	                setSubmitSucceeded = _props7.setSubmitSucceeded,
	                shouldAsyncValidate = _props7.shouldAsyncValidate,
	                shouldValidate = _props7.shouldValidate,
	                shouldError = _props7.shouldError,
	                shouldWarn = _props7.shouldWarn,
	                startAsyncValidation = _props7.startAsyncValidation,
	                startSubmit = _props7.startSubmit,
	                stopAsyncValidation = _props7.stopAsyncValidation,
	                stopSubmit = _props7.stopSubmit,
	                submitting = _props7.submitting,
	                submitFailed = _props7.submitFailed,
	                submitSucceeded = _props7.submitSucceeded,
	                touch = _props7.touch,
	                touchOnBlur = _props7.touchOnBlur,
	                touchOnChange = _props7.touchOnChange,
	                persistentSubmitErrors = _props7.persistentSubmitErrors,
	                syncErrors = _props7.syncErrors,
	                syncWarnings = _props7.syncWarnings,
	                unregisterField = _props7.unregisterField,
	                untouch = _props7.untouch,
	                updateSyncErrors = _props7.updateSyncErrors,
	                updateSyncWarnings = _props7.updateSyncWarnings,
	                valid = _props7.valid,
	                validExceptSubmit = _props7.validExceptSubmit,
	                values = _props7.values,
	                warning = _props7.warning,
	                rest = _objectWithoutProperties(_props7, ['anyTouched', 'arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncErrors', 'asyncValidate', 'asyncValidating', 'blur', 'change', 'clearSubmit', 'destroy', 'destroyOnUnmount', 'forceUnregisterOnUnmount', 'dirty', 'dispatch', 'enableReinitialize', 'error', 'focus', 'form', 'getFormState', 'initialize', 'initialized', 'initialValues', 'invalid', 'keepDirtyOnReinitialize', 'pristine', 'propNamespace', 'registeredFields', 'registerField', 'reset', 'setSubmitFailed', 'setSubmitSucceeded', 'shouldAsyncValidate', 'shouldValidate', 'shouldError', 'shouldWarn', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitting', 'submitFailed', 'submitSucceeded', 'touch', 'touchOnBlur', 'touchOnChange', 'persistentSubmitErrors', 'syncErrors', 'syncWarnings', 'unregisterField', 'untouch', 'updateSyncErrors', 'updateSyncWarnings', 'valid', 'validExceptSubmit', 'values', 'warning']);
	            /* eslint-enable no-unused-vars */
	
	
	            var reduxFormProps = _extends({
	              anyTouched: anyTouched,
	              asyncValidate: this.asyncValidate,
	              asyncValidating: asyncValidating
	            }, (0, _redux.bindActionCreators)({ blur: blur, change: change }, dispatch), {
	              clearSubmit: clearSubmit,
	              destroy: destroy,
	              dirty: dirty,
	              dispatch: dispatch,
	              error: error,
	              form: form,
	              handleSubmit: this.submit,
	              initialize: initialize,
	              initialized: initialized,
	              initialValues: initialValues,
	              invalid: invalid,
	              pristine: pristine,
	              reset: reset,
	              submitting: submitting,
	              submitFailed: submitFailed,
	              submitSucceeded: submitSucceeded,
	              touch: touch,
	              untouch: untouch,
	              valid: valid,
	              warning: warning
	            });
	            var propsToPass = _extends({}, propNamespace ? _defineProperty({}, propNamespace, reduxFormProps) : reduxFormProps, rest);
	            if (isClassComponent(WrappedComponent)) {
	              propsToPass.ref = 'wrapped';
	            }
	            return (0, _react.createElement)(WrappedComponent, propsToPass);
	          }
	        }]);
	
	        return Form;
	      }(_react.Component);
	
	      Form.displayName = 'Form(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	      Form.WrappedComponent = WrappedComponent;
	      Form.childContextTypes = {
	        _reduxForm: _propTypes2.default.object.isRequired
	      };
	      Form.propTypes = {
	        destroyOnUnmount: _propTypes2.default.bool,
	        forceUnregisterOnUnmount: _propTypes2.default.bool,
	        form: _propTypes2.default.string.isRequired,
	        initialValues: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
	        getFormState: _propTypes2.default.func,
	        onSubmitFail: _propTypes2.default.func,
	        onSubmitSuccess: _propTypes2.default.func,
	        propNamespace: _propTypes2.default.string,
	        validate: _propTypes2.default.func,
	        warn: _propTypes2.default.func,
	        touchOnBlur: _propTypes2.default.bool,
	        touchOnChange: _propTypes2.default.bool,
	        triggerSubmit: _propTypes2.default.bool,
	        persistentSubmitErrors: _propTypes2.default.bool,
	        registeredFields: _propTypes2.default.any
	      };
	
	      var connector = (0, _reactRedux.connect)(function (state, props) {
	        var form = props.form,
	            getFormState = props.getFormState,
	            initialValues = props.initialValues,
	            enableReinitialize = props.enableReinitialize,
	            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;
	
	        var formState = getIn(getFormState(state) || empty, form) || empty;
	        var stateInitial = getIn(formState, 'initial');
	        var initialized = !!stateInitial;
	
	        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
	        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;
	
	        var initial = initialValues || stateInitial || empty;
	
	        if (shouldUpdateInitialValues) {
	          initial = stateInitial || empty;
	        }
	
	        var values = getIn(formState, 'values') || initial;
	
	        if (shouldResetValues) {
	          values = initial;
	        }
	
	        var pristine = shouldResetValues || deepEqual(initial, values);
	        var asyncErrors = getIn(formState, 'asyncErrors');
	        var syncErrors = getIn(formState, 'syncErrors') || {};
	        var syncWarnings = getIn(formState, 'syncWarnings') || {};
	        var registeredFields = getIn(formState, 'registeredFields');
	        var valid = isValid(form, getFormState, false)(state);
	        var validExceptSubmit = isValid(form, getFormState, true)(state);
	        var anyTouched = !!getIn(formState, 'anyTouched');
	        var submitting = !!getIn(formState, 'submitting');
	        var submitFailed = !!getIn(formState, 'submitFailed');
	        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
	        var error = getIn(formState, 'error');
	        var warning = getIn(formState, 'warning');
	        var triggerSubmit = getIn(formState, 'triggerSubmit');
	        return {
	          anyTouched: anyTouched,
	          asyncErrors: asyncErrors,
	          asyncValidating: getIn(formState, 'asyncValidating') || false,
	          dirty: !pristine,
	          error: error,
	          initialized: initialized,
	          invalid: !valid,
	          pristine: pristine,
	          registeredFields: registeredFields,
	          submitting: submitting,
	          submitFailed: submitFailed,
	          submitSucceeded: submitSucceeded,
	          syncErrors: syncErrors,
	          syncWarnings: syncWarnings,
	          triggerSubmit: triggerSubmit,
	          values: values,
	          valid: valid,
	          validExceptSubmit: validExceptSubmit,
	          warning: warning
	        };
	      }, function (dispatch, initialProps) {
	        var bindForm = function bindForm(actionCreator) {
	          return actionCreator.bind(null, initialProps.form);
	        };
	
	        // Bind the first parameter on `props.form`
	        var boundFormACs = (0, _mapValues3.default)(formActions, bindForm);
	        var boundArrayACs = (0, _mapValues3.default)(arrayActions, bindForm);
	        var boundBlur = function boundBlur(field, value) {
	          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
	        };
	        var boundChange = function boundChange(field, value) {
	          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
	        };
	        var boundFocus = bindForm(focus);
	
	        // Wrap action creators with `dispatch`
	        var connectedFormACs = (0, _redux.bindActionCreators)(boundFormACs, dispatch);
	        var connectedArrayACs = {
	          insert: (0, _redux.bindActionCreators)(boundArrayACs.arrayInsert, dispatch),
	          move: (0, _redux.bindActionCreators)(boundArrayACs.arrayMove, dispatch),
	          pop: (0, _redux.bindActionCreators)(boundArrayACs.arrayPop, dispatch),
	          push: (0, _redux.bindActionCreators)(boundArrayACs.arrayPush, dispatch),
	          remove: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemove, dispatch),
	          removeAll: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemoveAll, dispatch),
	          shift: (0, _redux.bindActionCreators)(boundArrayACs.arrayShift, dispatch),
	          splice: (0, _redux.bindActionCreators)(boundArrayACs.arraySplice, dispatch),
	          swap: (0, _redux.bindActionCreators)(boundArrayACs.arraySwap, dispatch),
	          unshift: (0, _redux.bindActionCreators)(boundArrayACs.arrayUnshift, dispatch)
	        };
	
	        var computedActions = _extends({}, connectedFormACs, boundArrayACs, {
	          blur: boundBlur,
	          change: boundChange,
	          array: connectedArrayACs,
	          focus: boundFocus,
	          dispatch: dispatch
	        });
	
	        return function () {
	          return computedActions;
	        };
	      }, undefined, { withRef: true });
	      var ConnectedForm = (0, _hoistNonReactStatics2.default)(connector(Form), WrappedComponent);
	      ConnectedForm.defaultProps = config;
	
	      // build outer component to expose instance api
	
	      var ReduxForm = function (_Component2) {
	        _inherits(ReduxForm, _Component2);
	
	        function ReduxForm() {
	          _classCallCheck(this, ReduxForm);
	
	          return _possibleConstructorReturn(this, (ReduxForm.__proto__ || Object.getPrototypeOf(ReduxForm)).apply(this, arguments));
	        }
	
	        _createClass(ReduxForm, [{
	          key: 'submit',
	          value: function submit() {
	            return this.ref && this.ref.getWrappedInstance().submit();
	          }
	        }, {
	          key: 'reset',
	          value: function reset() {
	            if (this.ref) {
	              this.ref.getWrappedInstance().reset();
	            }
	          }
	        }, {
	          key: 'render',
	          value: function render() {
	            var _this5 = this;
	
	            var _props8 = this.props,
	                initialValues = _props8.initialValues,
	                rest = _objectWithoutProperties(_props8, ['initialValues']);
	
	            return (0, _react.createElement)(ConnectedForm, _extends({}, rest, {
	              ref: function ref(_ref3) {
	                return _this5.ref = _ref3;
	              },
	              // convert initialValues if need to
	              initialValues: fromJS(initialValues)
	            }));
	          }
	        }, {
	          key: 'valid',
	          get: function get() {
	            return !!(this.ref && this.ref.getWrappedInstance().isValid());
	          }
	        }, {
	          key: 'invalid',
	          get: function get() {
	            return !this.valid;
	          }
	        }, {
	          key: 'pristine',
	          get: function get() {
	            return !!(this.ref && this.ref.getWrappedInstance().isPristine());
	          }
	        }, {
	          key: 'dirty',
	          get: function get() {
	            return !this.pristine;
	          }
	        }, {
	          key: 'values',
	          get: function get() {
	            return this.ref ? this.ref.getWrappedInstance().getValues() : empty;
	          }
	        }, {
	          key: 'fieldList',
	          get: function get() {
	            // mainly provided for testing
	            return this.ref ? this.ref.getWrappedInstance().getFieldList() : [];
	          }
	        }, {
	          key: 'wrappedInstance',
	          get: function get() {
	            // for testing
	            return this.ref && this.ref.getWrappedInstance().refs.wrapped;
	          }
	        }]);
	
	        return ReduxForm;
	      }(_react.Component);
	
	      return (0, _hoistNonReactStatics2.default)(ReduxForm, WrappedComponent);
	    };
	  };
	};
	
	exports.default = createReduxForm;

/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRedux = __webpack_require__(10);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var createValues = function createValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (config) {
	    var _prop$getFormState$co = _extends({
	      prop: 'values',
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      }
	    }, config),
	        form = _prop$getFormState$co.form,
	        prop = _prop$getFormState$co.prop,
	        getFormState = _prop$getFormState$co.getFormState;
	
	    return (0, _reactRedux.connect)(function (state) {
	      return _defineProperty({}, prop, getIn(getFormState(state), form + '.values'));
	    }
	    // ignore dispatch
	    );
	  };
	};
	
	exports.default = createValues;

/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(131);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createDeleteInWithCleanUp(_ref) {
	  var deepEqual = _ref.deepEqual,
	      empty = _ref.empty,
	      getIn = _ref.getIn,
	      deleteIn = _ref.deleteIn,
	      setIn = _ref.setIn;
	
	  var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
	    if (path[path.length - 1] === ']') {
	      // array path
	      var pathTokens = (0, _toPath3.default)(path);
	      pathTokens.pop();
	      var parent = getIn(state, pathTokens.join('.'));
	      return parent ? setIn(state, path) : state;
	    }
	
	    var result = state;
	    if (getIn(state, path) !== undefined) {
	      result = deleteIn(state, path);
	    }
	
	    var dotIndex = path.lastIndexOf('.');
	    if (dotIndex > 0) {
	      var parentPath = path.substring(0, dotIndex);
	      if (parentPath[parentPath.length - 1] !== ']') {
	        var _parent = getIn(result, parentPath);
	        if (deepEqual(_parent, empty)) {
	          return deleteInWithCleanUp(result, parentPath);
	        }
	      }
	    }
	    return result;
	  };
	
	  return deleteInWithCleanUp;
	}
	
	exports.default = createDeleteInWithCleanUp;

/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEvent = __webpack_require__(480);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	  return result;
	};
	
	
	var getValue = function getValue(event, isReactNative) {
	  if ((0, _isEvent2.default)(event)) {
	    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	      return event.nativeEvent.text;
	    }
	    if (isReactNative && event.nativeEvent !== undefined) {
	      return event.nativeEvent.text;
	    }
	    var detypedEvent = event;
	    var _detypedEvent$target = detypedEvent.target,
	        type = _detypedEvent$target.type,
	        value = _detypedEvent$target.value,
	        checked = _detypedEvent$target.checked,
	        files = _detypedEvent$target.files,
	        dataTransfer = detypedEvent.dataTransfer;
	
	    if (type === 'checkbox') {
	      return !!checked;
	    }
	    if (type === 'file') {
	      return files || dataTransfer && dataTransfer.files;
	    }
	    if (type === 'select-multiple') {
	      return getSelectedValues(event.target.options);
	    }
	    return value;
	  }
	  return event;
	};
	
	exports.default = getValue;

/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _silenceEvent = __webpack_require__(482);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvents = function silenceEvents(fn) {
	  return function (event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _silenceEvent2.default)(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
	  };
	};
	exports.default = silenceEvents;

/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _plain = __webpack_require__(86);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toArray = function toArray(value) {
	  return Array.isArray(value) ? value : [value];
	};
	
	
	var getError = function getError(value, values, props, validators, name) {
	  var array = toArray(validators);
	  for (var i = 0; i < array.length; i++) {
	    var error = array[i](value, values, props, name);
	    if (error) {
	      return error;
	    }
	  }
	};
	
	var generateValidator = function generateValidator(validators, _ref) {
	  var getIn = _ref.getIn;
	  return function (values, props) {
	    var errors = {};
	    Object.keys(validators).forEach(function (name) {
	      var value = getIn(values, name);
	      var error = getError(value, values, props, validators[name], name);
	      if (error) {
	        errors = _plain2.default.setIn(errors, name, error);
	      }
	    });
	    return errors;
	  };
	};
	
	exports.default = generateValidator;

/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isPromise = __webpack_require__(264);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _SubmissionError = __webpack_require__(473);
	
	var _SubmissionError2 = _interopRequireDefault(_SubmissionError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
	  var dispatch = props.dispatch,
	      onSubmitFail = props.onSubmitFail,
	      onSubmitSuccess = props.onSubmitSuccess,
	      startSubmit = props.startSubmit,
	      stopSubmit = props.stopSubmit,
	      setSubmitFailed = props.setSubmitFailed,
	      setSubmitSucceeded = props.setSubmitSucceeded,
	      syncErrors = props.syncErrors,
	      asyncErrors = props.asyncErrors,
	      touch = props.touch,
	      values = props.values,
	      persistentSubmitErrors = props.persistentSubmitErrors;
	
	
	  touch.apply(undefined, _toConsumableArray(fields)); // mark all fields as touched
	
	  if (valid || persistentSubmitErrors) {
	    var doSubmit = function doSubmit() {
	      var result = void 0;
	      try {
	        result = submit(values, dispatch, props);
	      } catch (submitError) {
	        var error = submitError instanceof _SubmissionError2.default ? submitError.errors : undefined;
	        stopSubmit(error);
	        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	        if (onSubmitFail) {
	          onSubmitFail(error, dispatch, submitError, props);
	        }
	        if (error || onSubmitFail) {
	          // if you've provided an onSubmitFail callback, don't re-throw the error
	          return error;
	        } else {
	          throw submitError;
	        }
	      }
	      if ((0, _isPromise2.default)(result)) {
	        startSubmit();
	        return result.then(function (submitResult) {
	          stopSubmit();
	          setSubmitSucceeded();
	          if (onSubmitSuccess) {
	            onSubmitSuccess(submitResult, dispatch, props);
	          }
	          return submitResult;
	        }, function (submitError) {
	          var error = submitError instanceof _SubmissionError2.default ? submitError.errors : undefined;
	          stopSubmit(error);
	          setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	          if (onSubmitFail) {
	            onSubmitFail(error, dispatch, submitError, props);
	          }
	          if (error || onSubmitFail) {
	            // if you've provided an onSubmitFail callback, don't re-throw the error
	            return error;
	          } else {
	            throw submitError;
	          }
	        });
	      } else {
	        setSubmitSucceeded();
	        if (onSubmitSuccess) {
	          onSubmitSuccess(result, dispatch, props);
	        }
	      }
	      return result;
	    };
	
	    var asyncValidateResult = asyncValidate && asyncValidate();
	    if (asyncValidateResult) {
	      return asyncValidateResult.then(function (asyncErrors) {
	        if (asyncErrors) {
	          throw asyncErrors;
	        }
	        return doSubmit();
	      }).catch(function (asyncErrors) {
	        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	        if (onSubmitFail) {
	          onSubmitFail(asyncErrors, dispatch, null, props);
	        }
	        return Promise.reject(asyncErrors);
	      });
	    } else {
	      return doSubmit();
	    }
	  } else {
	    setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	    var errors = _extends({}, asyncErrors, syncErrors);
	    if (onSubmitFail) {
	      onSubmitFail(errors, dispatch, null, props);
	    }
	    return errors;
	  }
	};
	
	exports.default = handleSubmit;

/***/ },
/* 1287 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var getErrorKeys = function getErrorKeys(name, type) {
	  switch (type) {
	    case 'Field':
	      return [name, name + '._error'];
	    case 'FieldArray':
	      return [name + '._error'];
	    default:
	      throw new Error('Unknown field type');
	  }
	};
	
	
	var createHasError = function createHasError(_ref) {
	  var getIn = _ref.getIn;
	
	  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
	    if (!syncErrors && !asyncErrors && !submitErrors) {
	      return false;
	    }
	
	    var name = getIn(field, 'name');
	    var type = getIn(field, 'type');
	    return getErrorKeys(name, type).some(function (key) {
	      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
	    });
	  };
	  return hasError;
	};
	
	exports.default = createHasError;

/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.untouch = exports.unregisterField = exports.touch = exports.submit = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.setSubmitSucceeded = exports.setSubmitFailed = exports.reset = exports.registerField = exports.initialize = exports.focus = exports.destroy = exports.clearSubmitErrors = exports.change = exports.blur = exports.autofill = exports.arrayUnshift = exports.arraySwap = exports.arraySplice = exports.arrayShift = exports.arrayRemoveAll = exports.arrayRemove = exports.arrayPush = exports.arrayPop = exports.arrayMove = exports.arrayInsert = exports.actionTypes = exports.values = exports.reducer = exports.reduxForm = exports.hasSubmitFailed = exports.hasSubmitSucceeded = exports.isSubmitting = exports.isValid = exports.isPristine = exports.isInvalid = exports.isDirty = exports.getFormSubmitErrors = exports.getFormSyncWarnings = exports.getFormAsyncErrors = exports.getFormMeta = exports.getFormSyncErrors = exports.getFormInitialValues = exports.getFormValues = exports.getFormNames = exports.getFormError = exports.formValues = exports.formValueSelector = exports.FieldArray = exports.Fields = exports.Field = exports.formPropTypes = exports.fieldArrayPropTypes = exports.fieldArrayMetaPropTypes = exports.fieldArrayFieldsPropTypes = exports.fieldPropTypes = exports.fieldMetaPropTypes = exports.fieldInputPropTypes = exports.propTypes = exports.SubmissionError = exports.FormSection = exports.Form = exports.defaultShouldWarn = exports.defaultShouldError = exports.defaultShouldValidate = exports.defaultShouldAsyncValidate = undefined;
	
	var _defaultShouldAsyncValidate = __webpack_require__(476);
	
	Object.defineProperty(exports, 'defaultShouldAsyncValidate', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_defaultShouldAsyncValidate).default;
	  }
	});
	
	var _defaultShouldValidate = __webpack_require__(478);
	
	Object.defineProperty(exports, 'defaultShouldValidate', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_defaultShouldValidate).default;
	  }
	});
	
	var _defaultShouldError = __webpack_require__(477);
	
	Object.defineProperty(exports, 'defaultShouldError', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_defaultShouldError).default;
	  }
	});
	
	var _defaultShouldWarn = __webpack_require__(479);
	
	Object.defineProperty(exports, 'defaultShouldWarn', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_defaultShouldWarn).default;
	  }
	});
	
	var _Form = __webpack_require__(1270);
	
	Object.defineProperty(exports, 'Form', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Form).default;
	  }
	});
	
	var _FormSection = __webpack_require__(1271);
	
	Object.defineProperty(exports, 'FormSection', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormSection).default;
	  }
	});
	
	var _SubmissionError = __webpack_require__(473);
	
	Object.defineProperty(exports, 'SubmissionError', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SubmissionError).default;
	  }
	});
	
	var _propTypes = __webpack_require__(1313);
	
	Object.defineProperty(exports, 'propTypes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_propTypes).default;
	  }
	});
	Object.defineProperty(exports, 'fieldInputPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.fieldInputPropTypes;
	  }
	});
	Object.defineProperty(exports, 'fieldMetaPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.fieldMetaPropTypes;
	  }
	});
	Object.defineProperty(exports, 'fieldPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.fieldPropTypes;
	  }
	});
	Object.defineProperty(exports, 'fieldArrayFieldsPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.fieldArrayFieldsPropTypes;
	  }
	});
	Object.defineProperty(exports, 'fieldArrayMetaPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.fieldArrayMetaPropTypes;
	  }
	});
	Object.defineProperty(exports, 'fieldArrayPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.fieldArrayPropTypes;
	  }
	});
	Object.defineProperty(exports, 'formPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.formPropTypes;
	  }
	});
	
	var _Field = __webpack_require__(1289);
	
	Object.defineProperty(exports, 'Field', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Field).default;
	  }
	});
	
	var _Fields = __webpack_require__(1291);
	
	Object.defineProperty(exports, 'Fields', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Fields).default;
	  }
	});
	
	var _FieldArray = __webpack_require__(1290);
	
	Object.defineProperty(exports, 'FieldArray', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FieldArray).default;
	  }
	});
	
	var _formValueSelector = __webpack_require__(1292);
	
	Object.defineProperty(exports, 'formValueSelector', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_formValueSelector).default;
	  }
	});
	
	var _formValues = __webpack_require__(1293);
	
	Object.defineProperty(exports, 'formValues', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_formValues).default;
	  }
	});
	
	var _getFormError = __webpack_require__(1295);
	
	Object.defineProperty(exports, 'getFormError', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormError).default;
	  }
	});
	
	var _getFormNames = __webpack_require__(1298);
	
	Object.defineProperty(exports, 'getFormNames', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormNames).default;
	  }
	});
	
	var _getFormValues = __webpack_require__(1302);
	
	Object.defineProperty(exports, 'getFormValues', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormValues).default;
	  }
	});
	
	var _getFormInitialValues = __webpack_require__(1296);
	
	Object.defineProperty(exports, 'getFormInitialValues', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormInitialValues).default;
	  }
	});
	
	var _getFormSyncErrors = __webpack_require__(1300);
	
	Object.defineProperty(exports, 'getFormSyncErrors', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormSyncErrors).default;
	  }
	});
	
	var _getFormMeta = __webpack_require__(1297);
	
	Object.defineProperty(exports, 'getFormMeta', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormMeta).default;
	  }
	});
	
	var _getFormAsyncErrors = __webpack_require__(1294);
	
	Object.defineProperty(exports, 'getFormAsyncErrors', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormAsyncErrors).default;
	  }
	});
	
	var _getFormSyncWarnings = __webpack_require__(1301);
	
	Object.defineProperty(exports, 'getFormSyncWarnings', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormSyncWarnings).default;
	  }
	});
	
	var _getFormSubmitErrors = __webpack_require__(1299);
	
	Object.defineProperty(exports, 'getFormSubmitErrors', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormSubmitErrors).default;
	  }
	});
	
	var _isDirty = __webpack_require__(1305);
	
	Object.defineProperty(exports, 'isDirty', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isDirty).default;
	  }
	});
	
	var _isInvalid = __webpack_require__(1306);
	
	Object.defineProperty(exports, 'isInvalid', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isInvalid).default;
	  }
	});
	
	var _isPristine = __webpack_require__(1307);
	
	Object.defineProperty(exports, 'isPristine', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isPristine).default;
	  }
	});
	
	var _isValid = __webpack_require__(1309);
	
	Object.defineProperty(exports, 'isValid', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isValid).default;
	  }
	});
	
	var _isSubmitting = __webpack_require__(1308);
	
	Object.defineProperty(exports, 'isSubmitting', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isSubmitting).default;
	  }
	});
	
	var _hasSubmitSucceeded = __webpack_require__(1304);
	
	Object.defineProperty(exports, 'hasSubmitSucceeded', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_hasSubmitSucceeded).default;
	  }
	});
	
	var _hasSubmitFailed = __webpack_require__(1303);
	
	Object.defineProperty(exports, 'hasSubmitFailed', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_hasSubmitFailed).default;
	  }
	});
	
	var _reduxForm = __webpack_require__(1311);
	
	Object.defineProperty(exports, 'reduxForm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_reduxForm).default;
	  }
	});
	
	var _reducer = __webpack_require__(1310);
	
	Object.defineProperty(exports, 'reducer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_reducer).default;
	  }
	});
	
	var _values = __webpack_require__(1312);
	
	Object.defineProperty(exports, 'values', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_values).default;
	  }
	});
	
	var _actions = __webpack_require__(474);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _actionTypes2 = __webpack_require__(302);
	
	var _actionTypes = _interopRequireWildcard(_actionTypes2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionTypes = exports.actionTypes = _actionTypes;
	var arrayInsert = exports.arrayInsert = _actions2.default.arrayInsert;
	var arrayMove = exports.arrayMove = _actions2.default.arrayMove;
	var arrayPop = exports.arrayPop = _actions2.default.arrayPop;
	var arrayPush = exports.arrayPush = _actions2.default.arrayPush;
	var arrayRemove = exports.arrayRemove = _actions2.default.arrayRemove;
	var arrayRemoveAll = exports.arrayRemoveAll = _actions2.default.arrayRemoveAll;
	var arrayShift = exports.arrayShift = _actions2.default.arrayShift;
	var arraySplice = exports.arraySplice = _actions2.default.arraySplice;
	var arraySwap = exports.arraySwap = _actions2.default.arraySwap;
	var arrayUnshift = exports.arrayUnshift = _actions2.default.arrayUnshift;
	var autofill = exports.autofill = _actions2.default.autofill;
	var blur = exports.blur = _actions2.default.blur;
	var change = exports.change = _actions2.default.change;
	var clearSubmitErrors = exports.clearSubmitErrors = _actions2.default.clearSubmitErrors;
	var destroy = exports.destroy = _actions2.default.destroy;
	var focus = exports.focus = _actions2.default.focus;
	var initialize = exports.initialize = _actions2.default.initialize;
	var registerField = exports.registerField = _actions2.default.registerField;
	var reset = exports.reset = _actions2.default.reset;
	var setSubmitFailed = exports.setSubmitFailed = _actions2.default.setSubmitFailed;
	var setSubmitSucceeded = exports.setSubmitSucceeded = _actions2.default.setSubmitSucceeded;
	var startAsyncValidation = exports.startAsyncValidation = _actions2.default.startAsyncValidation;
	var startSubmit = exports.startSubmit = _actions2.default.startSubmit;
	var stopAsyncValidation = exports.stopAsyncValidation = _actions2.default.stopAsyncValidation;
	var stopSubmit = exports.stopSubmit = _actions2.default.stopSubmit;
	var submit = exports.submit = _actions2.default.submit;
	var touch = exports.touch = _actions2.default.touch;
	var unregisterField = exports.unregisterField = _actions2.default.unregisterField;
	var untouch = exports.untouch = _actions2.default.untouch;

/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createField = __webpack_require__(1273);
	
	var _createField2 = _interopRequireDefault(_createField);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createField2.default)(_immutable2.default);

/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createFieldArray = __webpack_require__(1274);
	
	var _createFieldArray2 = _interopRequireDefault(_createFieldArray);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createFieldArray2.default)(_immutable2.default);

/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createFields = __webpack_require__(1276);
	
	var _createFields2 = _interopRequireDefault(_createFields);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createFields2.default)(_immutable2.default);

/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createFormValueSelector = __webpack_require__(1277);
	
	var _createFormValueSelector2 = _interopRequireDefault(_createFormValueSelector);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createFormValueSelector2.default)(_immutable2.default);

/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createFormValues = __webpack_require__(1278);
	
	var _createFormValues2 = _interopRequireDefault(_createFormValues);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createFormValues2.default)(_immutable2.default);

/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormAsyncErrors = __webpack_require__(1314);
	
	var _getFormAsyncErrors2 = _interopRequireDefault(_getFormAsyncErrors);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormAsyncErrors2.default)(_immutable2.default);

/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormError = __webpack_require__(1315);
	
	var _getFormError2 = _interopRequireDefault(_getFormError);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormError2.default)(_immutable2.default);

/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormInitialValues = __webpack_require__(1316);
	
	var _getFormInitialValues2 = _interopRequireDefault(_getFormInitialValues);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormInitialValues2.default)(_immutable2.default);

/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormMeta = __webpack_require__(1317);
	
	var _getFormMeta2 = _interopRequireDefault(_getFormMeta);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormMeta2.default)(_immutable2.default);

/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormNames = __webpack_require__(1318);
	
	var _getFormNames2 = _interopRequireDefault(_getFormNames);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormNames2.default)(_immutable2.default);

/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormSubmitErrors = __webpack_require__(1319);
	
	var _getFormSubmitErrors2 = _interopRequireDefault(_getFormSubmitErrors);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormSubmitErrors2.default)(_immutable2.default);

/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormSyncErrors = __webpack_require__(1320);
	
	var _getFormSyncErrors2 = _interopRequireDefault(_getFormSyncErrors);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormSyncErrors2.default)(_immutable2.default);

/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormSyncWarnings = __webpack_require__(1321);
	
	var _getFormSyncWarnings2 = _interopRequireDefault(_getFormSyncWarnings);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormSyncWarnings2.default)(_immutable2.default);

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormValues = __webpack_require__(1322);
	
	var _getFormValues2 = _interopRequireDefault(_getFormValues);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormValues2.default)(_immutable2.default);

/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hasSubmitFailed = __webpack_require__(1323);
	
	var _hasSubmitFailed2 = _interopRequireDefault(_hasSubmitFailed);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _hasSubmitFailed2.default)(_immutable2.default);

/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hasSubmitSucceeded = __webpack_require__(1324);
	
	var _hasSubmitSucceeded2 = _interopRequireDefault(_hasSubmitSucceeded);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _hasSubmitSucceeded2.default)(_immutable2.default);

/***/ },
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isDirty = __webpack_require__(1325);
	
	var _isDirty2 = _interopRequireDefault(_isDirty);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _isDirty2.default)(_immutable2.default);

/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isInvalid = __webpack_require__(1326);
	
	var _isInvalid2 = _interopRequireDefault(_isInvalid);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _isInvalid2.default)(_immutable2.default);

/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPristine = __webpack_require__(484);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _isPristine2.default)(_immutable2.default);

/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isSubmitting = __webpack_require__(1327);
	
	var _isSubmitting2 = _interopRequireDefault(_isSubmitting);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _isSubmitting2.default)(_immutable2.default);

/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isValid = __webpack_require__(303);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _isValid2.default)(_immutable2.default);

/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createReducer = __webpack_require__(1279);
	
	var _createReducer2 = _interopRequireDefault(_createReducer);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createReducer2.default)(_immutable2.default);

/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createReduxForm = __webpack_require__(1280);
	
	var _createReduxForm2 = _interopRequireDefault(_createReduxForm);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createReduxForm2.default)(_immutable2.default);

/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createValues = __webpack_require__(1281);
	
	var _createValues2 = _interopRequireDefault(_createValues);
	
	var _immutable = __webpack_require__(24);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createValues2.default)(_immutable2.default);

/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fieldArrayPropTypes = exports.fieldPropTypes = exports.fieldArrayFieldsPropTypes = exports.fieldArrayMetaPropTypes = exports.fieldMetaPropTypes = exports.fieldInputPropTypes = exports.formPropTypes = undefined;
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var any = _propTypes2.default.any,
	    bool = _propTypes2.default.bool,
	    func = _propTypes2.default.func,
	    shape = _propTypes2.default.shape,
	    string = _propTypes2.default.string,
	    oneOfType = _propTypes2.default.oneOfType,
	    object = _propTypes2.default.object,
	    number = _propTypes2.default.number;
	var formPropTypes = exports.formPropTypes = {
	  // State:
	  anyTouched: bool.isRequired, // true if any of the fields have been marked as touched
	  asyncValidating: oneOfType([bool, string]).isRequired, // true if async validation is running, a string if a field triggered async validation
	  dirty: bool.isRequired, // true if any values are different from initialValues
	  error: any, // form-wide error from '_error' key in validation result
	  form: string.isRequired, // the name of the form
	  invalid: bool.isRequired, // true if there are any validation errors
	  initialized: bool.isRequired, // true if the form has been initialized
	  initialValues: object, // the initialValues object passed to reduxForm
	  pristine: bool.isRequired, // true if the values are the same as initialValues
	  pure: bool.isRequired, // if true, implements shouldComponentUpdate
	  submitting: bool.isRequired, // true if the form is in the process of being submitted
	  submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
	  submitSucceeded: bool.isRequired, // true if the form was successfully submitted
	  valid: bool.isRequired, // true if there are no validation errors
	  warning: any, // form-wide warning from '_warning' key in validation result
	  // Actions:
	  array: shape({
	    insert: func.isRequired, // function to insert a value into an array field
	    move: func.isRequired, // function to move a value within an array field
	    pop: func.isRequired, // function to pop a value off of an array field
	    push: func.isRequired, // function to push a value onto an array field
	    remove: func.isRequired, // function to remove a value from an array field
	    removeAll: func.isRequired, // function to remove all the values from an array field
	    shift: func.isRequired, // function to shift a value out of an array field
	    splice: func.isRequired, // function to splice a value into an array field
	    swap: func.isRequired, // function to swap values in an array field
	    unshift: func.isRequired // function to unshift a value into an array field
	  }),
	  asyncValidate: func.isRequired, // function to trigger async validation
	  autofill: func.isRequired, // action to set a value of a field and mark it as autofilled
	  blur: func.isRequired, // action to mark a field as blurred
	  change: func.isRequired, // action to change the value of a field
	  clearAsyncError: func.isRequired, // action to clear the async error of a field
	  destroy: func.isRequired, // action to destroy the form's data in Redux
	  dispatch: func.isRequired, // the Redux dispatch action
	  handleSubmit: func.isRequired, // function to submit the form
	  initialize: func.isRequired, // action to initialize form data
	  reset: func.isRequired, // action to reset the form data to previously initialized values
	  touch: func.isRequired, // action to mark fields as touched
	  submit: func.isRequired, // action to trigger a submission of the specified form
	  untouch: func.isRequired, // action to mark fields as untouched
	
	  // triggerSubmit
	  triggerSubmit: bool, // if true, submits the form on componentWillReceiveProps
	  clearSubmit: func.isRequired // called before a triggered submit, by default clears triggerSubmit
	};
	
	var fieldInputPropTypes = exports.fieldInputPropTypes = {
	  checked: bool,
	  name: string.isRequired,
	  onBlur: func.isRequired,
	  onChange: func.isRequired,
	  onDragStart: func.isRequired,
	  onDrop: func.isRequired,
	  onFocus: func.isRequired,
	  value: any
	};
	
	var fieldMetaPropTypes = exports.fieldMetaPropTypes = {
	  active: bool.isRequired,
	  asyncValidating: bool.isRequired,
	  autofilled: bool.isRequired,
	  dirty: bool.isRequired,
	  dispatch: func.isRequired,
	  error: string,
	  form: string.isRequired,
	  invalid: bool.isRequired,
	  pristine: bool.isRequired,
	  submitting: bool.isRequired,
	  submitFailed: bool.isRequired,
	  touched: bool.isRequired,
	  valid: bool.isRequired,
	  visited: bool.isRequired,
	  warning: string
	};
	
	var fieldArrayMetaPropTypes = exports.fieldArrayMetaPropTypes = {
	  dirty: bool.isRequired,
	  error: string,
	  form: string.isRequired,
	  invalid: bool.isRequired,
	  pristine: bool.isRequired,
	  submitFailed: bool,
	  submitting: bool,
	  valid: bool.isRequired,
	  warning: string
	};
	
	var fieldArrayFieldsPropTypes = exports.fieldArrayFieldsPropTypes = {
	  name: string.isRequired,
	  forEach: func.isRequired,
	  get: func.isRequired,
	  getAll: func.isRequired,
	  insert: func.isRequired,
	  length: number.isRequired,
	  map: func.isRequired,
	  move: func.isRequired,
	  pop: func.isRequired,
	  push: func.isRequired,
	  reduce: func.isRequired,
	  remove: func.isRequired,
	  removeAll: func.isRequired,
	  shift: func.isRequired,
	  swap: func.isRequired,
	  unshift: func.isRequired
	};
	
	var fieldPropTypes = exports.fieldPropTypes = {
	  input: shape(fieldInputPropTypes).isRequired,
	  meta: shape(fieldMetaPropTypes).isRequired
	};
	
	var fieldArrayPropTypes = exports.fieldArrayPropTypes = {
	  fields: shape(fieldArrayFieldsPropTypes).isRequired,
	  meta: shape(fieldArrayMetaPropTypes).isRequired
	};
	
	exports.default = formPropTypes;

/***/ },
/* 1314 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.asyncErrors');
	    };
	  };
	};
	
	exports.default = createGetFormAsyncErrors;

/***/ },
/* 1315 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormError = function createGetFormError(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.error');
	    };
	  };
	};
	
	exports.default = createGetFormError;

/***/ },
/* 1316 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.initial');
	    };
	  };
	};
	
	exports.default = createGetFormInitialValues;

/***/ },
/* 1317 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormMeta = function createGetFormMeta(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.fields');
	    };
	  };
	};
	
	exports.default = createGetFormMeta;

/***/ },
/* 1318 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function createGetFormNames(_ref) {
	  var getIn = _ref.getIn,
	      keys = _ref.keys;
	
	  return function (getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return keys(nonNullGetFormState(state));
	    };
	  };
	}
	
	exports.default = createGetFormNames;

/***/ },
/* 1319 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.submitErrors');
	    };
	  };
	};
	
	exports.default = createGetFormSubmitErrors;

/***/ },
/* 1320 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormSyncErrors = function createGetFormSyncErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.syncErrors');
	    };
	  };
	};
	
	exports.default = createGetFormSyncErrors;

/***/ },
/* 1321 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormSyncWarnings = function createGetFormSyncWarnings(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.syncWarnings');
	    };
	  };
	};
	
	exports.default = createGetFormSyncWarnings;

/***/ },
/* 1322 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormValues = function createGetFormValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.values');
	    };
	  };
	};
	
	exports.default = createGetFormValues;

/***/ },
/* 1323 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return !!getIn(nonNullGetFormState(state), form + '.submitFailed');
	    };
	  };
	};
	
	exports.default = createHasSubmitFailed;

/***/ },
/* 1324 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createHasSubmitSucceeded = function createHasSubmitSucceeded(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return !!getIn(nonNullGetFormState(state), form + '.submitSucceeded');
	    };
	  };
	};
	
	exports.default = createHasSubmitSucceeded;

/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPristine = __webpack_require__(484);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsDirty = function createIsDirty(structure) {
	  return function (form, getFormState) {
	    var isPristine = (0, _isPristine2.default)(structure)(form, getFormState);
	    return function (state) {
	      return !isPristine(state);
	    };
	  };
	};
	exports.default = createIsDirty;

/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isValid = __webpack_require__(303);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsInvalid = function createIsInvalid(structure) {
	  return function (form, getFormState) {
	    var isValid = (0, _isValid2.default)(structure)(form, getFormState);
	    return function (state) {
	      return !isValid(state);
	    };
	  };
	};
	exports.default = createIsInvalid;

/***/ },
/* 1327 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createIsSubmitting = function createIsSubmitting(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return !!getIn(nonNullGetFormState(state), form + '.submitting');
	    };
	  };
	};
	
	exports.default = createIsSubmitting;

/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqualWith2 = __webpack_require__(275);
	
	var _isEqualWith3 = _interopRequireDefault(_isEqualWith2);
	
	var _immutable = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customizer = function customizer(obj, other) {
	  if (obj === other) return true;
	  if (!obj && !other) {
	    var objIsEmpty = obj === null || obj === undefined || obj === '';
	    var otherIsEmpty = other === null || other === undefined || other === '';
	    return objIsEmpty === otherIsEmpty;
	  }
	
	  if (_immutable.Iterable.isIterable(obj) && _immutable.Iterable.isIterable(other)) {
	    return obj.count() === other.count() && obj.every(function (value, key) {
	      return other.has(key) && (0, _isEqualWith3.default)(value, other.get(key), customizer);
	    });
	  }
	
	  return void 0;
	};
	
	
	var deepEqual = function deepEqual(a, b) {
	  return (0, _isEqualWith3.default)(a, b, customizer);
	};
	
	exports.default = deepEqual;

/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(9);
	
	var _keys = __webpack_require__(486);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var empty = (0, _immutable.List)();
	
	var keys = function keys(value) {
	  if (_immutable.List.isList(value)) {
	    return value.map(function (i) {
	      return i.name;
	    });
	  }
	
	  if (_immutable.Iterable.isIterable(value)) {
	    return value.keySeq();
	  }
	
	  return value ? (0, _immutable.List)((0, _keys2.default)(value)) : empty;
	};
	
	exports.default = keys;

/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(131);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	exports.default = setIn;
	
	var _immutable = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrayPattern = /\[(\d+)\]/;
	
	
	var undefinedArrayMerge = function undefinedArrayMerge(previous, next) {
	  return next !== undefined ? next : previous;
	};
	
	var mergeLists = function mergeLists(original, value) {
	  return original && _immutable.List.isList(original) ? original.mergeDeepWith(undefinedArrayMerge, value) : value;
	};
	
	/*
	 * ImmutableJS' setIn function doesn't support array (List) creation
	 * so we must pre-insert all arrays in the path ahead of time.
	 * 
	 * Additionally we must also pre-set a dummy Map at the location
	 * of an array index if there's parts that come afterwards because 
	 * the setIn function uses `{}` to mark an unset value instead of 
	 * undefined (which is the case for list / arrays).
	 */
	function setIn(state, field, value) {
	  var path = (0, _toPath3.default)(field);
	  if (!field || typeof field !== 'string' || !arrayPattern.test(field)) {
	    return state.setIn(path, value);
	  }
	
	  return state.withMutations(function (mutable) {
	    var _loop = function _loop(pathIndex) {
	      var nextPart = path[pathIndex + 1];
	      if (isNaN(nextPart)) {
	        return 'continue';
	      }
	
	      mutable = mutable.updateIn(path.slice(0, pathIndex + 1), function (value) {
	        return mergeLists(value, new _immutable.List().set(parseInt(nextPart, 10), new _immutable.Map()));
	      });
	    };
	
	    for (var pathIndex = 0; pathIndex < path.length - 1; ++pathIndex) {
	      var _ret = _loop(pathIndex);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return mutable.setIn(path, value);
	  });
	}

/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(9);
	
	exports.default = function (list, index, removeNum, value) {
	  list = _immutable.List.isList(list) ? list : (0, _immutable.List)();
	
	  if (index < list.count()) {
	    if (value === undefined && !removeNum) {
	      // inserting undefined
	      // first insert true and then re-set it to undefined
	      return list.splice(index, 0, true) // placeholder
	      .set(index, undefined);
	    }
	    if (value != null) {
	      return list.splice(index, removeNum, value); // removing and adding
	    } else {
	      return list.splice(index, removeNum); // removing
	    }
	  }
	  if (removeNum) {
	    // trying to remove non-existant item: return original array
	    return list;
	  }
	  // trying to add outside of range: just set value
	  return list.set(index, value);
	};

/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqualWith2 = __webpack_require__(275);
	
	var _isEqualWith3 = _interopRequireDefault(_isEqualWith2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customizer = function customizer(obj, other) {
	  if (obj === other) return true;
	
	  if (!obj && !other) {
	    var objIsEmpty = obj === null || obj === undefined || obj === '';
	    var otherIsEmpty = other === null || other === undefined || other === '';
	    return objIsEmpty === otherIsEmpty;
	  }
	
	  if (obj && other && obj._error !== other._error) return false;
	  if (obj && other && obj._warning !== other._warning) return false;
	  if (_react2.default.isValidElement(obj) || _react2.default.isValidElement(other)) return false;
	};
	
	
	var deepEqual = function deepEqual(a, b) {
	  return (0, _isEqualWith3.default)(a, b, customizer);
	};
	
	exports.default = deepEqual;

/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(131);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function deleteInWithPath(state, first) {
	  if (state === undefined || state === null || first === undefined || first === null) {
	    return state;
	  }
	
	  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    rest[_key - 2] = arguments[_key];
	  }
	
	  if (rest.length) {
	    if (Array.isArray(state)) {
	      if (isNaN(first)) {
	        throw new Error('Must access array elements with a number, not "' + String(first) + '".');
	      }
	      var firstIndex = Number(first);
	      if (firstIndex < state.length) {
	        var result = deleteInWithPath.apply(undefined, [state && state[firstIndex]].concat(_toConsumableArray(rest)));
	        if (result !== state[firstIndex]) {
	          var copy = [].concat(_toConsumableArray(state));
	          copy[firstIndex] = result;
	          return copy;
	        }
	      }
	      return state;
	    }
	    if (first in state) {
	      var _result = deleteInWithPath.apply(undefined, [state && state[first]].concat(_toConsumableArray(rest)));
	      return state[first] === _result ? state : _extends({}, state, _defineProperty({}, first, _result));
	    }
	    return state;
	  }
	  if (Array.isArray(state)) {
	    if (isNaN(first)) {
	      throw new Error('Cannot delete non-numerical index from an array. Given: "' + String(first));
	    }
	    var _firstIndex = Number(first);
	    if (_firstIndex < state.length) {
	      var _copy = [].concat(_toConsumableArray(state));
	      _copy.splice(_firstIndex, 1);
	      return _copy;
	    }
	    return state;
	  }
	  if (first in state) {
	    var _copy2 = _extends({}, state);
	    delete _copy2[first];
	    return _copy2;
	  }
	  return state;
	}
	
	var deleteIn = function deleteIn(state, field) {
	  return deleteInWithPath.apply(undefined, [state].concat(_toConsumableArray((0, _toPath3.default)(field))));
	};
	
	exports.default = deleteIn;

/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(131);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
	  if (pathIndex >= path.length) {
	    return value;
	  }
	
	  var first = path[pathIndex];
	  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
	  var next = setInWithPath(firstState, value, path, pathIndex + 1);
	
	  if (!state) {
	    if (isNaN(first)) {
	      return _defineProperty({}, first, next);
	    }
	    var initialized = [];
	    initialized[parseInt(first, 10)] = next;
	    return initialized;
	  }
	
	  if (Array.isArray(state)) {
	    var copy = [].concat(state);
	    copy[parseInt(first, 10)] = next;
	    return copy;
	  }
	
	  return _extends({}, state, _defineProperty({}, first, next));
	};
	
	var setIn = function setIn(state, field, value) {
	  return setInWithPath(state, value, (0, _toPath3.default)(field), 0);
	};
	
	exports.default = setIn;

/***/ },
/* 1335 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var splice = function splice(array, index, removeNum, value) {
	  array = array || [];
	
	  if (index < array.length) {
	    if (value === undefined && !removeNum) {
	      // inserting undefined
	      var _copy2 = [].concat(_toConsumableArray(array));
	      _copy2.splice(index, 0, true); // temporary placeholder
	      _copy2[index] = undefined; // set to undefined
	      return _copy2;
	    }
	    if (value != null) {
	      var _copy3 = [].concat(_toConsumableArray(array));
	      _copy3.splice(index, removeNum, value); // removing and adding
	      return _copy3;
	    }
	    var _copy = [].concat(_toConsumableArray(array));
	    _copy.splice(index, removeNum); // removing
	    return _copy;
	  }
	  if (removeNum) {
	    // trying to remove non-existant item: return original array
	    return array;
	  }
	  // trying to add outside of range: just set value
	  var copy = [].concat(_toConsumableArray(array));
	  copy[index] = value;
	  return copy;
	};
	
	exports.default = splice;

/***/ },
/* 1336 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var dataKey = exports.dataKey = 'text';

/***/ },
/* 1337 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var getDisplayName = function getDisplayName(Comp) {
	  return Comp.displayName || Comp.name || 'Component';
	};
	exports.default = getDisplayName;

/***/ },
/* 1338 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ },
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" id=\"Layer_1\" x=\"0\" y=\"0\" viewBox=\"0 0 100 100\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\"><path fill=\"#333333\" d=\"M36.22 49.97c2.56-1.95 5.37-3.38 8.49-4.18 2.16-0.56 4.37-0.77 6.59-0.64 3.98 0.23 7.63 1.5 10.97 3.66 3.2 2.07 5.82 4.74 7.97 7.87 1.4 2.04 2.55 4.19 3.47 6.44 2.27 0.03 4.54 0.43 7.04 0.68 0-12.66 0-25.55 0-38.44 0-5.69 0.98-6.85 6.56-7.78 0.13-0.02 0.24-0.17 0.52-0.38 0-0.54 0-1.2 0-1.86 0.04-6.11-1.44-7.57-7.64-7.57C59.77 7.77 39.34 7.77 18.91 7.77c-5.6 0-8.36 3.53-6.96 8.97 0.11 0.41 0.74 0.9 1.19 0.98 4.88 0.82 5.98 2.08 5.98 7.08 0.01 12.3 0.01 24.6 0.01 36.91 0 0.76 0 1.52 0 2.02 2.35-0.23 4.33-0.6 6.3-0.6 0.34 0 0.67 0 1.01 0 0.74-1.8 1.63-3.55 2.69-5.24C31.02 54.83 33.36 52.16 36.22 49.97zM46.71 15.26c0.78-0.19 1.57-0.32 2.37-0.35 0.06 0 0.13-0.03 0.19-0.05 0.53 0 1.07 0 1.6 0 0.07 0.02 0.14 0.04 0.22 0.05 1.88 0.11 3.67 0.57 5.34 1.42 4.21 2.13 6.89 5.51 7.84 10.13 1.62 7.92-3.45 15.24-10.84 16.97-7.55 1.77-15.11-2.63-17.24-10.09C33.84 25.22 38.82 17.14 46.71 15.26z\"></path><path fill=\"#333333\" d=\"M75.56 68.06c-0.06 0-0.13 0-0.19 0 0.49 1.89 0.83 3.8 1.04 5.74 0.16 1.46 0.23 2.92 0.22 4.39 0 0.31-0.1 0.58-0.28 0.82-0.23 0.3-0.52 0.52-0.84 0.72-0.68 0.43-1.42 0.73-2.17 1-1.61 0.56-3.27 0.95-4.94 1.24-1.49 0.26-2.98 0.49-4.49 0.67-1.5 0.18-3.01 0.31-4.52 0.43-3.1 0.25-6.22 0.32-10.1 0.36-1.58-0.05-3.93-0.11-6.28-0.22-1.53-0.07-3.06-0.19-4.58-0.34-2.71-0.25-5.41-0.61-8.07-1.19-1.4-0.3-2.8-0.65-4.13-1.19-0.53-0.22-1.06-0.48-1.56-0.77-0.3-0.17-0.56-0.42-0.81-0.67-0.28-0.29-0.4-0.66-0.38-1.07 0.06-1.56 0.13-3.12 0.32-4.67 0.22-1.79 0.56-3.54 1-5.26-0.24 0-0.48 0-0.72 0-3.26-0.01-5.42 1.51-6.54 4.45-1.8 4.71-1.86 9.49-0.05 14.21 1.23 3.22 3.27 4.52 6.69 4.53 8.51 0.01 17.01 0 25.52 0 0 0 0 0 0-0.01 8.58 0 17.16-0.06 25.74 0.03 3.38 0.04 5.56-1.56 6.8-4.47 2.01-4.76 1.97-9.6-0.04-14.36C80.97 69.55 78.8 68.05 75.56 68.06z\"></path><path fill=\"#333333\" d=\"M10.58 22.63c-2.31-0.04-4.62-0.05-6.93 0.01-2.52 0.07-3.6 1.39-3.32 3.92 1.71 15.77 3.41 31.53 5.13 47.29 0.4 3.65 1.66 4.74 5.73 4.78-0.06-4.36 0.54-8.44 2.9-12.08 0.18-0.28 0.18-0.72 0.18-1.08 0.01-13.11 0.03-26.22-0.02-39.33C14.23 23.69 13.06 22.67 10.58 22.63z\"></path><path fill=\"#333333\" d=\"M96.25 22.64c-2.08-0.06-4.17-0.03-6.26-0.01-3.33 0.03-4.25 0.93-4.25 4.25-0.01 12.75-0.01 25.49 0.02 38.24 0 0.79 0.06 1.7 0.44 2.34 2.03 3.4 2.46 7.11 2.42 11.1 3.39 0.2 5.52-1.04 5.76-3.36 1.73-16.3 3.45-32.59 5.14-48.89C99.79 23.85 98.75 22.71 96.25 22.64z\"></path><path fill=\"#333333\" d=\"M50.47 19.49c0.05 0.01 0.1 0.03 0.15 0.03 1.29 0.07 2.51 0.39 3.66 0.97 2.89 1.46 4.72 3.78 5.38 6.95 1.11 5.43-2.37 10.46-7.44 11.64-5.18 1.22-10.36-1.8-11.83-6.92-1.59-5.57 1.82-11.11 7.23-12.4 0.53-0.13 1.07-0.22 1.62-0.24 0.04 0 0.09-0.02 0.13-0.03C49.74 19.49 50.11 19.49 50.47 19.49z\"></path><path fill=\"#333333\" d=\"M49.39 79.66c-1.26-0.04-3.13-0.09-5-0.17-1.22-0.06-2.44-0.15-3.65-0.27-2.16-0.2-4.31-0.49-6.43-0.94-1.12-0.24-2.23-0.52-3.29-0.95-0.43-0.17-0.84-0.38-1.24-0.61-0.24-0.14-0.45-0.34-0.64-0.53-0.22-0.23-0.32-0.53-0.3-0.85 0.05-1.24 0.1-2.49 0.25-3.72 0.54-4.4 1.89-8.53 4.24-12.3 1.52-2.43 3.38-4.55 5.66-6.29 2.04-1.55 4.28-2.69 6.76-3.33 1.72-0.44 3.48-0.61 5.25-0.51 3.17 0.19 6.08 1.2 8.74 2.91 2.55 1.65 4.64 3.78 6.35 6.27 1.91 2.77 3.23 5.81 4.08 9.06 0.39 1.51 0.67 3.03 0.83 4.58 0.13 1.16 0.18 2.33 0.18 3.5 0 0.25-0.08 0.46-0.23 0.65-0.18 0.24-0.42 0.42-0.67 0.58-0.54 0.34-1.13 0.58-1.73 0.8-1.28 0.45-2.6 0.76-3.94 0.99-1.19 0.2-2.38 0.39-3.57 0.54-1.2 0.15-2.4 0.24-3.6 0.34C54.96 79.57 52.48 79.63 49.39 79.66z\"></path><g display=\"none\"><g display=\"inline\"><path fill=\"#333333\" d=\"M32.64 49.47c2.48-1.95 5.22-3.37 8.25-4.17 2.1-0.56 4.24-0.77 6.41-0.64 2.67 0.16 5.18 0.82 7.54 1.92-0.27-0.53-0.5-1.09-0.67-1.68-0.42-1.48-0.45-2.96-0.16-4.35-1.39 0.95-2.96 1.66-4.67 2.05-7.31 1.72-14.64-2.55-16.71-9.77-2.25-7.86 2.57-15.69 10.21-17.52 0.75-0.18 1.52-0.31 2.29-0.34 0.06 0 0.12-0.03 0.18-0.04 0.52 0 1.03 0 1.55 0 0.07 0.02 0.14 0.04 0.21 0.04 1.82 0.1 3.55 0.56 5.17 1.38 4.08 2.07 6.67 5.33 7.59 9.81 0.58 2.82 0.28 5.56-0.69 7.98 0.51-0.23 1.05-0.42 1.61-0.56 0.49-0.12 0.98-0.2 1.48-0.22 0.04 0 0.08-0.02 0.12-0.03 0.33 0 0.67 0 1 0 0.05 0.01 0.09 0.03 0.14 0.03 1.18 0.07 2.29 0.36 3.34 0.89 2.63 1.34 4.31 3.45 4.9 6.34 1.01 4.96-2.16 9.54-6.78 10.62-1.09 0.26-2.19 0.3-3.24 0.16 0.38 0.37 0.75 0.76 1.12 1.15 0.27 0 0.53 0 0.8 0.02 2.5 0.15 4.79 0.97 6.89 2.36 2.01 1.34 3.65 3.06 5 5.08 0.65 0.96 1.2 1.97 1.68 3.01 1.2 0.14 2.44 0.31 3.73 0.44 0-12.66 0-25.55 0-38.44 0-5.69 0.98-6.85 6.56-7.78 0.13-0.02 0.24-0.17 0.52-0.38 0-0.54 0-1.2 0-1.86 0.04-6.11-1.44-7.57-7.64-7.57C59.94 7.39 39.52 7.38 19.09 7.38c-5.6 0-8.36 3.53-6.96 8.97 0.11 0.41 0.74 0.9 1.19 0.98 4.88 0.82 5.98 2.08 5.98 7.08 0.01 12.3 0.01 24.6 0.01 36.91 0 0.76 0 1.52 0 2.02 1.33-0.13 2.54-0.3 3.69-0.43 0.75-1.91 1.66-3.76 2.74-5.54C27.59 54.32 29.85 51.66 32.64 49.47z\"></path><path fill=\"#333333\" d=\"M78.95 68.3c0.19 0.9 0.35 1.8 0.44 2.71 0.1 0.94 0.14 1.89 0.14 2.83 0 0.2-0.06 0.37-0.18 0.53-0.14 0.19-0.33 0.34-0.53 0.47-0.43 0.28-0.89 0.47-1.36 0.64-1.01 0.36-2.05 0.62-3.1 0.8-0.82 0.15-1.65 0.28-2.48 0.39 0.01 0.33 0.02 0.65 0.02 0.98 0 0.31-0.1 0.57-0.28 0.82-0.22 0.3-0.51 0.52-0.82 0.72-0.66 0.43-1.38 0.73-2.11 1-1.56 0.56-3.17 0.95-4.8 1.24-1.45 0.26-2.9 0.49-4.36 0.67-1.46 0.18-2.92 0.31-4.39 0.43-3.02 0.25-6.04 0.32-9.81 0.36-1.54-0.05-3.82-0.11-6.1-0.22-1.49-0.07-2.97-0.19-4.45-0.34-2.63-0.25-5.25-0.61-7.84-1.18-1.36-0.3-2.72-0.65-4.01-1.19-0.52-0.22-1.03-0.48-1.51-0.77-0.29-0.17-0.55-0.42-0.78-0.67-0.27-0.29-0.38-0.66-0.37-1.07 0.06-1.56 0.12-3.12 0.31-4.66 0.19-1.56 0.46-3.09 0.81-4.6-1.69 0.66-2.91 1.98-3.66 3.94-1.8 4.71-1.86 9.49-0.05 14.21 1.23 3.22 3.27 4.52 6.69 4.53 8.51 0.01 17.01 0 25.52 0 0 0 0 0 0-0.01 8.58 0 17.16-0.06 25.74 0.03 3.38 0.04 5.56-1.56 6.8-4.47 2.01-4.76 1.97-9.6-0.04-14.36C81.6 70.26 80.47 69 78.95 68.3z\"></path><path fill=\"#333333\" d=\"M10.75 22.24c-2.31-0.04-4.62-0.05-6.93 0.01-2.52 0.07-3.6 1.39-3.32 3.92 1.71 15.77 3.41 31.53 5.13 47.29 0.4 3.65 1.66 4.74 5.73 4.78-0.06-4.36 0.54-8.44 2.9-12.08 0.18-0.28 0.18-0.72 0.18-1.08 0.01-13.11 0.03-26.22-0.02-39.33C14.4 23.31 13.24 22.29 10.75 22.24z\"></path><path fill=\"#333333\" d=\"M96.43 22.25c-2.08-0.06-4.17-0.03-6.26-0.01-3.33 0.03-4.25 0.93-4.25 4.25-0.01 12.75-0.01 25.49 0.02 38.24 0 0.79 0.06 1.7 0.44 2.34 2.03 3.4 2.46 7.11 2.42 11.1 3.39 0.2 5.52-1.04 5.76-3.36 1.73-16.3 3.45-32.59 5.14-48.89C99.96 23.47 98.93 22.33 96.43 22.25z\"></path></g><g display=\"inline\"><path fill=\"#333333\" d=\"M48.26 38.64c5.07-1.19 8.55-6.21 7.44-11.64-0.65-3.17-2.49-5.48-5.37-6.95-1.15-0.58-2.37-0.9-3.66-0.97-0.05 0-0.1-0.02-0.15-0.03-0.37 0-0.73 0-1.1 0-0.04 0.01-0.09 0.03-0.13 0.03-0.55 0.02-1.09 0.11-1.62 0.24-5.41 1.3-8.82 6.84-7.23 12.4C37.89 36.84 43.08 39.86 48.26 38.64z\"></path><path fill=\"#333333\" d=\"M64.11 48.09c2.95-0.69 4.97-3.61 4.33-6.77-0.38-1.84-1.45-3.19-3.12-4.04-0.67-0.34-1.38-0.52-2.13-0.57-0.03 0-0.06-0.01-0.09-0.02-0.21 0-0.42 0-0.64 0-0.02 0.01-0.05 0.02-0.07 0.02-0.32 0.01-0.63 0.07-0.94 0.14-3.15 0.75-5.13 3.98-4.2 7.21C58.08 47.04 61.1 48.8 64.11 48.09z\"></path><path fill=\"#333333\" d=\"M75.08 69.63c-0.1-0.93-0.26-1.85-0.5-2.75-0.51-1.95-1.3-3.77-2.45-5.44-1.03-1.5-2.28-2.78-3.81-3.77-1.6-1.03-3.34-1.64-5.25-1.75-0.87-0.05-1.72 0.01-2.57 0.18-1.43-1.73-3.08-3.23-4.99-4.47-2.66-1.72-5.57-2.73-8.74-2.91-1.77-0.1-3.53 0.07-5.25 0.51-2.49 0.64-4.73 1.78-6.76 3.33-2.28 1.74-4.14 3.87-5.66 6.3-2.36 3.77-3.7 7.9-4.24 12.3-0.15 1.24-0.2 2.48-0.25 3.72-0.01 0.33 0.08 0.62 0.3 0.85 0.19 0.2 0.41 0.4 0.64 0.54 0.4 0.23 0.81 0.44 1.24 0.61 1.06 0.44 2.17 0.71 3.29 0.95 2.12 0.46 4.27 0.74 6.43 0.95 1.22 0.11 2.43 0.21 3.65 0.27 1.87 0.09 3.74 0.13 5 0.17 3.09-0.03 5.57-0.09 8.05-0.29 1.2-0.1 2.4-0.19 3.6-0.34 1.2-0.15 2.39-0.33 3.57-0.54 1.34-0.23 2.66-0.54 3.94-0.99 0.6-0.21 1.19-0.45 1.73-0.79 0.25-0.16 0.48-0.34 0.67-0.58 0.15-0.19 0.23-0.4 0.23-0.65 0-0.32-0.01-0.65-0.02-0.97 0.01 0 0.01 0 0.01 0 0.72-0.06 1.44-0.12 2.16-0.2 0.72-0.09 1.43-0.2 2.15-0.32 0.8-0.14 1.6-0.32 2.37-0.59 0.36-0.13 0.72-0.27 1.04-0.48 0.15-0.1 0.29-0.2 0.4-0.35 0.09-0.11 0.14-0.24 0.14-0.39C75.19 71.03 75.16 70.33 75.08 69.63z\"></path></g></g></svg>"

/***/ },
/* 1344 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" id=\"Layer_1\" x=\"0\" y=\"0\" viewBox=\"0 0 100 100\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\"><path fill=\"#333333\" d=\"M80.55 63.75c-2.57-0.25-4.91-0.67-7.24-0.68 -16.03-0.06-32.06-0.05-48.09-0.01 -1.98 0.01-3.95 0.37-6.3 0.6 0-0.5 0-1.26 0-2.02 0-12.3 0-24.6-0.01-36.9 0-4.99-1.1-6.25-5.98-7.08 -0.45-0.08-1.08-0.56-1.19-0.98 -1.4-5.45 1.36-8.97 6.96-8.97C39.13 7.71 59.56 7.71 79.99 7.71c6.21 0 7.68 1.46 7.64 7.57 0 0.66 0 1.33 0 1.87 -0.28 0.22-0.39 0.36-0.52 0.38 -5.58 0.93-6.56 2.09-6.56 7.78C80.56 38.2 80.55 51.09 80.55 63.75z\"></path><path fill=\"#333333\" d=\"M49.48 91.18c-8.51 0-17.01 0-25.52 0 -3.42 0-5.46-1.31-6.69-4.53 -1.81-4.72-1.75-9.5 0.05-14.21 1.13-2.94 3.28-4.45 6.54-4.44 17.16 0.03 34.32 0.03 51.49 0 3.24-0.01 5.41 1.49 6.62 4.38 2.01 4.76 2.05 9.61 0.04 14.36 -1.23 2.91-3.41 4.51-6.79 4.47 -8.58-0.1-17.16-0.03-25.74-0.03C49.48 91.18 49.48 91.18 49.48 91.18z\"></path><path fill=\"#333333\" d=\"M10.98 78.57c-4.07-0.04-5.33-1.12-5.73-4.78C3.53 58.03 1.83 42.27 0.12 26.5c-0.27-2.53 0.8-3.85 3.32-3.92 2.31-0.07 4.62-0.05 6.93-0.01 2.49 0.04 3.65 1.06 3.66 3.51 0.05 13.11 0.03 26.22 0.02 39.34 0 0.36 0.01 0.8-0.18 1.08C11.52 70.13 10.92 74.21 10.98 78.57z\"></path><path fill=\"#333333\" d=\"M88.42 78.5c0.04-3.98-0.4-7.7-2.42-11.1 -0.38-0.64-0.44-1.56-0.44-2.34 -0.03-12.75-0.02-25.49-0.02-38.24 0-3.32 0.91-4.22 4.25-4.25 2.09-0.02 4.18-0.05 6.26 0.01 2.5 0.08 3.53 1.21 3.28 3.67 -1.69 16.3-3.41 32.6-5.14 48.89C93.94 77.46 91.81 78.7 88.42 78.5z\"></path></svg>"

/***/ },
/* 1345 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" id=\"Layer_1\" x=\"0\" y=\"0\" viewBox=\"0 0 100 100\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\"><path fill=\"#333333\" stroke=\"#11AAF6\" stroke-width=\"3\" stroke-miterlimit=\"10\" d=\"M80.55 63.75c-2.57-0.25-4.91-0.67-7.24-0.68 -16.03-0.06-32.06-0.05-48.09-0.01 -1.98 0.01-3.95 0.37-6.3 0.6 0-0.5 0-1.26 0-2.02 0-12.3 0-24.6-0.01-36.9 0-4.99-1.1-6.25-5.98-7.08 -0.45-0.08-1.08-0.56-1.19-0.98 -1.4-5.45 1.36-8.97 6.96-8.97 20.43 0 40.86 0 61.29 0 6.21 0 7.68 1.46 7.64 7.57 0 0.66 0 1.33 0 1.87 -0.28 0.22-0.39 0.36-0.52 0.38 -5.58 0.93-6.56 2.09-6.56 7.78C80.56 38.2 80.55 51.09 80.55 63.75z\"></path><path fill=\"#333333\" stroke=\"#11AAF6\" stroke-width=\"3\" stroke-miterlimit=\"10\" d=\"M49.48 91.18c-8.51 0-17.01 0-25.52 0 -3.42 0-5.46-1.31-6.69-4.53 -1.81-4.72-1.75-9.5 0.05-14.21 1.13-2.94 3.28-4.45 6.54-4.44 17.16 0.03 34.32 0.03 51.49 0 3.24-0.01 5.41 1.49 6.62 4.38 2.01 4.76 2.05 9.61 0.04 14.36 -1.23 2.91-3.41 4.51-6.79 4.47 -8.58-0.1-17.16-0.03-25.74-0.03C49.48 91.18 49.48 91.18 49.48 91.18z\"></path><path fill=\"#333333\" stroke=\"#11AAF6\" stroke-width=\"3\" stroke-miterlimit=\"10\" d=\"M10.98 78.57c-4.07-0.04-5.33-1.12-5.73-4.78C3.53 58.03 1.83 42.27 0.12 26.5c-0.27-2.53 0.8-3.85 3.32-3.92 2.31-0.07 4.62-0.05 6.93-0.01 2.49 0.04 3.65 1.06 3.66 3.51 0.05 13.11 0.03 26.22 0.02 39.34 0 0.36 0.01 0.8-0.18 1.08C11.52 70.13 10.92 74.21 10.98 78.57z\"></path><path fill=\"#333333\" stroke=\"#11AAF6\" stroke-width=\"3\" stroke-miterlimit=\"10\" d=\"M88.42 78.5c0.04-3.98-0.4-7.7-2.42-11.1 -0.38-0.64-0.44-1.56-0.44-2.34 -0.03-12.75-0.02-25.49-0.02-38.24 0-3.32 0.91-4.22 4.25-4.25 2.09-0.02 4.18-0.05 6.26 0.01 2.5 0.08 3.53 1.21 3.28 3.67 -1.69 16.3-3.41 32.6-5.14 48.89C93.94 77.46 91.81 78.7 88.42 78.5z\"></path></svg>"

/***/ },
/* 1346 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" id=\"Layer_1\" x=\"0\" y=\"0\" viewBox=\"0 0 100 100\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\"><path fill=\"#333333\" d=\"M32.64 49.47c2.48-1.95 5.22-3.37 8.25-4.17 2.1-0.56 4.24-0.77 6.41-0.64 2.67 0.16 5.18 0.82 7.54 1.92-0.27-0.53-0.5-1.09-0.67-1.68-0.42-1.48-0.45-2.96-0.16-4.35-1.39 0.95-2.96 1.66-4.67 2.05-7.31 1.72-14.64-2.55-16.71-9.77-2.25-7.86 2.57-15.69 10.21-17.52 0.75-0.18 1.52-0.31 2.29-0.34 0.06 0 0.12-0.03 0.18-0.04 0.52 0 1.03 0 1.55 0 0.07 0.02 0.14 0.04 0.21 0.04 1.82 0.1 3.55 0.56 5.17 1.38 4.08 2.07 6.67 5.33 7.59 9.81 0.58 2.82 0.28 5.56-0.69 7.98 0.51-0.23 1.05-0.42 1.61-0.56 0.49-0.12 0.98-0.2 1.48-0.22 0.04 0 0.08-0.02 0.12-0.03 0.33 0 0.67 0 1 0 0.05 0.01 0.09 0.03 0.14 0.03 1.18 0.07 2.29 0.36 3.34 0.89 2.63 1.34 4.31 3.45 4.9 6.34 1.01 4.96-2.16 9.54-6.78 10.62-1.09 0.26-2.19 0.3-3.24 0.16 0.38 0.37 0.75 0.76 1.12 1.15 0.27 0 0.53 0 0.8 0.02 2.5 0.15 4.79 0.97 6.89 2.36 2.01 1.34 3.65 3.06 5 5.08 0.65 0.96 1.2 1.97 1.68 3.01 1.2 0.14 2.44 0.31 3.73 0.44 0-12.66 0-25.55 0-38.44 0-5.69 0.98-6.85 6.56-7.78 0.13-0.02 0.24-0.17 0.52-0.38 0-0.54 0-1.2 0-1.86 0.04-6.11-1.44-7.57-7.64-7.57C59.94 7.39 39.52 7.38 19.09 7.38c-5.6 0-8.36 3.53-6.96 8.97 0.11 0.41 0.74 0.9 1.19 0.98 4.88 0.82 5.98 2.08 5.98 7.08 0.01 12.3 0.01 24.6 0.01 36.91 0 0.76 0 1.52 0 2.02 1.33-0.13 2.54-0.3 3.69-0.43 0.75-1.91 1.66-3.76 2.74-5.54C27.59 54.32 29.85 51.66 32.64 49.47z\"></path><path fill=\"#333333\" d=\"M78.95 68.3c0.19 0.9 0.35 1.8 0.44 2.71 0.1 0.94 0.14 1.89 0.14 2.83 0 0.2-0.06 0.37-0.18 0.53-0.14 0.19-0.33 0.34-0.53 0.47-0.43 0.28-0.89 0.47-1.36 0.64-1.01 0.36-2.05 0.62-3.1 0.8-0.82 0.15-1.65 0.28-2.48 0.39 0.01 0.33 0.02 0.65 0.02 0.98 0 0.31-0.1 0.57-0.28 0.82-0.22 0.3-0.51 0.52-0.82 0.72-0.66 0.43-1.38 0.73-2.11 1-1.56 0.56-3.17 0.95-4.8 1.24-1.45 0.26-2.9 0.49-4.36 0.67-1.46 0.18-2.92 0.31-4.39 0.43-3.02 0.25-6.04 0.32-9.81 0.36-1.54-0.05-3.82-0.11-6.1-0.22-1.49-0.07-2.97-0.19-4.45-0.34-2.63-0.25-5.25-0.61-7.84-1.18-1.36-0.3-2.72-0.65-4.01-1.19-0.52-0.22-1.03-0.48-1.51-0.77-0.29-0.17-0.55-0.42-0.78-0.67-0.27-0.29-0.38-0.66-0.37-1.07 0.06-1.56 0.12-3.12 0.31-4.66 0.19-1.56 0.46-3.09 0.81-4.6-1.69 0.66-2.91 1.98-3.66 3.94-1.8 4.71-1.86 9.49-0.05 14.21 1.23 3.22 3.27 4.52 6.69 4.53 8.51 0.01 17.01 0 25.52 0 0 0 0 0 0-0.01 8.58 0 17.16-0.06 25.74 0.03 3.38 0.04 5.56-1.56 6.8-4.47 2.01-4.76 1.97-9.6-0.04-14.36C81.6 70.26 80.47 69 78.95 68.3z\"></path><path fill=\"#333333\" d=\"M10.75 22.24c-2.31-0.04-4.62-0.05-6.93 0.01-2.52 0.07-3.6 1.39-3.32 3.92 1.71 15.77 3.41 31.53 5.13 47.29 0.4 3.65 1.66 4.74 5.73 4.78-0.06-4.36 0.54-8.44 2.9-12.08 0.18-0.28 0.18-0.72 0.18-1.08 0.01-13.11 0.03-26.22-0.02-39.33C14.4 23.31 13.24 22.29 10.75 22.24z\"></path><path fill=\"#333333\" d=\"M96.43 22.25c-2.08-0.06-4.17-0.03-6.26-0.01-3.33 0.03-4.25 0.93-4.25 4.25-0.01 12.75-0.01 25.49 0.02 38.24 0 0.79 0.06 1.7 0.44 2.34 2.03 3.4 2.46 7.11 2.42 11.1 3.39 0.2 5.52-1.04 5.76-3.36 1.73-16.3 3.45-32.59 5.14-48.89C99.96 23.47 98.93 22.33 96.43 22.25z\"></path><path fill=\"#333333\" d=\"M48.26 38.64c5.07-1.19 8.55-6.21 7.44-11.64-0.65-3.17-2.49-5.48-5.37-6.95-1.15-0.58-2.37-0.9-3.66-0.97-0.05 0-0.1-0.02-0.15-0.03-0.37 0-0.73 0-1.1 0-0.04 0.01-0.09 0.03-0.13 0.03-0.55 0.02-1.09 0.11-1.62 0.24-5.41 1.3-8.82 6.84-7.23 12.4C37.89 36.84 43.08 39.86 48.26 38.64z\"></path><path fill=\"#333333\" d=\"M64.11 48.09c2.95-0.69 4.97-3.61 4.33-6.77-0.38-1.84-1.45-3.19-3.12-4.04-0.67-0.34-1.38-0.52-2.13-0.57-0.03 0-0.06-0.01-0.09-0.02-0.21 0-0.42 0-0.64 0-0.02 0.01-0.05 0.02-0.07 0.02-0.32 0.01-0.63 0.07-0.94 0.14-3.15 0.75-5.13 3.98-4.2 7.21C58.08 47.04 61.1 48.8 64.11 48.09z\"></path><path fill=\"#333333\" d=\"M75.08 69.63c-0.1-0.93-0.26-1.85-0.5-2.75-0.51-1.95-1.3-3.77-2.45-5.44-1.03-1.5-2.28-2.78-3.81-3.77-1.6-1.03-3.34-1.64-5.25-1.75-0.87-0.05-1.72 0.01-2.57 0.18-1.43-1.73-3.08-3.23-4.99-4.47-2.66-1.72-5.57-2.73-8.74-2.91-1.77-0.1-3.53 0.07-5.25 0.51-2.49 0.64-4.73 1.78-6.76 3.33-2.28 1.74-4.14 3.87-5.66 6.3-2.36 3.77-3.7 7.9-4.24 12.3-0.15 1.24-0.2 2.48-0.25 3.72-0.01 0.33 0.08 0.62 0.3 0.85 0.19 0.2 0.41 0.4 0.64 0.54 0.4 0.23 0.81 0.44 1.24 0.61 1.06 0.44 2.17 0.71 3.29 0.95 2.12 0.46 4.27 0.74 6.43 0.95 1.22 0.11 2.43 0.21 3.65 0.27 1.87 0.09 3.74 0.13 5 0.17 3.09-0.03 5.57-0.09 8.05-0.29 1.2-0.1 2.4-0.19 3.6-0.34 1.2-0.15 2.39-0.33 3.57-0.54 1.34-0.23 2.66-0.54 3.94-0.99 0.6-0.21 1.19-0.45 1.73-0.79 0.25-0.16 0.48-0.34 0.67-0.58 0.15-0.19 0.23-0.4 0.23-0.65 0-0.32-0.01-0.65-0.02-0.97 0.01 0 0.01 0 0.01 0 0.72-0.06 1.44-0.12 2.16-0.2 0.72-0.09 1.43-0.2 2.15-0.32 0.8-0.14 1.6-0.32 2.37-0.59 0.36-0.13 0.72-0.27 1.04-0.48 0.15-0.1 0.29-0.2 0.4-0.35 0.09-0.11 0.14-0.24 0.14-0.39C75.19 71.03 75.16 70.33 75.08 69.63z\"></path></svg>"

/***/ },
/* 1347 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><path d=\"M13.34 18.316c4.866.823 5.964 2.078 5.967 7.063.008 12.276.006 24.553.01 36.83v2.017c2.346-.234 4.317-.595 6.288-.6 15.997-.047 31.995-.054 47.993.005 2.33.01 4.66.43 7.23.682 0-12.633.002-25.5 0-38.364-.002-5.675.976-6.838 6.545-7.764.128-.02.234-.167.52-.382 0-.537-.005-1.2 0-1.86.04-6.1-1.434-7.554-7.628-7.554-20.39.002-40.778 0-61.165-.002-5.585 0-8.344 3.52-6.946 8.955.106.41.735.897 1.185.973zm43.663-2.148c.664-.663 1.34-1.33 2.086-1.893 1.513-1.143 3.145-1.23 4.852-.39 1.705.838 2.26.72 3.592-.644.408-.417.81-.843 1.24-1.24.784-.724 1.62-.81 2.447-.113 1.18.995 2.392 1.987 2.984 3.494v.196c-.782.934-1.536 1.893-2.354 2.794-.81.894-1.037 1.676-.452 2.73 1.416 2.555.763 4.53-1.073 6.43-.61.632-1.27 1.213-1.852 1.867-.507.57-1.05.64-1.63.226-.763-.545-1.547-1.086-2.212-1.74-2.588-2.553-5.172-5.112-7.68-7.74-1.858-1.944-1.813-2.11.053-3.975zm-31.535 25.92c.175-.646.337-1.298.528-1.94.57-1.914 1.67-3.49 3.074-4.89 3.933-3.916 7.85-7.85 11.777-11.772 4.77-4.765 11.275-4.828 16.123-.132 1.888 1.83 3.762 3.676 5.57 5.582 4.006 4.22 4.204 10.59.225 14.822-4.29 4.56-8.802 8.912-13.253 13.318-1.564 1.548-3.506 2.42-5.685 2.76-.147.022-.283.123-.424.188H40.87c-1.013-.304-2.048-.55-3.032-.926-1.762-.675-3.117-1.93-4.416-3.258-1.63-1.665-3.287-3.3-4.926-4.956-1.723-1.74-2.502-3.94-3.027-6.26-.002-.845-.002-1.69-.002-2.535z\"></path><path d=\"M36.905 54.066c.94.834 2.114 1.54 3.305 1.93 2.493.81 4.75.11 6.834-1.606-.324-.343-.558-.602-.804-.85-1.4-1.4-2.807-2.793-4.2-4.2-.928-.934-1.008-1.934-.246-2.748.766-.818 1.79-.803 2.744.085.76.708 1.494 1.445 2.216 2.19.94.972 1.858 1.965 2.81 2.974l3.054-3.12c-.244-.257-.458-.494-.682-.72-1.486-1.497-2.993-2.973-4.452-4.496-.76-.792-.747-1.82-.073-2.546.72-.774 1.723-.816 2.604-.042.657.577 1.27 1.208 1.875 1.842 1.088 1.14 2.157 2.302 3.063 3.272l3.212-3.01c-.01-.02-.022-.053-.044-.075l-4.673-4.692c-1.017-1.02-1.173-2.107-.42-2.905.85-.9 1.87-.82 2.962.26 1.36 1.348 2.706 2.71 4.063 4.063.22.22.464.413.706.626 1.815-2.63 1.444-6.438-.83-8.78-1.83-1.885-3.687-3.75-5.56-5.593-3.19-3.138-7.468-3.19-10.677-.05-4.106 4.018-8.182 8.07-12.2 12.175-3.207 3.28-3.098 7.534.155 10.81 1.738 1.75 3.415 3.573 5.257 5.208zM75.636 68.56c-17.127.03-34.255.034-51.382 0-3.255-.006-5.406 1.506-6.528 4.437-1.8 4.698-1.857 9.47-.054 14.182 1.23 3.213 3.263 4.514 6.675 4.516 8.49.005 16.98.002 25.468.002v-.007c8.564 0 17.128-.064 25.69.033 3.38.038 5.553-1.552 6.782-4.458 2.01-4.747 1.963-9.578-.04-14.333-1.214-2.885-3.38-4.378-6.61-4.372zM10.783 23.22c-2.304-.04-4.61-.053-6.914.014-2.52.073-3.592 1.384-3.318 3.912 1.704 15.733 3.406 31.467 5.12 47.2.397 3.642 1.655 4.726 5.72 4.765-.056-4.353.535-8.424 2.89-12.057.182-.28.176-.715.176-1.077.005-13.086.025-26.172-.024-39.257-.01-2.44-1.17-3.457-3.65-3.5zM96.288 23.23c-2.08-.062-4.166-.027-6.248-.01-3.327.025-4.237.93-4.24 4.24-.005 12.722-.008 25.443.018 38.163.002.787.06 1.697.442 2.34 2.025 3.39 2.455 7.1 2.42 11.075 3.385.2 5.505-1.037 5.75-3.35 1.726-16.263 3.438-32.527 5.128-48.794.256-2.454-.775-3.59-3.27-3.664z\"></path></svg>"

/***/ },
/* 1348 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"1018.274 321.333 155.249 175.973\"><defs><path id=\"a\" d=\"M1024.857 327.643h143.7v164.53h-143.7z\"></path></defs><clipPath id=\"b\"><use xlink:href=\"#a\" overflow=\"visible\"></use></clipPath><path d=\"M1164.784 442.667l-17.595-10.137 14.85-8.823c2.386-1.147 3.13-4.344 1.768-6.694-1.38-2.405-4.363-2.91-6.63-1.596l-19.798 11.57-31.472-18.264 31.472-18.068 19.8 11.54c.617.45 1.416.715 2.3.715 1.676 0 3.178-.787 4.328-2.294 1.327-2.388.618-5.545-1.768-6.694l-14.85-8.814 17.594-10.135c2.294-1.323 3.076-4.27 1.768-6.694-1.252-2.333-4.354-3.14-6.72-1.773l-17.68 10.23-.267-17.638c-.038-2.728-2.12-4.923-4.863-4.923-2.734 0-4.88 2.37-4.86 4.922l.173 23.282-31.29 18.07V363.78l19.715-11.202c2.3-1.302 3.305-4.323 1.943-6.692-1.38-2.416-4.217-3.12-6.63-1.772l-15.03 8.464v-20.004c0-2.727-2.208-4.93-4.942-4.93-2.743 0-4.862 2.204-4.862 4.93v20.19l-15.56-8.65c-2.424-1.333-5.187-.578-6.54 1.772-1.38 2.404-.526 5.352 1.85 6.692l20.25 11.376v36.304l-32.01-18.408.185-22.752c.266-2.553-2.034-4.922-4.778-4.922h-.174c-2.56 0-4.834 2.195-4.862 4.922l-.174 17.113-17.24-9.868c-2.4-1.396-5.376-.57-6.628 1.744-1.318 2.442-.636 5.326 1.768 6.713l17.413 10.042-15.205 9.08c-2.383 1.15-3.13 4.344-1.676 6.694.93 1.523 2.294 2.294 4.154 2.294.966 0 1.777-.237 2.56-.715l19.89-11.717 31.917 18.244-31.916 18.427-19.89-11.734c-2.385-1.387-5.47-.736-6.714 1.596-1.316 2.426-.606 5.345 1.676 6.694l15.205 8.988-17.413 10.137c-2.395 1.397-3.178 4.326-1.768 6.71.985 1.653 2.3 2.462 4.154 2.462.44 0 1.325-.256 2.475-.707l17.24-9.88.173 17.117c.028 2.726 2.303 4.828 4.863 4.828h.175c2.744 0 4.797-2.268 4.778-5.013l-.184-22.73 32.007-18.245v36.12l-20.25 11.375c-2.41 1.36-3.257 4.306-1.85 6.692.977 1.68 2.294 2.488 4.155 2.488.884 0 1.695-.155 2.385-.55l15.56-8.795v20.53c0 2.725 2.12 4.855 4.864 4.855 2.735 0 4.944-2.13 4.944-4.856v-20.19l15.028 8.457c.69.394 1.502.55 2.303.55 1.942 0 3.378-.79 4.328-2.49 1.344-2.367.48-5.333-1.943-6.692l-19.716-11.02V417.19l31.29 18.068-.173 23.09c-.018 2.745 2.127 5.013 4.862 5.013 2.744 0 4.825-2.1 4.863-4.827l.266-17.73 17.68 10.32c.682.394 1.595.533 2.57.533 1.85 0 3.213-.77 4.15-2.296 1.45-2.352.527-5.38-1.766-6.693zm0 0\"></path></svg>"

/***/ },
/* 1349 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 202.115 176.265\"><path d=\"M195.552 165.017v.024c0 2.372-1.922 4.294-4.293 4.294H10.874c-2.37 0-4.293-1.922-4.293-4.293v-.023c0-2.37 1.922-4.293 4.293-4.293H191.26c2.37 0 4.292 1.922 4.292 4.293z\"></path><path d=\"M191.26 168.93h-.024c-2.37 0-4.293-1.92-4.293-4.292V29.858c0-2.37 1.922-4.293 4.293-4.293h.024c2.37 0 4.293 1.922 4.293 4.293v134.78c0 2.37-1.923 4.293-4.293 4.293zM10.9 169.334h-.025c-2.37 0-4.293-1.922-4.293-4.293V29.86c0-2.372 1.922-4.294 4.293-4.294h.024c2.37 0 4.292 1.922 4.292 4.293v135.18c0 2.372-1.922 4.294-4.293 4.294z\"></path><path d=\"M195.552 29.86c0 2.37-1.922 4.292-4.293 4.292H10.874c-2.37 0-4.293-1.922-4.293-4.293 0-2.372 1.922-4.294 4.293-4.294H191.26c2.37 0 4.292 1.922 4.292 4.293zM133.613 15.56H68.946c-2.21 0-4-1.792-4-4v-.586c0-2.21 1.79-4 4-4h64.667c2.21 0 4 1.79 4 4v.585c0 2.208-1.79 4-4 4z\"></path><path d=\"M73.532 10.973v19c0 2.21-1.79 4-4 4h-.585c-2.21 0-4-1.79-4-4v-19c0-2.21 1.79-4 4-4h.585c2.21 0 4 1.79 4 4zM137.656 10.973v19c0 2.21-1.79 4-4 4h-.585c-2.208 0-4-1.79-4-4v-19c0-2.21 1.792-4 4-4h.586c2.21 0 4 1.79 4 4zM195.496 165.017v.024c0 2.372-1.922 4.294-4.293 4.294H11.875c-2.37 0-4.293-1.922-4.293-4.293v-.023c0-2.37 1.922-4.293 4.293-4.293h179.33c2.37 0 4.29 1.922 4.29 4.293z\"></path><path d=\"M103.66 62.938c0 8.274 6.706 14.98 14.98 14.98 8.273 0 14.98-6.706 14.98-14.98 0-8.274-6.706-14.98-14.98-14.98-8.274 0-14.98 6.706-14.98 14.98zm1.497 0c0-7.435 6.048-13.483 13.483-13.483 7.434 0 13.483 6.048 13.483 13.483S126.075 76.42 118.64 76.42c-7.435 0-13.483-6.048-13.483-13.482z\" stroke=\"#000\" stroke-width=\"4\" stroke-miterlimit=\"10\"></path><path d=\"M181.13 96.21c-2.224 5.974-22.4 11.657-38.218 12.445-1.784.09-1.633.023-2.358.11-10.174 1.233-24.947 12.44-25.52 12.536-.023.005-.705.268-.702.047-.206-.058-.368-.184-.437-.366l-7.088-18.67c.118-.207.33-.566.64-.996 6.928-9.66 24.75-3.76 42.45-14.167 0 0 17.42-10.24 23.644-10.924.272-.03.703-.077.703-.046.206.058.368.184.437.366 2.17 6.24 4.342 12.478 6.513 18.716.094.432.006.762-.064.95z\" fill=\"none\" stroke=\"#000\" stroke-width=\"4\" stroke-miterlimit=\"10\"></path></svg>"

/***/ },
/* 1350 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"818.103 321.188 177.146 176.265\"><path d=\"M986.932 330.9c-1.555-1.975-3.938-3.13-6.464-3.13h-81.99c-2.176 0-4.262.857-5.798 2.384l-65.593 65.1c-1.54 1.524-2.402 3.594-2.402 5.753v81.375c0 4.495 3.67 8.138 8.2 8.138H964.07c4.53 0 8.2-3.643 8.2-8.138v-80.375l16.15-64.13c.614-2.428.065-5.002-1.488-6.977zM964.07 482.383H832.884v-73.238H964.07v73.238zm0-81.375H832.884l65.593-65.1h81.99l-16.397 65.1z\"></path><path d=\"M931.274 417.283h24.597v8.138h-24.596z\"></path></svg>"

/***/ },
/* 1351 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"1197.468 321.333 136.169 176.265\"><defs><path id=\"a\" d=\"M1204.05 327.656h123.005v162.172H1204.05z\"></path></defs><clipPath id=\"b\"><use xlink:href=\"#a\" overflow=\"visible\"></use></clipPath><path d=\"M1318.852 481.72H1212.25V360.09h65.6l41.002 40.543v81.086zm-90.202-145.956h32.8v16.217h-32.8v-16.216zm82.002 24.326l8.2 8.11-10.603 10.483-8.2-8.11 10.602-10.483zm3.397 24.326l10.602-10.484c3.203-3.168 3.203-8.3 0-11.468l-8.2-8.108c-1.605-1.58-3.7-2.373-5.8-2.373s-4.2.792-5.797 2.376l-10.603 10.48-10.603-10.483c-1.537-1.52-3.623-2.373-5.798-2.373h-8.2v-16.217c0-4.48-3.67-8.11-8.2-8.11h-32.8c-4.53 0-8.2 3.63-8.2 8.11v16.217h-8.2c-4.53 0-8.2 3.63-8.2 8.11V481.72c0 4.48 3.67 8.11 8.2 8.11h106.6c4.53 0 8.2-3.63 8.2-8.11v-81.086c0-2.152-.864-4.214-2.403-5.733l-10.6-10.487z\"></path><path d=\"M1253.25 408.742h24.6v40.543h-24.6v-40.543zm-1.49-8.11l-19.802-26.72c-1.345-1.816-3.9-2.2-5.735-.875-1.826 1.32-2.22 3.86-.88 5.665l19.708 26.593v44.524l-18.673 12.31c-1.88 1.244-2.394 3.758-1.137 5.623.793 1.173 2.09 1.805 3.41 1.805.786 0 1.578-.222 2.275-.68l17.417-11.485h34.42l17.416 11.482c.697.46 1.49.68 2.274.68 1.32 0 2.62-.632 3.41-1.804 1.258-1.864.745-4.378-1.136-5.62l-18.674-12.313V406.88l11.163-11.555c1.57-1.62 1.506-4.184-.13-5.73-1.65-1.55-4.244-1.48-5.796.13l-10.538 10.91h-28.99v-.002z\"></path></svg>"

/***/ },
/* 1352 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"1357.388 321.333 163.701 176.265\"><defs><path id=\"a\" d=\"M1363.717 327.995h150.79V491.82h-150.79z\"></path></defs><clipPath id=\"b\"><use xlink:href=\"#a\" overflow=\"visible\"></use></clipPath><path d=\"M1438.425 416.16h1.174c10.75-.17 19.445-3.65 25.865-10.307 14.124-14.667 11.777-39.808 11.52-42.207-.918-18.012-10.164-26.628-17.793-30.65-5.688-3.007-12.33-4.63-19.74-4.764h-.624c-4.072 0-12.07.61-19.738 4.63-7.705 4.02-17.097 12.637-18.014 30.784-.256 2.4-2.605 27.54 11.52 42.207 6.383 6.656 15.08 10.138 25.83 10.306zm-27.554-51.67c0-.1.04-.202.04-.27 1.21-24.23 19.884-26.83 27.883-26.83h.44c9.906.202 26.745 3.92 27.883 26.83 0 .102 0 .203.038.27.036.237 2.605 23.217-9.063 35.314-4.62 4.798-10.785 7.163-18.893 7.23h-.367c-8.07-.067-14.272-2.43-18.858-7.23-11.632-12.03-9.137-35.11-9.1-35.313zm0 0\" clip-path=\"url(#b)\"></path><path d=\"M1514.407 457.858v-.1c0-.272-.038-.543-.038-.846-.22-6.69-.698-22.336-16.62-27.337-.11-.035-.256-.068-.367-.102-16.546-3.886-30.304-12.672-30.45-12.773-2.238-1.453-5.32-.947-6.898 1.114-1.578 2.063-1.028 4.9 1.21 6.354.624.404 15.226 9.765 33.497 14.09 8.547 2.806 9.502 11.22 9.758 18.925 0 .304 0 .574.038.845.036 3.04-.184 7.74-.77 10.44-5.944 3.11-29.242 13.856-64.683 13.856-35.293 0-58.737-10.78-64.717-13.888-.588-2.704-.844-7.402-.77-10.443 0-.27.036-.54.036-.845.258-7.704 1.21-16.12 9.76-18.924 18.27-4.325 32.873-13.718 33.496-14.09 2.238-1.453 2.79-4.293 1.21-6.353-1.577-2.06-4.658-2.566-6.896-1.115-.147.103-13.832 8.887-30.452 12.775-.147.033-.256.068-.367.1-15.922 5.037-16.4 20.682-16.62 27.338 0 .305 0 .576-.035.845v.102c-.038 1.757-.073 10.78 1.87 15.307.368.88 1.027 1.622 1.91 2.128 1.1.677 27.48 16.153 71.615 16.153 44.135 0 70.516-15.51 71.616-16.153.845-.506 1.54-1.25 1.91-2.128 1.83-4.495 1.793-13.517 1.757-15.274zm0 0\" clip-path=\"url(#b)\"></path></svg>"

/***/ },
/* 1353 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"676.168 321.188 119.332 176.265\"><g stroke=\"#000\" stroke-miterlimit=\"10\"><g stroke-width=\"4\"><path d=\"M720.99 344.21c0 8.273 6.706 14.98 14.98 14.98 8.273 0 14.98-6.706 14.98-14.98 0-8.274-6.706-14.98-14.98-14.98-8.274 0-14.98 6.706-14.98 14.98zm1.497 0c0-7.435 6.048-13.483 13.483-13.483 7.435 0 13.483 6.048 13.483 13.483 0 9.047-6.048 13.483-13.483 13.483-7.434 0-13.483-6.048-13.483-13.483zM684.148 344.21c0 8.273 6.707 14.98 14.98 14.98 8.274 0 14.982-6.706 14.982-14.98 0-8.274-6.707-14.98-14.98-14.98-8.275 0-14.982 6.706-14.982 14.98zm1.498 0c0-7.435 6.048-13.483 13.483-13.483 7.434 0 13.482 6.048 13.482 13.483s-6.048 13.483-13.483 13.483c-7.435 0-13.484-6.048-13.484-13.483zM757.83 344.21c0 8.273 6.707 14.98 14.98 14.98 8.274 0 14.982-6.706 14.982-14.98 0-8.274-6.707-14.98-14.98-14.98-8.275 0-14.982 6.706-14.982 14.98zm1.498 0c0-7.435 6.048-13.483 13.483-13.483 7.435 0 13.484 6.048 13.484 13.483s-6.048 13.483-13.483 13.483c-7.434 0-13.482-6.048-13.482-13.483zM684.57 474.43c0 8.273 6.706 14.98 14.98 14.98 8.273 0 14.98-6.706 14.98-14.98 0-8.274-6.706-14.98-14.98-14.98-8.274 0-14.98 6.706-14.98 14.98zm1.497 0c0-7.435 6.048-13.483 13.483-13.483 7.435 0 13.483 6.048 13.483 13.483 0 9.047-6.048 13.483-13.483 13.483-7.435 0-13.483-6.05-13.483-13.483zM721.41 474.43c0 8.273 6.707 14.98 14.98 14.98 8.274 0 14.982-6.706 14.982-14.98 0-8.274-6.707-14.98-14.98-14.98-8.276 0-14.982 6.706-14.982 14.98zm1.498 0c0-7.435 6.048-13.483 13.483-13.483 7.435 0 13.484 6.048 13.484 13.483s-6.048 13.483-13.483 13.483c-7.434 0-13.482-6.05-13.482-13.483z\"></path></g><g stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M772.81 419.878c-1.836 0-3.325-1.49-3.325-3.326v-55.56c0-1.838 1.49-3.327 3.326-3.327 1.838 0 3.327 1.49 3.327 3.326v55.562c0 1.837-1.49 3.326-3.326 3.326z\"></path><path d=\"M775.496 416.34c0 1.955-1.584 3.54-3.538 3.54h-71.552c-1.954 0-3.538-1.585-3.538-3.54 0-1.953 1.584-3.537 3.538-3.537h71.552c1.955 0 3.538 1.584 3.538 3.538z\"></path><path d=\"M732.644 358.085h6.653V459.92h-6.653zM695.803 358.693h6.653v101.835h-6.653z\"></path></g></g></svg>"

/***/ },
/* 1354 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" x=\"0\" y=\"0\" viewBox=\"0 0 174.2 174.2\" xml:space=\"preserve\"><path d=\"M164 137.9c-25.4-15.7-24-66.6-24-67.4 0-23.8-15.8-43.9-37.5-50.6v-4.6C102.5 6.9 95.6 0 87.1 0S71.7 6.9 71.7 15.4v4.6C50.1 26.6 34.3 46.8 34.3 70.8c0.5 14.2-2.9 54.1-24 67.1 -2.8 1.8-4.2 5.2-3.3 8.4 0.9 3.2 3.8 5.4 7.2 5.4h44.7c3 12.9 14.5 22.5 28.2 22.5s25.3-9.6 28.2-22.5h44.7c3.3 0 6.3-2.2 7.2-5.4C168.2 143.1 166.8 139.7 164 137.9zM80.4 136.8H32.5c17.8-25.2 16.7-64.5 16.7-66.3 0-20.9 17-37.9 37.9-37.9 20.9 0 37.9 17 37.9 37.7 -0.1 2-1.2 41.4 16.7 66.5H80.4z\"></path></svg>"

/***/ },
/* 1355 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1\" viewBox=\"0 0 50 50\" enable-background=\"new 0 0 50 50\" style=\"width:20px; height:20px;\"><path style=\"text-indent:0;text-align:start;line-height:normal;text-transform:none;block-progression:tb;-inkscape-font-specification:Bitstream Vera Sans\" d=\"M 11 0 C 10.477778 0 9.9395305 0.18546949 9.5625 0.5625 C 9.1854695 0.93953051 9 1.4777778 9 2 L 9 4 L 2 4 C 1.4777778 4 0.93953051 4.1854695 0.5625 4.5625 C 0.18546949 4.9395305 0 5.4777778 0 6 L 0 48 C 0 48.522222 0.18546949 49.060469 0.5625 49.4375 C 0.93953051 49.814531 1.4777778 50 2 50 L 48 50 C 48.522222 50 49.060469 49.814531 49.4375 49.4375 C 49.814531 49.060469 50 48.522222 50 48 L 50 6 C 50 5.4777778 49.814531 4.9395305 49.4375 4.5625 C 49.060469 4.1854695 48.522222 4 48 4 L 41 4 L 41 2 C 41 1.4777778 40.814531 0.93953051 40.4375 0.5625 C 40.060469 0.18546949 39.522222 0 39 0 L 37 0 C 36.477778 0 35.939531 0.18546949 35.5625 0.5625 C 35.185469 0.93953051 35 1.4777778 35 2 L 35 4 L 15 4 L 15 2 C 15 1.4777778 14.814531 0.93953051 14.4375 0.5625 C 14.060469 0.18546949 13.522222 0 13 0 L 11 0 z M 11 2 L 13 2 L 13 8 L 11 8 L 11 2 z M 37 2 L 39 2 L 39 8 L 37 8 L 37 2 z M 2 6 L 9 6 L 9 8 C 9 8.5222222 9.1854695 9.0604695 9.5625 9.4375 C 9.9395305 9.8145305 10.477778 10 11 10 L 13 10 C 13.522222 10 14.060469 9.8145305 14.4375 9.4375 C 14.814531 9.0604695 15 8.5222222 15 8 L 15 6 L 35 6 L 35 8 C 35 8.5222222 35.185469 9.0604695 35.5625 9.4375 C 35.939531 9.8145305 36.477778 10 37 10 L 39 10 C 39.522222 10 40.060469 9.8145305 40.4375 9.4375 C 40.814531 9.0604695 41 8.5222222 41 8 L 41 6 L 48 6 L 48 14 L 2 14 L 2 6 z M 2 16 L 48 16 L 48 48 L 2 48 L 2 16 z M 6.8125 21 A 1.0001 1.0001 0 0 0 6 22 L 6 43 A 1.0001 1.0001 0 0 0 7 44 L 30 44 L 43 44 A 1.0001 1.0001 0 0 0 44 43 L 44 22 A 1.0001 1.0001 0 0 0 43 21 L 7 21 A 1.0001 1.0001 0 0 0 6.90625 21 A 1.0001 1.0001 0 0 0 6.8125 21 z M 8 23 L 15 23 L 15 28 L 8 28 L 8 23 z M 17 23 L 24 23 L 24 28 L 17 28 L 17 23 z M 26 23 L 33 23 L 33 28 L 26 28 L 26 23 z M 35 23 L 42 23 L 42 28 L 35 28 L 35 23 z M 8 30 L 15 30 L 15 35 L 8 35 L 8 30 z M 17 30 L 24 30 L 24 35 L 17 35 L 17 30 z M 26 30 L 33 30 L 33 35 L 26 35 L 26 30 z M 35 30 L 42 30 L 42 35 L 35 35 L 35 30 z M 8 37 L 15 37 L 15 42 L 8 42 L 8 37 z M 17 37 L 24 37 L 24 42 L 17 42 L 17 37 z M 26 37 L 33 37 L 33 42 L 30 42 L 26 42 L 26 37 z M 35 37 L 42 37 L 42 42 L 35 42 L 35 37 z\"></path></svg>"

/***/ },
/* 1356 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" x=\"0\" y=\"0\" viewBox=\"0 0 122.9 120.6\" enable-background=\"new 0 0 122.948 120.551\" xml:space=\"preserve\"><g opacity=\"0.2\"><path d=\"M48.9 8.2c4.3 0 8.6 0.6 12.8 1.6 14 3.3 27.5 10.7 38 20.5 8.3 7.7 15.4 17.9 14.6 29.7 -0.7 12-8.7 22.4-17 30.4 -9.9 9.5-22.4 17.4-36 20.4 -3.1 0.7-6.3 1-9.4 1 -10.1 0-19.7-3.6-27.1-11.1C13.8 89.6 9 73.3 8.7 58.1c-0.3-14.4 3.5-30.3 14.5-40.5C30.4 10.9 39.5 8.2 48.9 8.2M48.9 0.2L48.9 0.2c-12.3 0-23 4-31.1 11.5C11.2 17.8 0.2 32 0.7 58.3c0.4 19.2 7.1 36.7 18.4 48.1 8.6 8.7 20.3 13.5 32.8 13.5 3.7 0 7.4-0.4 11.1-1.2 17.6-3.8 31.4-14.3 39.9-22.4 12.2-11.7 18.7-23.7 19.5-35.7 0.8-12.4-5.2-24.9-17.2-36.1C93.4 13.6 78.6 5.6 63.5 2 58.6 0.8 53.6 0.2 48.9 0.2L48.9 0.2z\"></path></g><path fill=\"#FFFFFF\" d=\"M114.3 60.1c-0.7 12-8.7 22.4-17 30.4 -9.9 9.5-22.4 17.4-36 20.4 -13.3 2.9-26.8-0.3-36.5-10.1C13.8 89.6 9 73.3 8.7 58.1c-0.3-14.4 3.5-30.3 14.5-40.5C33.7 7.9 48.3 6.6 61.7 9.8c14 3.3 27.5 10.7 38 20.5C108 38 115.1 48.3 114.3 60.1z\"></path><path fill=\"#0979BD\" d=\"M30.2 40.6c-0.4 0-0.7 0-1.1 0.1v1.8H29.2v19.9h0v0.7c0.3 0 0.7 0.1 1.1 0.1 6.2 0 11.3-5 11.3-11.3C41.5 45.6 36.5 40.6 30.2 40.6M34.3 52.8c0 0.7-0.1 1.4-0.3 2.1h-2.6v-2.1H34.3zM31.4 50.7v-2.1h2.6c0.1 0.7 0.2 1.4 0.3 2.1H31.4zM36.6 52.8h2.6c-0.1 0.7-0.2 1.4-0.5 2.1h-2.4C36.4 54.3 36.5 53.6 36.6 52.8M36.6 50.7c-0.1-0.7-0.1-1.4-0.3-2.1h2.4c0.3 0.7 0.4 1.4 0.5 2.1H36.6zM37.6 46.5h-1.9c-0.4-1-0.9-2-1.4-2.8C35.6 44.4 36.7 45.3 37.6 46.5M33.5 46.5h-2V42.9C32.3 43.9 33 45.2 33.5 46.5M31.4 60.8v-3.7h2c-0.5 1.4-1.2 2.6-2 3.7H31.4zM34.2 59.9c0.6-0.9 1.1-1.8 1.4-2.9h1.9C36.7 58.3 35.6 59.2 34.2 59.9\"></path><path fill=\"#0979BD\" d=\"M66.5 61.7h-5.9V43.1h5.8c3.8 0 5.5 2.6 5.5 4.8 0 1.8-0.7 3-2.2 3.9v0.1c2.2 0.5 3.4 2 3.4 4.2C73.1 58.7 71.2 61.7 66.5 61.7M65.9 46h-1.9v4.9h1.8c1.5 0 2.7-1 2.7-2.5C68.5 47 67.6 46 65.9 46M66.6 53.7h-2.6v5.1h2.2c2.3 0 3.4-1 3.4-2.7C69.6 54.7 68.5 53.7 66.6 53.7\"></path><polygon fill=\"#0979BD\" points=\"86.8 45.9 81.9 45.9 81.9 61.7 78.4 61.7 78.4 45.9 73 45.9 73 43.1 87.9 43.1 \"></polygon><path fill=\"#0979BD\" d=\"M55.4 61.7l-1.8-4.7h-6.6l-1.7 4.7h-3.4l7.2-18.6h2.6l7.5 18.6H55.4zM51 50c-0.3-0.9-0.6-1.7-0.7-2.3h0c-0.1 0.6-0.4 1.4-0.7 2.3l-1.6 4.3h4.5L51 50z\"></path><path fill=\"#0979BD\" d=\"M98 61.7l-1.8-4.7h-6.6l-1.7 4.7h-3.4l7.2-18.6h2.6l7.5 18.6H98zM93.6 50c-0.3-0.9-0.6-1.7-0.7-2.3h0c-0.1 0.6-0.4 1.4-0.7 2.3L90.6 54.3h4.5L93.6 50z\"></path><path fill=\"#E21F3F\" d=\"M28.1 49.7v-0.9l-5.4-5.4c-0.3 0.3-0.6 0.6-0.9 0.9l5.4 5.4H28.1z\"></path><path fill=\"#E21F3F\" d=\"M28.1 53.9v0.9l-5.4 5.4c-0.3-0.3-0.6-0.6-0.9-0.9l5.4-5.4H28.1z\"></path><path fill=\"#E21F3F\" d=\"M28.1 50.8h-9.1c0 0.3-0.1 0.7-0.1 1s0 0.7 0.1 1h9.1V50.8z\"></path><path fill=\"#0979BD\" d=\"M21.3 45c-1 1.4-1.8 2.9-2.1 4.7h6.8L21.3 45z\"></path><path fill=\"#0979BD\" d=\"M28.1 47.5v-6.8c-1.7 0.3-3.3 1.1-4.7 2.1L28.1 47.5z\"></path><path fill=\"#0979BD\" d=\"M23.4 60.7c1.4 1 2.9 1.8 4.7 2.1v-6.8L23.4 60.7z\"></path><path fill=\"#0979BD\" d=\"M26 53.9h-6.8c0.3 1.7 1.1 3.3 2.1 4.7L26 53.9z\"></path><text transform=\"matrix(1 0 0 1 19.0101 73.8255)\"><tspan x=\"0\" y=\"0\" fill=\"#0979BD\" font-family=\"&#x27;MalayalamSangamMN-Bold&#x27;\" font-size=\"10.3\">ABTA No</tspan><tspan x=\"45.5\" y=\"0\" fill=\"#0979BD\" font-family=\"&#x27;MalayalamSangamMN&#x27;\" font-size=\"10.3\">. P6847</tspan></text></svg>"

/***/ },
/* 1357 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" x=\"0\" y=\"0\" viewBox=\"0 0 132.4 120.3\" enable-background=\"new 0 0 132.448 120.301\" xml:space=\"preserve\"><path fill=\"#3DA4DC\" d=\"M122.7 66.8c1.7 13.7-0.4 29.8-12.7 38.2 -12.6 8.6-30 6.5-43.9 3.3 -15.9-3.8-32.7-10.2-45.5-20.8 -8.5-7.1-14-16.6-10.6-27.8 3.6-12 13.3-22.2 22.3-30.4 9.9-8.9 21.7-17.4 35.1-19.8C99.2 3.7 119.4 40 122.7 66.8z\"></path><defs><rect x=\"14.5\" y=\"-17.5\" width=\"111.4\" height=\"157.5\"></rect></defs><path fill=\"#FFFFFF\" d=\"M106.6 58.8v5.2c-0.2 0.2-0.1 0.4-0.1 0.6 -0.1 1.2-0.2 2.3-0.5 3.5 -1.4 7.7-5 14.2-10.6 19.6 -5.7 5.4-12.4 8.7-20.2 9.7 -1 0.1-2 0.3-3.1 0.4h-3.4c-0.2 0-0.4-0.1-0.6-0.1 -2.8-0.2-5.7-0.6-8.4-1.5C46.4 91.6 38.1 82.5 34.8 68.8c-0.4-1.7-0.5-3.5-0.8-5.3v-4.6c0.2-1.2 0.3-2.5 0.5-3.7 1.3-7.6 4.7-14.2 10.3-19.6 6.2-6.1 13.6-9.5 22.2-10.3 0.9-0.1 1.8 0 2.7-0.2h1.1c0.2 0.2 0.4 0.1 0.6 0.1 1.7 0 3.3 0.2 4.9 0.5 7.3 1.3 13.6 4.4 19 9.5 5.8 5.5 9.4 12.3 10.8 20.2C106.2 56.4 106.4 57.6 106.6 58.8M70.3 95.3c18.6 0 33.8-15.2 33.9-33.7 0.1-18.3-14.7-34.2-34.2-34 -18 0.1-33.1 14.5-33.5 33C36 79.1 50.8 95.2 70.3 95.3M81.9 79c-2-0.3-3.8-0.7-5.7-1 -4.7-0.8-9.3-1.6-14-2.5 -3-0.5-5.9-1.1-8.9-1.6 -0.4-0.1-0.5-0.2-0.5-0.6 0.4-2.4 0.8-4.8 1.3-7.2 0.9-4.9 1.7-9.8 2.6-14.7 0.8-4.6 1.6-9.2 2.4-13.8 0.1-0.4 0.2-0.6 0.7-0.5 1.5 0.3 3.1 0.6 4.7 0.8 0.6 0.1 0.6 0.3 0.3 0.7 -1.2 2.2-2 4.5-2.4 7 -0.8 5 0.3 9.5 3.2 13.6 3.6 5.1 8.6 7.9 14.7 8.6 1.1 0.1 2.2 0.3 3.2 0.1 0.6-0.1 0.7 0.1 0.6 0.6 -0.4 2.3-0.8 4.5-1.2 6.8 -0.2 1-0.3 2-0.5 2.9C82.3 78.7 82.3 79.2 81.9 79M71.8 69.2c-0.2 0-0.4 0-0.7 0 -1 0.1-1.6 0.6-1.8 1.3 -0.2 0.8 0.2 1.5 1 1.9 1.2 0.7 2.5 0.9 3.9 0.7 0.9-0.1 1.6-0.6 1.7-1.3 0.2-0.9-0.2-1.5-1.1-2C73.9 69.4 72.9 69.3 71.8 69.2M55.8 70.1c0.8-0.1 1.5 0.5 2-0.2 0.1-0.2 0.4-0.1 0.6-0.1 0.5 0.1 1 0.2 1.5 0.3 0.5 0 0.8 0.2 0.9 0.7 0 0.2 0.2 0.3 0.4 0.3 0.4 0.1 0.8 0.1 1.3 0.2 -0.6-1.3-1.2-2.5-1.8-3.8 -0.2-0.4-1.7-0.6-2-0.3C57.8 68.1 56.8 69 55.8 70.1M68.6 69.3c0.2 0.1 0.4 0 0.4-0.3 0-0.2-0.1-0.3-0.3-0.4 -1.6-0.3-3.3-0.6-4.9-0.9 -0.2 0-0.4-0.1-0.5 0.2 0 0.3 0 0.4 0.3 0.4 0.4 0 0.8 0.2 1.2 0.2 0.5 0 0.5 0.3 0.5 0.7 -0.1 0.6-0.2 1.1-0.3 1.7 -0.1 0.4-0.1 0.7 0.5 0.7 0.9 0.1 0.9 0.1 1.1-0.8 0-0.2 0.1-0.5 0.1-0.7 0.2-1.2 0.2-1.2 1.4-1C68.2 69.2 68.4 69.3 68.6 69.3M81.3 74.6c0.3 0.1 0.5 0.1 0.5-0.2 0-0.2 0-0.4-0.3-0.4 -0.9-0.1-1.8-0.3-2.7-0.5 -0.4-0.1-0.4-0.2-0.4-0.5 0.1-0.6 0.2-1.3 0.4-1.9 0.1-0.5 0-0.6-0.5-0.6 -0.2 0-0.3-0.1-0.5-0.1 -0.2 0-0.4 0-0.5 0.3 -0.2 1-0.3 1.9-0.5 2.9 -0.1 0.3 0.1 0.4 0.3 0.4C78.6 74.1 80 74.3 81.3 74.6M78.3 40.5c1.3 0.2 2.7 0.5 4 0.7 1.9 0.3 3.8 0.7 5.7 1 0.5 0.1 0.7 0.2 0.6 0.8 -1.4 7.6-2.7 15.1-4 22.7 -0.1 0.5-0.2 0.7-0.8 0.6 -7.5-0.9-12.4-6.6-13.3-12.8 -0.5-3.6 0.7-6.7 3.1-9.4 1.2-1.3 2.5-2.4 4.1-3.4C77.8 40.6 78 40.5 78.3 40.5M51.5 78.4c2.3 0 4.6 2.2 4.5 4.3 0 2.2-1.9 4-4 4 -2.3 0-4.6-2.1-4.6-4.3C47.5 80.3 49.4 78.4 51.5 78.4M54.7 81.7c0-1.4-1.5-2.6-2.8-2 -1.4 0.6-2.4 1.6-2.9 3 -0.5 1.4 0.6 2.8 2 2.8C52.6 85.6 54.7 83.4 54.7 81.7M96.2 78.8c0 0.9-0.3 1.7-0.8 2.5 -0.6 0.8-1.2 1.5-1.8 2.3 -0.2 0.3-0.4 0.3-0.7 0.1 -1.7-1.4-3.5-2.8-5.2-4.1 -0.3-0.2-0.3-0.4-0.1-0.7 0.7-0.8 1.3-1.6 1.9-2.4 1.1-1.4 2.4-1.8 3.8-1.3C95 75.6 96.2 77.1 96.2 78.8M95.1 79.6c0-0.2-0.1-0.6-0.3-0.9 -0.6-1-1.5-1.8-2.6-2.2 -0.8-0.3-1.6-0.1-2.2 0.5 -0.3 0.3-0.6 0.7-0.9 1 -0.2 0.2-0.1 0.3 0.1 0.5 1.5 1.1 2.9 2.3 4.4 3.4 0.1 0.1 0.2 0.2 0.4 0C94.5 81.3 95.1 80.7 95.1 79.6M44.3 80.4c-0.3-0.5-0.6-1-0.9-1.5 -0.2-0.2 0-0.4 0.1-0.6 0.5-0.9 1-1.7 1.5-2.6 0.1-0.1 0.1-0.3 0.3-0.6 -1 0.6-1.8 1-2.5 1.5 -0.4 0.2-0.5 0.3-0.8-0.2 -0.5-1.1-0.5-1 0.5-1.7 1.7-1 3.3-1.9 4.9-2.9 0.4-0.2 0.6-0.3 0.9 0.2 0.4 0.8 0.9 1.5 1.3 2.3 0.5 0.9 0.4 1.8-0.2 2.4 -0.7 0.7-1.7 0.7-2.6 0.1 -0.3-0.2-0.5-0.2-0.6 0.1C45.6 78 45 79.2 44.3 80.4M47 75.7c0.7 0 1.3-0.4 1.6-1 0.2-0.4 0-0.8-0.1-1.1 -0.1-0.3-0.3-0.4-0.6-0.2 -0.5 0.3-1.1 0.6-1.6 0.9 -0.6 0.4-0.6 0.6-0.1 1C46.5 75.6 46.7 75.7 47 75.7M47 69c0 0.9-0.2 1.5-1 1.9 -0.9 0.4-1.9 0.3-2.5-0.3 -0.5-0.5-0.8-1.1-0.9-1.7 -0.1-0.5-0.4-0.6-0.8-0.4 -0.7 0.2-1.4 0.4-2.1 0.6 -0.4 0.1-0.5 0.1-0.6-0.3 -0.3-1.2-0.3-1.2 0.9-1.5 1.8-0.5 3.7-1 5.5-1.5 0.4-0.1 0.7-0.1 0.8 0.4C46.5 67.1 47 68.1 47 69M44.4 69.5c0.6 0 1.3-0.3 1.6-0.7 0.3-0.4 0.2-0.8 0.1-1.2 -0.2-0.4-0.5 0-0.8 0 -0.5 0.1-1 0.2-1.5 0.4 -0.2 0.1-0.6 0-0.6 0.3 0 0.3 0.2 0.6 0.4 0.8C43.8 69.3 44.1 69.4 44.4 69.5M88.5 83.3c-0.6 0.4-1.1 0.8-1.7 1.1 -0.3 0.2-0.3 0.4-0.1 0.6 0.4 0.5 0.8 1.1 1.1 1.6 0.2 0.3 0.3 0.2 0.5 0.1 0.5-0.4 1.1-0.9 1.7-1.3 0 0 0.1 0 0.1 0.1 0.5 0.7 0.5 0.7-0.2 1.2 -0.8 0.5-1.6 1.1-2.3 1.6 -0.3 0.2-0.5 0.3-0.7-0.1 -1.3-1.8-2.6-3.6-3.8-5.5 -0.2-0.3-0.2-0.4 0.1-0.6 0.9-0.6 1.9-1.3 2.8-2 0.5-0.4 0.5 0.2 0.7 0.4 0.3 0.3 0 0.3-0.2 0.4 -0.1 0-0.1 0.1-0.2 0.1 -2.1 1.3-1.8 0.7-0.5 2.7 0.2 0.2 0.3 0.3 0.5 0.1 0.4-0.3 0.9-0.6 1.2-0.9 0.4-0.4 0.6-0.3 0.8 0.1C88.4 83.1 88.5 83.2 88.5 83.3M63.1 92.3c0.4-2.3 0.8-4.6 1.1-6.8 0-0.3 0.2-0.4 0.5-0.3 1.1 0.2 2.2 0.4 3.3 0.6 0.6 0.1 0.4 0.4 0.3 0.7 0 0.5-0.3 0.3-0.6 0.2 0 0-0.1 0-0.1 0 -2.3-0.5-1.7-0.7-2.2 1.5 -0.1 0.4 0.1 0.5 0.4 0.6 0.5 0.1 1 0.1 1.5 0.2 0.3 0 0.6 0 0.4 0.4 -0.1 0.3 0 0.6-0.5 0.5 -0.5-0.2-1.1-0.2-1.6-0.4 -0.3-0.1-0.4 0-0.5 0.3 -0.1 0.7-0.2 1.3-0.3 2 -0.1 0.3 0.1 0.4 0.4 0.4 0.6 0 1.1 0.1 1.7 0.2 0.3 0 0.5 0.1 0.3 0.4 -0.1 0.2 0.1 0.7-0.5 0.6 -1.1-0.2-2.3-0.4-3.4-0.6C63.2 92.6 63 92.5 63.1 92.3M75.8 86.8c-0.3 0-0.4-0.2-0.6-0.4 -1.1-0.7-2.5-0.5-3.2 0.6 -0.8 1.2-0.7 3.4 0.2 4.6 0.8 1.1 2.4 1.3 3.6 0.4 0.2-0.1 0.4-0.7 0.6-0.3 0.1 0.2 0.1 0.8-0.4 1.1 -0.9 0.5-1.9 0.6-3 0.5 -1.9-0.2-3.2-1.5-3.4-3.3 -0.2-2.2 0.7-3.8 2.6-4.4 0.9-0.3 1.9-0.4 2.9-0.2 0.9 0.2 0.9 0.2 0.8 1C75.9 86.6 75.9 86.7 75.8 86.8M78.5 85.2c-0.4 0.2-0.8 0.4-1.3 0.6 -0.2 0.1-0.4 0.3-0.5-0.1 0-0.3-0.5-0.5 0.1-0.8 1.5-0.6 3.1-1.2 4.6-1.8 0.6-0.2 0.5 0.3 0.6 0.5 0.2 0.4-0.1 0.3-0.3 0.4 -1.5 0.5-1.5 0.5-0.9 1.9 0.6 1.5 1.1 2.9 1.7 4.4 0.2 0.4 0.2 0.6-0.4 0.8 -1.1 0.3-1.1 0.4-1.5-0.7 -0.6-1.6-1.2-3.2-1.9-4.7C78.9 85.5 78.9 85.2 78.5 85.2M59.4 84.4c0.1-0.2-0.1-0.3-0.3-0.3 -0.4-0.1-0.8-0.3-1.2-0.4 -0.2-0.1-0.5-0.1-0.3-0.4 0.1-0.2 0.1-0.7 0.6-0.5 1.5 0.7 3.1 1.3 4.6 2 0.5 0.2 0.1 0.5 0 0.7 -0.1 0.4-0.3 0.2-0.5 0.1 -0.4-0.2-0.9-0.7-1.3-0.6 -0.4 0.1-0.5 0.8-0.7 1.3 -0.6 1.4-1.3 2.9-1.9 4.4 -0.1 0.4-0.3 0.5-0.7 0.3 -0.3-0.2-0.9-0.2-1-0.6 -0.1-0.3 0.3-0.7 0.4-1.1 0.6-1.5 1.3-3 1.9-4.5C59.3 84.6 59.4 84.5 59.4 84.4M73 72.5c-0.6 0-1.2-0.2-1.8-0.6 -0.7-0.6-0.5-1.6 0.4-1.9 0.7-0.2 1.3-0.1 2 0.1 0.8 0.3 1.1 0.8 1 1.4C74.4 72.2 73.9 72.5 73 72.5M59.6 67.9c0.2 0.5 0.4 0.9 0.6 1.4 -0.6 0.1-1.1-0.1-1.7-0.2C58.9 68.7 59.2 68.3 59.6 67.9\"></path><g opacity=\"0.2\"><path d=\"M73.9 8.8c28.1 0 45.7 33.1 48.8 58 1.7 13.7-0.4 29.8-12.7 38.2 -6.6 4.5-14.6 6.1-22.6 6.1 -7.3 0-14.7-1.3-21.3-2.8 -15.9-3.8-32.7-10.2-45.5-20.8 -8.5-7.1-14-16.6-10.6-27.8 3.6-12 13.3-22.2 22.3-30.4 9.9-8.9 21.7-17.4 35.1-19.8C69.5 8.9 71.7 8.8 73.9 8.8M73.9 0.8v8V0.8h0c-2.6 0-5.3 0.2-8 0.7 -12.8 2.3-25.2 9.2-39.1 21.8C17.6 31.6 6.5 43 2.2 57.3 -1.7 70.3 3 83.2 15.4 93.5c12.2 10.2 28.6 17.7 48.8 22.5 8.7 2.1 16.3 3.1 23.1 3.1 10.7 0 19.9-2.5 27.2-7.5 12.8-8.7 18.7-25.4 16.1-45.8 -1.8-14.7-8-30.4-16.5-42.1C103.2 8.7 89.2 0.8 73.9 0.8L73.9 0.8z\"></path></g></svg>"

/***/ },
/* 1358 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" x=\"0\" y=\"0\" viewBox=\"0 0 361.3 322.1\" xml:space=\"preserve\"><path fill=\"#EE3C67\" d=\"M358.2 163.7c24.9 96.8-106.3 141.7-177.6 153.6 -45.8 7.7-101.1 9.1-140.5-20.2C3.5 269.8-4.2 222.3 1.9 179.6 13.8 95.9 80.8-11.6 178 1c42.4 5.5 80.2 31.2 110.8 59.7C318.6 88.5 347.9 123.5 358.2 163.7z\"></path><path fill=\"#FFFFFF\" d=\"M76.2 118.9h-1.3c-1.6 0-2.2-0.6-2.2-1.8 0-1.2 0.7-1.8 2.2-1.8h1.3v-2.8c0-3.5 2.9-5.3 6.1-5.3 2 0 3.7 0.8 3.7 2.6 0 1.1-0.8 1.9-1.8 1.9 -0.4 0-0.8-0.1-1.2-0.1 -0.8 0-1.2 0.5-1.2 1.3v2.4h1.7c1.7 0 2.5 0.5 2.5 1.8 0 1.4-0.9 1.8-2.5 1.8h-1.7v14c0 1.8-1.1 2.8-2.8 2.8s-2.8-1-2.8-2.8L76.2 118.9 76.2 118.9zM88.9 117.4c0-1.6 1.1-2.6 2.5-2.6 1.4 0 2.5 0.9 2.5 2.6v2.2H94c0.7-2.3 1.9-4.8 4.6-4.8 1.8 0 3.1 1.1 3.1 2.7 0 2-1.4 2.8-2.8 2.8h-1c-2.2 0-3.5 1.6-3.5 6.2v6.5c0 1.5-0.6 2.8-2.8 2.8s-2.8-1.3-2.8-2.8C88.9 132.9 88.9 117.4 88.9 117.4zM113.3 114.8c6.7 0 10.3 4.6 10.3 10.5 0 5.5-2.7 10.5-10.3 10.5s-10.3-5-10.3-10.5C103 119.3 106.5 114.8 113.3 114.8zM113.3 131.6c3.3 0 4.7-3 4.7-6.3 0-3.6-1.5-6.3-4.7-6.3 -3.2 0-4.8 2.7-4.8 6.3C108.5 128.6 109.9 131.6 113.3 131.6zM127.3 117.5c0-1.6 1-2.8 2.6-2.8 1.7 0 2.6 1.1 2.6 2.8v0.7h0.1c1.5-2.2 3.9-3.5 6.7-3.5 1.9 0 4.3 0.9 5.3 3.5 1.6-2.2 3.6-3.5 6.6-3.5 3.9 0 7 1.8 7 6.7v11.4c0 1.5-0.6 2.8-2.8 2.8 -2.2 0-2.8-1.3-2.8-2.8v-10c0-2-0.9-3.6-3.1-3.6 -2.1 0-4 1.8-4 4.4v9.2c0 1.5-0.6 2.8-2.8 2.8 -2.2 0-2.8-1.3-2.8-2.8v-10c0-2-0.9-3.6-3.1-3.6 -2.1 0-4 1.8-4 4.4v9.2c0 1.5-0.6 2.8-2.8 2.8 -2.1 0-2.8-1.3-2.8-2.8L127.3 117.5 127.3 117.5z\"></path><path fill=\"#FFFFFF\" d=\"M74.4 241.7c0-1.7 0.8-2.6 2.5-2.6 1.6 0 2.5 0.9 2.5 2.6v0.9h0.1c0.9-2.4 3.2-3.5 5.9-3.5 4.7 0 8.7 3.4 8.7 10.6 0 5.3-2.7 10.4-8.6 10.4 -2.6 0-4.5-1.1-5.5-2.8H80v7.4c0 1.9-1.1 2.8-2.8 2.8 -1.6 0-2.8-1-2.8-2.8L74.4 241.7 74.4 241.7zM84.2 243.4c-3.2 0-4.5 2.9-4.5 6.1 0 2.8 1.1 6.2 4.5 6.2 3.5 0 4.4-3.6 4.4-6.2C88.6 246.2 87.1 243.5 84.2 243.4zM102.6 250.6c0 2.9 1.9 5.1 5.2 5.1 4.2 0 4.2-2.8 6.4-2.8 1.3 0 2.3 1.1 2.3 2.2 0 3.4-5.4 4.9-8.7 4.9 -7.8 0-10.7-5.3-10.7-10.2 0-6.5 3.9-10.8 10.5-10.8 6.4 0 10.1 4.6 10.1 9.1 0 1.9-0.6 2.4-2.4 2.4H102.6zM112.4 247.4c-0.3-2.6-2.2-4.4-4.7-4.4 -2.8 0-4.5 1.7-5.1 4.4H112.4zM121.7 241.7c0-1.6 1.1-2.6 2.5-2.6 1.4 0 2.5 0.9 2.5 2.6v2.2h0.1c0.7-2.3 1.9-4.8 4.6-4.8 1.8 0 3.1 1.1 3.1 2.7 0 2-1.4 2.8-2.8 2.8h-1c-2.2 0-3.5 1.6-3.5 6.2v6.5c0 1.5-0.6 2.8-2.8 2.8 -2.2 0-2.8-1.3-2.8-2.8L121.7 241.7 121.7 241.7zM148.8 241.7c0-1.7 0.8-2.6 2.5-2.6 1.6 0 2.5 0.9 2.5 2.6v0.9h0.1c0.9-2.4 3.2-3.5 5.9-3.5 4.7 0 8.7 3.4 8.7 10.6 0 5.3-2.7 10.4-8.6 10.4 -2.6 0-4.5-1.1-5.5-2.8h-0.1v7.4c0 1.9-1.1 2.8-2.8 2.8 -1.6 0-2.8-1-2.8-2.8V241.7zM158.5 243.4c-3.2 0-4.5 2.9-4.5 6.1 0 2.8 1.1 6.2 4.5 6.2 3.5 0 4.4-3.6 4.4-6.2C162.9 246.2 161.5 243.5 158.5 243.4zM177 250.6c0 2.9 1.9 5.1 5.2 5.1 4.2 0 4.2-2.8 6.4-2.8 1.3 0 2.3 1.1 2.3 2.2 0 3.4-5.4 4.9-8.7 4.9 -7.8 0-10.7-5.3-10.7-10.2 0-6.5 3.9-10.8 10.5-10.8 6.4 0 10.1 4.6 10.1 9.1 0 1.9-0.6 2.4-2.4 2.4H177zM186.7 247.4c-0.3-2.6-2.2-4.4-4.7-4.4 -2.8 0-4.5 1.7-5.1 4.4H186.7zM196 241.7c0-1.6 1.1-2.6 2.5-2.6 1.4 0 2.5 0.9 2.5 2.6v2.2h0.1c0.7-2.3 1.9-4.8 4.6-4.8 1.8 0 3.1 1.1 3.1 2.7 0 2-1.4 2.8-2.8 2.8h-1c-2.2 0-3.5 1.6-3.5 6.2v6.5c0 1.5-0.6 2.8-2.8 2.8 -2.2 0-2.8-1.3-2.8-2.8L196 241.7 196 241.7zM218.8 239.1c4.2 0 8.5 1.7 8.5 4.2 0 1.3-0.9 2.4-2.3 2.4 -2.2 0-2.2-2.5-5.8-2.5 -1.9 0-3.2 0.5-3.2 1.7 0 1.3 1.3 1.6 3 2l2.3 0.5c3.2 0.7 6.9 2 6.9 5.9 0 4.6-4.4 6.7-8.6 6.7 -5 0-9.2-2.3-9.2-5 0-1.3 0.7-2.3 2.3-2.3 2.4 0 2.6 3.4 6.7 3.4 2 0 3.3-0.9 3.3-2 0-1.4-1.2-1.6-3.2-2.1l-3.3-0.9c-3.2-0.8-5.8-2.1-5.8-5.9C210.5 240.8 215 239.1 218.8 239.1zM241.5 239.1c6.7 0 10.3 4.6 10.3 10.5 0 5.5-2.7 10.5-10.3 10.5 -7.6 0-10.3-4.9-10.3-10.5C231.2 243.7 234.7 239.1 241.5 239.1zM241.5 255.9c3.3 0 4.7-3 4.7-6.3 0-3.6-1.5-6.3-4.7-6.3 -3.2 0-4.8 2.7-4.8 6.3C236.7 252.9 238.1 255.9 241.5 255.9zM255.5 241.9c0-1.6 0.8-2.8 2.5-2.8 1.8 0 2.5 1.1 2.5 2.8v0.7h0.1c1.5-2 3.6-3.5 6.8-3.5 3.3 0 7 1.7 7 7.3v10.8c0 1.5-0.6 2.8-2.8 2.8 -2.2 0-2.8-1.3-2.8-2.8v-9.7c0-2.2-1.1-3.8-3.5-3.8 -1.9 0-4.2 1.6-4.2 4.4v9.2c0 1.5-0.6 2.8-2.8 2.8 -2.1 0-2.8-1.3-2.8-2.8L255.5 241.9 255.5 241.9z\"></path><path fill=\"#FFFFFF\" d=\"M75.1 68.4c0-2.8 1.5-3.6 3.7-3.6h7.6c6.8 0 13.1 3 13.1 13.7 0 8.7-4.8 13.7-13.2 13.7h-7.5c-2.2 0-3.7-0.9-3.7-3.7L75.1 68.4 75.1 68.4zM81.4 87.3h5.2c5 0 6.6-4.5 6.6-8.7 0-5.4-2-8.7-6.6-8.7h-5.2C81.4 69.8 81.4 87.3 81.4 87.3zM108.3 83.4c0 2.9 1.9 5.1 5.2 5.1 4.2 0 4.2-2.8 6.4-2.8 1.3 0 2.3 1.1 2.3 2.2 0 3.4-5.4 4.9-8.7 4.9 -7.8 0-10.7-5.3-10.7-10.2 0-6.5 3.9-10.8 10.5-10.8 6.4 0 10.1 4.6 10.1 9.1 0 1.9-0.6 2.4-2.4 2.4L108.3 83.4 108.3 83.4zM118.1 80.1c-0.3-2.6-2.2-4.4-4.7-4.4 -2.8 0-4.5 1.7-5.1 4.4H118.1zM127.1 74.4c0-1.7 0.8-2.6 2.5-2.6 1.6 0 2.5 0.9 2.5 2.6v0.9h0.1c0.9-2.4 3.2-3.5 5.9-3.5 4.7 0 8.7 3.4 8.7 10.6 0 5.3-2.7 10.4-8.6 10.4 -2.6 0-4.5-1.1-5.5-2.8h-0.1v7.4c0 1.8-1.1 2.8-2.8 2.8 -1.6 0-2.8-1-2.8-2.8L127.1 74.4 127.1 74.4zM136.8 76.2c-3.2 0-4.5 2.9-4.5 6.1 0 2.8 1.1 6.2 4.5 6.2 3.5 0 4.4-3.6 4.4-6.2C141.2 78.9 139.8 76.2 136.8 76.2zM160 71.8c6.7 0 10.3 4.6 10.3 10.5 0 5.6-2.7 10.5-10.3 10.5s-10.3-4.9-10.3-10.5C149.7 76.4 153.3 71.8 160 71.8zM160 88.6c3.3 0 4.7-3 4.7-6.3 0-3.6-1.5-6.3-4.7-6.3 -3.2 0-4.8 2.7-4.8 6.3C155.3 85.7 156.7 88.6 160 88.6zM181.5 71.8c4.2 0 8.5 1.7 8.5 4.2 0 1.3-0.9 2.4-2.3 2.4 -2.2 0-2.2-2.5-5.8-2.5 -1.9 0-3.2 0.5-3.2 1.7 0 1.3 1.3 1.6 3 2l2.3 0.5c3.2 0.7 6.9 2 6.9 5.9 0 4.6-4.4 6.7-8.6 6.7 -5 0-9.2-2.3-9.2-5 0-1.3 0.7-2.3 2.3-2.3 2.4 0 2.6 3.4 6.7 3.4 2 0 3.3-0.9 3.3-2 0-1.4-1.2-1.6-3.2-2.1l-3.3-0.9c-3.2-0.8-5.8-2.1-5.8-5.9C173.2 73.5 177.7 71.8 181.5 71.8zM197.8 64.1c1.6 0 2.9 1.3 2.9 2.9 0 1.6-1.3 2.9-2.9 2.9 -1.6 0-2.9-1.3-2.9-2.9C194.9 65.5 196.2 64.1 197.8 64.1zM195 74.6c0-1.5 0.6-2.8 2.8-2.8 2.2 0 2.8 1.3 2.8 2.8V90c0 1.5-0.6 2.8-2.8 2.8 -2.2 0-2.8-1.3-2.8-2.8V74.6zM206.8 76h-1c-1.6 0-2.2-0.6-2.2-1.8 0-1.2 0.7-1.8 2.2-1.8h1v-3.4c0-1.8 1.1-2.8 2.8-2.8 1.7 0 2.8 0.9 2.8 2.8v3.4h1.7c1.6 0 2.5 0.5 2.5 1.8 0 1.4-0.9 1.8-2.5 1.8h-1.7v11.2c0 0.9 0.5 1.3 1.5 1.3h0.8c1.2 0 1.9 0.7 1.9 1.8 0 1.6-1.4 2.5-4.1 2.5 -4 0-5.7-1.7-5.7-5L206.8 76 206.8 76zM227 71.8c4.2 0 8.5 1.7 8.5 4.2 0 1.3-0.9 2.4-2.3 2.4 -2.2 0-2.2-2.5-5.8-2.5 -1.9 0-3.2 0.5-3.2 1.7 0 1.3 1.2 1.6 3 2l2.3 0.5c3.2 0.7 6.9 2 6.9 5.9 0 4.6-4.4 6.7-8.6 6.7 -5 0-9.2-2.3-9.2-5 0-1.3 0.7-2.3 2.3-2.3 2.4 0 2.6 3.4 6.7 3.4 2 0 3.3-0.9 3.3-2 0-1.4-1.2-1.6-3.2-2.1l-3.3-0.9c-3.2-0.8-5.8-2.1-5.8-5.9C218.6 73.5 223.2 71.8 227 71.8z\"></path><path fill=\"#FFFFFF\" d=\"M108.3 180.5c4.4 0 6.6 1.6 6.6 5.1 0 3.5-2.2 5.1-6.6 5.1h-8.4c0.3 0.9 0.5 1.6 0.5 2.6 0 6.3-5.2 12.4-10.9 16.6l0.2 0.3c3.7-1.5 6.7-3.3 11.8-3.3 6.9 0 10.7 2.1 16.1 2.1 1.8 0 6.2-1.2 7.9-1.2 3.9 0 6.1 3 6.1 6.8 0 6.5-6.3 9-12.2 9 -7.2 0-15.1-4-24.4-4 -4.3 0-6.7 0.9-8.5 2 -1.9 1-3.2 2-5.3 2 -4.5 0-6.8-3.2-6.8-7.3 0-6.9 11.1-9.8 11.1-20.3 0-1.9-0.5-3.7-1.2-5.3h-5.6c-3.4 0-5.7-1.7-5.7-5.1 0-3.1 1.7-5.1 5-5.1h2.2c-2.2-3.2-3.2-7.3-3.2-11.4 0-13.1 11.7-22.4 26.7-22.4 18.6 0 27.6 10 27.6 18.3 0 4.8-3.3 7.4-8 7.4 -9.3 0-3.6-12.9-18-12.9 -6.3 0-12.2 3.7-12.2 10.6 0 3.6 1.8 7.2 3.5 10.4H108.3z\"></path><path fill=\"#FFFFFF\" d=\"M145.4 214.3c0-27.7 32.4-32.7 32.4-43.5 0-5.2-4.2-7.5-8.1-7.5 -3.4 0-6.2 1.8-8 3.7 -2.6 2.5-5.4 3.6-8.2 1.3l-4.1-3.3c-2.9-2.3-3.7-4.9-1.5-7.8 3.7-4.8 10.9-11.2 23.4-11.2 12.3 0 25.6 7 25.6 23 0 23.4-30.3 27.9-31.3 37.6h26.7c3.8 0 5.8 2 5.8 5.8v4.2c0 3.8-2 5.8-5.8 5.8h-40.8c-3.6 0-6.2-2-6.2-5.8V214.3zM209 210.1c1.3-4 3.4-4.4 6.7-3.9 1.8 0.3 3 0.6 5.2 0.6 9.3 0 14.2-5.9 16.5-13.4h-0.2c-1.8 1.8-6.6 3.7-12.2 3.7 -14.1 0-23-12.3-23-25 0-12.9 9.3-26 25.5-26 15.2 0 30.6 11.7 30.6 35.3 0 21.3-12.5 42.3-35.9 42.3 -4.1 0-8.7-0.6-11.2-1.4 -3.5-1-4.7-3.6-3.6-7.2L209 210.1zM239.3 176.8c0-6.1-5.2-13.9-11.7-13.9 -4.3 0-7.5 3.6-7.5 8.7 0 5 2.9 10.7 12.2 10.7C236.3 182.3 239.3 181.3 239.3 176.8z\"></path></svg>"

/***/ },
/* 1359 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" x=\"0\" y=\"0\" viewBox=\"0 0 128.7 116.3\" enable-background=\"new 0 0 128.698 116.301\" xml:space=\"preserve\"><path fill=\"#F4B91B\" d=\"M118.9 58.5c7.6 29.7-32.6 43.5-54.5 47.1 -14 2.3-31 2.8-43.1-6.2C10.1 91 7.8 76.4 9.6 63.3 13.3 37.7 33.8 4.7 63.7 8.6c13 1.7 24.6 9.6 34 18.3C106.8 35.4 115.8 46.1 118.9 58.5z\"></path><path fill=\"#FFFFFF\" d=\"M49.8 63.7c0-0.8-0.6-1-1.1-1h-0.6c-0.6 0-0.9 0.2-1.1 0.9l-1.7 5.7h0l-1.8-5.7c-0.2-0.7-0.5-0.9-1.1-0.9h-0.6c-0.5 0-1.1 0.2-1.1 1v7.2c0 0.5 0.2 1 0.9 1 0.7 0 0.9-0.5 0.9-1V65.4h0l1.9 5.9c0.1 0.4 0.4 0.6 0.9 0.6 0.4 0 0.7-0.2 0.9-0.6l1.9-5.9h0v5.5c0 0.5 0.2 1 0.9 1 0.6 0 0.9-0.5 0.9-1V63.7zM51.2 68.4c0 1.8 0.9 3.4 3.3 3.4 2.4 0 3.3-1.6 3.3-3.4 0-1.9-1.2-3.4-3.3-3.4C52.3 65.1 51.2 66.6 51.2 68.4zM56 68.4c0 1.1-0.5 2-1.5 2 -1.1 0-1.5-1-1.5-2 0-1.2 0.5-2 1.5-2C55.5 66.4 56 67.3 56 68.4zM64.1 71.8c0.7 0 0.9-0.4 0.9-0.9v-3.5c0-1.8-1.2-2.4-2.3-2.4 -1 0-1.7 0.5-2.2 1.1h0v-0.2c0-0.5-0.2-0.9-0.8-0.9 -0.6 0-0.8 0.4-0.8 0.9v4.9c0 0.5 0.2 0.9 0.9 0.9 0.7 0 0.9-0.4 0.9-0.9v-3c0-0.9 0.7-1.4 1.4-1.4 0.8 0 1.1 0.5 1.1 1.2v3.1C63.2 71.4 63.4 71.8 64.1 71.8zM70 71c0-0.4-0.2-0.6-0.6-0.6h-0.3c-0.3 0-0.5-0.1-0.5-0.4v-3.6h0.5c0.5 0 0.8-0.2 0.8-0.6 0-0.4-0.3-0.6-0.8-0.6h-0.5v-1.1c0-0.6-0.4-0.9-0.9-0.9 -0.5 0-0.9 0.3-0.9 0.9v1.1h-0.3c-0.5 0-0.7 0.2-0.7 0.6 0 0.4 0.2 0.6 0.7 0.6h0.3v3.8c0 1.1 0.5 1.6 1.8 1.6C69.6 71.8 70 71.5 70 71zM76.1 71.8c0.7 0 0.9-0.4 0.9-0.9v-3.5c0-1.8-1.2-2.4-2.3-2.4 -1 0-1.6 0.5-2 0.9h0v-2.5c0-0.6-0.4-0.9-0.9-0.9 -0.5 0-0.9 0.3-0.9 0.9v7.4c0 0.5 0.2 0.9 0.9 0.9 0.7 0 0.9-0.4 0.9-0.9v-3c0-0.9 0.7-1.4 1.4-1.4 0.8 0 1.1 0.5 1.1 1.2v3.1C75.2 71.4 75.4 71.8 76.1 71.8zM78.5 63.6v7.4c0 0.6 0.4 0.9 0.9 0.9 0.5 0 0.9-0.3 0.9-0.9v-7.4c0-0.6-0.4-0.9-0.9-0.9C78.9 62.7 78.5 63 78.5 63.6zM86.2 65.1c-0.5 0-0.7 0.3-0.9 0.8l-1.1 4.1h0l-1.2-4.2c-0.1-0.4-0.4-0.7-0.9-0.7 -0.5 0-0.9 0.4-0.9 0.9 0 0.2 0.1 0.4 0.2 0.8l1.9 5.3c-0.1 0.6-0.4 0.6-0.6 0.6h-0.2c-0.5 0-0.8 0.2-0.8 0.7 0 0.4 0.3 0.8 1.1 0.8 1.1 0 1.6-0.6 2-1.9l2.1-5.9c0.1-0.2 0.1-0.4 0.1-0.6C87.1 65.7 86.9 65.1 86.2 65.1zM39.1 77.5h-3.1c-0.7 0-1.2 0.3-1.2 1.2v6.8c0 0.6 0.4 1 1 1s1-0.4 1-1v-2.4h2.2c1.9 0 3.1-1.2 3.1-2.8C42.2 78.4 40.8 77.5 39.1 77.5zM38.8 81.6h-1.9v-2.5h1.7c1 0 1.6 0.4 1.6 1.3C40.2 81.1 39.6 81.6 38.8 81.6zM48.8 81.6c0-1.3-1.2-1.8-2.9-1.8 -1.8 0-2.8 0.9-2.8 1.6 0 0.4 0.3 0.7 0.8 0.7 0.7 0 0.7-1 2.1-1 0.6 0 1.1 0.2 1.1 0.7 0 0.5-0.3 0.6-0.8 0.7l-1.1 0.1c-1.4 0.2-2.5 0.6-2.5 2.1 0 1.1 1 1.8 2 1.8 0.9 0 1.8-0.3 2.5-1 0 0.6 0.3 1 1.1 1 0.4 0 0.8-0.3 0.8-0.7 0-0.3-0.2-0.5-0.2-1.2V81.6zM47 84c0 0.7-0.6 1.3-1.6 1.3 -0.6 0-1-0.3-1-0.7 0-0.5 0.4-0.8 1.2-0.9l0.6-0.1c0.2 0 0.6-0.1 0.8-0.3V84zM54.7 79.8c-0.5 0-0.7 0.3-0.9 0.8l-1.1 4.1h0l-1.2-4.2c-0.1-0.4-0.4-0.7-0.9-0.7 -0.5 0-0.9 0.4-0.9 0.9 0 0.2 0.1 0.4 0.2 0.8l1.9 5.3c-0.1 0.6-0.4 0.6-0.6 0.6h-0.2c-0.5 0-0.8 0.2-0.8 0.7 0 0.4 0.3 0.8 1.1 0.8 1.1 0 1.6-0.6 2-1.9l2.1-5.9c0.1-0.2 0.1-0.4 0.1-0.6C55.6 80.4 55.4 79.8 54.7 79.8zM64.1 79.8c-1 0-1.6 0.4-2.1 1.1 -0.3-0.8-1.1-1.1-1.7-1.1 -0.9 0-1.7 0.4-2.2 1.1h0v-0.2c0-0.5-0.3-0.9-0.8-0.9s-0.8 0.4-0.8 0.9v4.9c0 0.5 0.2 0.9 0.9 0.9 0.7 0 0.9-0.4 0.9-0.9v-3c0-0.8 0.6-1.4 1.3-1.4 0.7 0 1 0.5 1 1.2v3.2c0 0.5 0.2 0.9 0.9 0.9 0.7 0 0.9-0.4 0.9-0.9v-3c0-0.8 0.6-1.4 1.3-1.4 0.7 0 1 0.5 1 1.2v3.2c0 0.5 0.2 0.9 0.9 0.9 0.7 0 0.9-0.4 0.9-0.9V82C66.4 80.4 65.4 79.8 64.1 79.8zM70.9 79.8c-2.1 0-3.4 1.4-3.4 3.5 0 1.6 0.9 3.2 3.4 3.2 1.1 0 2.8-0.5 2.8-1.6 0-0.3-0.3-0.7-0.7-0.7 -0.7 0-0.7 0.9-2.1 0.9 -1 0-1.7-0.7-1.7-1.6h4c0.6 0 0.8-0.2 0.8-0.8C74.1 81.2 73 79.8 70.9 79.8zM69.3 82.5c0.2-0.9 0.7-1.4 1.6-1.4 0.8 0 1.4 0.6 1.5 1.4H69.3zM79.1 79.8c-1 0-1.7 0.5-2.2 1.1h0v-0.2c0-0.5-0.2-0.9-0.8-0.9 -0.6 0-0.8 0.4-0.8 0.9v4.9c0 0.5 0.2 0.9 0.9 0.9 0.7 0 0.9-0.4 0.9-0.9V82.7c0-0.9 0.7-1.4 1.4-1.4 0.8 0 1.1 0.5 1.1 1.2v3.1c0 0.5 0.2 0.9 0.9 0.9 0.7 0 0.9-0.4 0.9-0.9v-3.5C81.4 80.3 80.2 79.8 79.1 79.8zM85.6 81.1c0.5 0 0.8-0.2 0.8-0.6 0-0.4-0.3-0.6-0.8-0.6h-0.5v-1.1c0-0.6-0.4-0.9-0.9-0.9 -0.5 0-0.9 0.3-0.9 0.9v1.1H82.9c-0.5 0-0.7 0.2-0.7 0.6 0 0.4 0.2 0.6 0.7 0.6h0.3v3.8c0 1.1 0.5 1.6 1.8 1.6 0.9 0 1.3-0.3 1.3-0.8 0-0.4-0.2-0.6-0.6-0.6h-0.3c-0.3 0-0.5-0.1-0.5-0.4v-3.6H85.6zM90.5 82.5l-0.7-0.2c-0.6-0.1-1-0.2-1-0.6 0-0.4 0.4-0.6 1-0.6 1.1 0 1.2 0.8 1.9 0.8 0.5 0 0.7-0.4 0.7-0.8 0-0.8-1.4-1.4-2.7-1.4 -1.2 0-2.7 0.5-2.7 2 0 1.2 0.8 1.6 1.9 1.9l1.1 0.3c0.6 0.2 1 0.2 1 0.7 0 0.4-0.4 0.6-1 0.6 -1.3 0-1.4-1.1-2.2-1.1 -0.5 0-0.7 0.4-0.7 0.7 0 0.9 1.3 1.6 3 1.6 1.3 0 2.8-0.7 2.8-2.1C92.7 83.1 91.5 82.7 90.5 82.5zM51 53.7c5.7 2.8 10.6-2.7 11.7-8.3 1-5.2-1.1-10.8-5.1-13.3 -1.9-1.2-5-1.1-7 0 -2.3 1.2-3.9 3.6-4.6 6.2 -0.4 1.4-0.7 3-0.7 4.5C45.3 47.2 47.1 51.8 51 53.7zM50.3 37.6c1.8-2.3 4.8-3 6.8-0.8 1.6 1.7 2.2 3.9 2.1 6.3 -0.2 4.4-3 8.9-7.4 6.7C48.1 47.9 47.9 40.7 50.3 37.6zM66.6 40.7c1.8 0.7 4.2-0.1 5.1-1.8 0.7-1.5 0.5-3.4-0.8-4.5 -0.6-0.5-1.7-1.1-2.5-1.2 -2.7-0.2-5 2.4-4.2 5C64.6 39.2 65.5 40.3 66.6 40.7zM66.9 37c0-0.6 0.6-1.1 1.2-1 0.6 0 1.1 0.6 1 1.2 -0.1 0.7-0.7 1-1.2 1C67.4 38.2 66.8 37.8 66.9 37zM68.4 53.3c4.1-6.1 8.2-11.9 12.2-18.2 1.3-2.1-2.1-3.8-3.4-1.8 -4 6.3-8.1 12.1-12.2 18.2C63.7 53.6 67 55.3 68.4 53.3zM81.4 51.4c0.7-1.5 0.5-3.5-0.8-4.6 -0.6-0.5-1.7-1.1-2.5-1.2 -2.7-0.2-5.1 2.4-4.2 5 0.4 1.1 1.2 2.1 2.3 2.6C78.1 54 80.6 53.1 81.4 51.4zM77.7 50.7c-0.6-0.1-1.1-0.5-1-1.2 0.1-0.6 0.6-1.1 1.2-1 0.6 0.1 1.1 0.6 1 1.2C78.8 50.4 78.2 50.7 77.7 50.7z\"></path><g opacity=\"0.2\"><path d=\"M58.9 8.2c1.6 0 3.1 0.1 4.8 0.3 13 1.7 24.6 9.6 34 18.3 9.1 8.5 18.1 19.3 21.3 31.6 7.6 29.7-32.6 43.5-54.5 47.1 -5.1 0.8-10.5 1.4-15.9 1.4 -9.7 0-19.4-1.9-27.2-7.7C10.1 91 7.8 76.4 9.6 63.3 13.1 39 31.7 8.2 58.9 8.2M58.9 0.2v8V0.2H58.9C44.2 0.2 30 7.9 19.1 21.7 10.1 33.1 3.8 47.9 1.7 62.2 -0.9 80.9 4.5 96.8 16.6 105.8c8.2 6.1 19 9.2 31.9 9.2 5.4 0 11-0.5 17.3-1.6 5.9-1 17.7-3.4 29.7-8.8 12.5-5.5 21.5-12.5 26.9-20.7 5.4-8.2 6.9-17.8 4.3-27.5 -3.1-11.9-10.8-23.5-23.6-35.5C90.3 9.1 77.4 2.3 64.7 0.6 62.8 0.4 60.8 0.2 58.9 0.2L58.9 0.2z\"></path></g></svg>"

/***/ },
/* 1360 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 132.448 120.301\" enable-background=\"new 0 0 132.448 120.301\" xml:space=\"preserve\"><g><g><path fill=\"#FFFFFF\" d=\"M122.676,66.782c1.7,13.707-0.421,29.788-12.706,38.176c-12.628,8.623-30.022,6.537-43.945,3.255 c-15.933-3.757-32.733-10.201-45.527-20.848c-8.511-7.082-13.951-16.63-10.599-27.81c3.594-11.993,13.277-22.174,22.328-30.39 c9.86-8.95,21.694-17.443,35.075-19.817C99.203,3.687,119.354,40.01,122.676,66.782z\"></path></g></g><g opacity=\"0.2\"><g><path d=\"M73.868,8.758c28.093-0.002,45.72,33.137,48.807,58.024c1.7,13.707-0.421,29.788-12.706,38.176 c-6.63,4.527-14.575,6.103-22.64,6.103c-7.297,0-14.692-1.289-21.305-2.848c-15.933-3.757-32.733-10.201-45.527-20.848 c-8.511-7.082-13.951-16.63-10.599-27.81c3.594-11.993,13.277-22.174,22.328-30.39c9.86-8.95,21.694-17.442,35.075-19.817 C69.548,8.949,71.74,8.759,73.868,8.758 M73.871,0.758v8V0.758h-0.003c-2.622,0-5.301,0.24-7.964,0.712 c-12.78,2.267-25.19,9.185-39.055,21.77C17.627,31.612,6.495,43.044,2.235,57.258C-1.682,70.324,2.986,83.201,15.38,93.514 c12.214,10.163,28.635,17.728,48.809,22.485c8.738,2.06,16.308,3.061,23.14,3.061c10.732,0,19.867-2.522,27.152-7.496 c12.779-8.725,18.659-25.407,16.134-45.767c-1.819-14.661-7.988-30.389-16.5-42.07C103.165,8.701,89.249,0.758,73.871,0.758 L73.871,0.758z\"></path></g></g><path fill=\"#646464\" d=\"M77.675,97.702c-4.293-0.112-8.242-1.499-12.019-3.461c-5.841-3.035-10.889-7.138-15.597-11.683 c-4.91-4.74-9.395-9.836-12.916-15.718c-2.219-3.706-3.972-7.6-4.637-11.914c-0.727-4.717,0.326-8.906,3.825-12.283 c1.187-1.146,2.476-2.236,3.872-3.104c1.997-1.241,3.905-0.949,5.44,0.841c1.291,1.505,2.379,3.192,3.49,4.843 c1.44,2.142,2.817,4.326,4.214,6.497c1.606,2.495,1.241,4.888-1.022,6.813c-0.604,0.513-1.218,1.018-1.783,1.572 c-1.93,1.889-2.299,3.783-1.228,6.275c0.932,2.168,2.386,3.984,3.951,5.713c2.441,2.697,4.985,5.297,8.05,7.293 c1.036,0.675,2.188,1.226,3.357,1.626c1.729,0.591,3.351,0.184,4.681-1.08c0.794-0.755,1.51-1.595,2.229-2.426 c1.74-2.01,4.14-2.462,6.392-1.036c3.411,2.16,6.777,4.392,10.141,6.625c0.655,0.435,1.265,0.965,1.808,1.534 c1.347,1.41,1.723,3.126,0.732,4.789C87.737,94.314,83.767,97.683,77.675,97.702z\"></path><path fill=\"#646464\" d=\"M83.097,65.795c-0.835-0.113-2.374-0.34-3.918-0.52c-0.409-0.048-0.878-0.055-1.247,0.096 c-3.371,1.382-6.827,2.435-10.469,2.77c-0.78,0.072-1.58,0.03-2.361-0.054c-0.298-0.032-0.738-0.283-0.802-0.519 c-0.065-0.238,0.187-0.66,0.42-0.865c1.941-1.702,3.11-3.831,3.571-6.352c0.103-0.562,0.178-1.117-0.273-1.656 c-5.904-7.041-4.727-16.611,2.19-22.393c4.429-3.702,9.608-5.169,15.333-4.743c5.164,0.384,9.663,2.301,13.292,6.042 c3.177,3.274,4.818,7.218,4.575,11.798c-0.249,4.692-2.381,8.51-5.939,11.518C93.538,64.242,88.913,65.69,83.097,65.795z M70.792,64.45c0.147-0.023,0.393-0.038,0.626-0.1c2.091-0.561,4.037-1.463,5.809-2.689c0.68-0.47,1.264-0.523,2.037-0.338 c5.489,1.311,10.624,0.535,15.182-2.907c6.67-5.037,6.886-13.795,0.512-19.195c-2.908-2.464-6.327-3.675-10.113-3.865 c-4.745-0.238-9.001,1.048-12.579,4.24c-5.207,4.645-5.637,11.883-0.957,17c0.979,1.071,1.2,2.19,0.9,3.433 C71.854,61.495,71.294,62.914,70.792,64.45z\"></path><path fill=\"#646464\" d=\"M76.465,51.039c-1.327-0.005-2.44-1.135-2.422-2.459c0.017-1.296,1.125-2.388,2.417-2.382 c1.329,0.006,2.443,1.135,2.424,2.457C78.866,49.947,77.753,51.044,76.465,51.039z\"></path><path fill=\"#646464\" d=\"M86.252,48.61c-0.003,1.324-1.133,2.443-2.454,2.429c-1.287-0.013-2.383-1.122-2.387-2.414 c-0.004-1.322,1.134-2.448,2.451-2.427C85.159,46.219,86.254,47.324,86.252,48.61z\"></path><path fill=\"#646464\" d=\"M93.619,48.632c-0.011,1.327-1.157,2.442-2.474,2.406c-1.297-0.035-2.378-1.146-2.37-2.435 c0.008-1.29,1.109-2.395,2.398-2.408C92.492,46.181,93.63,47.315,93.619,48.632z\"></path></svg>"

/***/ },
/* 1361 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" x=\"0\" y=\"0\" viewBox=\"0 0 124.4 122.1\" enable-background=\"new 0 0 124.396 122.101\" xml:space=\"preserve\"><g opacity=\"0.2\"><path d=\"M49.5 9c4.3 0 8.6 0.6 12.8 1.6 14 3.3 27.5 10.7 38 20.5 8.3 7.7 15.4 17.9 14.6 29.7 -0.7 12-8.7 22.4-17 30.4 -9.9 9.5-22.4 17.4-36 20.4 -3.1 0.7-6.3 1-9.4 1 -10.1 0-19.7-3.6-27.1-11.1C14.4 90.4 9.7 74.1 9.4 58.9c-0.3-14.4 3.5-30.3 14.5-40.5C31 11.7 40.2 9 49.5 9M49.5 1L49.5 1c-12.3 0-23 4-31.1 11.5C11.8 18.6 0.8 32.8 1.4 59.1c0.4 19.2 7.1 36.7 18.4 48.1 8.6 8.7 20.3 13.5 32.8 13.5 3.7 0 7.4-0.4 11.1-1.2 17.6-3.8 31.4-14.3 39.9-22.4 12.2-11.7 18.7-23.7 19.5-35.7 0.8-12.4-5.2-24.9-17.2-36.1C94.1 14.4 79.3 6.4 64.2 2.8 59.2 1.6 54.3 1 49.5 1L49.5 1z\"></path></g><path fill=\"#9FCC3B\" d=\"M115 60.8c-0.7 12-8.7 22.4-17 30.4 -9.9 9.5-22.4 17.4-36 20.4 -13.3 2.9-26.8-0.3-36.5-10.1C14.4 90.4 9.7 74.1 9.4 58.9c-0.3-14.4 3.5-30.3 14.5-40.5C34.3 8.7 49 7.4 62.3 10.6c14 3.3 27.5 10.7 38 20.5C108.6 38.8 115.7 49 115 60.8z\"></path><path fill=\"#FFFFFF\" d=\"M41.1 66.7c0-0.9 0.5-1.2 1.2-1.2h3.1c1.7 0 3.1 0.8 3.1 2.8 0 1.6-1.1 2.8-3.1 2.8H43.2v2.4c0 0.6-0.4 1-1 1 -0.6 0-1-0.4-1-1V66.7zM43.2 69.7h1.9c0.8 0 1.4-0.5 1.4-1.3 0-0.9-0.6-1.3-1.6-1.3H43.2V69.7zM49.8 68.7c0-0.5 0.4-0.8 0.8-0.8 0.5 0 0.8 0.3 0.8 0.8v0.7h0c0.2-0.8 0.6-1.5 1.5-1.5 0.6 0 1 0.4 1 0.9 0 0.7-0.4 0.9-0.9 0.9h-0.3c-0.7 0-1.1 0.5-1.1 2v2.1c0 0.5-0.2 0.9-0.9 0.9s-0.9-0.4-0.9-0.9V68.7zM55.8 65.3c0.5 0 0.9 0.4 0.9 0.9 0 0.5-0.4 0.9-0.9 0.9 -0.5 0-0.9-0.4-0.9-0.9C54.8 65.8 55.3 65.3 55.8 65.3zM54.9 68.7c0-0.5 0.2-0.9 0.9-0.9 0.7 0 0.9 0.4 0.9 0.9v5c0 0.5-0.2 0.9-0.9 0.9 -0.7 0-0.9-0.4-0.9-0.9V68.7zM61.3 67.8c1.5 0 2.7 0.9 2.7 1.7 0 0.5-0.4 0.8-0.8 0.8 -0.9 0-0.5-1.1-1.9-1.1 -0.7 0-1.5 0.5-1.5 2.1 0 1.1 0.5 1.9 1.5 1.9 1.3 0 1-1.2 2-1.2 0.5 0 0.8 0.3 0.8 0.7 0 0.8-0.9 1.9-2.8 1.9 -2.2 0-3.3-1.4-3.3-3.3C57.9 69.3 59.1 67.8 61.3 67.8zM66.5 71.6c0 1 0.6 1.7 1.7 1.7 1.4 0 1.4-0.9 2.1-0.9 0.4 0 0.7 0.4 0.7 0.7 0 1.1-1.8 1.6-2.9 1.6 -2.5 0-3.5-1.7-3.5-3.3 0-2.1 1.3-3.5 3.4-3.5 2.1 0 3.3 1.5 3.3 3 0 0.6-0.2 0.8-0.8 0.8H66.5zM69.7 70.6c-0.1-0.8-0.7-1.4-1.5-1.4 -0.9 0-1.5 0.6-1.7 1.4H69.7zM40 81.4c0-0.8 0.6-1 1.1-1h0.6c0.6 0 0.9 0.3 1.1 0.9l1.8 5.8h0l1.8-5.8c0.2-0.7 0.5-0.9 1.1-0.9h0.6c0.5 0 1.1 0.2 1.1 1v7.3c0 0.5-0.2 1-0.9 1 -0.7 0-0.9-0.5-0.9-1v-5.6h0l-1.9 6c-0.1 0.4-0.4 0.6-0.9 0.6 -0.4 0-0.7-0.2-0.9-0.6l-1.9-6h0v5.6c0 0.5-0.2 1-0.9 1 -0.7 0-0.9-0.5-0.9-1V81.4zM57 87.7c0 0.8 0.2 0.9 0.2 1.2 0 0.4-0.4 0.7-0.8 0.7 -0.8 0-1-0.5-1.1-1.1 -0.7 0.8-1.5 1.1-2.5 1.1 -1 0-2.1-0.7-2.1-1.9 0-1.5 1.1-1.9 2.5-2.1l1.1-0.1c0.4 0 0.8-0.1 0.8-0.7 0-0.5-0.5-0.7-1.1-0.7 -1.3 0-1.4 1-2.1 1 -0.5 0-0.8-0.3-0.8-0.7 0-0.7 1-1.6 2.9-1.6 1.7 0 3 0.6 3 1.9V87.7zM55.1 86.4c-0.2 0.2-0.6 0.3-0.8 0.3l-0.7 0.1c-0.8 0.1-1.2 0.4-1.2 0.9 0 0.4 0.4 0.7 1 0.7 1 0 1.6-0.6 1.6-1.3V86.4zM59 84.2h-0.3c-0.5 0-0.7-0.2-0.7-0.6s0.2-0.6 0.7-0.6h0.3v-1.1c0-0.6 0.4-0.9 0.9-0.9 0.5 0 0.9 0.3 0.9 0.9v1.1h0.5c0.5 0 0.8 0.2 0.8 0.6 0 0.4-0.3 0.6-0.8 0.6h-0.5v3.6c0 0.3 0.2 0.4 0.5 0.4h0.3c0.4 0 0.6 0.2 0.6 0.6 0 0.5-0.4 0.8-1.3 0.8 -1.3 0-1.9-0.5-1.9-1.6V84.2zM66.2 82.8c1.5 0 2.7 0.9 2.7 1.7 0 0.5-0.4 0.8-0.8 0.8 -0.9 0-0.5-1.1-1.9-1.1 -0.7 0-1.5 0.5-1.5 2.1 0 1.1 0.5 1.9 1.5 1.9 1.3 0 1-1.2 2-1.2 0.5 0 0.8 0.3 0.8 0.7 0 0.8-0.9 1.9-2.8 1.9 -2.2 0-3.3-1.4-3.3-3.3C62.8 84.3 64 82.8 66.2 82.8zM69.9 81.3c0-0.6 0.4-0.9 0.9-0.9 0.5 0 0.9 0.3 0.9 0.9v2.5h0c0.4-0.5 1-1 2-1 1.1 0 2.3 0.5 2.3 2.4v3.5c0 0.5-0.2 0.9-0.9 0.9s-0.9-0.4-0.9-0.9v-3.2c0-0.7-0.4-1.3-1.1-1.3 -0.6 0-1.4 0.5-1.4 1.4v3c0 0.5-0.2 0.9-0.9 0.9 -0.7 0-0.9-0.4-0.9-0.9V81.3z\"></path><path fill=\"#FFFFFF\" d=\"M75.3 28.7c-5.9 8.2-14.1 18.7-18.8 29.1 -0.2 0.4-0.7 1-1.1 1.2 -1.5 1-4.1 0.4-4.9-1 -2.9-5.4-6.8-10.6-9.9-15.3 -2-3 5.1-3.8 6.6-1.9 2.3 3 6.1 10.2 6.1 10.2 0.9 0 8.6-17.6 14.6-24.3C69.4 25 77.3 25.8 75.3 28.7z\"></path></svg>"

/***/ },
/* 1362 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1792 1792\"><path d=\"M1216 832q0-185-131.5-316.5t-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5 316.5-131.5 131.5-316.5zm512 832q0 52-38 90t-90 38q-54 0-90-38l-343-342q-179 124-399 124-143 0-273.5-55.5t-225-150-150-225-55.5-273.5 55.5-273.5 150-225 225-150 273.5-55.5 273.5 55.5 225 150 150 225 55.5 273.5q0 220-124 399l343 343q37 37 37 90z\"></path></svg>"

/***/ },
/* 1363 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 512 408\" style=\"enable-background:new 0 0 512 408;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#005F86;} </style><g><g><path class=\"st0\" d=\"M501.8,209.1h-22.2L283.9,13.3c-0.2-0.2-0.5-0.4-0.7-0.6C276.7,4.9,266.9,0,256,0c-11.4,0-21.5,5.4-28,13.7 L102.9,138.8c-4,4-4,10.4,0,14.4c2,2,4.6,3,7.2,3s5.2-1,7.2-3L222.7,47.9c5,13.5,18.1,23.2,33.3,23.2c15.3,0,28.4-9.8,33.4-23.4 l161.4,161.4H10.2c-5.6,0-10.2,4.6-10.2,10.2v178.5c0,5.6,4.6,10.2,10.2,10.2h491.6c5.6,0,10.2-4.6,10.2-10.2V219.3 C512,213.6,507.4,209.1,501.8,209.1z M256,50.7c-8.4,0-15.2-6.8-15.2-15.2s6.8-15.2,15.2-15.2s15.2,6.8,15.2,15.2 S264.4,50.7,256,50.7z M491.6,387.6H20.4V229.5h471.2L491.6,387.6L491.6,387.6z\"></path></g></g><g><g><path class=\"st0\" d=\"M110.3,253.7c-5.6,0-10.2,4.6-10.2,10.2v34.3H64.6v-34.3c0-5.6-4.6-10.2-10.2-10.2s-10.2,4.6-10.2,10.2v89 c0,5.6,4.6,10.2,10.2,10.2s10.2-4.6,10.2-10.2v-34.3h35.4v34.3c0,5.6,4.6,10.2,10.2,10.2c5.6,0,10.2-4.6,10.2-10.2v-89 C120.5,258.3,115.9,253.7,110.3,253.7z\"></path></g></g><g><g><path class=\"st0\" d=\"M389.1,342.9h-44.2v-24.3h29.3c5.6,0,10.2-4.6,10.2-10.2s-4.6-10.2-10.2-10.2h-29.3v-24.1h44.6 c5.6,0,10.2-4.6,10.2-10.2s-4.6-10.2-10.2-10.2h-54.8c-5.6,0-10.2,4.6-10.2,10.2v89c0,5.6,4.6,10.2,10.2,10.2l54.4-0.1 c5.6,0,10.2-4.4,10.2-10C399.3,347.5,394.7,342.9,389.1,342.9z\"></path></g></g><g><g><path class=\"st0\" d=\"M460.9,342.9h-30.2v-79c0-5.6-4.6-10.2-10.2-10.2s-10.2,4.6-10.2,10.2v89c0,5.6,4.6,10.2,10.2,10.2l40.4-0.1 c5.6,0,10.2-4.4,10.2-10C471.1,347.5,466.6,342.9,460.9,342.9z\"></path></g></g><g><g><path class=\"st0\" d=\"M304.5,253.7h-54.4c-5.6,0-10.2,4.6-10.2,10.2s4.6,10.2,10.2,10.2h17v78.8c0,5.6,4.6,10.2,10.2,10.2 s10.2-4.6,10.2-10.2v-78.8h17c5.6,0,10.2-4.6,10.2-10.2C314.7,258.3,310.2,253.7,304.5,253.7z\"></path></g></g><g><g><path class=\"st0\" d=\"M186.7,253.7c-30.2,0-54.7,24.5-54.7,54.7c0,30.2,24.5,54.7,54.7,54.7s54.7-24.5,54.7-54.7 C241.4,278.3,216.8,253.7,186.7,253.7z M186.7,342.7c-18.9,0-34.3-15.4-34.3-34.3s15.4-34.3,34.3-34.3s34.3,15.4,34.3,34.3 S205.6,342.7,186.7,342.7z\"></path></g></g><g><g><path class=\"st0\" d=\"M89.3,166.5c-4-4-10.4-4-14.4,0l-10.3,10.3c-4,4-4,10.4,0,14.4c2,2,4.6,3,7.2,3s5.2-1,7.2-3l10.3-10.3 C93.3,177,93.3,170.5,89.3,166.5z\"></path></g></g></svg>"

/***/ },
/* 1364 */
1354,
/* 1365 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 512 512\" enable-background=\"new 0 0 512 512\"><path fill=\"#FFFFFF\" d=\"m429.2 82.8c-46.2-46.3-107.8-71.8-173.2-71.8s-127 25.5-173.2 71.8-71.8 107.8-71.8 173.2 25.5 127 71.8 173.2 107.8 71.8 173.2 71.8 127-25.5 173.2-71.8 71.8-107.8 71.8-173.2-25.5-127-71.8-173.2zm49.6 162.2h-95c-0.9-37.8-6.2-74.2-15.5-106.5 18.1-9.3 35-21 50.5-34.8 35 37.4 57.3 86.8 60 141.3zm-211.8 22h94.9c-0.8 34.8-5.6 68.1-13.9 97.9-25.6-10.3-52.9-16.3-81-17.6v-80.3zm136-178.6c-12.8 11.3-26.8 20.9-41.6 28.9-3.8-10.6-8.1-20.6-12.9-30-9.5-18.8-20.3-34.2-32.2-46 32.5 9.1 62 25.4 86.7 47.1zm-136-52c22.9 5.1 44.5 26.2 61.9 60.6 4.7 9.3 8.9 19.2 12.6 29.7-23.5 9.7-48.6 15.4-74.5 16.7v-107zm81.1 111.4c8.2 29.6 12.9 62.7 13.7 97.3h-94.8v-79.6c28.2-1.3 55.5-7.4 81.1-17.7zm-103.1 97.2h-94.9c0.8-34.6 5.5-67.7 13.7-97.3 25.6 10.4 53 16.4 81.1 17.6v79.7zm0.1-208.6v107c-25.9-1.3-51.1-7-74.5-16.7 3.7-10.5 7.9-20.4 12.6-29.7 17.4-34.4 39-55.5 61.9-60.6zm-49.3 4.9c-11.9 11.8-22.7 27.3-32.2 46-4.7 9.4-9 19.4-12.9 30-14.8-8-28.7-17.6-41.6-28.9 24.7-21.7 54.2-38 86.7-47.1zm-102.5 62.4c15.5 13.8 32.4 25.4 50.5 34.8-9.3 32.4-14.7 68.7-15.5 106.5h-95c2.7-54.5 25-103.9 60-141.3zm-60 163.3h95c0.9 38.1 6.3 74.6 15.7 107.1-18 9.3-34.9 20.8-50.3 34.6-35.3-37.5-57.7-87-60.4-141.7zm76.2 157c12.8-11.2 26.7-20.8 41.4-28.7 3.8 10.3 8 20.2 12.7 29.4 9.5 18.8 20.3 34.2 32.2 46.1-32.3-9.1-61.7-25.3-86.3-46.8zm135.6 51.6c-22.9-5.1-44.5-26.2-61.9-60.6-4.6-9.1-8.7-18.8-12.4-29.1 23.4-9.7 48.5-15.4 74.3-16.6v106.3zm-81-110.7c-8.3-29.8-13.1-63.1-13.9-97.9h94.9v80.3c-28.1 1.2-55.4 7.2-81 17.6zm103 110.7v-106.3c25.8 1.3 50.9 6.9 74.3 16.6-3.7 10.3-7.8 20-12.4 29.1-17.4 34.4-39 55.5-61.9 60.6zm49.3-4.9c11.9-11.8 22.7-27.3 32.2-46.1 4.7-9.2 8.9-19.1 12.7-29.4 14.7 7.9 28.6 17.5 41.4 28.7-24.6 21.6-54 37.8-86.3 46.8zm102.2-62c-15.4-13.7-32.3-25.3-50.3-34.6 9.4-32.5 14.8-69.1 15.7-107.1h95c-2.8 54.7-25.2 104.2-60.4 141.7z\"></path></svg>"

/***/ },
/* 1366 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 21.9 21.9\" enable-background=\"new 0 0 21.9 21.9\"><path d=\"M14.1 11.3c-0.2-0.2-0.2-0.5 0-0.7l7.5-7.5c0.2-0.2 0.3-0.5 0.3-0.7s-0.1-0.5-0.3-0.7l-1.4-1.4C20 0.1 19.7 0 19.5 0c-0.3 0-0.5 0.1-0.7 0.3l-7.5 7.5c-0.2 0.2-0.5 0.2-0.7 0L3.1 0.3C2.9 0.1 2.6 0 2.4 0S1.9 0.1 1.7 0.3L0.3 1.7C0.1 1.9 0 2.2 0 2.4s0.1 0.5 0.3 0.7l7.5 7.5c0.2 0.2 0.2 0.5 0 0.7l-7.5 7.5C0.1 19 0 19.3 0 19.5s0.1 0.5 0.3 0.7l1.4 1.4c0.2 0.2 0.5 0.3 0.7 0.3s0.5-0.1 0.7-0.3l7.5-7.5c0.2-0.2 0.5-0.2 0.7 0l7.5 7.5c0.2 0.2 0.5 0.3 0.7 0.3s0.5-0.1 0.7-0.3l1.4-1.4c0.2-0.2 0.3-0.5 0.3-0.7s-0.1-0.5-0.3-0.7L14.1 11.3z\" fill=\"#FFFFFF\"></path></svg>"

/***/ }
]);


/** WEBPACK FOOTER **
 ** appSearchUnit.js
 **/